import { Form as Form$1, Notification, Content, Columns, Button, Block, Container, Icon, Modal, Message, Panel, Tag, Loader, Heading, Image } from '@bgea-js/react-ui';
import _styled from '@emotion/styled/base';
import { useFormikContext, Field as Field$2, ErrorMessage as ErrorMessage$1, FieldArray, Formik, Form as Form$2, useField } from 'formik';
import React, { useEffect, useState, useRef, useMemo, useImperativeHandle, useCallback, isValidElement, createElement, createContext, Component, forwardRef, useReducer, useContext } from 'react';
import * as Yup from 'yup';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useScript, useDebounce } from '@bgea-js/react-hooks';
import * as R from 'ramda';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { usePlacesWidget } from 'react-google-autocomplete';
import { useGoogleReCaptcha as useGoogleReCaptcha$1, GoogleReCaptchaProvider as GoogleReCaptchaProvider$1 } from 'react-google-recaptcha-v3';
import { PhoneInput } from 'react-international-phone';
import { DollarSignIcon, LockIcon, SpinnerIcon, EnvelopeIcon, CloseIcon } from '@bgea-js/react-icons';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enUS, zhTW, zhCN, ru, pt, es, ar } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { pickDomAttributes } from '@bgea-js/react-utilities';
import * as colors from '@bgea-js/colors';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var convertOptionsToList = function convertOptionsToList(optionObj) {
  var keys = Object.keys(optionObj);
  if (keys.length === 0) {
    return [];
  }
  return keys.map(function (key) {
    return {
      value: optionObj[key],
      id: key
    };
  });
};

var convertToBase64 = function convertToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var _reader$result;
      return resolve(((_reader$result = reader.result) === null || _reader$result === void 0 ? void 0 : _reader$result.toString()) || '');
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

var deepFind = function deepFind(obj, path) {
  return path.replace(/\[/g, '.').replace(/\]/g, '').split('.').reduce(function (acc, cur) {
    return (acc || {})[cur];
  }, obj);
};

var fieldClassList = function fieldClassList() {
  var classList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched;
  var classL = classList;
  if (fieldName !== '' && deepFind(touched, fieldName)) {
    var errorMessage = deepFind(errors, fieldName) || undefined;
    classL += errorMessage !== undefined && errorMessage !== '' ? " is-danger" : '';
  }
  return classL;
};

/**
 * // Removes leading 0s and guaranty that value is at least 5.
 * @param {string} value
 * @returns string
 */
var formatCurrency = function formatCurrency(value) {
  var minCurrencyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  // Removes leading or trailing 0s
  var formattedValue = value.replace(/^0+/, '');

  // If the value is less than minCurrencyValue then returns minCurrencyValue
  var formattedVal = parseInt(formattedValue, 10) >= minCurrencyValue ? formattedValue : minCurrencyValue;
  // Returns a string with the value rounded to two decimals
  return parseFloat("".concat(formattedVal)).toFixed(2);
};

var validateAcknowledgement = function validateAcknowledgement(value) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var schema = Yup["boolean"]();
  var errMsg = errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'You must agree to submit this form.';
  if (required && typeof required !== 'undefined') {
    schema = required ? schema.required(errMsg).oneOf([true], errMsg) : schema;
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

// This is the validation function for the captcha box. Does not allow less than 1 character to be entered. Allows for translation
var validateCaptcha = function validateCaptcha(value, required, t) {
  var schema;
  if (required && typeof required !== 'undefined') {
    schema = Yup["boolean"]().oneOf([true], t('Required', {
      ns: 'validation'
    }));
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var validateCountry = function validateCountry(value) {
  var schema = Yup.string().required('Required').notOneOf(['', 'Select One'], 'Required');
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

/*  Logic from BGForm - Needs to be refactored */

var validateCurrency = function validateCurrency(required) {
  var minCurrencyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return function (value) {
    // This function does not allow users to enter a value less than minCurrencyValue

    var schema = Yup.number().typeError("Please enter an amount of at least $".concat(minCurrencyValue, ".")).test("Please enter an amount of at least $".concat(minCurrencyValue, "."), "Please enter an amount of at least $".concat(minCurrencyValue, "."), function (val) {
      return val >= minCurrencyValue;
    }).positive("Please enter an amount of at least $".concat(minCurrencyValue, "."));
    if (typeof required !== 'undefined') {
      schema = required ? schema.required('Required') : schema;
    }
    return Yup.reach(schema).validate(value)["catch"](function (err) {
      return err.errors;
    }).then(function (result) {
      return result === value ? '' : result;
    });
  };
};

var validateEchoPhoneNumber = function validateEchoPhoneNumber(value) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please check your phone number format - it appears to be invalid. Make sure the area code starts with 1 and enter only numbers.';
  var useCountryCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var min = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 11;
  var max = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 11;
  var translations = arguments.length > 5 ? arguments[5] : undefined;
  if (useCountryCode) {
    var val = value === null || value === void 0 ? void 0 : value.replace('+', '');
    return (val === null || val === void 0 ? void 0 : val.length) === min && (val === null || val === void 0 ? void 0 : val.length) === max ? '' : errorMessage;
  }
  var schema = Yup.string().required((translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || 'Required').min(min, errorMessage).max(max, errorMessage).matches(/^1[0-9]+$/, {
    message: "".concat(errorMessage)
  });
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

/*  Logic from BGForm - Needs to be refactored */

var validateEmail = function validateEmail(isValidEmailAddress, paypal, required, translations, value) {
  // This regex does not allow government or military addresses
  var containsGovMil = function containsGovMil(string) {
    return /^.*(gov|mil)$/.test(string);
  };
  var schema = Yup.string().email(translations === null || translations === void 0 ? void 0 : translations.invalidEmail).test(translations === null || translations === void 0 ? void 0 : translations.useAnotherEmail, translations === null || translations === void 0 ? void 0 : translations.useAnotherEmail, function (val) {
    return !containsGovMil(val);
  });
  // This if statement makes it so the field is not required unless the required prop is true
  if (typeof required !== 'undefined') {
    schema = required ? schema.required(translations === null || translations === void 0 ? void 0 : translations.requiredLabel) : schema;
  }
  if (!paypal) {
    schema = schema.test(translations === null || translations === void 0 ? void 0 : translations.invalidEmail, translations === null || translations === void 0 ? void 0 : translations.invalidEmail, function () {
      return isValidEmailAddress === true || isValidEmailAddress === null;
    });
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

/*  Logic from BGForm - Needs to be refactored */

var validateInput = function validateInput(translations, value, required) {
  var schema = Yup.string();
  if (typeof required !== 'undefined') {
    schema = required ? schema.required((translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || 'Required').test('Select One', 'Please Select One', function (val) {
      return val !== 'Select One';
    }) : schema;
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var validateMultiSelect = function validateMultiSelect(selectedOptions, required, max) {
  var schema = Yup.array().of(Yup.string());
  if (required) {
    schema = schema.min(1, 'Required');
  }
  if (max) {
    schema = schema.max(max, "You can select up to ".concat(max, " options"));
  }
  return Yup.reach(schema).validate(selectedOptions)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === selectedOptions ? '' : result;
  });
};

var validateName = function validateName(value, required) {
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 32;
  var invalidTxt = arguments.length > 3 ? arguments[3] : undefined;
  var maxCharsTxt = arguments.length > 4 ? arguments[4] : undefined;
  var requiredTxt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'Required';
  var schema = Yup.string().max(max, maxCharsTxt).matches(/^(?:[ '\*-9A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E\u2202]+)?$/, invalidTxt);
  if (typeof required !== 'undefined') {
    schema = required ? schema.required(requiredTxt) : schema;
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var getSchemaMin = function getSchemaMin(schema, required, min) {
  var newSchema = schema;
  newSchema = required ? newSchema.required('Required').min(min, "Minimum ".concat(min)) : newSchema;
  return newSchema;
};
var getSchemaMax = function getSchemaMax(schema, required, max) {
  var newSchema = schema;
  newSchema = required ? newSchema.required('Required').max(max, "Maximum ".concat(max)) : newSchema;
  return newSchema;
};
var getSchema = function getSchema(schema, required, min, max, errorMessage) {
  var newSchema = schema;
  if (typeof required !== 'undefined' && required === true && min && max) {
    newSchema = required ? newSchema.required('Required').min(min, errorMessage || "Range ".concat(min, " to ").concat(max)).max(max, errorMessage || "Range ".concat(min, " to ").concat(max)) : newSchema;
  } else if (typeof required !== 'undefined' && required === true && min) {
    newSchema = getSchemaMin(newSchema, required, min);
  } else if (typeof required !== 'undefined' && required === true && max) {
    newSchema = getSchemaMax(newSchema, required, max);
  } else if (typeof required !== 'undefined' && required === true) {
    newSchema = required ? newSchema.required('Required') : newSchema;
  }
  return newSchema;
};
var validateNumber = function validateNumber(value, required, min, max, errorMessage) {
  var schema = Yup.number('Required').typeError('Required');
  schema = getSchema(schema, required, min, max, errorMessage);
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var getSchemaValue = function getSchemaValue(required, value) {
  var val = _typeof(value) !== 'object' ? JSON.parse(value) : value;
  var vp;
  if (val.length > 0) {
    val === null || val === void 0 ? void 0 : val.forEach(function (v) {
      vp = JSON.parse(v);
    });
  } else {
    vp = val;
  }
  var schemaVal = vp.label;
  var schema = Yup.string();
  if (typeof required !== 'undefined') {
    schema = required ? schema.required('Required').test('Select One', 'Please Select One', function (v) {
      return v !== 'Select One';
    }) : schema;
  }
  return {
    vp: vp,
    schema: schema,
    schemaVal: schemaVal
  };
};
var validateObject = function validateObject(value, required) {
  if (value !== undefined && value !== '') {
    var _getSchemaValue = getSchemaValue(required, value),
      vp = _getSchemaValue.vp,
      _schema = _getSchemaValue.schema,
      schemaVal = _getSchemaValue.schemaVal;
    return Yup.reach(_schema).validate(schemaVal)["catch"](function (err) {
      return err.errors;
    }).then(function (result) {
      return result === vp.label ? '' : result;
    });
  }
  var schema = Yup.string();
  if (typeof required !== 'undefined') {
    schema = required ? schema.required('Required') : schema;
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var validatePhone = function validatePhone(value, minPhoneLength, phoneOptional, required, requiredLabel, invalidLabel) {
  // This regex only allows numbers to be entered in this field.
  // const phoneRegExp =
  //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  var phoneRegExp;
  if (phoneOptional === true) {
    phoneRegExp = /(^$)|[0-9 \-().+]{7,32}$/;
  } else {
    phoneRegExp = /^[0-9 \-().+]{7,32}$/;
  }

  // The input in this function has to be greater than 10 and less than 12
  var schema = Yup.string();
  schema = value && (value === null || value === void 0 ? void 0 : value.length) > 0 ? schema.matches(phoneRegExp, invalidLabel).min(minPhoneLength || 0, 'Number is too short') : schema;
  schema = required && !value ? schema.required(requiredLabel) : schema;
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

var validateString = function validateString(translations, value, required, max) {
  var schema = Yup.string();
  if (value && typeof required !== 'undefined' && required === true && max) {
    schema = required ? schema.required((translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || 'Required').test('len', "Maximum of ".concat(max, " characters. Your current character count is ").concat(value.length, "."), function (val) {
      return val.length < max + 1;
    }) : schema;
  } else if (typeof required !== 'undefined' && required === true) {
    schema = required ? schema.required((translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || 'Required') : schema;
  }
  return Yup.reach(schema).validate(value)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === value ? '' : result;
  });
};

/*  Logic from BGForm - Needs to be refactored */

var validateZipPostalCode = function validateZipPostalCode(value) {
  var minPostalCodeLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var maxPostalCodeLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var errorMessage = arguments.length > 3 ? arguments[3] : undefined;
  // Trim the value to prevent users from entering only white space
  var val = value === null || value === void 0 ? void 0 : value.trim();
  var schema = Yup.string().required('Required').min(minPostalCodeLength, errorMessage || "Invalid Postal Code").max(maxPostalCodeLength, errorMessage || "Invalid Postal Code");
  return Yup.reach(schema).validate(val)["catch"](function (err) {
    return err.errors;
  }).then(function (result) {
    return result === val ? '' : result;
  });
};

var ADD_ITEM_CART = 'bgform-add-item-to-cart';
var ADD_TO_CART = 'add_to_cart';
var BEGIN_CHECKOUT = 'begin_checkout';
var CART_CHANGED = 'cart_changed';
var DELETE_ITEM_CART = 'bgform-delete-item-to-cart';
var DONATION_CONFIRMATION = 'DonationConfirmation';
var DONATION_FUNNEL = 'donation_funnel';
var FORM_ERROR = 'form_error';
var FORM_LOAD = 'form_load';
var FORM_LOAD_ERROR = 'form_load_error';
var LEAD_CONFIRMATION = 'LeadConfirmation';
var MONTHLY_DONATION_CONFIRMATION = 'MonthlyDonationConfirmation';
var REMOVE_FROM_CART = 'remove_from_cart';
var VIEW_CART = 'view_cart';
var CONFIRMATION = 'Confirmation';
var TEST_MONTHLY_GIFT_REQUEST = 'test_monthly_gift_request';
var AUTO_COMPLETE_ADDRESS = 'autoCompleteAddress';
var PAYMENT_INPUTS_DONATION_FUNNEL = ['collector.entity[0].firstName', 'collector.entity[0].lastName', 'collector.entity[0].email[0].emailAddress', 'collector.entity[0].phone[0].phoneNumber', 'collector.entity[0].address[0].cityTownRegion', 'collector.entity[0].address[0].zipPostalCode', 'collector.entity[0].address[0].stateProvince'];

var Analytics = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ADD_ITEM_CART: ADD_ITEM_CART,
  ADD_TO_CART: ADD_TO_CART,
  AUTO_COMPLETE_ADDRESS: AUTO_COMPLETE_ADDRESS,
  BEGIN_CHECKOUT: BEGIN_CHECKOUT,
  CART_CHANGED: CART_CHANGED,
  CONFIRMATION: CONFIRMATION,
  DELETE_ITEM_CART: DELETE_ITEM_CART,
  DONATION_CONFIRMATION: DONATION_CONFIRMATION,
  DONATION_FUNNEL: DONATION_FUNNEL,
  FORM_ERROR: FORM_ERROR,
  FORM_LOAD: FORM_LOAD,
  FORM_LOAD_ERROR: FORM_LOAD_ERROR,
  LEAD_CONFIRMATION: LEAD_CONFIRMATION,
  MONTHLY_DONATION_CONFIRMATION: MONTHLY_DONATION_CONFIRMATION,
  PAYMENT_INPUTS_DONATION_FUNNEL: PAYMENT_INPUTS_DONATION_FUNNEL,
  REMOVE_FROM_CART: REMOVE_FROM_CART,
  TEST_MONTHLY_GIFT_REQUEST: TEST_MONTHLY_GIFT_REQUEST,
  VIEW_CART: VIEW_CART
});

var Frequency = /*#__PURE__*/function (Frequency) {
  Frequency["Monthly"] = "monthly";
  Frequency["OneTime"] = "one-time";
  return Frequency;
}({});
/**
 * If only BUS (i.e. billing) is present it is assumed to be MAIL (shipping) and physical as
 * well.
 */
var AddressType = /*#__PURE__*/function (AddressType) {
  AddressType["Bus"] = "BUS";
  AddressType["Mail"] = "MAIL";
  AddressType["Physical"] = "PHYSICAL";
  return AddressType;
}({});

/**
 * Used to subsribe users to email lists. To use, pass the esub code as the key and the
 * desired boolean. True subscribes, false does nothing.
 */

/**
 * Send for every subscriptionID where isActive is True AND send for every subscriptionID
 * that is transitioning from true to false. No reason to send false for any other esubs.
 */

var EmailType = /*#__PURE__*/function (EmailType) {
  EmailType["Home"] = "home";
  EmailType["Work"] = "work";
  return EmailType;
}({});
var RelationshipType = /*#__PURE__*/function (RelationshipType) {
  RelationshipType["CallTaker"] = "Call Taker";
  RelationshipType["Church"] = "Church";
  RelationshipType["DecisionMagazineGiftee"] = "Decision Magazine Giftee";
  RelationshipType["GroupMember"] = "GroupMember";
  RelationshipType["HonorAndMemorialHonoree"] = "Honor and Memorial Honoree";
  RelationshipType["OnlineTrainingGiftee"] = "Online Training Giftee";
  RelationshipType["Pastor"] = "Pastor";
  RelationshipType["Reporter"] = "Reporter";
  RelationshipType["Reportee"] = "Reportee";
  RelationshipType["Spouse"] = "Spouse";
  RelationshipType["Visitor"] = "Visitor";
  return RelationshipType;
}({});

/**
 * I = Individual, F = Family, O = Organization
 */
var EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["F"] = "F";
  EntityType["I"] = "I";
  EntityType["O"] = "O";
  return EntityType;
}({});
var PhoneNumberFieldFormat = /*#__PURE__*/function (PhoneNumberFieldFormat) {
  PhoneNumberFieldFormat["International"] = "international";
  PhoneNumberFieldFormat["Separated"] = "separated";
  PhoneNumberFieldFormat["Us"] = "US";
  return PhoneNumberFieldFormat;
}({});
var PhoneType = /*#__PURE__*/function (PhoneType) {
  PhoneType["Bus"] = "BUS";
  PhoneType["Cell"] = "CELL";
  PhoneType["Fax"] = "FAX";
  PhoneType["Home"] = "HOME";
  PhoneType["Oth"] = "OTH";
  PhoneType["Rrt"] = "RRT";
  PhoneType["Sfjcontact"] = "SFJCONTACT";
  PhoneType["Work"] = "WORK";
  return PhoneType;
}({});
/**
 * Defines gift type as honor or memorial.
 */
var GiftType = /*#__PURE__*/function (GiftType) {
  GiftType["SendInHonor"] = "Send in Honor";
  GiftType["SendInMemory"] = "Send in Memory";
  return GiftType;
}({});
var SendBlank = /*#__PURE__*/function (SendBlank) {
  SendBlank["N"] = "N";
  SendBlank["Y"] = "Y";
  return SendBlank;
}({});
/**
 * OTHER is for TVTM, required
 */
var CommunicationType = /*#__PURE__*/function (CommunicationType) {
  CommunicationType["Assurance"] = "ASSURANCE";
  CommunicationType["Callreques"] = "CALLREQUES";
  CommunicationType["Email"] = "EMAIL";
  CommunicationType["Followup"] = "FOLLOWUP";
  CommunicationType["Org"] = "ORG";
  CommunicationType["Other"] = "OTHER";
  CommunicationType["Pastorname"] = "PASTORNAME";
  CommunicationType["Pavera"] = "PAVERA";
  CommunicationType["Paverb"] = "PAVERB";
  CommunicationType["Paverc"] = "PAVERC";
  CommunicationType["Paverd"] = "PAVERD";
  CommunicationType["Pavere"] = "PAVERE";
  CommunicationType["Paverf"] = "PAVERF";
  CommunicationType["Prayer"] = "PRAYER";
  CommunicationType["Reded"] = "REDED";
  CommunicationType["Resrelwvy"] = "RESRELWVY";
  CommunicationType["Rsrchtopic"] = "RSRCHTOPIC";
  CommunicationType["Salvation"] = "SALVATION";
  CommunicationType["Suicide"] = "SUICIDE";
  CommunicationType["Volrelwvy"] = "VOLRELWVY";
  CommunicationType["Volpasref"] = "VOLPASREF";
  return CommunicationType;
}({});
var DeliverToOtherDepartment = /*#__PURE__*/function (DeliverToOtherDepartment) {
  DeliverToOtherDepartment["ChristianGuidance"] = "Christian Guidance";
  DeliverToOtherDepartment["Library"] = "Library";
  return DeliverToOtherDepartment;
}({});

/* Custom Types */

var VogonStatus = /*#__PURE__*/function (VogonStatus) {
  VogonStatus["Success"] = "success";
  VogonStatus["Loading"] = "loading";
  return VogonStatus;
}({});
var Language = /*#__PURE__*/function (Language) {
  Language["AMH"] = "AMH";
  Language["ENGLISH"] = "english";
  Language["SPANISH"] = "spanish";
  Language["LO"] = "LO";
  return Language;
}({});
var DDCLANG = /*#__PURE__*/function (DDCLANG) {
  DDCLANG["EN"] = "EN";
  DDCLANG["ES"] = "ES";
  return DDCLANG;
}({});
var Templates = /*#__PURE__*/function (Templates) {
  Templates["ARCHIVE_RESEARCH_CHECKIN"] = "archiveResearchCheckin";
  Templates["CALL_TAKER_FORM"] = "callTaker";
  Templates["CHECKOUT"] = "checkout";
  Templates["CHURCH_APPLICATION"] = "churchApplication";
  Templates["CHURCH_INTEREST"] = "churchInterest";
  Templates["CLWC_ATTENDANCE"] = "clwcAttendance";
  Templates["CONTACT_US"] = "contactUs";
  Templates["COURSE_INTEREST"] = "courseInterest";
  Templates["DATA_ENTRY_FREE_TSHIRT"] = "dataEntryFreeTShirt";
  Templates["DATA_ENTRY_PRAYER_TEAM"] = "dataEntryPrayerTeam";
  Templates["DATA_ENTRY_VOLUNTEER"] = "dataEntryVolunteer";
  Templates["DECISION_MAGAZINE"] = "decisionMagazine";
  Templates["EMAIL_SUBSCRIBE"] = "emailSubscribe";
  Templates["FREE_SHIC_VOD"] = "freeShicVod";
  Templates["FREE_TSHIRT"] = "freeTShirt";
  Templates["GET_INVOLVED"] = "getInvolved";
  Templates["GROUP_BOOKING"] = "groupBooking";
  Templates["GROUP_LEADER"] = "groupLeader";
  Templates["GROUP_MEMBER"] = "groupMember";
  Templates["GROUP_REGISTRATIONS"] = "groupRegistrations";
  Templates["GROUP_REQUEST"] = "groupRequest";
  Templates["HONOR_MEMORIAL_GIVING"] = "honorMemorialGiving";
  Templates["HOST_SEMINAR"] = "hostSeminar";
  Templates["INDIVIDUAL_VOLUNTEER"] = "individualVolunteer";
  Templates["INQUIRER_RESPONSE"] = "inquirerResponse";
  Templates["LANDING_PAGE"] = "landingPage";
  Templates["LEAP_RETREAT_MARRIAGE"] = "leapRetreatMarriage";
  Templates["LEGACY_PARTNER"] = "legacyPartner";
  Templates["LIGHT_FM_EVENT"] = "lightfmevent";
  Templates["MEDIA_REQUEST"] = "mediaRequest";
  Templates["MISCONDUCT"] = "misconduct";
  Templates["NEW_NAMES"] = "newNames";
  Templates["NEW_NAMES_DONATION"] = "newNamesDonation";
  Templates["ONLINE_GIVING"] = "onlineGiving";
  Templates["PEACE_WITH_GOD_PRAYER"] = "peaceWithGodPrayer";
  Templates["PEACE_WITH_GOD_QUESTION"] = "peaceWithGodQuestion";
  Templates["PERMISSION_REQUEST"] = "permissionRequest";
  Templates["PRAYER_REQUEST"] = "prayerRequest";
  Templates["PRAYER_TEAM_MEMBER"] = "prayerTeamMember";
  Templates["PRAYER_LINE_REQUEST"] = "prayerLineRequest";
  Templates["PROJECT_LIST"] = "projectList";
  Templates["SERVICE_REVIEW"] = "serviceReview";
  Templates["SINGLE_DONATION"] = "singleDonationForm";
  Templates["SUBSCRIPTIONS"] = "subscriptions";
  Templates["TRAINING_REGISTRATION"] = "trainingRegistration";
  Templates["VOLUNTEER"] = "volunteer";
  Templates["VOLUNTEER_APP"] = "volunteerApp";
  Templates["VOLUNTEER_INTEREST"] = "volunteerInterest";
  Templates["VOLUNTEER_LIGHT_FM"] = "volunteerLightFm";
  return Templates;
}({});
var Countries = /*#__PURE__*/function (Countries) {
  Countries["AU"] = "AU";
  Countries["AR"] = "AR";
  Countries["BO"] = "BO";
  Countries["BE"] = "BE";
  Countries["EE"] = "EE";
  Countries["ET"] = "ET";
  Countries["ES"] = "ES";
  Countries["GB"] = "GB";
  Countries["ID"] = "ID";
  Countries["IT"] = "IT";
  Countries["JP"] = "JP";
  Countries["KH"] = "KH";
  Countries["LA"] = "LA";
  Countries["PE"] = "PE";
  Countries["PT"] = "PT";
  Countries["US"] = "US";
  Countries["VN"] = "VN";
  return Countries;
}({});
var PaymentOptions = /*#__PURE__*/function (PaymentOptions) {
  PaymentOptions["APAY"] = "APAY";
  PaymentOptions["CCP"] = "CCP";
  PaymentOptions["EFT"] = "EFT";
  return PaymentOptions;
}({});
var SubscriptionCategory = /*#__PURE__*/function (SubscriptionCategory) {
  SubscriptionCategory["GENERAL"] = "general";
  SubscriptionCategory["MINISTRY"] = "ministry";
  return SubscriptionCategory;
}({});
var FluentLanguageValue = /*#__PURE__*/function (FluentLanguageValue) {
  FluentLanguageValue["YES"] = "yes";
  FluentLanguageValue["NO"] = "no";
  return FluentLanguageValue;
}({});

var PAYMENT_TYPE = {
  ITEMIZED: 'One-Time',
  RECURRING: 'Recurring'
};

var nthNumber = function nthNumber(number) {
  if (number > 3 && number < 21) return 'th';
  switch (number % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};
var getDaysInMonth = function getDaysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};
var formatDate = function formatDate(date, formValues) {
  var _formValues$formLogic, _formValues$formLogic2;
  var locales = (formValues === null || formValues === void 0 ? void 0 : (_formValues$formLogic = formValues.formLogic) === null || _formValues$formLogic === void 0 ? void 0 : _formValues$formLogic.locales) || 'default';
  if (formValues !== null && formValues !== void 0 && (_formValues$formLogic2 = formValues.formLogic) !== null && _formValues$formLogic2 !== void 0 && _formValues$formLogic2.locales && locales !== 'en-US') {
    return date.toLocaleString(locales, {
      dateStyle: 'long'
    });
  }
  var day = date.getDate();
  var month = date.toLocaleString('default', {
    month: 'long'
  });
  var year = date.getFullYear();
  return "".concat(month, " ").concat(day).concat(nthNumber(day), ", ").concat(year);
};
var isValidDate = function isValidDate(dateString) {
  var date = new Date(dateString);
  return !isNaN(date.getTime());
};

var chargeDates = function chargeDates() {
  return Array.from({
    length: 27
  }, function (value, index) {
    return 1 + index;
  });
};
var getChargeDays = function getChargeDays() {
  var Days = [];
  for (var i = 1; i <= 27; i++) {
    Days.push(i);
  }
  return Days;
};
var chargeMonths = function chargeMonths() {
  return ["January", "February", "March", "April", 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
};

var ordinalSuffix = function ordinalSuffix(i) {
  var n = typeof i === 'string' && i.includes('-') ? parseInt(i.split('-')[2], 10) : i;
  if (typeof n !== 'number') return;
  // eslint-disable-next-line consistent-return
  return (
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    n + {
      e: 'st',
      o: 'nd',
      w: 'rd',
      h: 'th'
    }[new Intl.PluralRules('en', {
      type: 'ordinal'
    }).select(n)[2]]
  );
};

var getAvailableOptions = function getAvailableOptions(cartObj) {
  var projects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return projects.sort(function (a, b) {
    return (a === null || a === void 0 ? void 0 : a.order) - (b === null || b === void 0 ? void 0 : b.order);
  }).filter(function (project) {
    return !cartObj[project === null || project === void 0 ? void 0 : project.projectId];
  }).map(function (project) {
    return {
      title: project === null || project === void 0 ? void 0 : project.title,
      projectId: project === null || project === void 0 ? void 0 : project.projectId,
      order: project === null || project === void 0 ? void 0 : project.order
    };
  });
};
var getAvailabilityChargeDates = function getAvailabilityChargeDates() {
  return chargeDates().reduce(function (r, e) {
    r[e] = ordinalSuffix(e);
    return r;
  }, {});
};
var getAvailabilityChargeDays = function getAvailabilityChargeDays() {
  return getChargeDays().reduce(function (r, e) {
    r[e] = ordinalSuffix(e);
    return r;
  }, {});
};
var getAvailabilityChargeMonths = function getAvailabilityChargeMonths() {
  var monthNames = chargeMonths();
  return monthNames.map(function (item, idx) {
    return {
      value: item,
      id: idx + 1
    };
  });
};
var hasPayment = function hasPayment(cartObj) {
  return cartObj && Object.values(cartObj).length > 0 && Object.values(cartObj).every(function (project) {
    return (project === null || project === void 0 ? void 0 : project.amount) > 0;
  }) || false;
};
var hasRecurringPaymentType = function hasRecurringPaymentType(cartObj) {
  return cartObj && Object.values(cartObj).some(function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === PAYMENT_TYPE.RECURRING;
  });
};
var getProjectDescription = function getProjectDescription(projects, projectId) {
  var project = projects.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.projectId) === projectId;
  });
  return (project === null || project === void 0 ? void 0 : project.description) || '';
};
var getProject = function getProject(projects, projectId) {
  return projects.find(function (project) {
    return (project === null || project === void 0 ? void 0 : project.projectId) === projectId;
  });
};
var addItemToCart = function addItemToCart(_ref) {
  var amount = _ref.amount,
    cartObj = _ref.cartObj,
    projectId = _ref.projectId,
    paytmentType = _ref.paytmentType,
    projectOptions = _ref.projectOptions,
    projects = _ref.projects,
    setAddedItem = _ref.setAddedItem,
    setCartInfo = _ref.setCartInfo,
    setFieldValue = _ref.setFieldValue,
    setProjectOptions = _ref.setProjectOptions,
    _ref$isAddedByQuery = _ref.isAddedByQuery,
    isAddedByQuery = _ref$isAddedByQuery === void 0 ? false : _ref$isAddedByQuery;
  var project = _objectSpread2({}, cartObj);
  var id = parseInt(projectId, 10);
  var projectItem = getProject(projects, id);
  var projectAmount = parseFloat(amount);
  var cartItem = {
    projectId: projectItem === null || projectItem === void 0 ? void 0 : projectItem.projectId,
    title: projectItem === null || projectItem === void 0 ? void 0 : projectItem.title,
    type: paytmentType,
    amount: projectAmount
  };
  var updatedProjectOptions = projectOptions.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.projectId) !== id;
  });
  setAddedItem(_objectSpread2({}, cartItem));
  project[cartItem === null || cartItem === void 0 ? void 0 : cartItem.projectId] = cartItem;
  setCartInfo(JSON.stringify(project));
  setFieldValue('formLogic.cartInfo', project);
  setProjectOptions(updatedProjectOptions);
  addCartEvent({
    cartItem: cartItem
  });
  if (isAddedByQuery) {
    setFieldValue('collector.cart.donation.projects', Object.values(project).map(function (item) {
      return {
        projectId: item === null || item === void 0 ? void 0 : item.projectId,
        amount: item === null || item === void 0 ? void 0 : item.amount,
        initialChargeProcessed: true
      };
    }));
  }
};
var getQueryStringDict = function getQueryStringDict() {
  var queryString = window.location.search.substring(1).split('&');
  var queryDict = {};
  for (var i = 0; i < queryString.length; i++) {
    var param = queryString[i].split('=');
    if (param.length === 2) {
      queryDict[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '));
    }
  }
  return queryDict;
};
var getValidDate = function getValidDate(date) {
  var dateArr = date.split('-');
  if ((dateArr === null || dateArr === void 0 ? void 0 : dateArr.length) === 0) {
    return new Date();
  }
  var _dateArr = _slicedToArray(dateArr, 3),
    year = _dateArr[0],
    month = _dateArr[1],
    day = _dateArr[2];
  return new Date(year, month - 1, day);
};
var calculateStartDate = function calculateStartDate(recurringDate) {
  var _getValidDate$getDate, _ref2;
  var today = new Date();
  var recurringDay = isNaN(Number(recurringDate)) ? (_getValidDate$getDate = getValidDate(recurringDate).getDate()) === null || _getValidDate$getDate === void 0 ? void 0 : _getValidDate$getDate.toString() : recurringDate;
  var daysInMonth = getDaysInMonth(today);
  var month = today.getMonth();
  var todaysDay = today.getDate();
  var year = today.getFullYear();
  var monthIndex = month;
  var dayDifference = daysInMonth - todaysDay + parseInt(recurringDay, 10);
  var indicator = dayDifference - 28;
  if (indicator < 0) {
    monthIndex = (month + 2) % 12; // don't allow array overrun
  } else {
    monthIndex = (month + 1) % 12; // don't allow array overrun
  }
  // add year
  if (monthIndex < month) {
    year += 1;
  }
  var padMonth = (_ref2 = "".concat(monthIndex + 1)) === null || _ref2 === void 0 ? void 0 : _ref2.padStart(2, '0');
  return "".concat(year, "-").concat(padMonth, "-").concat("0".concat(recurringDay).slice(-2));
};
var getFormattedStartDate = function getFormattedStartDate(startDate, formValues) {
  var calculatedDate = calculateStartDate(startDate);
  return formatDate(getValidDate(calculatedDate), formValues);
};
var createDate = function createDate(dateInNumber) {
  var dateArr = dateInNumber.split('-');
  var _dateArr2 = _slicedToArray(dateArr, 3),
    year = _dateArr2[0],
    month = _dateArr2[1],
    day = _dateArr2[2];
  var DayNu = parseInt(day, 10);
  var adjustedMonth = month - 1;
  var date = new Date(year, adjustedMonth, day);
  var dayWithSuffix = ordinalSuffix(DayNu);
  var formattedDate = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return "".concat(formattedDate.replace(/\b\d{1,2}\b/, dayWithSuffix));
};
var calculateStartDateMonthDropDown = function calculateStartDateMonthDropDown(recurringDate, recurringMonth) {
  var today = new Date();
  var recurringDay = +recurringDate;
  var currentMonth = today.getMonth() + 1;
  var month = +recurringMonth;
  var year = today.getFullYear();
  var currentDate = today.getDate();
  var monthYear = year;
  if (currentMonth >= month && recurringDay <= currentDate + 1) {
    monthYear += 1;
  }
  // add year

  if (isNaN(Number(recurringDate)) && recurringDate !== undefined && recurringMonth !== undefined) {
    var dateArr = recurringDate.split('-');
    var _dateArr3 = _slicedToArray(dateArr, 3),
      modifiedDate = _dateArr3[2];
    return "".concat(monthYear, "-").concat(String(month).padStart(2, '0'), "-").concat(String(modifiedDate).padStart(2, '0'));
  }
  return "".concat(monthYear, "-").concat(String(month).padStart(2, '0'), "-").concat(String(recurringDay).padStart(2, '0'));
};
var getFormattedStartDateDropDown = function getFormattedStartDateDropDown(startDate, startMonth) {
  var dateInNumber = calculateStartDateMonthDropDown(startDate, startMonth);
  return createDate(dateInNumber);
};
var shouldEnableButton = function shouldEnableButton(_ref3) {
  var _values$formLogic, _Object$keys;
  var currencyError = _ref3.currencyError,
    hasCartPayment = _ref3.hasCartPayment,
    hasRecurringPayment = _ref3.hasRecurringPayment,
    values = _ref3.values;
  return (hasCartPayment && !hasRecurringPayment || hasCartPayment && hasRecurringPayment && (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.recurringDate)) && ((_Object$keys = Object.keys(currencyError)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0;
};
var updateCartInfo = function updateCartInfo(_ref4) {
  var _values$formLogic2, _values$formLogic3, _Object$values, _values$formLogic4;
  var cartInfo = _ref4.cartInfo,
    values = _ref4.values,
    getUpdatedProjectInfo = _ref4.getUpdatedProjectInfo,
    setCartInfo = _ref4.setCartInfo;
  var formLogicInfoStr = JSON.stringify((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.cartInfo);
  if ((_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.cartInfo && ((_Object$values = Object.values((_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.cartInfo)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 0 && formLogicInfoStr !== cartInfo) {
    var projectItem = getUpdatedProjectInfo();
    setCartInfo(JSON.stringify(projectItem));
  }
};
var updateRecurringPayment = function updateRecurringPayment(_ref5) {
  var _values$formLogic5;
  var cartObj = _ref5.cartObj,
    hasRecurringPayment = _ref5.hasRecurringPayment,
    values = _ref5.values,
    setFieldValue = _ref5.setFieldValue,
    setCartInfo = _ref5.setCartInfo;
  if (!hasRecurringPayment && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.recurringDate) {
    var _values$collector$car;
    var projectItem = _objectSpread2({}, cartObj);
    values.formLogic.recurringDate = '';
    (_values$collector$car = values.collector.cart.donation.projects) === null || _values$collector$car === void 0 ? void 0 : _values$collector$car.forEach(function (project, index) {
      if (project.recurringDate) {
        var _projectItem$project$;
        (_projectItem$project$ = projectItem[project === null || project === void 0 ? void 0 : project.projectId]) === null || _projectItem$project$ === void 0 ? true : delete _projectItem$project$.recurringDate;
        delete values.collector.cart.donation.projects[index].recurringDate;
      }
    });
    setFieldValue('formLogic.recurringDate', '');
    setCartInfo(JSON.stringify(projectItem));
  }
};
var updateSelectedProject = function updateSelectedProject(_ref6) {
  var _values$formLogic6, _values$formLogic6$se;
  var addedItem = _ref6.addedItem,
    cartObj = _ref6.cartObj,
    projectOptions = _ref6.projectOptions,
    projects = _ref6.projects,
    values = _ref6.values,
    setAddedItem = _ref6.setAddedItem,
    setCartInfo = _ref6.setCartInfo,
    setProjectOptions = _ref6.setProjectOptions;
  if ((_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && (_values$formLogic6$se = _values$formLogic6.selectedProjectDonation) !== null && _values$formLogic6$se !== void 0 && _values$formLogic6$se.projectId) {
    var _values$formLogic$sel, _values$collector$car2;
    var storedCartItem = _objectSpread2({}, cartObj[addedItem === null || addedItem === void 0 ? void 0 : addedItem.projectId]);
    var selectedId = (_values$formLogic$sel = values.formLogic.selectedProjectDonation) === null || _values$formLogic$sel === void 0 ? void 0 : _values$formLogic$sel.projectId;
    var selectedProjected = projects.find(function (project) {
      return (project === null || project === void 0 ? void 0 : project.projectId) === selectedId;
    });
    var cartItem = _objectSpread2({
      projectId: selectedId,
      title: selectedProjected === null || selectedProjected === void 0 ? void 0 : selectedProjected.title,
      type: storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.type,
      amount: storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.amount
    }, (storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate) && {
      recurringDate: storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate
    });
    var options = projectOptions === null || projectOptions === void 0 ? void 0 : projectOptions.filter(function (item) {
      return (item === null || item === void 0 ? void 0 : item.projectId) !== selectedId;
    });
    var projectObj = _objectSpread2({}, cartObj);
    delete projectObj[addedItem === null || addedItem === void 0 ? void 0 : addedItem.projectId];
    projectObj[selectedId] = cartItem;
    (_values$collector$car2 = values.collector.cart.donation.projects) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.forEach(function (project) {
      if (project.projectId === (addedItem === null || addedItem === void 0 ? void 0 : addedItem.projectId)) {
        project.projectId = selectedId;
      }
    });
    setProjectOptions([{
      projectId: addedItem === null || addedItem === void 0 ? void 0 : addedItem.projectId,
      title: addedItem === null || addedItem === void 0 ? void 0 : addedItem.title
    }].concat(_toConsumableArray(options)));
    setAddedItem(_objectSpread2({}, cartItem));
    setCartInfo(JSON.stringify(projectObj));
  }
};
var handleCheckoutComponentDidMount = function handleCheckoutComponentDidMount(_ref7) {
  var _Object$keys2;
  var amount = _ref7.amount,
    cartObj = _ref7.cartObj,
    enableApayPayment = _ref7.enableApayPayment,
    giftOffer = _ref7.giftOffer,
    getProjectInfo = _ref7.getProjectInfo,
    hasQueryParams = _ref7.hasQueryParams,
    invalidProjectErrorMsg = _ref7.invalidProjectErrorMsg,
    paytmentType = _ref7.paytmentType,
    productId = _ref7.productId,
    projectId = _ref7.projectId,
    projectOptions = _ref7.projectOptions,
    projects = _ref7.projects,
    setAddedItem = _ref7.setAddedItem,
    setCartInfo = _ref7.setCartInfo,
    setFieldValue = _ref7.setFieldValue,
    setProjectOptions = _ref7.setProjectOptions,
    siteId = _ref7.siteId,
    showFreeGiftOffer = _ref7.showFreeGiftOffer,
    showUpgradeGift = _ref7.showUpgradeGift,
    site = _ref7.site,
    logging = _ref7.logging,
    setShowInvalidProjectError = _ref7.setShowInvalidProjectError;
  var queryProjectDict = getQueryStringDict();
  var _getProjectInfo = getProjectInfo(),
    donations = _getProjectInfo.donations,
    projectList = _getProjectInfo.projectList,
    recurringDate = _getProjectInfo.recurringDate;
  var source = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.source;
  if (recurringDate) {
    var recurringDateNum = parseInt(recurringDate.split('-')[2], 10);
    setFieldValue('formLogic.recurringDateNum', "".concat(recurringDateNum));
  }
  setFieldValue('collector.cart.donation.projects', donations);
  setFieldValue('formLogic.projects', projectList);
  setFieldValue('formLogic.activeMethod', 'CC');
  setFieldValue('formLogic.recurringDate', recurringDate);
  setFieldValue('formLogic.cartId', siteId);
  setFieldValue('formLogic.shouldFormatCurrency', true);
  setFieldValue('formLogic.isDonation', true);
  setFieldValue('formLogic.hasCaptchaBluefinPaymentIframe', true);
  setFieldValue('formLogic.isDonation', true);
  if (((_Object$keys2 = Object.keys(giftOffer)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0) {
    setFieldValue('formLogic.giftOffer', giftOffer);
  }
  if (showFreeGiftOffer) {
    setFieldValue("formLogic.showFreeGiftOffer", true);
  }
  if (source) {
    setFieldValue('collector.SESourceCode', source);
  }
  if (showUpgradeGift) {
    setFieldValue('formLogic.showUpgradeGift', true);
  }
  if (enableApayPayment) {
    setFieldValue("formLogic.enableApayPayment", true);
  }
  viewCartEvent({
    donations: donations,
    projectList: projectList
  });
  var isValidProject = projects.some(function (prj) {
    return prj.projectId === parseInt(projectId, 10);
  });
  if (isValidProject && paytmentType && amount) {
    setShowInvalidProjectError(false);
    if (productId) {
      var customGiftOffer = {
        title: '',
        author: '',
        description: 'In appreciation for your support, a free gift is available with our compliments.*',
        productCode: productId,
        image: ''
      };
      setFieldValue('formLogic.giftOffer', customGiftOffer);
    }
    addItemToCart({
      amount: amount,
      cartObj: cartObj,
      projectId: projectId,
      paytmentType: paytmentType,
      projectOptions: projectOptions,
      projects: projects,
      setAddedItem: setAddedItem,
      setCartInfo: setCartInfo,
      setFieldValue: setFieldValue,
      setProjectOptions: setProjectOptions,
      isAddedByQuery: hasQueryParams
    });
  } else {
    setFieldValue('formLogic.cartInfo', cartObj);
  }
  if (projectId && !isValidProject) {
    setShowInvalidProjectError(true);
    logging({
      log: JSON.stringify({
        description: invalidProjectErrorMsg,
        referrer: document.referrer,
        projectId: projectId
      }),
      type: 'info',
      referrer: site
    });
  }
};

/* BRB Donation Cart logic */

var handleOrgGift = function handleOrgGift(values, setFieldValue) {
  var _values$collector, _values$collector$car3, _values$collector$car4, _values$collector$car5;
  if ((values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car3 = _values$collector.cart) === null || _values$collector$car3 === void 0 ? void 0 : (_values$collector$car4 = _values$collector$car3.donation) === null || _values$collector$car4 === void 0 ? void 0 : (_values$collector$car5 = _values$collector$car4.projects) === null || _values$collector$car5 === void 0 ? void 0 : _values$collector$car5.length) > 0) {
    values.collector.cart.donation.projects.forEach(function (item, index) {
      setFieldValue("collector.cart.donation.projects[".concat(index, "].orgGift"), values.formLogic.orgGift);
    });
  }
};
var handleSubTotal = function handleSubTotal(cart, setFieldValue) {
  var _cart$donation, _cart$donation$projec;
  if ((cart === null || cart === void 0 ? void 0 : (_cart$donation = cart.donation) === null || _cart$donation === void 0 ? void 0 : (_cart$donation$projec = _cart$donation.projects) === null || _cart$donation$projec === void 0 ? void 0 : _cart$donation$projec.length) > 0) {
    var _cart$donation2, _cart$donation2$proje;
    var total = cart === null || cart === void 0 ? void 0 : (_cart$donation2 = cart.donation) === null || _cart$donation2 === void 0 ? void 0 : (_cart$donation2$proje = _cart$donation2.projects) === null || _cart$donation2$proje === void 0 ? void 0 : _cart$donation2$proje.reduce(function (a, b) {
      return a + ((b === null || b === void 0 ? void 0 : b.amount) || 0);
    }, 0);
    setFieldValue("collector.cart.cartTotals.subTotal", total);
  } else {
    setFieldValue("collector.cart.cartTotals.subTotal", 0);
  }
};
var handleRecurringDateLogic = function handleRecurringDateLogic(values, setFieldValue) {
  var _values$formLogic7;
  if (Array.isArray(values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.recurringDonations)) {
    var _values$formLogic8, _values$formLogic8$re;
    values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : (_values$formLogic8$re = _values$formLogic8.recurringDonations) === null || _values$formLogic8$re === void 0 ? void 0 : _values$formLogic8$re.forEach(function (item, index) {
      var _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$collector3, _values$collector3$ca, _values$collector3$ca2;
      if (values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$ca = _values$collector2.cart) !== null && _values$collector2$ca !== void 0 && (_values$collector2$ca2 = _values$collector2$ca.donation) !== null && _values$collector2$ca2 !== void 0 && _values$collector2$ca2.projects && Array.isArray(values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$ca = _values$collector3.cart) === null || _values$collector3$ca === void 0 ? void 0 : (_values$collector3$ca2 = _values$collector3$ca.donation) === null || _values$collector3$ca2 === void 0 ? void 0 : _values$collector3$ca2.projects)) {
        var _values$collector5, _values$collector5$ca, _values$collector5$ca2, _values$collector5$ca3;
        if (values.formLogic.recurringDonations[index]) {
          var _values$collector4, _values$collector4$ca, _values$collector4$ca2;
          if (values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && (_values$collector4$ca = _values$collector4.cart) !== null && _values$collector4$ca !== void 0 && (_values$collector4$ca2 = _values$collector4$ca.donation) !== null && _values$collector4$ca2 !== void 0 && _values$collector4$ca2.projects[index]) {
            var _values$formLogic9;
            setFieldValue("collector.cart.donation.projects[".concat(index, "].recurringDate"), values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : _values$formLogic9.recurringDate);
          }
        } else if (values !== null && values !== void 0 && (_values$collector5 = values.collector) !== null && _values$collector5 !== void 0 && (_values$collector5$ca = _values$collector5.cart) !== null && _values$collector5$ca !== void 0 && (_values$collector5$ca2 = _values$collector5$ca.donation) !== null && _values$collector5$ca2 !== void 0 && (_values$collector5$ca3 = _values$collector5$ca2.projects[index]) !== null && _values$collector5$ca3 !== void 0 && _values$collector5$ca3.recurringDate) {
          delete values.collector.cart.donation.projects[index].recurringDate;
        }
      }
    });
  }
};
var handleDeleteItem = function handleDeleteItem(index, nextDonationCount, values, setNextDonationCount) {
  var _values$formLogic10, _values$formLogic11, _values$formLogic12, _values$formLogic12$r, _values$formLogic13, _values$formLogic13$i;
  if (values !== null && values !== void 0 && (_values$formLogic10 = values.formLogic) !== null && _values$formLogic10 !== void 0 && _values$formLogic10.itemizedDonations && (values === null || values === void 0 ? void 0 : (_values$formLogic11 = values.formLogic) === null || _values$formLogic11 === void 0 ? void 0 : _values$formLogic11.itemizedDonations[index]) === 1) {
    delete values.formLogic.itemCalculator;
  }
  if ((values === null || values === void 0 ? void 0 : (_values$formLogic12 = values.formLogic) === null || _values$formLogic12 === void 0 ? void 0 : (_values$formLogic12$r = _values$formLogic12.recurringDonations) === null || _values$formLogic12$r === void 0 ? void 0 : _values$formLogic12$r.length) > 0) {
    values.formLogic.recurringDonations.splice(index, 1);
  }
  if ((values === null || values === void 0 ? void 0 : (_values$formLogic13 = values.formLogic) === null || _values$formLogic13 === void 0 ? void 0 : (_values$formLogic13$i = _values$formLogic13.itemizedDonations) === null || _values$formLogic13$i === void 0 ? void 0 : _values$formLogic13$i.length) > 0) {
    values.formLogic.itemizedDonations.splice(index, 1);
  }
  setNextDonationCount(nextDonationCount - 1);
};
var getChargeDates = function getChargeDates() {
  var Dates = [];
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth();
  var day = date.getDate();
  var thisMonth = month + 1;
  var nextMonth = month + 2;
  for (var i = 1; i <= 27; i++) {
    if (day - i <= 5 || i < day) {
      var dateStr = nextMonth === 13 ? "".concat(year + 1, "-01-").concat(i) : "".concat(year, "-").concat(nextMonth, "-").concat(i);
      Dates.push(dateStr);
    } else {
      var _dateStr = nextMonth === 13 ? "".concat(year + 1, "-01-").concat(i) : "".concat(year, "-").concat(thisMonth, "-").concat(i);
      Dates.push(_dateStr);
    }
  }
  return Dates;
};
var getAvailableDateOptions = function getAvailableDateOptions(values) {
  var availableChargeDates = {};
  var chrgDates = getChargeDates();
  if (values.formLogic && values.formLogic.activeMethod === 'CC') {
    availableChargeDates[''] = '';
    availableChargeDates[chrgDates[4]] = '5th of Next Month';
    availableChargeDates[chrgDates[19]] = '20th of Next Month';
  }
  if (values.formLogic && values.formLogic.activeMethod === 'EFT') {
    availableChargeDates[''] = '';
    availableChargeDates[chrgDates[4]] = '5th of Next Month';
    availableChargeDates[chrgDates[9]] = '10th of Next Month';
    availableChargeDates[chrgDates[14]] = '15th of Next Month';
    availableChargeDates[chrgDates[24]] = '25th of Next Month';
  }
  return convertOptionsToList(availableChargeDates);
};
var getRecurringTotal = function getRecurringTotal(cart) {
  var _cart$donation3, _cart$donation3$proje;
  var recurringTotal = 0;
  if ((cart === null || cart === void 0 ? void 0 : (_cart$donation3 = cart.donation) === null || _cart$donation3 === void 0 ? void 0 : (_cart$donation3$proje = _cart$donation3.projects) === null || _cart$donation3$proje === void 0 ? void 0 : _cart$donation3$proje.length) > 0) {
    var _cart$donation4;
    recurringTotal = cart === null || cart === void 0 ? void 0 : (_cart$donation4 = cart.donation) === null || _cart$donation4 === void 0 ? void 0 : _cart$donation4.projects.filter(function (project) {
      return project === null || project === void 0 ? void 0 : project.recurringDate;
    }).reduce(function (a, b) {
      return a + ((b === null || b === void 0 ? void 0 : b.amount) || 0);
    }, 0);
  }
  return recurringTotal;
};
var getProjectOptions = function getProjectOptions(projectId, values) {
  var _values$formLogic14, _values$formLogic14$b, _values$formLogic14$b2, _values$formLogic14$b3;
  var projectOptions = [{
    id: projectId,
    value: 'Where Most Needed'
  }];

  // If projects are sent in, replace the defualt with given projects
  if ((values === null || values === void 0 ? void 0 : (_values$formLogic14 = values.formLogic) === null || _values$formLogic14 === void 0 ? void 0 : (_values$formLogic14$b = _values$formLogic14.brbInfo) === null || _values$formLogic14$b === void 0 ? void 0 : (_values$formLogic14$b2 = _values$formLogic14$b.campaign) === null || _values$formLogic14$b2 === void 0 ? void 0 : (_values$formLogic14$b3 = _values$formLogic14$b2.projects) === null || _values$formLogic14$b3 === void 0 ? void 0 : _values$formLogic14$b3.length) > 0) {
    var _values$formLogic15, _values$formLogic15$b, _values$formLogic15$b2, _values$formLogic15$b3;
    projectOptions = values === null || values === void 0 ? void 0 : (_values$formLogic15 = values.formLogic) === null || _values$formLogic15 === void 0 ? void 0 : (_values$formLogic15$b = _values$formLogic15.brbInfo) === null || _values$formLogic15$b === void 0 ? void 0 : (_values$formLogic15$b2 = _values$formLogic15$b.campaign) === null || _values$formLogic15$b2 === void 0 ? void 0 : (_values$formLogic15$b3 = _values$formLogic15$b2.projects) === null || _values$formLogic15$b3 === void 0 ? void 0 : _values$formLogic15$b3.map(function (project) {
      return {
        id: project === null || project === void 0 ? void 0 : project.project,
        value: project.description
      };
    });
  }
  return projectOptions;
};

var excludeListDonationFunnel = [Templates.DECISION_MAGAZINE];
var rekey = function rekey(object, oldKey, newKey) {
  if (object[oldKey]) {
    object[newKey] = object[oldKey];
    delete object[oldKey];
  }
};
var isRecurring = false; // To hold previous state

var getRecurringDateInfo = function getRecurringDateInfo(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$collector$car3, _values$formLogic, _values$formLogic$car, _values$formLogic$car2, _values$formLogic$car3, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$formLogic4$ca, _values$formLogic4$ca2, _values$formLogic4$ca3, _values$formLogic5;
  var cartObj = _ref.cartObj,
    values = _ref.values;
  var currentRecurringDate = '';
  var prevRecurringDate = (cartObj === null || cartObj === void 0 ? void 0 : cartObj.recurringDate) || (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.projects[0]) === null || _values$collector$car3 === void 0 ? void 0 : _values$collector$car3.recurringDate) || '';
  if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && (_values$formLogic$car = _values$formLogic.cart) !== null && _values$formLogic$car !== void 0 && (_values$formLogic$car2 = _values$formLogic$car.donation) !== null && _values$formLogic$car2 !== void 0 && (_values$formLogic$car3 = _values$formLogic$car2.projects[0]) !== null && _values$formLogic$car3 !== void 0 && _values$formLogic$car3.isRecurring && values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.defaultDebitDay && !(values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.recurringDateNum)) {
    currentRecurringDate = calculateStartDate('5');
  } else if (values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && (_values$formLogic4$ca = _values$formLogic4.cart) !== null && _values$formLogic4$ca !== void 0 && (_values$formLogic4$ca2 = _values$formLogic4$ca.donation) !== null && _values$formLogic4$ca2 !== void 0 && (_values$formLogic4$ca3 = _values$formLogic4$ca2.projects[0]) !== null && _values$formLogic4$ca3 !== void 0 && _values$formLogic4$ca3.isRecurring && values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.recurringDateNum) {
    var _values$formLogic6;
    currentRecurringDate = calculateStartDate(values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.recurringDateNum);
  }
  return {
    prevRecurringDate: prevRecurringDate,
    currentRecurringDate: currentRecurringDate
  };
};
var transformEcommerce = function transformEcommerce(eventData) {
  var _eventData$submission, _eventData$cart, _eventData$cart$cartT, _eventData$cart2, _eventData$cart2$cart, _eventData$cart3, _eventData$cart3$cart, _eventData$cart4, _eventData$cart4$cart;
  var ecommerceData = {
    // 'eventType':  eventData.eventType,
    // 'purchase': {
    transaction_id: ((_eventData$submission = eventData.submissionresponse) === null || _eventData$submission === void 0 ? void 0 : _eventData$submission.id) || undefined,
    // Transaction ID- Type: String
    // 'affiliation': 'Online Store',  // Affliation - Type: String
    value: ((_eventData$cart = eventData.cart) === null || _eventData$cart === void 0 ? void 0 : (_eventData$cart$cartT = _eventData$cart.cartTotals) === null || _eventData$cart$cartT === void 0 ? void 0 : _eventData$cart$cartT.subTotal) || 0,
    // Product Price- Type: Numeric
    tax: ((_eventData$cart2 = eventData.cart) === null || _eventData$cart2 === void 0 ? void 0 : (_eventData$cart2$cart = _eventData$cart2.cartTotals) === null || _eventData$cart2$cart === void 0 ? void 0 : _eventData$cart2$cart.taxAmount) || 0,
    // Taxes If applicable- Type: Numeric - 9.99
    shipping: ((_eventData$cart3 = eventData.cart) === null || _eventData$cart3 === void 0 ? void 0 : (_eventData$cart3$cart = _eventData$cart3.cartTotals) === null || _eventData$cart3$cart === void 0 ? void 0 : _eventData$cart3$cart.shippingTotal) || 0,
    // Shipping Charges- Type: Numeric - 9.99
    currency: ((_eventData$cart4 = eventData.cart) === null || _eventData$cart4 === void 0 ? void 0 : (_eventData$cart4$cart = _eventData$cart4.cartTotals) === null || _eventData$cart4$cart === void 0 ? void 0 : _eventData$cart4$cart.currency) || 'USD',
    // Currency-Type: String - 'USD'
    payment_type: eventData.paymentMethod || undefined,
    items: []
    // 'coupon': 'SUMMER_SALE',     // Coupon Code if applicable- Type: String
    // }
  };

  var items = [];
  Object.keys(eventData.cart).forEach(function (e) {
    if (eventData.cart[e] && Array.isArray(eventData.cart[e])) {
      items.push.apply(items, _toConsumableArray(eventData.cart[e].map(function (v) {
        return _objectSpread2(_objectSpread2({}, v), {}, {
          item_category: e
        });
      })));
    }
    if (e === 'donation') {
      items.push.apply(items, _toConsumableArray(eventData.cart[e].projects.map(function (v) {
        return _objectSpread2(_objectSpread2({}, v), {}, {
          item_category: e,
          item_variant: v.recurringDate ? 'Recurring' : 'One Time'
        });
      })));
    }
  });
  items.forEach(function (i) {
    rekey(i, 'amount', 'price');
    rekey(i, 'projectId', 'item_name');
    rekey(i, 'productId', 'item_name');
    rekey(i, 'eventId', 'item_name');
  });
  ecommerceData.items = items;
  return ecommerceData;
};
var getProjectData = function getProjectData(_ref2) {
  var _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$collector2$ca3, _values$formLogic7;
  var amount = _ref2.amount,
    cartObj = _ref2.cartObj,
    frequency = _ref2.frequency,
    values = _ref2.values;
  return {
    currency: 'USD',
    value: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.amount) || amount,
    items: [{
      item_id: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.projectId) || (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : (_values$collector2$ca2 = _values$collector2$ca.donation) === null || _values$collector2$ca2 === void 0 ? void 0 : (_values$collector2$ca3 = _values$collector2$ca2.projects[0]) === null || _values$collector2$ca3 === void 0 ? void 0 : _values$collector2$ca3.projectId),
      item_name: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.title) || (values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.projectTitle) || '',
      item_category: 'donation',
      item_variant: frequency,
      price: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.amount) || amount,
      quantity: 1
    }]
  };
};
var getCartData = function getCartData(_ref3) {
  var cartItem = _ref3.cartItem;
  return {
    currency: 'USD',
    value: cartItem === null || cartItem === void 0 ? void 0 : cartItem.amount,
    items: [{
      item_id: cartItem === null || cartItem === void 0 ? void 0 : cartItem.projectId,
      item_name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.title,
      item_category: 'donation',
      price: cartItem === null || cartItem === void 0 ? void 0 : cartItem.amount,
      quantity: 1
    }]
  };
};

/* Adding logs to debug embed forms */
var trackEvent = function trackEvent() {
  var eventType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bgform';
  var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.dataLayer = window.dataLayer || [];
  if (eventType === 'bgform-ecommerce') {
    try {
      window.dataLayer.push({
        ecommerce: null
      });
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: transformEcommerce(eventData)
      });
    } catch (error) {
      /* catch error */
    }
  } else {
    // postAnalyticsMessage(eventType, eventData);
    window.dataLayer.push({
      eventData: null
    });
    window.dataLayer.push({
      event: eventType,
      eventData: eventData
    });
  }
};

/* START DONATION FUNNEL Events */

var trackDonationFunnel = function trackDonationFunnel(_ref4) {
  var _values$formLogic8;
  var _ref4$beginButtonClic = _ref4.beginButtonClick,
    beginButtonClick = _ref4$beginButtonClic === void 0 ? null : _ref4$beginButtonClic,
    _ref4$paymentOptionCl = _ref4.paymentOptionClick,
    paymentOptionClick = _ref4$paymentOptionCl === void 0 ? null : _ref4$paymentOptionCl,
    _ref4$addressDetailCo = _ref4.addressDetailComplete,
    addressDetailComplete = _ref4$addressDetailCo === void 0 ? null : _ref4$addressDetailCo,
    _ref4$paymentButtonCl = _ref4.paymentButtonClick,
    paymentButtonClick = _ref4$paymentButtonCl === void 0 ? null : _ref4$paymentButtonCl,
    _ref4$donationConfirm = _ref4.donationConfirmed,
    donationConfirmed = _ref4$donationConfirm === void 0 ? null : _ref4$donationConfirm,
    values = _ref4.values;
  var templateName = values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : _values$formLogic8.templateName;
  if (!excludeListDonationFunnel.includes(templateName)) {
    trackEvent(DONATION_FUNNEL, {
      beginButtonClick: beginButtonClick,
      paymentOptionClick: paymentOptionClick,
      addressDetailComplete: addressDetailComplete,
      paymentButtonClick: paymentButtonClick,
      donationConfirmed: donationConfirmed
    });
  }
};
var trackGivingButtons = function trackGivingButtons() {
  trackEvent('donation_default_click');
};

/* END DONATION FUNNEL Events  */

var beginCheckoutEvent = function beginCheckoutEvent(_ref5) {
  var _values$collector3, _values$collector3$ca, _values$collector3$ca2, _values$collector3$ca3, _values$formLogic9, _values$formLogic9$ca, _values$formLogic9$ca2, _values$formLogic9$ca3;
  var values = _ref5.values;
  var amount = values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$ca = _values$collector3.cart) === null || _values$collector3$ca === void 0 ? void 0 : (_values$collector3$ca2 = _values$collector3$ca.donation) === null || _values$collector3$ca2 === void 0 ? void 0 : (_values$collector3$ca3 = _values$collector3$ca2.projects[0]) === null || _values$collector3$ca3 === void 0 ? void 0 : _values$collector3$ca3.amount;
  var currentFrequency = "".concat(Frequency.Monthly);
  isRecurring = values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : (_values$formLogic9$ca = _values$formLogic9.cart) === null || _values$formLogic9$ca === void 0 ? void 0 : (_values$formLogic9$ca2 = _values$formLogic9$ca.donation) === null || _values$formLogic9$ca2 === void 0 ? void 0 : (_values$formLogic9$ca3 = _values$formLogic9$ca2.projects[0]) === null || _values$formLogic9$ca3 === void 0 ? void 0 : _values$formLogic9$ca3.isRecurring;
  var frequency = isRecurring ? currentFrequency : Frequency.OneTime;
  trackEvent(BEGIN_CHECKOUT, getProjectData({
    amount: amount,
    frequency: frequency,
    values: values
  }));
  trackDonationFunnel({
    beginButtonClick: 'Y',
    values: values
  });
};
var removeFromCartEvent = function removeFromCartEvent(_ref6) {
  var amount = _ref6.amount,
    cartObj = _ref6.cartObj,
    frequency = _ref6.frequency,
    values = _ref6.values;
  trackEvent(REMOVE_FROM_CART, getProjectData({
    amount: amount,
    cartObj: cartObj,
    frequency: frequency,
    values: values
  }));
};
var addToCartEvent = function addToCartEvent(_ref7) {
  var amount = _ref7.amount,
    cartObj = _ref7.cartObj,
    frequency = _ref7.frequency,
    values = _ref7.values;
  trackEvent(ADD_TO_CART, getProjectData({
    amount: amount,
    cartObj: cartObj,
    frequency: frequency,
    values: values
  }));
};
var updateCartEvent = function updateCartEvent(_ref8) {
  var _values$collector4, _values$collector4$ca, _values$collector4$ca2, _values$collector5, _values$collector5$ca, _values$collector5$ca2, _values$collector5$ca3, _values$formLogic10, _values$formLogic10$c, _values$formLogic10$c2, _values$formLogic10$c3;
  var values = _ref8.values;
  var prevAmount = values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$ca = _values$collector4.cart) === null || _values$collector4$ca === void 0 ? void 0 : (_values$collector4$ca2 = _values$collector4$ca.cartTotals) === null || _values$collector4$ca2 === void 0 ? void 0 : _values$collector4$ca2.subTotal;
  var currentAmount = values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$ca = _values$collector5.cart) === null || _values$collector5$ca === void 0 ? void 0 : (_values$collector5$ca2 = _values$collector5$ca.donation) === null || _values$collector5$ca2 === void 0 ? void 0 : (_values$collector5$ca3 = _values$collector5$ca2.projects[0]) === null || _values$collector5$ca3 === void 0 ? void 0 : _values$collector5$ca3.amount;
  var _getRecurringDateInfo = getRecurringDateInfo({
      values: values
    }),
    currentRecurringDate = _getRecurringDateInfo.currentRecurringDate,
    prevRecurringDate = _getRecurringDateInfo.prevRecurringDate;
  var prevFrequency = "".concat(Frequency.Monthly, " - ").concat(prevRecurringDate);
  removeFromCartEvent({
    amount: prevAmount,
    frequency: isRecurring ? prevFrequency : Frequency.OneTime,
    values: values
  });
  var currentFrequency = "".concat(Frequency.Monthly, " - ").concat(currentRecurringDate);
  isRecurring = values === null || values === void 0 ? void 0 : (_values$formLogic10 = values.formLogic) === null || _values$formLogic10 === void 0 ? void 0 : (_values$formLogic10$c = _values$formLogic10.cart) === null || _values$formLogic10$c === void 0 ? void 0 : (_values$formLogic10$c2 = _values$formLogic10$c.donation) === null || _values$formLogic10$c2 === void 0 ? void 0 : (_values$formLogic10$c3 = _values$formLogic10$c2.projects[0]) === null || _values$formLogic10$c3 === void 0 ? void 0 : _values$formLogic10$c3.isRecurring;
  addToCartEvent({
    amount: currentAmount,
    frequency: isRecurring ? currentFrequency : Frequency.OneTime,
    values: values
  });
};
var updateCheckoutEvent = function updateCheckoutEvent(_ref9) {
  var cartObj = _ref9.cartObj,
    frequency = _ref9.frequency;
  var _getRecurringDateInfo2 = getRecurringDateInfo({
      cartObj: cartObj
    }),
    prevRecurringDate = _getRecurringDateInfo2.prevRecurringDate;
  var prevFrequency = "".concat(Frequency.Monthly, " - ").concat(prevRecurringDate);
  removeFromCartEvent({
    cartObj: cartObj,
    frequency: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.type) === 'Recurring' ? prevFrequency : Frequency.OneTime
  });
  addToCartEvent({
    cartObj: cartObj,
    frequency: frequency === 'Recurring' ? Frequency.Monthly : Frequency.OneTime
  });
};
var addCartEvent = function addCartEvent(_ref10) {
  var cartItem = _ref10.cartItem;
  trackEvent(ADD_TO_CART, getCartData({
    cartItem: cartItem
  }));
};
var removeCartEvent = function removeCartEvent(_ref11) {
  var cartItem = _ref11.cartItem;
  trackEvent(REMOVE_FROM_CART, getCartData({
    cartItem: cartItem
  }));
};
var viewCartEvent = function viewCartEvent(_ref12) {
  var donations = _ref12.donations,
    projectList = _ref12.projectList;
  trackEvent(VIEW_CART, {
    currency: 'USD',
    value: donations.reduce(function (acc, donation) {
      return +acc + (donation === null || donation === void 0 ? void 0 : donation.amount);
    }, 0),
    items: donations.map(function (donation, idx) {
      var _projectList$find;
      return {
        item_id: donation === null || donation === void 0 ? void 0 : donation.projectId,
        item_name: ((_projectList$find = projectList.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.projectId) === (donation === null || donation === void 0 ? void 0 : donation.projectId);
        })) === null || _projectList$find === void 0 ? void 0 : _projectList$find.description) || '',
        index: idx,
        price: donation === null || donation === void 0 ? void 0 : donation.amount,
        quantity: 1
      };
    })
  });
};

/* START TEST_MONTHLY_GIFT_REQUEST Events  */
var qualifyingGiftEvent = function qualifyingGiftEvent(_ref13) {
  var _ref13$value = _ref13.value,
    value = _ref13$value === void 0 ? null : _ref13$value;
  trackEvent(TEST_MONTHLY_GIFT_REQUEST, {
    qualifyingGift: value,
    selectedForAsk: null,
    userChoice: null,
    amount: null,
    recurring: null,
    confirmed: null
  });
};
var selectedForAskEvent = function selectedForAskEvent(_ref14) {
  var value = _ref14.value;
  trackEvent(TEST_MONTHLY_GIFT_REQUEST, {
    qualifyingGift: 'Y',
    selectedForAsk: value,
    userChoice: null,
    amount: null,
    recurring: null,
    confirmed: null
  });
};
var alternateButtonAmounts = function alternateButtonAmounts(_ref15) {
  var controlAmounts = _ref15.controlAmounts,
    testingAmounts = _ref15.testingAmounts;
  trackEvent('test_donation_defaults', {
    controlAmounts: controlAmounts,
    testingAmounts: testingAmounts
  });
};
var powerByTextError = function powerByTextError(_ref16) {
  var phoneNumber = _ref16.phoneNumber;
  trackEvent('phone_error', {
    phoneNumber: phoneNumber
  });
};
var userChoiceEvent = function userChoiceEvent(_ref17) {
  var amount = _ref17.amount,
    _ref17$confirmed = _ref17.confirmed,
    confirmed = _ref17$confirmed === void 0 ? null : _ref17$confirmed,
    recurring = _ref17.recurring,
    _ref17$value = _ref17.value,
    value = _ref17$value === void 0 ? null : _ref17$value;
  trackEvent(TEST_MONTHLY_GIFT_REQUEST, {
    qualifyingGift: 'Y',
    selectedForAsk: 'Y',
    userChoice: value,
    amount: amount,
    recurring: recurring,
    confirmed: confirmed
  });
};
var confirmationChoiceEvent = function confirmationChoiceEvent(_ref18) {
  var qualifyingGift = _ref18.qualifyingGift,
    selectedForAsk = _ref18.selectedForAsk,
    userChoice = _ref18.userChoice,
    amount = _ref18.amount,
    recurring = _ref18.recurring,
    confirmed = _ref18.confirmed;
  trackEvent(TEST_MONTHLY_GIFT_REQUEST, {
    qualifyingGift: qualifyingGift,
    selectedForAsk: selectedForAsk,
    userChoice: userChoice,
    amount: amount,
    recurring: recurring,
    confirmed: confirmed
  });
};

/* END TEST_MONTHLY_GIFT_REQUEST Events  */

var getApayErrors = function getApayErrors(_ref) {
  var _billingContact$given, _billingContact$famil, _billingContact$addre, _billingContact$local, _billingContact$admin, _billingContact$posta;
  var billingContact = _ref.billingContact;
  var errors = [];
  if (!(billingContact !== null && billingContact !== void 0 && (_billingContact$given = billingContact.givenName) !== null && _billingContact$given !== void 0 && _billingContact$given.trim()) || !(billingContact !== null && billingContact !== void 0 && (_billingContact$famil = billingContact.familyName) !== null && _billingContact$famil !== void 0 && _billingContact$famil.trim())) {
    var billingNameError = new window.ApplePayError('billingContactInvalid', 'name', 'Please enter your first and last name.');
    errors.push(billingNameError);
  }
  if (!(billingContact !== null && billingContact !== void 0 && (_billingContact$addre = billingContact.addressLines[0]) !== null && _billingContact$addre !== void 0 && _billingContact$addre.trim())) {
    var billingAddressLinesError = new window.ApplePayError('billingContactInvalid', 'addressLines', 'Please enter a valid address.');
    errors.push(billingAddressLinesError);
  }
  if (!(billingContact !== null && billingContact !== void 0 && (_billingContact$local = billingContact.locality) !== null && _billingContact$local !== void 0 && _billingContact$local.trim())) {
    var billingLocalityError = new window.ApplePayError('billingContactInvalid', 'locality', 'Please enter a valid city.');
    errors.push(billingLocalityError);
  }
  if (!(billingContact !== null && billingContact !== void 0 && (_billingContact$admin = billingContact.administrativeArea) !== null && _billingContact$admin !== void 0 && _billingContact$admin.trim())) {
    var billingAdministrativeAreaError = new window.ApplePayError('billingContactInvalid', 'administrativeArea', 'Please enter a valid state.');
    errors.push(billingAdministrativeAreaError);
  }
  if (!(billingContact !== null && billingContact !== void 0 && (_billingContact$posta = billingContact.postalCode) !== null && _billingContact$posta !== void 0 && _billingContact$posta.trim())) {
    var billingPostalCodeError = new window.ApplePayError('billingContactInvalid', 'postalCode', 'Please enter a valid postal code.');
    errors.push(billingPostalCodeError);
  }
  return errors;
};
var isValidEmail$1 = function isValidEmail(_ref2) {
  var _emailAddress$trim;
  var billingContact = _ref2.billingContact,
    enableApayNeverBounce = _ref2.enableApayNeverBounce,
    shippingContact = _ref2.shippingContact,
    emailVerifyHandler = _ref2.emailVerifyHandler;
  // eslint-disable-line consistent-return
  var emailAddress = (billingContact === null || billingContact === void 0 ? void 0 : billingContact.emailAddress) || (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.emailAddress);
  var isEmailValid = (emailAddress === null || emailAddress === void 0 ? void 0 : (_emailAddress$trim = emailAddress.trim()) === null || _emailAddress$trim === void 0 ? void 0 : _emailAddress$trim.length) > 0;
  var isEmailNeverBounceValid = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return emailVerifyHandler.postEmailVerify(emailAddress);
          case 3:
            response = _context.sent;
            return _context.abrupt("return", (response === null || response === void 0 ? void 0 : response.emailValid) !== false);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", isEmailValid);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function isEmailNeverBounceValid() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (!enableApayNeverBounce) {
    return isEmailValid;
  }
  isEmailNeverBounceValid().then(function (isValid) {
    return isValid && isEmailValid;
  });
};
var getPaymentErrors = function getPaymentErrors(payment) {
  var enableApayNeverBounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var emailVerifyHandler = arguments.length > 2 ? arguments[2] : undefined;
  var shippingContact = payment === null || payment === void 0 ? void 0 : payment.shippingContact;
  var billingContact = payment === null || payment === void 0 ? void 0 : payment.billingContact;
  var aPayErrors = getApayErrors({
    billingContact: billingContact
  });
  var isEmailValid = isValidEmail$1({
    billingContact: billingContact,
    enableApayNeverBounce: enableApayNeverBounce,
    shippingContact: shippingContact,
    emailVerifyHandler: emailVerifyHandler
  });
  if (!isEmailValid) {
    var shippingEmailAddressError = new window.ApplePayError('shippingContactInvalid', 'emailAddress', 'Please enter a valid email address.');
    aPayErrors.push(shippingEmailAddressError);
  }
  return aPayErrors;
};
var handleFormValues$1 = function handleFormValues(payment, values, setFieldValue) {
  var _values$collector, _values$collector$ent;
  var account = getBluefinAccount();
  var shippingContact = payment === null || payment === void 0 ? void 0 : payment.shippingContact;
  var billingContact = payment === null || payment === void 0 ? void 0 : payment.billingContact;
  var emailAddress = (billingContact === null || billingContact === void 0 ? void 0 : billingContact.emailAddress) || (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.emailAddress);

  // Only create empty object if there is none
  if (!(values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.email)) {
    setFieldValue("collector.entity[0].email", [{}], false);
  }
  setFieldValue("collector.entity[0].email[0].emailAddress", emailAddress, false);
  if (billingContact !== null && billingContact !== void 0 && billingContact.givenName) {
    setFieldValue("collector.entity[0].firstName", billingContact === null || billingContact === void 0 ? void 0 : billingContact.givenName, false);
  }
  if (billingContact !== null && billingContact !== void 0 && billingContact.familyName) {
    setFieldValue("collector.entity[0].lastName", billingContact === null || billingContact === void 0 ? void 0 : billingContact.familyName, false);
  }
  if (shippingContact !== null && shippingContact !== void 0 && shippingContact.phoneNumber) {
    setFieldValue("collector.entity[0].phone[0]", {
      phoneType: 'CELL',
      phoneNumber: shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.phoneNumber
    }, false);
  }
  setFieldValue("collector.entity[0].address", [{
    addressType: 'MAIL',
    street: billingContact !== null && billingContact !== void 0 && billingContact.addressLines[0] ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.addressLines[0] : '',
    streetTwo: billingContact !== null && billingContact !== void 0 && billingContact.addressLines[1] ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.addressLines[1] : '',
    cityTownRegion: billingContact !== null && billingContact !== void 0 && billingContact.locality ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.locality : '',
    stateProvince: billingContact !== null && billingContact !== void 0 && billingContact.administrativeArea ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.administrativeArea : '',
    zipPostalCode: billingContact !== null && billingContact !== void 0 && billingContact.postalCode ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.postalCode : '',
    country: billingContact !== null && billingContact !== void 0 && billingContact.countryCode ? billingContact === null || billingContact === void 0 ? void 0 : billingContact.countryCode : 'US'
  }], false);
  setFieldValue("payment", {
    account: account,
    bluefinAPay: {
      data: JSON.stringify(payment === null || payment === void 0 ? void 0 : payment.token)
    }
  }, false);
  donationGiftLogic(values, setFieldValue);
  setFieldValue("formLogic.isAPayPayment", true, false);
};

var getFormURI = function getFormURI() {
  if (!process.env.FORMS_URI && process.env.GATSBY_VOGON_URI) {
    return "".concat(process.env.GATSBY_VOGON_URI, "/");
  }
  if (!process.env.FORMS_URI && process.env.REACT_APP_VOGON_URI) {
    return "".concat(process.env.REACT_APP_VOGON_URI, "/");
  }
  return "".concat(process.env.FORMS_URI, "/");
};
var getLoggingURI = function getLoggingURI() {
  if (!process.env.LOGGING_URI && process.env.GATSBY_LOGGING_URI) {
    return "".concat(process.env.GATSBY_LOGGING_URI, "/");
  }
  if (!process.env.LOGGING_URI && process.env.REACT_APP_LOGGING_URI) {
    return "".concat(process.env.REACT_APP_LOGGING_URI, "/");
  }
  return "".concat(process.env.LOGGING_URI, "/");
};
var getApiURI = function getApiURI() {
  if (!process.env.API_URI && process.env.GATSBY_API_URI) {
    return "".concat(process.env.GATSBY_API_URI, "/");
  }
  if (!process.env.API_URI && process.env.REACT_APP_API_URI) {
    return "".concat(process.env.REACT_APP_API_URI, "/");
  }
  return "".concat(process.env.API_URI, "/");
};
var getAcousticURI = function getAcousticURI() {
  if (!process.env.ACOUSTIC_URI && process.env.GATSBY_ACOUSTIC_URI) {
    return "".concat(process.env.GATSBY_ACOUSTIC_URI, "/");
  }
  if (!process.env.ACOUSTIC_URI && process.env.REACT_APP_ACOUSTIC_URI) {
    return "".concat(process.env.REACT_APP_ACOUSTIC_URI, "/");
  }
  return "".concat(process.env.ACOUSTIC_URI, "/");
};
var getFileUploadURI = function getFileUploadURI() {
  if (!process.env.FILE_UPLOAD_URI && process.env.GATSBY_FILE_UPLOAD_URI) {
    return "".concat(process.env.GATSBY_FILE_UPLOAD_URI, "/");
  }
  if (!process.env.FILE_UPLOAD_URI && process.env.REACT_APP_FILE_UPLOAD_URI) {
    return "".concat(process.env.REACT_APP_FILE_UPLOAD_URI, "/");
  }
  return "".concat(process.env.FILE_UPLOAD_URI, "/");
};
var getPowerByTextApiURI = function getPowerByTextApiURI() {
  if (!process.env.POWER_BY_TEXT_API_URI && process.env.GATSBY_POWER_BY_TEXT_API_URI) {
    return "".concat(process.env.GATSBY_POWER_BY_TEXT_API_URI, "/");
  }
  if (!process.env.POWER_BY_TEXT_API_URI && process.env.REACT_APP_POWER_BY_TEXT_API_URI) {
    return "".concat(process.env.REACT_APP_POWER_BY_TEXT_API_URI, "/");
  }
  return "".concat(process.env.POWER_BY_TEXT_API_URI, "/");
};
var getReferenceURI = function getReferenceURI() {
  if (!process.env.REFERENCE_URI && process.env.GATSBY_REFERENCE_URI) {
    return "".concat(process.env.GATSBY_REFERENCE_URI, "/");
  }
  if (!process.env.REFERENCE_URI && process.env.REACT_APP_REFERENCE_URI) {
    return "".concat(process.env.REACT_APP_REFERENCE_URI, "/");
  }
  return "".concat(process.env.REFERENCE_URI, "/");
};
var getStellofyURI = function getStellofyURI() {
  if (!process.env.STELLOFY_URI && process.env.GATSBY_STELLOFY_URI) {
    return "".concat(process.env.GATSBY_STELLOFY_URI, "/");
  }
  if (!process.env.STELLOFY_URI && process.env.REACT_APP_STELLOFY_URI) {
    return "".concat(process.env.REACT_APP_STELLOFY_URI, "/");
  }
  return "".concat(process.env.STELLOFY_URI, "/");
};
var getBluefinApiURI = function getBluefinApiURI() {
  if (!process.env.BLUEFIN_API_URI && process.env.GATSBY_BLUEFIN_API_URI) {
    return "".concat(process.env.GATSBY_BLUEFIN_API_URI, "/");
  }
  if (!process.env.BLUEFIN_API_URI && process.env.REACT_APP_BLUEFIN_API_URI) {
    return "".concat(process.env.REACT_APP_BLUEFIN_API_URI, "/");
  }
  return "".concat(process.env.BLUEFIN_API_URI, "/");
};
var getDataEntryURI = function getDataEntryURI() {
  if (!process.env.DATA_ENTRY_URI) {
    return '';
  }
  return "".concat(process.env.DATA_ENTRY_URI, "/");
};
var getBRBInfo = function getBRBInfo() {
  if (!process.env.BRB_URI) {
    return '';
  }
  return "".concat(process.env.BRB_URI, "/");
};
var getEmbedFormURL = function getEmbedFormURL() {
  if (!process.env.EMBED_FORM_URL) {
    return '';
  }
  return "".concat(process.env.EMBED_FORM_URL, "/");
};
var getCraftyClicksAccessToken = function getCraftyClicksAccessToken() {
  if (!process.env.CRAFTY_CLICKS_ACCESS_TOKEN) {
    return '';
  }
  return "".concat(process.env.CRAFTY_CLICKS_ACCESS_TOKEN);
};
var getSiteUrl = function getSiteUrl() {
  var _document, _document$location;
  var documentLocationHref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var site = 'bgeatest.com';
  if (typeof document !== 'undefined' && !((_document = document) !== null && _document !== void 0 && (_document$location = _document.location) !== null && _document$location !== void 0 && _document$location.host.includes('localhost'))) {
    site = documentLocationHref || document.location.href;
  }
  return site;
};
var getEnvironmentVariable = function getEnvironmentVariable() {
  if (!process.env.ENVIRONMENT_VARIABLE && process.env.GATSBY_ENVIRONMENT_VARIABLE) {
    return "".concat(process.env.GATSBY_ENVIRONMENT_VARIABLE);
  }
  if (!process.env.ENVIRONMENT_VARIABLE && process.env.REACT_APP_ENVIRONMENT_VARIABLE) {
    return "".concat(process.env.REACT_APP_ENVIRONMENT_VARIABLE);
  }
  return "".concat(process.env.ENVIRONMENT_VARIABLE);
};
var getGoogleMapVariable = function getGoogleMapVariable() {
  if (!process.env.GOOGLE_MAPS_API_KEY && process.env.GATSBY_GOOGLE_MAPS_API_KEY) {
    return "".concat(process.env.GATSBY_GOOGLE_MAPS_API_KEY);
  }
  if (!process.env.GOOGLE_MAPS_API_KEY && process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
    return "".concat(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
  }
  return "".concat(process.env.GOOGLE_MAPS_API_KEY);
};
var isDevEnvironment = function isDevEnvironment() {
  return getEnvironmentVariable() === 'dev';
};
var isQaEnvironment = function isQaEnvironment() {
  return getEnvironmentVariable() === 'qa';
};
var isStagingEnvironment = function isStagingEnvironment() {
  return getEnvironmentVariable() === 'staging';
};
var isProdEnvironment = function isProdEnvironment() {
  return getEnvironmentVariable() === 'production';
};

var BluefinException = /*#__PURE__*/_createClass(function BluefinException(code, message) {
  _classCallCheck(this, BluefinException);
  var self = {
    code: code,
    message: message
  };
  return {
    name: 'BluefinException',
    code: self.code,
    message: self.message,
    toString: function toString() {
      return "[ name : BluefinException, code : ".concat(self.code, ", message : ").concat(self.message, "]");
    }
  };
});

var _this$1 = undefined;
var lpad = function lpad(num, size) {
  var numInt = parseInt(num, 10);
  var s = "000000000000".concat(numInt);
  return s.substr(s.length - size);
};

// orginal guid function from payconex library
var uuid = function uuid() {
  var s4 = function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return "".concat(s4() + s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4()).concat(s4()).concat(s4());
};
var isJSON = function isJSON(item) {
  var newItem = typeof item !== 'string' ? JSON.stringify(item) : item;
  try {
    newItem = JSON.parse(item);
  } catch (e) {
    return false;
  }
  if (_typeof(newItem) === 'object' && newItem !== null) {
    return true;
  }
  return false;
};
var buildSrcLabel = function buildSrcLabel(src, settings) {
  var newSrc = src;
  if (settings.numberLabel) {
    newSrc += "&number_label=".concat(encodeURIComponent(settings.numberLabel));
  }
  if (settings.expyLabel) {
    newSrc += "&expy_label=".concat(encodeURIComponent(settings.expyLabel));
  }
  if (settings.cvvLabel) {
    newSrc += "&cvv_label=".concat(encodeURIComponent(settings.cvvLabel));
  }
  return newSrc;
};
var buildSrcFont = function buildSrcFont(src, settings) {
  var newSrc = src;
  if (undefined !== settings.labelFontFamily) {
    newSrc += "&label_font_family=".concat(settings.labelFontFamily);
  }
  if (undefined !== settings.labelFontSize) {
    newSrc += "&label_font_size=".concat(settings.labelFontSize);
  }
  if (undefined !== settings.labelFontColor) {
    newSrc += "&label_font_color=".concat(encodeURIComponent(settings.labelFontColor));
  }
  if (undefined !== settings.inputFontFamily) {
    newSrc += "&input_font_family=".concat(settings.inputFontFamily);
  }
  if (undefined !== settings.inputFontSize) {
    newSrc += "&input_font_size=".concat(settings.inputFontSize);
  }
  if (undefined !== settings.inputFontColor) {
    newSrc += "&input_font_color=".concat(encodeURIComponent(settings.inputFontColor));
  }
  return newSrc;
};
var buildSrcStr = function buildSrcStr(masked, settings, src) {
  var newSrc = buildSrcFont(src, settings);
  var newMasked = masked;
  if (undefined !== settings.inputStyle) {
    newSrc += "&input_style=".concat(settings.inputStyle);
  }
  if (undefined !== settings.timeout) {
    newSrc += "&timeout=".concat(settings.timeout);
  }
  newSrc = buildSrcLabel(newSrc, settings);
  if (settings.masked) {
    var _settings$masked, _settings$masked2;
    if (settings !== null && settings !== void 0 && (_settings$masked = settings.masked) !== null && _settings$masked !== void 0 && _settings$masked.formData && settings !== null && settings !== void 0 && (_settings$masked2 = settings.masked) !== null && _settings$masked2 !== void 0 && _settings$masked2.eToken) {
      newMasked = settings === null || settings === void 0 ? void 0 : settings.masked;
    } else {
      throw new BluefinException(103, 'Invalid masked data object.');
    }
  }
  if (undefined !== settings.css && "".concat(settings.css).length !== 0) {
    newSrc += "&css=".concat(encodeURIComponent(btoa(JSON.stringify(settings.css))));
  }
  if (undefined !== settings.text && "".concat(settings.text).length !== 0) {
    newSrc += "&text=".concat(encodeURIComponent(btoa(JSON.stringify(settings.text))));
  }
  if (undefined !== settings.font && "".concat(settings.font).length !== 0) {
    newSrc += "&font=".concat(encodeURIComponent(btoa(JSON.stringify(settings.font))));
  }
  if (undefined !== settings.paymentMethod) {
    newSrc += "&payment_method=".concat(settings.paymentMethod);
  }
  return {
    newMasked: newMasked,
    newSrc: newSrc
  };
};
var applyHelper = function applyHelper(details, setFieldValue, values) {
  var _values$collector, _values$collector$ent, _details$purchase_uni, _details$purchase_uni2, _details$purchase_uni3, _details$purchase_uni4, _details$purchase_uni5, _details$purchase_uni6, _details$purchase_uni7, _details$purchase_uni8, _details$purchase_uni9, _details$purchase_uni10, _details$purchase_uni11, _details$purchase_uni12, _details$purchase_uni13, _details$purchase_uni14, _details$purchase_uni15, _details$purchase_uni16, _details$purchase_uni17, _details$purchase_uni18;
  if (!(values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.address)) {
    setFieldValue("collector.entity[0].address", [{}]);
  }
  setFieldValue("collector.entity[0].address[0].addressType", 'MAIL');
  if (details !== null && details !== void 0 && (_details$purchase_uni = details.purchase_units[0]) !== null && _details$purchase_uni !== void 0 && (_details$purchase_uni2 = _details$purchase_uni.shipping) !== null && _details$purchase_uni2 !== void 0 && (_details$purchase_uni3 = _details$purchase_uni2.address) !== null && _details$purchase_uni3 !== void 0 && _details$purchase_uni3.address_line_1) {
    setFieldValue("collector.entity[0].address[0].street", details.purchase_units[0].shipping.address.address_line_1);
  }
  if (details !== null && details !== void 0 && (_details$purchase_uni4 = details.purchase_units[0]) !== null && _details$purchase_uni4 !== void 0 && (_details$purchase_uni5 = _details$purchase_uni4.shipping) !== null && _details$purchase_uni5 !== void 0 && (_details$purchase_uni6 = _details$purchase_uni5.address) !== null && _details$purchase_uni6 !== void 0 && _details$purchase_uni6.address_line_2) {
    setFieldValue("collector.entity[0].address[0].streetTwo", details.purchase_units[0].shipping.address.address_line_2);
  }
  if (details !== null && details !== void 0 && (_details$purchase_uni7 = details.purchase_units[0]) !== null && _details$purchase_uni7 !== void 0 && (_details$purchase_uni8 = _details$purchase_uni7.shipping) !== null && _details$purchase_uni8 !== void 0 && (_details$purchase_uni9 = _details$purchase_uni8.address) !== null && _details$purchase_uni9 !== void 0 && _details$purchase_uni9.admin_area_2) {
    setFieldValue("collector.entity[0].address[0].cityTownRegion", details.purchase_units[0].shipping.address.admin_area_2);
  }

  // (details.purchase_units[0].shipping.address.address_line_3 && setFieldValue(`collector.entity[0].address.streetThree`, details.purchase_units[0].shipping.address.address_line_3))

  if (details !== null && details !== void 0 && (_details$purchase_uni10 = details.purchase_units[0]) !== null && _details$purchase_uni10 !== void 0 && (_details$purchase_uni11 = _details$purchase_uni10.shipping) !== null && _details$purchase_uni11 !== void 0 && (_details$purchase_uni12 = _details$purchase_uni11.address) !== null && _details$purchase_uni12 !== void 0 && _details$purchase_uni12.admin_area_1) {
    setFieldValue("collector.entity[0].address[0].stateProvince", details.purchase_units[0].shipping.address.admin_area_1);
  }
  if (details !== null && details !== void 0 && (_details$purchase_uni13 = details.purchase_units[0]) !== null && _details$purchase_uni13 !== void 0 && (_details$purchase_uni14 = _details$purchase_uni13.shipping) !== null && _details$purchase_uni14 !== void 0 && (_details$purchase_uni15 = _details$purchase_uni14.address) !== null && _details$purchase_uni15 !== void 0 && _details$purchase_uni15.postal_code) {
    setFieldValue("collector.entity[0].address[0].zipPostalCode", details.purchase_units[0].shipping.address.postal_code);
  }
  if (details !== null && details !== void 0 && (_details$purchase_uni16 = details.purchase_units[0]) !== null && _details$purchase_uni16 !== void 0 && (_details$purchase_uni17 = _details$purchase_uni16.shipping) !== null && _details$purchase_uni17 !== void 0 && (_details$purchase_uni18 = _details$purchase_uni17.address) !== null && _details$purchase_uni18 !== void 0 && _details$purchase_uni18.country_code) {
    setFieldValue("collector.entity[0].address[0].country", details.purchase_units[0].shipping.address.country_code);
  }
};
var responseHandlerHelper = function responseHandlerHelper(callbacks, handleInvalidInput, messageId) {
  return {
    success: function success(fn) {
      if (undefined !== messageId) {
        if (undefined === callbacks[messageId]) {
          callbacks[messageId] = {};
        }
        callbacks[messageId].successBack = fn;
      }
      return _this$1;
    },
    failure: function failure(fn) {
      if (undefined !== messageId) {
        if (undefined === callbacks[messageId]) {
          callbacks[messageId] = {};
        }
        callbacks[messageId].errorBack = fn;
      }
      return _this$1;
    },
    invalidInput: function invalidInput(fn) {
      return handleInvalidInput(fn, messageId);
    },
    loaded: function loaded(fn) {
      if (undefined !== messageId) {
        if (undefined === callbacks[messageId]) {
          callbacks[messageId] = {};
        }
        callbacks[messageId].loadBack = fn;
      }
      return _this$1;
    },
    id: messageId
  };
};
var listenerEncryptHelper = function listenerEncryptHelper(data, errorBack, invalidInputBack, successBack, setSubmitting) {
  if (data.success && undefined !== successBack) {
    successBack({
      id: data.message_id,
      eToken: data.eToken,
      masked: data.masked_data
    });
    setSubmitting(true);
  } else if (!data.success) {
    if (undefined !== data.invalidInputs && undefined !== invalidInputBack) {
      invalidInputBack({
        id: data.message_id,
        invalidInputs: data.invalidInputs
      });
    } else if (undefined !== errorBack) {
      errorBack({
        id: data.message_id,
        message: data.message
      });
    }
  }
};
var listenerHelper = function listenerHelper(data, errorBack, invalidInputBack, successBack, setSubmitting) {
  switch (data.command) {
    case 'encrypt_resp':
      listenerEncryptHelper(data, errorBack, invalidInputBack, successBack, setSubmitting);
      break;
    case 'payment_iframe_loaded':
    case undefined:
    default:
      if (!data.success && undefined !== errorBack) {
        errorBack({
          id: data.message_id,
          message: data.message
        });
      }
      if (data.success && undefined !== successBack) {
        successBack({
          id: data.message_id
        });
      }
  }
};
var isValidEmail = function isValidEmail(values) {
  var _values$collector2, _values$collector2$en;
  if (values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[0]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.email) {
    var _values$collector3, _values$collector3$en, _values$collector3$en2, _values$collector3$en3;
    return (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.email[0]) === null || _values$collector3$en2 === void 0 ? void 0 : (_values$collector3$en3 = _values$collector3$en2.emailAddress) === null || _values$collector3$en3 === void 0 ? void 0 : _values$collector3$en3.length) > 0;
  }
  return true;
};
var validateFields = function validateFields(_ref) {
  var _values$collector4, _values$collector4$en, _values$collector4$en2, _values$collector5, _values$collector5$en, _values$collector5$en2, _values$collector6, _values$collector6$en, _values$collector6$en2, _values$collector6$en3, _values$collector7, _values$collector7$en, _values$collector7$en2, _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector8$en3, _values$collector9, _values$collector9$en, _values$collector9$en2, _values$collector9$en3;
  var values = _ref.values;
  return (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$en = _values$collector4.entity[0]) === null || _values$collector4$en === void 0 ? void 0 : (_values$collector4$en2 = _values$collector4$en.firstName) === null || _values$collector4$en2 === void 0 ? void 0 : _values$collector4$en2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : (_values$collector5$en2 = _values$collector5$en.lastName) === null || _values$collector5$en2 === void 0 ? void 0 : _values$collector5$en2.length) > 0 && isValidEmail(values) && (values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[0]) === null || _values$collector6$en === void 0 ? void 0 : (_values$collector6$en2 = _values$collector6$en.phone[0]) === null || _values$collector6$en2 === void 0 ? void 0 : (_values$collector6$en3 = _values$collector6$en2.phoneNumber) === null || _values$collector6$en3 === void 0 ? void 0 : _values$collector6$en3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? void 0 : (_values$collector7$en2 = _values$collector7$en.address[0]) === null || _values$collector7$en2 === void 0 ? void 0 : _values$collector7$en2.cityTownRegion.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.address[0]) === null || _values$collector8$en2 === void 0 ? void 0 : (_values$collector8$en3 = _values$collector8$en2.zipPostalCode) === null || _values$collector8$en3 === void 0 ? void 0 : _values$collector8$en3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : (_values$collector9$en = _values$collector9.entity[0]) === null || _values$collector9$en === void 0 ? void 0 : (_values$collector9$en2 = _values$collector9$en.address[0]) === null || _values$collector9$en2 === void 0 ? void 0 : (_values$collector9$en3 = _values$collector9$en2.stateProvince) === null || _values$collector9$en3 === void 0 ? void 0 : _values$collector9$en3.length) > 0;
};
var getBluefinAccount = function getBluefinAccount() {
  if (!process.env.BLUEFIN_ACCOUNT && process.env.GATSBY_BLUEFIN_ACCOUNT) {
    return "".concat(process.env.GATSBY_BLUEFIN_ACCOUNT);
  }
  if (!process.env.BLUEFIN_ACCOUNT && process.env.REACT_APP_BLUEFIN_ACCOUNT) {
    return "".concat(process.env.REACT_APP_BLUEFIN_ACCOUNT);
  }
  return "".concat(process.env.BLUEFIN_ACCOUNT);
};
var getAppleMerchantId = function getAppleMerchantId() {
  if (!process.env.APPLE_MERCHANT_ID && process.env.GATSBY_APPLE_MERCHANT_ID) {
    return "".concat(process.env.GATSBY_BLUEFIN_ACCOUNT);
  }
  if (!process.env.APPLE_MERCHANT_ID && process.env.REACT_APP_APPLE_MERCHANT_ID) {
    return "".concat(process.env.REACT_APP_APPLE_MERCHANT_ID);
  }
  return "".concat(process.env.APPLE_MERCHANT_ID);
};
var getBluefinServer = function getBluefinServer() {
  if (!process.env.BLUEFIN_DEVSERVER && process.env.GATSBY_BLUEFIN_DEVSERVER) {
    return "".concat(process.env.GATSBY_BLUEFIN_DEVSERVER);
  }
  if (!process.env.BLUEFIN_DEVSERVER && process.env.REACT_APP_BLUEFIN_DEVSERVER) {
    return "".concat(process.env.REACT_APP_BLUEFIN_DEVSERVER);
  }
  return "".concat(process.env.BLUEFIN_DEVSERVER);
};

var _excluded$17 = ["entity", "langChurchQuestion", "orgType", "relationshipPath", "relationshipType", "setOrg", "showLangQuestion", "setFieldValue"];
var codeKey = 'DTR';
var dtrValue = 'CH025';
var churchCrusadeCodeEventValue = '1307';
var getChurchCodes = function getChurchCodes(city, entity, values) {
  var _values$formLogic, _values$collector$ent, _values$collector$ent2;
  var cityEvent = JSON.parse(city);
  var templateName = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.templateName;
  var resetChurchArr = ((_values$collector$ent = values.collector.entity[entity]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return !(item !== null && item !== void 0 && item.key.startsWith('CRUSADE:')) && (item === null || item === void 0 ? void 0 : item.key) !== codeKey;
  })) || [];
  var churchCodes = templateName === Templates.CHURCH_INTEREST ? [].concat(_toConsumableArray(resetChurchArr), [{
    key: codeKey,
    value: "".concat(cityEvent.SECodeEventId).concat(dtrValue)
  }, {
    key: "CRUSADE:".concat(cityEvent.crusadeCodeEventId),
    value: churchCrusadeCodeEventValue
  }]) : _toConsumableArray(resetChurchArr);
  return [].concat(_toConsumableArray(churchCodes), [{
    key: "CRUSADE:".concat(cityEvent.crusadeCodeEventId),
    value: 'EVENT'
  }]);
};
var getChurchFieldNames = function getChurchFieldNames(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    props = _ref.props;
  var churchFieldName = (props === null || props === void 0 ? void 0 : props.churchFieldName) || '';
  var phoneFieldName = props !== null && props !== void 0 && props.phoneFieldName ? props === null || props === void 0 ? void 0 : props.phoneFieldName : "collector.entity[".concat(entity, "].phone[0].phoneNumber");
  var orgFieldName = !(props !== null && props !== void 0 && props.churchFieldName) ? "collector.entity[".concat(entity, "].organizationName") : "".concat(churchFieldName, ".organizationName");
  var orgRoleName = !(props !== null && props !== void 0 && props.churchFieldName) ? "collector.entity[".concat(entity, "].orgs.role") : "".concat(churchFieldName, ".orgs.role");
  var phoneName = !(props !== null && props !== void 0 && props.churchFieldName) ? phoneFieldName : "".concat(churchFieldName, ".pastor_phone");
  return {
    orgFieldName: orgFieldName,
    orgRoleName: orgRoleName,
    phoneName: phoneName
  };
};
var setDefaultValues = function setDefaultValues(_ref2) {
  var entity = _ref2.entity,
    langChurchQuestion = _ref2.langChurchQuestion,
    orgType = _ref2.orgType,
    relationshipPath = _ref2.relationshipPath,
    relationshipType = _ref2.relationshipType,
    setOrg = _ref2.setOrg,
    showLangQuestion = _ref2.showLangQuestion,
    setFieldValue = _ref2.setFieldValue,
    props = _objectWithoutProperties(_ref2, _excluded$17);
  if (showLangQuestion) {
    setFieldValue(langChurchQuestion, '');
  }
  setFieldValue("collector.entity[".concat(entity, "].entityType"), 'O');
  setFieldValue("collector.entity[".concat(entity, "].isPrimary"), false);
  setFieldValue("collector.entity[".concat(entity, "].entityRelationship"), [{
    path: relationshipPath || undefined,
    relationshipType: relationshipType || undefined
  }]);
  if (setOrg) {
    setFieldValue("collector.entity[".concat(entity, "].orgs.orgType"), orgType);
  }
  if (props !== null && props !== void 0 && props.showAttendanceField) {
    setFieldValue("collector.entity[".concat(entity, "].orgs.avgWeekendAttendance"), '');
    setFieldValue("formLogic.churchAttendance.orgs[".concat(entity, "].avgWeekendAttendance"), '', false);
  }
  if (props !== null && props !== void 0 && props.showChurchCapacity) {
    setFieldValue("collector.entity[".concat(entity, "].orgs.sanctuarySize"), '');
    setFieldValue("formLogic.sanctuarySize.orgs[".concat(entity, "].sanctuarySize"), '', false);
  }
  setFieldValue("collector.entity[".concat(entity, "].address[0].street"), '');
  setFieldValue("collector.entity[".concat(entity, "].address[0].streetTwo"), '');
  setFieldValue("collector.entity[".concat(entity, "].address[0].streetThree"), '');
  setFieldValue("collector.entity[".concat(entity, "].address[0].cityTownRegion"), '');
  setFieldValue("collector.entity[".concat(entity, "].address[0].stateProvince"), '');
  setFieldValue("collector.entity[".concat(entity, "].address[0].zipPostalCode"), '');
  setFieldValue("collector.entity[".concat(entity, "].organizationName"), '');
  setFieldValue("collector.entity[".concat(entity, "].phone[0].phoneNumber"), '');
};

/* TODO: Get friendly message from Comms and should come from translation package */
var ErrorMessages = {
  FloodControlled: 'Too Many Entries',
  LogicUnprocessable: 'Sorry, the business logic check failed due to a communication error',
  PaymentUnprocessable: 'Sorry, there was an error with your payment information',
  GenericUnprocessable: 'Sorry, there was an error or some required information is missing.',
  UserAlreadySubmitted: 'User has already submitted an entry',
  PaypalFailureMessage: 'A processing error occurred after charging your PayPal account. The charge has been fully refunded.'
};

var getErrorMessage = function getErrorMessage(_ref) {
  var status = _ref.status;
  return (status === null || status === void 0 ? void 0 : status.hasErrorInfo) && (status === null || status === void 0 ? void 0 : status.message) || ErrorMessages[status] || ErrorMessages.GenericUnprocessable;
};

var freeGiftHeper = function freeGiftHeper(giftOffer) {
  var _giftOffer$labelOptio, _giftOffer$labelOptio2;
  var labelText = giftOffer.description;
  if (giftOffer && giftOffer.title && !(giftOffer !== null && giftOffer !== void 0 && giftOffer.label)) {
    labelText = giftOffer.author && giftOffer.author !== '' ? "In appreciation for your support, this month's special gift, <i>".concat(giftOffer.title, "</i> by ").concat(giftOffer.author, ", is available with our compliments.*") : "In appreciation for your support, this month's special gift, <i>".concat(giftOffer.title, "</i>, is available with our compliments.*");
  } else if (giftOffer !== null && giftOffer !== void 0 && giftOffer.label) {
    labelText = giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.label;
  }
  var options = [{
    label: (giftOffer === null || giftOffer === void 0 ? void 0 : (_giftOffer$labelOptio = giftOffer.labelOptions) === null || _giftOffer$labelOptio === void 0 ? void 0 : _giftOffer$labelOptio.length) > 0 && (giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.labelOptions[0]) || 'Yes, I would like the special gift',
    name: 'radioGroup',
    id: 'option1',
    value: 'yes'
  }, {
    label: (giftOffer === null || giftOffer === void 0 ? void 0 : (_giftOffer$labelOptio2 = giftOffer.labelOptions) === null || _giftOffer$labelOptio2 === void 0 ? void 0 : _giftOffer$labelOptio2.length) > 1 && (giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.labelOptions[1]) || 'No thank you, I would not like the special gift in order to maximize my donation',
    name: 'radioGroup',
    id: 'option2',
    value: 'no'
  }];
  return {
    labelText: labelText,
    options: options
  };
};
var donationGiftLogic = function donationGiftLogic(values, setFieldValue) {
  var _values$formLogic, _values$formLogic$gif, _values$formLogic2, _values$formLogic3, _values$formLogic5, _values$formLogic6;
  if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && (_values$formLogic$gif = _values$formLogic.giftOffer) !== null && _values$formLogic$gif !== void 0 && _values$formLogic$gif.productCode && (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.freeGiftOffer) !== 'no' && !(values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.disablePaypalGiftOffer)) {
    var _values$formLogic4, _giftOffer$warehouse;
    var giftOffer = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.giftOffer;
    var products = giftOffer !== null && giftOffer !== void 0 && giftOffer.productCode ? [_objectSpread2({
      amount: 0,
      productId: giftOffer.productCode,
      quantity: 1
    }, (giftOffer === null || giftOffer === void 0 ? void 0 : (_giftOffer$warehouse = giftOffer.warehouse) === null || _giftOffer$warehouse === void 0 ? void 0 : _giftOffer$warehouse.length) > 0 && {
      warehouse: giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.warehouse
    })] : [];
    setFieldValue("collector.cart.products", products, false);
  } else if ((values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.freeGiftOffer) === 'yes' && values !== null && values !== void 0 && (_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && _values$formLogic6.disablePaypalGiftOffer) {
    var _values$collector, _values$collector$car;
    values === null || values === void 0 ? true : (_values$collector = values.collector) === null || _values$collector === void 0 ? true : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? true : delete _values$collector$car.products;
  }
};

var nbResultHandler = function nbResultHandler(setEmailValidationStatus, setIsNBprocessing, setValidationSuccess, successTimeoutId) {
  return function (event) {
    var timeoutIdSuccess = successTimeoutId;
    setIsNBprocessing(false);
    var isValid = event.detail.result.response.result !== 'invalid';
    if (isValid) {
      setEmailValidationStatus(true);
      setValidationSuccess(true);
      if (timeoutIdSuccess) clearTimeout(timeoutIdSuccess);
      timeoutIdSuccess = setTimeout(function () {
        return setValidationSuccess(false);
      }, 3000);
    } else {
      setEmailValidationStatus(false);
    }
  };
};
var nbLoadingHandler = function nbLoadingHandler(setEmailValidationStatus, setIsNBprocessing) {
  return function () {
    setIsNBprocessing(true);
    setEmailValidationStatus(null);
  };
};
var nbClearHandler = function nbClearHandler(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId) {
  return function (e) {
    if (e.detail.result && e.detail.result.isError()) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      removeEvents(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId);
      setEmailValidationStatus(true);
      setIsNBprocessing(false);
      setIsNBValid(false);
      setFieldTouched(name, true);
    }
  };
};
var addEvents = function addEvents(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId) {
  bodyElement.addEventListener('nb:result', nbResultHandler(setEmailValidationStatus, setIsNBprocessing, setValidationSuccess, successTimeoutId));
  bodyElement.addEventListener('nb:loading', nbLoadingHandler(setEmailValidationStatus, setIsNBprocessing));
  bodyElement.addEventListener('nb:clear', nbClearHandler(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId));
};
var removeEvents = function removeEvents(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId) {
  bodyElement.removeEventListener('nb:result', nbResultHandler(setEmailValidationStatus, setIsNBprocessing, setValidationSuccess, successTimeoutId));
  bodyElement.removeEventListener('nb:loading', nbLoadingHandler(setEmailValidationStatus, setIsNBprocessing));
  bodyElement.removeEventListener('nb:clear', nbClearHandler(bodyElement, name, setEmailValidationStatus, setIsNBprocessing, setIsNBValid, setFieldTouched, setValidationSuccess, successTimeoutId));
};

// Never Bounce JS widget settings
var NBSettings = function NBSettings(translations, nbLatency) {
  return {
    acceptedMessage: 'Valid email',
    acceptedStatusCodes: [0, 3, 4],
    ajaxMode: false,
    apiKey: 'public_5004dfb266ffaed36bf2a504320fbeb0',
    apiOnly: false,
    autoFieldHookup: true,
    blockFreemail: false,
    blockRoleAccount: false,
    blockThrottledAttempts: false,
    debugMode: false,
    displayPoweredBy: false,
    feedback: false,
    feedbackClass: 'nb-feedback',
    hiddenField: true,
    inputLatency: nbLatency,
    loadingMessage: 'Loading...',
    rejectedMessage: (translations === null || translations === void 0 ? void 0 : translations.invalidEmail) || '',
    softRejectMessage: (translations === null || translations === void 0 ? void 0 : translations.enterValidEmail) || '',
    throttleRejectMessage: 'Too many attempts, try again later',
    timeout: 25
  };
};
var DEFAULT_ERROR = 'Email validation needed';
var inputEmailClass = function inputEmailClass(errorClass, errorMessage, validationSuccess) {
  var className = 'input';
  if (validationSuccess && !errorMessage) {
    className += ' is-success';
  } else if (errorClass) {
    className += errorClass;
  }
  return className;
};

/* eslint no-restricted-syntax: 0 */

var newAddressHelper = function newAddressHelper(values) {
  if (values.newAddress) {
    // eslint-disable-next-line guard-for-in
    for (var key in values.newAddress.newQuestions) {
      delete values.newAddress.newQuestions[key];
    }
    delete values.newAddress;
  }
};

// eslint-disable-next-line sonarjs/cognitive-complexity
var questionsHelper = function questionsHelper(values) {
  if (values.newQuestions) {
    for (var key in values.newQuestions) {
      if (values.newQuestions[key] === '' || values.newQuestions[key] === ',,,,,') {
        delete values.newQuestions[key];
      } else {
        if (!values.collector.questions) {
          values.collector.questions = [];
        }
        var hasQuestionId = key.search('questionId') !== -1;
        var question = hasQuestionId ? JSON.parse(key) : key;
        var questionInfo = _objectSpread2(_objectSpread2({}, hasQuestionId && {
          questionId: question.questionId
        }), {}, {
          questionText: hasQuestionId ? question.questionText : key,
          answerText: values.newQuestions[key]
        });
        values.collector.questions.push(questionInfo);
        delete values.newQuestions[key];
      }
    }
    delete values.newQuestions;
  }
  newAddressHelper(values);
  return values;
};

var getPaypalLogPayload = function getPaypalLogPayload(values) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$collector2, _values$collector3, _values$collector4, _values$collector5, _values$collector5$en, _values$collector6, _values$collector6$en, _values$collector7, _values$collector7$en, _values$collector7$en2, _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector9, _values$collector10, _values$collector10$e, _values$collector11, _values$collector11$e, _values$collector12, _values$collector13, _values$collector13$e, _values$collector14, _values$collector14$e;
  return _objectSpread2(_objectSpread2(_objectSpread2({
    projects: values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.projects,
    sourceCode: (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : _values$collector2.SESourceCode) || ''
  }, (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : _values$collector3.entity) && (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : _values$collector4.entity[0]) && (values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : _values$collector5$en.email) && (values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[0]) === null || _values$collector6$en === void 0 ? void 0 : _values$collector6$en.email[0]) && (values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? void 0 : (_values$collector7$en2 = _values$collector7$en.email[0]) === null || _values$collector7$en2 === void 0 ? void 0 : _values$collector7$en2.emailAddress) && {
    emailAddress: values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.email[0]) === null || _values$collector8$en2 === void 0 ? void 0 : _values$collector8$en2.emailAddress
  }), (values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : _values$collector9.entity) && (values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$e = _values$collector10.entity[0]) === null || _values$collector10$e === void 0 ? void 0 : _values$collector10$e.firstName) && {
    firstName: values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : _values$collector11$e.firstName
  }), (values === null || values === void 0 ? void 0 : (_values$collector12 = values.collector) === null || _values$collector12 === void 0 ? void 0 : _values$collector12.entity) && (values === null || values === void 0 ? void 0 : (_values$collector13 = values.collector) === null || _values$collector13 === void 0 ? void 0 : (_values$collector13$e = _values$collector13.entity[0]) === null || _values$collector13$e === void 0 ? void 0 : _values$collector13$e.lastName) && {
    lastName: values === null || values === void 0 ? void 0 : (_values$collector14 = values.collector) === null || _values$collector14 === void 0 ? void 0 : (_values$collector14$e = _values$collector14.entity[0]) === null || _values$collector14$e === void 0 ? void 0 : _values$collector14$e.lastName
  });
};
var setShippingAddress = function setShippingAddress(_ref) {
  var _details$purchase_uni, _details$purchase_uni2, _details$purchase_uni3, _details$purchase_uni4, _details$purchase_uni5, _details$purchase_uni6, _details$purchase_uni7, _details$purchase_uni8, _details$purchase_uni9, _details$purchase_uni10, _details$purchase_uni11, _details$purchase_uni12, _details$purchase_uni13, _details$purchase_uni14, _details$purchase_uni15, _details$purchase_uni16, _details$purchase_uni17, _details$purchase_uni18, _details$purchase_uni19, _details$purchase_uni20, _details$purchase_uni21, _details$purchase_uni22, _details$purchase_uni23, _details$purchase_uni24, _details$purchase_uni25, _details$purchase_uni26, _details$purchase_uni27, _details$purchase_uni28, _details$purchase_uni29, _details$purchase_uni30;
  var details = _ref.details,
    setFieldValue = _ref.setFieldValue;
  setFieldValue("collector.entity[0].address", [{
    addressType: 'MAIL',
    street: details !== null && details !== void 0 && (_details$purchase_uni = details.purchase_units[0]) !== null && _details$purchase_uni !== void 0 && (_details$purchase_uni2 = _details$purchase_uni.shipping) !== null && _details$purchase_uni2 !== void 0 && (_details$purchase_uni3 = _details$purchase_uni2.address) !== null && _details$purchase_uni3 !== void 0 && _details$purchase_uni3.address_line_1 ? details === null || details === void 0 ? void 0 : (_details$purchase_uni4 = details.purchase_units[0]) === null || _details$purchase_uni4 === void 0 ? void 0 : (_details$purchase_uni5 = _details$purchase_uni4.shipping) === null || _details$purchase_uni5 === void 0 ? void 0 : (_details$purchase_uni6 = _details$purchase_uni5.address) === null || _details$purchase_uni6 === void 0 ? void 0 : _details$purchase_uni6.address_line_1 : '',
    streetTwo: details.purchase_units[0].shipping.address.address_line_2 ? details.purchase_units[0].shipping.address.address_line_2 : '',
    cityTownRegion: details !== null && details !== void 0 && (_details$purchase_uni7 = details.purchase_units[0]) !== null && _details$purchase_uni7 !== void 0 && (_details$purchase_uni8 = _details$purchase_uni7.shipping) !== null && _details$purchase_uni8 !== void 0 && (_details$purchase_uni9 = _details$purchase_uni8.address) !== null && _details$purchase_uni9 !== void 0 && _details$purchase_uni9.admin_area_2 ? details === null || details === void 0 ? void 0 : (_details$purchase_uni10 = details.purchase_units[0]) === null || _details$purchase_uni10 === void 0 ? void 0 : (_details$purchase_uni11 = _details$purchase_uni10.shipping) === null || _details$purchase_uni11 === void 0 ? void 0 : (_details$purchase_uni12 = _details$purchase_uni11.address) === null || _details$purchase_uni12 === void 0 ? void 0 : _details$purchase_uni12.admin_area_2 : '',
    stateProvince: details !== null && details !== void 0 && (_details$purchase_uni13 = details.purchase_units[0]) !== null && _details$purchase_uni13 !== void 0 && (_details$purchase_uni14 = _details$purchase_uni13.shipping) !== null && _details$purchase_uni14 !== void 0 && (_details$purchase_uni15 = _details$purchase_uni14.address) !== null && _details$purchase_uni15 !== void 0 && _details$purchase_uni15.admin_area_1 ? details === null || details === void 0 ? void 0 : (_details$purchase_uni16 = details.purchase_units[0]) === null || _details$purchase_uni16 === void 0 ? void 0 : (_details$purchase_uni17 = _details$purchase_uni16.shipping) === null || _details$purchase_uni17 === void 0 ? void 0 : (_details$purchase_uni18 = _details$purchase_uni17.address) === null || _details$purchase_uni18 === void 0 ? void 0 : _details$purchase_uni18.admin_area_1 : '',
    zipPostalCode: details !== null && details !== void 0 && (_details$purchase_uni19 = details.purchase_units[0]) !== null && _details$purchase_uni19 !== void 0 && (_details$purchase_uni20 = _details$purchase_uni19.shipping) !== null && _details$purchase_uni20 !== void 0 && (_details$purchase_uni21 = _details$purchase_uni20.address) !== null && _details$purchase_uni21 !== void 0 && _details$purchase_uni21.postal_code ? details === null || details === void 0 ? void 0 : (_details$purchase_uni22 = details.purchase_units[0]) === null || _details$purchase_uni22 === void 0 ? void 0 : (_details$purchase_uni23 = _details$purchase_uni22.shipping) === null || _details$purchase_uni23 === void 0 ? void 0 : (_details$purchase_uni24 = _details$purchase_uni23.address) === null || _details$purchase_uni24 === void 0 ? void 0 : _details$purchase_uni24.postal_code : '',
    country: details !== null && details !== void 0 && (_details$purchase_uni25 = details.purchase_units[0]) !== null && _details$purchase_uni25 !== void 0 && (_details$purchase_uni26 = _details$purchase_uni25.shipping) !== null && _details$purchase_uni26 !== void 0 && (_details$purchase_uni27 = _details$purchase_uni26.address) !== null && _details$purchase_uni27 !== void 0 && _details$purchase_uni27.country_code ? details === null || details === void 0 ? void 0 : (_details$purchase_uni28 = details.purchase_units[0]) === null || _details$purchase_uni28 === void 0 ? void 0 : (_details$purchase_uni29 = _details$purchase_uni28.shipping) === null || _details$purchase_uni29 === void 0 ? void 0 : (_details$purchase_uni30 = _details$purchase_uni29.address) === null || _details$purchase_uni30 === void 0 ? void 0 : _details$purchase_uni30.country_code : 'US'
  }], true);
};
var setPayerAddress = function setPayerAddress(_ref2) {
  var _details$payer, _details$payer$addres, _details$payer2, _details$payer2$addre, _details$payer3, _details$payer3$addre, _details$payer4, _details$payer4$addre, _details$payer5, _details$payer5$addre, _details$payer6, _details$payer6$addre, _details$payer7, _details$payer7$addre, _details$payer8, _details$payer8$addre, _details$payer9, _details$payer9$addre, _details$payer10, _details$payer10$addr, _details$payer11, _details$payer11$addr, _details$payer12, _details$payer12$addr;
  var details = _ref2.details,
    setFieldValue = _ref2.setFieldValue;
  setFieldValue("collector.entity[0].address", [{
    addressType: 'MAIL',
    street: details !== null && details !== void 0 && (_details$payer = details.payer) !== null && _details$payer !== void 0 && (_details$payer$addres = _details$payer.address) !== null && _details$payer$addres !== void 0 && _details$payer$addres.address_line_1 ? details === null || details === void 0 ? void 0 : (_details$payer2 = details.payer) === null || _details$payer2 === void 0 ? void 0 : (_details$payer2$addre = _details$payer2.address) === null || _details$payer2$addre === void 0 ? void 0 : _details$payer2$addre.address_line_1 : '',
    streetTwo: details !== null && details !== void 0 && (_details$payer3 = details.payer) !== null && _details$payer3 !== void 0 && (_details$payer3$addre = _details$payer3.address) !== null && _details$payer3$addre !== void 0 && _details$payer3$addre.address_line_2 ? details === null || details === void 0 ? void 0 : (_details$payer4 = details.payer) === null || _details$payer4 === void 0 ? void 0 : (_details$payer4$addre = _details$payer4.address) === null || _details$payer4$addre === void 0 ? void 0 : _details$payer4$addre.address_line_2 : '',
    cityTownRegion: details !== null && details !== void 0 && (_details$payer5 = details.payer) !== null && _details$payer5 !== void 0 && (_details$payer5$addre = _details$payer5.address) !== null && _details$payer5$addre !== void 0 && _details$payer5$addre.admin_area_2 ? details === null || details === void 0 ? void 0 : (_details$payer6 = details.payer) === null || _details$payer6 === void 0 ? void 0 : (_details$payer6$addre = _details$payer6.address) === null || _details$payer6$addre === void 0 ? void 0 : _details$payer6$addre.admin_area_2 : '',
    stateProvince: details !== null && details !== void 0 && (_details$payer7 = details.payer) !== null && _details$payer7 !== void 0 && (_details$payer7$addre = _details$payer7.address) !== null && _details$payer7$addre !== void 0 && _details$payer7$addre.admin_area_1 ? details === null || details === void 0 ? void 0 : (_details$payer8 = details.payer) === null || _details$payer8 === void 0 ? void 0 : (_details$payer8$addre = _details$payer8.address) === null || _details$payer8$addre === void 0 ? void 0 : _details$payer8$addre.admin_area_1 : '',
    zipPostalCode: details !== null && details !== void 0 && (_details$payer9 = details.payer) !== null && _details$payer9 !== void 0 && (_details$payer9$addre = _details$payer9.address) !== null && _details$payer9$addre !== void 0 && _details$payer9$addre.postal_code ? details === null || details === void 0 ? void 0 : (_details$payer10 = details.payer) === null || _details$payer10 === void 0 ? void 0 : (_details$payer10$addr = _details$payer10.address) === null || _details$payer10$addr === void 0 ? void 0 : _details$payer10$addr.postal_code : '',
    country: details !== null && details !== void 0 && (_details$payer11 = details.payer) !== null && _details$payer11 !== void 0 && (_details$payer11$addr = _details$payer11.address) !== null && _details$payer11$addr !== void 0 && _details$payer11$addr.country_code ? details === null || details === void 0 ? void 0 : (_details$payer12 = details.payer) === null || _details$payer12 === void 0 ? void 0 : (_details$payer12$addr = _details$payer12.address) === null || _details$payer12$addr === void 0 ? void 0 : _details$payer12$addr.country_code : 'US'
  }], true);
};
var handleFormValues = function handleFormValues(details, values, setFieldValue) {
  var _values$collector15, _values$collector15$e, _details$payer13, _values$collector16, _values$collector16$e, _details$purchase_uni31, _details$payer14;
  // Only create empty object if there is none
  if (!(values !== null && values !== void 0 && (_values$collector15 = values.collector) !== null && _values$collector15 !== void 0 && (_values$collector15$e = _values$collector15.entity[0]) !== null && _values$collector15$e !== void 0 && _values$collector15$e.email)) {
    setFieldValue("collector.entity[0].email", [{}]);
  }
  if (details !== null && details !== void 0 && (_details$payer13 = details.payer) !== null && _details$payer13 !== void 0 && _details$payer13.email_address) {
    setFieldValue("collector.entity[0].email[0].emailAddress", details.payer.email_address);
  }
  if (!(values !== null && values !== void 0 && (_values$collector16 = values.collector) !== null && _values$collector16 !== void 0 && (_values$collector16$e = _values$collector16.entity[0]) !== null && _values$collector16$e !== void 0 && _values$collector16$e.address)) {
    setFieldValue("collector.entity[0].address", [{}]);
  }
  if (details !== null && details !== void 0 && (_details$purchase_uni31 = details.purchase_units[0]) !== null && _details$purchase_uni31 !== void 0 && _details$purchase_uni31.shipping) {
    setShippingAddress({
      details: details,
      setFieldValue: setFieldValue
    });
  } else if (details !== null && details !== void 0 && (_details$payer14 = details.payer) !== null && _details$payer14 !== void 0 && _details$payer14.address) {
    setPayerAddress({
      details: details,
      setFieldValue: setFieldValue
    });
  }
  donationGiftLogic(values, setFieldValue);
};
var handleApprovedCaptureHelper = function handleApprovedCaptureHelper(data, actions, setFieldValue, envVariables, logging, onApproved, paypalLogPayload, setHasPaypalData, values) {
  function apply(details) {
    var _details$purchase_uni32, _details$purchase_uni33, _details$purchase_uni34, _details$payer15, _details$payer15$name, _details$payer16, _details$payer16$name;
    setFieldValue("payment", {});
    setFieldValue("payment.account", process.env.PAYPAL_CLIENT_ID || process.env.GATSBY_PAYPAL_CLIENT_ID || envVariables.payPalClientID);
    setFieldValue("payment.paypal", {});
    if (details !== null && details !== void 0 && (_details$purchase_uni32 = details.purchase_units[0]) !== null && _details$purchase_uni32 !== void 0 && (_details$purchase_uni33 = _details$purchase_uni32.payments) !== null && _details$purchase_uni33 !== void 0 && (_details$purchase_uni34 = _details$purchase_uni33.captures[0]) !== null && _details$purchase_uni34 !== void 0 && _details$purchase_uni34.id) {
      setFieldValue("payment.paypal.transactionId", details.purchase_units[0].payments.captures[0].id);
    }
    if (details !== null && details !== void 0 && (_details$payer15 = details.payer) !== null && _details$payer15 !== void 0 && (_details$payer15$name = _details$payer15.name) !== null && _details$payer15$name !== void 0 && _details$payer15$name.given_name) {
      setFieldValue("collector.entity[0].firstName", details.payer.name.given_name);
    }
    if (details !== null && details !== void 0 && (_details$payer16 = details.payer) !== null && _details$payer16 !== void 0 && (_details$payer16$name = _details$payer16.name) !== null && _details$payer16$name !== void 0 && _details$payer16$name.surname) {
      setFieldValue("collector.entity[0].lastName", details.payer.name.surname);
    }
    handleFormValues(details, values, setFieldValue);
    applyHelper(details, setFieldValue, values);
  }
  var getPaypalOrderCapture = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var order;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            logging({
              functionName: 'usePaypalPayment.getPaypalOrderCapture',
              error: {},
              description: 'PayPal before Capture',
              type: 'info'
            });
            _context.next = 4;
            return actions.order.capture();
          case 4:
            order = _context.sent;
            logging({
              functionName: 'usePaypalPayment.getPaypalOrderCapture',
              error: {},
              description: 'PayPal after Capture',
              type: 'info'
            });
            onApproved(data.orderID);
            apply(order);
            setHasPaypalData(true);
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            logging({
              functionName: 'usePaypalPayment.getPaypalOrderCapture',
              error: _context.t0,
              description: 'PayPal Error Capture',
              logPayload: paypalLogPayload
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function getPaypalOrderCapture() {
      return _ref3.apply(this, arguments);
    };
  }();
  return getPaypalOrderCapture();
};
var isValidHonorMemorial = function isValidHonorMemorial(honorMemoryInfo) {
  var _honorMemoryInfo$hono, _honorMemoryInfo$mail, _honorMemoryInfo$mail2, _honorMemoryInfo$mail3, _honorMemoryInfo$mail4, _honorMemoryInfo$name;
  return (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$hono = honorMemoryInfo.honorMemoryName) === null || _honorMemoryInfo$hono === void 0 ? void 0 : _honorMemoryInfo$hono.length) > 0 && (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$mail = honorMemoryInfo.mailCardToAddress) === null || _honorMemoryInfo$mail === void 0 ? void 0 : _honorMemoryInfo$mail.length) > 0 && (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$mail2 = honorMemoryInfo.mailCardToCity) === null || _honorMemoryInfo$mail2 === void 0 ? void 0 : _honorMemoryInfo$mail2.length) > 0 && (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$mail3 = honorMemoryInfo.mailCardToState) === null || _honorMemoryInfo$mail3 === void 0 ? void 0 : _honorMemoryInfo$mail3.length) > 0 && (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$mail4 = honorMemoryInfo.mailCardToZip) === null || _honorMemoryInfo$mail4 === void 0 ? void 0 : _honorMemoryInfo$mail4.length) > 0 && (honorMemoryInfo === null || honorMemoryInfo === void 0 ? void 0 : (_honorMemoryInfo$name = honorMemoryInfo.nameOnCard) === null || _honorMemoryInfo$name === void 0 ? void 0 : _honorMemoryInfo$name.length) > 0;
};

var formatUSCurrency = function formatUSCurrency(value) {
  var fractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits
  }).format(value);
};
var calculateTotalPrice = function calculateTotalPrice(productList) {
  return productList.reduce(function (acc, product) {
    return +acc + +product.price;
  }, 0);
};
var calculateDiscount = function calculateDiscount(originalPrice, promoPrice) {
  return originalPrice - promoPrice;
};

var getRecaptchaKeyV2 = function getRecaptchaKeyV2() {
  if (!process.env.RECAPTCHA_SITEKEY_VERSION_TWO && process.env.GATSBY_RECAPACTHA_SITEKEY_VERSION_TWO) {
    return process.env.GATSBY_RECAPACTHA_SITEKEY_VERSION_TWO;
  }
  return process.env.RECAPTCHA_SITEKEY_VERSION_TWO;
};
var getRecaptchaKeyV3 = function getRecaptchaKeyV3() {
  if (!process.env.RECAPTCHA_SITEKEY_VERSION_THREE && process.env.GATSBY_RECAPACTHA_SITEKEY_VERSION_THREE) {
    return process.env.GATSBY_RECAPACTHA_SITEKEY_VERSION_THREE;
  }
  if (!process.env.RECAPTCHA_SITEKEY_VERSION_THREE && process.env.REACT_APP_RECAPACTHA_SITEKEY_VERSION_THREE) {
    return "".concat(process.env.REACT_APP_RECAPACTHA_SITEKEY_VERSION_THREE, "/");
  }
  return process.env.RECAPTCHA_SITEKEY_VERSION_THREE;
};
var captchaCheckboxScrollPosition = function captchaCheckboxScrollPosition(captchaRef) {
  var rect = captchaRef.current.getBoundingClientRect();
  var absoluteTop = +window.scrollY + +rect.top;
  return +absoluteTop + +rect.height + 150 - window.innerHeight;
};
var loadRecaptchaV2Script = function loadRecaptchaV2Script() {
  var script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js';
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};
var isDisableRecaptcha = function isDisableRecaptcha(_ref) {
  var _values$formLogic;
  var values = _ref.values,
    isRecaptchaDisabled = _ref.isDisableRecaptcha;
  if (isRecaptchaDisabled === true || (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isDisableRecaptcha) === true) {
    return true;
  }
  if (!process.env.DISABLE_RECAPTCHA && process.env.GATSBY_DISABLE_RECAPTCHA) {
    return process.env.GATSBY_DISABLE_RECAPTCHA;
  }
  if (!process.env.DISABLE_RECAPTCHA && process.env.REACT_APP_DISABLE_RECAPTCHA) {
    return process.env.REACT_APP_DISABLE_RECAPTCHA;
  }
  if (!process.env.REACT_APP_DISABLE_RECAPTCHA && process.env.DISABLE_RECAPTCHA) {
    return process.env.DISABLE_RECAPTCHA;
  }
  return false;
};

var _excluded$16 = ["errorMessage", "id", "isChecked", "isRequired", "label", "labelHtml", "title", "name", "valueObj", "validate"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CheckboxField = /*#__PURE__*/_styled(Field$2, process.env.NODE_ENV === "production" ? {
  target: "e1qshtn01"
} : {
  target: "e1qshtn01",
  label: "CheckboxField"
})(process.env.NODE_ENV === "production" ? {
  name: "10hcc6x",
  styles: "margin-right:0.313rem"
} : {
  name: "10hcc6x",
  styles: "margin-right:0.313rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var FormLabel = /*#__PURE__*/_styled(Form$1.Label, process.env.NODE_ENV === "production" ? {
  target: "e1qshtn00"
} : {
  target: "e1qshtn00",
  label: "FormLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "1tjylrs",
  styles: "width:fit-content"
} : {
  name: "1tjylrs",
  styles: "width:fit-content",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var Checkbox = function Checkbox(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
    id = _ref.id,
    _ref$isChecked = _ref.isChecked,
    isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    label = _ref.label,
    _ref$labelHtml = _ref.labelHtml,
    labelHtml = _ref$labelHtml === void 0 ? '' : _ref$labelHtml,
    title = _ref.title,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'checkbox' : _ref$name,
    valueObj = _ref.valueObj,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (value) {
      return validateAcknowledgement(value, isRequired, errorMessage);
    } : _ref$validate,
    props = _objectWithoutProperties(_ref, _excluded$16);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    if (!valueObj) {
      setFieldValue(name, isChecked);
    }
  }, []);
  return jsxs(Form$1.Field, {
    children: [title && jsx(Form$1.Label, {
      children: title
    }), jsxs(FormLabel, {
      children: [jsx(CheckboxField, _objectSpread2({
        type: "checkbox",
        id: id,
        required: isRequired,
        name: name,
        validate: isRequired ? validate : function () {},
        value: JSON.stringify(valueObj)
      }, props)), !labelHtml ? label :
      // eslint-disable-next-line react/no-danger
      jsx("span", {
        dangerouslySetInnerHTML: {
          __html: labelHtml
        }
      })]
    }), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

var _excluded$15 = ["label", "name", "required", "validate"];
var Acknowledgement = function Acknowledgement(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'I Agree.' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'formLogic.agreement' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (value) {
      return validateAcknowledgement(value, required);
    } : _ref$validate,
    props = _objectWithoutProperties(_ref, _excluded$15);
  return jsxs(Notification, {
    children: [jsx(Content, {
      children: props === null || props === void 0 ? void 0 : props.children
    }), jsx(Form$1.Field, {
      children: jsx(Columns, {
        children: jsx(Columns.Column, {
          children: props.multiple ? jsxs(Fragment, {
            children: [jsx(Checkbox, {
              name: props.names[0] ? props.names[0] : name,
              label: props.labels[0] ? props.labels[0] : label,
              validate: validate
            }), jsx(Content, {
              children: (props === null || props === void 0 ? void 0 : props.waiverLiabilityBetweenCheckboxes) && (props === null || props === void 0 ? void 0 : props.waiverLiabilityStatement)
            }), jsx(Checkbox, {
              name: props.names[1] ? props.names[1] : name,
              label: props.labels[1] ? props.labels[1] : label,
              validate: validate
            })]
          }) : jsx(Checkbox, {
            name: name,
            label: label,
            validate: validate
          })
        })
      })
    })]
  });
};

var _excluded$14 = ["entity", "index", "label", "name", "required"];
var Region = function Region(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'input' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$14);
  var _useRegion = useRegion(_objectSpread2({
      entity: entity,
      index: index,
      label: label,
      required: required
    }, props)),
    options = _useRegion.options,
    selectText = _useRegion.selectText,
    textLabel = _useRegion.textLabel,
    validate = _useRegion.validate;
  return jsx(Form$1.Field, {
    className: "form-region-component",
    children: jsxs(Form$1.Control, {
      children: [jsxs(Form$1.Label, {
        htmlFor: name,
        children: [textLabel, required ? jsx("span", {
          "aria-hidden": "true",
          children: "*"
        }) : '']
      }), jsx("div", {
        className: fieldClassList('select is-fullwidth', name),
        children: jsxs(Field$2, {
          name: name,
          type: "select",
          as: "select",
          label: label,
          className: "select",
          required: required,
          "aria-required": required,
          validate: validate,
          id: name,
          children: [jsx("option", {
            value: "",
            children: selectText
          }, "selectone"), options === null || options === void 0 ? void 0 : options.map(function (region) {
            return jsx("option", {
              value: region.id,
              children: region.value
            }, "region-".concat(region.id));
          })]
        })
      }), name !== '' && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: jsx(ErrorMessage$1, {
          name: name
        })
      })]
    })
  });
};

var _excluded$13 = ["defaultValue", "fieldDisclaimer", "label", "labelHtml", "name", "options", "required", "useFullWidth"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DropdownContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ego3o942"
} : {
  target: "ego3o942",
  label: "DropdownContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
var Select = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ego3o941"
} : {
  target: "ego3o941",
  label: "Select"
})("width:", function (props) {
  return props.useFullWidth ? '100%' : 'auto';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var FieldSelect = /*#__PURE__*/_styled(Field$2, process.env.NODE_ENV === "production" ? {
  target: "ego3o940"
} : {
  target: "ego3o940",
  label: "FieldSelect"
})("width:", function (props) {
  return props.useFullWidth ? '100%' : 'auto';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Dropdown = function Dropdown(_ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    fieldDisclaimer = _ref.fieldDisclaimer,
    label = _ref.label,
    _ref$labelHtml = _ref.labelHtml,
    labelHtml = _ref$labelHtml === void 0 ? '' : _ref$labelHtml,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'Fieldset' : _ref$name,
    options = _ref.options,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$useFullWidth = _ref.useFullWidth,
    useFullWidth = _ref$useFullWidth === void 0 ? false : _ref$useFullWidth,
    props = _objectWithoutProperties(_ref, _excluded$13);
  var _useInputValidation = useInputValidation({
      required: required
    }),
    validate = _useInputValidation.validate;
  return jsxs(Form$1.Field, {
    children: [jsxs(Form$1.Label, {
      children: [!labelHtml ? label :
      // eslint-disable-next-line react/no-danger
      jsx("span", {
        dangerouslySetInnerHTML: {
          __html: labelHtml
        }
      }), required ? jsx("span", {
        "aria-hidden": "true",
        children: "*"
      }) : '']
    }), jsx(Form$1.Control, {
      children: jsxs(DropdownContainer, {
        className: "dropdown-container",
        children: [jsx(Select, {
          className: fieldClassList('select', name),
          useFullWidth: useFullWidth,
          children: jsx(FieldSelect, _objectSpread2(_objectSpread2({
            name: name,
            className: "select",
            as: "select",
            useFullWidth: useFullWidth,
            validate: (props === null || props === void 0 ? void 0 : props.validate) || validate
          }, props), {}, {
            children: options.map(function (option, idx) {
              var value = option !== null && option !== void 0 && option.valueObj ? option === null || option === void 0 ? void 0 : option.valueObj : option.id;
              return jsx("option", {
                value: value,
                disabled: !!option.isDisabled,
                selected: option.value === defaultValue,
                children: option.value
              }, "".concat(option.id).concat(idx));
            })
          }))
        }), fieldDisclaimer && jsx("div", {
          className: "p-2 has-text-weight-bold",
          children: fieldDisclaimer
        })]
      })
    }), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

var Country = function Country(_ref) {
  var _ref$country = _ref.country,
    country = _ref$country === void 0 ? [] : _ref$country,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Country' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "].country") : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$showAllCountries = _ref.showAllCountries,
    showAllCountries = _ref$showAllCountries === void 0 ? false : _ref$showAllCountries,
    onChange = _ref.onChange,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (value) {
      return validateCountry(value);
    } : _ref$validate;
  var _useCountry = useCountry({
      country: country,
      label: label,
      onChange: onChange,
      showAllCountries: showAllCountries
    }),
    countryLabel = _useCountry.countryLabel,
    countryOptions = _useCountry.countryOptions,
    handleOnChange = _useCountry.handleOnChange;
  return jsx(Dropdown, {
    defaultValue: country[0],
    label: countryLabel,
    name: name,
    options: countryOptions,
    onChange: handleOnChange,
    validate: validate,
    required: required
  });
};

var _excluded$12 = ["id", "label", "name", "maxLen", "required"];
var InputText = function InputText(_ref) {
  _ref.id;
    var label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'input' : _ref$name,
    _ref$maxLen = _ref.maxLen,
    maxLen = _ref$maxLen === void 0 ? 65535 : _ref$maxLen,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$12);
  var _useInputValidation = useInputValidation({
      required: required,
      maxLen: maxLen
    }),
    validate = _useInputValidation.validate;
  var _useInputBlur = useInputBlur({
      name: name,
      required: required
    }),
    errorMessage = _useInputBlur.errorMessage,
    handleOnBlur = _useInputBlur.handleOnBlur,
    handleOnBlurUnControlled = _useInputBlur.handleOnBlurUnControlled;
  var _useInputTextEvents = useInputTextEvents({
      name: name
    }),
    handleOnChangeUnControlled = _useInputTextEvents.handleOnChangeUnControlled,
    handleOnKeyDown = _useInputTextEvents.handleOnKeyDown;
  if (props !== null && props !== void 0 && props.useControlledInput) {
    return jsxs(Form$1.Field, {
      className: "form-input-text",
      children: [label && jsxs(Form$1.Label, {
        htmlFor: name,
        children: [label, required ? jsx("span", {
          "aria-hidden": "true",
          children: "*"
        }) : '']
      }), jsx("input", {
        ref: props === null || props === void 0 ? void 0 : props.innerRef,
        name: name,
        onKeyDown: handleOnKeyDown,
        className: "input ".concat(errorMessage ? 'is-danger' : ''),
        onBlur: (props === null || props === void 0 ? void 0 : props.onBlur) || handleOnBlurUnControlled,
        onChange: (props === null || props === void 0 ? void 0 : props.onChange) || handleOnChangeUnControlled,
        id: name,
        type: "text"
      }), ((props === null || props === void 0 ? void 0 : props.errorMessage) || errorMessage) && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: (props === null || props === void 0 ? void 0 : props.errorMessage) || errorMessage
      })]
    });
  }
  return jsxs(Form$1.Field, {
    className: "form-input-text",
    children: [label && jsxs(Form$1.Label, {
      htmlFor: name,
      children: [label, required ? jsx("span", {
        "aria-hidden": "true",
        children: "*"
      }) : '']
    }), jsx(Field$2, _objectSpread2(_objectSpread2({}, props), {}, {
      type: "text",
      className: (props === null || props === void 0 ? void 0 : props.className) || fieldClassList('input', name),
      id: name,
      required: required,
      "aria-required": required,
      onBlur: handleOnBlur,
      onKeyDown: handleOnKeyDown,
      name: name,
      validate: (props === null || props === void 0 ? void 0 : props.validate) || validate
    })), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

var _excluded$11 = ["name", "showLabel", "required"];
var Column$3 = /*#__PURE__*/_styled(Columns.Column, process.env.NODE_ENV === "production" ? {
  target: "e1knefbz0"
} : {
  target: "e1knefbz0",
  label: "Column"
})("padding-top:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";padding-bottom:0;margin-top:0;margin-bottom:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var DefaultAddress = function DefaultAddress(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4, _props$visibleList5, _props$visibleList6, _props$visibleList7;
  var name = _ref.name,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$11);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address = _useFormatAddress.address,
    addressLabel = _useFormatAddress.addressLabel,
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  if (!address) {
    return null;
  }
  return jsxs(Fragment, {
    children: [showLabel === true && addressLabel && jsx("legend", {
      className: "label",
      children: addressLabel
    }), jsxs(Columns, {
      multiline: true,
      children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('country')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(Country, {
          name: "".concat(name, ".country"),
          entity: props === null || props === void 0 ? void 0 : props.entity,
          index: props === null || props === void 0 ? void 0 : props.index,
          country: props === null || props === void 0 ? void 0 : props.country,
          validate: validateInput,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('street')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".street"),
          label: address1Label,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('streetTwo')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".streetTwo"),
          label: address2Label,
          required: false
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('streetThree')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".streetThree"),
          label: address3Label,
          required: false
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList5 = props.visibleList) === null || _props$visibleList5 === void 0 ? void 0 : _props$visibleList5.includes('cityTownRegion')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".cityTownRegion"),
          label: cityLabel,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList6 = props.visibleList) === null || _props$visibleList6 === void 0 ? void 0 : _props$visibleList6.includes('stateProvince')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(Region, {
          entity: props === null || props === void 0 ? void 0 : props.entity,
          name: "".concat(name, ".stateProvince"),
          index: props === null || props === void 0 ? void 0 : props.index,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList7 = props.visibleList) === null || _props$visibleList7 === void 0 ? void 0 : _props$visibleList7.includes('zipPostalCode')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        className: "postal-code-field",
        children: jsx(InputText, {
          name: "".concat(name, ".zipPostalCode"),
          label: postalCodeLabel,
          required: required
        })
      })]
    })]
  });
};

var _excluded$10 = ["name"];
var Address$h = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$10);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    postCodeLabel = _useFormatAddress.postCodeLabel,
    stateLabel = _useFormatAddress.stateLabel,
    streetAddressLabel = _useFormatAddress.streetAddressLabel,
    suburbLabel = _useFormatAddress.suburbLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      isFirst: true,
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: streetAddressLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: suburbLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        label: stateLabel,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var MobilizationAddress$g = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var AU = function AU(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$g, _objectSpread2({}, props)) : jsx(Address$h, _objectSpread2({}, props));
};

var _excluded$$ = ["name"];
var Address$g = function Address(_ref) {
  _ref.name;
    var props = _objectWithoutProperties(_ref, _excluded$$);
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$_ = ["name"];
var MobilizationAddress$f = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$_);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    address1Label = _useFormatAddress.address1Label,
    cityLabel = _useFormatAddress.cityLabel,
    stateLabel = _useFormatAddress.stateLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".stateProvince"),
        label: stateLabel,
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    })]
  });
};

var BE = function BE(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$f, _objectSpread2({}, props)) : jsx(Address$g, _objectSpread2({}, props));
};

var Address$f = function Address(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$Z = ["name"];
var MobilizationAddress$e = function MobilizationAddress(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4, _props$visibleList5, _props$visibleList6;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$Z);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList5 = props.visibleList) === null || _props$visibleList5 === void 0 ? void 0 : _props$visibleList5.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList6 = props.visibleList) === null || _props$visibleList6 === void 0 ? void 0 : _props$visibleList6.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    })]
  });
};

var EE = function EE(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$e, _objectSpread2({}, props)) : jsx(Address$f, _objectSpread2({}, props));
};

var Address$e = function Address(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$Y = ["name"];
var MobilizationAddress$d = function MobilizationAddress(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$Y);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    stateLabel = _useFormatAddress.stateLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".stateProvince"),
        label: stateLabel,
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var KH = function KH(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$d, _objectSpread2({}, props)) : jsx(Address$e, _objectSpread2({}, props));
};

var _excluded$X = ["autoCompleteLabel", "entity", "index", "name", "handleManualAddress", "required"];
var AutoCompleteAddress = function AutoCompleteAddress(_ref) {
  var _values$formLogic;
  var _ref$autoCompleteLabe = _ref.autoCompleteLabel,
    autoCompleteLabel = _ref$autoCompleteLabe === void 0 ? 'Address' : _ref$autoCompleteLabe,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref$name,
    handleManualAddress = _ref.handleManualAddress,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$X);
  var _useAutoCompleteAddre = useAutoCompleteAddress({
      entity: entity,
      index: index,
      name: name,
      handleManualAddress: handleManualAddress
    }),
    handleChange = _useAutoCompleteAddre.handleChange,
    handleKeyDown = _useAutoCompleteAddre.handleKeyDown,
    ref = _useAutoCompleteAddre.ref,
    selectedCountry = _useAutoCompleteAddre.selectedCountry,
    startTypingAddressText = _useAutoCompleteAddre.startTypingAddressText,
    values = _useAutoCompleteAddre.values;
  return selectedCountry && jsxs(Columns, {
    children: [jsx(Columns.Column, {
      size: "half",
      children: jsx(Form$1.Control, {
        children: jsx(InputText, {
          innerRef: ref,
          label: autoCompleteLabel,
          placeholder: startTypingAddressText,
          name: "formLogic.inputAutoCompleteRef",
          required: required,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          value: values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.inputAutoCompleteRef
        })
      })
    }), jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: props === null || props === void 0 ? void 0 : props.address2Label,
        required: false
      })
    }), jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: props === null || props === void 0 ? void 0 : props.cityLabel,
        required: required
      })
    }), jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: entity,
        name: "".concat(name, ".stateProvince"),
        index: index,
        required: required
      })
    }), jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: props === null || props === void 0 ? void 0 : props.postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var _excluded$W = ["name", "required"];
var Address$d = function Address(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4, _props$visibleList5, _props$visibleList6, _props$visibleList7;
  var name = _ref.name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$W);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    hideManualAddress = _useFormatAddress.hideManualAddress,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    handleManualAddress = _useFormatAddress.handleManualAddress,
    validateInput = _useFormatAddress.validateInput;
  return jsx(Fragment, {
    children: hideManualAddress ? jsx(Columns, {
      multiline: true,
      children: jsx(Column$3, {
        size: 12,
        children: jsx(AutoCompleteAddress, _objectSpread2(_objectSpread2({}, props), {}, {
          autoCompleteLabel: (props === null || props === void 0 ? void 0 : props.address1Label) || address1Label,
          required: required,
          address2Label: (props === null || props === void 0 ? void 0 : props.address2Label) || address2Label,
          cityLabel: cityLabel,
          postalCodeLabel: postalCodeLabel,
          handleManualAddress: handleManualAddress
        }))
      })
    }) : jsxs(Columns, {
      multiline: true,
      children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('country')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(Country, {
          name: "".concat(name, ".country"),
          entity: props === null || props === void 0 ? void 0 : props.entity,
          index: props === null || props === void 0 ? void 0 : props.index,
          country: props === null || props === void 0 ? void 0 : props.country,
          validate: validateInput,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('street')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".street"),
          label: (props === null || props === void 0 ? void 0 : props.address1Label) || address1Label,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('streetTwo')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".streetTwo"),
          label: address2Label,
          required: false
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('streetThree')) && jsx(Column$3, {
        size: "half",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".streetThree"),
          label: address3Label,
          required: false
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList5 = props.visibleList) === null || _props$visibleList5 === void 0 ? void 0 : _props$visibleList5.includes('cityTownRegion')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(InputText, {
          name: "".concat(name, ".cityTownRegion"),
          label: cityLabel,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList6 = props.visibleList) === null || _props$visibleList6 === void 0 ? void 0 : _props$visibleList6.includes('stateProvince')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        children: jsx(Region, {
          label: props === null || props === void 0 ? void 0 : props.stateLabel,
          entity: props === null || props === void 0 ? void 0 : props.entity,
          name: "".concat(name, ".stateProvince"),
          index: props === null || props === void 0 ? void 0 : props.index,
          required: required
        })
      }), (props === null || props === void 0 ? void 0 : (_props$visibleList7 = props.visibleList) === null || _props$visibleList7 === void 0 ? void 0 : _props$visibleList7.includes('zipPostalCode')) && jsx(Column$3, {
        size: "one-third",
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        className: "postal-code-field",
        children: jsx(InputText, {
          name: "".concat(name, ".zipPostalCode"),
          label: postalCodeLabel,
          required: true,
          validate: props === null || props === void 0 ? void 0 : props.validate
        })
      })]
    })
  });
};

var MobilizationAddress$c = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var US = function US(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$c, _objectSpread2({}, props)) : jsx(Address$d, _objectSpread2({}, props));
};

var _excluded$V = ["name"];
var Address$c = function Address(_ref) {
  var _props$postalCodeList;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$V);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: (props === null || props === void 0 ? void 0 : (_props$postalCodeList = props.postalCodeList) === null || _props$postalCodeList === void 0 ? void 0 : _props$postalCodeList.length) > 0 ? jsx(Dropdown, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        options: props === null || props === void 0 ? void 0 : props.postalCodeList,
        required: true
      }) : jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || address1Label,
        required: true
      })
    })]
  });
};

var _excluded$U = ["name"];
var MobilizationAddress$b = function MobilizationAddress(_ref) {
  var _props$postalCodeList;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$U);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    stateLabel = _useFormatAddress.stateLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: (props === null || props === void 0 ? void 0 : (_props$postalCodeList = props.postalCodeList) === null || _props$postalCodeList === void 0 ? void 0 : _props$postalCodeList.length) > 0 ? jsx(Dropdown, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        options: props === null || props === void 0 ? void 0 : props.postalCodeList,
        required: true
      }) : jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".stateProvince"),
        label: stateLabel,
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || address1Label,
        required: true
      })
    })]
  });
};

var JP = function JP(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$b, _objectSpread2({}, props)) : jsx(Address$c, _objectSpread2({}, props));
};

var _excluded$T = ["name"];
var Address$b = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$T);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  var _useLaosAddress = useLaosAddress(),
    cityList = _useLaosAddress.cityList,
    districtList = _useLaosAddress.districtList,
    villageList = _useLaosAddress.villageList;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".cityTownRegion"),
        label: "".concat(cityLabel),
        options: cityList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && (districtList === null || districtList === void 0 ? void 0 : districtList.length) > 0 && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: "".concat(address2Label),
        options: districtList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && (villageList === null || villageList === void 0 ? void 0 : villageList.length) > 1 && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetTwo"),
        label: "".concat(address3Label),
        options: villageList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var MobilizationAddress$a = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var LA = function LA(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$a, _objectSpread2({}, props)) : jsx(Address$b, _objectSpread2({}, props));
};

var _excluded$S = ["name"];
var Address$a = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$S);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    countyLabel = _useFormatAddress.countyLabel,
    townCityLabel = _useFormatAddress.townCityLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Columns.Column, {
      size: "half",
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required,
        showAllCountries: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      className: "address-postal-code",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: "Postcode",
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: townCityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: props !== null && props !== void 0 && props.useRegionComponent ? jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: countyLabel
      }) : jsx(InputText, {
        name: "".concat(name, ".stateProvince"),
        label: countyLabel
      })
    })]
  });
};

var _excluded$R = ["name"];
var MobilizationAddress$9 = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$R);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    countyLabel = _useFormatAddress.countyLabel,
    townCityLabel = _useFormatAddress.townCityLabel,
    validateInput = _useFormatAddress.validateInput;
  var _useCraftyClicks = useCraftyClicks(_objectSpread2({
      name: name
    }, props)),
    cityTownRegionInput = _useCraftyClicks.cityTownRegionInput,
    stateProvinceInput = _useCraftyClicks.stateProvinceInput,
    streetInput = _useCraftyClicks.streetInput,
    streetTwoInput = _useCraftyClicks.streetTwoInput,
    streetThreeInput = _useCraftyClicks.streetThreeInput,
    zipPostalCodeInput = _useCraftyClicks.zipPostalCodeInput,
    postalLookUpHandler = _useCraftyClicks.postalLookUpHandler;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Columns.Column, {
      size: 12,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required,
        showAllCountries: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsxs(Fragment, {
      children: [jsx(Column$3, {
        size: 6,
        className: "address-postal-code",
        children: jsxs(Form$1.Field, {
          children: [jsxs(Form$1.Label, {
            htmlFor: name,
            children: ["Postcode", jsx("span", {
              "aria-hidden": "true",
              children: "*"
            })]
          }), jsxs(Columns, {
            children: [jsx(Column$3, {
              children: jsx(Form$1.Control, {
                children: jsx(InputText, {
                  name: "".concat(name, ".zipPostalCode"),
                  label: "",
                  required: true,
                  validate: props === null || props === void 0 ? void 0 : props.validate,
                  innerRef: zipPostalCodeInput,
                  useControlledInput: true
                })
              })
            }), jsx(Column$3, {
              children: jsx(Form$1.Control, {
                children: jsx(Button, {
                  type: "button",
                  onClick: postalLookUpHandler,
                  children: "Find Address"
                })
              })
            })]
          })]
        })
      }), jsx(Column$3, {
        size: 12,
        children: jsx("div", {
          id: "craftyPostcodeResultDisplay".concat(props === null || props === void 0 ? void 0 : props.entity).concat(props === null || props === void 0 ? void 0 : props.index),
          className: "crafty-click-results"
        })
      })]
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        innerRef: streetInput,
        useControlledInput: true,
        required: props === null || props === void 0 ? void 0 : props.street1Required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false,
        innerRef: streetTwoInput,
        useControlledInput: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        innerRef: streetThreeInput,
        required: false,
        useControlledInput: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: townCityLabel,
        innerRef: cityTownRegionInput,
        required: true,
        useControlledInput: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: props !== null && props !== void 0 && props.useRegionComponent ? jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: countyLabel
      }) : jsx(InputText, {
        name: "".concat(name, ".stateProvince"),
        innerRef: stateProvinceInput,
        useControlledInput: true,
        label: countyLabel
      })
    })]
  });
};

var GB = function GB(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$9, _objectSpread2({}, props)) : jsx(Address$a, _objectSpread2({}, props));
};

var _excluded$Q = ["name"];
var Address$9 = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$Q);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    stateLabel = _useFormatAddress.stateLabel,
    streetAddressLabel = _useFormatAddress.streetAddressLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      isFirst: true,
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: streetAddressLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: 12,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        label: stateLabel,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "half",
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var MobilizationAddress$8 = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var PT = function PT(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$8, _objectSpread2({}, props)) : jsx(Address$9, _objectSpread2({}, props));
};

var _excluded$P = ["name"];
var Address$8 = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$P);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  var _useVietnamAddress = useVietnamAddress({
      visibleList: props === null || props === void 0 ? void 0 : props.visibleList
    }),
    cityList = _useVietnamAddress.cityList,
    districtTownList = _useVietnamAddress.districtTownList,
    villageList = _useVietnamAddress.villageList;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required,
        showAllCountries: props === null || props === void 0 ? void 0 : props.showAllCountries
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetTwo"),
        label: "".concat(address2Label),
        options: districtTownList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: "".concat(address3Label),
        options: villageList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        options: cityList,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var MobilizationAddress$7 = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var VN = function VN(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$7, _objectSpread2({}, props)) : jsx(Address$8, _objectSpread2({}, props));
};

var _excluded$O = ["name"];
var Address$7 = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$O);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label
    }, props)),
    address3Label = _useFormatAddress.address3Label,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: "Calle, N\xFAmero",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: "Barrio",
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Zona",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: "Departmento"
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var _excluded$N = ["name"];
var MobilizationAddress$6 = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$N);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label
    }, props)),
    address3Label = _useFormatAddress.address3Label,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: "Calle, N\xFAmero",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: "Barrio",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Zona"
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".stateProvince"),
        label: "Departmento",
        options: props === null || props === void 0 ? void 0 : props.customRegionList
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var BO = function BO(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$6, _objectSpread2({}, props)) : jsx(Address$7, _objectSpread2({}, props));
};

var _excluded$M = ["name"];
var Address$6 = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$M);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: "Calle y N\xFAmero /Altura",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: "Barrio",
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Localidad",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: "Partido",
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: "Provincia"
      })
    })]
  });
};

var _excluded$L = ["name"];
var MobilizationAddress$5 = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$L);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: "Calle y N\xFAmero /Altura",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: "Barrio",
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Localidad",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: "Partido",
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var AR = function AR(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$5, _objectSpread2({}, props)) : jsx(Address$6, _objectSpread2({}, props));
};

var _excluded$K = ["name"];
var Address$5 = function Address(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$K);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    address2Label = _useFormatAddress.address2Label,
    address3Label = _useFormatAddress.address3Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: address2Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: address3Label,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: props !== null && props !== void 0 && props.customRegionList ? jsx(Dropdown, {
        name: "".concat(name, ".stateProvince"),
        label: "Provincia",
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: props === null || props === void 0 ? void 0 : props.required
      }) : jsx(Region, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: true,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var MobilizationAddress$4 = function MobilizationAddress(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var IT = function IT(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$4, _objectSpread2({}, props)) : jsx(Address$5, _objectSpread2({}, props));
};

var _excluded$J = ["name"];
var Address$4 = function Address(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$J);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  var _useEthiopiaAddress = useEthiopiaAddress(),
    cities = _useEthiopiaAddress.cities,
    districtLabel = _useEthiopiaAddress.districtLabel,
    subCityLabel = _useEthiopiaAddress.subCityLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, _objectSpread2(_objectSpread2({}, props), {}, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required
      }))
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: subCityLabel,
        options: cities,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: districtLabel,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: address1Label
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('zipPostalCode')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var _excluded$I = ["name"];
var MobilizationAddress$3 = function MobilizationAddress(_ref) {
  var _props$visibleList, _props$visibleList2, _props$visibleList3, _props$visibleList4;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$I);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    address1Label = _useFormatAddress.address1Label,
    cityLabel = _useFormatAddress.cityLabel,
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  var _useEthiopiaAddress = useEthiopiaAddress(),
    cities = _useEthiopiaAddress.cities,
    districtLabel = _useEthiopiaAddress.districtLabel,
    subCityLabel = _useEthiopiaAddress.subCityLabel;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, _objectSpread2(_objectSpread2({}, props), {}, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        label: props === null || props === void 0 ? void 0 : props.stateLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      }))
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('cityTownRegion')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: (props === null || props === void 0 ? void 0 : props.cityLabel) || cityLabel,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: (props === null || props === void 0 ? void 0 : props.subCityLabel) || subCityLabel,
        options: cities,
        required: false
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: (props === null || props === void 0 ? void 0 : props.districtLabel) || districtLabel,
        required: (props === null || props === void 0 ? void 0 : props.street2Required) || false
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList3 = props.visibleList) === null || _props$visibleList3 === void 0 ? void 0 : _props$visibleList3.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: props.address1Label || address1Label,
        required: (props === null || props === void 0 ? void 0 : props.street1Required) || false
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList4 = props.visibleList) === null || _props$visibleList4 === void 0 ? void 0 : _props$visibleList4.includes('zipPostalCode')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        validate: props === null || props === void 0 ? void 0 : props.validate
      })
    })]
  });
};

var ET = function ET(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$3, _objectSpread2({}, props)) : jsx(Address$4, _objectSpread2({}, props));
};

var Address$3 = function Address(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$H = ["name"];
var MobilizationAddress$2 = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$H);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    postalCodeLabel = _useFormatAddress.postalCodeLabel,
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || 'Nombre de la calle, número, apartamento, letra',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: postalCodeLabel,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: (props === null || props === void 0 ? void 0 : props.cityLabel) || 'Municipio',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, _objectSpread2(_objectSpread2({}, props), {}, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: "Provincia"
      }))
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var ES = function ES(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$2, _objectSpread2({}, props)) : jsx(Address$3, _objectSpread2({}, props));
};

var _excluded$G = ["name"];
var Address$2 = function Address(_ref) {
  _ref.name;
    var props = _objectWithoutProperties(_ref, _excluded$G);
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$F = ["name"];
var MobilizationAddress$1 = function MobilizationAddress(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$F);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || 'Jalan, No.',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || 'Kelurahan',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetThree"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || 'Kecamatan',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Kota",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('stateProvince')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Region, _objectSpread2(_objectSpread2({}, props), {}, {
        entity: props === null || props === void 0 ? void 0 : props.entity,
        name: "".concat(name, ".stateProvince"),
        index: props === null || props === void 0 ? void 0 : props.index,
        required: props === null || props === void 0 ? void 0 : props.required,
        label: "Provinsi"
      }))
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: "Kode Pos",
        required: props === null || props === void 0 ? void 0 : props.required
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var ID = function ID(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress$1, _objectSpread2({}, props)) : jsx(Address$2, _objectSpread2({}, props));
};

var Address$1 = function Address(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(DefaultAddress, _objectSpread2({}, props));
};

var _excluded$E = ["name"];
var MobilizationAddress = function MobilizationAddress(_ref) {
  var _props$visibleList, _props$visibleList2;
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$E);
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: props === null || props === void 0 ? void 0 : props.entity,
      index: props === null || props === void 0 ? void 0 : props.index,
      label: props === null || props === void 0 ? void 0 : props.label,
      name: name
    }, props)),
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Columns, {
    multiline: true,
    children: [(props === null || props === void 0 ? void 0 : props.visibleList.includes('street')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".street"),
        label: (props === null || props === void 0 ? void 0 : props.address1Label) || 'Dirección',
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList = props.visibleList) === null || _props$visibleList === void 0 ? void 0 : _props$visibleList.includes('streetTwo')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".streetTwo"),
        label: "N\xFAmero"
      })
    }), (props === null || props === void 0 ? void 0 : (_props$visibleList2 = props.visibleList) === null || _props$visibleList2 === void 0 ? void 0 : _props$visibleList2.includes('streetThree')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: (props === null || props === void 0 ? void 0 : props.customRegionList) && jsx(Dropdown, {
        name: "".concat(name, ".streetThree"),
        label: "Distrito/Zona",
        options: props === null || props === void 0 ? void 0 : props.customRegionList,
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('cityTownRegion')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(InputText, {
        name: "".concat(name, ".cityTownRegion"),
        label: "Ciudad",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('zipPostalCode')) && jsx(Column$3, {
      size: "one-third",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      className: "postal-code-field",
      children: jsx(InputText, {
        name: "".concat(name, ".zipPostalCode"),
        label: "C\xF3digo Postal",
        required: true
      })
    }), (props === null || props === void 0 ? void 0 : props.visibleList.includes('country')) && jsx(Column$3, {
      size: "half",
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      children: jsx(Country, {
        name: "".concat(name, ".country"),
        entity: props === null || props === void 0 ? void 0 : props.entity,
        index: props === null || props === void 0 ? void 0 : props.index,
        country: props === null || props === void 0 ? void 0 : props.country,
        validate: validateInput,
        required: props === null || props === void 0 ? void 0 : props.required
      })
    })]
  });
};

var PE = function PE(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useMobilizationAddress = (props === null || props === void 0 ? void 0 : props.useMobilizationAddress) || false;
  return useMobilizationAddress ? jsx(MobilizationAddress, _objectSpread2({}, props)) : jsx(Address$1, _objectSpread2({}, props));
};

var _excluded$D = ["autoComplete", "entity", "index", "name"];
var useAddress = function useAddress(_ref) {
  var _props$country;
  var autoComplete = _ref.autoComplete,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref$name,
    props = _objectWithoutProperties(_ref, _excluded$D);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(autoComplete),
    _useState2 = _slicedToArray(_useState, 2),
    showAutocomplete = _useState2[0],
    setShowAutoComplete = _useState2[1];
  var _useState3 = useState(function () {
      return DefaultAddress;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    Format = _useState4[0],
    setFormat = _useState4[1];
  var addressValues = deepFind(values, name);
  var country = (addressValues === null || addressValues === void 0 ? void 0 : addressValues.country) || (props === null || props === void 0 ? void 0 : (_props$country = props.country) === null || _props$country === void 0 ? void 0 : _props$country.length) === 1 && (props === null || props === void 0 ? void 0 : props.country[0]) || 'US';
  var defaultAddress = {
    addressType: (props === null || props === void 0 ? void 0 : props.addressType) || (props === null || props === void 0 ? void 0 : props.type) || 'MAIL',
    street: '',
    streetTwo: '',
    cityTownRegion: '',
    stateProvince: '',
    zipPostalCode: '',
    country: country
  };
  var address = deepFind(values, name) || defaultAddress;
  useEffect(function () {
    if (country === Countries.US) {
      setFormat(function () {
        return US;
      });
    } else if (country === Countries.LA) {
      setFormat(function () {
        return LA;
      });
    } else if (country === Countries.GB) {
      setFormat(function () {
        return GB;
      });
    } else if (country === Countries.AU) {
      setFormat(function () {
        return AU;
      });
    } else if (country === Countries.PT) {
      setFormat(function () {
        return PT;
      });
    } else if (country === Countries.JP) {
      setFormat(function () {
        return JP;
      });
    } else if (country === Countries.VN) {
      setFormat(function () {
        return VN;
      });
    } else if (country === Countries.BO) {
      setFormat(function () {
        return BO;
      });
    } else if (country === Countries.AR) {
      setFormat(function () {
        return AR;
      });
    } else if (country === Countries.IT) {
      setFormat(function () {
        return IT;
      });
    } else if (country === Countries.ET) {
      setFormat(function () {
        return ET;
      });
    } else if (country === Countries.EE) {
      setFormat(function () {
        return EE;
      });
    } else if (country === Countries.ES) {
      setFormat(function () {
        return ES;
      });
    } else if (country === Countries.BE) {
      setFormat(function () {
        return BE;
      });
    } else if (country === Countries.ID) {
      setFormat(function () {
        return ID;
      });
    } else if (country === Countries.KH) {
      setFormat(function () {
        return KH;
      });
    } else if (country === Countries.PE) {
      setFormat(function () {
        return PE;
      });
    } else {
      setFormat(function () {
        return DefaultAddress;
      });
    }
  }, [address === null || address === void 0 ? void 0 : address.country]);
  useEffect(function () {
    setFieldValue(name, address);
  }, []);
  return {
    address: address,
    setFieldValue: setFieldValue,
    setShowAutoComplete: setShowAutoComplete,
    showAutocomplete: showAutocomplete,
    values: values,
    Format: Format
  };
};

var useApplePayButton = function useApplePayButton(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$formLogic5, _values$formLogic5$pa, _values$collector, _values$collector$car, _values$collector$car2, _values$collector$car3;
  var applePayVersion = _ref.applePayVersion,
    onPaymentSuccess = _ref.onPaymentSuccess,
    onPaymentError = _ref.onPaymentError;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var account = getBluefinAccount();
  var token = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.token) || '';
  var isEmbedSite = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.isEmbedSite;
  var enableApayValidation = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.enableApayValidation;
  var enableApayNeverBounce = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.enableApayNeverBounce;
  var postAPaySessionHandler = usePostAPaySession({
    key: token
  });
  var emailVerifyHandler = usePostEmailVerify({
    key: token
  });
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var site = getSiteUrl(values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : (_values$formLogic5$pa = _values$formLogic5.parentDocumentInfo) === null || _values$formLogic5$pa === void 0 ? void 0 : _values$formLogic5$pa.documentLocationHref);
  var siteHost = site === null || site === void 0 ? void 0 : site.replace('https://', '');
  var siteRefererUrl = siteHost !== null && siteHost !== void 0 && siteHost.split('/') ? siteHost === null || siteHost === void 0 ? void 0 : siteHost.split('/')[0] : '';
  var refererUrl = !isEmbedSite ? location.host : siteRefererUrl;
  var paymentRequest = {
    countryCode: 'US',
    currencyCode: 'USD',
    supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
    merchantCapabilities: ['supports3DS'],
    requiredBillingContactFields: ['postalAddress', 'name', 'email'],
    requiredShippingContactFields: ['email', 'phone'],
    ApplePayContactField: ['email', 'name', 'phone', 'postalAddress'],
    total: {
      label: 'Billy Graham Evangelistic Association',
      amount: values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.projects[0]) === null || _values$collector$car3 === void 0 ? void 0 : _values$collector$car3.amount
    }
  };
  var handlePayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var session;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            try {
              e === null || e === void 0 ? void 0 : e.preventDefault();
              session = new window.ApplePaySession(applePayVersion, paymentRequest);
              session.onvalidatemerchant = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var payload, aPaySessionResponse, merchantSession;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      payload = {
                        account: account,
                        refererUrl: refererUrl
                      };
                      _context.next = 4;
                      return postAPaySessionHandler.postAPaySession(payload);
                    case 4:
                      aPaySessionResponse = _context.sent;
                      merchantSession = aPaySessionResponse === null || aPaySessionResponse === void 0 ? void 0 : aPaySessionResponse.payload; // Pass the session object to Apple
                      session.completeMerchantValidation(merchantSession);
                      _context.next = 13;
                      break;
                    case 9:
                      _context.prev = 9;
                      _context.t0 = _context["catch"](0);
                      logging({
                        functionName: 'useApplePayButton.handlePayment.session.onvalidatemerchant',
                        error: _context.t0
                      });
                      session.abort();
                    case 13:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 9]]);
              }));
              session.onpaymentauthorized = function (applePayment) {
                var payment = applePayment === null || applePayment === void 0 ? void 0 : applePayment.payment;
                var aPayErrors = getPaymentErrors(payment, enableApayNeverBounce, emailVerifyHandler);
                if (enableApayValidation && (aPayErrors === null || aPayErrors === void 0 ? void 0 : aPayErrors.length) === 0 || !enableApayValidation) {
                  var result = {
                    status: window.ApplePaySession.STATUS_SUCCESS
                  };
                  session.completePayment(result);
                  onPaymentSuccess(payment);
                } else {
                  session.completePayment({
                    status: window.ApplePaySession.STATUS_FAILURE,
                    errors: aPayErrors
                  });
                }
              };
              session.oncancel = function () {
                logging({
                  functionName: 'useApplePayButton.handlePayment.session.oncancel',
                  error: {}
                });
              };
              session.begin();
            } catch (error) {
              if (onPaymentError && error instanceof Error) {
                onPaymentError(error);
              }
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handlePayment(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    values: values,
    handlePayment: handlePayment
  };
};

var ApiClient = /*#__PURE__*/function () {
  function ApiClient(config) {
    _classCallCheck(this, ApiClient);
    this.acoustic = axios.create(config.acoustic);
    this.api = axios.create(config.api);
    this.bluefinApi = axios.create(config.bluefinApi);
    this.brbApi = axios.create(config.brbApi);
    this.dataentry = axios.create(config.dataentry);
    this.fileUpload = axios.create(config.fileUpload);
    this.forms = axios.create(config.forms);
    this.logging = axios.create(config.logging);
    this.powerByText = axios.create(config.powerByText);
    this.reference = axios.create(config.reference);
    this.stellofy = axios.create(config.stellofy);
  }

  /**
   * Get a Vogon ping response.
   *
   * @function
   */
  _createClass(ApiClient, [{
    key: "getPing",
    value: function getPing() {
      return this.forms.get('/v1/ping');
    }

    /**
     * Get a user's data.
     *
     * @function
     */
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      return this.dataentry.get('/react/getCurrentUserInfo');
    }

    /**
     * Get call taker and fundraiser info
     *
     * @function
     */
  }, {
    key: "getBRBInfo",
    value: function getBRBInfo() {
      return this.brbApi.get('/react/getFormConfig');
    }

    /**
     * Get a full list of Email list table.
     *
     * @function
     */
  }, {
    key: "getEmailList",
    value: function getEmailList() {
      return this.api.get('/reference/esubs/get_EmailList/v1');
    }

    /**
     * Create a Form Data
     *
     * @function
     * @param {Object} payload
     */
  }, {
    key: "createFormData",
    value: function createFormData(payload) {
      return this.forms.post('/v1/submit', payload);
    }

    /**
     * Create a token to our api service
     *
     * @function
     * @param action: String header action
     */
  }, {
    key: "createToken",
    value: function createToken() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'create';
      var sessionValue = "{\"action\":\"".concat(action, "\"}");
      return this.api.post('/upload', null, {
        headers: {
          'BG-Session': sessionValue
        }
      });
    }

    /**
     * Create a Logging entry
     *
     * @function
     * @param {Object} payload
     */
  }, {
    key: "createLogging",
    value: function createLogging(key, payload) {
      var data = JSON.stringify(payload);
      return this.api.post('/log/v1/store', data, {
        headers: {
          'Content-type': 'application/json',
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }

    /**
     * Upload a file to our api service
     *
     * @function
     * @param key: String auth token
     * @param payload: Object with site, form id, and object of files in base64 format
     */
  }, {
    key: "uploadUserFile",
    value: function uploadUserFile(key, payload) {
      var data = JSON.stringify(payload);
      var sessionId = key || (payload === null || payload === void 0 ? void 0 : payload.sessionId);
      return this.api.post('upload/v1/uploadFile', data, {
        headers: {
          'Content-type': 'application/json',
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(sessionId, "\"}")
        }
      });
    }

    /**
     * Delete a file to our api service
     *
     * @function
     * @param key: String auth token
     * @param payload: Object with site, form id, and string of file name
     */
  }, {
    key: "deleteUserFile",
    value: function deleteUserFile(key, payload) {
      var data = JSON.stringify(payload);
      return this.api.post('upload/v1/deleteFile', data, {
        headers: {
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }

    /**
     * Get DMAG products from the reference API(v1) based on the given sub location, sub type, and promo code.
     *
     * @function
     * @param {string} subLocation - The location Ex: us.
     * @param {string} subType - The subscription type Ex: 1pd.
     * @param {string} promoCode - The discount code.
     */
  }, {
    key: "getDmagProducts",
    value: function getDmagProducts(subLocation, subType, promoCode) {
      var path = "".concat(subLocation, "/").concat(subType);
      if (promoCode) {
        path += "/".concat(promoCode);
      }
      return this.api.get("/reference/dmagsubs/get_product/v1/".concat(path));
    }

    /**
     * Get DMAG subscriptions with discounts from the reference API(v1).
     *
     * @function
     */
  }, {
    key: "getDmagSubscriptions",
    value: function getDmagSubscriptions() {
      return this.api.get('/reference/dmagsubs/get_AllSubscriptions/v1');
    }

    /**
     * Get DMAG subscriptions with no discounts from the reference API(v1).
     *
     * @function
     */
  }, {
    key: "getDmagNonDiscountSubscriptions",
    value: function getDmagNonDiscountSubscriptions() {
      return this.api.get('/reference/dmagsubs/get_AllNonDiscountedSubscriptions/v1');
    }

    /**
     * Get Courses products table from the reference API(v1) based on the given product code.
     *
     * @function
     * @param {string} productCode - The product code.
     */
  }, {
    key: "getCoursesProducts",
    value: function getCoursesProducts(productCode) {
      return this.api.get("/reference/online_courses/getProductsTable/v1/".concat(productCode));
    }

    /**
     * Get Courses discount price from the courses server based on given product code and promo code.
     *
     * @function
     * @param {string} productCode - The product code.
     * @param {string} promoCode - The promo code.
     */
  }, {
    key: "getCoursesDiscountPrice",
    value: function getCoursesDiscountPrice(productCode, promoCode) {
      return this.api.get("/reference/online_courses/get_DiscountPrice/v1/".concat(productCode, "/").concat(promoCode));
    }

    /**
     * Get user information from Stellofy based on a given people id.
     *
     * @function
     * @param {string} peopleId - The token.
     */
  }, {
    key: "getStellofyPeople",
    value: function getStellofyPeople(peopleId) {
      return this.stellofy.get("/api/v3/people/".concat(peopleId));
    }

    /**
     * Get role information for a user from Stellofy based on a given role id.
     *
     * @function
     * @param {string} roleId - The token.
     */
  }, {
    key: "getStellofyRole",
    value: function getStellofyRole(roleId) {
      return this.stellofy.get("/api/v3/roles/".concat(roleId));
    }

    /**
     * Call the PayConex API to fetch a payment session object
     *
     * @function
     * @param {string} merchantId - The Merchant Id in PayConex.
     * @param {Object} payload - Apple data
     */
  }, {
    key: "postPayConexApi",
    value: function postPayConexApi(merchantId, payload) {
      var data = JSON.stringify(payload);
      return this.bluefinApi.post("/api/v1/apple_pay/".concat(merchantId, "/get_apple_pay_session"), data, {
        headers: {
          'content-type': 'application/json'
        }
      });
    }

    /**
     * Get token information from Stellofy based on a given token.
     *
     * @function
     * @param key: String auth token
     * @param {string} stellofyToken - The token.
     */
  }, {
    key: "getStellofyToken",
    value: function getStellofyToken(key, stellofyToken) {
      return this.api.get("/stellofy/v3/tokens?token=".concat(stellofyToken), {
        headers: {
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }

    /**
     * Get current subscriptions for given email address.
     *
     * @function
     * @param {string} payload - email and dsan
     */
  }, {
    key: "getUserEsubList",
    value: function getUserEsubList(payload) {
      return this.acoustic.post('/v1/getEsubList', payload);
    }

    /**
     * Verify if valid email from NeverBounce via Email Verify api service
     *
     * @function
     * @param key: String auth token
     * @param payload: Object with string of email address
     */
  }, {
    key: "postEmailVerify",
    value: function postEmailVerify(key, payload) {
      return this.api.post('verify/v1/verify-email', payload, {
        headers: {
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }

    /**
     * Creates a new Apple Pay Session
     *
     * @function
     * @param key: String auth token
     * @param {Object} payload - Apple data - account: string , refererUrl: string
     */
  }, {
    key: "postAPaySession",
    value: function postAPaySession(key, payload) {
      return this.api.post('/bluefin/apay', payload, {
        headers: {
          'content-type': 'application/json',
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }

    /**
     * Creates subscribers to a PoweredByText group
     *
     * @function
     * @param key: String auth token
     * @param {Object} payload - mobileNo: string
     */
  }, {
    key: "postAddSubscriberPowerText",
    value: function postAddSubscriberPowerText(key, payload) {
      return this.api.post('/text/v1/add-subscriber', payload, {
        headers: {
          'content-type': 'application/json',
          'BG-Session': "{\"action\":\"auth\", \"key\":\"".concat(key, "\"}")
        }
      });
    }
  }]);
  return ApiClient;
}();
var apiClient = new ApiClient({
  acoustic: {
    baseURL: getAcousticURI()
  },
  api: {
    baseURL: getApiURI()
  },
  bluefinApi: {
    baseURL: getBluefinApiURI()
  },
  brbApi: {
    baseURL: getBRBInfo()
  },
  dataentry: {
    baseURL: getDataEntryURI()
  },
  fileUpload: {
    baseURL: getFileUploadURI()
  },
  forms: {
    baseURL: getFormURI()
  },
  logging: {
    baseURL: getLoggingURI()
  },
  powerByText: {
    baseURL: getPowerByTextApiURI()
  },
  reference: {
    baseURL: getReferenceURI()
  },
  stellofy: {
    baseURL: getStellofyURI()
  }
});

var useCreateLogging = function useCreateLogging(_ref) {
  var key = _ref.key,
    values = _ref.values;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var GENERIC_ERROR_MESSAGE = t('errors:default');
  var loggingQuery = useMutation(function (payload) {
    return apiClient.createLogging(key, payload);
  });
  var createLogging = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      var _values$formLogic, _values$formLogic$par, _values$formLogic2, site, formLoadDateInfo, formLoadDateStr, log, data, errorTypeEq, isInvalidRequest, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            site = getSiteUrl(values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref);
            formLoadDateInfo = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.formLoadDateInfo;
            formLoadDateStr = formLoadDateInfo ? "formLoadDateInfo: ".concat(formLoadDateInfo) : '';
            log = "".concat(payload.log, " ").concat(formLoadDateStr);
            data = _objectSpread2(_objectSpread2({}, payload), {}, {
              log: log,
              referrer: (payload === null || payload === void 0 ? void 0 : payload.referrer) || site
            });
            _context.next = 8;
            return loggingQuery.mutateAsync(data);
          case 8:
            return _context.abrupt("return", _context.sent);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            errorTypeEq = R.pathEq(['response', 'data', 'error', 'type']);
            isInvalidRequest = errorTypeEq('INVALID_REQUEST_ERROR', _context.t0);
            if (isInvalidRequest) {
              errorMessage = R.path(['response', 'data', 'error', 'message'], _context.t0);
            } else {
              errorMessage = _context.t0.message;
            }
            throw new Error(errorMessage || GENERIC_ERROR_MESSAGE);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function createLogging(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    createLogging: createLogging
  };
};

var useLogging = function useLogging() {
  var _values$formLogic, _values$formLogic2, _values$formLogic2$pa;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var token = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.token) || '';
  var loggingHandler = useCreateLogging({
    key: token,
    values: values
  });
  var site = getSiteUrl(values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pa = _values$formLogic2.parentDocumentInfo) === null || _values$formLogic2$pa === void 0 ? void 0 : _values$formLogic2$pa.documentLocationHref);
  var logging = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var _ref$description, description, functionName, error, _ref$logPayload, logPayload, _ref$type, type, _Object$keys, _error$response, _error$response$data, formData, data, errDataMessage, payload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref$description = _ref.description, description = _ref$description === void 0 ? '' : _ref$description, functionName = _ref.functionName, error = _ref.error, _ref$logPayload = _ref.logPayload, logPayload = _ref$logPayload === void 0 ? {} : _ref$logPayload, _ref$type = _ref.type, type = _ref$type === void 0 ? 'error' : _ref$type;
            _context.prev = 1;
            formData = _objectSpread2({}, values);
            formData === null || formData === void 0 ? true : delete formData.translations;
            data = ((_Object$keys = Object.keys(logPayload)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 ? logPayload : formData;
            errDataMessage = (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || '';
            payload = {
              log: JSON.stringify({
                data: data,
                error: "BGEA-JS Error ".concat(JSON.stringify(error.toJSON())),
                description: "BGEA-JS Client-side Form function name: ".concat(functionName, " description: ").concat(description, " additional error message: ").concat(errDataMessage, " ")
              }),
              type: type,
              referrer: site
            };
            _context.next = 9;
            return loggingHandler.createLogging(payload);
          case 9:
            _context.next = 13;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    }));
    return function logging(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    logging: logging
  };
};

var useApplePayment = function useApplePayment() {
  var _values$formLogic;
  var applePaySdkJs = "https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js";
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setErrors = _useFormikContext.setErrors,
    setFieldValue = _useFormikContext.setFieldValue,
    submitForm = _useFormikContext.submitForm;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isApplePayAvailable = _useState2[0],
    setIsApplePayAvailable = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    applePayVersion = _useState4[0],
    setApplePayVersion = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasPaymentData = _useState6[0],
    setHasPaymentData = _useState6[1];
  var isAPayPayment = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isAPayPayment;
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var _useScript = useScript({
      url: applePaySdkJs
    }),
    _useScript2 = _slicedToArray(_useScript, 1),
    scriptLoading = _useScript2[0];
  var handlePaymentSuccess = function handlePaymentSuccess(payment) {
    handleFormValues$1(payment, values, setFieldValue);
    setHasPaymentData(true);
  };
  var handlePaymentError = function handlePaymentError(error) {
    logging({
      functionName: 'useApplePayment.handlePaymentError',
      error: error
    });
  };
  useEffect(function () {
    if (hasPaymentData && isAPayPayment) {
      setErrors({});
      submitForm();
    }
  }, [hasPaymentData, isAPayPayment]);
  useEffect(function () {
    if (!scriptLoading && window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      for (var i = 15; i > 0; i--) {
        if (window.ApplePaySession.supportsVersion(i)) {
          setApplePayVersion(i);
          break;
        }
      }
      setIsApplePayAvailable(true);
    }
  }, [scriptLoading]);
  return {
    applePayVersion: applePayVersion,
    isApplePayAvailable: isApplePayAvailable,
    values: values,
    handlePaymentSuccess: handlePaymentSuccess,
    handlePaymentError: handlePaymentError
  };
};

var GOOGLE_MAPS_API_KEY = 'AIzaSyBd0P-AOyzRyhNXFczEji2_GHwG5So7q8E';

var useAutoCompleteAddress = function useAutoCompleteAddress(_ref) {
  var _values$collector, _values$collector$ent, _values$collector$ent2, _values$formLogic5;
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref$name,
    handleManualAddress = _ref.handleManualAddress;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange,
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAddressFields = _useState2[0],
    setShowAddressFields = _useState2[1];
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var startTypingAddressText = translations === null || translations === void 0 ? void 0 : translations.startTypingAddressText;
  var googleMapsApiKey = getGoogleMapVariable() || GOOGLE_MAPS_API_KEY;
  var selectedCountry = ((_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity["".concat(entity)]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.address["".concat(index)]) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.country) || '';
  var _usePlacesWidget = usePlacesWidget({
      apiKey: googleMapsApiKey,
      inputAutocompleteValue: 'off',
      options: {
        types: ['address'],
        componentRestrictions: {
          country: selectedCountry || []
        }
      },
      onPlaceSelected: function onPlaceSelected(place) {
        try {
          var _streetNumber, _values$collector2, _values$formLogic, _values$formLogic$par;
          var inputRef = ref;
          var address = {
            street_number: {
              long_name: ''
            },
            route: {
              long_name: ''
            },
            postal_code: {
              long_name: ''
            },
            locality: {
              long_name: ''
            },
            administrative_area_level_1: {
              short_name: ''
            },
            country: ''
          };
          place.address_components.forEach(function (element) {
            if (element.types && Array.isArray(element.types)) {
              element.types.forEach(function (type) {
                address[type] = {
                  long_name: element.long_name,
                  short_name: element.short_name
                };
              });
            }
          });
          var streetNumber = address.street_number.long_name;
          if (inputRef !== null && inputRef !== void 0 && inputRef.current && !address.street_number.long_name) {
            var _inputRef$current, _inputRef$current$val;
            streetNumber = inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$val = _inputRef$current.value) === null || _inputRef$current$val === void 0 ? void 0 : _inputRef$current$val.split(' ')[0];
          }
          var street = "".concat((_streetNumber = streetNumber) === null || _streetNumber === void 0 ? void 0 : _streetNumber.trim(), " ").concat(address.route.long_name);
          setFieldValue('formLogic.inputAutoCompleteRef', street);
          var addressObj = {
            street: street,
            streetTwo: '',
            stateProvince: address.administrative_area_level_1.short_name,
            cityTownRegion: address.locality.long_name,
            zipPostalCode: address.postal_code.long_name,
            country: selectedCountry
          };
          setFieldValue("".concat(name), addressObj);
          setShowAddressFields(true);
          trackEvent(AUTO_COMPLETE_ADDRESS, {
            formCategory: values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : _values$collector2.formID,
            formAction: 'AutoCompleteAddress',
            formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref) || document.location.href,
            formValue: 1
          });
          trackDonationFunnel({
            addressDetailComplete: 'Y',
            values: values
          });
        } catch (error) {
          handleManualAddress();
        }
      }
    }),
    ref = _usePlacesWidget.ref;
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.stopPropagation();
      // Prevent form submission or other default behavior
      e.preventDefault();
    }
  };
  useEffect(function () {
    var _values$formLogic2, _values$formLogic2$in, _values$formLogic3, _values$collector3, _values$collector3$en, _values$collector3$en2;
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$in = _values$formLogic2.inputAutoCompleteRef) === null || _values$formLogic2$in === void 0 ? void 0 : _values$formLogic2$in.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.inputAutoCompleteRef) !== (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.address[0]) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.street)) {
      var _values$formLogic4;
      setFieldValue("collector.entity[".concat(entity, "].address[").concat(index, "].street"), values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.inputAutoCompleteRef, false);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.inputAutoCompleteRef]);
  return {
    handleChange: handleChange,
    handleKeyDown: handleKeyDown,
    ref: ref,
    selectedCountry: selectedCountry,
    showAddressFields: showAddressFields,
    startTypingAddressText: startTypingAddressText,
    values: values
  };
};

var BFConfigCC = {
  create: true,
  iframeId: 'payment_iframe_cc',
  settings: {
    parentId: 'iframe_container_cc',
    cvv: 'required',
    expy: 'double_dropdown',
    layout: 3,
    width: '100%',
    height: '290px',
    timeout: '180',
    css: {
      class_row: 'margin:0;',
      class_input_box: 'font-family:"Gotham SSm A","Gotham SSm B",sans-serif; font-weight:lighter; letter-spacing:1px; font-size:1.2rem; padding:0.5rem;width:94%;max-width: 400px;',
      id_body: 'font-family:"Gotham SSm A","Gotham SSm B",sans-serif; font-weight:lighter; font-size:1.25rem; letter-spacing:1px; margin-top:0.5rem;',
      class_label: 'display: block;font-size:.85rem; letter-spacing:1px; color:#0a0a0a;margin-bottom: .25rem;',
      id_number_input: 'border-radius:5px;letter-spacing:1px; padding:.5rem; border:1px solid #cacaca; margin:0 0 1rem; font-size:.8rem; width: 100%; color:#0a0a0a; background-color:#fff; box-shadow:inset 0px 1px 3px #ececec; transition:box-shadow .5s,border-color .25s ease-in-out; transform: scale(1.3); transform-origin: left center; margin: 10px 0;',
      id_cvv_input: 'border-radius:5px;letter-spacing:1px; padding:.5rem; border:1px solid #cacaca; margin:0 0 1rem; font-size:1.2rem; color:#0a0a0a; background-color:#fff; box-shadow:inset 0px 1px 3px #ececec;  transition:box-shadow .5s,border-color .25s ease-in-out; width: 150px;',
      id_expy_dd_month: 'border-radius:5px;font-size:1em; border-width:1px; margin:0 1em 1em 0; font-weight:lighter; background-color:#efefef; border:1px solid #cacaca; color:#0a0a0a; letter-spacing:1px;height: 40px;',
      id_expy_dd_year: 'border-radius:5px;font-size:1em; border-width:1px; margin:0 1em 1em 0; font-weight:lighter; background-color:#efefef; border:1px solid #cacaca; color:#0a0a0a; letter-spacing:1px;height: 40px;',
      id_timeout_div: 'font-weight: lighter;',
      id_timeout_header: 'color: #000;',
      id_timeout_text: 'color: #111;',
      id_timeout_link: 'color: #111; text-decoration: none; background:#eee; padding:.5rem; border:1px solid #666; border-radius:5px;'
    }
  }
};

var BFConfigEFT = {
  create: true,
  iframeId: 'payment_iframe_eft',
  settings: {
    parentId: 'iframe_container_eft',
    layout: 'layout_1',
    width: '100%',
    height: '233px',
    expy: 'double_dropdown',
    timeout: '180',
    paymentMethod: 'ach',
    css: {
      class_row: 'margin:0;',
      class_input_box: 'font-family:"Gotham SSm A","Gotham SSm B",sans-serif; font-weight:lighter; letter-spacing:1px; font-size:1.2rem; padding:0.5rem;width:94%;max-width: 400px;',
      id_body: 'font-family:"Gotham SSm A","Gotham SSm B",sans-serif; font-weight:lighter; font-size:1.25rem; letter-spacing:1px; margin-top:0.5rem;',
      class_label: 'display: block;font-size:.85rem; letter-spacing:1px; color:#0a0a0a;margin-bottom: .25rem;',
      id_account_input: 'border-radius:5px;letter-spacing:1px; padding:.5rem; border:1px solid #cacaca; margin:0 0 1rem; font-size:1rem; color:#0a0a0a; background-color:#fff; box-shadow:inset 0px 1px 3px #ececec; transition:box-shadow .5s,border-color .25s ease-in-out;',
      id_routing_input: 'border-radius:5px;letter-spacing:1px; padding:.5rem; border:1px solid #cacaca; margin:0 0 1rem; font-size:1.2rem; color:#0a0a0a; background-color:#fff; box-shadow:inset 0px 1px 3px #ececec;  transition:box-shadow .5s,border-color .25s ease-in-out; width: 150px;'
    }
  }
};

var BFIframeType = {
  CC: BFConfigCC,
  EFT: BFConfigEFT
};
var BFConfig = function BFConfig(type) {
  var _values$formLogic, _values$formLogic$lan;
  var bluefinAcc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.REACT_APP_BLUEFIN_ACCOUNT;
  var bluefinDevServer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.REACT_APP_BLUEFIN_DEVSERVER;
  var gatsbyBluefinAcc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : process.env.GATSBY_BLUEFIN_ACCOUNT;
  var gatsbyBluefinDevServer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : process.env.GATSBY_BLUEFIN_DEVSERVER;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var _useTranslation = useTranslation(['resource']),
    t = _useTranslation.t;
  var config = BFIframeType[type];
  config.settings.lang = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$lan = _values$formLogic.language) === null || _values$formLogic$lan === void 0 ? void 0 : _values$formLogic$lan.toLowerCase()) || 'en';
  config.settings.account = bluefinAcc || gatsbyBluefinAcc;
  config.settings.devServer = bluefinDevServer || gatsbyBluefinDevServer;
  config.settings.text = {
    number: {
      label: (translations === null || translations === void 0 ? void 0 : translations.cardNumberText) || t('number', {
        ns: 'resource'
      }),
      placeholder: ''
    },
    expy_double_dropdown: {
      label: (translations === null || translations === void 0 ? void 0 : translations.expirationText) || t('expy_double_dropdown', {
        ns: 'resource'
      }),
      placeholder_1: 'MM',
      placeholder_2: 'YY'
    },
    cvv: {
      label: (translations === null || translations === void 0 ? void 0 : translations.cvvText) || t('cvv', {
        ns: 'resource'
      }),
      placeholder: ''
    },
    timeout_header: {
      text: t('Secure connection timed out.', {
        ns: 'resource'
      })
    },
    timeout_body: {
      text: t('Reconnect', {
        ns: 'resource'
      })
    },
    bank_account: {
      label: (translations === null || translations === void 0 ? void 0 : translations.accountNumberText) || t('bank_account', {
        ns: 'resource'
      }),
      placeholder: ''
    },
    routing_number: {
      label: (translations === null || translations === void 0 ? void 0 : translations.routingNumberText) || t('routing_number', {
        ns: 'resource'
      }),
      placeholder: ''
    }
  };
  return config;
};
var useBluefinPayment = function useBluefinPayment() {
  return {
    BFConfig: BFConfig
  };
};

var AckText = {
  en: {
    ackText: 'By providing your personal details, you accept that we will use your personal details to communicate with you about ministry updates and opportunities from Billy Graham Evangelistic Association. ',
    privacyText: 'View our full Privacy Policy.'
  },
  es: {
    ackText: 'Al proporcionar sus datos personales, usted acepta que utilicemos sus datos personales para comunicarnos con usted sobre las actualizaciones y oportunidades del ministerio de la Billy Graham Evangelistic Association. ',
    privacyText: 'Consulta nuestra Política de privacidad.'
  },
  id: {
    ackText: 'Al proporcionar sus datos personales, usted acepta que utilicemos sus datos personales para comunicarnos con usted sobre las actualizaciones y oportunidades del ministerio de la Billy Graham Evangelistic Association. ',
    privacyText: 'Consulta nuestra Política de privacidad.'
  }
};

var _excluded$C = ["callbacks", "masked", "method"];
var _this = undefined;
var getTotalAmount = function getTotalAmount(values) {
  var _values$collector, _cart$donation, _cart$donation$projec;
  var cart = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.cart;
  var total = cart === null || cart === void 0 ? void 0 : (_cart$donation = cart.donation) === null || _cart$donation === void 0 ? void 0 : (_cart$donation$projec = _cart$donation.projects) === null || _cart$donation$projec === void 0 ? void 0 : _cart$donation$projec.reduce(function (a, b) {
    return a + (b.amount || 0);
  }, 0);
  return total ? formatCurrency("".concat(total)) : 0;
};
var useBluefinPaymentIframe = function useBluefinPaymentIframe(_ref) {
  var _Object$keys, _values$formLogic, _values$formLogic$lan, _values$formLogic2, _values$formLogic3, _AckText$language, _AckText$language2, _values$formLogic4, _values$formLogic5, _Object$keys2, _values$formLogic6, _values$formLogic7, _values$collector2;
  var callbacks = _ref.callbacks,
    masked = _ref.masked,
    method = _ref.method,
    props = _objectWithoutProperties(_ref, _excluded$C);
  var ref = useRef(null);
  var domain = props.config.settings.devServer || 'https://cert.payconex.net';
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    submitForm = _useFormikContext.submitForm,
    setFieldValue = _useFormikContext.setFieldValue,
    setStatus = _useFormikContext.setStatus,
    setSubmitting = _useFormikContext.setSubmitting,
    isSubmitting = _useFormikContext.isSubmitting,
    isValid = _useFormikContext.isValid,
    status = _useFormikContext.status,
    validateForm = _useFormikContext.validateForm,
    values = _useFormikContext.values;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var totalAmt = getTotalAmount(values);
  var totalAmount = "".concat(totalAmt);
  var hasErrors = ((_Object$keys = Object.keys(errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var language = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$lan = _values$formLogic.language) === null || _values$formLogic$lan === void 0 ? void 0 : _values$formLogic$lan.toLowerCase()) || 'en';
  var showFormErrorScreen = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.showFormErrorScreen) || false;
  var isEmbedSite = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.isEmbedSite) || false;
  var ackText = (_AckText$language = AckText[language]) === null || _AckText$language === void 0 ? void 0 : _AckText$language.ackText;
  var privacyText = (_AckText$language2 = AckText[language]) === null || _AckText$language2 === void 0 ? void 0 : _AckText$language2.privacyText;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var showGiftOffer = (values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.showFreeGiftOffer) && (values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.giftOffer) && ((_Object$keys2 = Object.keys(values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.giftOffer)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0;
  var giftOffer = values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.giftOffer;
  var errorMessage = getErrorMessage({
    status: status
  });
  var buildSrc = function buildSrc(settings) {
    var versionPath = '';
    if (undefined !== settings.css || undefined !== settings.text || undefined !== settings.font || undefined !== settings.paymentMethod) {
      versionPath = '/styled.php';
    }
    var src = "https://secure.payconex.net/iframe".concat(versionPath, "?aid=");
    if (settings.devServer) {
      src = "".concat(settings.devServer, "/iframe").concat(versionPath, "?aid=");
    }
    src += lpad(settings.account, 12);
    if (settings.lang) {
      src += "&lang=".concat(settings.lang);
    }
    if (settings.cvv) {
      src += "&cvv=".concat(settings.cvv);
    }
    if (settings.expy) {
      src += "&expy=".concat(settings.expy);
    }
    if (settings.layout) {
      src += "&layout=".concat(settings.layout);
    }
    if (settings.inputWidth) {
      src += "&input_width=".concat(settings.inputWidth);
    }
    if (settings.labelWidth) {
      src += "&label_width=".concat(settings.labelWidth);
    }
    if (undefined !== settings.showPlaceholders) {
      src += "&show_placeholders=".concat(settings.showPlaceholders);
    }
    var _buildSrcStr = buildSrcStr(masked, settings, src),
      newMasked = _buildSrcStr.newMasked,
      newSrc = _buildSrcStr.newSrc;
    masked = newMasked;
    return newSrc;
  };
  var _useState3 = useState({
      invalidCard: false,
      panelClass: '',
      loaded: true,
      masked: false,
      instanceId: uuid(),
      lastAction: null,
      iframeSrc: buildSrc(props.config.settings),
      iframeHeading: '',
      iframeClass: '',
      lockIcon: 'lock'
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var msg = function msg(message) {
    return new Promise(function (resolve) {
      resolve(ref.current.contentWindow.postMessage(message, domain));
    });
  };
  var handleInvalidInput = function handleInvalidInput(fn, messageId) {
    if (undefined !== messageId) {
      if (undefined === callbacks[messageId]) {
        callbacks[messageId] = {};
      }
      callbacks[messageId].invalidInputBack = fn;
    }
    return _this;
  };
  var responseHandler = function responseHandler(messageId, includeInvalid) {
    var obj = responseHandlerHelper(callbacks, handleInvalidInput, messageId);
    if (undefined !== includeInvalid && includeInvalid === true) {
      obj.invalidInput = function (fn) {
        return handleInvalidInput(fn, messageId);
      };
    }
    return obj;
  };
  var setMasked = function setMasked(maskedData, eToken) {
    var messageId = uuid();
    callbacks[messageId] = callbacks.template;
    var message = JSON.stringify({
      message_id: messageId,
      instance_id: state.instanceId,
      command: 'set_masked',
      masked_data: maskedData,
      eToken: eToken
    });
    msg(message).then(function () {
      return responseHandler(messageId, true);
    })["catch"](function () {
      return alert('uh oh');
    });
  };
  var settings = {
    loaded: function loaded() {},
    failure: function failure() {
      setStatus('BluefinIframeFailure');
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        invalidCard: true,
        loaded: true,
        panelClass: 'is-danger is-failure',
        iframeClass: '',
        iframeHeading: 'Invalid Payment Information',
        lastAction: 'failure'
      }));
    },
    success: function success(e) {
      setStatus('BluefinIframeSuccess');
      if (e.masked) {
        var presubmit = function presubmit() {
          return new Promise(function (resolve) {
            setMasked(e.masked, e.eToken);
            setFieldValue("payment", {});
            setFieldValue("payment.account", props.config.settings.account);
            if (method === 'CCP') {
              setFieldValue("payment.bluefinCC", {
                etoken: e.eToken,
                exp: e.masked.expy
              });
            }
            if (method === 'EFT') {
              setFieldValue("payment.bluefinEFT", {
                etoken: e.eToken
              });
            }
            setState(_objectSpread2(_objectSpread2({}, state), {}, {
              invalidCard: false,
              loaded: true,
              panelClass: 'is-success',
              iframeClass: '',
              lastAction: 'success'
            }));
            setTimeout(function () {
              resolve('resolved');
            }, 2000);
          });
        };
        var process = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return presubmit();
                case 2:
                  setFieldValue("formLogic.isPaypalPayment", false, false);
                  submitForm();
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function process() {
            return _ref2.apply(this, arguments);
          };
        }();
        process();
      }
    },
    invalidInput: function invalidInput() {
      setStatus('BluefinIframeInvalid');
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        invalidCard: true,
        loaded: true,
        panelClass: 'is-danger is-invalid',
        iframeClass: '',
        iframeHeading: 'Invalid Payment Information',
        lastAction: 'invalidInput'
      }));
    }
  };
  callbacks = {
    template: {
      errorBack: settings.failure,
      successBack: settings.success,
      invalidInputBack: settings.invalidInput
    }
  };
  var listener = function listener(event) {
    if (domain.indexOf(event.origin) === -1) {
      return;
    }
    var data = isJSON(event.data) ? JSON.parse(event.data) : event.data;
    if (state.instanceId !== data.instance_id) {
      return;
    }
    var errorBack = callbacks.template.errorBack;
    var successBack = callbacks.template.successBack;
    var invalidInputBack = callbacks.template.invalidInputBack;
    if (undefined !== callbacks[data.message_id]) {
      errorBack = callbacks[data.message_id].errorBack;
      successBack = callbacks[data.message_id].successBack;
      invalidInputBack = callbacks[data.message_id].invalidInputBack;
    }
    listenerHelper(data, errorBack, invalidInputBack, successBack, setSubmitting);
  };
  var encrypt = function encrypt() {
    setFieldValue('formLogic.isBluefinEncrypting', true, false);
    setStatus('BluefinEncrypting');
    var messageId = uuid();
    callbacks[messageId] = callbacks.template;
    var message = JSON.stringify({
      message_id: messageId,
      instance_id: state.instanceId,
      command: 'encrypt'
    });
    msg(message).then(function () {
      return responseHandler(messageId, true);
    })["catch"](function () {
      /* error */
    });
  };
  var processBtn = function processBtn() {
    // todo: validate against floodcontrol send entity data returning hash or error
    if (!hasErrors) {
      encrypt();
      trackDonationFunnel({
        paymentButtonClick: 'Y',
        values: values
      });
    }
  };
  var headingCreditCardText = (translations === null || translations === void 0 ? void 0 : translations.ccInfoText) || 'Credit Card Information';
  var headingCheckingText = (translations === null || translations === void 0 ? void 0 : translations.checkingInfoText) || 'Checking Account Information';
  var iframeLoaded = function iframeLoaded() {
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      loaded: true,
      iframeClass: '',
      lockIcon: 'lock',
      iframeHeading: props.type === 'CC' ? " ".concat(headingCreditCardText) : " ".concat(headingCheckingText),
      lastAction: 'iframeLoaded'
    }));
  };
  useEffect(function () {
    if (validateFields({
      values: values
    })) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : _values$collector2.entity]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    // Anything in here is fired on component mount.
    window.addEventListener('message', listener, false);
    setState(_objectSpread2(_objectSpread2({}, state), {}, {
      loaded: false,
      iframeClass: 'is-hidden',
      iframeHeading: 'Establishing Secure Payment Connection...',
      lockIcon: 'lock'
    }));
    setSubmitting(false);
    return function () {
      // Anything in here is fired on component unmount.
    };
  }, []);
  return {
    ackText: ackText,
    errorMessage: errorMessage,
    giftOffer: giftOffer,
    iframeLoaded: iframeLoaded,
    isEmbedSite: isEmbedSite,
    isSubmitting: isSubmitting,
    isDisabled: !isValid,
    privacyText: privacyText,
    processBtn: processBtn,
    ref: ref,
    showFormErrorScreen: showFormErrorScreen,
    showGiftOffer: showGiftOffer,
    state: state,
    status: status,
    totalAmount: totalAmount
  };
};

var useOrgRoles = function useOrgRoles(_ref) {
  var orgRoles = _ref.orgRoles;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var defaultRoles = {
    '': '',
    'ADMIN': t('Administrator', {
      ns: 'common'
    }),
    'CAMPUSPAST': t('Church Satellite Campus Pastor', {
      ns: 'common'
    }),
    'CAP': t('Associate Pastor', {
      ns: 'common'
    }),
    'CCP': t("Children's Pastor", {
      ns: 'common'
    }),
    'CHP': t('Chaplain', {
      ns: 'common'
    }),
    'CHURMEM': t('Church Member', {
      ns: 'common'
    }),
    'CSP': t('Senior Pastor', {
      ns: 'common'
    }),
    'CYP': t('Youth Pastor', {
      ns: 'common'
    }),
    'PASTOR': t('Pastor', {
      ns: 'common'
    }),
    'CHLEAD': t('Church Leader', {
      ns: 'common'
    })
  };
  useEffect(function () {
    if (orgRoles) {
      setFieldValue('collector.entity[1].orgs.role', '');
    }
  }, []);
  var optionsList = orgRoles ? convertOptionsToList(orgRoles) : convertOptionsToList(defaultRoles);
  return {
    optionsList: optionsList
  };
};

var _excluded$B = ["values"],
  _excluded2$1 = ["entity", "orgRoles", "orgType", "relationshipPath", "relationshipType", "setOrg", "showLangQuestion"];
var getFieldLabels = function getFieldLabels(_ref) {
  var values = _ref.values,
    props = _objectWithoutProperties(_ref, _excluded$B);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var churchLabel = (translations === null || translations === void 0 ? void 0 : translations.churchLabel) || t('Church Name', {
    ns: 'labels'
  });
  var roleLabel = (translations === null || translations === void 0 ? void 0 : translations.roleLabel) || t('What is your role?', {
    ns: 'labels'
  });
  var churchAddressLabel = (props === null || props === void 0 ? void 0 : props.churchAddressLabel) || (translations === null || translations === void 0 ? void 0 : translations.churchAddressLabel) || t('Church Address', {
    ns: 'labels'
  });
  churchAddressLabel = props !== null && props !== void 0 && props.hideChurchLabel ? '' : churchAddressLabel;
  var churchLangQuestionLabel = translations === null || translations === void 0 ? void 0 : translations.churchLangQuestionLabel;
  var phoneLabel = (translations === null || translations === void 0 ? void 0 : translations.churchPhoneLabel) || "".concat(t('Church Phone', {
    ns: 'labels'
  }));
  var denominationLabel = "".concat(t('Denomination', {
    ns: 'labels'
  }));
  var mobilePhoneLabel = (translations === null || translations === void 0 ? void 0 : translations.mobilePhoneLabel) || t('Mobile Phone Number', {
    ns: 'labels'
  });
  var attendanceLabel = (translations === null || translations === void 0 ? void 0 : translations.attendanceLabel) || "".concat(t('Average Sunday Morning Attendance', {
    ns: 'labels'
  }));
  var capacityLabel = (translations === null || translations === void 0 ? void 0 : translations.capacityLabel) || "".concat(t('Sanctuary Capacity', {
    ns: 'labels'
  }));
  return {
    attendanceLabel: attendanceLabel,
    capacityLabel: capacityLabel,
    churchAddressLabel: churchAddressLabel,
    churchLabel: churchLabel,
    churchLangQuestionLabel: churchLangQuestionLabel,
    denominationLabel: denominationLabel,
    mobilePhoneLabel: mobilePhoneLabel,
    phoneLabel: phoneLabel,
    roleLabel: roleLabel
  };
};
var useChurch = function useChurch(_ref2) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic3$ch, _values$formLogic3$ch2, _values$formLogic4, _values$formLogic4$sa, _values$formLogic4$sa2, _values$collector, _values$collector$ent, _values$collector$ent2;
  var entity = _ref2.entity,
    orgRoles = _ref2.orgRoles,
    orgType = _ref2.orgType,
    relationshipPath = _ref2.relationshipPath,
    relationshipType = _ref2.relationshipType,
    setOrg = _ref2.setOrg,
    showLangQuestion = _ref2.showLangQuestion,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useOrgRoles = useOrgRoles({
      orgRoles: orgRoles
    }),
    optionsList = _useOrgRoles.optionsList;
  var _getFieldLabels = getFieldLabels({
      values: values
    }),
    attendanceLabel = _getFieldLabels.attendanceLabel,
    capacityLabel = _getFieldLabels.capacityLabel,
    churchAddressLabel = _getFieldLabels.churchAddressLabel,
    churchLabel = _getFieldLabels.churchLabel,
    denominationLabel = _getFieldLabels.denominationLabel,
    churchLangQuestionLabel = _getFieldLabels.churchLangQuestionLabel,
    mobilePhoneLabel = _getFieldLabels.mobilePhoneLabel,
    phoneLabel = _getFieldLabels.phoneLabel,
    roleLabel = _getFieldLabels.roleLabel;
  var languageCode = (props === null || props === void 0 ? void 0 : props.languageCode) || 'DEFLANG';
  var langChurchQuestion = 'formLogic.langChurchQuestion';
  var orgRolesList = Array.isArray(orgRoles) ? _toConsumableArray(orgRoles) : optionsList;
  var churchLangQuestion = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.churchLangQuestion) || '';
  var city = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.city;
  var avgWeekendAttendance = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$ch = _values$formLogic3.churchAttendance) === null || _values$formLogic3$ch === void 0 ? void 0 : (_values$formLogic3$ch2 = _values$formLogic3$ch.orgs[entity]) === null || _values$formLogic3$ch2 === void 0 ? void 0 : _values$formLogic3$ch2.avgWeekendAttendance;
  var sanctuarySize = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : (_values$formLogic4$sa = _values$formLogic4.sanctuarySize) === null || _values$formLogic4$sa === void 0 ? void 0 : (_values$formLogic4$sa2 = _values$formLogic4$sa.orgs[entity]) === null || _values$formLogic4$sa2 === void 0 ? void 0 : _values$formLogic4$sa2.sanctuarySize;
  var resetArr = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[entity]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.key) !== languageCode;
  })) || [];
  var _getChurchFieldNames = getChurchFieldNames({
      entity: entity,
      props: props
    }),
    orgFieldName = _getChurchFieldNames.orgFieldName,
    orgRoleName = _getChurchFieldNames.orgRoleName,
    phoneName = _getChurchFieldNames.phoneName;
  useEffect(function () {
    if (avgWeekendAttendance) {
      var numericValue = avgWeekendAttendance === null || avgWeekendAttendance === void 0 ? void 0 : avgWeekendAttendance.replace(/[^0-9]/g, '');
      setFieldValue("formLogic.churchAttendance.orgs[".concat(entity, "].avgWeekendAttendance"), numericValue, false);
      setFieldValue("collector.entity[".concat(entity, "].orgs.avgWeekendAttendance"), Number(numericValue), false);
    }
  }, [avgWeekendAttendance]);
  useEffect(function () {
    if (sanctuarySize) {
      var numericValue = sanctuarySize === null || sanctuarySize === void 0 ? void 0 : sanctuarySize.replace(/[^0-9]/g, '');
      setFieldValue("formLogic.sanctuarySize.orgs[".concat(entity, "].sanctuarySize"), numericValue, false);
      setFieldValue("collector.entity[".concat(entity, "].orgs.sanctuarySize"), Number(numericValue), false);
    }
  }, [sanctuarySize]);
  useEffect(function () {
    var _values$collector2, _values$collector2$en;
    if (churchLangQuestion === Language.SPANISH) {
      var codes = [].concat(_toConsumableArray(resetArr), [{
        key: languageCode,
        value: 'ES'
      }]);
      setFieldValue("collector.entity[".concat(entity, "].code"), codes);
    } else if (values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[entity]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.code) {
      setFieldValue("collector.entity[".concat(entity, "].code"), resetArr);
    }
  }, [churchLangQuestion]);
  useEffect(function () {
    if (city) {
      var codes = getChurchCodes(city, entity, values);
      setFieldValue("collector.entity[".concat(entity, "].code"), codes);
    }
  }, [city]);
  useEffect(function () {
    setDefaultValues(_objectSpread2({
      entity: entity,
      langChurchQuestion: langChurchQuestion,
      orgType: orgType,
      relationshipPath: relationshipPath,
      relationshipType: relationshipType,
      setOrg: setOrg,
      showLangQuestion: showLangQuestion,
      setFieldValue: setFieldValue
    }, props));
  }, []);
  return {
    attendanceLabel: attendanceLabel,
    capacityLabel: capacityLabel,
    churchAddressLabel: churchAddressLabel,
    churchLabel: churchLabel,
    churchLangQuestionLabel: churchLangQuestionLabel,
    denominationLabel: denominationLabel,
    mobilePhoneLabel: mobilePhoneLabel,
    phoneName: phoneName,
    orgFieldName: orgFieldName,
    orgRoleName: orgRoleName,
    orgRolesList: orgRolesList,
    phoneLabel: phoneLabel,
    roleLabel: roleLabel,
    values: values
  };
};

var CountryRegion = [{
  countryName: 'Afghanistan',
  countryShortCode: 'AF',
  regions: [{
    name: 'Badakhshan',
    shortCode: 'BDS'
  }, {
    name: 'Badghis',
    shortCode: 'BDG'
  }, {
    name: 'Baghlan',
    shortCode: 'BGL'
  }, {
    name: 'Balkh',
    shortCode: 'BAL'
  }, {
    name: 'Bamyan',
    shortCode: 'BAM'
  }, {
    name: 'Daykundi',
    shortCode: 'DAY'
  }, {
    name: 'Farah',
    shortCode: 'FRA'
  }, {
    name: 'Faryab',
    shortCode: 'FYB'
  }, {
    name: 'Ghazni',
    shortCode: 'GHA'
  }, {
    name: 'Ghor',
    shortCode: 'GHO'
  }, {
    name: 'Helmand',
    shortCode: 'HEL'
  }, {
    name: 'Herat',
    shortCode: 'HER'
  }, {
    name: 'Jowzjan',
    shortCode: 'JOW'
  }, {
    name: 'Kabul',
    shortCode: 'KAB'
  }, {
    name: 'Kandahar',
    shortCode: 'KAN'
  }, {
    name: 'Kapisa',
    shortCode: 'KAP'
  }, {
    name: 'Khost',
    shortCode: 'KHO'
  }, {
    name: 'Kunar',
    shortCode: 'KNR'
  }, {
    name: 'Kunduz',
    shortCode: 'KDZ'
  }, {
    name: 'Laghman',
    shortCode: 'LAG'
  }, {
    name: 'Logar',
    shortCode: 'LOW'
  }, {
    name: 'Maidan Wardak',
    shortCode: 'WAR'
  }, {
    name: 'Nangarhar',
    shortCode: 'NAN'
  }, {
    name: 'Nimruz',
    shortCode: 'NIM'
  }, {
    name: 'Nuristan',
    shortCode: 'NUR'
  }, {
    name: 'Paktia',
    shortCode: 'PIA'
  }, {
    name: 'Paktika',
    shortCode: 'PKA'
  }, {
    name: 'Panjshir',
    shortCode: 'PAN'
  }, {
    name: 'Parwan',
    shortCode: 'PAR'
  }, {
    name: 'Samangan',
    shortCode: 'SAM'
  }, {
    name: 'Sar-e Pol',
    shortCode: 'SAR'
  }, {
    name: 'Takhar',
    shortCode: 'TAK'
  }, {
    name: 'Urozgan',
    shortCode: 'ORU'
  }, {
    name: 'Zabul',
    shortCode: 'ZAB'
  }]
}, {
  countryName: 'Åland Islands',
  countryShortCode: 'AX',
  regions: [{
    name: 'Brändö',
    shortCode: 'BR'
  }, {
    name: 'Eckerö',
    shortCode: 'EC'
  }, {
    name: 'Finström',
    shortCode: 'FN'
  }, {
    name: 'Föglö',
    shortCode: 'FG'
  }, {
    name: 'Geta',
    shortCode: 'GT'
  }, {
    name: 'Hammarland',
    shortCode: 'HM'
  }, {
    name: 'Jomala',
    shortCode: 'JM'
  }, {
    name: 'Kumlinge',
    shortCode: 'KM'
  }, {
    name: 'Kökar',
    shortCode: 'KK'
  }, {
    name: 'Lemland',
    shortCode: 'LE'
  }, {
    name: 'Lumparland',
    shortCode: 'LU'
  }, {
    name: 'Mariehamn',
    shortCode: 'MH'
  }, {
    name: 'Saltvik',
    shortCode: 'SV'
  }, {
    name: 'Sottunga',
    shortCode: 'ST'
  }, {
    name: 'Sund',
    shortCode: 'SD'
  }, {
    name: 'Vårdö',
    shortCode: 'VR'
  }]
}, {
  countryName: 'Albania',
  countryShortCode: 'AL',
  regions: [{
    name: 'Berat',
    shortCode: '01'
  }, {
    name: 'Dibër',
    shortCode: '09'
  }, {
    name: 'Durrës',
    shortCode: '02'
  }, {
    name: 'Elbasan',
    shortCode: '03'
  }, {
    name: 'Fier',
    shortCode: '04'
  }, {
    name: 'Gjirokastër',
    shortCode: '05'
  }, {
    name: 'Korçë',
    shortCode: '06'
  }, {
    name: 'Kukës',
    shortCode: '07'
  }, {
    name: 'Lezhë',
    shortCode: '08'
  }, {
    name: 'Shkodër',
    shortCode: '10'
  }, {
    name: 'Tirana',
    shortCode: '11'
  }, {
    name: 'Vlorë',
    shortCode: '12'
  }]
}, {
  countryName: 'Algeria',
  countryShortCode: 'DZ',
  regions: [{
    name: 'Adrar',
    shortCode: '01'
  }, {
    name: 'Aïn Defla',
    shortCode: '44'
  }, {
    name: 'Aïn Témouchent',
    shortCode: '46'
  }, {
    name: 'Algiers',
    shortCode: '16'
  }, {
    name: 'Annaba',
    shortCode: '23'
  }, {
    name: 'Batna',
    shortCode: '05'
  }, {
    name: 'Béchar',
    shortCode: '08'
  }, {
    name: 'Béjaïa',
    shortCode: '06'
  }, {
    name: 'Biskra',
    shortCode: '07'
  }, {
    name: 'Blida',
    shortCode: '09'
  }, {
    name: 'Bordj Bou Arréridj',
    shortCode: '34'
  }, {
    name: 'Bouïra',
    shortCode: '10'
  }, {
    name: 'Boumerdès',
    shortCode: '35'
  }, {
    name: 'Chlef',
    shortCode: '02'
  }, {
    name: 'Constantine',
    shortCode: '25'
  }, {
    name: 'Djelfa',
    shortCode: '17'
  }, {
    name: 'El Bayadh',
    shortCode: '32'
  }, {
    name: 'El Oued',
    shortCode: '39'
  }, {
    name: 'El Tarf',
    shortCode: '36'
  }, {
    name: 'Ghardaïa',
    shortCode: '47'
  }, {
    name: 'Guelma',
    shortCode: '24'
  }, {
    name: 'Illizi',
    shortCode: '33'
  }, {
    name: 'Jijel',
    shortCode: '18'
  }, {
    name: 'Khenchela',
    shortCode: '40'
  }, {
    name: 'Laghouat',
    shortCode: '03'
  }, {
    name: 'Mascara',
    shortCode: '29'
  }, {
    name: 'Médéa',
    shortCode: '26'
  }, {
    name: 'Mila',
    shortCode: '43'
  }, {
    name: 'Mostaganem',
    shortCode: '27'
  }, {
    name: 'Msila',
    shortCode: '28'
  }, {
    name: 'Naâma',
    shortCode: '45'
  }, {
    name: 'Oran',
    shortCode: '31'
  }, {
    name: 'Ouargla',
    shortCode: '30'
  }, {
    name: 'Oum el Bouaghi',
    shortCode: '04'
  }, {
    name: 'Relizane',
    shortCode: '48'
  }, {
    name: 'Saïda',
    shortCode: '20'
  }, {
    name: 'Sétif',
    shortCode: '19'
  }, {
    name: 'Sidi Bel Abbès',
    shortCode: '22'
  }, {
    name: 'Skikda',
    shortCode: '21'
  }, {
    name: 'Souk Ahras',
    shortCode: '41'
  }, {
    name: 'Tamanghasset',
    shortCode: '11'
  }, {
    name: 'Tébessa',
    shortCode: '12'
  }, {
    name: 'Tiaret',
    shortCode: '14'
  }, {
    name: 'Tindouf',
    shortCode: '37'
  }, {
    name: 'Tipaza',
    shortCode: '42'
  }, {
    name: 'Tissemsilt',
    shortCode: '38'
  }, {
    name: 'Tizi Ouzou',
    shortCode: '15'
  }, {
    name: 'Tlemcen',
    shortCode: '13'
  }]
}, {
  countryName: 'American Samoa',
  countryShortCode: 'AS',
  regions: [{
    name: 'Tutuila',
    shortCode: '01'
  }, {
    name: "Aunu'u",
    shortCode: '02'
  }, {
    name: "Ta'ū",
    shortCode: '03'
  }, {
    name: 'Ofu‑Olosega',
    shortCode: '04'
  }, {
    name: 'Rose Atoll',
    shortCode: '21'
  }, {
    name: 'Swains Island',
    shortCode: '22'
  }]
}, {
  countryName: 'Andorra',
  countryShortCode: 'AD',
  regions: [{
    name: 'Andorra la Vella',
    shortCode: '07'
  }, {
    name: 'Canillo',
    shortCode: '02'
  }, {
    name: 'Encamp',
    shortCode: '03'
  }, {
    name: 'Escaldes-Engordany',
    shortCode: '08'
  }, {
    name: 'La Massana',
    shortCode: '04'
  }, {
    name: 'Ordino',
    shortCode: '05'
  }, {
    name: 'Sant Julià de Lòria',
    shortCode: '06'
  }]
}, {
  countryName: 'Angola',
  countryShortCode: 'AO',
  regions: [{
    name: 'Bengo',
    shortCode: 'BGO'
  }, {
    name: 'Benguela',
    shortCode: 'BGU'
  }, {
    name: 'Bié',
    shortCode: 'BIE'
  }, {
    name: 'Cabinda',
    shortCode: 'CAB'
  }, {
    name: 'Cuando Cubango',
    shortCode: 'CCU'
  }, {
    name: 'Cuanza Norte',
    shortCode: 'CNO'
  }, {
    name: 'Cuanza Sul',
    shortCode: 'CUS'
  }, {
    name: 'Cunene',
    shortCode: 'CNN'
  }, {
    name: 'Huambo',
    shortCode: 'HUA'
  }, {
    name: 'Huíla',
    shortCode: 'HUI'
  }, {
    name: 'Luanda',
    shortCode: 'LUA'
  }, {
    name: 'Lunda Norte',
    shortCode: 'LNO'
  }, {
    name: 'Lunda Sul',
    shortCode: 'LSU'
  }, {
    name: 'Malanje',
    shortCode: 'MAL'
  }, {
    name: 'Moxico',
    shortCode: 'MOX'
  }, {
    name: 'Namibe',
    shortCode: 'NAM'
  }, {
    name: 'Uíge',
    shortCode: 'UIG'
  }, {
    name: 'Zaire',
    shortCode: 'ZAI'
  }]
}, {
  countryName: 'Anguilla',
  countryShortCode: 'AI',
  regions: [{
    name: 'Anguilla',
    shortCode: '01'
  }, {
    name: 'Anguillita Island',
    shortCode: '02'
  }, {
    name: 'Blowing Rock',
    shortCode: '03'
  }, {
    name: 'Cove Cay',
    shortCode: '04'
  }, {
    name: 'Crocus Cay',
    shortCode: '05'
  }, {
    name: "Deadman's Cay",
    shortCode: '06'
  }, {
    name: 'Dog Island',
    shortCode: '07'
  }, {
    name: 'East Cay',
    shortCode: '08'
  }, {
    name: 'Little Island',
    shortCode: '09'
  }, {
    name: 'Little Scrub Island',
    shortCode: '10'
  }, {
    name: 'Mid Cay',
    shortCode: '11'
  }, {
    name: 'North Cay',
    shortCode: '12'
  }, {
    name: 'Prickly Pear Cays',
    shortCode: '13'
  }, {
    name: 'Rabbit Island',
    shortCode: '14'
  }, {
    name: 'Sandy Island/Sand Island',
    shortCode: '15'
  }, {
    name: 'Scilly Cay',
    shortCode: '16'
  }, {
    name: 'Scrub Island',
    shortCode: '17'
  }, {
    name: 'Seal Island',
    shortCode: '18'
  }, {
    name: 'Sombrero/Hat Island',
    shortCode: '19'
  }, {
    name: 'South Cay',
    shortCode: '20'
  }, {
    name: 'South Wager Island',
    shortCode: '21'
  }, {
    name: 'West Cay',
    shortCode: '22'
  }]
}, {
  countryName: 'Antarctica',
  countryShortCode: 'AQ',
  regions: [{
    name: 'Antarctica',
    shortCode: 'AQ'
  }]
}, {
  countryName: 'Antigua and Barbuda',
  countryShortCode: 'AG',
  regions: [{
    name: 'Antigua Island',
    shortCode: '01'
  }, {
    name: 'Barbuda Island',
    shortCode: '02'
  }, {
    name: 'Bird Island',
    shortCode: '04'
  }, {
    name: 'Bishop Island',
    shortCode: '05'
  }, {
    name: 'Blake Island',
    shortCode: '06'
  }, {
    name: 'Crump Island',
    shortCode: '09'
  }, {
    name: 'Dulcina Island',
    shortCode: '10'
  }, {
    name: 'Exchange Island',
    shortCode: '11'
  }, {
    name: 'Five Islands',
    shortCode: '12'
  }, {
    name: 'Great Bird Island',
    shortCode: '13'
  }, {
    name: 'Green Island',
    shortCode: '14'
  }, {
    name: 'Guiana Island',
    shortCode: '15'
  }, {
    name: 'Hawes Island',
    shortCode: '17'
  }, {
    name: 'Hells Gate Island',
    shortCode: '16'
  }, {
    name: 'Henry Island',
    shortCode: '18'
  }, {
    name: 'Johnson Island',
    shortCode: '19'
  }, {
    name: 'Kid Island',
    shortCode: '20'
  }, {
    name: 'Lobster Island',
    shortCode: '22'
  }, {
    name: 'Maiden Island',
    shortCode: '24'
  }, {
    name: 'Moor Island',
    shortCode: '25'
  }, {
    name: 'Nanny Island',
    shortCode: '26'
  }, {
    name: 'Pelican Island',
    shortCode: '27'
  }, {
    name: 'Prickly Pear Island',
    shortCode: '28'
  }, {
    name: 'Rabbit Island',
    shortCode: '29'
  }, {
    name: 'Red Head Island',
    shortCode: '31'
  }, {
    name: 'Redonda Island',
    shortCode: '03'
  }, {
    name: 'Sandy Island',
    shortCode: '32'
  }, {
    name: 'Smith Island',
    shortCode: '33'
  }, {
    name: 'The Sisters',
    shortCode: '34'
  }, {
    name: 'Vernon Island',
    shortCode: '35'
  }, {
    name: 'Wicked Will Island',
    shortCode: '36'
  }, {
    name: 'York Island',
    shortCode: '37'
  }]
}, {
  countryName: 'Argentina',
  countryShortCode: 'AR',
  regions: [{
    name: 'Buenos Aires',
    shortCode: 'B'
  }, {
    name: 'Capital Federal',
    shortCode: 'C'
  }, {
    name: 'Catamarca',
    shortCode: 'K'
  }, {
    name: 'Chaco',
    shortCode: 'H'
  }, {
    name: 'Chubut',
    shortCode: 'U'
  }, {
    name: 'Córdoba',
    shortCode: 'X'
  }, {
    name: 'Corrientes',
    shortCode: 'W'
  }, {
    name: 'Entre Ríos',
    shortCode: 'E'
  }, {
    name: 'Formosa',
    shortCode: 'P'
  }, {
    name: 'Jujuy',
    shortCode: 'Y'
  }, {
    name: 'La Pampa',
    shortCode: 'L'
  }, {
    name: 'La Rioja',
    shortCode: 'F'
  }, {
    name: 'Mendoza',
    shortCode: 'M'
  }, {
    name: 'Misiones',
    shortCode: 'N'
  }, {
    name: 'Neuquén',
    shortCode: 'Q'
  }, {
    name: 'Río Negro',
    shortCode: 'R'
  }, {
    name: 'Salta',
    shortCode: 'A'
  }, {
    name: 'San Juan',
    shortCode: 'J'
  }, {
    name: 'San Luis',
    shortCode: 'D'
  }, {
    name: 'Santa Cruz',
    shortCode: 'Z'
  }, {
    name: 'Santa Fe',
    shortCode: 'S'
  }, {
    name: 'Santiago del Estero',
    shortCode: 'G'
  }, {
    name: 'Tierra del Fuego',
    shortCode: 'V'
  }, {
    name: 'Tucumán',
    shortCode: 'T'
  }]
}, {
  countryName: 'Armenia',
  countryShortCode: 'AM',
  regions: [{
    name: 'Aragatsotn',
    shortCode: 'AG'
  }, {
    name: 'Ararat',
    shortCode: 'AR'
  }, {
    name: 'Armavir',
    shortCode: 'AV'
  }, {
    name: 'Gegharkunik',
    shortCode: 'GR'
  }, {
    name: 'Kotayk',
    shortCode: 'KT'
  }, {
    name: 'Lori',
    shortCode: 'LO'
  }, {
    name: 'Shirak',
    shortCode: 'SH'
  }, {
    name: 'Syunik',
    shortCode: 'SU'
  }, {
    name: 'Tavush',
    shortCode: 'TV'
  }, {
    name: 'Vayots Dzor',
    shortCode: 'VD'
  }, {
    name: 'Yerevan',
    shortCode: 'ER'
  }]
}, {
  countryName: 'Aruba',
  countryShortCode: 'AW',
  regions: [{
    name: 'Aruba',
    shortCode: 'AW'
  }]
}, {
  countryName: 'Australia',
  countryShortCode: 'AU',
  regions: [{
    name: 'Australian Capital Territory',
    shortCode: 'ACT'
  }, {
    name: 'New South Wales',
    shortCode: 'NSW'
  }, {
    name: 'Northern Territory',
    shortCode: 'NT'
  }, {
    name: 'Queensland',
    shortCode: 'QLD'
  }, {
    name: 'South Australia',
    shortCode: 'SA'
  }, {
    name: 'Tasmania',
    shortCode: 'TAS'
  }, {
    name: 'Victoria',
    shortCode: 'VIC'
  }, {
    name: 'Western Australia',
    shortCode: 'WA'
  }]
}, {
  countryName: 'Austria',
  countryShortCode: 'AT',
  regions: [{
    name: 'Burgenland',
    shortCode: '1'
  }, {
    name: 'Kärnten',
    shortCode: '2'
  }, {
    name: 'Niederösterreich',
    shortCode: '3'
  }, {
    name: 'Oberösterreich',
    shortCode: '4'
  }, {
    name: 'Salzburg',
    shortCode: '5'
  }, {
    name: 'Steiermark',
    shortCode: '6'
  }, {
    name: 'Tirol',
    shortCode: '7'
  }, {
    name: 'Vorarlberg',
    shortCode: '8'
  }, {
    name: 'Wien',
    shortCode: '9'
  }]
}, {
  countryName: 'Azerbaijan',
  countryShortCode: 'AZ',
  regions: [{
    name: 'Abşeron',
    shortCode: 'ABS'
  }, {
    name: 'Ağcabədi',
    shortCode: 'AGC'
  }, {
    name: 'Ağdam',
    shortCode: 'AGM'
  }, {
    name: 'Ağdaş',
    shortCode: 'AGS'
  }, {
    name: 'Ağstafa',
    shortCode: 'AGA'
  }, {
    name: 'Ağsu',
    shortCode: 'AGU'
  }, {
    name: 'Astara',
    shortCode: 'AST'
  }, {
    name: 'Bakı',
    shortCode: 'BAK'
  }, {
    name: 'Babək',
    shortCode: 'BAB'
  }, {
    name: 'Balakən',
    shortCode: 'BAL'
  }, {
    name: 'Bərdə',
    shortCode: 'BAR'
  }, {
    name: 'Beyləqan',
    shortCode: 'BEY'
  }, {
    name: 'Biləsuvar',
    shortCode: 'BIL'
  }, {
    name: 'Cəbrayıl',
    shortCode: 'CAB'
  }, {
    name: 'Cəlilabad',
    shortCode: 'CAL'
  }, {
    name: 'Culfa',
    shortCode: 'CUL'
  }, {
    name: 'Daşkəsən',
    shortCode: 'DAS'
  }, {
    name: 'Füzuli',
    shortCode: 'FUZ'
  }, {
    name: 'Gədəbəy',
    shortCode: 'GAD'
  }, {
    name: 'Goranboy',
    shortCode: 'GOR'
  }, {
    name: 'Göyçay',
    shortCode: 'GOY'
  }, {
    name: 'Göygöl',
    shortCode: 'GYG'
  }, {
    name: 'Hacıqabul',
    shortCode: 'HAC'
  }, {
    name: 'İmişli',
    shortCode: 'IMI'
  }, {
    name: 'İsmayıllı',
    shortCode: 'ISM'
  }, {
    name: 'Kəlbəcər',
    shortCode: 'KAL'
  }, {
    name: 'Kǝngǝrli',
    shortCode: 'KAN'
  }, {
    name: 'Kürdəmir',
    shortCode: 'KUR'
  }, {
    name: 'Laçın',
    shortCode: 'LAC'
  }, {
    name: 'Lənkəran',
    shortCode: 'LAN'
  }, {
    name: 'Lerik',
    shortCode: 'LER'
  }, {
    name: 'Masallı',
    shortCode: 'MAS'
  }, {
    name: 'Neftçala',
    shortCode: 'NEF'
  }, {
    name: 'Oğuz',
    shortCode: 'OGU'
  }, {
    name: 'Ordubad',
    shortCode: 'ORD'
  }, {
    name: 'Qəbələ',
    shortCode: 'QAB'
  }, {
    name: 'Qax',
    shortCode: 'QAX'
  }, {
    name: 'Qazax',
    shortCode: 'QAZ'
  }, {
    name: 'Qobustan',
    shortCode: 'QOB'
  }, {
    name: 'Quba',
    shortCode: 'QBA'
  }, {
    name: 'Qubadli',
    shortCode: 'QBI'
  }, {
    name: 'Qusar',
    shortCode: 'QUS'
  }, {
    name: 'Saatlı',
    shortCode: 'SAT'
  }, {
    name: 'Sabirabad',
    shortCode: 'SAB'
  }, {
    name: 'Şabran',
    shortCode: 'SBN'
  }, {
    name: 'Sədərək',
    shortCode: 'SAD'
  }, {
    name: 'Şahbuz',
    shortCode: 'SAH'
  }, {
    name: 'Şəki',
    shortCode: 'SAK'
  }, {
    name: 'Salyan',
    shortCode: 'SAL'
  }, {
    name: 'Şamaxı',
    shortCode: 'SMI'
  }, {
    name: 'Şəmkir',
    shortCode: 'SKR'
  }, {
    name: 'Samux',
    shortCode: 'SMX'
  }, {
    name: 'Şərur',
    shortCode: 'SAR'
  }, {
    name: 'Siyəzən',
    shortCode: 'SIY'
  }, {
    name: 'Şuşa',
    shortCode: 'SUS'
  }, {
    name: 'Tərtər',
    shortCode: 'TAR'
  }, {
    name: 'Tovuz',
    shortCode: 'TOV'
  }, {
    name: 'Ucar',
    shortCode: 'UCA'
  }, {
    name: 'Xaçmaz',
    shortCode: 'XAC'
  }, {
    name: 'Xızı',
    shortCode: 'XIZ'
  }, {
    name: 'Xocalı',
    shortCode: 'XCI'
  }, {
    name: 'Xocavənd',
    shortCode: 'XVD'
  }, {
    name: 'Yardımlı',
    shortCode: 'YAR'
  }, {
    name: 'Yevlax',
    shortCode: 'YEV'
  }, {
    name: 'Zəngilan',
    shortCode: 'ZAN'
  }, {
    name: 'Zaqatala',
    shortCode: 'ZAQ'
  }, {
    name: 'Zərdab',
    shortCode: 'ZAR'
  }]
}, {
  countryName: 'Bahamas',
  countryShortCode: 'BS',
  regions: [{
    name: 'Acklins Island',
    shortCode: '01'
  }, {
    name: 'Berry Islands',
    shortCode: '22'
  }, {
    name: 'Bimini',
    shortCode: '02'
  }, {
    name: 'Black Point',
    shortCode: '23'
  }, {
    name: 'Cat Island',
    shortCode: '03'
  }, {
    name: 'Central Abaco',
    shortCode: '24'
  }, {
    name: 'Crooked Island and Long Cay',
    shortCode: '28'
  }, {
    name: 'East Grand Bahama',
    shortCode: '29'
  }, {
    name: 'Exuma',
    shortCode: '04'
  }, {
    name: 'Freeport',
    shortCode: '05'
  }, {
    name: 'Fresh Creek',
    shortCode: '06'
  }, {
    name: "Governor's Harbour",
    shortCode: '07'
  }, {
    name: 'Green Turtle Cay',
    shortCode: '08'
  }, {
    name: 'Harbour Island',
    shortCode: '09'
  }, {
    name: 'High Rock',
    shortCode: '10'
  }, {
    name: 'Inagua',
    shortCode: '11'
  }, {
    name: 'Kemps Bay',
    shortCode: '12'
  }, {
    name: 'Long Island',
    shortCode: '13'
  }, {
    name: 'Marsh Harbour',
    shortCode: '14'
  }, {
    name: 'Mayaguana',
    shortCode: '15'
  }, {
    name: 'Moore’s Island',
    shortCode: '40'
  }, {
    name: 'New Providence',
    shortCode: '16'
  }, {
    name: 'Nichollstown and Berry Islands',
    shortCode: '17'
  }, {
    name: 'North Abaco',
    shortCode: '42'
  }, {
    name: 'North Andros',
    shortCode: '41'
  }, {
    name: 'North Eleuthera',
    shortCode: '33'
  }, {
    name: 'Ragged Island',
    shortCode: '18'
  }, {
    name: 'Rock Sound',
    shortCode: '19'
  }, {
    name: 'San Salvador and Rum Cay',
    shortCode: '20'
  }, {
    name: 'Sandy Point',
    shortCode: '21'
  }, {
    name: 'South Abaco',
    shortCode: '35'
  }, {
    name: 'South Andros',
    shortCode: '36'
  }, {
    name: 'South Eleuthera',
    shortCode: '37'
  }, {
    name: 'West Grand Bahama',
    shortCode: '39'
  }]
}, {
  countryName: 'Bahrain',
  countryShortCode: 'BH',
  regions: [{
    name: 'Al Janūbīyah',
    shortCode: '14'
  }, {
    name: 'Al Manāmah',
    shortCode: '13'
  }, {
    name: 'Al Muḩarraq',
    shortCode: '15'
  }, {
    name: 'Al Wusţá',
    shortCode: '16'
  }, {
    name: 'Ash Shamālīyah',
    shortCode: '17'
  }]
}, {
  countryName: 'Bangladesh',
  countryShortCode: 'BD',
  regions: [{
    name: 'Barisal',
    shortCode: 'A'
  }, {
    name: 'Chittagong',
    shortCode: 'B'
  }, {
    name: 'Dhaka',
    shortCode: 'C'
  }, {
    name: 'Khulna',
    shortCode: 'D'
  }, {
    name: 'Mymensingh',
    shortCode: 'M'
  }, {
    name: 'Rajshahi',
    shortCode: 'E'
  }, {
    name: 'Rangpur',
    shortCode: 'F'
  }, {
    name: 'Sylhet',
    shortCode: 'G'
  }]
}, {
  countryName: 'Barbados',
  countryShortCode: 'BB',
  regions: [{
    name: 'Christ Church',
    shortCode: '01'
  }, {
    name: 'Saint Andrew',
    shortCode: '02'
  }, {
    name: 'Saint George',
    shortCode: '03'
  }, {
    name: 'Saint James',
    shortCode: '04'
  }, {
    name: 'Saint John',
    shortCode: '05'
  }, {
    name: 'Saint Joseph',
    shortCode: '06'
  }, {
    name: 'Saint Lucy',
    shortCode: '07'
  }, {
    name: 'Saint Michael',
    shortCode: '08'
  }, {
    name: 'Saint Peter',
    shortCode: '09'
  }, {
    name: 'Saint Philip',
    shortCode: '10'
  }, {
    name: 'Saint Thomas',
    shortCode: '11'
  }]
}, {
  countryName: 'Belarus',
  countryShortCode: 'BY',
  regions: [{
    name: 'Brest voblast',
    shortCode: 'BR'
  }, {
    name: 'Gorod Minsk',
    shortCode: 'HM'
  }, {
    name: 'Homiel voblast',
    shortCode: 'HO'
  }, {
    name: 'Hrodna voblast',
    shortCode: 'HR'
  }, {
    name: 'Mahilyow voblast',
    shortCode: 'MA'
  }, {
    name: 'Minsk voblast',
    shortCode: 'MI'
  }, {
    name: 'Vitsebsk voblast',
    shortCode: 'VI'
  }]
}, {
  countryName: 'Belgium',
  countryShortCode: 'BE',
  regions: [{
    name: 'Brussels',
    shortCode: 'BRU'
  }, {
    name: 'Flanders',
    shortCode: 'VLG'
  }, {
    name: 'Wallonia',
    shortCode: 'WAL'
  }]
}, {
  countryName: 'Belize',
  countryShortCode: 'BZ',
  regions: [{
    name: 'Belize District',
    shortCode: 'BZ'
  }, {
    name: 'Cayo District',
    shortCode: 'CY'
  }, {
    name: 'Corozal District',
    shortCode: 'CZL'
  }, {
    name: 'Orange Walk District',
    shortCode: 'OW'
  }, {
    name: 'Stann Creek District',
    shortCode: 'SC'
  }, {
    name: 'Toledo District',
    shortCode: 'TOL'
  }]
}, {
  countryName: 'Benin',
  countryShortCode: 'BJ',
  regions: [{
    name: 'Alibori',
    shortCode: 'AL'
  }, {
    name: 'Atakora',
    shortCode: 'AK'
  }, {
    name: 'Atlantique',
    shortCode: 'AQ'
  }, {
    name: 'Borgou',
    shortCode: 'BO'
  }, {
    name: 'Collines Department',
    shortCode: 'CO'
  }, {
    name: 'Donga',
    shortCode: 'DO'
  }, {
    name: 'Kouffo',
    shortCode: 'KO'
  }, {
    name: 'Littoral Department',
    shortCode: 'LI'
  }, {
    name: 'Mono Department',
    shortCode: 'MO'
  }, {
    name: 'Ouémé',
    shortCode: 'OU'
  }, {
    name: 'Plateau',
    shortCode: 'PL'
  }, {
    name: 'Zou',
    shortCode: 'ZO'
  }]
}, {
  countryName: 'Bermuda',
  countryShortCode: 'BM',
  regions: [{
    name: 'City of Hamilton',
    shortCode: '03'
  }, {
    name: 'Devonshire Parish',
    shortCode: '01'
  }, {
    name: 'Hamilton Parish',
    shortCode: '02'
  }, {
    name: 'Paget Parish',
    shortCode: '04'
  }, {
    name: 'Pembroke Parish',
    shortCode: '05'
  }, {
    name: 'Sandys Parish',
    shortCode: '08'
  }, {
    name: "Smith's Parish",
    shortCode: '09'
  }, {
    name: 'Southampton Parish',
    shortCode: '10'
  }, {
    name: "St. George's Parish",
    shortCode: '07'
  }, {
    name: 'Town of St. George',
    shortCode: '06'
  }, {
    name: 'Warwick Parish',
    shortCode: '11'
  }]
}, {
  countryName: 'Bhutan',
  countryShortCode: 'BT',
  regions: [{
    name: 'Bumthang',
    shortCode: '33'
  }, {
    name: 'Chhukha',
    shortCode: '12'
  }, {
    name: 'Dagana',
    shortCode: '22'
  }, {
    name: 'Gasa',
    shortCode: 'GA'
  }, {
    name: 'Haa',
    shortCode: '13'
  }, {
    name: 'Lhuntse',
    shortCode: '44'
  }, {
    name: 'Mongar',
    shortCode: '42'
  }, {
    name: 'Paro',
    shortCode: '11'
  }, {
    name: 'Pemagatshel',
    shortCode: '43'
  }, {
    name: 'Punakha',
    shortCode: '23'
  }, {
    name: 'Samdrup Jongkhar',
    shortCode: '45'
  }, {
    name: 'Samtse',
    shortCode: '14'
  }, {
    name: 'Sarpang',
    shortCode: '31'
  }, {
    name: 'Thimphu',
    shortCode: '15'
  }, {
    name: 'Trashigang',
    shortCode: '41'
  }, {
    name: 'Trashiyangtse',
    shortCode: 'TY'
  }, {
    name: 'Trongsa',
    shortCode: '32'
  }, {
    name: 'Tsirang',
    shortCode: '21'
  }, {
    name: 'Wangdue Phodrang',
    shortCode: '24'
  }, {
    name: 'Zhemgang',
    shortCode: '34'
  }]
}, {
  countryName: 'Bolivia',
  countryShortCode: 'BO',
  regions: [{
    name: 'Beni',
    shortCode: 'B'
  }, {
    name: 'Chuquisaca',
    shortCode: 'H'
  }, {
    name: 'Cochabamba',
    shortCode: 'C'
  }, {
    name: 'La Paz',
    shortCode: 'L'
  }, {
    name: 'Oruro',
    shortCode: 'O'
  }, {
    name: 'Pando',
    shortCode: 'N'
  }, {
    name: 'Potosí',
    shortCode: 'P'
  }, {
    name: 'Santa Cruz',
    shortCode: 'S'
  }, {
    name: 'Tarija',
    shortCode: 'T'
  }]
}, {
  countryName: 'Bonaire, Sint Eustatius and Saba',
  countryShortCode: 'BQ',
  regions: [{
    name: 'Bonaire',
    shortCode: 'BO'
  }, {
    name: 'Saba Isand',
    shortCode: 'SA'
  }, {
    name: 'Sint Eustatius',
    shortCode: 'SE'
  }]
}, {
  countryName: 'Bosnia and Herzegovina',
  countryShortCode: 'BA',
  regions: [{
    name: 'Brčko Distrikt',
    shortCode: 'BRC'
  }, {
    name: 'Federacija Bosne i Hercegovine',
    shortCode: 'BIH'
  }, {
    name: 'Republika Srpska',
    shortCode: 'SRP'
  }]
}, {
  countryName: 'Botswana',
  countryShortCode: 'BW',
  regions: [{
    name: 'Central',
    shortCode: 'CE'
  }, {
    name: 'Ghanzi',
    shortCode: 'GH'
  }, {
    name: 'Kgalagadi',
    shortCode: 'KG'
  }, {
    name: 'Kgatleng',
    shortCode: 'KL'
  }, {
    name: 'Kweneng',
    shortCode: 'KW'
  }, {
    name: 'North West',
    shortCode: 'NW'
  }, {
    name: 'North-East',
    shortCode: 'NE'
  }, {
    name: 'South East',
    shortCode: 'SE'
  }, {
    name: 'Southern',
    shortCode: 'SO'
  }]
}, {
  countryName: 'Bouvet Island',
  countryShortCode: 'BV',
  regions: [{
    name: 'Bouvet Island',
    shortCode: 'BV'
  }]
}, {
  countryName: 'Brazil',
  countryShortCode: 'BR',
  regions: [{
    name: 'Acre',
    shortCode: 'AC'
  }, {
    name: 'Alagoas',
    shortCode: 'AL'
  }, {
    name: 'Amapá',
    shortCode: 'AP'
  }, {
    name: 'Amazonas',
    shortCode: 'AM'
  }, {
    name: 'Bahia',
    shortCode: 'BA'
  }, {
    name: 'Ceará',
    shortCode: 'CE'
  }, {
    name: 'Distrito Federal',
    shortCode: 'DF'
  }, {
    name: 'Espírito Santo',
    shortCode: 'ES'
  }, {
    name: 'Goiás',
    shortCode: 'GO'
  }, {
    name: 'Maranhão',
    shortCode: 'MA'
  }, {
    name: 'Mato Grosso',
    shortCode: 'MT'
  }, {
    name: 'Mato Grosso do Sul',
    shortCode: 'MS'
  }, {
    name: 'Minas Gerais',
    shortCode: 'MG'
  }, {
    name: 'Pará',
    shortCode: 'PA'
  }, {
    name: 'Paraíba',
    shortCode: 'PB'
  }, {
    name: 'Paraná',
    shortCode: 'PR'
  }, {
    name: 'Pernambuco',
    shortCode: 'PE'
  }, {
    name: 'Piauí',
    shortCode: 'PI'
  }, {
    name: 'Rio de Janeiro',
    shortCode: 'RJ'
  }, {
    name: 'Rio Grande do Norte',
    shortCode: 'RN'
  }, {
    name: 'Rio Grande do Sul',
    shortCode: 'RS'
  }, {
    name: 'Rondônia',
    shortCode: 'RO'
  }, {
    name: 'Roraima',
    shortCode: 'RR'
  }, {
    name: 'Santa Catarina',
    shortCode: 'SC'
  }, {
    name: 'São Paulo',
    shortCode: 'SP'
  }, {
    name: 'Sergipe',
    shortCode: 'SE'
  }, {
    name: 'Tocantins',
    shortCode: 'TO'
  }]
}, {
  countryName: 'British Indian Ocean Territory',
  countryShortCode: 'IO',
  regions: [{
    name: 'British Indian Ocean Territory',
    shortCode: 'IO'
  }]
}, {
  countryName: 'Brunei Darussalam',
  countryShortCode: 'BN',
  regions: [{
    name: 'Belait',
    shortCode: 'BE'
  }, {
    name: 'Brunei Muara',
    shortCode: 'BM'
  }, {
    name: 'Temburong',
    shortCode: 'TE'
  }, {
    name: 'Tutong',
    shortCode: 'TU'
  }]
}, {
  countryName: 'Bulgaria',
  countryShortCode: 'BG',
  regions: [{
    name: 'Blagoevgrad',
    shortCode: '01'
  }, {
    name: 'Burgas',
    shortCode: '02'
  }, {
    name: 'Dobrich',
    shortCode: '08'
  }, {
    name: 'Gabrovo',
    shortCode: '07'
  }, {
    name: 'Jambol',
    shortCode: '28'
  }, {
    name: 'Khaskovo',
    shortCode: '26'
  }, {
    name: 'Kjustendil',
    shortCode: '10'
  }, {
    name: 'Kurdzhali',
    shortCode: '09'
  }, {
    name: 'Lovech',
    shortCode: '11'
  }, {
    name: 'Montana',
    shortCode: '12'
  }, {
    name: 'Pazardzhik',
    shortCode: '13'
  }, {
    name: 'Pernik',
    shortCode: '14'
  }, {
    name: 'Pleven',
    shortCode: '15'
  }, {
    name: 'Plovdiv',
    shortCode: '16'
  }, {
    name: 'Razgrad',
    shortCode: '17'
  }, {
    name: 'Ruse',
    shortCode: '18'
  }, {
    name: 'Shumen',
    shortCode: '27'
  }, {
    name: 'Silistra',
    shortCode: '19'
  }, {
    name: 'Sliven',
    shortCode: '20'
  }, {
    name: 'Smoljan',
    shortCode: '21'
  }, {
    name: 'Sofija',
    shortCode: '23'
  }, {
    name: 'Sofija-Grad',
    shortCode: '22'
  }, {
    name: 'Stara Zagora',
    shortCode: '24'
  }, {
    name: 'Turgovishhe',
    shortCode: '25'
  }, {
    name: 'Varna',
    shortCode: '03'
  }, {
    name: 'Veliko Turnovo',
    shortCode: '04'
  }, {
    name: 'Vidin',
    shortCode: '05'
  }, {
    name: 'Vraca',
    shortCode: '06'
  }]
}, {
  countryName: 'Burkina Faso',
  countryShortCode: 'BF',
  regions: [{
    name: 'Balé',
    shortCode: 'BAL'
  }, {
    name: 'Bam/Lake Bam',
    shortCode: 'BAM'
  }, {
    name: 'Banwa Province',
    shortCode: 'BAN'
  }, {
    name: 'Bazèga',
    shortCode: 'BAZ'
  }, {
    name: 'Bougouriba',
    shortCode: 'BGR'
  }, {
    name: 'Boulgou Province',
    shortCode: 'BLG'
  }, {
    name: 'Boulkiemdé',
    shortCode: 'BLK'
  }, {
    name: 'Comoé/Komoe',
    shortCode: 'COM'
  }, {
    name: 'Ganzourgou Province',
    shortCode: 'GAN'
  }, {
    name: 'Gnagna',
    shortCode: 'GNA'
  }, {
    name: 'Gourma Province',
    shortCode: 'GOU'
  }, {
    name: 'Houet',
    shortCode: 'HOU'
  }, {
    name: 'Ioba',
    shortCode: 'IOB'
  }, {
    name: 'Kadiogo',
    shortCode: 'KAD'
  }, {
    name: 'Kénédougou',
    shortCode: 'KEN'
  }, {
    name: 'Komondjari',
    shortCode: 'KMD'
  }, {
    name: 'Kompienga',
    shortCode: 'KMP'
  }, {
    name: 'Kossi Province',
    shortCode: 'KOS'
  }, {
    name: 'Koulpélogo',
    shortCode: 'KOP'
  }, {
    name: 'Kouritenga',
    shortCode: 'KOT'
  }, {
    name: 'Kourwéogo',
    shortCode: 'KOW'
  }, {
    name: 'Léraba',
    shortCode: 'LER'
  }, {
    name: 'Loroum',
    shortCode: 'LOR'
  }, {
    name: 'Mouhoun',
    shortCode: 'MOU'
  }, {
    name: 'Namentenga',
    shortCode: 'NAM'
  }, {
    name: 'Naouri/Nahouri',
    shortCode: 'NAO'
  }, {
    name: 'Nayala',
    shortCode: 'NAY'
  }, {
    name: 'Noumbiel',
    shortCode: 'NOU'
  }, {
    name: 'Oubritenga',
    shortCode: 'OUB'
  }, {
    name: 'Oudalan',
    shortCode: 'OUD'
  }, {
    name: 'Passoré',
    shortCode: 'PAS'
  }, {
    name: 'Poni',
    shortCode: 'PON'
  }, {
    name: 'Sanguié',
    shortCode: 'SNG'
  }, {
    name: 'Sanmatenga',
    shortCode: 'SMT'
  }, {
    name: 'Séno',
    shortCode: 'SEN'
  }, {
    name: 'Sissili',
    shortCode: 'SIS'
  }, {
    name: 'Soum',
    shortCode: 'SOM'
  }, {
    name: 'Sourou',
    shortCode: 'SOR'
  }, {
    name: 'Tapoa',
    shortCode: 'TAP'
  }, {
    name: 'Tui/Tuy',
    shortCode: 'TUI'
  }, {
    name: 'Yagha',
    shortCode: 'YAG'
  }, {
    name: 'Yatenga',
    shortCode: 'YAT'
  }, {
    name: 'Ziro',
    shortCode: 'ZIR'
  }, {
    name: 'Zondoma',
    shortCode: 'ZON'
  }, {
    name: 'Zoundwéogo',
    shortCode: 'ZOU'
  }]
}, {
  countryName: 'Burundi',
  countryShortCode: 'BI',
  regions: [{
    name: 'Bubanza',
    shortCode: 'BB'
  }, {
    name: 'Bujumbura Mairie',
    shortCode: 'BM'
  }, {
    name: 'Bujumbura Rural',
    shortCode: 'BL'
  }, {
    name: 'Bururi',
    shortCode: 'BR'
  }, {
    name: 'Cankuzo',
    shortCode: 'CA'
  }, {
    name: 'Cibitoke',
    shortCode: 'CI'
  }, {
    name: 'Gitega',
    shortCode: 'GI'
  }, {
    name: 'Karuzi',
    shortCode: 'KR'
  }, {
    name: 'Kayanza',
    shortCode: 'KY'
  }, {
    name: 'Kirundo',
    shortCode: 'KI'
  }, {
    name: 'Makamba',
    shortCode: 'MA'
  }, {
    name: 'Muramvya',
    shortCode: 'MU'
  }, {
    name: 'Muyinga',
    shortCode: 'MY'
  }, {
    name: 'Mwaro',
    shortCode: 'MW'
  }, {
    name: 'Ngozi',
    shortCode: 'NG'
  }, {
    name: 'Rutana',
    shortCode: 'RT'
  }, {
    name: 'Ruyigi',
    shortCode: 'RY'
  }]
}, {
  countryName: 'Cambodia',
  countryShortCode: 'KH',
  regions: [{
    name: 'Baat Dambang',
    shortCode: '2'
  }, {
    name: 'Banteay Mean Chey',
    shortCode: '1'
  }, {
    name: 'Kampong Chaam',
    shortCode: '3'
  }, {
    name: 'Kampong Chhnang',
    shortCode: '4'
  }, {
    name: 'Kampong Spueu',
    shortCode: '5'
  }, {
    name: 'Kampong Thum',
    shortCode: '6'
  }, {
    name: 'Kampot',
    shortCode: '7'
  }, {
    name: 'Kandaal',
    shortCode: '8'
  }, {
    name: 'Kaoh Kong',
    shortCode: '9'
  }, {
    name: 'Kracheh',
    shortCode: '10'
  }, {
    name: 'Krong Kaeb',
    shortCode: '23'
  }, {
    name: 'Krong Pailin',
    shortCode: '24'
  }, {
    name: 'Krong Preah Sihanouk',
    shortCode: '18'
  }, {
    name: 'Mondol Kiri',
    shortCode: '11'
  }, {
    name: 'Otdar Mean Chey',
    shortCode: '22'
  }, {
    name: 'Phnom Penh',
    shortCode: '12'
  }, {
    name: 'Pousaat',
    shortCode: '15'
  }, {
    name: 'Preah Vihear',
    shortCode: '13'
  }, {
    name: 'Prey Veaeng',
    shortCode: '14'
  }, {
    name: 'Rotanah Kiri',
    shortCode: '16'
  }, {
    name: 'Siem Reab',
    shortCode: '17'
  }, {
    name: 'Stueng Treng',
    shortCode: '19'
  }, {
    name: 'Svaay Rieng',
    shortCode: '20'
  }, {
    name: 'Taakaev',
    shortCode: '21'
  }, {
    name: 'Tbong Khmum',
    shortCode: '25'
  }]
}, {
  countryName: 'Cameroon',
  countryShortCode: 'CM',
  regions: [{
    name: 'Adamaoua',
    shortCode: 'AD'
  }, {
    name: 'Centre',
    shortCode: 'CE'
  }, {
    name: 'Est',
    shortCode: 'ES'
  }, {
    name: 'Extrême-Nord',
    shortCode: 'EN'
  }, {
    name: 'Littoral',
    shortCode: 'LT'
  }, {
    name: 'Nord',
    shortCode: 'NO'
  }, {
    name: 'Nord-Ouest',
    shortCode: 'NW'
  }, {
    name: 'Ouest',
    shortCode: 'OU'
  }, {
    name: 'Sud',
    shortCode: 'SU'
  }, {
    name: 'Sud-Ouest',
    shortCode: 'SW'
  }]
}, {
  countryName: 'Canada',
  countryShortCode: 'CA',
  regions: [{
    name: 'Alberta',
    shortCode: 'AB'
  }, {
    name: 'British Columbia',
    shortCode: 'BC'
  }, {
    name: 'Manitoba',
    shortCode: 'MB'
  }, {
    name: 'New Brunswick',
    shortCode: 'NB'
  }, {
    name: 'Newfoundland and Labrador',
    shortCode: 'NL'
  }, {
    name: 'Northwest Territories',
    shortCode: 'NT'
  }, {
    name: 'Nova Scotia',
    shortCode: 'NS'
  }, {
    name: 'Nunavut',
    shortCode: 'NU'
  }, {
    name: 'Ontario',
    shortCode: 'ON'
  }, {
    name: 'Prince Edward Island',
    shortCode: 'PE'
  }, {
    name: 'Quebec',
    shortCode: 'QC'
  }, {
    name: 'Saskatchewan',
    shortCode: 'SK'
  }, {
    name: 'Yukon',
    shortCode: 'YT'
  }]
}, {
  countryName: 'Cape Verde',
  countryShortCode: 'CV',
  regions: [{
    name: 'Boa Vista',
    shortCode: 'BV'
  }, {
    name: 'Brava',
    shortCode: 'BR'
  }, {
    name: 'Calheta de São Miguel',
    shortCode: 'CS'
  }, {
    name: 'Maio',
    shortCode: 'MA'
  }, {
    name: 'Mosteiros',
    shortCode: 'MO'
  }, {
    name: 'Paúl',
    shortCode: 'PA'
  }, {
    name: 'Porto Novo',
    shortCode: 'PN'
  }, {
    name: 'Praia',
    shortCode: 'PR'
  }, {
    name: 'Ribeira Brava',
    shortCode: 'RB'
  }, {
    name: 'Ribeira Grande',
    shortCode: 'RG'
  }, {
    name: 'Sal',
    shortCode: 'SL'
  }, {
    name: 'Santa Catarina',
    shortCode: 'CA'
  }, {
    name: 'Santa Cruz',
    shortCode: 'CR'
  }, {
    name: 'São Domingos',
    shortCode: 'SD'
  }, {
    name: 'São Filipe',
    shortCode: 'SF'
  }, {
    name: 'São Nicolau',
    shortCode: 'SN'
  }, {
    name: 'São Vicente',
    shortCode: 'SV'
  }, {
    name: 'Tarrafal',
    shortCode: 'TA'
  }, {
    name: 'Tarrafal de São Nicolau',
    shortCode: 'TS'
  }]
}, {
  countryName: 'Cayman Islands',
  countryShortCode: 'KY',
  regions: [{
    name: 'Creek'
  }, {
    name: 'Eastern'
  }, {
    name: 'Midland'
  }, {
    name: 'South Town'
  }, {
    name: 'Spot Bay'
  }, {
    name: 'Stake Bay'
  }, {
    name: 'West End'
  }, {
    name: 'Western'
  }]
}, {
  countryName: 'Central African Republic',
  countryShortCode: 'CF',
  regions: [{
    name: 'Bamingui-Bangoran',
    shortCode: 'BB'
  }, {
    name: 'Bangui',
    shortCode: 'BGF'
  }, {
    name: 'Basse-Kotto',
    shortCode: 'BK'
  }, {
    name: 'Haute-Kotto',
    shortCode: 'HK'
  }, {
    name: 'Haut-Mbomou',
    shortCode: 'HM'
  }, {
    name: 'Kémo',
    shortCode: 'KG'
  }, {
    name: 'Lobaye',
    shortCode: 'LB'
  }, {
    name: 'Mambéré-Kadéï',
    shortCode: 'HS'
  }, {
    name: 'Mbomou',
    shortCode: 'MB'
  }, {
    name: 'Nana-Grebizi',
    shortCode: '10'
  }, {
    name: 'Nana-Mambéré',
    shortCode: 'NM'
  }, {
    name: "Ombella-M'Poko",
    shortCode: 'MP'
  }, {
    name: 'Ouaka',
    shortCode: 'UK'
  }, {
    name: 'Ouham',
    shortCode: 'AC'
  }, {
    name: 'Ouham Péndé',
    shortCode: 'OP'
  }, {
    name: 'Sangha-Mbaéré',
    shortCode: 'SE'
  }, {
    name: 'Vakaga',
    shortCode: 'VK'
  }]
}, {
  countryName: 'Chad',
  countryShortCode: 'TD',
  regions: [{
    name: 'Bahr el Ghazal',
    shortCode: 'BG'
  }, {
    name: 'Batha',
    shortCode: 'BA'
  }, {
    name: 'Borkou',
    shortCode: 'BO'
  }, {
    name: 'Chari-Baguirmi',
    shortCode: 'CB'
  }, {
    name: 'Ennedi-Est',
    shortCode: 'EE'
  }, {
    name: 'Ennedi-Ouest',
    shortCode: 'EO'
  }, {
    name: 'Guéra',
    shortCode: 'GR'
  }, {
    name: 'Hadjer Lamis',
    shortCode: 'HL'
  }, {
    name: 'Kanem',
    shortCode: 'KA'
  }, {
    name: 'Lac',
    shortCode: 'LC'
  }, {
    name: 'Logone Occidental',
    shortCode: 'LO'
  }, {
    name: 'Logone Oriental',
    shortCode: 'LR'
  }, {
    name: 'Mondoul',
    shortCode: 'MA'
  }, {
    name: 'Mayo-Kébbi-Est',
    shortCode: 'ME'
  }, {
    name: 'Moyen-Chari',
    shortCode: 'MC'
  }, {
    name: 'Ouaddai',
    shortCode: 'OD'
  }, {
    name: 'Salamat',
    shortCode: 'SA'
  }, {
    name: 'Sila',
    shortCode: 'SI'
  }, {
    name: 'Tandjilé',
    shortCode: 'TA'
  }, {
    name: 'Tibesti',
    shortCode: 'TI'
  }, {
    name: 'Ville de Ndjamena',
    shortCode: 'ND'
  }, {
    name: 'Wadi Fira',
    shortCode: 'WF'
  }]
}, {
  countryName: 'Chile',
  countryShortCode: 'CL',
  regions: [{
    name: 'Aisén del General Carlos Ibáñez del Campo',
    shortCode: 'AI'
  }, {
    name: 'Antofagasta',
    shortCode: 'AN'
  }, {
    name: 'Araucanía',
    shortCode: 'AR'
  }, {
    name: 'Arica y Parinacota',
    shortCode: 'AP'
  }, {
    name: 'Atacama',
    shortCode: 'AT'
  }, {
    name: 'Bío-Bío',
    shortCode: 'BI'
  }, {
    name: 'Coquimbo',
    shortCode: 'CO'
  }, {
    name: "Libertador General Bernardo O'Higgins",
    shortCode: 'LI'
  }, {
    name: 'Los Lagos',
    shortCode: 'LL'
  }, {
    name: 'Los Ríos',
    shortCode: 'LR'
  }, {
    name: 'Magallanes y Antartica Chilena',
    shortCode: 'MA'
  }, {
    name: 'Marga-Marga',
    shortCode: ''
  }, {
    name: 'Maule',
    shortCode: 'ML'
  }, {
    name: 'Ñuble',
    shortCode: 'NB'
  }, {
    name: 'Región Metropolitana de Santiago',
    shortCode: 'RM'
  }, {
    name: 'Tarapacá',
    shortCode: 'TA'
  }, {
    name: 'Valparaíso',
    shortCode: 'VS'
  }]
}, {
  countryName: 'China',
  countryShortCode: 'CN',
  regions: [{
    name: 'Anhui',
    shortCode: '34'
  }, {
    name: 'Beijing',
    shortCode: '11'
  }, {
    name: 'Chongqing',
    shortCode: '50'
  }, {
    name: 'Fujian',
    shortCode: '35'
  }, {
    name: 'Gansu',
    shortCode: '62'
  }, {
    name: 'Guangdong',
    shortCode: '44'
  }, {
    name: 'Guangxi',
    shortCode: '45'
  }, {
    name: 'Guizhou',
    shortCode: '52'
  }, {
    name: 'Hainan',
    shortCode: '46'
  }, {
    name: 'Hebei',
    shortCode: '13'
  }, {
    name: 'Heilongjiang',
    shortCode: '23'
  }, {
    name: 'Henan',
    shortCode: '41'
  }, {
    name: 'Hong Kong',
    shortCode: '91'
  }, {
    name: 'Hubei',
    shortCode: '42'
  }, {
    name: 'Hunan',
    shortCode: '43'
  }, {
    name: 'Inner Mongolia',
    shortCode: '15'
  }, {
    name: 'Jiangsu',
    shortCode: '32'
  }, {
    name: 'Jiangxi',
    shortCode: '36'
  }, {
    name: 'Jilin',
    shortCode: '22'
  }, {
    name: 'Liaoning',
    shortCode: '21'
  }, {
    name: 'Macau',
    shortCode: '92'
  }, {
    name: 'Ningxia',
    shortCode: '64'
  }, {
    name: 'Qinghai',
    shortCode: '63'
  }, {
    name: 'Shaanxi',
    shortCode: '61'
  }, {
    name: 'Shandong',
    shortCode: '37'
  }, {
    name: 'Shanghai',
    shortCode: '31'
  }, {
    name: 'Shanxi',
    shortCode: '14'
  }, {
    name: 'Sichuan',
    shortCode: '51'
  }, {
    name: 'Tianjin',
    shortCode: '12'
  }, {
    name: 'Tibet',
    shortCode: '54'
  }, {
    name: 'Xinjiang',
    shortCode: '65'
  }, {
    name: 'Yunnan',
    shortCode: '53'
  }, {
    name: 'Zhejiang',
    shortCode: '33'
  }]
}, {
  countryName: 'Christmas Island',
  countryShortCode: 'CX',
  regions: [{
    name: 'Christmas Island',
    shortCode: 'CX'
  }]
}, {
  countryName: 'Cocos (Keeling) Islands',
  countryShortCode: 'CC',
  regions: [{
    name: 'Direction Island',
    shortCode: 'DI'
  }, {
    name: 'Home Island',
    shortCode: 'HM'
  }, {
    name: 'Horsburgh Island',
    shortCode: 'HR'
  }, {
    name: 'North Keeling Island',
    shortCode: 'NK'
  }, {
    name: 'South Island',
    shortCode: 'SI'
  }, {
    name: 'West Island',
    shortCode: 'WI'
  }]
}, {
  countryName: 'Colombia',
  countryShortCode: 'CO',
  regions: [{
    name: 'Amazonas',
    shortCode: 'AMA'
  }, {
    name: 'Antioquia',
    shortCode: 'ANT'
  }, {
    name: 'Arauca',
    shortCode: 'ARA'
  }, {
    name: 'Archipiélago de San Andrés',
    shortCode: 'SAP'
  }, {
    name: 'Atlántico',
    shortCode: 'ATL'
  }, {
    name: 'Bogotá D.C.',
    shortCode: 'DC'
  }, {
    name: 'Bolívar',
    shortCode: 'BOL'
  }, {
    name: 'Boyacá',
    shortCode: 'BOY'
  }, {
    name: 'Caldas',
    shortCode: 'CAL'
  }, {
    name: 'Caquetá',
    shortCode: 'CAQ'
  }, {
    name: 'Casanare',
    shortCode: 'CAS'
  }, {
    name: 'Cauca',
    shortCode: 'CAU'
  }, {
    name: 'Cesar',
    shortCode: 'CES'
  }, {
    name: 'Chocó',
    shortCode: 'CHO'
  }, {
    name: 'Córdoba',
    shortCode: 'COR'
  }, {
    name: 'Cundinamarca',
    shortCode: 'CUN'
  }, {
    name: 'Guainía',
    shortCode: 'GUA'
  }, {
    name: 'Guaviare',
    shortCode: 'GUV'
  }, {
    name: 'Huila',
    shortCode: 'HUI'
  }, {
    name: 'La Guajira',
    shortCode: 'LAG'
  }, {
    name: 'Magdalena',
    shortCode: 'MAG'
  }, {
    name: 'Meta',
    shortCode: 'MET'
  }, {
    name: 'Nariño',
    shortCode: 'NAR'
  }, {
    name: 'Norte de Santander',
    shortCode: 'NSA'
  }, {
    name: 'Putumayo',
    shortCode: 'PUT'
  }, {
    name: 'Quindío',
    shortCode: 'QUI'
  }, {
    name: 'Risaralda',
    shortCode: 'RIS'
  }, {
    name: 'Santander',
    shortCode: 'SAN'
  }, {
    name: 'Sucre',
    shortCode: 'SUC'
  }, {
    name: 'Tolima',
    shortCode: 'TOL'
  }, {
    name: 'Valle del Cauca',
    shortCode: 'VAC'
  }, {
    name: 'Vaupés',
    shortCode: 'VAU'
  }, {
    name: 'Vichada',
    shortCode: 'VID'
  }]
}, {
  countryName: 'Comoros',
  countryShortCode: 'KM',
  regions: [{
    name: 'Andjazîdja',
    shortCode: 'G'
  }, {
    name: 'Andjouân',
    shortCode: 'A'
  }, {
    name: 'Moûhîlî',
    shortCode: 'M'
  }]
}, {
  countryName: 'Congo, Republic of the (Brazzaville)',
  countryShortCode: 'CG',
  regions: [{
    name: 'Bouenza',
    shortCode: '11'
  }, {
    name: 'Brazzaville',
    shortCode: 'BZV'
  }, {
    name: 'Cuvette',
    shortCode: '8'
  }, {
    name: 'Cuvette-Ouest',
    shortCode: '15'
  }, {
    name: 'Kouilou',
    shortCode: '5'
  }, {
    name: 'Lékoumou',
    shortCode: '2'
  }, {
    name: 'Likouala',
    shortCode: '7'
  }, {
    name: 'Niari',
    shortCode: '9'
  }, {
    name: 'Plateaux',
    shortCode: '14'
  }, {
    name: 'Pointe-Noire',
    shortCode: '16'
  }, {
    name: 'Pool',
    shortCode: '12'
  }, {
    name: 'Sangha',
    shortCode: '13'
  }]
}, {
  countryName: 'Congo, the Democratic Republic of the (Kinshasa)',
  countryShortCode: 'CD',
  regions: [{
    name: 'Bandundu',
    shortCode: 'BN'
  }, {
    name: 'Bas-Congo',
    shortCode: 'BC'
  }, {
    name: 'Équateur',
    shortCode: 'EQ'
  }, {
    name: 'Kasaï-Occidental',
    shortCode: 'KE'
  }, {
    name: 'Kasaï-Oriental',
    shortCode: 'KW'
  }, {
    name: 'Katanga',
    shortCode: 'KA'
  }, {
    name: 'Kinshasa',
    shortCode: 'KN'
  }, {
    name: 'Maniema',
    shortCode: 'MA'
  }, {
    name: 'Nord-Kivu',
    shortCode: 'NK'
  }, {
    name: 'Orientale',
    shortCode: 'OR'
  }, {
    name: 'Sud-Kivu',
    shortCode: 'SK'
  }]
}, {
  countryName: 'Cook Islands',
  countryShortCode: 'CK',
  regions: [{
    name: 'Aitutaki'
  }, {
    name: 'Atiu'
  }, {
    name: 'Avarua'
  }, {
    name: 'Mangaia'
  }, {
    name: 'Manihiki'
  }, {
    name: "Ma'uke"
  }, {
    name: 'Mitiaro'
  }, {
    name: 'Nassau'
  }, {
    name: 'Palmerston'
  }, {
    name: 'Penrhyn'
  }, {
    name: 'Pukapuka'
  }, {
    name: 'Rakahanga'
  }]
}, {
  countryName: 'Costa Rica',
  countryShortCode: 'CR',
  regions: [{
    name: 'Alajuela',
    shortCode: '2'
  }, {
    name: 'Cartago',
    shortCode: '3'
  }, {
    name: 'Guanacaste',
    shortCode: '5'
  }, {
    name: 'Heredia',
    shortCode: '4'
  }, {
    name: 'Limón',
    shortCode: '7'
  }, {
    name: 'Puntarenas',
    shortCode: '6'
  }, {
    name: 'San José',
    shortCode: '1'
  }]
}, {
  countryName: "Côte d'Ivoire, Republic of",
  countryShortCode: 'CI',
  regions: [{
    name: 'Agnéby',
    shortCode: '16'
  }, {
    name: 'Bafing',
    shortCode: '17'
  }, {
    name: 'Bas-Sassandra',
    shortCode: '09'
  }, {
    name: 'Denguélé',
    shortCode: '10'
  }, {
    name: 'Dix-Huit Montagnes',
    shortCode: '06'
  }, {
    name: 'Fromager',
    shortCode: '18'
  }, {
    name: 'Haut-Sassandra',
    shortCode: '02'
  }, {
    name: 'Lacs',
    shortCode: '07'
  }, {
    name: 'Lagunes',
    shortCode: '01'
  }, {
    name: 'Marahoué',
    shortCode: '12'
  }, {
    name: 'Moyen-Cavally',
    shortCode: '19'
  }, {
    name: 'Moyen-Comoé',
    shortCode: '05'
  }, {
    name: "N'zi-Comoé",
    shortCode: '11'
  }, {
    name: 'Savanes',
    shortCode: '03'
  }, {
    name: 'Sud-Bandama',
    shortCode: '15'
  }, {
    name: 'Sud-Comoé',
    shortCode: '13'
  }, {
    name: 'Vallée du Bandama',
    shortCode: '04'
  }, {
    name: 'Worodougou',
    shortCode: '14'
  }, {
    name: 'Zanzan',
    shortCode: '08'
  }]
}, {
  countryName: 'Croatia',
  countryShortCode: 'HR',
  regions: [{
    name: 'Bjelovarsko-bilogorska županija',
    shortCode: '07'
  }, {
    name: 'Brodsko-posavska županija',
    shortCode: '12'
  }, {
    name: 'Dubrovačko-neretvanska županija',
    shortCode: '19'
  }, {
    name: 'Grad Zagreb',
    shortCode: '21'
  }, {
    name: 'Istarska županija',
    shortCode: '18'
  }, {
    name: 'Karlovačka županija',
    shortCode: '04'
  }, {
    name: 'Koprivničko-križevačka županija',
    shortCode: '06'
  }, {
    name: 'Krapinsko-zagorska županija',
    shortCode: '02'
  }, {
    name: 'Ličko-senjska županija',
    shortCode: '09'
  }, {
    name: 'Međimurska županija',
    shortCode: '20'
  }, {
    name: 'Osječko-baranjska županija',
    shortCode: '14'
  }, {
    name: 'Požeško-slavonska županija',
    shortCode: '11'
  }, {
    name: 'Primorsko-goranska županija',
    shortCode: '08'
  }, {
    name: 'Sisačko-moslavačka županija',
    shortCode: '03'
  }, {
    name: 'Splitsko-dalmatinska županija',
    shortCode: '17'
  }, {
    name: 'Šibensko-kninska županija',
    shortCode: '15'
  }, {
    name: 'Varaždinska županija',
    shortCode: '05'
  }, {
    name: 'Virovitičko-podravska županija',
    shortCode: '10'
  }, {
    name: 'Vukovarsko-srijemska županija',
    shortCode: '16'
  }, {
    name: 'Zadarska županija',
    shortCode: '13'
  }, {
    name: 'Zagrebačka županija',
    shortCode: '01'
  }]
}, {
  countryName: 'Cuba',
  countryShortCode: 'CU',
  regions: [{
    name: 'Artemisa',
    shortCode: '15'
  }, {
    name: 'Camagüey',
    shortCode: '09'
  }, {
    name: 'Ciego de Ávila',
    shortCode: '08'
  }, {
    name: 'Cienfuegos',
    shortCode: '06'
  }, {
    name: 'Granma',
    shortCode: '12'
  }, {
    name: 'Guantánamo',
    shortCode: '14'
  }, {
    name: 'Holguín',
    shortCode: '11'
  }, {
    name: 'Isla de la Juventud',
    shortCode: '99'
  }, {
    name: 'La Habana',
    shortCode: '03'
  }, {
    name: 'Las Tunas',
    shortCode: '10'
  }, {
    name: 'Matanzas',
    shortCode: '04'
  }, {
    name: 'Mayabeque',
    shortCode: '16'
  }, {
    name: 'Pinar del Río',
    shortCode: '01'
  }, {
    name: 'Sancti Spíritus',
    shortCode: '07'
  }, {
    name: 'Santiago de Cuba',
    shortCode: '13'
  }, {
    name: 'Villa Clara',
    shortCode: '05'
  }]
}, {
  countryName: 'Curaçao',
  countryShortCode: 'CW',
  regions: [{
    name: 'Curaçao',
    shortCode: 'CW'
  }]
}, {
  countryName: 'Cyprus',
  countryShortCode: 'CY',
  regions: [{
    name: 'Ammochostos',
    shortCode: '04'
  }, {
    name: 'Keryneia',
    shortCode: '06'
  }, {
    name: 'Larnaka',
    shortCode: '03'
  }, {
    name: 'Lefkosia',
    shortCode: '01'
  }, {
    name: 'Lemesos',
    shortCode: '02'
  }, {
    name: 'Pafos',
    shortCode: '05'
  }]
}, {
  countryName: 'Czech Republic',
  countryShortCode: 'CZ',
  regions: [{
    name: 'Hlavní město Praha',
    shortCode: 'PR'
  }, {
    name: 'Jihočeský kraj',
    shortCode: 'JC'
  }, {
    name: 'Jihomoravský kraj',
    shortCode: 'JM'
  }, {
    name: 'Karlovarský kraj',
    shortCode: 'KA'
  }, {
    name: 'Královéhradecký kraj',
    shortCode: 'KR'
  }, {
    name: 'Liberecký kraj',
    shortCode: 'LI'
  }, {
    name: 'Moravskoslezský kraj',
    shortCode: 'MO'
  }, {
    name: 'Olomoucký kraj',
    shortCode: 'OL'
  }, {
    name: 'Pardubický kraj',
    shortCode: 'PA'
  }, {
    name: 'Plzeňský kraj',
    shortCode: 'PL'
  }, {
    name: 'Středočeský kraj',
    shortCode: 'ST'
  }, {
    name: 'Ústecký kraj',
    shortCode: 'US'
  }, {
    name: 'Vysočina',
    shortCode: 'VY'
  }, {
    name: 'Zlínský kraj',
    shortCode: 'ZL'
  }]
}, {
  countryName: 'Denmark',
  countryShortCode: 'DK',
  regions: [{
    name: 'Hovedstaden',
    shortCode: '84'
  }, {
    name: 'Kujalleq',
    shortCode: 'GL-KU'
  }, {
    name: 'Midtjylland',
    shortCode: '82'
  }, {
    name: 'Norderøerne',
    shortCode: 'FO-01'
  }, {
    name: 'Nordjylland',
    shortCode: '81'
  }, {
    name: 'Østerø',
    shortCode: 'FO-06'
  }, {
    name: 'Qaasuitsup',
    shortCode: 'GL-QA'
  }, {
    name: 'Qeqqata',
    shortCode: 'GL-QE'
  }, {
    name: 'Sandø',
    shortCode: 'FO-02'
  }, {
    name: 'Sermersooq',
    shortCode: 'GL-SM'
  }, {
    name: 'Sjælland',
    shortCode: '85'
  }, {
    name: 'Strømø',
    shortCode: 'FO-03'
  }, {
    name: 'Suderø',
    shortCode: 'FO-04'
  }, {
    name: 'Syddanmark',
    shortCode: '83'
  }, {
    name: 'Vågø',
    shortCode: 'FO-05'
  }]
}, {
  countryName: 'Djibouti',
  countryShortCode: 'DJ',
  regions: [{
    name: 'Ali Sabieh',
    shortCode: 'AS'
  }, {
    name: 'Arta',
    shortCode: 'AR'
  }, {
    name: 'Dikhil',
    shortCode: 'DI'
  }, {
    name: 'Obock',
    shortCode: 'OB'
  }, {
    name: 'Tadjourah',
    shortCode: 'TA'
  }]
}, {
  countryName: 'Dominica',
  countryShortCode: 'DM',
  regions: [{
    name: 'Saint Andrew Parish',
    shortCode: '02'
  }, {
    name: 'Saint David Parish',
    shortCode: '03'
  }, {
    name: 'Saint George Parish',
    shortCode: '04'
  }, {
    name: 'Saint John Parish',
    shortCode: '05'
  }, {
    name: 'Saint Joseph Parish',
    shortCode: '06'
  }, {
    name: 'Saint Luke Parish',
    shortCode: '07'
  }, {
    name: 'Saint Mark Parish',
    shortCode: '08'
  }, {
    name: 'Saint Patrick Parish',
    shortCode: '09'
  }, {
    name: 'Saint Paul Parish',
    shortCode: '10'
  }, {
    name: 'Saint Peter Parish',
    shortCode: '11'
  }]
}, {
  countryName: 'Dominican Republic',
  countryShortCode: 'DO',
  regions: [{
    name: 'Cibao Central',
    shortCode: '02'
  }, {
    name: 'Del Valle',
    shortCode: '37'
  }, {
    name: 'Distrito Nacional',
    shortCode: '01'
  }, {
    name: 'Enriquillo',
    shortCode: '38'
  }, {
    name: 'Norcentral',
    shortCode: '04'
  }, {
    name: 'Nordeste',
    shortCode: '33'
  }, {
    name: 'Noroeste',
    shortCode: '34'
  }, {
    name: 'Norte',
    shortCode: '35'
  }, {
    name: 'Valdesia',
    shortCode: '42'
  }]
}, {
  countryName: 'Ecuador',
  countryShortCode: 'EC',
  regions: [{
    name: 'Azuay',
    shortCode: 'A'
  }, {
    name: 'Bolívar',
    shortCode: 'B'
  }, {
    name: 'Cañar',
    shortCode: 'F'
  }, {
    name: 'Carchi',
    shortCode: 'C'
  }, {
    name: 'Chimborazo',
    shortCode: 'H'
  }, {
    name: 'Cotopaxi',
    shortCode: 'X'
  }, {
    name: 'El Oro',
    shortCode: 'O'
  }, {
    name: 'Esmeraldas',
    shortCode: 'E'
  }, {
    name: 'Galápagos',
    shortCode: 'W'
  }, {
    name: 'Guayas',
    shortCode: 'G'
  }, {
    name: 'Imbabura',
    shortCode: 'I'
  }, {
    name: 'Loja',
    shortCode: 'L'
  }, {
    name: 'Los Ríos',
    shortCode: 'R'
  }, {
    name: 'Manabí',
    shortCode: 'M'
  }, {
    name: 'Morona-Santiago',
    shortCode: 'S'
  }, {
    name: 'Napo',
    shortCode: 'N'
  }, {
    name: 'Orellana',
    shortCode: 'D'
  }, {
    name: 'Pastaza',
    shortCode: 'Y'
  }, {
    name: 'Pichincha',
    shortCode: 'P'
  }, {
    name: 'Santa Elena',
    shortCode: 'SE'
  }, {
    name: 'Santo Domingo de los Tsáchilas',
    shortCode: 'SD'
  }, {
    name: 'Sucumbíos',
    shortCode: 'U'
  }, {
    name: 'Tungurahua',
    shortCode: 'T'
  }, {
    name: 'Zamora-Chinchipe',
    shortCode: 'Z'
  }]
}, {
  countryName: 'Egypt',
  countryShortCode: 'EG',
  regions: [{
    name: 'Alexandria',
    shortCode: 'ALX'
  }, {
    name: 'Aswan',
    shortCode: 'ASN'
  }, {
    name: 'Asyout',
    shortCode: 'AST'
  }, {
    name: 'Bani Sueif',
    shortCode: 'BNS'
  }, {
    name: 'Beheira',
    shortCode: 'BH'
  }, {
    name: 'Cairo',
    shortCode: 'C'
  }, {
    name: 'Daqahlia',
    shortCode: 'DK'
  }, {
    name: 'Dumiat',
    shortCode: 'DT'
  }, {
    name: 'El Bahr El Ahmar',
    shortCode: 'BA'
  }, {
    name: 'El Ismailia',
    shortCode: 'IS'
  }, {
    name: 'El Suez',
    shortCode: 'SUZ'
  }, {
    name: 'El Wadi El Gedeed',
    shortCode: 'WAD'
  }, {
    name: 'Fayoum',
    shortCode: 'FYM'
  }, {
    name: 'Gharbia',
    shortCode: 'GH'
  }, {
    name: 'Giza',
    shortCode: 'GZ'
  }, {
    name: 'Helwan',
    shortCode: 'HU'
  }, {
    name: 'Kafr El Sheikh',
    shortCode: 'KFS'
  }, {
    name: 'Luxor',
    shortCode: 'LX'
  }, {
    name: 'Matrouh',
    shortCode: 'MT'
  }, {
    name: 'Menia',
    shortCode: 'MN'
  }, {
    name: 'Menofia',
    shortCode: 'MNF'
  }, {
    name: 'North Sinai',
    shortCode: 'SIN'
  }, {
    name: 'Port Said',
    shortCode: 'PTS'
  }, {
    name: 'Qalubia',
    shortCode: 'KB'
  }, {
    name: 'Qena',
    shortCode: 'KN'
  }, {
    name: 'Sharqia',
    shortCode: 'SHR'
  }, {
    name: 'Sixth of October',
    shortCode: 'SU'
  }, {
    name: 'Sohag',
    shortCode: 'SHG'
  }, {
    name: 'South Sinai',
    shortCode: 'JS'
  }]
}, {
  countryName: 'El Salvador',
  countryShortCode: 'SV',
  regions: [{
    name: 'Ahuachapán',
    shortCode: 'AH'
  }, {
    name: 'Cabañas',
    shortCode: 'CA'
  }, {
    name: 'Cuscatlán',
    shortCode: 'CU'
  }, {
    name: 'Chalatenango',
    shortCode: 'CH'
  }, {
    name: 'La Libertad',
    shortCode: 'LI'
  }, {
    name: 'La Paz',
    shortCode: 'PA'
  }, {
    name: 'La Unión',
    shortCode: 'UN'
  }, {
    name: 'Morazán',
    shortCode: 'MO'
  }, {
    name: 'San Miguel',
    shortCode: 'SM'
  }, {
    name: 'San Salvador',
    shortCode: 'SS'
  }, {
    name: 'Santa Ana',
    shortCode: 'SA'
  }, {
    name: 'San Vicente',
    shortCode: 'SV'
  }, {
    name: 'Sonsonate',
    shortCode: 'SO'
  }, {
    name: 'Usulután',
    shortCode: 'US'
  }]
}, {
  countryName: 'Equatorial Guinea',
  countryShortCode: 'GQ',
  regions: [{
    name: 'Annobón',
    shortCode: 'AN'
  }, {
    name: 'Bioko Norte',
    shortCode: 'BN'
  }, {
    name: 'Bioko Sur',
    shortCode: 'BS'
  }, {
    name: 'Centro Sur',
    shortCode: 'CS'
  }, {
    name: 'Kié-Ntem',
    shortCode: 'KN'
  }, {
    name: 'Litoral',
    shortCode: 'LI'
  }, {
    name: 'Wele-Nzas',
    shortCode: 'WN'
  }]
}, {
  countryName: 'Eritrea',
  countryShortCode: 'ER',
  regions: [{
    name: 'Anseba',
    shortCode: 'AN'
  }, {
    name: 'Debub',
    shortCode: 'DU'
  }, {
    name: 'Debub-Keih-Bahri',
    shortCode: 'DK'
  }, {
    name: 'Gash-Barka',
    shortCode: 'GB'
  }, {
    name: 'Maekel',
    shortCode: 'MA'
  }, {
    name: 'Semien-Keih-Bahri',
    shortCode: 'SK'
  }]
}, {
  countryName: 'Estonia',
  countryShortCode: 'EE',
  regions: [{
    name: 'Alutaguse (Алутагузе)',
    shortCode: '130'
  }, {
    name: 'Anija (Ания)',
    shortCode: '141'
  }, {
    name: 'Antsla (Антсла)',
    shortCode: '142'
  }, {
    name: 'Elva (Элва)',
    shortCode: '171'
  }, {
    name: 'Haapsalu (Хаапсалу)',
    shortCode: '184'
  }, {
    name: 'Haljala (Хальяла)',
    shortCode: '191'
  }, {
    name: 'Harjumaa (Харьюмаа)',
    shortCode: '37'
  }, {
    name: 'Harku (Харку)',
    shortCode: '198'
  }, {
    name: 'Hiiumaa (Хийумаа (уезд))',
    shortCode: '39'
  }, {
    name: 'Hiiumaa (Хийумаа)',
    shortCode: '205'
  }, {
    name: 'Häädemeeste (Хяэдемеэсте)',
    shortCode: '214'
  }, {
    name: 'Ida-Virumaa (Ида-Вирумаа)',
    shortCode: '45'
  }, {
    name: 'Järva (Ярва)',
    shortCode: '255'
  }, {
    name: 'Järvamaa (Ярвамаа)',
    shortCode: '52'
  }, {
    name: 'Jõelähtme (Йыэляхтме)',
    shortCode: '245'
  }, {
    name: 'Jõgeva (Йыгева)',
    shortCode: '247'
  }, {
    name: 'Jõgevamaa (Йыгевамаа)',
    shortCode: '50'
  }, {
    name: 'Jõhvi (Йыхви)',
    shortCode: '251'
  }, {
    name: 'Kadrina (Кадрина)',
    shortCode: '272'
  }, {
    name: 'Kambja (Камбья)',
    shortCode: '283'
  }, {
    name: 'Kanepi (Канепи)',
    shortCode: '284'
  }, {
    name: 'Kastre (Кастре)',
    shortCode: '291'
  }, {
    name: 'Kehtna (Кехтна)',
    shortCode: '293'
  }, {
    name: 'Keila (Кейла)',
    shortCode: '296'
  }, {
    name: 'Kihnu (Кихну)',
    shortCode: '303'
  }, {
    name: 'Kiili (Кийли)',
    shortCode: '305'
  }, {
    name: 'Kohila (Кохила)',
    shortCode: '317'
  }, {
    name: 'Kohtla-Järve (Кохтла-Ярве)',
    shortCode: '321'
  }, {
    name: 'Kose (Козе)',
    shortCode: '338'
  }, {
    name: 'Kuusalu (Куусалу)',
    shortCode: '353'
  }, {
    name: 'Loksa (Локса)',
    shortCode: '424'
  }, {
    name: 'Luunja (Луунья)',
    shortCode: '432'
  }, {
    name: 'Lääne-Harju (Ляэне-Харью)',
    shortCode: '431'
  }, {
    name: 'Lääne-Nigula (Ляэне-Нигула)',
    shortCode: '441'
  }, {
    name: 'Lääne-Virumaa (Ляэне-Вирумаа)',
    shortCode: '60'
  }, {
    name: 'Läänemaa (Ляэнемаа)',
    shortCode: '56'
  }, {
    name: 'Lääneranna (Ляэнеранна)',
    shortCode: '430'
  }, {
    name: 'Lüganuse (Люганузе)',
    shortCode: '442'
  }, {
    name: 'Maardu (Маарду)',
    shortCode: '446'
  }, {
    name: 'Muhu (Муху)',
    shortCode: '478'
  }, {
    name: 'Mulgi (Мулги)',
    shortCode: '480'
  }, {
    name: 'Mustvee (Мутвеэ)',
    shortCode: '486'
  }, {
    name: 'Märjamaa (Мярьямаа)',
    shortCode: '503'
  }, {
    name: 'Narva (Нарва)',
    shortCode: '511'
  }, {
    name: 'Narva-Jõesuu (Нарва-Йыэсуу)',
    shortCode: '514'
  }, {
    name: 'Nõo (Ныо)',
    shortCode: '528'
  }, {
    name: 'Otepää (Отепя)',
    shortCode: '557'
  }, {
    name: 'Paide (Пайде)',
    shortCode: '567'
  }, {
    name: 'Peipsiääre (Пейпсияэре)',
    shortCode: '586'
  }, {
    name: 'Pärnu (Пярну)',
    shortCode: '624'
  }, {
    name: 'Pärnumaa (Пярнумаа)',
    shortCode: '68'
  }, {
    name: 'Põhja-Pärnumaa (Пыхья-Пярнумаа)',
    shortCode: '638'
  }, {
    name: 'Põhja-Sakala (Пыхья-Сакала)',
    shortCode: '615'
  }, {
    name: 'Põltsamaa (Пылтсамаа)',
    shortCode: '618'
  }, {
    name: 'Põlva (Пылва)',
    shortCode: '622'
  }, {
    name: 'Põlvamaa (Пылвамаа)',
    shortCode: '64'
  }, {
    name: 'Raasiku (Раазику)',
    shortCode: '651'
  }, {
    name: 'Rae (Раэ)',
    shortCode: '653'
  }, {
    name: 'Rakvere (Раквере)',
    shortCode: '663'
  }, {
    name: 'Rakvere (Раквере (волость))',
    shortCode: '661'
  }, {
    name: 'Rapla (Рапла)',
    shortCode: '668'
  }, {
    name: 'Raplamaa (Рапламаа)',
    shortCode: '71'
  }, {
    name: 'Ruhnu (Рухну)',
    shortCode: '689'
  }, {
    name: 'Räpina (Ряпина)',
    shortCode: '708'
  }, {
    name: 'Rõuge (Рыуге)',
    shortCode: '698'
  }, {
    name: 'Saarde (Саарде)',
    shortCode: '712'
  }, {
    name: 'Saaremaa (Сааремаа (уезд))',
    shortCode: '74'
  }, {
    name: 'Saaremaa (Сааремаа)',
    shortCode: '714'
  }, {
    name: 'Saku (Саку)',
    shortCode: '719'
  }, {
    name: 'Saue (Сауэ)',
    shortCode: '726'
  }, {
    name: 'Setomaa (Сетомаа)',
    shortCode: '732'
  }, {
    name: 'Sillamäe (Силламяэ)',
    shortCode: '735'
  }, {
    name: 'Tallinn (Таллинн)',
    shortCode: '784'
  }, {
    name: 'Tapa (Тапа)',
    shortCode: '792'
  }, {
    name: 'Tartu (Тарту)',
    shortCode: '793'
  }, {
    name: 'Tartu (Тарту (волость))',
    shortCode: '796'
  }, {
    name: 'Tartumaa (Тартумаа)',
    shortCode: '79'
  }, {
    name: 'Toila (Тойла)',
    shortCode: '803'
  }, {
    name: 'Tori (Тори)',
    shortCode: '809'
  }, {
    name: 'Tõrva (Тырва)',
    shortCode: '824'
  }, {
    name: 'Türi (Тюри)',
    shortCode: '834'
  }, {
    name: 'Valga (Валга)',
    shortCode: '855'
  }, {
    name: 'Valgamaa (Валгамаа)',
    shortCode: '81'
  }, {
    name: 'Viimsi (Виймси)',
    shortCode: '890'
  }, {
    name: 'Viljandi (Вильянди)',
    shortCode: '897'
  }, {
    name: 'Viljandi (Вильянди (волость))',
    shortCode: '899'
  }, {
    name: 'Viljandimaa (Вильяндимаа)',
    shortCode: '84'
  }, {
    name: 'Vinni (Винни)',
    shortCode: '901'
  }, {
    name: 'Viru-Nigula (Виру-Нигула)',
    shortCode: '903'
  }, {
    name: 'Vormsi (Вормси)',
    shortCode: '907'
  }, {
    name: 'Väike-Maarja (Вяйке-Маарья)',
    shortCode: '928'
  }, {
    name: 'Võru (Выру)',
    shortCode: '919'
  }, {
    name: 'Võru (Выру (волость))',
    shortCode: '917'
  }, {
    name: 'Võrumaa (Вырумаа)',
    shortCode: '87'
  }]
}, {
  countryName: 'Ethiopia',
  countryShortCode: 'ET',
  regions: [{
    name: 'አዲስ አበባ',
    shortCode: 'AA'
  }, {
    name: 'አፋር',
    shortCode: 'AF'
  }, {
    name: 'አማራ',
    shortCode: 'AM'
  }, {
    name: 'ቤኔሻንጉል-ጉሙዝ',
    shortCode: 'BE'
  }, {
    name: 'ማዕከላዊ ኢትዮጵያ',
    shortCode: 'XX'
  }, {
    name: 'ድሬዳዋ',
    shortCode: 'DD'
  }, {
    name: 'ጋምቤላ',
    shortCode: 'GA'
  }, {
    name: 'ሀረሪ',
    shortCode: 'HA'
  }, {
    name: 'ኦሮሚያ',
    shortCode: 'OR'
  }, {
    name: 'ሲዳማ',
    shortCode: 'SI'
  }, {
    name: 'ሶማሌ',
    shortCode: 'SO'
  }, {
    name: 'ደቡብ ኢትዮጵያ',
    shortCode: 'SN'
  }, {
    name: 'ደቡብ ምዕራብ ኢትዮጵያ',
    shortCode: 'SW'
  }, {
    name: 'ትግራይ',
    shortCode: 'TI'
  }]
}, {
  countryName: 'Falkland Islands (Islas Malvinas)',
  countryShortCode: 'FK',
  regions: [{
    name: 'Falkland Islands (Islas Malvinas)'
  }]
}, {
  countryName: 'Faroe Islands',
  countryShortCode: 'FO',
  regions: [{
    name: 'Bordoy'
  }, {
    name: 'Eysturoy'
  }, {
    name: 'Mykines'
  }, {
    name: 'Sandoy'
  }, {
    name: 'Skuvoy'
  }, {
    name: 'Streymoy'
  }, {
    name: 'Suduroy'
  }, {
    name: 'Tvoroyri'
  }, {
    name: 'Vagar'
  }]
}, {
  countryName: 'Fiji',
  countryShortCode: 'FJ',
  regions: [{
    name: 'Ba',
    shortCode: '01'
  }, {
    name: 'Bua',
    shortCode: '02'
  }, {
    name: 'Cakaudrove',
    shortCode: '03'
  }, {
    name: 'Kadavu',
    shortCode: '04'
  }, {
    name: 'Lau',
    shortCode: '05'
  }, {
    name: 'Lomaiviti',
    shortCode: '06'
  }, {
    name: 'Macuata',
    shortCode: '07'
  }, {
    name: 'Nadroga and Navosa',
    shortCode: '08'
  }, {
    name: 'Naitasiri',
    shortCode: '09'
  }, {
    name: 'Namosi',
    shortCode: '10'
  }, {
    name: 'Ra',
    shortCode: '11'
  }, {
    name: 'Rewa',
    shortCode: '12'
  }, {
    name: 'Rotuma',
    shortCode: 'R'
  }, {
    name: 'Serua',
    shortCode: '13'
  }, {
    name: 'Tailevu',
    shortCode: '14'
  }]
}, {
  countryName: 'Finland',
  countryShortCode: 'FI',
  regions: [{
    name: 'Ahvenanmaan maakunta',
    shortCode: 'FI-01'
  }, {
    name: 'Etelä-Karjala',
    shortCode: 'FI-02'
  }, {
    name: 'Etelä-Pohjanmaa',
    shortCode: 'FI-03'
  }, {
    name: 'Etelä-Savo',
    shortCode: 'FI-04'
  }, {
    name: 'Kainuu',
    shortCode: 'FI-05'
  }, {
    name: 'Kanta-Häme',
    shortCode: 'FI-06'
  }, {
    name: 'Keski-Pohjanmaa',
    shortCode: 'FI-07'
  }, {
    name: 'Keski-Suomi',
    shortCode: 'FI-08'
  }, {
    name: 'Kymenlaakso',
    shortCode: 'FI-09'
  }, {
    name: 'Lappi',
    shortCode: 'FI-10'
  }, {
    name: 'Pirkanmaa',
    shortCode: 'FI-11'
  }, {
    name: 'Pohjanmaa',
    shortCode: 'FI-12'
  }, {
    name: 'Pohjois-Karjala',
    shortCode: 'FI-13'
  }, {
    name: 'Pohjois-Pohjanmaa',
    shortCode: 'FI-14'
  }, {
    name: 'Pohjois-Savo',
    shortCode: 'FI-15'
  }, {
    name: 'Päijät-Häme',
    shortCode: 'FI-16'
  }, {
    name: 'Satakunta',
    shortCode: 'FI-17'
  }, {
    name: 'Uusimaa',
    shortCode: 'FI-18'
  }, {
    name: 'Varsinais-Suomi',
    shortCode: 'FI-19'
  }]
}, {
  countryName: 'France',
  countryShortCode: 'FR',
  regions: [{
    name: 'Auvergne-Rhône-Alpes',
    shortCode: 'ARA'
  }, {
    name: 'Bourgogne-Franche-Comté',
    shortCode: 'BFC'
  }, {
    name: 'Bretagne',
    shortCode: 'BRE'
  }, {
    name: 'Centre-Val de Loire',
    shortCode: 'CVL'
  }, {
    name: 'Corse',
    shortCode: 'COR'
  }, {
    name: 'Grand Est',
    shortCode: 'GES'
  }, {
    name: 'Hauts-de-France',
    shortCode: 'HDF'
  }, {
    name: 'Île-de-France',
    shortCode: 'IDF'
  }, {
    name: 'Normandie',
    shortCode: 'NOR'
  }, {
    name: 'Nouvelle-Aquitaine',
    shortCode: 'NAQ'
  }, {
    name: 'Occitanie',
    shortCode: 'OCC'
  }, {
    name: 'Pays de la Loire',
    shortCode: 'PDL'
  }, {
    name: "Provence-Alpes-Cote d'Azur",
    shortCode: 'PAC'
  }, {
    name: 'Clipperton',
    shortCode: 'CP'
  }, {
    name: 'Guadeloupe',
    shortCode: 'GP'
  }, {
    name: 'Guyane',
    shortCode: 'GF'
  }, {
    name: 'Martinique',
    shortCode: 'MQ'
  }, {
    name: 'Mayotte',
    shortCode: 'YT'
  }, {
    name: 'Novelle-Calédonie',
    shortCode: 'NC'
  }, {
    name: 'Polynésie',
    shortCode: 'PF'
  }, {
    name: 'Saint-Pierre-et-Miquelon',
    shortCode: 'PM'
  }, {
    name: 'Saint Barthélemy',
    shortCode: 'BL'
  }, {
    name: 'Saint Martin',
    shortCode: 'MF'
  }, {
    name: 'Réunion',
    shortCode: 'RE'
  }, {
    name: 'Terres Australes Françaises',
    shortCode: 'TF'
  }, {
    name: 'Wallis-et-Futuna',
    shortCode: 'WF'
  }]
}, {
  countryName: 'French Guiana',
  countryShortCode: 'GF',
  regions: [{
    name: 'French Guiana'
  }]
}, {
  countryName: 'French Polynesia',
  countryShortCode: 'PF',
  regions: [{
    name: 'Archipel des Marquises'
  }, {
    name: 'Archipel des Tuamotu'
  }, {
    name: 'Archipel des Tubuai'
  }, {
    name: 'Iles du Vent'
  }, {
    name: 'Iles Sous-le-Vent'
  }]
}, {
  countryName: 'French Southern and Antarctic Lands',
  countryShortCode: 'TF',
  regions: [{
    name: 'Adelie Land'
  }, {
    name: 'Ile Crozet'
  }, {
    name: 'Iles Kerguelen'
  }, {
    name: 'Iles Saint-Paul et Amsterdam'
  }]
}, {
  countryName: 'Gabon',
  countryShortCode: 'GA',
  regions: [{
    name: 'Estuaire',
    shortCode: '1'
  }, {
    name: 'Haut-Ogooué',
    shortCode: '2'
  }, {
    name: 'Moyen-Ogooué',
    shortCode: '3'
  }, {
    name: 'Ngounié',
    shortCode: '4'
  }, {
    name: 'Nyanga',
    shortCode: '5'
  }, {
    name: 'Ogooué-Ivindo',
    shortCode: '6'
  }, {
    name: 'Ogooué-Lolo',
    shortCode: '7'
  }, {
    name: 'Ogooué-Maritime',
    shortCode: '8'
  }, {
    name: 'Woleu-Ntem',
    shortCode: '9'
  }]
}, {
  countryName: 'Gambia, The',
  countryShortCode: 'GM',
  regions: [{
    name: 'Banjul',
    shortCode: 'B'
  }, {
    name: 'Central River',
    shortCode: 'M'
  }, {
    name: 'Lower River',
    shortCode: 'L'
  }, {
    name: 'North Bank',
    shortCode: 'N'
  }, {
    name: 'Upper River',
    shortCode: 'U'
  }, {
    name: 'Western',
    shortCode: 'W'
  }]
}, {
  countryName: 'Georgia',
  countryShortCode: 'GE',
  regions: [{
    name: 'Abkhazia (Sokhumi)',
    shortCode: 'AB'
  }, {
    name: "Ajaria (Bat'umi)",
    shortCode: 'AJ'
  }, {
    name: 'Guria',
    shortCode: 'GU'
  }, {
    name: 'Imereti',
    shortCode: 'IM'
  }, {
    name: "K'akheti",
    shortCode: 'KA'
  }, {
    name: 'Kvemo Kartli',
    shortCode: 'KK'
  }, {
    name: 'Mtshkheta-Mtianeti',
    shortCode: 'MM'
  }, {
    name: "Rach'a-Lexhkumi-KvemoSvaneti",
    shortCode: 'RL'
  }, {
    name: 'Samegrelo-Zemo Svaneti',
    shortCode: 'SZ'
  }, {
    name: 'Samtskhe-Javakheti',
    shortCode: 'SJ'
  }, {
    name: 'Shida Kartli',
    shortCode: 'SK'
  }, {
    name: 'Tbilisi',
    shortCode: 'TB'
  }]
}, {
  countryName: 'Germany',
  countryShortCode: 'DE',
  regions: [{
    name: 'Baden-Württemberg',
    shortCode: 'BW'
  }, {
    name: 'Bayern',
    shortCode: 'BY'
  }, {
    name: 'Berlin',
    shortCode: 'BE'
  }, {
    name: 'Brandenburg',
    shortCode: 'BB'
  }, {
    name: 'Bremen',
    shortCode: 'HB'
  }, {
    name: 'Hamburg',
    shortCode: 'HH'
  }, {
    name: 'Hessen',
    shortCode: 'HE'
  }, {
    name: 'Mecklenburg-Vorpommern',
    shortCode: 'MV'
  }, {
    name: 'Niedersachsen',
    shortCode: 'NI'
  }, {
    name: 'Nordrhein-Westfalen',
    shortCode: 'NW'
  }, {
    name: 'Rheinland-Pfalz',
    shortCode: 'RP'
  }, {
    name: 'Saarland',
    shortCode: 'SL'
  }, {
    name: 'Sachsen',
    shortCode: 'SN'
  }, {
    name: 'Sachsen-Anhalt',
    shortCode: 'ST'
  }, {
    name: 'Schleswig-Holstein',
    shortCode: 'SH'
  }, {
    name: 'Thüringen',
    shortCode: 'TH'
  }]
}, {
  countryName: 'Ghana',
  countryShortCode: 'GH',
  regions: [{
    name: 'Ahafo'
  }, {
    name: 'Ashanti',
    shortCode: 'AH'
  }, {
    name: 'Bono'
  }, {
    name: 'Bono East'
  }, {
    name: 'Central',
    shortCode: 'CP'
  }, {
    name: 'Eastern',
    shortCode: 'EP'
  }, {
    name: 'Greater Accra',
    shortCode: 'AA'
  }, {
    name: 'Northern',
    shortCode: 'NP'
  }, {
    name: 'North East'
  }, {
    name: 'Oti'
  }, {
    name: 'Savannah'
  }, {
    name: 'Upper East',
    shortCode: 'UE'
  }, {
    name: 'Upper West',
    shortCode: 'UW'
  }, {
    name: 'Volta',
    shortCode: 'TV'
  }, {
    name: 'Western',
    shortCode: 'WP'
  }, {
    name: 'Western North'
  }]
}, {
  countryName: 'Gibraltar',
  countryShortCode: 'GI',
  regions: [{
    name: 'Gibraltar'
  }]
}, {
  countryName: 'Greece',
  countryShortCode: 'GR',
  regions: [{
    name: 'Anatolikí Makedonía kai Thráki',
    shortCode: 'A'
  }, {
    name: 'Attikḯ',
    shortCode: 'I'
  }, {
    name: 'Dytikí Elláda',
    shortCode: 'G'
  }, {
    name: 'Dytikí Makedonía',
    shortCode: 'C'
  }, {
    name: 'Ionía Nísia',
    shortCode: 'F'
  }, {
    name: 'Kentrikí Makedonía',
    shortCode: 'B'
  }, {
    name: 'Krítí',
    shortCode: 'M'
  }, {
    name: 'Notío Aigaío',
    shortCode: 'L'
  }, {
    name: 'Peloponnísos',
    shortCode: 'J'
  }, {
    name: 'Stereá Elláda',
    shortCode: 'H'
  }, {
    name: 'Thessalía',
    shortCode: 'E'
  }, {
    name: 'Voreío Aigaío',
    shortCode: 'K'
  }, {
    name: 'Ípeiros',
    shortCode: 'D'
  }, {
    name: 'Ágion Óros',
    shortCode: '69'
  }]
}, {
  countryName: 'Greenland',
  countryShortCode: 'GL',
  regions: [{
    name: 'Kommune Kujalleq',
    shortCode: 'KU'
  }, {
    name: 'Kommuneqarfik Sermersooq',
    shortCode: 'SM'
  }, {
    name: 'Qaasuitsup Kommunia',
    shortCode: 'QA'
  }, {
    name: 'Qeqqata Kommunia',
    shortCode: 'QE'
  }]
}, {
  countryName: 'Grenada',
  countryShortCode: 'GD',
  regions: [{
    name: 'Saint Andrew',
    shortCode: '01'
  }, {
    name: 'Saint David',
    shortCode: '02'
  }, {
    name: 'Saint George',
    shortCode: '03'
  }, {
    name: 'Saint John',
    shortCode: '04'
  }, {
    name: 'Saint Mark',
    shortCode: '05'
  }, {
    name: 'Saint Patrick',
    shortCode: '06'
  }, {
    name: 'Southern Grenadine Islands',
    shortCode: '10'
  }]
}, {
  countryName: 'Guadeloupe',
  countryShortCode: 'GP',
  regions: [{
    name: 'Guadeloupe'
  }]
}, {
  countryName: 'Guam',
  countryShortCode: 'GU',
  regions: [{
    name: 'Guam'
  }]
}, {
  countryName: 'Guatemala',
  countryShortCode: 'GT',
  regions: [{
    name: 'Alta Verapaz',
    shortCode: 'AV'
  }, {
    name: 'Baja Verapaz',
    shortCode: 'BV'
  }, {
    name: 'Chimaltenango',
    shortCode: 'CM'
  }, {
    name: 'Chiquimula',
    shortCode: 'CQ'
  }, {
    name: 'El Progreso',
    shortCode: 'PR'
  }, {
    name: 'Escuintla',
    shortCode: 'ES'
  }, {
    name: 'Guatemala',
    shortCode: 'GU'
  }, {
    name: 'Huehuetenango',
    shortCode: 'HU'
  }, {
    name: 'Izabal',
    shortCode: 'IZ'
  }, {
    name: 'Jalapa',
    shortCode: 'JA'
  }, {
    name: 'Jutiapa',
    shortCode: 'JU'
  }, {
    name: 'Petén',
    shortCode: 'PE'
  }, {
    name: 'Quetzaltenango',
    shortCode: 'QZ'
  }, {
    name: 'Quiché',
    shortCode: 'QC'
  }, {
    name: 'Retalhuleu',
    shortCode: 'Re'
  }, {
    name: 'Sacatepéquez',
    shortCode: 'SA'
  }, {
    name: 'San Marcos',
    shortCode: 'SM'
  }, {
    name: 'Santa Rosa',
    shortCode: 'SR'
  }, {
    name: 'Sololá',
    shortCode: 'SO'
  }, {
    name: 'Suchitepéquez',
    shortCode: 'SU'
  }, {
    name: 'Totonicapán',
    shortCode: 'TO'
  }, {
    name: 'Zacapa',
    shortCode: 'ZA'
  }]
}, {
  countryName: 'Guernsey',
  countryShortCode: 'GG',
  regions: [{
    name: 'Castel'
  }, {
    name: 'Forest'
  }, {
    name: 'St. Andrew'
  }, {
    name: 'St. Martin'
  }, {
    name: 'St. Peter Port'
  }, {
    name: 'St. Pierre du Bois'
  }, {
    name: 'St. Sampson'
  }, {
    name: 'St. Saviour'
  }, {
    name: 'Torteval'
  }, {
    name: 'Vale'
  }]
}, {
  countryName: 'Guinea',
  countryShortCode: 'GN',
  regions: [{
    name: 'Boké',
    shortCode: 'B'
  }, {
    name: 'Conakry',
    shortCode: 'C'
  }, {
    name: 'Faranah',
    shortCode: 'F'
  }, {
    name: 'Kankan',
    shortCode: 'K'
  }, {
    name: 'Kindia',
    shortCode: 'D'
  }, {
    name: 'Labé',
    shortCode: 'L'
  }, {
    name: 'Mamou',
    shortCode: 'M'
  }, {
    name: 'Nzérékoré',
    shortCode: 'N'
  }]
}, {
  countryName: 'Guinea-Bissau',
  countryShortCode: 'GW',
  regions: [{
    name: 'Bafatá',
    shortCode: 'BA'
  }, {
    name: 'Biombo',
    shortCode: 'BM'
  }, {
    name: 'Bissau',
    shortCode: 'BS'
  }, {
    name: 'Bolama-Bijagos',
    shortCode: 'BL'
  }, {
    name: 'Cacheu',
    shortCode: 'CA'
  }, {
    name: 'Gabú',
    shortCode: 'GA'
  }, {
    name: 'Oio',
    shortCode: 'OI'
  }, {
    name: 'Quinara',
    shortCode: 'QU'
  }, {
    name: 'Tombali',
    shortCode: 'TO'
  }]
}, {
  countryName: 'Guyana',
  countryShortCode: 'GY',
  regions: [{
    name: 'Barima-Waini',
    shortCode: 'BA'
  }, {
    name: 'Cuyuni-Mazaruni',
    shortCode: 'CU'
  }, {
    name: 'Demerara-Mahaica',
    shortCode: 'DE'
  }, {
    name: 'East Berbice-Corentyne',
    shortCode: 'EB'
  }, {
    name: 'Essequibo Islands-West Demerara',
    shortCode: 'ES'
  }, {
    name: 'Mahaica-Berbice',
    shortCode: 'MA'
  }, {
    name: 'Pomeroon-Supenaam',
    shortCode: 'PM'
  }, {
    name: 'Potaro-Siparuni',
    shortCode: 'PT'
  }, {
    name: 'Upper Demerara-Berbice',
    shortCode: 'UD'
  }, {
    name: 'Upper Takutu-Upper Essequibo',
    shortCode: 'UT'
  }]
}, {
  countryName: 'Haiti',
  countryShortCode: 'HT',
  regions: [{
    name: 'Artibonite',
    shortCode: 'AR'
  }, {
    name: 'Centre',
    shortCode: 'CE'
  }, {
    name: "Grand'Anse",
    shortCode: 'GA'
  }, {
    name: 'Nippes',
    shortCode: 'NI'
  }, {
    name: 'Nord',
    shortCode: 'ND'
  }, {
    name: 'Nord-Est',
    shortCode: 'NE'
  }, {
    name: 'Nord-Ouest',
    shortCode: 'NO'
  }, {
    name: 'Ouest',
    shortCode: 'OU'
  }, {
    name: 'Sud',
    shortCode: 'SD'
  }, {
    name: 'Sud-Est',
    shortCode: 'SE'
  }]
}, {
  countryName: 'Heard Island and McDonald Islands',
  countryShortCode: 'HM',
  regions: [{
    name: 'Heard Island and McDonald Islands'
  }]
}, {
  countryName: 'Holy See (Vatican City)',
  countryShortCode: 'VA',
  regions: [{
    name: 'Holy See (Vatican City)',
    shortCode: '01'
  }]
}, {
  countryName: 'Honduras',
  countryShortCode: 'HN',
  regions: [{
    name: 'Atlántida',
    shortCode: 'AT'
  }, {
    name: 'Choluteca',
    shortCode: 'CH'
  }, {
    name: 'Colón',
    shortCode: 'CL'
  }, {
    name: 'Comayagua',
    shortCode: 'CM'
  }, {
    name: 'Copán',
    shortCode: 'CP'
  }, {
    name: 'Cortés',
    shortCode: 'CR'
  }, {
    name: 'El Paraíso',
    shortCode: 'EP'
  }, {
    name: 'Francisco Morazan',
    shortCode: 'FM'
  }, {
    name: 'Gracias a Dios',
    shortCode: 'GD'
  }, {
    name: 'Intibucá',
    shortCode: 'IN'
  }, {
    name: 'Islas de la Bahía',
    shortCode: 'IB'
  }, {
    name: 'La Paz',
    shortCode: 'LP'
  }, {
    name: 'Lempira',
    shortCode: 'LE'
  }, {
    name: 'Ocotepeque',
    shortCode: 'OC'
  }, {
    name: 'Olancho',
    shortCode: 'OL'
  }, {
    name: 'Santa Bárbara',
    shortCode: 'SB'
  }, {
    name: 'Valle',
    shortCode: 'VA'
  }, {
    name: 'Yoro',
    shortCode: 'YO'
  }]
}, {
  countryName: 'Hong Kong',
  countryShortCode: 'HK',
  regions: [{
    name: 'Hong Kong',
    shortCode: 'HK'
  }]
}, {
  countryName: 'Hungary',
  countryShortCode: 'HU',
  regions: [{
    name: 'Bács-Kiskun',
    shortCode: 'BK'
  }, {
    name: 'Baranya',
    shortCode: 'BA'
  }, {
    name: 'Békés',
    shortCode: 'BE'
  }, {
    name: 'Békéscsaba',
    shortCode: 'BC'
  }, {
    name: 'Borsod-Abauj-Zemplen',
    shortCode: 'BZ'
  }, {
    name: 'Budapest',
    shortCode: 'BU'
  }, {
    name: 'Csongrád',
    shortCode: 'CS'
  }, {
    name: 'Debrecen',
    shortCode: 'DE'
  }, {
    name: 'Dunaújváros',
    shortCode: 'DU'
  }, {
    name: 'Eger',
    shortCode: 'EG'
  }, {
    name: 'Érd',
    shortCode: 'ER'
  }, {
    name: 'Fejér',
    shortCode: 'FE'
  }, {
    name: 'Győr',
    shortCode: 'GY'
  }, {
    name: 'Győr-Moson-Sopron',
    shortCode: 'GS'
  }, {
    name: 'Hajdú-Bihar',
    shortCode: 'HB'
  }, {
    name: 'Heves',
    shortCode: 'HE'
  }, {
    name: 'Hódmezővásárhely',
    shortCode: 'HV'
  }, {
    name: 'Jász-Nagykun-Szolnok',
    shortCode: 'N'
  }, {
    name: 'Kaposvár',
    shortCode: 'KV'
  }, {
    name: 'Kecskemét',
    shortCode: 'KM'
  }, {
    name: 'Komárom-Esztergom',
    shortCode: 'KE'
  }, {
    name: 'Miskolc',
    shortCode: 'MI'
  }, {
    name: 'Nagykanizsa',
    shortCode: 'NK'
  }, {
    name: 'Nógrád',
    shortCode: 'NO'
  }, {
    name: 'Nyíregyháza',
    shortCode: 'NY'
  }, {
    name: 'Pécs',
    shortCode: 'PS'
  }, {
    name: 'Pest',
    shortCode: 'PE'
  }, {
    name: 'Salgótarján',
    shortCode: 'ST'
  }, {
    name: 'Somogy',
    shortCode: 'SO'
  }, {
    name: 'Sopron',
    shortCode: 'SN'
  }, {
    name: 'Szabolcs-á-Bereg',
    shortCode: 'SZ'
  }, {
    name: 'Szeged',
    shortCode: 'SD'
  }, {
    name: 'Székesfehérvár',
    shortCode: 'SF'
  }, {
    name: 'Szekszárd',
    shortCode: 'SS'
  }, {
    name: 'Szolnok',
    shortCode: 'SK'
  }, {
    name: 'Szombathely',
    shortCode: 'SH'
  }, {
    name: 'Tatabánya',
    shortCode: 'TB'
  }, {
    name: 'Tolna',
    shortCode: 'TO'
  }, {
    name: 'Vas',
    shortCode: 'VA'
  }, {
    name: 'Veszprém',
    shortCode: 'VE'
  }, {
    name: 'Veszprém (City)',
    shortCode: 'VM'
  }, {
    name: 'Zala',
    shortCode: 'ZA'
  }, {
    name: 'Zalaegerszeg',
    shortCode: 'ZE'
  }]
}, {
  countryName: 'Iceland',
  countryShortCode: 'IS',
  regions: [{
    name: 'Austurland',
    shortCode: '7'
  }, {
    name: 'Höfuðborgarsvæði utan Reykjavíkur',
    shortCode: '1'
  }, {
    name: 'Norðurland eystra',
    shortCode: '6'
  }, {
    name: 'Norðurland vestra',
    shortCode: '5'
  }, {
    name: 'Suðurland',
    shortCode: '8'
  }, {
    name: 'Suðurnes',
    shortCode: '2'
  }, {
    name: 'Vestfirðir',
    shortCode: '4'
  }, {
    name: 'Vesturland',
    shortCode: '3'
  }]
}, {
  countryName: 'India',
  countryShortCode: 'IN',
  regions: [{
    name: 'Andaman and Nicobar Islands',
    shortCode: 'AN'
  }, {
    name: 'Andhra Pradesh',
    shortCode: 'AP'
  }, {
    name: 'Arunachal Pradesh',
    shortCode: 'AR'
  }, {
    name: 'Assam',
    shortCode: 'AS'
  }, {
    name: 'Bihar',
    shortCode: 'BR'
  }, {
    name: 'Chandigarh',
    shortCode: 'CH'
  }, {
    name: 'Chhattisgarh',
    shortCode: 'CT'
  }, {
    name: 'Dadra and Nagar Haveli',
    shortCode: 'DN'
  }, {
    name: 'Daman and Diu',
    shortCode: 'DD'
  }, {
    name: 'Delhi',
    shortCode: 'DL'
  }, {
    name: 'Goa',
    shortCode: 'GA'
  }, {
    name: 'Gujarat',
    shortCode: 'GJ'
  }, {
    name: 'Haryana',
    shortCode: 'HR'
  }, {
    name: 'Himachal Pradesh',
    shortCode: 'HP'
  }, {
    name: 'Jammu and Kashmir',
    shortCode: 'JK'
  }, {
    name: 'Jharkhand',
    shortCode: 'JH'
  }, {
    name: 'Karnataka',
    shortCode: 'KA'
  }, {
    name: 'Kerala',
    shortCode: 'KL'
  }, {
    name: 'Lakshadweep',
    shortCode: 'LD'
  }, {
    name: 'Madhya Pradesh',
    shortCode: 'MP'
  }, {
    name: 'Maharashtra',
    shortCode: 'MH'
  }, {
    name: 'Manipur',
    shortCode: 'MN'
  }, {
    name: 'Meghalaya',
    shortCode: 'ML'
  }, {
    name: 'Mizoram',
    shortCode: 'MZ'
  }, {
    name: 'Nagaland',
    shortCode: 'NL'
  }, {
    name: 'Odisha',
    shortCode: 'OR'
  }, {
    name: 'Puducherry',
    shortCode: 'PY'
  }, {
    name: 'Punjab',
    shortCode: 'PB'
  }, {
    name: 'Rajasthan',
    shortCode: 'RJ'
  }, {
    name: 'Sikkim',
    shortCode: 'WK'
  }, {
    name: 'Tamil Nadu',
    shortCode: 'TN'
  }, {
    name: 'Telangana',
    shortCode: 'TG'
  }, {
    name: 'Tripura',
    shortCode: 'TR'
  }, {
    name: 'Uttarakhand',
    shortCode: 'UT'
  }, {
    name: 'Uttar Pradesh',
    shortCode: 'UP'
  }, {
    name: 'West Bengal',
    shortCode: 'WB'
  }]
}, {
  countryName: 'Indonesia',
  countryShortCode: 'ID',
  regions: [{
    name: 'Aceh',
    shortCode: 'AC'
  }, {
    name: 'Bali',
    shortCode: 'BA'
  }, {
    name: 'Bangka Belitung',
    shortCode: 'BB'
  }, {
    name: 'Banten',
    shortCode: 'BT'
  }, {
    name: 'Bengkulu',
    shortCode: 'BE'
  }, {
    name: 'Gorontalo',
    shortCode: 'GO'
  }, {
    name: 'Jakarta Raya',
    shortCode: 'JK'
  }, {
    name: 'Jambi',
    shortCode: 'JA'
  }, {
    name: 'Jawa Barat',
    shortCode: 'JB'
  }, {
    name: 'Jawa Tengah',
    shortCode: 'JT'
  }, {
    name: 'Jawa Timur',
    shortCode: 'JI'
  }, {
    name: 'Kalimantan Barat',
    shortCode: 'KB'
  }, {
    name: 'Kalimantan Selatan',
    shortCode: 'KS'
  }, {
    name: 'Kalimantan Tengah',
    shortCode: 'KT'
  }, {
    name: 'Kalimantan Timur',
    shortCode: 'KI'
  }, {
    name: 'Kalimantan Utara',
    shortCode: 'KU'
  }, {
    name: 'Kepulauan Riau',
    shortCode: 'KR'
  }, {
    name: 'Lampung',
    shortCode: 'LA'
  }, {
    name: 'Maluku',
    shortCode: 'MA'
  }, {
    name: 'Maluku Utara',
    shortCode: 'MU'
  }, {
    name: 'Nusa Tenggara Barat',
    shortCode: 'NB'
  }, {
    name: 'Nusa Tenggara Timur',
    shortCode: 'NT'
  }, {
    name: 'Papua',
    shortCode: 'PA'
  }, {
    name: 'Papua Barat',
    shortCode: 'PB'
  }, {
    name: 'Riau',
    shortCode: 'RI'
  }, {
    name: 'Sulawesi Selatan',
    shortCode: 'SR'
  }, {
    name: 'Sulawesi Tengah',
    shortCode: 'ST'
  }, {
    name: 'Sulawesi Tenggara',
    shortCode: 'SG'
  }, {
    name: 'Sulawesi Utara',
    shortCode: 'SA'
  }, {
    name: 'Sumatera Barat',
    shortCode: 'SB'
  }, {
    name: 'Sumatera Selatan',
    shortCode: 'SS'
  }, {
    name: 'Sumatera Utara',
    shortCode: 'SU'
  }, {
    name: 'Yogyakarta',
    shortCode: 'YO'
  }]
}, {
  countryName: 'Iran, Islamic Republic of',
  countryShortCode: 'IR',
  regions: [{
    name: 'Alborz',
    shortCode: '32'
  }, {
    name: 'Ardabīl',
    shortCode: '03'
  }, {
    name: 'Āz̄arbāyjān-e Gharbī',
    shortCode: '02'
  }, {
    name: 'Āz̄arbāyjān-e Sharqī',
    shortCode: '01'
  }, {
    name: 'Būshehr',
    shortCode: '06'
  }, {
    name: 'Chahār Maḩāl va Bakhtīārī',
    shortCode: '08'
  }, {
    name: 'Eşfahān',
    shortCode: '04'
  }, {
    name: 'Fārs',
    shortCode: '14'
  }, {
    name: 'Gīlān',
    shortCode: '19'
  }, {
    name: 'Golestān',
    shortCode: '27'
  }, {
    name: 'Hamadān',
    shortCode: '24'
  }, {
    name: 'Hormozgān',
    shortCode: '23'
  }, {
    name: 'Īlām',
    shortCode: '05'
  }, {
    name: 'Kermān',
    shortCode: '15'
  }, {
    name: 'Kermānshāh',
    shortCode: '17'
  }, {
    name: 'Khorāsān-e Jonūbī',
    shortCode: '29'
  }, {
    name: 'Khorāsān-e Raẕavī',
    shortCode: '30'
  }, {
    name: 'Khorāsān-e Shomālī',
    shortCode: '61'
  }, {
    name: 'Khūzestān',
    shortCode: '10'
  }, {
    name: 'Kohgīlūyeh va Bowyer Aḩmad',
    shortCode: '18'
  }, {
    name: 'Kordestān',
    shortCode: '16'
  }, {
    name: 'Lorestān',
    shortCode: '20'
  }, {
    name: 'Markazi',
    shortCode: '22'
  }, {
    name: 'Māzandarān',
    shortCode: '21'
  }, {
    name: 'Qazvīn',
    shortCode: '28'
  }, {
    name: 'Qom',
    shortCode: '26'
  }, {
    name: 'Semnān',
    shortCode: '12'
  }, {
    name: 'Sīstān va Balūchestān',
    shortCode: '13'
  }, {
    name: 'Tehrān',
    shortCode: '07'
  }, {
    name: 'Yazd',
    shortCode: '25'
  }, {
    name: 'Zanjān',
    shortCode: '11'
  }]
}, {
  countryName: 'Iraq',
  countryShortCode: 'IQ',
  regions: [{
    name: 'Al Anbār',
    shortCode: 'AN'
  }, {
    name: 'Al Başrah',
    shortCode: 'BA'
  }, {
    name: 'Al Muthanná',
    shortCode: 'MU'
  }, {
    name: 'Al Qādisīyah',
    shortCode: 'QA'
  }, {
    name: 'An Najaf',
    shortCode: 'NA'
  }, {
    name: 'Arbīl',
    shortCode: 'AR'
  }, {
    name: 'As Sulaymānīyah',
    shortCode: 'SU'
  }, {
    name: 'Bābil',
    shortCode: 'BB'
  }, {
    name: 'Baghdād',
    shortCode: 'BG'
  }, {
    name: 'Dohuk',
    shortCode: 'DA'
  }, {
    name: 'Dhī Qār',
    shortCode: 'DQ'
  }, {
    name: 'Diyālá',
    shortCode: 'DI'
  }, {
    name: "Karbalā'",
    shortCode: 'KA'
  }, {
    name: 'Kirkuk',
    shortCode: 'KI'
  }, {
    name: 'Maysān',
    shortCode: 'MA'
  }, {
    name: 'Nīnawá',
    shortCode: 'NI'
  }, {
    name: 'Şalāḩ ad Dīn',
    shortCode: 'SD'
  }, {
    name: 'Wāsiţ',
    shortCode: 'WA'
  }]
}, {
  countryName: 'Ireland',
  countryShortCode: 'IE',
  regions: [{
    name: 'Carlow',
    shortCode: 'CW'
  }, {
    name: 'Cavan',
    shortCode: 'CN'
  }, {
    name: 'Clare',
    shortCode: 'CE'
  }, {
    name: 'Cork',
    shortCode: 'CO'
  }, {
    name: 'Donegal',
    shortCode: 'DL'
  }, {
    name: 'Dublin',
    shortCode: 'D'
  }, {
    name: 'Galway',
    shortCode: 'G'
  }, {
    name: 'Kerry',
    shortCode: 'KY'
  }, {
    name: 'Kildare',
    shortCode: 'KE'
  }, {
    name: 'Kilkenny',
    shortCode: 'KK'
  }, {
    name: 'Laois',
    shortCode: 'LS'
  }, {
    name: 'Leitrim',
    shortCode: 'LM'
  }, {
    name: 'Limerick',
    shortCode: 'LK'
  }, {
    name: 'Longford',
    shortCode: 'LD'
  }, {
    name: 'Louth',
    shortCode: 'LH'
  }, {
    name: 'Mayo',
    shortCode: 'MO'
  }, {
    name: 'Meath',
    shortCode: 'MH'
  }, {
    name: 'Monaghan',
    shortCode: 'MN'
  }, {
    name: 'Offaly',
    shortCode: 'OY'
  }, {
    name: 'Roscommon',
    shortCode: 'RN'
  }, {
    name: 'Sligo',
    shortCode: 'SO'
  }, {
    name: 'Tipperary',
    shortCode: 'TA'
  }, {
    name: 'Waterford',
    shortCode: 'WD'
  }, {
    name: 'Westmeath',
    shortCode: 'WH'
  }, {
    name: 'Wexford',
    shortCode: 'WX'
  }, {
    name: 'Wicklow',
    shortCode: 'WW'
  }]
}, {
  countryName: 'Isle of Man',
  countryShortCode: 'IM',
  regions: [{
    name: 'Isle of Man'
  }]
}, {
  countryName: 'Israel',
  countryShortCode: 'IL',
  regions: [{
    name: 'HaDarom',
    shortCode: 'D'
  }, {
    name: 'HaMerkaz',
    shortCode: 'M'
  }, {
    name: 'HaTsafon',
    shortCode: 'Z'
  }, {
    name: 'H̱efa',
    shortCode: 'HA'
  }, {
    name: 'Tel-Aviv',
    shortCode: 'TA'
  }, {
    name: 'Yerushalayim',
    shortCode: 'JM'
  }]
}, {
  countryName: 'Italy',
  countryShortCode: 'IT',
  regions: [{
    name: 'Abruzzo',
    shortCode: '65'
  }, {
    name: 'Basilicata',
    shortCode: '77'
  }, {
    name: 'Calabria',
    shortCode: '78'
  }, {
    name: 'Campania',
    shortCode: '72'
  }, {
    name: 'Emilia-Romagna',
    shortCode: '45'
  }, {
    name: 'Friuli-Venezia Giulia',
    shortCode: '36'
  }, {
    name: 'Lazio',
    shortCode: '62'
  }, {
    name: 'Liguria',
    shortCode: '42'
  }, {
    name: 'Lombardia',
    shortCode: '25'
  }, {
    name: 'Marche',
    shortCode: '57'
  }, {
    name: 'Molise',
    shortCode: '67'
  }, {
    name: 'Piemonte',
    shortCode: '21'
  }, {
    name: 'Puglia',
    shortCode: '75'
  }, {
    name: 'Sardegna',
    shortCode: '88'
  }, {
    name: 'Sicilia',
    shortCode: '82'
  }, {
    name: 'Toscana',
    shortCode: '52'
  }, {
    name: 'Trentino-Alto Adige',
    shortCode: '32'
  }, {
    name: 'Umbria',
    shortCode: '55'
  }, {
    name: "Valle d'Aosta",
    shortCode: '23'
  }, {
    name: 'Veneto',
    shortCode: '34'
  }]
}, {
  countryName: 'Jamaica',
  countryShortCode: 'JM',
  regions: [{
    name: 'Clarendon',
    shortCode: '13'
  }, {
    name: 'Hanover',
    shortCode: '09'
  }, {
    name: 'Kingston',
    shortCode: '01'
  }, {
    name: 'Manchester',
    shortCode: '12'
  }, {
    name: 'Portland',
    shortCode: '04'
  }, {
    name: 'Saint Andrew',
    shortCode: '02'
  }, {
    name: 'Saint Ann',
    shortCode: '06'
  }, {
    name: 'Saint Catherine',
    shortCode: '14'
  }, {
    name: 'Saint Elizabeth',
    shortCode: '11'
  }, {
    name: 'Saint James',
    shortCode: '08'
  }, {
    name: 'Saint Mary',
    shortCode: '05'
  }, {
    name: 'Saint Thomas',
    shortCode: '03'
  }, {
    name: 'Trelawny',
    shortCode: '07'
  }, {
    name: 'Westmoreland',
    shortCode: '10'
  }]
}, {
  countryName: 'Japan',
  countryShortCode: 'JP',
  regions: [{
    name: '青森県',
    // Aomori
    shortCode: '02'
  }, {
    name: '秋田県',
    // Akita
    shortCode: '03'
  }, {
    name: '石川県',
    // Ishikawa
    shortCode: '04'
  }, {
    name: '茨城県',
    // Ibaraki
    shortCode: '05'
  }, {
    name: '岩手県',
    // Iwate
    shortCode: '06'
  }, {
    name: '愛媛県',
    // Ehime
    shortCode: '07'
  }, {
    name: '大分県',
    // Oita
    shortCode: '08'
  }, {
    name: '大阪府',
    // Osaka
    shortCode: '09'
  }, {
    name: '岡山県',
    // Okayama
    shortCode: '10'
  }, {
    name: '沖縄県',
    // Okinawa
    shortCode: '11'
  }, {
    name: '香川県',
    // Kagawa
    shortCode: '12'
  }, {
    name: '鹿児島県',
    // Kagoshima
    shortCode: '13'
  }, {
    name: '神奈川県',
    // Kanagawa
    shortCode: '14'
  }, {
    name: '岐阜県',
    // Gifu
    shortCode: '15'
  }, {
    name: '京都府',
    // Kyoto
    shortCode: '16'
  }, {
    name: '熊本県',
    // Kumamoto
    shortCode: '17'
  }, {
    name: '群馬県',
    // Gunma
    shortCode: '18'
  }, {
    name: '高知県',
    // Kochi
    shortCode: '19'
  }, {
    name: '埼玉県',
    // Saitama
    shortCode: '20'
  }, {
    name: '佐賀県',
    // Saga
    shortCode: '21'
  }, {
    name: '滋賀県',
    // Shiga
    shortCode: '22'
  }, {
    name: '静岡県',
    // Shizuoka
    shortCode: '23'
  }, {
    name: '島根県',
    // Shimane
    shortCode: '24'
  }, {
    name: '千葉県',
    // Chiba
    shortCode: '25'
  }, {
    name: '東京都',
    // Tokyo
    shortCode: '26'
  }, {
    name: '徳島県',
    // Tokushima
    shortCode: '27'
  }, {
    name: '栃木県',
    // Tochigi
    shortCode: '28'
  }, {
    name: '鳥取県',
    // Tottori
    shortCode: '29'
  }, {
    name: '富山県',
    // Toyama
    shortCode: '30'
  }, {
    name: '長崎県',
    // Nagasaki
    shortCode: '31'
  }, {
    name: '長野県',
    // Nagano
    shortCode: '32'
  }, {
    name: '奈良県',
    // Nara
    shortCode: '33'
  }, {
    name: '新潟県',
    // Niigata
    shortCode: '34'
  }, {
    name: '兵庫県',
    // Hyogo
    shortCode: '35'
  }, {
    name: '広島県',
    // Hiroshima
    shortCode: '36'
  }, {
    name: '福井県',
    // Fukui
    shortCode: '37'
  }, {
    name: '福岡県',
    // Fukuoka
    shortCode: '38'
  }, {
    name: '福島県',
    // Fukushima
    shortCode: '39'
  }, {
    name: '北海道',
    // Hokkaido
    shortCode: '40'
  }, {
    name: '三重県',
    // Mie
    shortCode: '41'
  }, {
    name: '宮城県',
    // Miyagi
    shortCode: '42'
  }, {
    name: '宮崎県',
    // Miyazaki
    shortCode: '43'
  }, {
    name: '山形県',
    // Yamagata
    shortCode: '44'
  }, {
    name: '山口県',
    // Yamaguchi
    shortCode: '45'
  }, {
    name: '山梨県',
    // Yamanashi
    shortCode: '46'
  }, {
    name: '和歌山県',
    // Wakayama
    shortCode: '47'
  }]
}, {
  countryName: 'Jersey',
  countryShortCode: 'JE',
  regions: [{
    name: 'Jersey'
  }]
}, {
  countryName: 'Jordan',
  countryShortCode: 'JO',
  regions: [{
    name: '‘Ajlūn',
    shortCode: 'AJ'
  }, {
    name: "Al 'Aqabah",
    shortCode: 'AQ'
  }, {
    name: 'Al Balqā’',
    shortCode: 'BA'
  }, {
    name: 'Al Karak',
    shortCode: 'KA'
  }, {
    name: 'Al Mafraq',
    shortCode: 'MA'
  }, {
    name: 'Al ‘A̅şimah',
    shortCode: 'AM'
  }, {
    name: 'Aţ Ţafīlah',
    shortCode: 'AT'
  }, {
    name: 'Az Zarqā’',
    shortCode: 'AZ'
  }, {
    name: 'Irbid',
    shortCode: 'IR'
  }, {
    name: 'Jarash',
    shortCode: 'JA'
  }, {
    name: 'Ma‘ān',
    shortCode: 'MN'
  }, {
    name: 'Mādabā',
    shortCode: 'MD'
  }]
}, {
  countryName: 'Kazakhstan',
  countryShortCode: 'KZ',
  regions: [{
    name: 'Almaty',
    shortCode: 'ALA'
  }, {
    name: 'Aqmola',
    shortCode: 'AKM'
  }, {
    name: 'Aqtobe',
    shortCode: 'AKT'
  }, {
    name: 'Astana',
    shortCode: 'AST'
  }, {
    name: 'Atyrau',
    shortCode: 'ATY'
  }, {
    name: 'Batys Qazaqstan',
    shortCode: 'ZAP'
  }, {
    name: 'Bayqongyr'
  }, {
    name: 'Mangghystau',
    shortCode: 'MAN'
  }, {
    name: 'Ongtustik Qazaqstan',
    shortCode: 'YUZ'
  }, {
    name: 'Pavlodar',
    shortCode: 'PAV'
  }, {
    name: 'Qaraghandy',
    shortCode: 'KAR'
  }, {
    name: 'Qostanay',
    shortCode: 'KUS'
  }, {
    name: 'Qyzylorda',
    shortCode: 'KZY'
  }, {
    name: 'Shyghys Qazaqstan',
    shortCode: 'VOS'
  }, {
    name: 'Soltustik Qazaqstan',
    shortCode: 'SEV'
  }, {
    name: 'Zhambyl',
    shortCode: 'ZHA'
  }]
}, {
  countryName: 'Kenya',
  countryShortCode: 'KE',
  regions: [{
    name: 'Baringo',
    shortCode: '01'
  }, {
    name: 'Bomet',
    shortCode: '02'
  }, {
    name: 'Bungoma',
    shortCode: '03'
  }, {
    name: 'Busia',
    shortCode: '04'
  }, {
    name: 'Eleyo/Marakwet',
    shortCode: '05'
  }, {
    name: 'Embu',
    shortCode: '06'
  }, {
    name: 'Garissa',
    shortCode: '07'
  }, {
    name: 'Homa Bay',
    shortCode: '08'
  }, {
    name: 'Isiolo',
    shortCode: '09'
  }, {
    name: 'Kajiado',
    shortCode: '10'
  }, {
    name: 'Kakamega',
    shortCode: '11'
  }, {
    name: 'Kericho',
    shortCode: '12'
  }, {
    name: 'Kiambu',
    shortCode: '13'
  }, {
    name: 'Kilifi',
    shortCode: '14'
  }, {
    name: 'Kirinyaga',
    shortCode: '15'
  }, {
    name: 'Kisii',
    shortCode: '16'
  }, {
    name: 'Kisumu',
    shortCode: '17'
  }, {
    name: 'Kitui',
    shortCode: '18'
  }, {
    name: 'Kwale',
    shortCode: '19'
  }, {
    name: 'Laikipia',
    shortCode: '20'
  }, {
    name: 'Lamu',
    shortCode: '21'
  }, {
    name: 'Machakos',
    shortCode: '22'
  }, {
    name: 'Makueni',
    shortCode: '23'
  }, {
    name: 'Mandera',
    shortCode: '24'
  }, {
    name: 'Marsabit',
    shortCode: '25'
  }, {
    name: 'Meru',
    shortCode: '26'
  }, {
    name: 'Migori',
    shortCode: '27'
  }, {
    name: 'Mombasa',
    shortCode: '28'
  }, {
    name: "Murang'a",
    shortCode: '29'
  }, {
    name: 'Nairobi City',
    shortCode: '30'
  }, {
    name: 'Nakuru',
    shortCode: '31'
  }, {
    name: 'Nandi',
    shortCode: '32'
  }, {
    name: 'Narok',
    shortCode: '33'
  }, {
    name: 'Nyamira',
    shortCode: '34'
  }, {
    name: 'Nyandarua',
    shortCode: '35'
  }, {
    name: 'Nyeri',
    shortCode: '36'
  }, {
    name: 'Samburu',
    shortCode: '37'
  }, {
    name: 'Siaya',
    shortCode: '38'
  }, {
    name: 'Taita/Taveta',
    shortCode: '39'
  }, {
    name: 'Tana River',
    shortCode: '40'
  }, {
    name: 'Tharaka-Nithi',
    shortCode: '41'
  }, {
    name: 'Trans Nzoia',
    shortCode: '42'
  }, {
    name: 'Turkana',
    shortCode: '43'
  }, {
    name: 'Uasin Gishu',
    shortCode: '44'
  }, {
    name: 'Vihiga',
    shortCode: '45'
  }, {
    name: 'Wajir',
    shortCode: '46'
  }, {
    name: 'West Pokot',
    shortCode: '47'
  }]
}, {
  countryName: 'Kiribati',
  countryShortCode: 'KI',
  regions: [{
    name: 'Abaiang'
  }, {
    name: 'Abemama'
  }, {
    name: 'Aranuka'
  }, {
    name: 'Arorae'
  }, {
    name: 'Banaba'
  }, {
    name: 'Beru'
  }, {
    name: 'Butaritari'
  }, {
    name: 'Central Gilberts'
  }, {
    name: 'Gilbert Islands',
    shortCode: 'G'
  }, {
    name: 'Kanton'
  }, {
    name: 'Kiritimati'
  }, {
    name: 'Kuria'
  }, {
    name: 'Line Islands',
    shortCode: 'L'
  }, {
    name: 'Maiana'
  }, {
    name: 'Makin'
  }, {
    name: 'Marakei'
  }, {
    name: 'Nikunau'
  }, {
    name: 'Nonouti'
  }, {
    name: 'Northern Gilberts'
  }, {
    name: 'Onotoa'
  }, {
    name: 'Phoenix Islands',
    shortCode: 'P'
  }, {
    name: 'Southern Gilberts'
  }, {
    name: 'Tabiteuea'
  }, {
    name: 'Tabuaeran'
  }, {
    name: 'Tamana'
  }, {
    name: 'Tarawa'
  }, {
    name: 'Teraina'
  }]
}, {
  countryName: "Korea, Democratic People's Republic of",
  countryShortCode: 'KP',
  regions: [{
    name: 'Chagang-do (Chagang Province)',
    shortCode: '04'
  }, {
    name: 'Hamgyong-bukto (North Hamgyong Province)',
    shortCode: '09'
  }, {
    name: 'Hamgyong-namdo (South Hamgyong Province)',
    shortCode: '08'
  }, {
    name: 'Hwanghae-bukto (North Hwanghae Province)',
    shortCode: '06'
  }, {
    name: 'Hwanghae-namdo (South Hwanghae Province)',
    shortCode: '05'
  }, {
    name: 'Kangwon-do (Kangwon Province)',
    shortCode: '07'
  }, {
    name: 'Nasŏn (Najin-Sŏnbong)',
    shortCode: '13'
  }, {
    name: "P'yongan-bukto (North P'yongan Province)",
    shortCode: '03'
  }, {
    name: "P'yongan-namdo (South P'yongan Province)",
    shortCode: '02'
  }, {
    name: "P'yongyang-si (P'yongyang City)",
    shortCode: '01'
  }, {
    name: 'Yanggang-do (Yanggang Province)',
    shortCode: '10'
  }]
}, {
  countryName: 'Korea, Republic of',
  countryShortCode: 'KR',
  regions: [{
    name: "Ch'ungch'ongbuk-do",
    shortCode: '43'
  }, {
    name: "Ch'ungch'ongnam-do",
    shortCode: '44'
  }, {
    name: 'Cheju-do',
    shortCode: '49'
  }, {
    name: 'Chollabuk-do',
    shortCode: '45'
  }, {
    name: 'Chollanam-do',
    shortCode: '46'
  }, {
    name: "Inch'on-Kwangyokhi",
    shortCode: '28'
  }, {
    name: 'Kang-won-do',
    shortCode: '42'
  }, {
    name: 'Kwangju-Kwangyokshi',
    shortCode: '29'
  }, {
    name: 'Kyonggi-do',
    shortCode: '41'
  }, {
    name: 'Kyongsangbuk-do',
    shortCode: '47'
  }, {
    name: 'Kyongsangnam-do',
    shortCode: '48'
  }, {
    name: 'Pusan-Kwangyokshi',
    shortCode: '26'
  }, {
    name: "Seoul-T'ukpyolshi",
    shortCode: '11'
  }, {
    name: 'Sejong',
    shortCode: '50'
  }, {
    name: 'Taegu-Kwangyokshi',
    shortCode: '27'
  }, {
    name: 'Taejon-Kwangyokshi',
    shortCode: '30'
  }, {
    name: 'Ulsan-Kwangyokshi',
    shortCode: '31'
  }]
}, {
  countryName: 'Kosovo',
  countryShortCode: 'XK',
  regions: [{
    name: 'Farizaj',
    shortCode: 'FZ'
  }, {
    name: 'Gjakova',
    shortCode: 'GK'
  }, {
    name: 'Gjilan',
    shortCode: 'GL'
  }, {
    name: 'Mitrovica',
    shortCode: 'MI'
  }, {
    name: 'Peja/Peć',
    shortCode: 'PE'
  }, {
    name: 'Pristina',
    shortCode: 'PR'
  }, {
    name: 'Prizren',
    shortCode: 'PZ'
  }]
}, {
  countryName: 'Kuwait',
  countryShortCode: 'KW',
  regions: [{
    name: 'Al Aḩmadi',
    shortCode: 'AH'
  }, {
    name: 'Al Farwānīyah',
    shortCode: 'FA'
  }, {
    name: 'Al Jahrā’',
    shortCode: 'JA'
  }, {
    name: 'Al ‘Āşimah',
    shortCode: 'KU'
  }, {
    name: 'Ḩawallī',
    shortCode: 'HA'
  }, {
    name: 'Mubārak al Kabir',
    shortCode: 'MU'
  }]
}, {
  countryName: 'Kyrgyzstan',
  countryShortCode: 'KG',
  regions: [{
    name: 'Batken Oblasty',
    shortCode: 'B'
  }, {
    name: 'Bishkek Shaary',
    shortCode: 'GB'
  }, {
    name: 'Chuy Oblasty (Bishkek)',
    shortCode: 'C'
  }, {
    name: 'Jalal-Abad Oblasty',
    shortCode: 'J'
  }, {
    name: 'Naryn Oblasty',
    shortCode: 'N'
  }, {
    name: 'Osh Oblasty',
    shortCode: 'O'
  }, {
    name: 'Talas Oblasty',
    shortCode: 'T'
  }, {
    name: 'Ysyk-Kol Oblasty (Karakol)',
    shortCode: 'Y'
  }]
}, {
  countryName: 'Laos',
  countryShortCode: 'LA',
  regions: [{
    name: 'Attapu',
    shortCode: 'AT'
  }, {
    name: 'Bokèo',
    shortCode: 'BK'
  }, {
    name: 'Bolikhamxai',
    shortCode: 'BL'
  }, {
    name: 'Champasak',
    shortCode: 'CH'
  }, {
    name: 'Houaphan',
    shortCode: 'HO'
  }, {
    name: 'Khammouan',
    shortCode: 'KH'
  }, {
    name: 'Louang Namtha',
    shortCode: 'LM'
  }, {
    name: 'Louangphabang',
    shortCode: 'LP'
  }, {
    name: 'Oudômxai',
    shortCode: 'OU'
  }, {
    name: 'Phôngsali',
    shortCode: 'PH'
  }, {
    name: 'Salavan',
    shortCode: 'SL'
  }, {
    name: 'Savannakhét',
    shortCode: 'SV'
  }, {
    name: 'Vientiane',
    shortCode: 'VI'
  }, {
    name: 'Xaignabouli',
    shortCode: 'XA'
  }, {
    name: 'Xékong',
    shortCode: 'XE'
  }, {
    name: 'Xaisomboun',
    shortCode: 'XS'
  }, {
    name: 'Xiangkhouang',
    shortCode: 'XI'
  }]
}, {
  countryName: 'Latvia',
  countryShortCode: 'LV',
  regions: [{
    name: 'Aglona',
    shortCode: '001'
  }, {
    name: 'Aizkraukle',
    shortCode: '002'
  }, {
    name: 'Aizpute',
    shortCode: '003'
  }, {
    name: 'Aknīste',
    shortCode: '004'
  }, {
    name: 'Aloja',
    shortCode: '005'
  }, {
    name: 'Alsunga',
    shortCode: '06'
  }, {
    name: 'Alūksne',
    shortCode: '007'
  }, {
    name: 'Amata',
    shortCode: '008'
  }, {
    name: 'Ape',
    shortCode: '009'
  }, {
    name: 'Auce',
    shortCode: '010'
  }, {
    name: 'Ādaži',
    shortCode: '011'
  }, {
    name: 'Babīte',
    shortCode: '012'
  }, {
    name: 'Baldone',
    shortCode: '013'
  }, {
    name: 'Baltinava',
    shortCode: '014'
  }, {
    name: 'Balvi',
    shortCode: '015'
  }, {
    name: 'Bauska',
    shortCode: '016'
  }, {
    name: 'Beverīna',
    shortCode: '017'
  }, {
    name: 'Brocēni',
    shortCode: '018'
  }, {
    name: 'Burtnieki',
    shortCode: '019'
  }, {
    name: 'Carnikava',
    shortCode: '020'
  }, {
    name: 'Cesvaine',
    shortCode: '021'
  }, {
    name: 'Cēsis',
    shortCode: '022'
  }, {
    name: 'Cibla',
    shortCode: '023'
  }, {
    name: 'Dagda',
    shortCode: '024'
  }, {
    name: 'Daugavpils',
    shortCode: '025'
  }, {
    name: 'Daugavpils (City)',
    shortCode: 'DGV'
  }, {
    name: 'Dobele',
    shortCode: '026'
  }, {
    name: 'Dundaga',
    shortCode: '027'
  }, {
    name: 'Durbe',
    shortCode: '028'
  }, {
    name: 'Engure',
    shortCode: '029'
  }, {
    name: 'Ērgļi',
    shortCode: '030'
  }, {
    name: 'Garkalne',
    shortCode: '031'
  }, {
    name: 'Grobiņa',
    shortCode: '032'
  }, {
    name: 'Gulbene',
    shortCode: '033'
  }, {
    name: 'Iecava',
    shortCode: '034'
  }, {
    name: 'Ikšķile',
    shortCode: '035'
  }, {
    name: 'Ilūkste',
    shortCode: '036'
  }, {
    name: 'Inčukalns',
    shortCode: '037'
  }, {
    name: 'Jaunjelgava',
    shortCode: '038'
  }, {
    name: 'Jaunpiebalga',
    shortCode: '039'
  }, {
    name: 'Jaunpils',
    shortCode: '040'
  }, {
    name: 'Jelgava',
    shortCode: '041'
  }, {
    name: 'Jelgava (City)',
    shortCode: 'JEL'
  }, {
    name: 'Jēkabpils',
    shortCode: '042'
  }, {
    name: 'Jēkabpils (City)',
    shortCode: 'JKB'
  }, {
    name: 'Jūrmala (City)',
    shortCode: 'JUR'
  }, {
    name: 'Kandava',
    shortCode: '043'
  }, {
    name: 'Kārsava',
    shortCode: '044'
  }, {
    name: 'Kocēni',
    shortCode: '045'
  }, {
    name: 'Koknese',
    shortCode: '046'
  }, {
    name: 'Krāslava',
    shortCode: '047'
  }, {
    name: 'Krimulda',
    shortCode: '048'
  }, {
    name: 'Krustpils',
    shortCode: '049'
  }, {
    name: 'Kuldīga',
    shortCode: '050'
  }, {
    name: 'Ķegums',
    shortCode: '051'
  }, {
    name: 'Ķekava',
    shortCode: '052'
  }, {
    name: 'Lielvārde',
    shortCode: '053'
  }, {
    name: 'Liepāja',
    shortCode: 'LPX'
  }, {
    name: 'Limbaži',
    shortCode: '054'
  }, {
    name: 'Līgatne',
    shortCode: '055'
  }, {
    name: 'Līvāni',
    shortCode: '056'
  }, {
    name: 'Lubāna',
    shortCode: '057'
  }, {
    name: 'Ludza',
    shortCode: '058'
  }, {
    name: 'Madona',
    shortCode: '059'
  }, {
    name: 'Mazsalaca',
    shortCode: '060'
  }, {
    name: 'Mālpils',
    shortCode: '061'
  }, {
    name: 'Mārupe',
    shortCode: '062'
  }, {
    name: 'Mērsrags',
    shortCode: '063'
  }, {
    name: 'Naukšēni',
    shortCode: '064'
  }, {
    name: 'Nereta',
    shortCode: '065'
  }, {
    name: 'Nīca',
    shortCode: '066'
  }, {
    name: 'Ogre',
    shortCode: '067'
  }, {
    name: 'Olaine',
    shortCode: '068'
  }, {
    name: 'Ozolnieki',
    shortCode: '069'
  }, {
    name: 'Pārgauja',
    shortCode: '070'
  }, {
    name: 'Pāvilosta',
    shortCode: '071'
  }, {
    name: 'Pļaviņas',
    shortCode: '072'
  }, {
    name: 'Preiļi',
    shortCode: '073'
  }, {
    name: 'Priekule',
    shortCode: '074'
  }, {
    name: 'Priekuļi',
    shortCode: '075'
  }, {
    name: 'Rauna',
    shortCode: '076'
  }, {
    name: 'Rēzekne',
    shortCode: '077'
  }, {
    name: 'Rēzekne (City)',
    shortCode: 'REZ'
  }, {
    name: 'Riebiņi',
    shortCode: '078'
  }, {
    name: 'Rīga',
    shortCode: 'RIX'
  }, {
    name: 'Roja',
    shortCode: '079'
  }, {
    name: 'Ropaži',
    shortCode: '080'
  }, {
    name: 'Rucava',
    shortCode: '081'
  }, {
    name: 'Rugāji',
    shortCode: '082'
  }, {
    name: 'Rundāle',
    shortCode: '083'
  }, {
    name: 'Rūjiena',
    shortCode: '084'
  }, {
    name: 'Sala',
    shortCode: '085'
  }, {
    name: 'Salacgrīva',
    shortCode: '086'
  }, {
    name: 'Salaspils',
    shortCode: '087'
  }, {
    name: 'Saldus',
    shortCode: '088'
  }, {
    name: 'Saulkrasti',
    shortCode: '089'
  }, {
    name: 'Sēja',
    shortCode: '090'
  }, {
    name: 'Sigulda',
    shortCode: '091'
  }, {
    name: 'Skrīveri',
    shortCode: '092'
  }, {
    name: 'Skrunda',
    shortCode: '093'
  }, {
    name: 'Smiltene',
    shortCode: '094'
  }, {
    name: 'Stopiņi',
    shortCode: '095'
  }, {
    name: 'Strenči',
    shortCode: '096'
  }, {
    name: 'Talsi',
    shortCode: '097'
  }, {
    name: 'Tērvete',
    shortCode: '098'
  }, {
    name: 'Tukums',
    shortCode: '099'
  }, {
    name: 'Vaiņode',
    shortCode: '100'
  }, {
    name: 'Valka',
    shortCode: '101'
  }, {
    name: 'Valmiera',
    shortCode: 'VMR'
  }, {
    name: 'Varakļāni',
    shortCode: '102'
  }, {
    name: 'Vārkava',
    shortCode: '103'
  }, {
    name: 'Vecpiebalga',
    shortCode: '104'
  }, {
    name: 'Vecumnieki',
    shortCode: '105'
  }, {
    name: 'Ventspils',
    shortCode: '106'
  }, {
    name: 'Ventspils (City)',
    shortCode: 'VEN'
  }, {
    name: 'Viesīte',
    shortCode: '107'
  }, {
    name: 'Viļaka',
    shortCode: '108'
  }, {
    name: 'Viļāni',
    shortCode: '109'
  }, {
    name: 'Zilupe',
    shortCode: '110'
  }]
}, {
  countryName: 'Lebanon',
  countryShortCode: 'LB',
  regions: [{
    name: 'Aakkâr',
    shortCode: 'AK'
  }, {
    name: 'Baalbelk-Hermel',
    shortCode: 'BH'
  }, {
    name: 'Béqaa',
    shortCode: 'BI'
  }, {
    name: 'Beyrouth',
    shortCode: 'BA'
  }, {
    name: 'Liban-Nord',
    shortCode: 'AS'
  }, {
    name: 'Liban-Sud',
    shortCode: 'JA'
  }, {
    name: 'Mont-Liban',
    shortCode: 'JL'
  }, {
    name: 'Nabatîyé',
    shortCode: 'NA'
  }]
}, {
  countryName: 'Lesotho',
  countryShortCode: 'LS',
  regions: [{
    name: 'Berea',
    shortCode: 'D'
  }, {
    name: 'Butha-Buthe',
    shortCode: 'B'
  }, {
    name: 'Leribe',
    shortCode: 'C'
  }, {
    name: 'Mafeteng',
    shortCode: 'E'
  }, {
    name: 'Maseru',
    shortCode: 'A'
  }, {
    name: 'Mohales Hoek',
    shortCode: 'F'
  }, {
    name: 'Mokhotlong',
    shortCode: 'J'
  }, {
    name: "Qacha's Nek",
    shortCode: 'H'
  }, {
    name: 'Quthing',
    shortCode: 'G'
  }, {
    name: 'Thaba-Tseka',
    shortCode: 'K'
  }]
}, {
  countryName: 'Liberia',
  countryShortCode: 'LR',
  regions: [{
    name: 'Bomi',
    shortCode: 'BM'
  }, {
    name: 'Bong',
    shortCode: 'BG'
  }, {
    name: 'Gbarpolu',
    shortCode: 'GP'
  }, {
    name: 'Grand Bassa',
    shortCode: 'GB'
  }, {
    name: 'Grand Cape Mount',
    shortCode: 'CM'
  }, {
    name: 'Grand Gedeh',
    shortCode: 'GG'
  }, {
    name: 'Grand Kru',
    shortCode: 'GK'
  }, {
    name: 'Lofa',
    shortCode: 'LO'
  }, {
    name: 'Margibi',
    shortCode: 'MG'
  }, {
    name: 'Maryland',
    shortCode: 'MY'
  }, {
    name: 'Montserrado',
    shortCode: 'MO'
  }, {
    name: 'Nimba',
    shortCode: 'NI'
  }, {
    name: 'River Cess',
    shortCode: 'RI'
  }, {
    name: 'River Geee',
    shortCode: 'RG'
  }, {
    name: 'Sinoe',
    shortCode: 'SI'
  }]
}, {
  countryName: 'Libya',
  countryShortCode: 'LY',
  regions: [{
    name: 'Al Buţnān',
    shortCode: 'BU'
  }, {
    name: 'Al Jabal al Akhḑar',
    shortCode: 'JA'
  }, {
    name: 'Al Jabal al Gharbī',
    shortCode: 'JG'
  }, {
    name: 'Al Jafārah',
    shortCode: 'JI'
  }, {
    name: 'Al Jufrah',
    shortCode: 'JU'
  }, {
    name: 'Al Kufrah',
    shortCode: 'FK'
  }, {
    name: 'Al Marj',
    shortCode: 'MJ'
  }, {
    name: 'Al Marquab',
    shortCode: 'MB'
  }, {
    name: 'Al Wāḩāt',
    shortCode: 'WA'
  }, {
    name: 'An Nuqaţ al Khams',
    shortCode: 'NQ'
  }, {
    name: 'Az Zāwiyah',
    shortCode: 'ZA'
  }, {
    name: 'Banghāzī',
    shortCode: 'BA'
  }, {
    name: 'Darnah',
    shortCode: 'DR'
  }, {
    name: 'Ghāt',
    shortCode: 'GH'
  }, {
    name: 'Mişrātah',
    shortCode: 'MI'
  }, {
    name: 'Murzuq',
    shortCode: 'MQ'
  }, {
    name: 'Nālūt',
    shortCode: 'NL'
  }, {
    name: 'Sabhā',
    shortCode: 'SB'
  }, {
    name: 'Surt',
    shortCode: 'SR'
  }, {
    name: 'Ţarābulus',
    shortCode: 'TB'
  }, {
    name: 'Yafran',
    shortCode: 'WD'
  }, {
    name: 'Wādī ash Shāţiʾ',
    shortCode: 'WS'
  }]
}, {
  countryName: 'Liechtenstein',
  countryShortCode: 'LI',
  regions: [{
    name: 'Balzers',
    shortCode: '01'
  }, {
    name: 'Eschen',
    shortCode: '02'
  }, {
    name: 'Gamprin',
    shortCode: '03'
  }, {
    name: 'Mauren',
    shortCode: '04'
  }, {
    name: 'Planken',
    shortCode: '05'
  }, {
    name: 'Ruggell',
    shortCode: '06'
  }, {
    name: 'Schaan',
    shortCode: '07'
  }, {
    name: 'Schellenberg',
    shortCode: '08'
  }, {
    name: 'Triesen',
    shortCode: '09'
  }, {
    name: 'Triesenberg',
    shortCode: '10'
  }, {
    name: 'Vaduz',
    shortCode: '11'
  }]
}, {
  countryName: 'Lithuania',
  countryShortCode: 'LT',
  regions: [{
    name: 'Alytaus',
    shortCode: 'AL'
  }, {
    name: 'Kauno',
    shortCode: 'KU'
  }, {
    name: 'Klaipėdos',
    shortCode: 'KL'
  }, {
    name: 'Marijampolės',
    shortCode: 'MR'
  }, {
    name: 'Panevėžio',
    shortCode: 'PN'
  }, {
    name: 'Šiaulių',
    shortCode: 'SA'
  }, {
    name: 'Tauragės',
    shortCode: 'TA'
  }, {
    name: 'Telšių',
    shortCode: 'TE'
  }, {
    name: 'Utenos',
    shortCode: 'UT'
  }, {
    name: 'Vilniaus',
    shortCode: 'VL'
  }]
}, {
  countryName: 'Luxembourg',
  countryShortCode: 'LU',
  regions: [{
    name: 'Capellen',
    shortCode: 'CA'
  }, {
    name: 'Clevaux',
    shortCode: 'CL'
  }, {
    name: 'Diekirch',
    shortCode: 'DI'
  }, {
    name: 'Echternach',
    shortCode: 'EC'
  }, {
    name: 'Esch-sur-Alzette',
    shortCode: 'ES'
  }, {
    name: 'Grevenmacher',
    shortCode: 'GR'
  }, {
    name: 'Luxembourg',
    shortCode: 'LU'
  }, {
    name: 'Mersch',
    shortCode: 'ME'
  }, {
    name: 'Redange',
    shortCode: 'RD'
  }, {
    name: 'Remich',
    shortCode: 'RM'
  }, {
    name: 'Vianden',
    shortCode: 'VD'
  }, {
    name: 'Wiltz',
    shortCode: 'WI'
  }]
}, {
  countryName: 'Macao',
  countryShortCode: 'MO',
  regions: [{
    name: 'Macao'
  }]
}, {
  countryName: 'Macedonia, Republic of',
  countryShortCode: 'MK',
  regions: [{
    name: 'Aračinovo',
    shortCode: '02'
  }, {
    name: 'Berovo',
    shortCode: '03'
  }, {
    name: 'Bitola',
    shortCode: '04'
  }, {
    name: 'Bogdanci',
    shortCode: '05'
  }, {
    name: 'Bogovinje',
    shortCode: '06'
  }, {
    name: 'Bosilovo',
    shortCode: '07'
  }, {
    name: 'Brvenica',
    shortCode: '08'
  }, {
    name: 'Centar Župa',
    shortCode: '78'
  }, {
    name: 'Čaška',
    shortCode: '80'
  }, {
    name: 'Češinovo-Obleševo',
    shortCode: '81'
  }, {
    name: 'Čučer Sandevo',
    shortCode: '82'
  }, {
    name: 'Debar',
    shortCode: '21'
  }, {
    name: 'Debarca',
    shortCode: '22'
  }, {
    name: 'Delčevo',
    shortCode: '23'
  }, {
    name: 'Demir Hisar',
    shortCode: '25'
  }, {
    name: 'Demir Kapija',
    shortCode: '24'
  }, {
    name: 'Doran',
    shortCode: '26'
  }, {
    name: 'Dolneni',
    shortCode: '27'
  }, {
    name: 'Gevgelija',
    shortCode: '18'
  }, {
    name: 'Gostivar',
    shortCode: '19'
  }, {
    name: 'Gradsko',
    shortCode: '20'
  }, {
    name: 'Ilinden',
    shortCode: '34'
  }, {
    name: 'Jegunovce',
    shortCode: '35'
  }, {
    name: 'Karbinci',
    shortCode: '37'
  }, {
    name: 'Kavadarci',
    shortCode: '36'
  }, {
    name: 'Kičevo',
    shortCode: '40'
  }, {
    name: 'Kočani',
    shortCode: '42'
  }, {
    name: 'Konče',
    shortCode: '41'
  }, {
    name: 'Kratovo',
    shortCode: '43'
  }, {
    name: 'Kriva Palanka',
    shortCode: '44'
  }, {
    name: 'Krivogaštani',
    shortCode: '45'
  }, {
    name: 'Kruševo',
    shortCode: '46'
  }, {
    name: 'Kumanovo',
    shortCode: '47'
  }, {
    name: 'Lipkovo',
    shortCode: '48'
  }, {
    name: 'Lozovo',
    shortCode: '49'
  }, {
    name: 'Makedonska Kamenica',
    shortCode: '51'
  }, {
    name: 'Makedonski Brod',
    shortCode: '52'
  }, {
    name: 'Mavrovo i Rostuša',
    shortCode: '50'
  }, {
    name: 'Mogila',
    shortCode: '53'
  }, {
    name: 'Negotino',
    shortCode: '54'
  }, {
    name: 'Novaci',
    shortCode: '55'
  }, {
    name: 'Novo Selo',
    shortCode: '56'
  }, {
    name: 'Ohrid',
    shortCode: '58'
  }, {
    name: 'Pehčevo',
    shortCode: '60'
  }, {
    name: 'Petrovec',
    shortCode: '59'
  }, {
    name: 'Plasnica',
    shortCode: '61'
  }, {
    name: 'Prilep',
    shortCode: '62'
  }, {
    name: 'Probištip',
    shortCode: '63'
  }, {
    name: 'Radoviš',
    shortCode: ''
  }, {
    name: 'Rankovce',
    shortCode: '65'
  }, {
    name: 'Resen',
    shortCode: '66'
  }, {
    name: 'Rosoman',
    shortCode: '67'
  }, {
    name: 'Skopje',
    shortCode: '85'
  }, {
    name: 'Sopište',
    shortCode: '70'
  }, {
    name: 'Staro Nagoričane',
    shortCode: '71'
  }, {
    name: 'Struga',
    shortCode: '72'
  }, {
    name: 'Strumica',
    shortCode: '73'
  }, {
    name: 'Studeničani',
    shortCode: '74'
  }, {
    name: 'Sveti Nikole',
    shortCode: '69'
  }, {
    name: 'Štip',
    shortCode: '83'
  }, {
    name: 'Tearce',
    shortCode: '75'
  }, {
    name: 'Tetovo',
    shortCode: '76'
  }, {
    name: 'Valandovo',
    shortCode: '10'
  }, {
    name: 'Vasilevo',
    shortCode: '11'
  }, {
    name: 'Veles',
    shortCode: '13'
  }, {
    name: 'Vevčani',
    shortCode: '12'
  }, {
    name: 'Vinica',
    shortCode: '14'
  }, {
    name: 'Vrapčište',
    shortCode: '16'
  }, {
    name: 'Zelenikovo',
    shortCode: '32'
  }, {
    name: 'Zrnovci',
    shortCode: '33'
  }, {
    name: 'Želino',
    shortCode: '30'
  }]
}, {
  countryName: 'Madagascar',
  countryShortCode: 'MG',
  regions: [{
    name: 'Antananarivo',
    shortCode: 'T'
  }, {
    name: 'Antsiranana',
    shortCode: 'D'
  }, {
    name: 'Fianarantsoa',
    shortCode: 'F'
  }, {
    name: 'Mahajanga',
    shortCode: 'M'
  }, {
    name: 'Toamasina',
    shortCode: 'A'
  }, {
    name: 'Toliara',
    shortCode: 'U'
  }]
}, {
  countryName: 'Malawi',
  countryShortCode: 'MW',
  regions: [{
    name: 'Balaka',
    shortCode: 'BA'
  }, {
    name: 'Blantyre',
    shortCode: 'BL'
  }, {
    name: 'Chikwawa',
    shortCode: 'CK'
  }, {
    name: 'Chiradzulu',
    shortCode: 'CR'
  }, {
    name: 'Chitipa',
    shortCode: 'CT'
  }, {
    name: 'Dedza',
    shortCode: 'DE'
  }, {
    name: 'Dowa',
    shortCode: 'DO'
  }, {
    name: 'Karonga',
    shortCode: 'KR'
  }, {
    name: 'Kasungu',
    shortCode: 'KS'
  }, {
    name: 'Likoma',
    shortCode: 'LK'
  }, {
    name: 'Lilongwe',
    shortCode: 'LI'
  }, {
    name: 'Machinga',
    shortCode: 'MH'
  }, {
    name: 'Mangochi',
    shortCode: 'MG'
  }, {
    name: 'Mchinji',
    shortCode: 'MC'
  }, {
    name: 'Mulanje',
    shortCode: 'MU'
  }, {
    name: 'Mwanza',
    shortCode: 'MW'
  }, {
    name: 'Mzimba',
    shortCode: 'MZ'
  }, {
    name: 'Nkhata Bay',
    shortCode: 'NE'
  }, {
    name: 'Nkhotakota',
    shortCode: 'NB'
  }, {
    name: 'Nsanje',
    shortCode: 'NS'
  }, {
    name: 'Ntcheu',
    shortCode: 'NU'
  }, {
    name: 'Ntchisi',
    shortCode: 'NI'
  }, {
    name: 'Phalombe',
    shortCode: 'PH'
  }, {
    name: 'Rumphi',
    shortCode: 'RU'
  }, {
    name: 'Salima',
    shortCode: 'SA'
  }, {
    name: 'Thyolo',
    shortCode: 'TH'
  }, {
    name: 'Zomba',
    shortCode: 'ZO'
  }]
}, {
  countryName: 'Malaysia',
  countryShortCode: 'MY',
  regions: [{
    name: 'Johor',
    shortCode: '01'
  }, {
    name: 'Kedah',
    shortCode: '02'
  }, {
    name: 'Kelantan',
    shortCode: '03'
  }, {
    name: 'Melaka',
    shortCode: '04'
  }, {
    name: 'Negeri Sembilan',
    shortCode: '05'
  }, {
    name: 'Pahang',
    shortCode: '06'
  }, {
    name: 'Perak',
    shortCode: '08'
  }, {
    name: 'Perlis',
    shortCode: '09'
  }, {
    name: 'Pulau Pinang',
    shortCode: '07'
  }, {
    name: 'Sabah',
    shortCode: '12'
  }, {
    name: 'Sarawak',
    shortCode: '13'
  }, {
    name: 'Selangor',
    shortCode: '10'
  }, {
    name: 'Terengganu',
    shortCode: '11'
  }, {
    name: 'Wilayah Persekutuan (Kuala Lumpur)',
    shortCode: '14'
  }, {
    name: 'Wilayah Persekutuan (Labuan)',
    shortCode: '15'
  }, {
    name: 'Wilayah Persekutuan (Putrajaya)',
    shortCode: '16'
  }]
}, {
  countryName: 'Maldives',
  countryShortCode: 'MV',
  regions: [{
    name: 'Alifu Alifu',
    shortCode: '02'
  }, {
    name: 'Alifu Dhaalu',
    shortCode: '00'
  }, {
    name: 'Baa',
    shortCode: '20'
  }, {
    name: 'Dhaalu',
    shortCode: '17'
  }, {
    name: 'Faafu',
    shortCode: '14'
  }, {
    name: 'Gaafu Alifu',
    shortCode: '27'
  }, {
    name: 'Gaafu Dhaalu',
    shortCode: '28'
  }, {
    name: 'Gnaviyani',
    shortCode: '29'
  }, {
    name: 'Haa Alifu',
    shortCode: '07'
  }, {
    name: 'Haa Dhaalu',
    shortCode: '23'
  }, {
    name: 'Kaafu',
    shortCode: '26'
  }, {
    name: 'Laamu',
    shortCode: '05'
  }, {
    name: 'Lhaviyani',
    shortCode: '03'
  }, {
    name: 'Malé',
    shortCode: 'MLE'
  }, {
    name: 'Meemu',
    shortCode: '12'
  }, {
    name: 'Noonu',
    shortCode: '25'
  }, {
    name: 'Raa',
    shortCode: '13'
  }, {
    name: 'Seenu',
    shortCode: '01'
  }, {
    name: 'Shaviyani',
    shortCode: '24'
  }, {
    name: 'Thaa',
    shortCode: '08'
  }, {
    name: 'Vaavu',
    shortCode: '04'
  }]
}, {
  countryName: 'Mali',
  countryShortCode: 'ML',
  regions: [{
    name: 'Bamako',
    shortCode: 'BKO'
  }, {
    name: 'Gao',
    shortCode: '7'
  }, {
    name: 'Kayes',
    shortCode: '1'
  }, {
    name: 'Kidal',
    shortCode: '8'
  }, {
    name: 'Koulikoro',
    shortCode: '2'
  }, {
    name: 'Mopti',
    shortCode: '5'
  }, {
    name: 'Segou',
    shortCode: '4'
  }, {
    name: 'Sikasso',
    shortCode: '3'
  }, {
    name: 'Tombouctou',
    shortCode: '6'
  }, {
    name: 'Taoudénit',
    shortCode: '9'
  }, {
    name: 'Ménaka',
    shortCode: '10'
  }]
}, {
  countryName: 'Malta',
  countryShortCode: 'MT',
  regions: [{
    name: 'Attard',
    shortCode: '01'
  }, {
    name: 'Balzan',
    shortCode: '02'
  }, {
    name: 'Birgu',
    shortCode: '03'
  }, {
    name: 'Birkirkara',
    shortCode: '04'
  }, {
    name: 'Birżebbuġa',
    shortCode: '05'
  }, {
    name: 'Bormla',
    shortCode: '06'
  }, {
    name: 'Dingli',
    shortCode: '07'
  }, {
    name: 'Fgura',
    shortCode: '08'
  }, {
    name: 'Floriana',
    shortCode: '09'
  }, {
    name: 'Fontana',
    shortCode: '10'
  }, {
    name: 'Guda',
    shortCode: '11'
  }, {
    name: 'Gżira',
    shortCode: '12'
  }, {
    name: 'Għajnsielem',
    shortCode: '13'
  }, {
    name: 'Għarb',
    shortCode: '14'
  }, {
    name: 'Għargħur',
    shortCode: '15'
  }, {
    name: 'Għasri',
    shortCode: '16'
  }, {
    name: 'Għaxaq',
    shortCode: '17'
  }, {
    name: 'Ħamrun',
    shortCode: '18'
  }, {
    name: 'Iklin',
    shortCode: '19'
  }, {
    name: 'Isla',
    shortCode: '20'
  }, {
    name: 'Kalkara',
    shortCode: '21'
  }, {
    name: 'Kerċem',
    shortCode: '22'
  }, {
    name: 'Kirkop',
    shortCode: '23'
  }, {
    name: 'Lija',
    shortCode: '24'
  }, {
    name: 'Luqa',
    shortCode: '25'
  }, {
    name: 'Marsa',
    shortCode: '26'
  }, {
    name: 'Marsaskala',
    shortCode: '27'
  }, {
    name: 'Marsaxlokk',
    shortCode: '28'
  }, {
    name: 'Mdina',
    shortCode: '29'
  }, {
    name: 'Mellieħa',
    shortCode: '30'
  }, {
    name: 'Mġarr',
    shortCode: '31'
  }, {
    name: 'Mosta',
    shortCode: '32'
  }, {
    name: 'Mqabba',
    shortCode: '33'
  }, {
    name: 'Msida',
    shortCode: '34'
  }, {
    name: 'Mtarfa',
    shortCode: '35'
  }, {
    name: 'Munxar',
    shortCode: '36'
  }, {
    name: 'Nadur',
    shortCode: '37'
  }, {
    name: 'Naxxar',
    shortCode: '38'
  }, {
    name: 'Paola',
    shortCode: '39'
  }, {
    name: 'Pembroke',
    shortCode: '40'
  }, {
    name: 'Pietà',
    shortCode: '41'
  }, {
    name: 'Qala',
    shortCode: '42'
  }, {
    name: 'Qormi',
    shortCode: '43'
  }, {
    name: 'Qrendi',
    shortCode: '44'
  }, {
    name: 'Rabat Għawdex',
    shortCode: '45'
  }, {
    name: 'Rabat Malta',
    shortCode: '46'
  }, {
    name: 'Safi',
    shortCode: '47'
  }, {
    name: 'San Ġiljan',
    shortCode: '48'
  }, {
    name: 'San Ġwann',
    shortCode: '49'
  }, {
    name: 'San Lawrenz',
    shortCode: '50'
  }, {
    name: 'San Pawl il-Baħar',
    shortCode: '51'
  }, {
    name: 'Sannat',
    shortCode: '52'
  }, {
    name: 'Santa Luċija',
    shortCode: '53'
  }, {
    name: 'Santa Venera',
    shortCode: '54'
  }, {
    name: 'Siġġiewi',
    shortCode: '55'
  }, {
    name: 'Sliema',
    shortCode: '56'
  }, {
    name: 'Swieqi',
    shortCode: '57'
  }, {
    name: 'Tai Xbiex',
    shortCode: '58'
  }, {
    name: 'Tarzien',
    shortCode: '59'
  }, {
    name: 'Valletta',
    shortCode: '60'
  }, {
    name: 'Xagħra',
    shortCode: '61'
  }, {
    name: 'Xewkija',
    shortCode: '62'
  }, {
    name: 'Xgħajra',
    shortCode: '63'
  }, {
    name: 'Żabbar',
    shortCode: '64'
  }, {
    name: 'Żebbuġ Għawde',
    shortCode: '65'
  }, {
    name: 'Żebbuġ Malta',
    shortCode: '66'
  }, {
    name: 'Żejtun',
    shortCode: '67'
  }, {
    name: 'Żurrieq',
    shortCode: '68'
  }]
}, {
  countryName: 'Marshall Islands',
  countryShortCode: 'MH',
  regions: [{
    name: 'Ailinglaplap',
    shortCode: 'ALL'
  }, {
    name: 'Ailuk',
    shortCode: 'ALK'
  }, {
    name: 'Arno',
    shortCode: 'ARN'
  }, {
    name: 'Aur',
    shortCode: 'AUR'
  }, {
    name: 'Bikini and Kili',
    shortCode: 'KIL'
  }, {
    name: 'Ebon',
    shortCode: 'EBO'
  }, {
    name: 'Jabat',
    shortCode: 'JAB'
  }, {
    name: 'Jaluit',
    shortCode: 'JAL'
  }, {
    name: 'Kwajalein',
    shortCode: 'KWA'
  }, {
    name: 'Lae',
    shortCode: 'LAE'
  }, {
    name: 'Lib',
    shortCode: 'LIB'
  }, {
    name: 'Likiep',
    shortCode: 'LIK'
  }, {
    name: 'Majuro',
    shortCode: 'MAJ'
  }, {
    name: 'Maloelap',
    shortCode: 'MAL'
  }, {
    name: 'Mejit',
    shortCode: 'MEJ'
  }, {
    name: 'Namdrik',
    shortCode: 'NMK'
  }, {
    name: 'Namu',
    shortCode: 'NMU'
  }, {
    name: 'Rongelap',
    shortCode: 'RON'
  }, {
    name: 'Ujae',
    shortCode: 'UJA'
  }, {
    name: 'Utrik',
    shortCode: 'UTI'
  }, {
    name: 'Wotho',
    shortCode: 'WTH'
  }, {
    name: 'Wotje',
    shortCode: 'WTJ'
  }]
}, {
  countryName: 'Martinique',
  countryShortCode: 'MQ',
  regions: [{
    name: 'Martinique'
  }]
}, {
  countryName: 'Mauritania',
  countryShortCode: 'MR',
  regions: [{
    name: 'Adrar',
    shortCode: '07'
  }, {
    name: 'Assaba',
    shortCode: '03'
  }, {
    name: 'Brakna',
    shortCode: '05'
  }, {
    name: 'Dakhlet Nouadhibou',
    shortCode: '08'
  }, {
    name: 'Gorgol',
    shortCode: '04'
  }, {
    name: 'Guidimaka',
    shortCode: '10'
  }, {
    name: 'Hodh Ech Chargui',
    shortCode: '01'
  }, {
    name: 'Hodh El Gharbi',
    shortCode: '02'
  }, {
    name: 'Inchiri',
    shortCode: '12'
  }, {
    name: 'Nouakchott Nord',
    shortCode: '14'
  }, {
    name: 'Nouakchott Ouest',
    shortCode: '13'
  }, {
    name: 'Nouakchott Sud',
    shortCode: '15'
  }, {
    name: 'Tagant',
    shortCode: '09'
  }, {
    name: 'Tiris Zemmour',
    shortCode: '11'
  }, {
    name: 'Trarza',
    shortCode: '06'
  }]
}, {
  countryName: 'Mauritius',
  countryShortCode: 'MU',
  regions: [{
    name: 'Agalega Islands',
    shortCode: 'AG'
  }, {
    name: 'Beau Bassin-Rose Hill',
    shortCode: 'BR'
  }, {
    name: 'Black River',
    shortCode: 'BL'
  }, {
    name: 'Cargados Carajos Shoals',
    shortCode: 'CC'
  }, {
    name: 'Curepipe',
    shortCode: 'CU'
  }, {
    name: 'Flacq',
    shortCode: 'FL'
  }, {
    name: 'Grand Port',
    shortCode: 'GP'
  }, {
    name: 'Moka',
    shortCode: 'MO'
  }, {
    name: 'Pamplemousses',
    shortCode: 'PA'
  }, {
    name: 'Plaines Wilhems',
    shortCode: 'PW'
  }, {
    name: 'Port Louis (City)',
    shortCode: 'PU'
  }, {
    name: 'Port Louis',
    shortCode: 'PL'
  }, {
    name: 'Riviere du Rempart',
    shortCode: 'RR'
  }, {
    name: 'Rodrigues Island',
    shortCode: 'RO'
  }, {
    name: 'Savanne',
    shortCode: 'SA'
  }, {
    name: 'Vacoas-Phoenix',
    shortCode: 'CP'
  }]
}, {
  countryName: 'Mayotte',
  countryShortCode: 'YT',
  regions: [{
    name: 'Dzaoudzi',
    shortCode: '01'
  }, {
    name: 'Pamandzi',
    shortCode: '02'
  }, {
    name: 'Mamoudzou',
    shortCode: '03'
  }, {
    name: 'Dembeni',
    shortCode: '04'
  }, {
    name: 'Bandrélé',
    shortCode: '05'
  }, {
    name: 'Kani-Kéli',
    shortCode: '06'
  }, {
    name: 'Bouéni',
    shortCode: '07'
  }, {
    name: 'Chirongui',
    shortCode: '08'
  }, {
    name: 'Sada',
    shortCode: '09'
  }, {
    name: 'Ouangani',
    shortCode: '10'
  }, {
    name: 'Chiconi',
    shortCode: '11'
  }, {
    name: 'Tsingoni',
    shortCode: '12'
  }, {
    name: "M'Tsangamouji",
    shortCode: '13'
  }, {
    name: 'Acoua',
    shortCode: '14'
  }, {
    name: 'Mtsamboro',
    shortCode: '15'
  }, {
    name: 'Bandraboua',
    shortCode: '16'
  }, {
    name: 'Koungou',
    shortCode: '17'
  }]
}, {
  countryName: 'Mexico',
  countryShortCode: 'MX',
  regions: [{
    name: 'Aguascalientes',
    shortCode: 'AGU'
  }, {
    name: 'Baja California',
    shortCode: 'BCN'
  }, {
    name: 'Baja California Sur',
    shortCode: 'BCS'
  }, {
    name: 'Campeche',
    shortCode: 'CAM'
  }, {
    name: 'Ciudad de México',
    shortCode: 'DIF'
  }, {
    name: 'Chiapas',
    shortCode: 'CHP'
  }, {
    name: 'Chihuahua',
    shortCode: 'CHH'
  }, {
    name: 'Coahuila de Zaragoza',
    shortCode: 'COA'
  }, {
    name: 'Colima',
    shortCode: 'COL'
  }, {
    name: 'Durango',
    shortCode: 'DUR'
  }, {
    name: 'Estado de México',
    shortCode: 'MEX'
  }, {
    name: 'Guanajuato',
    shortCode: 'GUA'
  }, {
    name: 'Guerrero',
    shortCode: 'GRO'
  }, {
    name: 'Hidalgo',
    shortCode: 'HID'
  }, {
    name: 'Jalisco',
    shortCode: 'JAL'
  }, {
    name: 'Michoacán de Ocampo',
    shortCode: 'MIC'
  }, {
    name: 'Morelos',
    shortCode: 'MOR'
  }, {
    name: 'Nayarit',
    shortCode: 'NAY'
  }, {
    name: 'Nuevo León',
    shortCode: 'NLE'
  }, {
    name: 'Oaxaca',
    shortCode: 'OAX'
  }, {
    name: 'Puebla',
    shortCode: 'PUE'
  }, {
    name: 'Querétaro de Arteaga',
    shortCode: 'QUE'
  }, {
    name: 'Quintana Roo',
    shortCode: 'ROO'
  }, {
    name: 'San Luis Potosí',
    shortCode: 'SLP'
  }, {
    name: 'Sinaloa',
    shortCode: 'SIN'
  }, {
    name: 'Sonora',
    shortCode: 'SON'
  }, {
    name: 'Tabasco',
    shortCode: 'TAB'
  }, {
    name: 'Tamaulipas',
    shortCode: 'TAM'
  }, {
    name: 'Tlaxcala',
    shortCode: 'TLA'
  }, {
    name: 'Veracruz',
    shortCode: 'VER'
  }, {
    name: 'Yucatán',
    shortCode: 'YUC'
  }, {
    name: 'Zacatecas',
    shortCode: 'ZAC'
  }]
}, {
  countryName: 'Micronesia, Federated States of',
  countryShortCode: 'FM',
  regions: [{
    name: 'Chuuk (Truk)',
    shortCode: 'TRK'
  }, {
    name: 'Kosrae',
    shortCode: 'KSA'
  }, {
    name: 'Pohnpei',
    shortCode: 'PNI'
  }, {
    name: 'Yap',
    shortCode: 'YAP'
  }]
}, {
  countryName: 'Moldova',
  countryShortCode: 'MD',
  regions: [{
    name: 'Aenii Noi',
    shortCode: 'AN'
  }, {
    name: 'Basarabeasca',
    shortCode: 'BS'
  }, {
    name: 'Bălți',
    shortCode: 'BA'
  }, {
    name: 'Bender',
    shortCode: 'BD'
  }, {
    name: 'Briceni',
    shortCode: 'BR'
  }, {
    name: 'Cahul',
    shortCode: 'CA'
  }, {
    name: 'Cantemir',
    shortCode: 'CT'
  }, {
    name: 'Călărași',
    shortCode: 'CL'
  }, {
    name: 'Căușeni',
    shortCode: 'CS'
  }, {
    name: 'Chișinău',
    shortCode: 'CU'
  }, {
    name: 'Cimișlia',
    shortCode: 'CM'
  }, {
    name: 'Criuleni',
    shortCode: 'CR'
  }, {
    name: 'Dondușeni',
    shortCode: 'DO'
  }, {
    name: 'Drochia',
    shortCode: 'DR'
  }, {
    name: 'Dubăsari',
    shortCode: 'DU'
  }, {
    name: 'Edineț',
    shortCode: 'ED'
  }, {
    name: 'Fălești',
    shortCode: 'FA'
  }, {
    name: 'Florești',
    shortCode: 'FL'
  }, {
    name: 'Găgăuzia',
    shortCode: 'GA'
  }, {
    name: 'Glodeni',
    shortCode: 'GL'
  }, {
    name: 'Hîncești',
    shortCode: 'HI'
  }, {
    name: 'Ialoveni',
    shortCode: 'IA'
  }, {
    name: 'Leova',
    shortCode: 'LE'
  }, {
    name: 'Nisporeni',
    shortCode: 'NI'
  }, {
    name: 'Ocnița',
    shortCode: 'OC'
  }, {
    name: 'Orhei',
    shortCode: 'OR'
  }, {
    name: 'Rezina',
    shortCode: 'RE'
  }, {
    name: 'Rîșcani',
    shortCode: 'RI'
  }, {
    name: 'Sîngerei',
    shortCode: 'SI'
  }, {
    name: 'Soroca',
    shortCode: 'SO'
  }, {
    name: 'Stînga Nistrului',
    shortCode: 'SN'
  }, {
    name: 'Strășeni',
    shortCode: 'ST'
  }, {
    name: 'Șoldănești',
    shortCode: 'SD'
  }, {
    name: 'Ștefan Vodă',
    shortCode: 'SV'
  }, {
    name: 'Taraclia',
    shortCode: 'TA'
  }, {
    name: 'Telenești',
    shortCode: 'TE'
  }, {
    name: 'Ungheni',
    shortCode: 'UN'
  }]
}, {
  countryName: 'Monaco',
  countryShortCode: 'MC',
  regions: [{
    name: 'Colle',
    shortCode: 'CL'
  }, {
    name: 'Condamine',
    shortCode: 'CO'
  }, {
    name: 'Fontvieille',
    shortCode: 'FO'
  }, {
    name: 'Gare',
    shortCode: 'GA'
  }, {
    name: 'Jardin Exotique',
    shortCode: 'JE'
  }, {
    name: 'Larvotto',
    shortCode: 'LA'
  }, {
    name: 'Malbousquet',
    shortCode: 'MA'
  }, {
    name: 'Monaco-Ville',
    shortCode: 'MO'
  }, {
    name: 'Moneghetti',
    shortCode: 'MG'
  }, {
    name: 'Monte-Carlo',
    shortCode: 'MC'
  }, {
    name: 'Moulins',
    shortCode: 'MU'
  }, {
    name: 'Port-Hercule',
    shortCode: 'PH'
  }, {
    name: 'Saint-Roman',
    shortCode: 'SR'
  }, {
    name: 'Sainte-Dévote',
    shortCode: 'SD'
  }, {
    name: 'Source',
    shortCode: 'SO'
  }, {
    name: 'Spélugues',
    shortCode: 'SP'
  }, {
    name: 'Vallon de la Rousse',
    shortCode: 'VR'
  }]
}, {
  countryName: 'Mongolia',
  countryShortCode: 'MN',
  regions: [{
    name: 'Arhangay',
    shortCode: '073'
  }, {
    name: 'Bayan-Olgiy',
    shortCode: '071'
  }, {
    name: 'Bayanhongor',
    shortCode: '069'
  }, {
    name: 'Bulgan',
    shortCode: '067'
  }, {
    name: 'Darhan',
    shortCode: '037'
  }, {
    name: 'Dornod',
    shortCode: '061'
  }, {
    name: 'Dornogovi',
    shortCode: '063'
  }, {
    name: 'Dundgovi',
    shortCode: '059'
  }, {
    name: 'Dzavhan',
    shortCode: '057'
  }, {
    name: 'Govi-Altay',
    shortCode: '065'
  }, {
    name: 'Govi-Sumber',
    shortCode: '064'
  }, {
    name: 'Hovd',
    shortCode: '043'
  }, {
    name: 'Hovsgol',
    shortCode: '041'
  }, {
    name: 'Omnogovi',
    shortCode: '053'
  }, {
    name: 'Ovorhangay',
    shortCode: '055'
  }, {
    name: 'Selenge',
    shortCode: '049'
  }, {
    name: 'Suhbaatar',
    shortCode: '051'
  }, {
    name: 'Tov',
    shortCode: '047'
  }, {
    name: 'Ulaanbaatar',
    shortCode: '1'
  }, {
    name: 'Uvs',
    shortCode: '046'
  }]
}, {
  countryName: 'Montenegro',
  countryShortCode: 'ME',
  regions: [{
    name: 'Andrijevica',
    shortCode: '01'
  }, {
    name: 'Bar',
    shortCode: '02'
  }, {
    name: 'Berane',
    shortCode: '03'
  }, {
    name: 'Bijelo Polje',
    shortCode: '04'
  }, {
    name: 'Budva',
    shortCode: '05'
  }, {
    name: 'Cetinje',
    shortCode: '06'
  }, {
    name: 'Danilovgrad',
    shortCode: '07'
  }, {
    name: 'Gusinje',
    shortCode: '22'
  }, {
    name: 'Herceg Novi',
    shortCode: '08'
  }, {
    name: 'Kolašin',
    shortCode: '09'
  }, {
    name: 'Kotor',
    shortCode: '10'
  }, {
    name: 'Mojkovac',
    shortCode: '11'
  }, {
    name: 'Nikšić',
    shortCode: '12'
  }, {
    name: 'Petnica',
    shortCode: '23'
  }, {
    name: 'Plav',
    shortCode: '13'
  }, {
    name: 'Plužine',
    shortCode: '14'
  }, {
    name: 'Pljevlja',
    shortCode: '15'
  }, {
    name: 'Podgorica',
    shortCode: '16'
  }, {
    name: 'Rožaje',
    shortCode: '17'
  }, {
    name: 'Šavnik',
    shortCode: '18'
  }, {
    name: 'Tivat',
    shortCode: '19'
  }, {
    name: 'Ulcinj',
    shortCode: '20'
  }, {
    name: 'Žabljak',
    shortCode: '21'
  }]
}, {
  countryName: 'Montserrat',
  countryShortCode: 'MS',
  regions: [{
    name: 'Saint Anthony'
  }, {
    name: 'Saint Georges'
  }, {
    name: "Saint Peter's"
  }]
}, {
  countryName: 'Morocco',
  countryShortCode: 'MA',
  regions: [{
    name: 'Tanger-Tétouan-Al Hoceïma',
    code: 'MA-01'
  }, {
    name: "L'Oriental",
    code: 'MA-02'
  }, {
    name: 'Fès-Meknès',
    code: 'MA-03'
  }, {
    name: 'Rabat-Salé-Kénitra',
    code: 'MA-04'
  }, {
    name: 'Béni Mellal-Khénifra',
    code: 'MA-05'
  }, {
    name: 'Casablanca-Settat',
    code: 'MA-06'
  }, {
    name: 'Marrakech-Safi',
    code: 'MA-07'
  }, {
    name: 'Drâa-Tafilalet',
    code: 'MA-08'
  }, {
    name: 'Souss-Massa',
    code: 'MA-09'
  }, {
    name: 'Guelmim-Oued Noun',
    code: 'MA-10'
  }, {
    name: 'Laâyoune-Sakia El Hamra',
    code: 'MA-11'
  }, {
    name: 'Dakhla-Oued Ed-Dahab',
    code: 'MA-12'
  }]
}, {
  countryName: 'Mozambique',
  countryShortCode: 'MZ',
  regions: [{
    name: 'Cabo Delgado',
    shortCode: 'P'
  }, {
    name: 'Gaza',
    shortCode: 'G'
  }, {
    name: 'Inhambane',
    shortCode: 'I'
  }, {
    name: 'Manica',
    shortCode: 'B'
  }, {
    name: 'Maputo',
    shortCode: 'L'
  }, {
    name: 'Maputo (City)',
    shortCode: 'MPM'
  }, {
    name: 'Nampula',
    shortCode: 'N'
  }, {
    name: 'Niassa',
    shortCode: 'A'
  }, {
    name: 'Sofala',
    shortCode: 'S'
  }, {
    name: 'Tete',
    shortCode: 'T'
  }, {
    name: 'Zambezia',
    shortCode: 'Q'
  }]
}, {
  countryName: 'Myanmar',
  countryShortCode: 'MM',
  regions: [{
    name: 'Ayeyarwady',
    shortCode: '07'
  }, {
    name: 'Bago',
    shortCode: '02'
  }, {
    name: 'Chin',
    shortCode: '14'
  }, {
    name: 'Kachin',
    shortCode: '11'
  }, {
    name: 'Kayah',
    shortCode: '12'
  }, {
    name: 'Kayin',
    shortCode: '13'
  }, {
    name: 'Magway',
    shortCode: '03'
  }, {
    name: 'Mandalay',
    shortCode: '04'
  }, {
    name: 'Mon',
    shortCode: '15'
  }, {
    name: 'Nay Pyi Taw',
    shortCode: '18'
  }, {
    name: 'Rakhine',
    shortCode: '16'
  }, {
    name: 'Sagaing',
    shortCode: '01'
  }, {
    name: 'Shan',
    shortCode: '17'
  }, {
    name: 'Tanintharyi',
    shortCode: '05'
  }, {
    name: 'Yangon',
    shortCode: '06'
  }]
}, {
  countryName: 'Namibia',
  countryShortCode: 'NA',
  regions: [{
    name: 'Erongo',
    shortCode: 'ER'
  }, {
    name: 'Hardap',
    shortCode: 'HA'
  }, {
    name: 'Kavango East',
    shortCode: 'KE'
  }, {
    name: 'Kavango West',
    shortCode: 'KW'
  }, {
    name: 'Karas',
    shortCode: 'KA'
  }, {
    name: 'Khomas',
    shortCode: 'KH'
  }, {
    name: 'Kunene',
    shortCode: 'KU'
  }, {
    name: 'Ohangwena',
    shortCode: 'OW'
  }, {
    name: 'Omaheke',
    shortCode: 'OH'
  }, {
    name: 'Omusati',
    shortCode: 'OS'
  }, {
    name: 'Oshana',
    shortCode: 'ON'
  }, {
    name: 'Oshikoto',
    shortCode: 'OT'
  }, {
    name: 'Otjozondjupa',
    shortCode: 'OD'
  }, {
    name: 'Zambezi',
    shortCode: 'CA'
  }]
}, {
  countryName: 'Nauru',
  countryShortCode: 'NR',
  regions: [{
    name: 'Aiwo',
    shortCode: '01'
  }, {
    name: 'Anabar',
    shortCode: '02'
  }, {
    name: 'Anetan',
    shortCode: '03'
  }, {
    name: 'Anibare',
    shortCode: '04'
  }, {
    name: 'Baiti',
    shortCode: '05'
  }, {
    name: 'Boe',
    shortCode: '06'
  }, {
    name: 'Buada',
    shortCode: '07'
  }, {
    name: 'Denigomodu',
    shortCode: '08'
  }, {
    name: 'Ewa',
    shortCode: '09'
  }, {
    name: 'Ijuw',
    shortCode: '10'
  }, {
    name: 'Meneng',
    shortCode: '11'
  }, {
    name: 'Nibok',
    shortCode: '12'
  }, {
    name: 'Uaboe',
    shortCode: '13'
  }, {
    name: 'Yaren',
    shortCode: '14'
  }]
}, {
  countryName: 'Nepal',
  countryShortCode: 'NP',
  regions: [{
    name: 'Bagmati',
    shortCode: 'BA'
  }, {
    name: 'Bheri',
    shortCode: 'BH'
  }, {
    name: 'Dhawalagiri',
    shortCode: 'DH'
  }, {
    name: 'Gandaki',
    shortCode: 'GA'
  }, {
    name: 'Janakpur',
    shortCode: 'JA'
  }, {
    name: 'Karnali',
    shortCode: 'KA'
  }, {
    name: 'Kosi',
    shortCode: 'KO'
  }, {
    name: 'Lumbini',
    shortCode: 'LU'
  }, {
    name: 'Mahakali',
    shortCode: 'MA'
  }, {
    name: 'Mechi',
    shortCode: 'ME'
  }, {
    name: 'Narayani',
    shortCode: 'NA'
  }, {
    name: 'Rapti',
    shortCode: 'RA'
  }, {
    name: 'Sagarmatha',
    shortCode: 'SA'
  }, {
    name: 'Seti',
    shortCode: 'SE'
  }]
}, {
  countryName: 'Netherlands',
  countryShortCode: 'NL',
  regions: [{
    name: 'Drenthe',
    shortCode: 'DR'
  }, {
    name: 'Flevoland',
    shortCode: 'FL'
  }, {
    name: 'Friesland',
    shortCode: 'FR'
  }, {
    name: 'Gelderland',
    shortCode: 'GE'
  }, {
    name: 'Groningen',
    shortCode: 'GR'
  }, {
    name: 'Limburg',
    shortCode: 'LI'
  }, {
    name: 'Noord-Brabant',
    shortCode: 'NB'
  }, {
    name: 'Noord-Holland',
    shortCode: 'NH'
  }, {
    name: 'Overijssel',
    shortCode: 'OV'
  }, {
    name: 'Utrecht',
    shortCode: 'UT'
  }, {
    name: 'Zeeland',
    shortCode: 'ZE'
  }, {
    name: 'Zuid-Holland',
    shortCode: 'ZH'
  }]
}, {
  countryName: 'New Caledonia',
  countryShortCode: 'NC',
  regions: [{
    name: 'Iles Loyaute'
  }, {
    name: 'Nord'
  }, {
    name: 'Sud'
  }]
}, {
  countryName: 'New Zealand',
  countryShortCode: 'NZ',
  regions: [{
    name: 'Auckland',
    shortCode: 'AUK'
  }, {
    name: 'Bay of Plenty',
    shortCode: 'BOP'
  }, {
    name: 'Canterbury',
    shortCode: 'CAN'
  }, {
    name: 'Gisborne',
    shortCode: 'GIS'
  }, {
    name: "Hawke's Bay",
    shortCode: 'HKB'
  }, {
    name: 'Marlborough',
    shortCode: 'MBH'
  }, {
    name: 'Manawatu-Wanganui',
    shortCode: 'MWT'
  }, {
    name: 'Northland',
    shortCode: 'NTL'
  }, {
    name: 'Nelson',
    shortCode: 'NSN'
  }, {
    name: 'Otago',
    shortCode: 'OTA'
  }, {
    name: 'Southland',
    shortCode: 'STL'
  }, {
    name: 'Taranaki',
    shortCode: 'TKI'
  }, {
    name: 'Tasman',
    shortCode: 'TAS'
  }, {
    name: 'Waikato',
    shortCode: 'WKO'
  }, {
    name: 'Wellington',
    shortCode: 'WGN'
  }, {
    name: 'West Coast',
    shortCode: 'WTC'
  }, {
    name: 'Chatham Islands Territory',
    shortCode: 'CIT'
  }]
}, {
  countryName: 'Nicaragua',
  countryShortCode: 'NI',
  regions: [{
    name: 'Boaco',
    shortCode: 'BO'
  }, {
    name: 'Carazo',
    shortCode: 'CA'
  }, {
    name: 'Chinandega',
    shortCode: 'CI'
  }, {
    name: 'Chontales',
    shortCode: 'CO'
  }, {
    name: 'Estelí',
    shortCode: 'ES'
  }, {
    name: 'Granada',
    shortCode: 'GR'
  }, {
    name: 'Jinotega',
    shortCode: 'JI'
  }, {
    name: 'León',
    shortCode: 'LE'
  }, {
    name: 'Madriz',
    shortCode: 'MD'
  }, {
    name: 'Managua',
    shortCode: 'MN'
  }, {
    name: 'Masaya',
    shortCode: 'MS'
  }, {
    name: 'Matagalpa',
    shortCode: 'MT'
  }, {
    name: 'Nueva Segovia',
    shortCode: 'NS'
  }, {
    name: 'Río San Juan',
    shortCode: 'SJ'
  }, {
    name: 'Rivas',
    shortCode: 'RI'
  }, {
    name: 'Atlántico Norte',
    shortCode: 'AN'
  }, {
    name: 'Atlántico Sur',
    shortCode: 'AS'
  }]
}, {
  countryName: 'Niger',
  countryShortCode: 'NE',
  regions: [{
    name: 'Agadez',
    shortCode: '1'
  }, {
    name: 'Diffa',
    shortCode: '2'
  }, {
    name: 'Dosso',
    shortCode: '3'
  }, {
    name: 'Maradi',
    shortCode: '4'
  }, {
    name: 'Niamey',
    shortCode: '8'
  }, {
    name: 'Tahoua',
    shortCode: '5'
  }, {
    name: 'Tillabéri',
    shortCode: '6'
  }, {
    name: 'Zinder',
    shortCode: '7'
  }]
}, {
  countryName: 'Nigeria',
  countryShortCode: 'NG',
  regions: [{
    name: 'Abia',
    shortCode: 'AB'
  }, {
    name: 'Abuja Federal Capital Territory',
    shortCode: 'FC'
  }, {
    name: 'Adamawa',
    shortCode: 'AD'
  }, {
    name: 'Akwa Ibom',
    shortCode: 'AK'
  }, {
    name: 'Anambra',
    shortCode: 'AN'
  }, {
    name: 'Bauchi',
    shortCode: 'BA'
  }, {
    name: 'Bayelsa',
    shortCode: 'BY'
  }, {
    name: 'Benue',
    shortCode: 'BE'
  }, {
    name: 'Borno',
    shortCode: 'BO'
  }, {
    name: 'Cross River',
    shortCode: 'CR'
  }, {
    name: 'Delta',
    shortCode: 'DE'
  }, {
    name: 'Ebonyi',
    shortCode: 'EB'
  }, {
    name: 'Edo',
    shortCode: 'ED'
  }, {
    name: 'Ekiti',
    shortCode: 'EK'
  }, {
    name: 'Enugu',
    shortCode: 'EN'
  }, {
    name: 'Gombe',
    shortCode: 'GO'
  }, {
    name: 'Imo',
    shortCode: 'IM'
  }, {
    name: 'Jigawa',
    shortCode: 'JI'
  }, {
    name: 'Kaduna',
    shortCode: 'KD'
  }, {
    name: 'Kano',
    shortCode: 'KN'
  }, {
    name: 'Katsina',
    shortCode: 'KT'
  }, {
    name: 'Kebbi',
    shortCode: 'KE'
  }, {
    name: 'Kogi',
    shortCode: 'KO'
  }, {
    name: 'Kwara',
    shortCode: 'KW'
  }, {
    name: 'Lagos',
    shortCode: 'LA'
  }, {
    name: 'Nassarawa',
    shortCode: 'NA'
  }, {
    name: 'Niger',
    shortCode: 'NI'
  }, {
    name: 'Ogun',
    shortCode: 'OG'
  }, {
    name: 'Ondo',
    shortCode: 'ON'
  }, {
    name: 'Osun',
    shortCode: 'OS'
  }, {
    name: 'Oyo',
    shortCode: 'OY'
  }, {
    name: 'Plateau',
    shortCode: 'PL'
  }, {
    name: 'Rivers',
    shortCode: 'RI'
  }, {
    name: 'Sokoto',
    shortCode: 'SO'
  }, {
    name: 'Taraba',
    shortCode: 'TA'
  }, {
    name: 'Yobe',
    shortCode: 'YO'
  }, {
    name: 'Zamfara',
    shortCode: 'ZA'
  }]
}, {
  countryName: 'Niue',
  countryShortCode: 'NU',
  regions: [{
    name: 'Niue'
  }]
}, {
  countryName: 'Norfolk Island',
  countryShortCode: 'NF',
  regions: [{
    name: 'Norfolk Island'
  }]
}, {
  countryName: 'Northern Mariana Islands',
  countryShortCode: 'MP',
  regions: [{
    name: 'Northern Islands'
  }, {
    name: 'Rota'
  }, {
    name: 'Saipan'
  }, {
    name: 'Tinian'
  }]
}, {
  countryName: 'Norway',
  countryShortCode: 'NO',
  regions: [{
    name: 'Akershus',
    shortCode: '02'
  }, {
    name: 'Aust-Agder',
    shortCode: '09'
  }, {
    name: 'Buskerud',
    shortCode: '06'
  }, {
    name: 'Finnmark',
    shortCode: '20'
  }, {
    name: 'Hedmark',
    shortCode: '04'
  }, {
    name: 'Hordaland',
    shortCode: '12'
  }, {
    name: 'Møre og Romsdal',
    shortCode: '15'
  }, {
    name: 'Nordland',
    shortCode: '18'
  }, {
    name: 'Nord-Trøndelag',
    shortCode: '17'
  }, {
    name: 'Oppland',
    shortCode: '05'
  }, {
    name: 'Oslo',
    shortCode: '03'
  }, {
    name: 'Rogaland',
    shortCode: '11'
  }, {
    name: 'Sogn og Fjordane',
    shortCode: '14'
  }, {
    name: 'Sør-Trøndelag',
    shortCode: '16'
  }, {
    name: 'Telemark',
    shortCode: '08'
  }, {
    name: 'Troms',
    shortCode: '19'
  }, {
    name: 'Vest-Agder',
    shortCode: '10'
  }, {
    name: 'Vestfold',
    shortCode: '07'
  }, {
    name: 'Østfold',
    shortCode: '01'
  }, {
    name: 'Jan Mayen',
    shortCode: '22'
  }, {
    name: 'Svalbard',
    shortCode: '21'
  }]
}, {
  countryName: 'Oman',
  countryShortCode: 'OM',
  regions: [{
    name: 'Ad Dakhiliyah',
    shortCode: 'DA'
  }, {
    name: 'Al Buraymi',
    shortCode: 'BU'
  }, {
    name: 'Al Wusta',
    shortCode: 'WU'
  }, {
    name: 'Az Zahirah',
    shortCode: 'ZA'
  }, {
    name: 'Janub al Batinah',
    shortCode: 'BS'
  }, {
    name: 'Janub ash Sharqiyah',
    shortCode: 'SS'
  }, {
    name: 'Masqat',
    shortCode: 'MA'
  }, {
    name: 'Musandam',
    shortCode: 'MU'
  }, {
    name: 'Shamal al Batinah',
    shortCode: 'BJ'
  }, {
    name: 'Shamal ash Sharqiyah',
    shortCode: 'SJ'
  }, {
    name: 'Zufar',
    shortCode: 'ZU'
  }]
}, {
  countryName: 'Pakistan',
  countryShortCode: 'PK',
  regions: [{
    name: 'Āzād Kashmīr',
    shortCode: 'JK'
  }, {
    name: 'Balōchistān',
    shortCode: 'BA'
  }, {
    name: 'Gilgit-Baltistān',
    shortCode: 'GB'
  }, {
    name: 'Islāmābād',
    shortCode: 'IS'
  }, {
    name: 'Khaībar Pakhtūnkhwās',
    shortCode: 'KP'
  }, {
    name: 'Punjāb',
    shortCode: 'PB'
  }, {
    name: 'Sindh',
    shortCode: 'SD'
  }, {
    name: 'Federally Administered Tribal Areas',
    shortCode: 'TA'
  }]
}, {
  countryName: 'Palau',
  countryShortCode: 'PW',
  regions: [{
    name: 'Aimeliik',
    shortCode: '002'
  }, {
    name: 'Airai',
    shortCode: '004'
  }, {
    name: 'Angaur',
    shortCode: '010'
  }, {
    name: 'Hatobohei',
    shortCode: '050'
  }, {
    name: 'Kayangel',
    shortCode: '100'
  }, {
    name: 'Koror',
    shortCode: '150'
  }, {
    name: 'Melekeok',
    shortCode: '212'
  }, {
    name: 'Ngaraard',
    shortCode: '214'
  }, {
    name: 'Ngarchelong',
    shortCode: '218'
  }, {
    name: 'Ngardmau',
    shortCode: '222'
  }, {
    name: 'Ngatpang',
    shortCode: '224'
  }, {
    name: 'Ngchesar',
    shortCode: '226'
  }, {
    name: 'Ngeremlengui',
    shortCode: '227'
  }, {
    name: 'Ngiwal',
    shortCode: '228'
  }, {
    name: 'Peleliu',
    shortCode: '350'
  }, {
    name: 'Sonsoral',
    shortCode: '370'
  }]
}, {
  countryName: 'Palestine, State of',
  countryShortCode: 'PS',
  regions: [{
    name: 'Ak Khalīl',
    shortCode: 'HBN'
  }, {
    name: 'Al Quds',
    shortCode: 'JEM'
  }, {
    name: 'Arīḩā wal Aghwār',
    shortCode: 'JRH'
  }, {
    name: 'Bayt Laḩm',
    shortCode: 'BTH'
  }, {
    name: 'Dayr al Balaḩ',
    shortCode: 'DEB'
  }, {
    name: 'Ghazzah',
    shortCode: 'GZA'
  }, {
    name: 'Janīn',
    shortCode: 'JEN'
  }, {
    name: 'Khān Yūnis',
    shortCode: 'KYS'
  }, {
    name: 'Nāblus',
    shortCode: 'NBS'
  }, {
    name: 'Qalqīyah',
    shortCode: 'QQA'
  }, {
    name: 'Rafaḩ',
    shortCode: 'RFH'
  }, {
    name: 'Rām Allāh wal Bīrah',
    shortCode: 'RBH'
  }, {
    name: 'Salfīt',
    shortCode: 'SLT'
  }, {
    name: 'Shamāl Ghazzah',
    shortCode: 'NGZ'
  }, {
    name: 'Ţūbās',
    shortCode: 'TBS'
  }, {
    name: 'Ţūlkarm',
    shortCode: 'TKM'
  }]
}, {
  countryName: 'Panama',
  countryShortCode: 'PA',
  regions: [{
    name: 'Bocas del Toro',
    shortCode: '1'
  }, {
    name: 'Chiriquí',
    shortCode: '4'
  }, {
    name: 'Coclé',
    shortCode: '2'
  }, {
    name: 'Colón',
    shortCode: '3'
  }, {
    name: 'Darién',
    shortCode: '5'
  }, {
    name: 'Emberá',
    shortCode: 'EM'
  }, {
    name: 'Herrera',
    shortCode: '6'
  }, {
    name: 'Kuna Yala',
    shortCode: 'KY'
  }, {
    name: 'Los Santos',
    shortCode: '7'
  }, {
    name: 'Ngäbe-Buglé',
    shortCode: 'NB'
  }, {
    name: 'Panamá',
    shortCode: '8'
  }, {
    name: 'Panamá Oeste',
    shortCode: '10'
  }, {
    name: 'Veraguas',
    shortCode: '9'
  }]
}, {
  countryName: 'Papua New Guinea',
  countryShortCode: 'PG',
  regions: [{
    name: 'Bougainville',
    shortCode: 'NSB'
  }, {
    name: 'Central',
    shortCode: 'CPM'
  }, {
    name: 'Chimbu',
    shortCode: 'CPK'
  }, {
    name: 'East New Britain',
    shortCode: 'EBR'
  }, {
    name: 'East Sepik',
    shortCode: 'ESW'
  }, {
    name: 'Eastern Highlands',
    shortCode: 'EHG'
  }, {
    name: 'Enga',
    shortCode: 'EPW'
  }, {
    name: 'Gulf',
    shortCode: 'GPK'
  }, {
    name: 'Hela',
    shortCode: 'HLA'
  }, {
    name: 'Jiwaka',
    shortCode: 'JWK'
  }, {
    name: 'Madang',
    shortCode: 'MOM'
  }, {
    name: 'Manus',
    shortCode: 'MRL'
  }, {
    name: 'Milne Bay',
    shortCode: 'MBA'
  }, {
    name: 'Morobe',
    shortCode: 'MPL'
  }, {
    name: 'Port Moresby',
    shortCode: 'NCD'
  }, {
    name: 'New Ireland',
    shortCode: 'NIK'
  }, {
    name: 'Northern',
    shortCode: 'NPP'
  }, {
    name: 'Southern Highlands',
    shortCode: 'SHM'
  }, {
    name: 'West New Britain',
    shortCode: 'WBK'
  }, {
    name: 'West Sepik',
    shortCode: 'SAN'
  }, {
    name: 'Western',
    shortCode: 'WPD'
  }, {
    name: 'Western Highlands',
    shortCode: 'WHM'
  }]
}, {
  countryName: 'Paraguay',
  countryShortCode: 'PY',
  regions: [{
    name: 'Alto Paraguay',
    shortCode: '16'
  }, {
    name: 'Alto Parana',
    shortCode: '10'
  }, {
    name: 'Amambay',
    shortCode: '13'
  }, {
    name: 'Asuncion',
    shortCode: 'ASU'
  }, {
    name: 'Caaguazu',
    shortCode: '5'
  }, {
    name: 'Caazapa',
    shortCode: '6'
  }, {
    name: 'Canindeyu',
    shortCode: '14'
  }, {
    name: 'Central',
    shortCode: '11'
  }, {
    name: 'Concepcion',
    shortCode: '1'
  }, {
    name: 'Cordillera',
    shortCode: '3'
  }, {
    name: 'Boqueron',
    shortCode: '17'
  }, {
    name: 'Guaira',
    shortCode: '4'
  }, {
    name: 'Itapua',
    shortCode: '7'
  }, {
    name: 'Misiones',
    shortCode: '8'
  }, {
    name: 'Neembucu',
    shortCode: '12'
  }, {
    name: 'Paraguari',
    shortCode: '9'
  }, {
    name: 'Presidente Hayes',
    shortCode: '15'
  }, {
    name: 'San Pedro',
    shortCode: '2'
  }]
}, {
  countryName: 'Peru',
  countryShortCode: 'PE',
  regions: [{
    name: 'Amazonas',
    shortCode: 'AMA'
  }, {
    name: 'Ancash',
    shortCode: 'ANC'
  }, {
    name: 'Apurimac',
    shortCode: 'APU'
  }, {
    name: 'Arequipa',
    shortCode: 'ARE'
  }, {
    name: 'Ayacucho',
    shortCode: 'AYA'
  }, {
    name: 'Cajamarca',
    shortCode: 'CAJ'
  }, {
    name: 'Callao',
    shortCode: 'CAL'
  }, {
    name: 'Cusco',
    shortCode: 'CUS'
  }, {
    name: 'Huancavelica',
    shortCode: 'HUV'
  }, {
    name: 'Huanuco',
    shortCode: 'HUC'
  }, {
    name: 'Ica',
    shortCode: 'ICA'
  }, {
    name: 'Junin',
    shortCode: 'JUN'
  }, {
    name: 'La Libertad',
    shortCode: 'LAL'
  }, {
    name: 'Lambayeque',
    shortCode: 'LAM'
  }, {
    name: 'Lima',
    shortCode: 'LIM'
  }, {
    name: 'Loreto',
    shortCode: 'LOR'
  }, {
    name: 'Madre de Dios',
    shortCode: 'MDD'
  }, {
    name: 'Moquegua',
    shortCode: 'MOQ'
  }, {
    name: 'Municipalidad Metropolitana de Lima',
    shortCode: 'LMA'
  }, {
    name: 'Pasco',
    shortCode: 'PAS'
  }, {
    name: 'Piura',
    shortCode: 'PIU'
  }, {
    name: 'Puno',
    shortCode: 'PUN'
  }, {
    name: 'San Martin',
    shortCode: 'SAM'
  }, {
    name: 'Tacna',
    shortCode: 'TAC'
  }, {
    name: 'Tumbes',
    shortCode: 'TUM'
  }, {
    name: 'Ucayali',
    shortCode: 'UCA'
  }]
}, {
  countryName: 'Philippines',
  countryShortCode: 'PH',
  regions: [{
    name: 'Abra',
    shortCode: 'ABR'
  }, {
    name: 'Agusan del Norte',
    shortCode: 'AGN'
  }, {
    name: 'Agusan del Sur',
    shortCode: 'AGS'
  }, {
    name: 'Aklan',
    shortCode: 'AKL'
  }, {
    name: 'Albay',
    shortCode: 'ALB'
  }, {
    name: 'Antique',
    shortCode: 'ANT'
  }, {
    name: 'Apayao',
    shortCode: 'APA'
  }, {
    name: 'Aurora',
    shortCode: 'AUR'
  }, {
    name: 'Basilan',
    shortCode: 'BAS'
  }, {
    name: 'Bataan',
    shortCode: 'BAN'
  }, {
    name: 'Batanes',
    shortCode: 'BTN'
  }, {
    name: 'Batangas',
    shortCode: 'BTG'
  }, {
    name: 'Benguet',
    shortCode: 'BEN'
  }, {
    name: 'Biliran',
    shortCode: 'BIL'
  }, {
    name: 'Bohol',
    shortCode: 'BOH'
  }, {
    name: 'Bukidnon',
    shortCode: 'BUK'
  }, {
    name: 'Bulacan',
    shortCode: 'BUL'
  }, {
    name: 'Cagayan',
    shortCode: 'CAG'
  }, {
    name: 'Camarines Norte',
    shortCode: 'CAN'
  }, {
    name: 'Camarines Sur',
    shortCode: 'CAS'
  }, {
    name: 'Camiguin',
    shortCode: 'CAM'
  }, {
    name: 'Capiz',
    shortCode: 'CAP'
  }, {
    name: 'Catanduanes',
    shortCode: 'CAT'
  }, {
    name: 'Cavite',
    shortCode: 'CAV'
  }, {
    name: 'Cebu',
    shortCode: 'CEB'
  }, {
    name: 'Compostela',
    shortCode: 'COM'
  }, {
    name: 'Cotabato',
    shortCode: 'NCO'
  }, {
    name: 'Davao del Norte',
    shortCode: 'DAV'
  }, {
    name: 'Davao del Sur',
    shortCode: 'DAS'
  }, {
    name: 'Davao Occidental',
    shortCode: 'DVO'
  }, {
    name: 'Davao Oriental',
    shortCode: 'DAO'
  }, {
    name: 'Dinagat Islands',
    shortCode: 'DIN'
  }, {
    name: 'Eastern Samar',
    shortCode: 'EAS'
  }, {
    name: 'Guimaras',
    shortCode: 'GUI'
  }, {
    name: 'Ifugao',
    shortCode: 'IFU'
  }, {
    name: 'Ilocos Norte',
    shortCode: 'ILN'
  }, {
    name: 'Ilocos Sur',
    shortCode: 'ILS'
  }, {
    name: 'Iloilo',
    shortCode: 'ILI'
  }, {
    name: 'Isabela',
    shortCode: 'ISA'
  }, {
    name: 'Kalinga',
    shortCode: 'KAL'
  }, {
    name: 'La Union',
    shortCode: 'LUN'
  }, {
    name: 'Laguna',
    shortCode: 'LAG'
  }, {
    name: 'Lanao del Norte',
    shortCode: 'LAN'
  }, {
    name: 'Lanao del Sur',
    shortCode: 'LAS'
  }, {
    name: 'Leyte',
    shortCode: 'LEY'
  }, {
    name: 'Maguindanao',
    shortCode: 'MAG'
  }, {
    name: 'Masbate',
    shortCode: 'MAS'
  }, {
    name: 'Metro Manila',
    shortCode: '00'
  }, {
    name: 'Mindoro Occidental',
    shortCode: 'MDC'
  }, {
    name: 'Mindoro Oriental',
    shortCode: 'MDR'
  }, {
    name: 'Misamis Occidental',
    shortCode: 'MSC'
  }, {
    name: 'Misamis Oriental',
    shortCode: 'MSR'
  }, {
    name: 'Mountain Province',
    shortCode: 'MOU'
  }, {
    name: 'Negros Occidental',
    shortCode: 'NEC'
  }, {
    name: 'Negros Oriental',
    shortCode: 'NER'
  }, {
    name: 'Northern Samar',
    shortCode: 'NSA'
  }, {
    name: 'Nueva Ecija',
    shortCode: 'NUE'
  }, {
    name: 'Nueva Vizcaya',
    shortCode: 'NUV'
  }, {
    name: 'Palawan',
    shortCode: 'PLW'
  }, {
    name: 'Pampanga',
    shortCode: 'PAM'
  }, {
    name: 'Pangasinan',
    shortCode: 'PAN'
  }, {
    name: 'Quezon',
    shortCode: 'QUE'
  }, {
    name: 'Quirino',
    shortCode: 'QUI'
  }, {
    name: 'Rizal',
    shortCode: 'RIZ'
  }, {
    name: 'Romblon',
    shortCode: 'ROM'
  }, {
    name: 'Samar',
    shortCode: 'WSA'
  }, {
    name: 'Sarangani',
    shortCode: 'SAR'
  }, {
    name: 'Siquijor',
    shortCode: 'SIG'
  }, {
    name: 'Sorsogon',
    shortCode: 'SOR'
  }, {
    name: 'Southern Leyte',
    shortCode: 'SLE'
  }, {
    name: 'Sultan Kudarat',
    shortCode: 'AUK'
  }, {
    name: 'Sulu',
    shortCode: 'SLU'
  }, {
    name: 'Surigao del Norte',
    shortCode: 'SUN'
  }, {
    name: 'Surigao del Sur',
    shortCode: 'SUR'
  }, {
    name: 'Tarlac',
    shortCode: 'TAR'
  }, {
    name: 'Tawi-Tawi',
    shortCode: 'TAW'
  }, {
    name: 'Zambales',
    shortCode: 'ZMB'
  }, {
    name: 'Zamboanga del Norte',
    shortCode: 'ZAN'
  }, {
    name: 'Zamboanga del Sur',
    shortCode: 'ZAS'
  }, {
    name: 'Zamboanga Sibugay',
    shortCode: 'ZSI'
  }]
}, {
  countryName: 'Pitcairn',
  countryShortCode: 'PN',
  regions: [{
    name: 'Pitcairn Islands'
  }]
}, {
  countryName: 'Poland',
  countryShortCode: 'PL',
  regions: [{
    name: 'Dolnośląskie',
    shortCode: 'DS'
  }, {
    name: 'Kujawsko-pomorskie',
    shortCode: 'KP'
  }, {
    name: 'Łódzkie',
    shortCode: 'LD'
  }, {
    name: 'Lubelskie',
    shortCode: 'LU'
  }, {
    name: 'Lubuskie',
    shortCode: 'LB'
  }, {
    name: 'Małopolskie',
    shortCode: 'MA'
  }, {
    name: 'Mazowieckie',
    shortCode: 'MZ'
  }, {
    name: 'Opolskie',
    shortCode: 'OP'
  }, {
    name: 'Podkarpackie',
    shortCode: 'PK'
  }, {
    name: 'Podlaskie',
    shortCode: 'PD'
  }, {
    name: 'Pomorskie',
    shortCode: 'PM'
  }, {
    name: 'Śląskie',
    shortCode: 'SL'
  }, {
    name: 'Świętokrzyskie',
    shortCode: 'SK'
  }, {
    name: 'Warmińsko-mazurskie',
    shortCode: 'WN'
  }, {
    name: 'Wielkopolskie',
    shortCode: 'WP'
  }, {
    name: 'Zachodniopomorskie',
    shortCode: 'ZP'
  }]
}, {
  countryName: 'Portugal',
  countryShortCode: 'PT',
  regions: [{
    name: 'Açores',
    shortCode: '20'
  }, {
    name: 'Aveiro',
    shortCode: '01'
  }, {
    name: 'Beja',
    shortCode: '02'
  }, {
    name: 'Braga',
    shortCode: '03'
  }, {
    name: 'Bragança',
    shortCode: '04'
  }, {
    name: 'Castelo Branco',
    shortCode: '05'
  }, {
    name: 'Coimbra',
    shortCode: '06'
  }, {
    name: 'Évora',
    shortCode: '07'
  }, {
    name: 'Faro',
    shortCode: '08'
  }, {
    name: 'Guarda',
    shortCode: '09'
  }, {
    name: 'Leiria',
    shortCode: '10'
  }, {
    name: 'Lisboa',
    shortCode: '11'
  }, {
    name: 'Madeira',
    shortCode: '30'
  }, {
    name: 'Portalegre',
    shortCode: '12'
  }, {
    name: 'Porto',
    shortCode: '13'
  }, {
    name: 'Santarém',
    shortCode: '14'
  }, {
    name: 'Setúbal',
    shortCode: '15'
  }, {
    name: 'Viana do Castelo',
    shortCode: '16'
  }, {
    name: 'Vila Real',
    shortCode: '17'
  }, {
    name: 'Viseu',
    shortCode: '18'
  }]
}, {
  countryName: 'Puerto Rico',
  countryShortCode: 'PR',
  regions: [{
    name: 'Adjuntas'
  }, {
    name: 'Aguada'
  }, {
    name: 'Aguadilla'
  }, {
    name: 'Aguas Buenas'
  }, {
    name: 'Aibonito'
  }, {
    name: 'Anasco'
  }, {
    name: 'Arecibo'
  }, {
    name: 'Arroyo'
  }, {
    name: 'Barceloneta'
  }, {
    name: 'Barranquitas'
  }, {
    name: 'Bayamon'
  }, {
    name: 'Cabo Rojo'
  }, {
    name: 'Caguas'
  }, {
    name: 'Camuy'
  }, {
    name: 'Canovanas'
  }, {
    name: 'Carolina'
  }, {
    name: 'Cat'
  }, {
    name: 'Ceiba'
  }, {
    name: 'Ciales'
  }, {
    name: 'Cidra'
  }, {
    name: 'Coamo'
  }, {
    name: 'Comerio'
  }, {
    name: 'Corozal'
  }, {
    name: 'Culebra'
  }, {
    name: 'Dorado'
  }, {
    name: 'Fajardo'
  }, {
    name: 'Florida'
  }, {
    name: 'Guanica'
  }, {
    name: 'Guayama'
  }, {
    name: 'Guayanilla'
  }, {
    name: 'Guaynabo'
  }, {
    name: 'Gurabo'
  }, {
    name: 'Hatillo'
  }, {
    name: 'Hormigueros'
  }, {
    name: 'Humacao'
  }, {
    name: 'Isabe'
  }, {
    name: 'Juana Diaz'
  }, {
    name: 'Juncos'
  }, {
    name: 'Lajas'
  }, {
    name: 'Lares'
  }, {
    name: 'Las Marias'
  }, {
    name: 'Las oiza'
  }, {
    name: 'Luquillo'
  }, {
    name: 'Manati'
  }, {
    name: 'Maricao'
  }, {
    name: 'Maunabo'
  }, {
    name: 'Mayaguez'
  }, {
    name: 'Moca'
  }, {
    name: 'Morovis'
  }, {
    name: 'Naguabo'
  }, {
    name: 'Naranjito'
  }, {
    name: 'Orocovis'
  }, {
    name: 'Patillas'
  }, {
    name: 'Penuelas'
  }, {
    name: 'Ponce'
  }, {
    name: 'Quebradillas'
  }, {
    name: 'Rincon'
  }, {
    name: 'Rio Grande'
  }, {
    name: 'Sabana linas'
  }, {
    name: 'San German'
  }, {
    name: 'San Juan'
  }, {
    name: 'San Lorenzo'
  }, {
    name: 'San Sebastian'
  }, {
    name: 'Santa Isabel'
  }, {
    name: 'Toa Alta'
  }, {
    name: 'Toa Baja'
  }, {
    name: 'Trujillo Alto'
  }, {
    name: 'Utuado'
  }, {
    name: 'Vega Alta'
  }, {
    name: 'Vega ues'
  }, {
    name: 'Villalba'
  }, {
    name: 'Yabucoa'
  }, {
    name: 'Yauco'
  }]
}, {
  countryName: 'Qatar',
  countryShortCode: 'QA',
  regions: [{
    name: 'Ad Dawḩah',
    shortCode: 'DA'
  }, {
    name: 'Al Khawr wa adh Dhakhīrah',
    shortCode: 'KH'
  }, {
    name: 'Al Wakrah',
    shortCode: 'WA'
  }, {
    name: 'Ar Rayyān',
    shortCode: 'RA'
  }, {
    name: 'Ash Shamāl',
    shortCode: 'MS'
  }, {
    name: 'Az̧ Za̧`āyin',
    shortCode: 'ZA'
  }, {
    name: 'Umm Şalāl',
    shortCode: 'US'
  }]
}, {
  countryName: 'Réunion',
  countryShortCode: 'RE',
  regions: [{
    name: 'Réunion'
  }]
}, {
  countryName: 'Romania',
  countryShortCode: 'RO',
  regions: [{
    name: 'Alba',
    shortCode: 'AB'
  }, {
    name: 'Arad',
    shortCode: 'AR'
  }, {
    name: 'Arges',
    shortCode: 'AG'
  }, {
    name: 'Bacau',
    shortCode: 'BC'
  }, {
    name: 'Bihor',
    shortCode: 'BH'
  }, {
    name: 'Bistrita-Nasaud',
    shortCode: 'BN'
  }, {
    name: 'Botosani',
    shortCode: 'BT'
  }, {
    name: 'Braila',
    shortCode: 'BR'
  }, {
    name: 'Brasov',
    shortCode: 'BV'
  }, {
    name: 'Bucuresti',
    shortCode: 'B'
  }, {
    name: 'Buzau',
    shortCode: 'BZ'
  }, {
    name: 'Calarasi',
    shortCode: 'CL'
  }, {
    name: 'Caras-Severin',
    shortCode: 'CS'
  }, {
    name: 'Cluj',
    shortCode: 'CJ'
  }, {
    name: 'Constanta',
    shortCode: 'CT'
  }, {
    name: 'Covasna',
    shortCode: 'CV'
  }, {
    name: 'Dambovita',
    shortCode: 'DB'
  }, {
    name: 'Dolj',
    shortCode: 'DJ'
  }, {
    name: 'Galati',
    shortCode: 'GL'
  }, {
    name: 'Giurgiu',
    shortCode: 'GR'
  }, {
    name: 'Gorj',
    shortCode: 'GJ'
  }, {
    name: 'Harghita',
    shortCode: 'HR'
  }, {
    name: 'Hunedoara',
    shortCode: 'HD'
  }, {
    name: 'Ialomita',
    shortCode: 'IL'
  }, {
    name: 'Iasi',
    shortCode: 'IS'
  }, {
    name: 'Maramures',
    shortCode: 'MM'
  }, {
    name: 'Mehedinti',
    shortCode: 'MH'
  }, {
    name: 'Mures',
    shortCode: 'MS'
  }, {
    name: 'Neamt',
    shortCode: 'NT'
  }, {
    name: 'Olt',
    shortCode: 'OT'
  }, {
    name: 'Prahova',
    shortCode: 'PH'
  }, {
    name: 'Salaj',
    shortCode: 'SJ'
  }, {
    name: 'Satu Mare',
    shortCode: 'SM'
  }, {
    name: 'Sibiu',
    shortCode: 'SB'
  }, {
    name: 'Suceava',
    shortCode: 'SV'
  }, {
    name: 'Teleorman',
    shortCode: 'TR'
  }, {
    name: 'Timis',
    shortCode: 'TM'
  }, {
    name: 'Tulcea',
    shortCode: 'TL'
  }, {
    name: 'Valcea',
    shortCode: 'VL'
  }, {
    name: 'Vaslui',
    shortCode: 'VS'
  }, {
    name: 'Vrancea',
    shortCode: 'VN'
  }]
}, {
  countryName: 'Russian Federation',
  countryShortCode: 'RU',
  regions: [{
    name: 'Republic of Adygea',
    shortCode: 'AD'
  }, {
    name: 'Republic of Altai (Gorno-Altaysk)',
    shortCode: 'AL'
  }, {
    name: 'Altai Krai',
    shortCode: 'ALT'
  }, {
    name: 'Amur Oblast',
    shortCode: 'AMU'
  }, {
    name: 'Arkhangelsk Oblast',
    shortCode: 'ARK'
  }, {
    name: 'Astrakhan Oblast',
    shortCode: 'AST'
  }, {
    name: 'Republic of Bashkortostan',
    shortCode: 'BA'
  }, {
    name: 'Belgorod Oblast',
    shortCode: 'BEL'
  }, {
    name: 'Bryansk Oblast',
    shortCode: 'BRY'
  }, {
    name: 'Republic of Buryatia',
    shortCode: 'BU'
  }, {
    name: 'Chechen Republic',
    shortCode: 'CE'
  }, {
    name: 'Chelyabinsk Oblast',
    shortCode: 'CHE'
  }, {
    name: 'Chukotka Autonomous Okrug',
    shortCode: 'CHU'
  }, {
    name: 'Chuvash Republic',
    shortCode: 'CU'
  }, {
    name: 'Republic of Dagestan',
    shortCode: 'DA'
  }, {
    name: 'Republic of Ingushetia',
    shortCode: 'IN'
  }, {
    name: 'Irkutsk Oblast',
    shortCode: 'IRK'
  }, {
    name: 'Ivanovo Oblast',
    shortCode: 'IVA'
  }, {
    name: 'Jewish Autonomous Oblast',
    shortCode: 'JEW'
  }, {
    name: 'Kabardino-Balkar Republic',
    shortCode: 'KB'
  }, {
    name: 'Kaliningrad Oblast',
    shortCode: 'KLN'
  }, {
    name: 'Republic of Kalmykia',
    shortCode: 'KL'
  }, {
    name: 'Kaluga Oblast',
    shortCode: 'KLU'
  }, {
    name: 'Kamchatka Krai',
    shortCode: 'KAM'
  }, {
    name: 'Karachay-Cherkess Republic',
    shortCode: 'KC'
  }, {
    name: 'Republic of Karelia',
    shortCode: 'KR'
  }, {
    name: 'Khabarovsk Krai',
    shortCode: 'KHA'
  }, {
    name: 'Republic of Khakassia',
    shortCode: 'KK'
  }, {
    name: 'Khanty-Mansi Autonomous Okrug - Yugra',
    shortCode: 'KHM'
  }, {
    name: 'Kemerovo Oblast',
    shortCode: 'KEM'
  }, {
    name: 'Kirov Oblast',
    shortCode: 'KIR'
  }, {
    name: 'Komi Republic',
    shortCode: 'KO'
  }, {
    name: 'Kostroma Oblast',
    shortCode: 'KOS'
  }, {
    name: 'Krasnodar Krai',
    shortCode: 'KDA'
  }, {
    name: 'Krasnoyarsk Krai',
    shortCode: 'KYA'
  }, {
    name: 'Kurgan Oblast',
    shortCode: 'KGN'
  }, {
    name: 'Kursk Oblast',
    shortCode: 'KRS'
  }, {
    name: 'Leningrad Oblast',
    shortCode: 'LEN'
  }, {
    name: 'Lipetsk Oblast',
    shortCode: 'LIP'
  }, {
    name: 'Magadan Oblast',
    shortCode: 'MAG'
  }, {
    name: 'Mari El Republic',
    shortCode: 'ME'
  }, {
    name: 'Republic of Mordovia',
    shortCode: 'MO'
  }, {
    name: 'Moscow Oblast',
    shortCode: 'MOS'
  }, {
    name: 'Moscow',
    shortCode: 'MOW'
  }, {
    name: 'Murmansk Oblast',
    shortCode: 'MU'
  }, {
    name: 'Nenets Autonomous Okrug',
    shortCode: 'NEN'
  }, {
    name: 'Nizhny Novgorod Oblast',
    shortCode: 'NIZ'
  }, {
    name: 'Novgorod Oblast',
    shortCode: 'NGR'
  }, {
    name: 'Novosibirsk Oblast',
    shortCode: 'NVS'
  }, {
    name: 'Omsk Oblast',
    shortCode: 'OMS'
  }, {
    name: 'Orenburg Oblast',
    shortCode: 'ORE'
  }, {
    name: 'Oryol Oblast',
    shortCode: 'ORL'
  }, {
    name: 'Penza Oblast',
    shortCode: 'PNZ'
  }, {
    name: 'Perm Krai',
    shortCode: 'PER'
  }, {
    name: 'Primorsky Krai',
    shortCode: 'PRI'
  }, {
    name: 'Pskov Oblast',
    shortCode: 'PSK'
  }, {
    name: 'Rostov Oblast',
    shortCode: 'ROS'
  }, {
    name: 'Ryazan Oblast',
    shortCode: 'RYA'
  }, {
    name: 'Saint Petersburg',
    shortCode: 'SPE'
  }, {
    name: 'Sakha (Yakutia) Republic',
    shortCode: 'SA'
  }, {
    name: 'Sakhalin Oblast',
    shortCode: 'SAK'
  }, {
    name: 'Samara Oblast',
    shortCode: 'SAM'
  }, {
    name: 'Saratov Oblast',
    shortCode: 'SAR'
  }, {
    name: 'Republic of North Ossetia-Alania',
    shortCode: 'NOA'
  }, {
    name: 'Smolensk Oblast',
    shortCode: 'SMO'
  }, {
    name: 'Stavropol Krai',
    shortCode: 'STA'
  }, {
    name: 'Sverdlovsk Oblast',
    shortCode: 'SVE'
  }, {
    name: 'Tambov Oblast',
    shortCode: 'TAM'
  }, {
    name: 'Republic of Tatarstan',
    shortCode: 'TA'
  }, {
    name: 'Tomsk Oblast',
    shortCode: 'TOM'
  }, {
    name: 'Tuva Republic',
    shortCode: 'TU'
  }, {
    name: 'Tula Oblast',
    shortCode: 'TUL'
  }, {
    name: 'Tver Oblast',
    shortCode: 'TVE'
  }, {
    name: 'Tyumen Oblast',
    shortCode: 'TYU'
  }, {
    name: 'Udmurt Republic',
    shortCode: 'UD'
  }, {
    name: 'Ulyanovsk Oblast',
    shortCode: 'ULY'
  }, {
    name: 'Vladimir Oblast',
    shortCode: 'VLA'
  }, {
    name: 'Volgograd Oblast',
    shortCode: 'VGG'
  }, {
    name: 'Vologda Oblast',
    shortCode: 'VLG'
  }, {
    name: 'Voronezh Oblast',
    shortCode: 'VOR'
  }, {
    name: 'Yamalo-Nenets Autonomous Okrug',
    shortCode: 'YAN'
  }, {
    name: 'Yaroslavl Oblast',
    shortCode: 'YAR'
  }, {
    name: 'Zabaykalsky Krai',
    shortCode: 'ZAB'
  }]
}, {
  countryName: 'Rwanda',
  countryShortCode: 'RW',
  regions: [{
    name: 'Kigali',
    shortCode: '01'
  }, {
    name: 'Eastern',
    shortCode: '02'
  }, {
    name: 'Northern',
    shortCode: '03'
  }, {
    name: 'Western',
    shortCode: '04'
  }, {
    name: 'Southern',
    shortCode: '05'
  }]
}, {
  countryName: 'Saint Barthélemy',
  countryShortCode: 'BL',
  regions: [{
    name: 'Au Vent',
    shortCode: '02'
  }, {
    name: 'Sous le Vent',
    shortCode: '01'
  }]
}, {
  countryName: 'Saint Helena, Ascension and Tristan da Cunha',
  countryShortCode: 'SH',
  regions: [{
    name: 'Ascension',
    shortCode: 'AC'
  }, {
    name: 'Saint Helena',
    shortCode: 'HL'
  }, {
    name: 'Tristan da Cunha',
    shortCode: 'TA'
  }]
}, {
  countryName: 'Saint Kitts and Nevis',
  countryShortCode: 'KN',
  regions: [{
    name: 'Saint Kitts',
    shortCode: 'K'
  }, {
    name: 'Nevis',
    shortCode: 'N'
  }]
}, {
  countryName: 'Saint Lucia',
  countryShortCode: 'LC',
  regions: [{
    name: 'Anse-la-Raye',
    shortCode: '01'
  }, {
    name: 'Canaries',
    shortCode: '12'
  }, {
    name: 'Castries',
    shortCode: '02'
  }, {
    name: 'Choiseul',
    shortCode: '03'
  }, {
    name: 'Dennery',
    shortCode: '05'
  }, {
    name: 'Gros Islet',
    shortCode: '06'
  }, {
    name: 'Laborie',
    shortCode: '07'
  }, {
    name: 'Micoud',
    shortCode: '08'
  }, {
    name: 'Soufriere',
    shortCode: '10'
  }, {
    name: 'Vieux Fort',
    shortCode: '11'
  }]
}, {
  countryName: 'Saint Martin',
  countryShortCode: 'MF',
  regions: [{
    name: 'Saint Martin'
  }]
}, {
  countryName: 'Saint Pierre and Miquelon',
  countryShortCode: 'PM',
  regions: [{
    name: 'Miquelon'
  }, {
    name: 'Saint Pierre'
  }]
}, {
  countryName: 'Saint Vincent and the Grenadines',
  countryShortCode: 'VC',
  regions: [{
    name: 'Charlotte',
    shortCode: '01'
  }, {
    name: 'Grenadines',
    shortCode: '06'
  }, {
    name: 'Saint Andrew',
    shortCode: '02'
  }, {
    name: 'Saint David',
    shortCode: '03'
  }, {
    name: 'Saint George',
    shortCode: '04'
  }, {
    name: 'Saint Patrick',
    shortCode: '05'
  }]
}, {
  countryName: 'Samoa',
  countryShortCode: 'WS',
  regions: [{
    name: "A'ana",
    shortCode: 'AA'
  }, {
    name: 'Aiga-i-le-Tai',
    shortCode: 'AL'
  }, {
    name: 'Atua',
    shortCode: 'AT'
  }, {
    name: "Fa'asaleleaga",
    shortCode: 'FA'
  }, {
    name: "Gaga'emauga",
    shortCode: 'GE'
  }, {
    name: 'Gagaifomauga',
    shortCode: 'GI'
  }, {
    name: 'Palauli',
    shortCode: 'PA'
  }, {
    name: "Satupa'itea",
    shortCode: 'SA'
  }, {
    name: 'Tuamasaga',
    shortCode: 'TU'
  }, {
    name: "Va'a-o-Fonoti",
    shortCode: 'VF'
  }, {
    name: 'Vaisigano',
    shortCode: 'VS'
  }]
}, {
  countryName: 'San Marino',
  countryShortCode: 'SM',
  regions: [{
    name: 'Acquaviva',
    shortCode: '01'
  }, {
    name: 'Borgo Maggiore',
    shortCode: '06'
  }, {
    name: 'Chiesanuova',
    shortCode: '02'
  }, {
    name: 'Domagnano',
    shortCode: '03'
  }, {
    name: 'Faetano',
    shortCode: '04'
  }, {
    name: 'Fiorentino',
    shortCode: '05'
  }, {
    name: 'Montegiardino',
    shortCode: '08'
  }, {
    name: 'San Marino',
    shortCode: '07'
  }, {
    name: 'Serravalle',
    shortCode: '09'
  }]
}, {
  countryName: 'Sao Tome and Principe',
  countryShortCode: 'ST',
  regions: [{
    name: 'Principe',
    shortCode: 'P'
  }, {
    name: 'Sao Tome',
    shortCode: 'S'
  }]
}, {
  countryName: 'Saudi Arabia',
  countryShortCode: 'SA',
  regions: [{
    name: "'Asir",
    shortCode: '14'
  }, {
    name: 'Al Bahah',
    shortCode: '11'
  }, {
    name: 'Al Hudud ash Shamaliyah',
    shortCode: '08'
  }, {
    name: 'Al Jawf',
    shortCode: '12'
  }, {
    name: 'Al Madinah al Munawwarah',
    shortCode: '03'
  }, {
    name: 'Al Qasim',
    shortCode: '05'
  }, {
    name: 'Ar Riyad',
    shortCode: '01'
  }, {
    name: 'Ash Sharqiyah',
    shortCode: '04'
  }, {
    name: "Ha'il",
    shortCode: '06'
  }, {
    name: 'Jazan',
    shortCode: '09'
  }, {
    name: 'Makkah al Mukarramah',
    shortCode: '02'
  }, {
    name: 'Najran',
    shortCode: '10'
  }, {
    name: 'Tabuk',
    shortCode: '07'
  }]
}, {
  countryName: 'Senegal',
  countryShortCode: 'SN',
  regions: [{
    name: 'Dakar',
    shortCode: 'DK'
  }, {
    name: 'Diourbel',
    shortCode: 'DB'
  }, {
    name: 'Fatick',
    shortCode: 'FK'
  }, {
    name: 'Kaffrine',
    shortCode: 'KA'
  }, {
    name: 'Kaolack',
    shortCode: 'KL'
  }, {
    name: 'Kedougou',
    shortCode: 'KE'
  }, {
    name: 'Kolda',
    shortCode: 'KD'
  }, {
    name: 'Louga',
    shortCode: 'LG'
  }, {
    name: 'Matam',
    shortCode: 'MT'
  }, {
    name: 'Saint-Louis',
    shortCode: 'SL'
  }, {
    name: 'Sedhiou',
    shortCode: 'SE'
  }, {
    name: 'Tambacounda',
    shortCode: 'TC'
  }, {
    name: 'Thies',
    shortCode: 'TH'
  }, {
    name: 'Ziguinchor',
    shortCode: 'ZG'
  }]
}, {
  countryName: 'Serbia',
  countryShortCode: 'RS',
  regions: [{
    name: 'Beograd (Belgrade)',
    shortCode: '00'
  }, {
    name: 'Borski',
    shortCode: '14'
  }, {
    name: 'Braničevski',
    shortCode: '11'
  }, {
    name: 'Jablanički',
    shortCode: '23'
  }, {
    name: 'Južnobački',
    shortCode: '06'
  }, {
    name: 'Južnobanatski',
    shortCode: '04'
  }, {
    name: 'Kolubarski',
    shortCode: '09'
  }, {
    name: 'Kosovski',
    shortCode: '25'
  }, {
    name: 'Kosovsko-Mitrovački',
    shortCode: '28'
  }, {
    name: 'Kosovsko-Pomoravski',
    shortCode: '29'
  }, {
    name: 'Mačvanski',
    shortCode: '08'
  }, {
    name: 'Moravički',
    shortCode: '17'
  }, {
    name: 'Nišavski',
    shortCode: '20'
  }, {
    name: 'Pčinjski',
    shortCode: '24'
  }, {
    name: 'Pećki',
    shortCode: '26'
  }, {
    name: 'Pirotski',
    shortCode: '22'
  }, {
    name: 'Podunavski',
    shortCode: '10'
  }, {
    name: 'Pomoravski',
    shortCode: '13'
  }, {
    name: 'Prizrenski',
    shortCode: '27'
  }, {
    name: 'Rasinski',
    shortCode: '19'
  }, {
    name: 'Raški',
    shortCode: '18'
  }, {
    name: 'Severnobački',
    shortCode: '01'
  }, {
    name: 'Severnobanatski',
    shortCode: '03'
  }, {
    name: 'Srednjebanatski',
    shortCode: '02'
  }, {
    name: 'Sremski',
    shortCode: '07'
  }, {
    name: 'Šumadijski',
    shortCode: '12'
  }, {
    name: 'Toplički',
    shortCode: '21'
  }, {
    name: 'Zaječarski',
    shortCode: '15'
  }, {
    name: 'Zapadnobački',
    shortCode: '05'
  }, {
    name: 'Zlatiborski',
    shortCode: '16'
  }]
}, {
  countryName: 'Seychelles',
  countryShortCode: 'SC',
  regions: [{
    name: 'Anse aux Pins',
    shortCode: '01'
  }, {
    name: 'Anse Boileau',
    shortCode: '02'
  }, {
    name: 'Anse Etoile',
    shortCode: '03'
  }, {
    name: 'Anse Royale',
    shortCode: '05'
  }, {
    name: 'Anu Cap',
    shortCode: '04'
  }, {
    name: 'Baie Lazare',
    shortCode: '06'
  }, {
    name: 'Baie Sainte Anne',
    shortCode: '07'
  }, {
    name: 'Beau Vallon',
    shortCode: '08'
  }, {
    name: 'Bel Air',
    shortCode: '09'
  }, {
    name: 'Bel Ombre',
    shortCode: '10'
  }, {
    name: 'Cascade',
    shortCode: '11'
  }, {
    name: 'Glacis',
    shortCode: '12'
  }, {
    name: "Grand'Anse Mahe",
    shortCode: '13'
  }, {
    name: "Grand'Anse Praslin",
    shortCode: '14'
  }, {
    name: 'La Digue',
    shortCode: '15'
  }, {
    name: 'La Riviere Anglaise',
    shortCode: '16'
  }, {
    name: 'Les Mamelles',
    shortCode: '24'
  }, {
    name: 'Mont Buxton',
    shortCode: '17'
  }, {
    name: 'Mont Fleuri',
    shortCode: '18'
  }, {
    name: 'Plaisance',
    shortCode: '19'
  }, {
    name: 'Pointe La Rue',
    shortCode: '20'
  }, {
    name: 'Port Glaud',
    shortCode: '21'
  }, {
    name: 'Roche Caiman',
    shortCode: '25'
  }, {
    name: 'Saint Louis',
    shortCode: '22'
  }, {
    name: 'Takamaka',
    shortCode: '23'
  }]
}, {
  countryName: 'Sierra Leone',
  countryShortCode: 'SL',
  regions: [{
    name: 'Eastern',
    shortCode: 'E'
  }, {
    name: 'Northern',
    shortCode: 'N'
  }, {
    name: 'Southern',
    shortCode: 'S'
  }, {
    name: 'Western',
    shortCode: 'W'
  }]
}, {
  countryName: 'Singapore',
  countryShortCode: 'SG',
  regions: [{
    name: 'Central Singapore',
    shortCode: '01'
  }, {
    name: 'North East',
    shortCode: '02'
  }, {
    name: 'North West',
    shortCode: '03'
  }, {
    name: 'South East',
    shortCode: '04'
  }, {
    name: 'South West',
    shortCode: '05'
  }]
}, {
  countryName: 'Sint Maarten (Dutch part)',
  countryShortCode: 'SX',
  regions: [{
    name: 'Sint Maarten'
  }]
}, {
  countryName: 'Slovakia',
  countryShortCode: 'SK',
  regions: [{
    name: 'Banskobystricky',
    shortCode: 'BC'
  }, {
    name: 'Bratislavsky',
    shortCode: 'BL'
  }, {
    name: 'Kosicky',
    shortCode: 'KI'
  }, {
    name: 'Nitriansky',
    shortCode: 'NI'
  }, {
    name: 'Presovsky',
    shortCode: 'PV'
  }, {
    name: 'Trenciansky',
    shortCode: 'TC'
  }, {
    name: 'Trnavsky',
    shortCode: 'TA'
  }, {
    name: 'Zilinsky',
    shortCode: 'ZI'
  }]
}, {
  countryName: 'Slovenia',
  countryShortCode: 'SI',
  regions: [{
    name: 'Ajdovscina',
    shortCode: '001'
  }, {
    name: 'Apace',
    shortCode: '195'
  }, {
    name: 'Beltinci',
    shortCode: '002'
  }, {
    name: 'Benedikt',
    shortCode: '148'
  }, {
    name: 'Bistrica ob Sotli',
    shortCode: '149'
  }, {
    name: 'Bled',
    shortCode: '003'
  }, {
    name: 'Bloke',
    shortCode: '150'
  }, {
    name: 'Bohinj',
    shortCode: '004'
  }, {
    name: 'Borovnica',
    shortCode: '005'
  }, {
    name: 'Bovec',
    shortCode: '006'
  }, {
    name: 'Braslovce',
    shortCode: '151'
  }, {
    name: 'Brda',
    shortCode: '007'
  }, {
    name: 'Brezice',
    shortCode: '009'
  }, {
    name: 'Brezovica',
    shortCode: '008'
  }, {
    name: 'Cankova',
    shortCode: '152'
  }, {
    name: 'Celje',
    shortCode: '011'
  }, {
    name: 'Cerklje na Gorenjskem',
    shortCode: '012'
  }, {
    name: 'Cerknica',
    shortCode: '013'
  }, {
    name: 'Cerkno',
    shortCode: '014'
  }, {
    name: 'Cerkvenjak',
    shortCode: '153'
  }, {
    name: 'Cirkulane',
    shortCode: '196'
  }, {
    name: 'Crensovci',
    shortCode: '015'
  }, {
    name: 'Crna na Koroskem',
    shortCode: '016'
  }, {
    name: 'Crnomelj',
    shortCode: '017'
  }, {
    name: 'Destrnik',
    shortCode: '018'
  }, {
    name: 'Divaca',
    shortCode: '019'
  }, {
    name: 'Dobje',
    shortCode: '154'
  }, {
    name: 'Dobrepolje',
    shortCode: '020'
  }, {
    name: 'Dobrna',
    shortCode: '155'
  }, {
    name: 'Dobrova-Polhov Gradec',
    shortCode: '021'
  }, {
    name: 'Dobrovnik',
    shortCode: '156'
  }, {
    name: 'Dol pri Ljubljani',
    shortCode: '022'
  }, {
    name: 'Dolenjske Toplice',
    shortCode: '157'
  }, {
    name: 'Domzale',
    shortCode: '023'
  }, {
    name: 'Dornava',
    shortCode: '024'
  }, {
    name: 'Dravograd',
    shortCode: '025'
  }, {
    name: 'Duplek',
    shortCode: '026'
  }, {
    name: 'Gorenja Vas-Poljane',
    shortCode: '027'
  }, {
    name: 'Gorisnica',
    shortCode: '028'
  }, {
    name: 'Gorje',
    shortCode: '207'
  }, {
    name: 'Gornja Radgona',
    shortCode: '029'
  }, {
    name: 'Gornji Grad',
    shortCode: '030'
  }, {
    name: 'Gornji Petrovci',
    shortCode: '031'
  }, {
    name: 'Grad',
    shortCode: '158'
  }, {
    name: 'Grosuplje',
    shortCode: '032'
  }, {
    name: 'Hajdina',
    shortCode: '159'
  }, {
    name: 'Hoce-Slivnica',
    shortCode: '160'
  }, {
    name: 'Hodos',
    shortCode: '161'
  }, {
    name: 'Horjul',
    shortCode: '162'
  }, {
    name: 'Hrastnik',
    shortCode: '034'
  }, {
    name: 'Hrpelje-Kozina',
    shortCode: '035'
  }, {
    name: 'Idrija',
    shortCode: '036'
  }, {
    name: 'Ig',
    shortCode: '037'
  }, {
    name: 'Ilirska Bistrica',
    shortCode: '038'
  }, {
    name: 'Ivancna Gorica',
    shortCode: '039'
  }, {
    name: 'Izola',
    shortCode: '040'
  }, {
    name: 'Jesenice',
    shortCode: '041'
  }, {
    name: 'Jursinci',
    shortCode: '042'
  }, {
    name: 'Kamnik',
    shortCode: '043'
  }, {
    name: 'Kanal',
    shortCode: '044'
  }, {
    name: 'Kidricevo',
    shortCode: '045'
  }, {
    name: 'Kobarid',
    shortCode: '046'
  }, {
    name: 'Kobilje',
    shortCode: '047'
  }, {
    name: 'Kocevje',
    shortCode: '048'
  }, {
    name: 'Komen',
    shortCode: '049'
  }, {
    name: 'Komenda',
    shortCode: '164'
  }, {
    name: 'Koper',
    shortCode: '050'
  }, {
    name: 'Kodanjevica na Krki',
    shortCode: '197'
  }, {
    name: 'Kostel',
    shortCode: '165'
  }, {
    name: 'Kozje',
    shortCode: '051'
  }, {
    name: 'Kranj',
    shortCode: '052'
  }, {
    name: 'Kranjska Gora',
    shortCode: '053'
  }, {
    name: 'Krizevci',
    shortCode: '166'
  }, {
    name: 'Krsko',
    shortCode: '054'
  }, {
    name: 'Kungota',
    shortCode: '055'
  }, {
    name: 'Kuzma',
    shortCode: '056'
  }, {
    name: 'Lasko',
    shortCode: '057'
  }, {
    name: 'Lenart',
    shortCode: '058'
  }, {
    name: 'Lendava',
    shortCode: '059'
  }, {
    name: 'Litija',
    shortCode: '060'
  }, {
    name: 'Ljubljana',
    shortCode: '061'
  }, {
    name: 'Ljubno',
    shortCode: '062'
  }, {
    name: 'Ljutomer',
    shortCode: '063'
  }, {
    name: 'Log-Dragomer',
    shortCode: '208'
  }, {
    name: 'Logatec',
    shortCode: '064'
  }, {
    name: 'Loska Dolina',
    shortCode: '065'
  }, {
    name: 'Loski Potok',
    shortCode: '066'
  }, {
    name: 'Lovrenc na Pohorju',
    shortCode: '167'
  }, {
    name: 'Lukovica',
    shortCode: '068'
  }, {
    name: 'Luce',
    shortCode: '067'
  }, {
    name: 'Majsperk',
    shortCode: '069'
  }, {
    name: 'Makole',
    shortCode: '198'
  }, {
    name: 'Maribor',
    shortCode: '070'
  }, {
    name: 'Markovci',
    shortCode: '168'
  }, {
    name: 'Medvode',
    shortCode: '071'
  }, {
    name: 'Menges',
    shortCode: '072'
  }, {
    name: 'Metlika',
    shortCode: '073'
  }, {
    name: 'Mezica',
    shortCode: '074'
  }, {
    name: 'Miklavz na Dravskem Polju',
    shortCode: '169'
  }, {
    name: 'Miren-Kostanjevica',
    shortCode: '075'
  }, {
    name: 'Mirna',
    shortCode: '212'
  }, {
    name: 'Mirna Pec',
    shortCode: '170'
  }, {
    name: 'Mislinja',
    shortCode: '076'
  }, {
    name: 'Mokronog-Trebelno',
    shortCode: '199'
  }, {
    name: 'Moravce',
    shortCode: '077'
  }, {
    name: 'Moravske Toplice',
    shortCode: '078'
  }, {
    name: 'Mozirje',
    shortCode: '079'
  }, {
    name: 'Murska Sobota',
    shortCode: '080'
  }, {
    name: 'Naklo',
    shortCode: '082'
  }, {
    name: 'Nazarje',
    shortCode: '083'
  }, {
    name: 'Nova Gorica',
    shortCode: '084'
  }, {
    name: 'Novo Mesto',
    shortCode: '085'
  }, {
    name: 'Odranci',
    shortCode: '086'
  }, {
    name: 'Ormoz',
    shortCode: '087'
  }, {
    name: 'Osilnica',
    shortCode: '088'
  }, {
    name: 'Pesnica',
    shortCode: '089'
  }, {
    name: 'Piran',
    shortCode: '090'
  }, {
    name: 'Pivka',
    shortCode: '091'
  }, {
    name: 'Podcetrtek',
    shortCode: '092'
  }, {
    name: 'Podlehnik',
    shortCode: '172'
  }, {
    name: 'Podvelka',
    shortCode: '093'
  }, {
    name: 'Poljcane',
    shortCode: '200'
  }, {
    name: 'Postojna',
    shortCode: '094'
  }, {
    name: 'Prebold',
    shortCode: '174'
  }, {
    name: 'Preddvor',
    shortCode: '095'
  }, {
    name: 'Prevalje',
    shortCode: '175'
  }, {
    name: 'Ptuj',
    shortCode: '096'
  }, {
    name: 'Race-Fram',
    shortCode: '098'
  }, {
    name: 'Radece',
    shortCode: '099'
  }, {
    name: 'Radenci',
    shortCode: '100'
  }, {
    name: 'Radlje ob Dravi',
    shortCode: '101'
  }, {
    name: 'Radovljica',
    shortCode: '102'
  }, {
    name: 'Ravne na Koroskem',
    shortCode: '103'
  }, {
    name: 'Razkrizje',
    shortCode: '176'
  }, {
    name: 'Recica ob Savinji',
    shortCode: '209'
  }, {
    name: 'Rence-Vogrsko',
    shortCode: '201'
  }, {
    name: 'Ribnica',
    shortCode: '104'
  }, {
    name: 'Ribnica na Poboriu',
    shortCode: '177'
  }, {
    name: 'Rogaska Slatina',
    shortCode: '106'
  }, {
    name: 'Rogasovci',
    shortCode: '105'
  }, {
    name: 'Rogatec',
    shortCode: '107'
  }, {
    name: 'Ruse',
    shortCode: '108'
  }, {
    name: 'Salovci',
    shortCode: '033'
  }, {
    name: 'Selnica ob Dravi',
    shortCode: '178'
  }, {
    name: 'Semic',
    shortCode: '109'
  }, {
    name: 'Sempeter-Vrtojba',
    shortCode: '183'
  }, {
    name: 'Sencur',
    shortCode: '117'
  }, {
    name: 'Sentilj',
    shortCode: '118'
  }, {
    name: 'Sentjernej',
    shortCode: '119'
  }, {
    name: 'Sentjur',
    shortCode: '120'
  }, {
    name: 'Sentrupert',
    shortCode: '211'
  }, {
    name: 'Sevnica',
    shortCode: '110'
  }, {
    name: 'Sezana',
    shortCode: '111'
  }, {
    name: 'Skocjan',
    shortCode: '121'
  }, {
    name: 'Skofja Loka',
    shortCode: '122'
  }, {
    name: 'Skofljica',
    shortCode: '123'
  }, {
    name: 'Slovenj Gradec',
    shortCode: '112'
  }, {
    name: 'Slovenska Bistrica',
    shortCode: '113'
  }, {
    name: 'Slovenske Konjice',
    shortCode: '114'
  }, {
    name: 'Smarje pri elsah',
    shortCode: '124'
  }, {
    name: 'Smarjeske Toplice',
    shortCode: '206'
  }, {
    name: 'Smartno ob Paki',
    shortCode: '125'
  }, {
    name: 'Smartno pri Litiji',
    shortCode: '194'
  }, {
    name: 'Sodrazica',
    shortCode: '179'
  }, {
    name: 'Solcava',
    shortCode: '180'
  }, {
    name: 'Sostanj',
    shortCode: '126'
  }, {
    name: 'Sredisce ob Dravi',
    shortCode: '202'
  }, {
    name: 'Starse',
    shortCode: '115'
  }, {
    name: 'Store',
    shortCode: '127'
  }, {
    name: 'Straza',
    shortCode: '203'
  }, {
    name: 'Sveta Ana',
    shortCode: '181'
  }, {
    name: 'Sveta Trojica v Slovenskih Goricah',
    shortCode: '204'
  }, {
    name: 'Sveta Andraz v Slovenskih Goricah',
    shortCode: '182'
  }, {
    name: 'Sveti Jurij',
    shortCode: '116'
  }, {
    name: 'Sveti Jurij v Slovenskih Goricah',
    shortCode: '210'
  }, {
    name: 'Sveti Tomaz',
    shortCode: '205'
  }, {
    name: 'Tabor',
    shortCode: '184'
  }, {
    name: 'Tisina',
    shortCode: '010'
  }, {
    name: 'Tolmin',
    shortCode: '128'
  }, {
    name: 'Trbovlje',
    shortCode: '129'
  }, {
    name: 'Trebnje',
    shortCode: '130'
  }, {
    name: 'Trnovska Vas',
    shortCode: '185'
  }, {
    name: 'Trzin',
    shortCode: '186'
  }, {
    name: 'Trzic',
    shortCode: '131'
  }, {
    name: 'Turnisce',
    shortCode: '132'
  }, {
    name: 'Velenje',
    shortCode: '133'
  }, {
    name: 'Velika Polana',
    shortCode: '187'
  }, {
    name: 'Velike Lasce',
    shortCode: '134'
  }, {
    name: 'Verzej',
    shortCode: '188'
  }, {
    name: 'Videm',
    shortCode: '135'
  }, {
    name: 'Vipava',
    shortCode: '136'
  }, {
    name: 'Vitanje',
    shortCode: '137'
  }, {
    name: 'Vodice',
    shortCode: '138'
  }, {
    name: 'Vojnik',
    shortCode: '139'
  }, {
    name: 'Vransko',
    shortCode: '189'
  }, {
    name: 'Vrhnika',
    shortCode: '140'
  }, {
    name: 'Vuzenica',
    shortCode: '141'
  }, {
    name: 'Zagorje ob Savi',
    shortCode: '142'
  }, {
    name: 'Zavrc',
    shortCode: '143'
  }, {
    name: 'Zrece',
    shortCode: '144'
  }, {
    name: 'Zalec',
    shortCode: '190'
  }, {
    name: 'Zelezniki',
    shortCode: '146'
  }, {
    name: 'Zetale',
    shortCode: '191'
  }, {
    name: 'Ziri',
    shortCode: '147'
  }, {
    name: 'Zirovnica',
    shortCode: '192'
  }, {
    name: 'Zuzemberk',
    shortCode: '193'
  }]
}, {
  countryName: 'Solomon Islands',
  countryShortCode: 'SB',
  regions: [{
    name: 'Central',
    shortCode: 'CE'
  }, {
    name: 'Choiseul',
    shortCode: 'CH'
  }, {
    name: 'Guadalcanal',
    shortCode: 'GU'
  }, {
    name: 'Honiara',
    shortCode: 'CT'
  }, {
    name: 'Isabel',
    shortCode: 'IS'
  }, {
    name: 'Makira-Ulawa',
    shortCode: 'MK'
  }, {
    name: 'Malaita',
    shortCode: 'ML'
  }, {
    name: 'Rennell and Bellona',
    shortCode: 'RB'
  }, {
    name: 'Temotu',
    shortCode: 'TE'
  }, {
    name: 'Western',
    shortCode: 'WE'
  }]
}, {
  countryName: 'Somalia',
  countryShortCode: 'SO',
  regions: [{
    name: 'Awdal',
    shortCode: 'AW'
  }, {
    name: 'Bakool',
    shortCode: 'BK'
  }, {
    name: 'Banaadir',
    shortCode: 'BN'
  }, {
    name: 'Bari',
    shortCode: 'BR'
  }, {
    name: 'Bay',
    shortCode: 'BY'
  }, {
    name: 'Galguduud',
    shortCode: 'GA'
  }, {
    name: 'Gedo',
    shortCode: 'GE'
  }, {
    name: 'Hiiraan',
    shortCode: 'HI'
  }, {
    name: 'Jubbada Dhexe',
    shortCode: 'JD'
  }, {
    name: 'Jubbada Hoose',
    shortCode: 'JH'
  }, {
    name: 'Mudug',
    shortCode: 'MU'
  }, {
    name: 'Nugaal',
    shortCode: 'NU'
  }, {
    name: 'Sanaag',
    shortCode: 'SA'
  }, {
    name: 'Shabeellaha Dhexe',
    shortCode: 'SD'
  }, {
    name: 'Shabeellaha Hoose',
    shortCode: 'SH'
  }, {
    name: 'Sool',
    shortCode: 'SO'
  }, {
    name: 'Togdheer',
    shortCode: 'TO'
  }, {
    name: 'Woqooyi Galbeed',
    shortCode: 'WO'
  }]
}, {
  countryName: 'South Africa',
  countryShortCode: 'ZA',
  regions: [{
    name: 'Eastern Cape',
    shortCode: 'EC'
  }, {
    name: 'Free State',
    shortCode: 'FS'
  }, {
    name: 'Gauteng',
    shortCode: 'GT'
  }, {
    name: 'KwaZulu-Natal',
    shortCode: 'NL'
  }, {
    name: 'Limpopo',
    shortCode: 'LP'
  }, {
    name: 'Mpumalanga',
    shortCode: 'MP'
  }, {
    name: 'Northern Cape',
    shortCode: 'NC'
  }, {
    name: 'North West',
    shortCode: 'NW'
  }, {
    name: 'Western Cape',
    shortCode: 'WC'
  }]
}, {
  countryName: 'South Georgia and South Sandwich Islands',
  countryShortCode: 'GS',
  regions: [{
    name: 'Bird Island'
  }, {
    name: 'Bristol Island'
  }, {
    name: 'Clerke Rocks'
  }, {
    name: 'Montagu Island'
  }, {
    name: 'Saunders Island'
  }, {
    name: 'South Georgia'
  }, {
    name: 'Southern Thule'
  }, {
    name: 'Traversay Islands'
  }]
}, {
  countryName: 'South Sudan',
  countryShortCode: 'SS',
  regions: [{
    name: 'Central Equatoria',
    shortCode: 'CE'
  }, {
    name: 'Eastern Equatoria',
    shortCode: 'EE'
  }, {
    name: 'Jonglei',
    shortCode: 'JG'
  }, {
    name: 'Lakes',
    shortCode: 'LK'
  }, {
    name: 'Northern Bahr el Ghazal',
    shortCode: 'BN'
  }, {
    name: 'Unity',
    shortCode: 'UY'
  }, {
    name: 'Upper Nile',
    shortCode: 'NU'
  }, {
    name: 'Warrap',
    shortCode: 'WR'
  }, {
    name: 'Western Bahr el Ghazal',
    shortCode: 'BW'
  }, {
    name: 'Western Equatoria',
    shortCode: 'EW'
  }]
}, {
  countryName: 'Spain',
  countryShortCode: 'ES',
  regions: [{
    name: 'Albacete',
    shortCode: 'AB'
  }, {
    name: 'Alicante',
    shortCode: 'A'
  }, {
    name: 'Almería',
    shortCode: 'AN'
  }, {
    name: 'Araba/Álava',
    shortCode: 'VI'
  }, {
    name: 'Asturias',
    shortCode: 'O'
  }, {
    name: 'Ávila',
    shortCode: 'AV'
  }, {
    name: 'Badajoz',
    shortCode: 'BA'
  }, {
    name: 'Barcelona',
    shortCode: 'B'
  }, {
    name: 'Bizkaia',
    shortCode: 'BI'
  }, {
    name: 'Burgos',
    shortCode: 'BU'
  }, {
    name: 'Cáceres',
    shortCode: 'CC'
  }, {
    name: 'Cádiz',
    shortCode: 'CA'
  }, {
    name: 'Cantabria',
    shortCode: 'S'
  }, {
    name: 'Castellón/Castelló',
    shortCode: 'CS'
  }, {
    name: 'Ceuta',
    shortCode: 'CE'
  }, {
    name: 'Ciudad Real',
    shortCode: 'CR'
  }, {
    name: 'Córdoba',
    shortCode: 'CO'
  }, {
    name: 'A Coruña',
    shortCode: 'C'
  }, {
    name: 'Cuenca',
    shortCode: 'CU'
  }, {
    name: 'Gipuzkoa',
    shortCode: 'SS'
  }, {
    name: 'Girona',
    shortCode: 'GI'
  }, {
    name: 'Granada',
    shortCode: 'GR'
  }, {
    name: 'Guadalajara',
    shortCode: 'GU'
  }, {
    name: 'Huelva',
    shortCode: 'H'
  }, {
    name: 'Huesca',
    shortCode: 'HU'
  }, {
    name: 'Illes Balears',
    shortCode: 'PM'
  }, {
    name: 'Jaén',
    shortCode: 'J'
  }, {
    name: 'León',
    shortCode: 'LE'
  }, {
    name: 'Lleida',
    shortCode: 'L'
  }, {
    name: 'Lugo',
    shortCode: 'LU'
  }, {
    name: 'Madrid',
    shortCode: 'M'
  }, {
    name: 'Málaga',
    shortCode: 'MA'
  }, {
    name: 'Melilla',
    shortCode: 'ML'
  }, {
    name: 'Murcia',
    shortCode: 'MU'
  }, {
    name: 'Navarra/Nafarroa',
    shortCode: 'NA'
  }, {
    name: 'Ourense',
    shortCode: 'OR'
  }, {
    name: 'Palencia',
    shortCode: 'P'
  }, {
    name: 'Las Palmas',
    shortCode: 'GC'
  }, {
    name: 'Pontevedra',
    shortCode: 'PO'
  }, {
    name: 'La Rioja',
    shortCode: 'LO'
  }, {
    name: 'Salamanca',
    shortCode: 'SA'
  }, {
    name: 'Santa Cruz de Tenerife',
    shortCode: 'TF'
  }, {
    name: 'Segovia',
    shortCode: 'SG'
  }, {
    name: 'Sevilla',
    shortCode: 'SE'
  }, {
    name: 'Soria',
    shortCode: 'SO'
  }, {
    name: 'Tarragona',
    shortCode: 'T'
  }, {
    name: 'Teruel',
    shortCode: 'TE'
  }, {
    name: 'Toledo',
    shortCode: 'TO'
  }, {
    name: 'Valencia/València',
    shortCode: 'V'
  }, {
    name: 'Valladolid',
    shortCode: 'VA'
  }, {
    name: 'Zamora',
    shortCode: 'ZA'
  }, {
    name: 'Zaragoza',
    shortCode: 'Z'
  }]
}, {
  countryName: 'Sri Lanka',
  countryShortCode: 'LK',
  regions: [{
    name: 'Basnahira',
    shortCode: '1'
  }, {
    name: 'Dakunu',
    shortCode: '3'
  }, {
    name: 'Madhyama',
    shortCode: '2'
  }, {
    name: 'Naegenahira',
    shortCode: '5'
  }, {
    name: 'Sabaragamuwa',
    shortCode: '9'
  }, {
    name: 'Uturu',
    shortCode: '4'
  }, {
    name: 'Uturumaeda',
    shortCode: '7'
  }, {
    name: 'Vayamba',
    shortCode: '6'
  }, {
    name: 'Uva',
    shortCode: '8'
  }]
}, {
  countryName: 'Sudan',
  countryShortCode: 'SD',
  regions: [{
    name: 'Al Bahr al Ahmar',
    shortCode: 'RS'
  }, {
    name: 'Al Jazirah',
    shortCode: 'GZ'
  }, {
    name: 'Al Khartum',
    shortCode: 'KH'
  }, {
    name: 'Al Qadarif',
    shortCode: 'GD'
  }, {
    name: 'An Nil al Abyad',
    shortCode: 'NW'
  }, {
    name: 'An Nil al Azraq',
    shortCode: 'NB'
  }, {
    name: 'Ash Shamaliyah',
    shortCode: 'NO'
  }, {
    name: 'Gharb Darfur',
    shortCode: 'DW'
  }, {
    name: 'Gharb Kurdufan',
    shortCode: 'GK'
  }, {
    name: 'Janub Darfur',
    shortCode: 'DS'
  }, {
    name: 'Janub Kurdufan',
    shortCode: 'KS'
  }, {
    name: 'Kassala',
    shortCode: 'KA'
  }, {
    name: 'Nahr an Nil',
    shortCode: 'NR'
  }, {
    name: 'Shamal Darfur',
    shortCode: 'DN'
  }, {
    name: 'Sharq Darfur',
    shortCode: 'DE'
  }, {
    name: 'Shiamal Kurdufan',
    shortCode: 'KN'
  }, {
    name: 'Sinnar',
    shortCode: 'SI'
  }, {
    name: 'Wasat Darfur Zalinjay',
    shortCode: 'DC'
  }]
}, {
  countryName: 'Suriname',
  countryShortCode: 'SR',
  regions: [{
    name: 'Brokopondo',
    shortCode: 'BR'
  }, {
    name: 'Commewijne',
    shortCode: 'CM'
  }, {
    name: 'Coronie',
    shortCode: 'CR'
  }, {
    name: 'Marowijne',
    shortCode: 'MA'
  }, {
    name: 'Nickerie',
    shortCode: 'NI'
  }, {
    name: 'Para',
    shortCode: 'PR'
  }, {
    name: 'Paramaribo',
    shortCode: 'PM'
  }, {
    name: 'Saramacca',
    shortCode: 'SA'
  }, {
    name: 'Sipaliwini',
    shortCode: 'SI'
  }, {
    name: 'Wanica',
    shortCode: 'WA'
  }]
}, {
  countryName: 'Swaziland',
  countryShortCode: 'SZ',
  regions: [{
    name: 'Hhohho',
    shortCode: 'HH'
  }, {
    name: 'Lubombo',
    shortCode: 'LU'
  }, {
    name: 'Manzini',
    shortCode: 'MA'
  }, {
    name: 'Shiselweni',
    shortCode: 'SH'
  }]
}, {
  countryName: 'Sweden',
  countryShortCode: 'SE',
  regions: [{
    name: 'Blekinge',
    shortCode: 'K'
  }, {
    name: 'Dalarna',
    shortCode: 'W'
  }, {
    name: 'Gävleborg',
    shortCode: 'X'
  }, {
    name: 'Gotland',
    shortCode: 'I'
  }, {
    name: 'Halland',
    shortCode: 'N'
  }, {
    name: 'Jämtland',
    shortCode: 'Z'
  }, {
    name: 'Jönköping',
    shortCode: 'F'
  }, {
    name: 'Kalmar',
    shortCode: 'H'
  }, {
    name: 'Kronoberg',
    shortCode: 'G'
  }, {
    name: 'Norrbotten',
    shortCode: 'BD'
  }, {
    name: 'Örebro',
    shortCode: 'T'
  }, {
    name: 'Östergötland',
    shortCode: 'E'
  }, {
    name: 'Skåne',
    shortCode: 'M'
  }, {
    name: 'Södermanland',
    shortCode: 'D'
  }, {
    name: 'Stockholm',
    shortCode: 'AB'
  }, {
    name: 'Uppsala',
    shortCode: 'C'
  }, {
    name: 'Värmland',
    shortCode: 'S'
  }, {
    name: 'Västerbotten',
    shortCode: 'AC'
  }, {
    name: 'Västernorrland',
    shortCode: 'Y'
  }, {
    name: 'Västmanland',
    shortCode: 'U'
  }, {
    name: 'Västra Götaland',
    shortCode: 'O'
  }]
}, {
  countryName: 'Switzerland',
  countryShortCode: 'CH',
  regions: [{
    name: 'Aargau',
    shortCode: 'AG'
  }, {
    name: 'Appenzell Ausserrhoden',
    shortCode: 'AR'
  }, {
    name: 'Appenzell Innerhoden',
    shortCode: 'AI'
  }, {
    name: 'Basel-Landschaft',
    shortCode: 'BL'
  }, {
    name: 'Basel-Stadt',
    shortCode: 'BS'
  }, {
    name: 'Bern',
    shortCode: 'BE'
  }, {
    name: 'Fribourg',
    shortCode: 'FR'
  }, {
    name: 'Genève',
    shortCode: 'GE'
  }, {
    name: 'Glarus',
    shortCode: 'GL'
  }, {
    name: 'Graubünden',
    shortCode: 'GR'
  }, {
    name: 'Jura',
    shortCode: 'JU'
  }, {
    name: 'Luzern',
    shortCode: 'LU'
  }, {
    name: 'Neuchâtel',
    shortCode: 'NE'
  }, {
    name: 'Nidwalden',
    shortCode: 'NW'
  }, {
    name: 'Obwalden',
    shortCode: 'OW'
  }, {
    name: 'Sankt Gallen',
    shortCode: 'SG'
  }, {
    name: 'Schaffhausen',
    shortCode: 'SH'
  }, {
    name: 'Schwyz',
    shortCode: 'SZ'
  }, {
    name: 'Solothurn',
    shortCode: 'SO'
  }, {
    name: 'Thurgau',
    shortCode: 'TG'
  }, {
    name: 'Ticino',
    shortCode: 'TI'
  }, {
    name: 'Uri',
    shortCode: 'UR'
  }, {
    name: 'Valais',
    shortCode: 'VS'
  }, {
    name: 'Vaud',
    shortCode: 'VD'
  }, {
    name: 'Zug',
    shortCode: 'ZG'
  }, {
    name: 'Zürich',
    shortCode: 'ZH'
  }]
}, {
  countryName: 'Syrian Arab Republic',
  countryShortCode: 'SY',
  regions: [{
    name: 'Al Hasakah',
    shortCode: 'HA'
  }, {
    name: 'Al Ladhiqiyah',
    shortCode: 'LA'
  }, {
    name: 'Al Qunaytirah',
    shortCode: 'QU'
  }, {
    name: 'Ar Raqqah',
    shortCode: 'RA'
  }, {
    name: "As Suwayda'",
    shortCode: 'SU'
  }, {
    name: "Dar'a",
    shortCode: 'DR'
  }, {
    name: 'Dayr az Zawr',
    shortCode: 'DY'
  }, {
    name: 'Dimashq',
    shortCode: 'DI'
  }, {
    name: 'Halab',
    shortCode: 'HL'
  }, {
    name: 'Hamah',
    shortCode: 'HM'
  }, {
    name: 'Hims',
    shortCode: 'HI'
  }, {
    name: 'Idlib',
    shortCode: 'ID'
  }, {
    name: 'Rif Dimashq',
    shortCode: 'RD'
  }, {
    name: 'Tartus',
    shortCode: 'TA'
  }]
}, {
  countryName: 'Taiwan',
  countryShortCode: 'TW',
  regions: [{
    name: 'Chang-hua',
    shortCode: 'CHA'
  }, {
    name: 'Chia-i',
    shortCode: 'CYQ'
  }, {
    name: 'Hsin-chu',
    shortCode: 'HSQ'
  }, {
    name: 'Hua-lien',
    shortCode: 'HUA'
  }, {
    name: 'Kao-hsiung',
    shortCode: 'KHH'
  }, {
    name: 'Keelung',
    shortCode: 'KEE'
  }, {
    name: 'Kinmen',
    shortCode: 'KIN'
  }, {
    name: 'Lienchiang',
    shortCode: 'LIE'
  }, {
    name: 'Miao-li',
    shortCode: 'MIA'
  }, {
    name: "Nan-t'ou",
    shortCode: 'NAN'
  }, {
    name: "P'eng-hu",
    shortCode: 'PEN'
  }, {
    name: 'New Taipei',
    shortCode: 'NWT'
  }, {
    name: "P'ing-tung",
    shortCode: 'PING'
  }, {
    name: "T'ai-chung",
    shortCode: 'TXG'
  }, {
    name: "T'ai-nan",
    shortCode: 'TNN'
  }, {
    name: "T'ai-pei",
    shortCode: 'TPE'
  }, {
    name: "T'ai-tung",
    shortCode: 'TTT'
  }, {
    name: "T'ao-yuan",
    shortCode: 'TAO'
  }, {
    name: 'Yi-lan',
    shortCode: 'ILA'
  }, {
    name: 'Yun-lin',
    shortCode: 'YUN'
  }]
}, {
  countryName: 'Tajikistan',
  countryShortCode: 'TJ',
  regions: [{
    name: 'Dushanbe',
    shortCode: 'DU'
  }, {
    name: 'Kŭhistoni Badakhshon',
    shortCode: 'GB'
  }, {
    name: 'Khatlon',
    shortCode: 'KT'
  }, {
    name: 'Sughd',
    shortCode: 'SU'
  }]
}, {
  countryName: 'Tanzania, United Republic of',
  countryShortCode: 'TZ',
  regions: [{
    name: 'Arusha',
    shortCode: '01'
  }, {
    name: 'Coast',
    shortCode: '19'
  }, {
    name: 'Dar es Salaam',
    shortCode: '02'
  }, {
    name: 'Dodoma',
    shortCode: '03'
  }, {
    name: 'Iringa',
    shortCode: '04'
  }, {
    name: 'Kagera',
    shortCode: '05'
  }, {
    name: 'Kigoma',
    shortCode: '08'
  }, {
    name: 'Kilimanjaro',
    shortCode: '09'
  }, {
    name: 'Lindi',
    shortCode: '12'
  }, {
    name: 'Manyara',
    shortCode: '26'
  }, {
    name: 'Mara',
    shortCode: '13'
  }, {
    name: 'Mbeya',
    shortCode: '14'
  }, {
    name: 'Morogoro',
    shortCode: '16'
  }, {
    name: 'Mtwara',
    shortCode: '17'
  }, {
    name: 'Mwanza',
    shortCode: '18'
  }, {
    name: 'Pemba North',
    shortCode: '06'
  }, {
    name: 'Pemba South',
    shortCode: '10'
  }, {
    name: 'Rukwa',
    shortCode: '20'
  }, {
    name: 'Ruvuma',
    shortCode: '21'
  }, {
    name: 'Shinyanga',
    shortCode: '22'
  }, {
    name: 'Singida',
    shortCode: '23'
  }, {
    name: 'Tabora',
    shortCode: '24'
  }, {
    name: 'Tanga',
    shortCode: '25'
  }, {
    name: 'Zanzibar North',
    shortCode: '07'
  }, {
    name: 'Zanzibar Central/South',
    shortCode: '11'
  }, {
    name: 'Zanzibar Urban/West',
    shortCode: '15'
  }]
}, {
  countryName: 'Thailand',
  countryShortCode: 'TH',
  regions: [{
    name: 'Amnat Charoen',
    shortCode: '37'
  }, {
    name: 'Ang Thong',
    shortCode: '15'
  }, {
    name: 'Bueng Kan',
    shortCode: '38'
  }, {
    name: 'Buri Ram',
    shortCode: '31'
  }, {
    name: 'Chachoengsao',
    shortCode: '24'
  }, {
    name: 'Chai Nat',
    shortCode: '18'
  }, {
    name: 'Chaiyaphum',
    shortCode: '36'
  }, {
    name: 'Chanthaburi',
    shortCode: '22'
  }, {
    name: 'Chiang Mai',
    shortCode: '50'
  }, {
    name: 'Chiang Rai',
    shortCode: '57'
  }, {
    name: 'Chon Buri',
    shortCode: '20'
  }, {
    name: 'Chumphon',
    shortCode: '86'
  }, {
    name: 'Kalasin',
    shortCode: '46'
  }, {
    name: 'Kamphaeng Phet',
    shortCode: '62'
  }, {
    name: 'Kanchanaburi',
    shortCode: '71'
  }, {
    name: 'Khon Kaen',
    shortCode: '40'
  }, {
    name: 'Krabi',
    shortCode: '81'
  }, {
    name: 'Krung Thep Mahanakhon (Bangkok)',
    shortCode: '10'
  }, {
    name: 'Lampang',
    shortCode: '52'
  }, {
    name: 'Lamphun',
    shortCode: '51'
  }, {
    name: 'Loei',
    shortCode: '42'
  }, {
    name: 'Lop Buri',
    shortCode: '16'
  }, {
    name: 'Mae Hong Son',
    shortCode: '58'
  }, {
    name: 'Maha Sarakham',
    shortCode: '44'
  }, {
    name: 'Mukdahan',
    shortCode: '49'
  }, {
    name: 'Nakhon Nayok',
    shortCode: '26'
  }, {
    name: 'Nakhon Phathom',
    shortCode: '73'
  }, {
    name: 'Nakhon Phanom',
    shortCode: '48'
  }, {
    name: 'Nakhon Ratchasima',
    shortCode: '30'
  }, {
    name: 'Nakhon Sawan',
    shortCode: '60'
  }, {
    name: 'Nakhon Si Thammarat',
    shortCode: '80'
  }, {
    name: 'Nan',
    shortCode: '55'
  }, {
    name: 'Narathiwat',
    shortCode: '96'
  }, {
    name: 'Nong Bua Lam Phu',
    shortCode: '39'
  }, {
    name: 'Nong Khai',
    shortCode: '43'
  }, {
    name: 'Nonthaburi',
    shortCode: '12'
  }, {
    name: 'Pathum Thani',
    shortCode: '13'
  }, {
    name: 'Pattani',
    shortCode: '94'
  }, {
    name: 'Phangnga',
    shortCode: '82'
  }, {
    name: 'Phatthalung',
    shortCode: '93'
  }, {
    name: 'Phayao',
    shortCode: '56'
  }, {
    name: 'Phetchabun',
    shortCode: '67'
  }, {
    name: 'Phetchaburi',
    shortCode: '76'
  }, {
    name: 'Phichit',
    shortCode: '66'
  }, {
    name: 'Phitsanulok',
    shortCode: '65'
  }, {
    name: 'Phra Nakhon Si Ayutthaya',
    shortCode: '14'
  }, {
    name: 'Phrae',
    shortCode: '54'
  }, {
    name: 'Phuket',
    shortCode: '83'
  }, {
    name: 'Prachin Buri',
    shortCode: '25'
  }, {
    name: 'Prachuap Khiri Khan',
    shortCode: '77'
  }, {
    name: 'Ranong',
    shortCode: '85'
  }, {
    name: 'Ratchaburi',
    shortCode: '70'
  }, {
    name: 'Rayong',
    shortCode: '21'
  }, {
    name: 'Roi Et',
    shortCode: '45'
  }, {
    name: 'Sa Kaeo',
    shortCode: '27'
  }, {
    name: 'Sakon Nakhon',
    shortCode: '47'
  }, {
    name: 'Samut Prakan',
    shortCode: '11'
  }, {
    name: 'Samut Sakhon',
    shortCode: '74'
  }, {
    name: 'Samut Songkhram',
    shortCode: '75'
  }, {
    name: 'Saraburi',
    shortCode: '19'
  }, {
    name: 'Satun',
    shortCode: '91'
  }, {
    name: 'Sing Buri',
    shortCode: '17'
  }, {
    name: 'Si Sa ket',
    shortCode: '33'
  }, {
    name: 'Songkhla',
    shortCode: '90'
  }, {
    name: 'Sukhothai',
    shortCode: '64'
  }, {
    name: 'Suphan Buri',
    shortCode: '72'
  }, {
    name: 'Surat Thani',
    shortCode: '84'
  }, {
    name: 'Surin',
    shortCode: '32'
  }, {
    name: 'Tak',
    shortCode: '63'
  }, {
    name: 'Trang',
    shortCode: '92'
  }, {
    name: 'Trat',
    shortCode: '23'
  }, {
    name: 'Ubon Ratchathani',
    shortCode: '34'
  }, {
    name: 'Udon Thani',
    shortCode: '41'
  }, {
    name: 'Uthai Thani',
    shortCode: '61'
  }, {
    name: 'Uttaradit',
    shortCode: '53'
  }, {
    name: 'Yala',
    shortCode: '95'
  }, {
    name: 'Yasothon',
    shortCode: '35'
  }]
}, {
  countryName: 'Timor-Leste',
  countryShortCode: 'TL',
  regions: [{
    name: 'Aileu',
    shortCode: 'AL'
  }, {
    name: 'Ainaro',
    shortCode: 'AN'
  }, {
    name: 'Baucau',
    shortCode: 'BA'
  }, {
    name: 'Bobonaro',
    shortCode: 'BO'
  }, {
    name: 'Cova Lima',
    shortCode: 'CO'
  }, {
    name: 'Dili',
    shortCode: 'DI'
  }, {
    name: 'Ermera',
    shortCode: 'ER'
  }, {
    name: 'Lautem',
    shortCode: 'LA'
  }, {
    name: 'Liquica',
    shortCode: 'LI'
  }, {
    name: 'Manatuto',
    shortCode: 'MT'
  }, {
    name: 'Manufahi',
    shortCode: 'MF'
  }, {
    name: 'Oecussi',
    shortCode: 'OE'
  }, {
    name: 'Viqueque',
    shortCode: 'VI'
  }]
}, {
  countryName: 'Togo',
  countryShortCode: 'TG',
  regions: [{
    name: 'Centre',
    shortCode: 'C'
  }, {
    name: 'Kara',
    shortCode: 'K'
  }, {
    name: 'Maritime',
    shortCode: 'M'
  }, {
    name: 'Plateaux',
    shortCode: 'P'
  }, {
    name: 'Savannes',
    shortCode: 'S'
  }]
}, {
  countryName: 'Tokelau',
  countryShortCode: 'TK',
  regions: [{
    name: 'Atafu'
  }, {
    name: 'Fakaofo'
  }, {
    name: 'Nukunonu'
  }]
}, {
  countryName: 'Tonga',
  countryShortCode: 'TO',
  regions: [{
    name: "'Eua",
    shortCode: '01'
  }, {
    name: "Ha'apai",
    shortCode: '02'
  }, {
    name: 'Niuas',
    shortCode: '03'
  }, {
    name: 'Tongatapu',
    shortCode: '04'
  }, {
    name: "Vava'u",
    shortCode: '05'
  }]
}, {
  countryName: 'Trinidad and Tobago',
  countryShortCode: 'TT',
  regions: [{
    name: 'Arima',
    shortCode: 'ARI'
  }, {
    name: 'Chaguanas',
    shortCode: 'CHA'
  }, {
    name: 'Couva-Tabaquite-Talparo',
    shortCode: 'CTT'
  }, {
    name: 'Diefo Martin',
    shortCode: 'DMN'
  }, {
    name: 'Mayaro-Rio Claro',
    shortCode: 'MRC'
  }, {
    name: 'Penal-Debe',
    shortCode: 'PED'
  }, {
    name: 'Point Fortin',
    shortCode: 'PTF'
  }, {
    name: 'Port-of-Spain',
    shortCode: 'POS'
  }, {
    name: 'Princes Town',
    shortCode: 'PRT'
  }, {
    name: 'San Fernando',
    shortCode: 'SFO'
  }, {
    name: 'San Juan-Laventille',
    shortCode: 'SJL'
  }, {
    name: 'Sangre Grande',
    shortCode: 'SGE'
  }, {
    name: 'Siparia',
    shortCode: 'SIP'
  }, {
    name: 'Tobago',
    shortCode: 'TOB'
  }, {
    name: 'Tunapuna-Piarco',
    shortCode: 'TUP'
  }]
}, {
  countryName: 'Tunisia',
  countryShortCode: 'TN',
  regions: [{
    name: 'Ariana',
    shortCode: '12'
  }, {
    name: 'Beja',
    shortCode: '31'
  }, {
    name: 'Ben Arous',
    shortCode: '13'
  }, {
    name: 'Bizerte',
    shortCode: '23'
  }, {
    name: 'Gabes',
    shortCode: '81'
  }, {
    name: 'Gafsa',
    shortCode: '71'
  }, {
    name: 'Jendouba',
    shortCode: '32'
  }, {
    name: 'Kairouan',
    shortCode: '41'
  }, {
    name: 'Kasserine',
    shortCode: '42'
  }, {
    name: 'Kebili',
    shortCode: '73'
  }, {
    name: 'Kef',
    shortCode: '33'
  }, {
    name: 'Mahdia',
    shortCode: '53'
  }, {
    name: 'Medenine',
    shortCode: '82'
  }, {
    name: 'Monastir',
    shortCode: '52'
  }, {
    name: 'Nabeul',
    shortCode: '21'
  }, {
    name: 'Sfax',
    shortCode: '61'
  }, {
    name: 'Sidi Bouzid',
    shortCode: '43'
  }, {
    name: 'Siliana',
    shortCode: '34'
  }, {
    name: 'Sousse',
    shortCode: '51'
  }, {
    name: 'Tataouine',
    shortCode: '83'
  }, {
    name: 'Tozeur',
    shortCode: '72'
  }, {
    name: 'Tunis',
    shortCode: '11'
  }, {
    name: 'Zaghouan',
    shortCode: '22'
  }]
}, {
  countryName: 'Turkey',
  countryShortCode: 'TR',
  regions: [{
    name: 'Adana',
    shortCode: '01'
  }, {
    name: 'Adiyaman',
    shortCode: '02'
  }, {
    name: 'Afyonkarahisar',
    shortCode: '03'
  }, {
    name: 'Agri',
    shortCode: '04'
  }, {
    name: 'Aksaray',
    shortCode: '68'
  }, {
    name: 'Amasya',
    shortCode: '05'
  }, {
    name: 'Ankara',
    shortCode: '06'
  }, {
    name: 'Antalya',
    shortCode: '07'
  }, {
    name: 'Ardahan',
    shortCode: '75'
  }, {
    name: 'Artvin',
    shortCode: '08'
  }, {
    name: 'Aydin',
    shortCode: '09'
  }, {
    name: 'Balikesir',
    shortCode: '10'
  }, {
    name: 'Bartin',
    shortCode: '74'
  }, {
    name: 'Batman',
    shortCode: '72'
  }, {
    name: 'Bayburt',
    shortCode: '69'
  }, {
    name: 'Bilecik',
    shortCode: '11'
  }, {
    name: 'Bingol',
    shortCode: '12'
  }, {
    name: 'Bitlis',
    shortCode: '13'
  }, {
    name: 'Bolu',
    shortCode: '14'
  }, {
    name: 'Burdur',
    shortCode: '15'
  }, {
    name: 'Bursa',
    shortCode: '16'
  }, {
    name: 'Canakkale',
    shortCode: '17'
  }, {
    name: 'Cankiri',
    shortCode: '18'
  }, {
    name: 'Corum',
    shortCode: '19'
  }, {
    name: 'Denizli',
    shortCode: '20'
  }, {
    name: 'Diyarbakir',
    shortCode: '21'
  }, {
    name: 'Duzce',
    shortCode: '81'
  }, {
    name: 'Edirne',
    shortCode: '22'
  }, {
    name: 'Elazig',
    shortCode: '23'
  }, {
    name: 'Erzincan',
    shortCode: '24'
  }, {
    name: 'Erzurum',
    shortCode: '25'
  }, {
    name: 'Eskisehir',
    shortCode: '26'
  }, {
    name: 'Gaziantep',
    shortCode: '27'
  }, {
    name: 'Giresun',
    shortCode: '28'
  }, {
    name: 'Gumushane',
    shortCode: '29'
  }, {
    name: 'Hakkari',
    shortCode: '30'
  }, {
    name: 'Hatay',
    shortCode: '31'
  }, {
    name: 'Igdir',
    shortCode: '76'
  }, {
    name: 'Isparta',
    shortCode: '32'
  }, {
    name: 'Istanbul',
    shortCode: '34'
  }, {
    name: 'Izmir',
    shortCode: '35'
  }, {
    name: 'Kahramanmaras',
    shortCode: '46'
  }, {
    name: 'Karabuk',
    shortCode: '78'
  }, {
    name: 'Karaman',
    shortCode: '70'
  }, {
    name: 'Kars',
    shortCode: '36'
  }, {
    name: 'Kastamonu',
    shortCode: '37'
  }, {
    name: 'Kayseri',
    shortCode: '38'
  }, {
    name: 'Kilis',
    shortCode: '79'
  }, {
    name: 'Kirikkale',
    shortCode: '71'
  }, {
    name: 'Kirklareli',
    shortCode: '39'
  }, {
    name: 'Kirsehir',
    shortCode: '40'
  }, {
    name: 'Kocaeli',
    shortCode: '41'
  }, {
    name: 'Konya',
    shortCode: '42'
  }, {
    name: 'Kutahya',
    shortCode: '43'
  }, {
    name: 'Malatya',
    shortCode: '44'
  }, {
    name: 'Manisa',
    shortCode: '45'
  }, {
    name: 'Mardin',
    shortCode: '47'
  }, {
    name: 'Mersin',
    shortCode: '33'
  }, {
    name: 'Mugla',
    shortCode: '48'
  }, {
    name: 'Mus',
    shortCode: '49'
  }, {
    name: 'Nevsehir',
    shortCode: '50'
  }, {
    name: 'Nigde',
    shortCode: '51'
  }, {
    name: 'Ordu',
    shortCode: '52'
  }, {
    name: 'Osmaniye',
    shortCode: '80'
  }, {
    name: 'Rize',
    shortCode: '53'
  }, {
    name: 'Sakarya',
    shortCode: '54'
  }, {
    name: 'Samsun',
    shortCode: '55'
  }, {
    name: 'Sanliurfa',
    shortCode: '63'
  }, {
    name: 'Siirt',
    shortCode: '56'
  }, {
    name: 'Sinop',
    shortCode: '57'
  }, {
    name: 'Sirnak',
    shortCode: '73'
  }, {
    name: 'Sivas',
    shortCode: '58'
  }, {
    name: 'Tekirdag',
    shortCode: '59'
  }, {
    name: 'Tokat',
    shortCode: '60'
  }, {
    name: 'Trabzon',
    shortCode: '61'
  }, {
    name: 'Tunceli',
    shortCode: '62'
  }, {
    name: 'Usak',
    shortCode: '64'
  }, {
    name: 'Van',
    shortCode: '65'
  }, {
    name: 'Yalova',
    shortCode: '77'
  }, {
    name: 'Yozgat',
    shortCode: '66'
  }, {
    name: 'Zonguldak',
    shortCode: '67'
  }]
}, {
  countryName: 'Turkmenistan',
  countryShortCode: 'TM',
  regions: [{
    name: 'Ahal',
    shortCode: 'A'
  }, {
    name: 'Asgabat',
    shortCode: 'S'
  }, {
    name: 'Balkan',
    shortCode: 'B'
  }, {
    name: 'Dashoguz',
    shortCode: 'D'
  }, {
    name: 'Lebap',
    shortCode: 'L'
  }, {
    name: 'Mary',
    shortCode: 'M'
  }]
}, {
  countryName: 'Turks and Caicos Islands',
  countryShortCode: 'TC',
  regions: [{
    name: 'Turks and Caicos Islands'
  }]
}, {
  countryName: 'Tuvalu',
  countryShortCode: 'TV',
  regions: [{
    name: 'Funafuti',
    shortCode: 'FUN'
  }, {
    name: 'Nanumanga',
    shortCode: 'NMG'
  }, {
    name: 'Nanumea',
    shortCode: 'NMA'
  }, {
    name: 'Niutao',
    shortCode: 'NIT'
  }, {
    name: 'Nui',
    shortCode: 'NUI'
  }, {
    name: 'Nukufetau',
    shortCode: 'NKF'
  }, {
    name: 'Nukulaelae',
    shortCode: 'NKL'
  }, {
    name: 'Vaitupu',
    shortCode: 'VAU'
  }]
}, {
  countryName: 'Uganda',
  countryShortCode: 'UG',
  regions: [{
    name: 'Abim',
    shortCode: '317'
  }, {
    name: 'Adjumani',
    shortCode: '301'
  }, {
    name: 'Amolatar',
    shortCode: '314'
  }, {
    name: 'Amuria',
    shortCode: '216'
  }, {
    name: 'Amuru',
    shortCode: '319'
  }, {
    name: 'Apac',
    shortCode: '302'
  }, {
    name: 'Arua',
    shortCode: '303'
  }, {
    name: 'Budaka',
    shortCode: '217'
  }, {
    name: 'Bududa',
    shortCode: '223'
  }, {
    name: 'Bugiri',
    shortCode: '201'
  }, {
    name: 'Bukedea',
    shortCode: '224'
  }, {
    name: 'Bukwa',
    shortCode: '218'
  }, {
    name: 'Buliisa',
    shortCode: '419'
  }, {
    name: 'Bundibugyo',
    shortCode: '401'
  }, {
    name: 'Bushenyi',
    shortCode: '402'
  }, {
    name: 'Busia',
    shortCode: '202'
  }, {
    name: 'Butaleja',
    shortCode: '219'
  }, {
    name: 'Dokolo',
    shortCode: '318'
  }, {
    name: 'Gulu',
    shortCode: '304'
  }, {
    name: 'Hoima',
    shortCode: '403'
  }, {
    name: 'Ibanda',
    shortCode: '416'
  }, {
    name: 'Iganga',
    shortCode: '203'
  }, {
    name: 'Isingiro',
    shortCode: '417'
  }, {
    name: 'Jinja',
    shortCode: '204'
  }, {
    name: 'Kaabong',
    shortCode: '315'
  }, {
    name: 'Kabale',
    shortCode: '404'
  }, {
    name: 'Kabarole',
    shortCode: '405'
  }, {
    name: 'Kaberamaido',
    shortCode: '213'
  }, {
    name: 'Kalangala',
    shortCode: '101'
  }, {
    name: 'Kaliro',
    shortCode: '220'
  }, {
    name: 'Kampala',
    shortCode: '102'
  }, {
    name: 'Kamuli',
    shortCode: '205'
  }, {
    name: 'Kamwenge',
    shortCode: '413'
  }, {
    name: 'Kanungu',
    shortCode: '414'
  }, {
    name: 'Kapchorwa',
    shortCode: '206'
  }, {
    name: 'Kasese',
    shortCode: '406'
  }, {
    name: 'Katakwi',
    shortCode: '207'
  }, {
    name: 'Kayunga',
    shortCode: '112'
  }, {
    name: 'Kibaale',
    shortCode: '407'
  }, {
    name: 'Kiboga',
    shortCode: '103'
  }, {
    name: 'Kiruhura',
    shortCode: '418'
  }, {
    name: 'Kisoro',
    shortCode: '408'
  }, {
    name: 'Kitgum',
    shortCode: '305'
  }, {
    name: 'Koboko',
    shortCode: '316'
  }, {
    name: 'Kotido',
    shortCode: '306'
  }, {
    name: 'Kumi',
    shortCode: '208'
  }, {
    name: 'Kyenjojo',
    shortCode: '415'
  }, {
    name: 'Lira',
    shortCode: '307'
  }, {
    name: 'Luwero',
    shortCode: '104'
  }, {
    name: 'Lyantonde',
    shortCode: '116'
  }, {
    name: 'Manafwa',
    shortCode: '221'
  }, {
    name: 'Maracha',
    shortCode: '320'
  }, {
    name: 'Masaka',
    shortCode: '105'
  }, {
    name: 'Masindi',
    shortCode: '409'
  }, {
    name: 'Mayuge',
    shortCode: '214'
  }, {
    name: 'Mbale',
    shortCode: '209'
  }, {
    name: 'Mbarara',
    shortCode: '410'
  }, {
    name: 'Mityana',
    shortCode: '114'
  }, {
    name: 'Moroto',
    shortCode: '308'
  }, {
    name: 'Moyo',
    shortCode: '309'
  }, {
    name: 'Mpigi',
    shortCode: '106'
  }, {
    name: 'Mubende',
    shortCode: '107'
  }, {
    name: 'Mukono',
    shortCode: '108'
  }, {
    name: 'Nakapiripirit',
    shortCode: '311'
  }, {
    name: 'Nakaseke',
    shortCode: '115'
  }, {
    name: 'Nakasongola',
    shortCode: '109'
  }, {
    name: 'Namutumba',
    shortCode: '222'
  }, {
    name: 'Nebbi',
    shortCode: '310'
  }, {
    name: 'Ntungamo',
    shortCode: '411'
  }, {
    name: 'Oyam',
    shortCode: '321'
  }, {
    name: 'Pader',
    shortCode: '312'
  }, {
    name: 'Pallisa',
    shortCode: '210'
  }, {
    name: 'Rakai',
    shortCode: '110'
  }, {
    name: 'Rukungiri',
    shortCode: '412'
  }, {
    name: 'Sembabule',
    shortCode: '111'
  }, {
    name: 'Sironko',
    shortCode: '215'
  }, {
    name: 'Soroti',
    shortCode: '211'
  }, {
    name: 'Tororo',
    shortCode: '212'
  }, {
    name: 'Wakiso',
    shortCode: '113'
  }, {
    name: 'Yumbe',
    shortCode: '313'
  }]
}, {
  countryName: 'Ukraine',
  countryShortCode: 'UA',
  regions: [{
    name: 'Cherkasy',
    shortCode: '71'
  }, {
    name: 'Chernihiv',
    shortCode: '74'
  }, {
    name: 'Chernivtsi',
    shortCode: '77'
  }, {
    name: 'Dnipropetrovsk',
    shortCode: '12'
  }, {
    name: 'Donetsk',
    shortCode: '14'
  }, {
    name: 'Ivano-Frankivsk',
    shortCode: '26'
  }, {
    name: 'Kharkiv',
    shortCode: '63'
  }, {
    name: 'Kherson',
    shortCode: '65'
  }, {
    name: 'Khmelnytskyi',
    shortCode: '68'
  }, {
    name: 'Kiev',
    shortCode: '32'
  }, {
    name: 'Kirovohrad',
    shortCode: '35'
  }, {
    name: 'Luhansk',
    shortCode: '09'
  }, {
    name: 'Lviv',
    shortCode: '46'
  }, {
    name: 'Mykolaiv',
    shortCode: '48'
  }, {
    name: 'Odessa',
    shortCode: '51'
  }, {
    name: 'Poltava',
    shortCode: '53'
  }, {
    name: 'Rivne',
    shortCode: '56'
  }, {
    name: 'Sumy',
    shortCode: '59'
  }, {
    name: 'Ternopil',
    shortCode: '61'
  }, {
    name: 'Vinnytsia',
    shortCode: '05'
  }, {
    name: 'Volyn',
    shortCode: '07'
  }, {
    name: 'Zakarpattia',
    shortCode: '21'
  }, {
    name: 'Zaporizhia',
    shortCode: '23'
  }, {
    name: 'Zhytomyr',
    shortCode: '18'
  }, {
    name: 'Avtonomna Respublika Krym',
    shortCode: '43'
  }, {
    name: 'Kyïv',
    shortCode: '30'
  }, {
    name: 'Sevastopol',
    shortCode: '40'
  }]
}, {
  countryName: 'United Arab Emirates',
  countryShortCode: 'AE',
  regions: [{
    name: 'Abu Dhabi',
    shortCode: 'AZ'
  }, {
    name: 'Ajman',
    shortCode: 'AJ'
  }, {
    name: 'Dubai',
    shortCode: 'DU'
  }, {
    name: 'Fujairah',
    shortCode: 'FU'
  }, {
    name: 'Ras al Khaimah',
    shortCode: 'RK'
  }, {
    name: 'Sharjah',
    shortCode: 'SH'
  }, {
    name: 'Umm Al Quwain',
    shortCode: 'UQ'
  }]
}, {
  countryName: 'United Kingdom',
  countryShortCode: 'GB',
  regions: [{
    name: 'Aberdeen City',
    shortCode: 'ABE'
  }, {
    name: 'Aberdeenshire',
    shortCode: 'ABD'
  }, {
    name: 'Angus',
    shortCode: 'ANS'
  }, {
    name: 'Antrim and Newtownabbey',
    shortCode: 'ANN'
  }, {
    name: 'Ards and North Down',
    shortCode: 'AND'
  }, {
    name: 'Argyll and Bute',
    shortCode: 'AGB'
  }, {
    name: 'Armagh, Banbridge and Craigavon',
    shortCode: 'ABC'
  }, {
    name: 'Barking and Dagenham',
    shortCode: 'BDG'
  }, {
    name: 'Barnet',
    shortCode: 'BNE'
  }, {
    name: 'Barnsley',
    shortCode: 'BNS'
  }, {
    name: 'Bath and North East Somerset',
    shortCode: 'BAS'
  }, {
    name: 'Bedford',
    shortCode: 'BDF'
  }, {
    name: 'Belfast',
    shortCode: 'BFS'
  }, {
    name: 'Bexley',
    shortCode: 'BEX'
  }, {
    name: 'Birmingham',
    shortCode: 'BIR'
  }, {
    name: 'Blackburn with Darwen',
    shortCode: 'BBD'
  }, {
    name: 'Blackpool',
    shortCode: 'BPL'
  }, {
    name: 'Blaenau Gwent',
    shortCode: 'BGW'
  }, {
    name: 'Bolton',
    shortCode: 'BOL'
  }, {
    name: 'Bournemouth',
    shortCode: 'BMH'
  }, {
    name: 'Bracknell Forest',
    shortCode: 'BRC'
  }, {
    name: 'Bradford',
    shortCode: 'BRD'
  }, {
    name: 'Brent',
    shortCode: 'BEN'
  }, {
    name: 'Bridgend',
    shortCode: 'BGE'
  }, {
    name: 'Brighton and Hove',
    shortCode: 'BNH'
  }, {
    name: 'Bristol, City of',
    shortCode: 'BST'
  }, {
    name: 'Bromley',
    shortCode: 'BRY'
  }, {
    name: 'Buckinghamshire',
    shortCode: 'BKM'
  }, {
    name: 'Bury',
    shortCode: 'BUR'
  }, {
    name: 'Caerphilly',
    shortCode: 'CAY'
  }, {
    name: 'Calderdale',
    shortCode: 'CLD'
  }, {
    name: 'Cambridgeshire',
    shortCode: 'CAM'
  }, {
    name: 'Camden',
    shortCode: 'CMD'
  }, {
    name: 'Cardiff',
    shortCode: 'CRF'
  }, {
    name: 'Carmarthenshire',
    shortCode: 'CMN'
  }, {
    name: 'Causeway Coast and Glens',
    shortCode: 'CCG'
  }, {
    name: 'Central Bedfordshire',
    shortCode: 'CBF'
  }, {
    name: 'Ceredigion',
    shortCode: 'CGN'
  }, {
    name: 'Cheshire East',
    shortCode: 'CHE'
  }, {
    name: 'Cheshire West and Chester',
    shortCode: 'CHW'
  }, {
    name: 'Clackmannanshire',
    shortCode: 'CLK'
  }, {
    name: 'Conwy',
    shortCode: 'CWY'
  }, {
    name: 'Cornwall',
    shortCode: 'CON'
  }, {
    name: 'Coventry',
    shortCode: 'COV'
  }, {
    name: 'Croydon',
    shortCode: 'CRY'
  }, {
    name: 'Cumbria',
    shortCode: 'CMA'
  }, {
    name: 'Darlington',
    shortCode: 'DAL'
  }, {
    name: 'Denbighshire',
    shortCode: 'DEN'
  }, {
    name: 'Derby',
    shortCode: 'DER'
  }, {
    name: 'Derbyshire',
    shortCode: 'DBY'
  }, {
    name: 'Derry and Strabane',
    shortCode: 'DRS'
  }, {
    name: 'Devon',
    shortCode: 'DEV'
  }, {
    name: 'Doncaster',
    shortCode: 'DNC'
  }, {
    name: 'Dorset',
    shortCode: 'DOR'
  }, {
    name: 'Dudley',
    shortCode: 'DUD'
  }, {
    name: 'Dumfries and Galloway',
    shortCode: 'DGY'
  }, {
    name: 'Dundee City',
    shortCode: 'DND'
  }, {
    name: 'Durham County',
    shortCode: 'DUR'
  }, {
    name: 'Ealing',
    shortCode: 'EAL'
  }, {
    name: 'East Ayrshire',
    shortCode: 'EAY'
  }, {
    name: 'East Dunbartonshire',
    shortCode: 'EDU'
  }, {
    name: 'East Lothian',
    shortCode: 'ELN'
  }, {
    name: 'East Renfrewshire',
    shortCode: 'ERW'
  }, {
    name: 'East Riding of Yorkshire',
    shortCode: 'ERY'
  }, {
    name: 'East Sussex',
    shortCode: 'ESX'
  }, {
    name: 'Edinburgh, City of',
    shortCode: 'EDH'
  }, {
    name: 'Eilean Siar',
    shortCode: 'ELS'
  }, {
    name: 'Enfield',
    shortCode: 'ENF'
  }, {
    name: 'Essex',
    shortCode: 'ESS'
  }, {
    name: 'Falkirk',
    shortCode: 'FAL'
  }, {
    name: 'Fermanagh and Omagh',
    shortCode: 'FMO'
  }, {
    name: 'Fife',
    shortCode: 'FIF'
  }, {
    name: 'Flintshire',
    shortCode: 'FLN'
  }, {
    name: 'Gateshead',
    shortCode: 'GAT'
  }, {
    name: 'Glasgow City',
    shortCode: 'GLG'
  }, {
    name: 'Gloucestershire',
    shortCode: 'GLS'
  }, {
    name: 'Greenwich',
    shortCode: 'GRE'
  }, {
    name: 'Gwynedd',
    shortCode: 'GWN'
  }, {
    name: 'Hackney',
    shortCode: 'HCK'
  }, {
    name: 'Halton',
    shortCode: 'HAL'
  }, {
    name: 'Hammersmith and Fulham',
    shortCode: 'HMF'
  }, {
    name: 'Hampshire',
    shortCode: 'HAM'
  }, {
    name: 'Haringey',
    shortCode: 'HRY'
  }, {
    name: 'Harrow',
    shortCode: 'HRW'
  }, {
    name: 'Hartlepool',
    shortCode: 'HPL'
  }, {
    name: 'Havering',
    shortCode: 'HAV'
  }, {
    name: 'Herefordshire',
    shortCode: 'HEF'
  }, {
    name: 'Hertfordshire',
    shortCode: 'HRT'
  }, {
    name: 'Highland',
    shortCode: 'HLD'
  }, {
    name: 'Hillingdon',
    shortCode: 'HIL'
  }, {
    name: 'Hounslow',
    shortCode: 'HNS'
  }, {
    name: 'Inverclyde',
    shortCode: 'IVC'
  }, {
    name: 'Isle of Anglesey',
    shortCode: 'AGY'
  }, {
    name: 'Isle of Wight',
    shortCode: 'IOW'
  }, {
    name: 'Isles of Scilly',
    shortCode: 'IOS'
  }, {
    name: 'Islington',
    shortCode: 'ISL'
  }, {
    name: 'Kensington and Chelsea',
    shortCode: 'KEC'
  }, {
    name: 'Kent',
    shortCode: 'KEN'
  }, {
    name: 'Kingston upon Hull',
    shortCode: 'KHL'
  }, {
    name: 'Kingston upon Thames',
    shortCode: 'KTT'
  }, {
    name: 'Kirklees',
    shortCode: 'KIR'
  }, {
    name: 'Knowsley',
    shortCode: 'KWL'
  }, {
    name: 'Lambeth',
    shortCode: 'LBH'
  }, {
    name: 'Lancashire',
    shortCode: 'LAN'
  }, {
    name: 'Leeds',
    shortCode: 'LDS'
  }, {
    name: 'Leicester',
    shortCode: 'LCE'
  }, {
    name: 'Leicestershire',
    shortCode: 'LEC'
  }, {
    name: 'Lewisham',
    shortCode: 'LEW'
  }, {
    name: 'Lincolnshire',
    shortCode: 'LIN'
  }, {
    name: 'Lisburn and Castlereagh',
    shortCode: 'LBC'
  }, {
    name: 'Liverpool',
    shortCode: 'LIV'
  }, {
    name: 'London, City of',
    shortCode: 'LND'
  }, {
    name: 'Luton',
    shortCode: 'LUT'
  }, {
    name: 'Manchester',
    shortCode: 'MAN'
  }, {
    name: 'Medway',
    shortCode: 'MDW'
  }, {
    name: 'Merthyr Tydfil',
    shortCode: 'MTY'
  }, {
    name: 'Merton',
    shortCode: 'MRT'
  }, {
    name: 'Mid and East Antrim',
    shortCode: 'MEA'
  }, {
    name: 'Mid Ulster',
    shortCode: 'MUL'
  }, {
    name: 'Middlesbrough',
    shortCode: 'MDB'
  }, {
    name: 'Midlothian',
    shortCode: 'MLN'
  }, {
    name: 'Milton Keynes',
    shortCode: 'MIK'
  }, {
    name: 'Monmouthshire',
    shortCode: 'MON'
  }, {
    name: 'Moray',
    shortCode: 'MRY'
  }, {
    name: 'Neath Port Talbot',
    shortCode: 'NTL'
  }, {
    name: 'Newcastle upon Tyne',
    shortCode: 'NET'
  }, {
    name: 'Newham',
    shortCode: 'NWM'
  }, {
    name: 'Newport',
    shortCode: 'NWP'
  }, {
    name: 'Newry, Mourne and Down',
    shortCode: 'NMD'
  }, {
    name: 'Norfolk',
    shortCode: 'NFK'
  }, {
    name: 'North Ayrshire',
    shortCode: 'NAY'
  }, {
    name: 'North East Lincolnshire',
    shortCode: 'NEL'
  }, {
    name: 'North Lanarkshire',
    shortCode: 'NLK'
  }, {
    name: 'North Lincolnshire',
    shortCode: 'NLN'
  }, {
    name: 'North Somerset',
    shortCode: 'NSM'
  }, {
    name: 'North Tyneside',
    shortCode: 'NTY'
  }, {
    name: 'North Yorkshire',
    shortCode: 'NYK'
  }, {
    name: 'Northamptonshire',
    shortCode: 'NTH'
  }, {
    name: 'Northumberland',
    shortCode: 'NBL'
  }, {
    name: 'Nottingham',
    shortCode: 'NGM'
  }, {
    name: 'Nottinghamshire',
    shortCode: 'NTT'
  }, {
    name: 'Oldham',
    shortCode: 'OLD'
  }, {
    name: 'Orkney Islands',
    shortCode: 'ORK'
  }, {
    name: 'Oxfordshire',
    shortCode: 'OXF'
  }, {
    name: 'Pembrokeshire',
    shortCode: 'PEM'
  }, {
    name: 'Perth and Kinross',
    shortCode: 'PKN'
  }, {
    name: 'Peterborough',
    shortCode: 'PTE'
  }, {
    name: 'Plymouth',
    shortCode: 'PLY'
  }, {
    name: 'Poole',
    shortCode: 'POL'
  }, {
    name: 'Portsmouth',
    shortCode: 'POR'
  }, {
    name: 'Powys',
    shortCode: 'POW'
  }, {
    name: 'Reading',
    shortCode: 'RDG'
  }, {
    name: 'Redbridge',
    shortCode: 'RDB'
  }, {
    name: 'Redcar and Cleveland',
    shortCode: 'RCC'
  }, {
    name: 'Renfrewshire',
    shortCode: 'RFW'
  }, {
    name: 'Rhondda, Cynon, Taff',
    shortCode: 'RCT'
  }, {
    name: 'Richmond upon Thames',
    shortCode: 'RIC'
  }, {
    name: 'Rochdale',
    shortCode: 'RCH'
  }, {
    name: 'Rotherham',
    shortCode: 'ROT'
  }, {
    name: 'Rutland',
    shortCode: 'RUT'
  }, {
    name: 'St. Helens',
    shortCode: 'SHN'
  }, {
    name: 'Salford',
    shortCode: 'SLF'
  }, {
    name: 'Sandwell',
    shortCode: 'SAW'
  }, {
    name: 'Scottish Borders, The',
    shortCode: 'SCB'
  }, {
    name: 'Sefton',
    shortCode: 'SFT'
  }, {
    name: 'Sheffield',
    shortCode: 'SHF'
  }, {
    name: 'Shetland Islands',
    shortCode: 'ZET'
  }, {
    name: 'Shropshire',
    shortCode: 'SHR'
  }, {
    name: 'Slough',
    shortCode: 'SLG'
  }, {
    name: 'Solihull',
    shortCode: 'SOL'
  }, {
    name: 'Somerset',
    shortCode: 'SOM'
  }, {
    name: 'South Ayrshire',
    shortCode: 'SAY'
  }, {
    name: 'South Gloucestershire',
    shortCode: 'SGC'
  }, {
    name: 'South Lanarkshire',
    shortCode: 'SLK'
  }, {
    name: 'South Tyneside',
    shortCode: 'STY'
  }, {
    name: 'Southampton',
    shortCode: 'STH'
  }, {
    name: 'Southend-on-Sea',
    shortCode: 'SOS'
  }, {
    name: 'Southwark',
    shortCode: 'SWK'
  }, {
    name: 'Staffordshire',
    shortCode: 'STS'
  }, {
    name: 'Stirling',
    shortCode: 'STG'
  }, {
    name: 'Stockport',
    shortCode: 'SKP'
  }, {
    name: 'Stockton-on-Tees',
    shortCode: 'STT'
  }, {
    name: 'Stoke-on-Trent',
    shortCode: 'STE'
  }, {
    name: 'Suffolk',
    shortCode: 'SFK'
  }, {
    name: 'Sunderland',
    shortCode: 'SND'
  }, {
    name: 'Surrey',
    shortCode: 'SRY'
  }, {
    name: 'Sutton',
    shortCode: 'STN'
  }, {
    name: 'Swansea',
    shortCode: 'SWA'
  }, {
    name: 'Swindon',
    shortCode: 'SWD'
  }, {
    name: 'Tameside',
    shortCode: 'TAM'
  }, {
    name: 'Telford and Wrekin',
    shortCode: 'TFW'
  }, {
    name: 'Thurrock',
    shortCode: 'THR'
  }, {
    name: 'Torbay',
    shortCode: 'TOB'
  }, {
    name: 'Torfaen',
    shortCode: 'TOF'
  }, {
    name: 'Tower Hamlets',
    shortCode: 'TWH'
  }, {
    name: 'Trafford',
    shortCode: 'TRF'
  }, {
    name: 'Vale of Glamorgan, The',
    shortCode: 'VGL'
  }, {
    name: 'Wakefield',
    shortCode: 'WKF'
  }, {
    name: 'Walsall',
    shortCode: 'WLL'
  }, {
    name: 'Waltham Forest',
    shortCode: 'WFT'
  }, {
    name: 'Wandsworth',
    shortCode: 'WND'
  }, {
    name: 'Warrington',
    shortCode: 'WRT'
  }, {
    name: 'Warwickshire',
    shortCode: 'WAR'
  }, {
    name: 'West Berkshire',
    shortCode: 'WBK'
  }, {
    name: 'West Dunbartonshire',
    shortCode: 'WDU'
  }, {
    name: 'West Lothian',
    shortCode: 'WLN'
  }, {
    name: 'West Sussex',
    shortCode: 'WSX'
  }, {
    name: 'Westminster',
    shortCode: 'WSM'
  }, {
    name: 'Wigan',
    shortCode: 'WGN'
  }, {
    name: 'Wiltshire',
    shortCode: 'WIL'
  }, {
    name: 'Windsor and Maidenhead',
    shortCode: 'WNM'
  }, {
    name: 'Wirral',
    shortCode: 'WRL'
  }, {
    name: 'Wokingham',
    shortCode: 'WOK'
  }, {
    name: 'Wolverhampton',
    shortCode: 'WLV'
  }, {
    name: 'Worcestershire',
    shortCode: 'WOR'
  }, {
    name: 'Wrexham',
    shortCode: 'WRX'
  }, {
    name: 'York',
    shortCode: 'YOR'
  }]
}, {
  countryName: 'United States',
  countryShortCode: 'US',
  regions: [{
    name: 'Alabama',
    shortCode: 'AL'
  }, {
    name: 'Alaska',
    shortCode: 'AK'
  }, {
    name: 'American Samoa',
    shortCode: 'AS'
  }, {
    name: 'Arizona',
    shortCode: 'AZ'
  }, {
    name: 'Arkansas',
    shortCode: 'AR'
  }, {
    name: 'Armed Forces Americas',
    shortCode: 'AA'
  }, {
    name: 'Armed Forces Europe, Canada, Africa and Middle East',
    shortCode: 'AE'
  }, {
    name: 'Armed Forces Pacific',
    shortCode: 'AP'
  }, {
    name: 'California',
    shortCode: 'CA'
  }, {
    name: 'Colorado',
    shortCode: 'CO'
  }, {
    name: 'Connecticut',
    shortCode: 'CT'
  }, {
    name: 'Delaware',
    shortCode: 'DE'
  }, {
    name: 'District of Columbia',
    shortCode: 'DC'
  }, {
    name: 'Florida',
    shortCode: 'FL'
  }, {
    name: 'Georgia',
    shortCode: 'GA'
  }, {
    name: 'Guam',
    shortCode: 'GU'
  }, {
    name: 'Hawaii',
    shortCode: 'HI'
  }, {
    name: 'Idaho',
    shortCode: 'ID'
  }, {
    name: 'Illinois',
    shortCode: 'IL'
  }, {
    name: 'Indiana',
    shortCode: 'IN'
  }, {
    name: 'Iowa',
    shortCode: 'IA'
  }, {
    name: 'Kansas',
    shortCode: 'KS'
  }, {
    name: 'Kentucky',
    shortCode: 'KY'
  }, {
    name: 'Louisiana',
    shortCode: 'LA'
  }, {
    name: 'Maine',
    shortCode: 'ME'
  }, {
    name: 'Marshall Islands',
    shortCode: 'MH'
  }, {
    name: 'Maryland',
    shortCode: 'MD'
  }, {
    name: 'Massachusetts',
    shortCode: 'MA'
  }, {
    name: 'Michigan',
    shortCode: 'MI'
  }, {
    name: 'Minnesota',
    shortCode: 'MN'
  }, {
    name: 'Mississippi',
    shortCode: 'MS'
  }, {
    name: 'Missouri',
    shortCode: 'MO'
  }, {
    name: 'Montana',
    shortCode: 'MT'
  }, {
    name: 'Nebraska',
    shortCode: 'NE'
  }, {
    name: 'Nevada',
    shortCode: 'NV'
  }, {
    name: 'New Hampshire',
    shortCode: 'NH'
  }, {
    name: 'New Jersey',
    shortCode: 'NJ'
  }, {
    name: 'New Mexico',
    shortCode: 'NM'
  }, {
    name: 'New York',
    shortCode: 'NY'
  }, {
    name: 'North Carolina',
    shortCode: 'NC'
  }, {
    name: 'North Dakota',
    shortCode: 'ND'
  }, {
    name: 'Northern Mariana Islands',
    shortCode: 'MP'
  }, {
    name: 'Ohio',
    shortCode: 'OH'
  }, {
    name: 'Oklahoma',
    shortCode: 'OK'
  }, {
    name: 'Oregon',
    shortCode: 'OR'
  }, {
    name: 'Palau',
    shortCode: 'PW'
  }, {
    name: 'Pennsylvania',
    shortCode: 'PA'
  }, {
    name: 'Puerto Rico',
    shortCode: 'PR'
  }, {
    name: 'Rhode Island',
    shortCode: 'RI'
  }, {
    name: 'South Carolina',
    shortCode: 'SC'
  }, {
    name: 'South Dakota',
    shortCode: 'SD'
  }, {
    name: 'Tennessee',
    shortCode: 'TN'
  }, {
    name: 'Texas',
    shortCode: 'TX'
  }, {
    name: 'Utah',
    shortCode: 'UT'
  }, {
    name: 'Vermont',
    shortCode: 'VT'
  }, {
    name: 'Virgin Islands',
    shortCode: 'VI'
  }, {
    name: 'Virginia',
    shortCode: 'VA'
  }, {
    name: 'Washington',
    shortCode: 'WA'
  }, {
    name: 'West Virginia',
    shortCode: 'WV'
  }, {
    name: 'Wisconsin',
    shortCode: 'WI'
  }, {
    name: 'Wyoming',
    shortCode: 'WY'
  }]
}, {
  countryName: 'United States Minor Outlying Islands',
  countryShortCode: 'UM',
  regions: [{
    name: 'Baker Island',
    shortCode: '81'
  }, {
    name: 'Howland Island',
    shortCode: '84'
  }, {
    name: 'Jarvis Island',
    shortCode: '86'
  }, {
    name: 'Johnston Atoll',
    shortCode: '67'
  }, {
    name: 'Kingman Reef',
    shortCode: '89'
  }, {
    name: 'Midway Islands',
    shortCode: '71'
  }, {
    name: 'Navassa Island',
    shortCode: '76'
  }, {
    name: 'Palmyra Atoll',
    shortCode: '95'
  }, {
    name: 'Wake Island',
    shortCode: '79'
  }, {
    name: 'Bajo Nuevo Bank',
    shortCode: 'BN'
  }, {
    name: 'Serranilla Bank',
    shortCode: 'SB'
  }]
}, {
  countryName: 'Uruguay',
  countryShortCode: 'UY',
  regions: [{
    name: 'Artigas',
    shortCode: 'AR'
  }, {
    name: 'Canelones',
    shortCode: 'CA'
  }, {
    name: 'Cerro Largo',
    shortCode: 'CL'
  }, {
    name: 'Colonia',
    shortCode: 'CO'
  }, {
    name: 'Durazno',
    shortCode: 'DU'
  }, {
    name: 'Flores',
    shortCode: 'FS'
  }, {
    name: 'Florida',
    shortCode: 'FD'
  }, {
    name: 'Lavalleja',
    shortCode: 'LA'
  }, {
    name: 'Maldonado',
    shortCode: 'MA'
  }, {
    name: 'Montevideo',
    shortCode: 'MO'
  }, {
    name: 'Paysandú',
    shortCode: 'PA'
  }, {
    name: 'Río Negro',
    shortCode: 'RN'
  }, {
    name: 'Rivera',
    shortCode: 'RV'
  }, {
    name: 'Rocha',
    shortCode: 'RO'
  }, {
    name: 'Salto',
    shortCode: 'SA'
  }, {
    name: 'San José',
    shortCode: 'SJ'
  }, {
    name: 'Soriano',
    shortCode: 'SO'
  }, {
    name: 'Tacuarembó',
    shortCode: 'TA'
  }, {
    name: 'Treinta y Tres',
    shortCode: 'TT'
  }]
}, {
  countryName: 'Uzbekistan',
  countryShortCode: 'UZ',
  regions: [{
    name: 'Toshkent shahri',
    shortCode: 'TK'
  }, {
    name: 'Andijon',
    shortCode: 'AN'
  }, {
    name: 'Buxoro',
    shortCode: 'BU'
  }, {
    name: 'Farg‘ona',
    shortCode: 'FA'
  }, {
    name: 'Jizzax',
    shortCode: 'JI'
  }, {
    name: 'Namangan',
    shortCode: 'NG'
  }, {
    name: 'Navoiy',
    shortCode: 'NW'
  }, {
    name: 'Qashqadaryo (Qarshi)',
    shortCode: 'QA'
  }, {
    name: 'Samarqand',
    shortCode: 'SA'
  }, {
    name: 'Sirdaryo (Guliston)',
    shortCode: 'SI'
  }, {
    name: 'Surxondaryo (Termiz)',
    shortCode: 'SU'
  }, {
    name: 'Toshkent wiloyati',
    shortCode: 'TO'
  }, {
    name: 'Xorazm (Urganch)',
    shortCode: 'XO'
  }, {
    name: 'Qoraqalpog‘iston Respublikasi (Nukus)',
    shortCode: 'QR'
  }]
}, {
  countryName: 'Vanuatu',
  countryShortCode: 'VU',
  regions: [{
    name: 'Malampa',
    shortCode: 'MAP'
  }, {
    name: 'Pénama',
    shortCode: 'PAM'
  }, {
    name: 'Sanma',
    shortCode: 'SAM'
  }, {
    name: 'Shéfa',
    shortCode: 'SEE'
  }, {
    name: 'Taféa',
    shortCode: 'TAE'
  }, {
    name: 'Torba',
    shortCode: 'TOB'
  }]
}, {
  countryName: 'Venezuela, Bolivarian Republic of',
  countryShortCode: 'VE',
  regions: [{
    name: 'Dependencias Federales',
    shortCode: 'W'
  }, {
    name: 'Distrito Federal',
    shortCode: 'A'
  }, {
    name: 'Amazonas',
    shortCode: 'Z'
  }, {
    name: 'Anzoátegui',
    shortCode: 'B'
  }, {
    name: 'Apure',
    shortCode: 'C'
  }, {
    name: 'Aragua',
    shortCode: 'D'
  }, {
    name: 'Barinas',
    shortCode: 'E'
  }, {
    name: 'Bolívar',
    shortCode: 'F'
  }, {
    name: 'Carabobo',
    shortCode: 'G'
  }, {
    name: 'Cojedes',
    shortCode: 'H'
  }, {
    name: 'Delta Amacuro',
    shortCode: 'Y'
  }, {
    name: 'Falcón',
    shortCode: 'I'
  }, {
    name: 'Guárico',
    shortCode: 'J'
  }, {
    name: 'Lara',
    shortCode: 'K'
  }, {
    name: 'Mérida',
    shortCode: 'L'
  }, {
    name: 'Miranda',
    shortCode: 'M'
  }, {
    name: 'Monagas',
    shortCode: 'N'
  }, {
    name: 'Nueva Esparta',
    shortCode: 'O'
  }, {
    name: 'Portuguesa',
    shortCode: 'P'
  }, {
    name: 'Sucre',
    shortCode: 'R'
  }, {
    name: 'Táchira',
    shortCode: 'S'
  }, {
    name: 'Trujillo',
    shortCode: 'T'
  }, {
    name: 'Vargas',
    shortCode: 'X'
  }, {
    name: 'Yaracuy',
    shortCode: 'U'
  }, {
    name: 'Zulia',
    shortCode: 'V'
  }]
}, {
  countryName: 'Vietnam',
  countryShortCode: 'VN',
  regions: [{
    name: 'Đồng Nai',
    shortCode: '39'
  }, {
    name: 'Đồng Tháp',
    shortCode: '45'
  }, {
    name: 'Gia Lai',
    shortCode: '30'
  }, {
    name: 'Hà Giang',
    shortCode: '03'
  }, {
    name: 'Hà Nam',
    shortCode: '63'
  }, {
    name: 'Hà Tây',
    shortCode: '15'
  }, {
    name: 'Hà Tĩnh',
    shortCode: '23'
  }, {
    name: 'Hải Dương',
    shortCode: '61'
  }, {
    name: 'Hậu Giang',
    shortCode: '73'
  }, {
    name: 'Hòa Bình',
    shortCode: '14'
  }, {
    name: 'Hưng Yên',
    shortCode: '66'
  }, {
    name: 'Khánh Hòa',
    shortCode: '34'
  }, {
    name: 'Kiên Giang',
    shortCode: '47'
  }, {
    name: 'Kon Tum',
    shortCode: '28'
  }, {
    name: 'Lai Châu',
    shortCode: '01'
  }, {
    name: 'Lâm Đồng',
    shortCode: '35'
  }, {
    name: 'Lạng Sơn',
    shortCode: '09'
  }, {
    name: 'Lào Cai',
    shortCode: '02'
  }, {
    name: 'Long An',
    shortCode: '41'
  }, {
    name: 'Nam Định',
    shortCode: '67'
  }, {
    name: 'Nghệ An',
    shortCode: '22'
  }, {
    name: 'Ninh Bình',
    shortCode: '18'
  }, {
    name: 'Ninh Thuận',
    shortCode: '36'
  }, {
    name: 'Phú Thọ',
    shortCode: '68'
  }, {
    name: 'Phú Yên',
    shortCode: '32'
  }, {
    name: 'Quảng Bình',
    shortCode: '24'
  }, {
    name: 'Quảng Nam',
    shortCode: '27'
  }, {
    name: 'Quảng Ngãi',
    shortCode: '29'
  }, {
    name: 'Quảng Ninh',
    shortCode: '13'
  }, {
    name: 'Quảng Trị',
    shortCode: '25'
  }, {
    name: 'Sóc Trăng',
    shortCode: '52'
  }, {
    name: 'Sơn La',
    shortCode: '05'
  }, {
    name: 'Tây Ninh',
    shortCode: '37'
  }, {
    name: 'Thái Bình',
    shortCode: '20'
  }, {
    name: 'Thái Nguyên',
    shortCode: '69'
  }, {
    name: 'Thanh Hóa',
    shortCode: '21'
  }, {
    name: 'Thừa Thiên–Huế',
    shortCode: '26'
  }, {
    name: 'Tiền Giang',
    shortCode: '46'
  }, {
    name: 'Trà Vinh',
    shortCode: '51'
  }, {
    name: 'Tuyên Quang',
    shortCode: '07'
  }, {
    name: 'Vĩnh Long',
    shortCode: '49'
  }, {
    name: 'Vĩnh Phúc',
    shortCode: '70'
  }, {
    name: 'Yên Bái',
    shortCode: '06'
  }, {
    name: 'Cần Thơ',
    shortCode: 'CT'
  }, {
    name: 'Đà Nẵng',
    shortCode: 'DN'
  }, {
    name: 'Hà Nội',
    shortCode: 'HN'
  }, {
    name: 'Hải Phòng',
    shortCode: 'HP'
  }, {
    name: 'Hồ Chí Minh (Sài Gòn)',
    shortCode: 'SG'
  }]
}, {
  countryName: 'Virgin Islands, British',
  countryShortCode: 'VG',
  regions: [{
    name: 'Anegada',
    shortCode: 'ANG'
  }, {
    name: 'Jost Van Dyke',
    shortCode: 'JVD'
  }, {
    name: 'Tortola',
    shortCode: 'TTA'
  }, {
    name: 'Virgin Gorda',
    shortCode: 'VGD'
  }]
}, {
  countryName: 'Virgin Islands, U.S.',
  countryShortCode: 'VI',
  regions: [{
    name: 'St. Thomas',
    shortCode: 'STH'
  }, {
    name: 'St. John',
    shortCode: 'SJO'
  }, {
    name: 'St. Croix',
    shortCode: 'SCR'
  }]
}, {
  countryName: 'Wallis and Futuna',
  countryShortCode: 'WF',
  regions: [{
    name: 'Alo',
    shortCode: 'ALO'
  }, {
    name: 'Sigave',
    shortCode: 'SIG'
  }, {
    name: 'Wallis',
    shortCode: 'WAL'
  }]
}, {
  countryName: 'Western Sahara',
  countryShortCode: 'EH',
  regions: [{
    name: 'Es Smara',
    shortCode: 'ESM'
  }, {
    name: 'Boujdour',
    shortCode: 'BOD'
  }, {
    name: 'Laâyoune',
    shortCode: 'LAA'
  }, {
    name: 'Aousserd',
    shortCode: 'AOU'
  }, {
    name: 'Oued ed Dahab',
    shortCode: 'OUD'
  }]
}, {
  countryName: 'Yemen',
  countryShortCode: 'YE',
  regions: [{
    name: 'Abyān',
    shortCode: 'AB'
  }, {
    name: "'Adan",
    shortCode: 'AD'
  }, {
    name: "Aḑ Ḑāli'",
    shortCode: 'DA'
  }, {
    name: "Al Bayḑā'",
    shortCode: 'BA'
  }, {
    name: 'Al Ḩudaydah',
    shortCode: 'HU'
  }, {
    name: 'Al Jawf',
    shortCode: 'JA'
  }, {
    name: 'Al Mahrah',
    shortCode: 'MR'
  }, {
    name: 'Al Maḩwīt',
    shortCode: 'MW'
  }, {
    name: "'Amrān",
    shortCode: 'AM'
  }, {
    name: 'Dhamār',
    shortCode: 'DH'
  }, {
    name: 'Ḩaḑramawt',
    shortCode: 'HD'
  }, {
    name: 'Ḩajjah',
    shortCode: 'HJ'
  }, {
    name: 'Ibb',
    shortCode: 'IB'
  }, {
    name: 'Laḩij',
    shortCode: 'LA'
  }, {
    name: "Ma'rib",
    shortCode: 'MA'
  }, {
    name: 'Raymah',
    shortCode: 'RA'
  }, {
    name: 'Şā‘dah',
    shortCode: 'SD'
  }, {
    name: "Şan‘ā'",
    shortCode: 'SN'
  }, {
    name: 'Shabwah',
    shortCode: 'SH'
  }, {
    name: 'Tā‘izz',
    shortCode: 'TA'
  }]
}, {
  countryName: 'Zambia',
  countryShortCode: 'ZM',
  regions: [{
    name: 'Central',
    shortCode: '02'
  }, {
    name: 'Copperbelt',
    shortCode: '08'
  }, {
    name: 'Eastern',
    shortCode: '03'
  }, {
    name: 'Luapula',
    shortCode: '04'
  }, {
    name: 'Lusaka',
    shortCode: '09'
  }, {
    name: 'Northern',
    shortCode: '05'
  }, {
    name: 'North-Western',
    shortCode: '06'
  }, {
    name: 'Southern',
    shortCode: '07'
  }, {
    name: 'Western',
    shortCode: '01'
  }]
}, {
  countryName: 'Zimbabwe',
  countryShortCode: 'ZW',
  regions: [{
    name: 'Bulawayo',
    shortCode: 'BU'
  }, {
    name: 'Harare',
    shortCode: 'HA'
  }, {
    name: 'Manicaland',
    shortCode: 'MA'
  }, {
    name: 'Mashonaland Central',
    shortCode: 'MC'
  }, {
    name: 'Mashonaland East',
    shortCode: 'ME'
  }, {
    name: 'Mashonaland West',
    shortCode: 'MW'
  }, {
    name: 'Masvingo',
    shortCode: 'MV'
  }, {
    name: 'Matabeleland North',
    shortCode: 'MN'
  }, {
    name: 'Matabeleland South',
    shortCode: 'MS'
  }, {
    name: 'Midlands',
    shortCode: 'MI'
  }]
}];

var transformOptions = function transformOptions(countries) {
  return countries.map(function (country) {
    return {
      id: country.countryShortCode,
      value: country.countryName
    };
  });
};
var useCountry = function useCountry(_ref) {
  var limitCountry = _ref.country,
    label = _ref.label,
    onChange = _ref.onChange,
    showAllCountries = _ref.showAllCountries;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange,
    values = _useFormikContext.values;
  var valueObj = values;
  var translations = deepFind(valueObj, 'translations');
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var countryList = (limitCountry === null || limitCountry === void 0 ? void 0 : limitCountry.length) === 0 || showAllCountries ? CountryRegion : CountryRegion.filter(function (country) {
    return limitCountry.includes(country.countryShortCode);
  });
  var countryLabel = (translations === null || translations === void 0 ? void 0 : translations.countryLabel) || t([label, 'Country'], {
    ns: 'labels'
  });
  var countryOptions = [{
    id: '',
    value: t('Select One', {
      ns: 'labels'
    })
  }].concat(_toConsumableArray(transformOptions(countryList)));
  var handleOnChange = function handleOnChange(e) {
    onChange && onChange(e);
    handleChange(e);
  };
  return {
    countryLabel: countryLabel,
    countryOptions: countryOptions,
    handleOnChange: handleOnChange,
    values: values
  };
};

var useCountryPostal = function useCountryPostal(_ref) {
  var required = _ref.required;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var valueObj = values;
  var translations = deepFind(valueObj, 'translations');
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var postalCodeLabel = (translations === null || translations === void 0 ? void 0 : translations.postalCodeLabel) || "".concat(t('Postal Code', {
    ns: 'labels'
  })).concat(required ? '*' : '');
  return {
    postalCodeLabel: postalCodeLabel,
    values: values
  };
};

var _excluded$A = ["name"];
/* CraftyClicks now known as Fetchify but not using Fetchify as that is an already known package at NPM */
var useCraftyClicks = function useCraftyClicks(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$A);
  var craftyClickJs = "".concat(getEmbedFormURL(), "static/js/crafty-clicks.js");
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    cpObj = _useState2[0],
    setCpPbj = _useState2[1];
  var streetInput = useRef(null);
  var streetTwoInput = useRef(null);
  var streetThreeInput = useRef(null);
  var cityTownRegionInput = useRef(null);
  var stateProvinceInput = useRef(null);
  var zipPostalCodeInput = useRef(null);
  var _useScript = useScript({
      url: craftyClickJs
    }),
    _useScript2 = _slicedToArray(_useScript, 1),
    scriptLoading = _useScript2[0];
  var setCollectorAddress = function setCollectorAddress() {
    var _values$collector, _values$collector$ent;
    if (values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[props === null || props === void 0 ? void 0 : props.entity]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.address[0]) {
      var _values$collector2, _values$collector2$en, _streetInput$current, _streetTwoInput$curre, _streetThreeInput$cur, _cityTownRegionInput$, _stateProvinceInput$c, _zipPostalCodeInput$c;
      var addressObj = _objectSpread2(_objectSpread2({}, values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[props === null || props === void 0 ? void 0 : props.entity]) === null || _values$collector2$en === void 0 ? void 0 : _values$collector2$en.address[0]), {}, {
        street: (streetInput === null || streetInput === void 0 ? void 0 : (_streetInput$current = streetInput.current) === null || _streetInput$current === void 0 ? void 0 : _streetInput$current.value) || '',
        streetTwo: (streetTwoInput === null || streetTwoInput === void 0 ? void 0 : (_streetTwoInput$curre = streetTwoInput.current) === null || _streetTwoInput$curre === void 0 ? void 0 : _streetTwoInput$curre.value) || '',
        streetThree: (streetThreeInput === null || streetThreeInput === void 0 ? void 0 : (_streetThreeInput$cur = streetThreeInput.current) === null || _streetThreeInput$cur === void 0 ? void 0 : _streetThreeInput$cur.value) || '',
        cityTownRegion: (cityTownRegionInput === null || cityTownRegionInput === void 0 ? void 0 : (_cityTownRegionInput$ = cityTownRegionInput.current) === null || _cityTownRegionInput$ === void 0 ? void 0 : _cityTownRegionInput$.value) || '',
        stateProvince: (stateProvinceInput === null || stateProvinceInput === void 0 ? void 0 : (_stateProvinceInput$c = stateProvinceInput.current) === null || _stateProvinceInput$c === void 0 ? void 0 : _stateProvinceInput$c.value) || '',
        zipPostalCode: (zipPostalCodeInput === null || zipPostalCodeInput === void 0 ? void 0 : (_zipPostalCodeInput$c = zipPostalCodeInput.current) === null || _zipPostalCodeInput$c === void 0 ? void 0 : _zipPostalCodeInput$c.value) || ''
      });
      setFieldValue("collector.entity[".concat(props === null || props === void 0 ? void 0 : props.entity, "].address[0]"), addressObj, false);
    }
  };
  var postalLookUpHandler = function postalLookUpHandler(e) {
    e.preventDefault();
    if (cpObj) {
      cpObj.doLookup();
    }
  };
  useEffect(function () {
    if (cpObj) {
      cpObj.set('access_token', getCraftyClicksAccessToken());
      cpObj.set('result_elem_id', "craftyPostcodeResultDisplay".concat(props === null || props === void 0 ? void 0 : props.entity).concat(props === null || props === void 0 ? void 0 : props.index));
      cpObj.set('form', '');
      cpObj.set('elem_street1', "".concat(name, ".street"));
      cpObj.set('elem_street2', "".concat(name, ".streetTwo"));
      cpObj.set('elem_street3', "".concat(name, ".streetThree"));
      cpObj.set('elem_town', "".concat(name, ".cityTownRegion"));
      cpObj.set('elem_county', "".concat(name, ".stateProvince"));
      cpObj.set('elem_postcode', "".concat(name, ".zipPostalCode"));
      cpObj.set('on_result_ready', function () {
        setCollectorAddress();
      });
      cpObj.set('on_result_selected', function () {
        setCollectorAddress();
      });
    }
  }, [cpObj]);
  useEffect(function () {
    if (!scriptLoading && window.CraftyPostcodeCreate) {
      setCpPbj(window.CraftyPostcodeCreate());
    }
  }, [scriptLoading]);
  return {
    cityTownRegionInput: cityTownRegionInput,
    stateProvinceInput: stateProvinceInput,
    streetInput: streetInput,
    streetTwoInput: streetTwoInput,
    streetThreeInput: streetThreeInput,
    zipPostalCodeInput: zipPostalCodeInput,
    postalLookUpHandler: postalLookUpHandler
  };
};

var FLOOD_CONTROLLED = 'FloodControlled';
var SUBMITTED = 'Submitted';
var UNPROCESSABLE = 'Unprocessable';
var POWER_BY_TEXT_ERROR = 'PowerByTextError';
var FORMS_TIMEOUT_ERROR = 'FormsTimeoutError';

var ResponseStatus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FLOOD_CONTROLLED: FLOOD_CONTROLLED,
  FORMS_TIMEOUT_ERROR: FORMS_TIMEOUT_ERROR,
  POWER_BY_TEXT_ERROR: POWER_BY_TEXT_ERROR,
  SUBMITTED: SUBMITTED,
  UNPROCESSABLE: UNPROCESSABLE
});

/* Logic from BGForm core/src/components/form/Submit.jsx  */
var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var isDupe = function isDupe(str) {
  var mid = str.length / 2;
  var s1 = str.substring(0, mid);
  var s2 = str.substring(mid, str.length);
  return s1.toLowerCase() === s2.toLowerCase();
};
var handleStatus = function handleStatus(response, actions) {
  var _response$data, _response$data$errors, _response$data8;
  var status = response === null || response === void 0 ? void 0 : response.status;
  var responseStatus;
  switch (status) {
    case 201:
      // Submitted
      responseStatus = SUBMITTED;
      break;
    case 429:
      // Flood Controlled
      responseStatus = FLOOD_CONTROLLED;
      break;
    case 422:
      // Unprocessable
      if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.length) > 0) {
        var _response$data2, _response$data2$error, _response$data3, _response$data3$error, _response$data3$error2, _response$data4, _response$data4$error, _response$data4$error2, _response$data5, _response$data5$error, _response$data5$error2, _response$data5$error3, _response$data5$error4, _response$data6, _response$data7;
        var message = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$error = _response$data2.errors[0]) === null || _response$data2$error === void 0 ? void 0 : _response$data2$error.message) || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$error = _response$data3.errors[0]) === null || _response$data3$error === void 0 ? void 0 : (_response$data3$error2 = _response$data3$error.error) === null || _response$data3$error2 === void 0 ? void 0 : _response$data3$error2.message) || (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$error = _response$data4.errors[0]) === null || _response$data4$error === void 0 ? void 0 : (_response$data4$error2 = _response$data4$error.data) === null || _response$data4$error2 === void 0 ? void 0 : _response$data4$error2.message) || UNPROCESSABLE;
        var responseErrorMsg = (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$error = _response$data5.errors[0]) === null || _response$data5$error === void 0 ? void 0 : (_response$data5$error2 = _response$data5$error.data) === null || _response$data5$error2 === void 0 ? void 0 : (_response$data5$error3 = _response$data5$error2.error) === null || _response$data5$error3 === void 0 ? void 0 : (_response$data5$error4 = _response$data5$error3.response) === null || _response$data5$error4 === void 0 ? void 0 : _response$data5$error4.error_message) || '';
        responseStatus = {
          component: response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.component,
          hasErrorInfo: true,
          message: "".concat(message, " ").concat(responseErrorMsg),
          status: response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.status
        };
      } else if (response !== null && response !== void 0 && (_response$data8 = response.data) !== null && _response$data8 !== void 0 && _response$data8.component) {
        var _response$data9;
        responseStatus = "".concat(capitalizeFirstLetter(response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.component)).concat(UNPROCESSABLE);
      } else {
        responseStatus = UNPROCESSABLE;
      }
      break;
    default:
      responseStatus = UNPROCESSABLE;
  }
  actions.setStatus(responseStatus);
  return responseStatus;
};
var cleanupRoles = function cleanupRoles(values) {
  var _values$collector, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2;
  if (values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && _values$collector.entity[1] && values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[1]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.orgs && (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[1]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.orgs) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.role) === '-1') {
    values.collector.entity[1].orgs.role = '';
  }
};
var cleanupEmail = function cleanupEmail(values) {
  var _values$collector4, _values$collector4$en, _values$collector4$en2, _values$collector6, _values$collector6$en, _values$collector6$en2, _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$collector$ent5, _values$collector$ent6;
  if ((values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$en = _values$collector4.entity[0]) === null || _values$collector4$en === void 0 ? void 0 : (_values$collector4$en2 = _values$collector4$en.email) === null || _values$collector4$en2 === void 0 ? void 0 : _values$collector4$en2.length) > 0) {
    var _values$collector5, _values$collector5$en;
    var email = values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : _values$collector5$en.email.filter(function (e) {
      var _e$emailSubscription;
      return (e === null || e === void 0 ? void 0 : e.emailAddress) || (e === null || e === void 0 ? void 0 : (_e$emailSubscription = e.emailSubscription) === null || _e$emailSubscription === void 0 ? void 0 : _e$emailSubscription.length) > 0;
    });
    values.collector.entity[0].email = email;
  }
  if ((values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[1]) === null || _values$collector6$en === void 0 ? void 0 : (_values$collector6$en2 = _values$collector6$en.email) === null || _values$collector6$en2 === void 0 ? void 0 : _values$collector6$en2.length) > 0) {
    var _values$collector7, _values$collector7$en;
    var _email = values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$en = _values$collector7.entity[1]) === null || _values$collector7$en === void 0 ? void 0 : _values$collector7$en.email.filter(function (e) {
      var _e$emailSubscription2;
      return (e === null || e === void 0 ? void 0 : e.emailAddress) || (e === null || e === void 0 ? void 0 : (_e$emailSubscription2 = e.emailSubscription) === null || _e$emailSubscription2 === void 0 ? void 0 : _e$emailSubscription2.length) > 0;
    });
    values.collector.entity[1].email = _email;
  }

  /* if entity 1 has no data remove it from entity array */
  if (values.collector.entity[1] && ((_values$collector$ent = values.collector.entity[1]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length) === 0 && ((_values$collector$ent3 = values.collector.entity[1].email) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.length) === 0 && values.collector.entity[1].phone[0] && (_values$collector$ent4 = values.collector.entity[1]) !== null && _values$collector$ent4 !== void 0 && _values$collector$ent4.phone[0] && !((_values$collector$ent5 = values.collector.entity[1]) !== null && _values$collector$ent5 !== void 0 && (_values$collector$ent6 = _values$collector$ent5.phone[0]) !== null && _values$collector$ent6 !== void 0 && _values$collector$ent6.phoneNumber)) {
    var _values$collector$ent7;
    (_values$collector$ent7 = values.collector.entity) === null || _values$collector$ent7 === void 0 ? void 0 : _values$collector$ent7.splice(1, 1);
  }
};
var cleanupPayload = function cleanupPayload(values) {
  var _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector10, _values$collector10$e, _values$collector10$e2, _values$collector12, _values$collector13, _values$collector13$e, _values$collector13$e2, _values$collector15, _values$collector15$a;
  if ((values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.phone) === null || _values$collector8$en2 === void 0 ? void 0 : _values$collector8$en2.length) > 0) {
    var _values$collector9, _values$collector9$en;
    var phones = values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : (_values$collector9$en = _values$collector9.entity[0]) === null || _values$collector9$en === void 0 ? void 0 : _values$collector9$en.phone.filter(function (p) {
      return (p === null || p === void 0 ? void 0 : p.phoneType) && (p === null || p === void 0 ? void 0 : p.phoneNumber);
    });
    values.collector.entity[0].phone = phones;
  }
  cleanupEmail(values);
  if ((values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$e = _values$collector10.entity[0]) === null || _values$collector10$e === void 0 ? void 0 : (_values$collector10$e2 = _values$collector10$e.social) === null || _values$collector10$e2 === void 0 ? void 0 : _values$collector10$e2.length) > 0) {
    var _values$collector11, _values$collector11$e;
    var social = values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : _values$collector11$e.social.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.socialMediaType) && (s === null || s === void 0 ? void 0 : s.handle);
    });
    values.collector.entity[0].social = social;
  }
  if (values !== null && values !== void 0 && (_values$collector12 = values.collector) !== null && _values$collector12 !== void 0 && _values$collector12.entity[1] && (values === null || values === void 0 ? void 0 : (_values$collector13 = values.collector) === null || _values$collector13 === void 0 ? void 0 : (_values$collector13$e = _values$collector13.entity[1]) === null || _values$collector13$e === void 0 ? void 0 : (_values$collector13$e2 = _values$collector13$e.address) === null || _values$collector13$e2 === void 0 ? void 0 : _values$collector13$e2.length) > 0) {
    var _values$collector14, _values$collector14$e;
    values === null || values === void 0 ? void 0 : (_values$collector14 = values.collector) === null || _values$collector14 === void 0 ? void 0 : (_values$collector14$e = _values$collector14.entity[1]) === null || _values$collector14$e === void 0 ? void 0 : _values$collector14$e.address.forEach(function (address) {
      for (var _i = 0, _Object$entries = Object.entries(address); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value === '-1') {
          address[key] = '';
        }
      }
    });
  }
  cleanupRoles(values);
  if ((values === null || values === void 0 ? void 0 : (_values$collector15 = values.collector) === null || _values$collector15 === void 0 ? void 0 : (_values$collector15$a = _values$collector15.attachments) === null || _values$collector15$a === void 0 ? void 0 : _values$collector15$a.length) > 0) {
    var _values$collector16, _values$collector16$a;
    var hasAttachments = function hasAttachments(item) {
      var _item$attachment;
      return (item === null || item === void 0 ? void 0 : (_item$attachment = item.attachment) === null || _item$attachment === void 0 ? void 0 : _item$attachment.length) > 0;
    };
    var attachments = values === null || values === void 0 ? void 0 : (_values$collector16 = values.collector) === null || _values$collector16 === void 0 ? void 0 : (_values$collector16$a = _values$collector16.attachments) === null || _values$collector16$a === void 0 ? void 0 : _values$collector16$a.filter(hasAttachments);
    if ((attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0) {
      values.collector.attachments = attachments;
    } else {
      delete values.collector.attachments;
    }
  }
};
var handleCollectorData = function handleCollectorData(values) {
  var _values$collector17;
  var duplicateList = [];
  // Trim postal codes to remove whitespace and check for duplication
  if (values !== null && values !== void 0 && (_values$collector17 = values.collector) !== null && _values$collector17 !== void 0 && _values$collector17.entity) {
    var _values$collector18, _values$collector18$e;
    values === null || values === void 0 ? void 0 : (_values$collector18 = values.collector) === null || _values$collector18 === void 0 ? void 0 : (_values$collector18$e = _values$collector18.entity) === null || _values$collector18$e === void 0 ? void 0 : _values$collector18$e.forEach(function (ent) {
      var _ent$address$, _ent$address$3, _ent$address$4, _ent$address$5, _ent$address$6, _ent$address$7, _ent$address$8, _ent$address$9, _ent$address$10;
      if (ent !== null && ent !== void 0 && ent.address && ent !== null && ent !== void 0 && (_ent$address$ = ent.address[0]) !== null && _ent$address$ !== void 0 && _ent$address$.zipPostalCode) {
        var _ent$address$2;
        ent.address[0].zipPostalCode = ent === null || ent === void 0 ? void 0 : (_ent$address$2 = ent.address[0]) === null || _ent$address$2 === void 0 ? void 0 : _ent$address$2.zipPostalCode.trim();
      }
      (ent === null || ent === void 0 ? void 0 : ent.firstName) && isDupe(ent.firstName) && duplicateList.push('firstName');
      (ent === null || ent === void 0 ? void 0 : ent.lastName) && isDupe(ent.lastName) && duplicateList.push('lastName');
      (ent === null || ent === void 0 ? void 0 : ent.address) && (ent === null || ent === void 0 ? void 0 : (_ent$address$3 = ent.address[0]) === null || _ent$address$3 === void 0 ? void 0 : _ent$address$3.street) && isDupe(ent === null || ent === void 0 ? void 0 : (_ent$address$4 = ent.address[0]) === null || _ent$address$4 === void 0 ? void 0 : _ent$address$4.street) && duplicateList.push('street');
      (ent === null || ent === void 0 ? void 0 : ent.address) && (ent === null || ent === void 0 ? void 0 : (_ent$address$5 = ent.address[0]) === null || _ent$address$5 === void 0 ? void 0 : _ent$address$5.streetTwo) && isDupe(ent === null || ent === void 0 ? void 0 : (_ent$address$6 = ent.address[0]) === null || _ent$address$6 === void 0 ? void 0 : _ent$address$6.streetTwo) && duplicateList.push('streetTwo');
      (ent === null || ent === void 0 ? void 0 : ent.address) && (ent === null || ent === void 0 ? void 0 : (_ent$address$7 = ent.address[0]) === null || _ent$address$7 === void 0 ? void 0 : _ent$address$7.cityTownRegion) && isDupe(ent === null || ent === void 0 ? void 0 : (_ent$address$8 = ent.address[0]) === null || _ent$address$8 === void 0 ? void 0 : _ent$address$8.cityTownRegion) && duplicateList.push('cityTownRegion');
      (ent === null || ent === void 0 ? void 0 : ent.address) && (ent === null || ent === void 0 ? void 0 : (_ent$address$9 = ent.address[0]) === null || _ent$address$9 === void 0 ? void 0 : _ent$address$9.zipPostalCode) && isDupe(ent === null || ent === void 0 ? void 0 : (_ent$address$10 = ent.address[0]) === null || _ent$address$10 === void 0 ? void 0 : _ent$address$10.zipPostalCode) && duplicateList.push('zipPostalCode');
      if (duplicateList.length > 0) {
        values.formLogic.hasDuplicateData = true;
        values.formLogic.duplicateList = duplicateList;
      }
    });
    cleanupPayload(values);
  }
};

/* Logic from BGForm core/src/components/form/Submit.jsx  */
var getPayload = function getPayload(val) {
  var _values$cart, _values$cart$donation, _values$collector19, _values$formLogic, _values$formLogic$par;
  var values = questionsHelper(val);
  handleCollectorData(values);
  if (values.translations) {
    delete values.translations;
  }
  if (values.submissionresponse) {
    delete values.submissionresponse;
  }
  if ((_values$cart = values.cart) !== null && _values$cart !== void 0 && (_values$cart$donation = _values$cart.donation) !== null && _values$cart$donation !== void 0 && _values$cart$donation.projects) {
    values.cart.donation.projects.forEach(function (item, index) {
      // TODO: use filter instead
      if (!Object.keys(item).length) {
        delete values.cart.donation.projects[index];
      }
    });
  }
  if (values !== null && values !== void 0 && values.formLogic.projects) {
    values === null || values === void 0 ? true : delete values.formLogic.projects;
  }
  trackEvent('bgform', {
    formCategory: (values === null || values === void 0 ? void 0 : (_values$collector19 = values.collector) === null || _values$collector19 === void 0 ? void 0 : _values$collector19.formID) || '',
    formAction: 'Submit',
    formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref) || document.location.href,
    formValue: 1
  });
  if (values !== null && values !== void 0 && values.collector) {
    var _values$formLogic2, _values$formLogic2$pa;
    values.collector.refererUrl = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pa = _values$formLogic2.parentDocumentInfo) === null || _values$formLogic2$pa === void 0 ? void 0 : _values$formLogic2$pa.documentLocationHref) || document.location.href;
    values.collector.userAgent = navigator.userAgent;
    if (values.collector.entity) {
      values.collector.entity = values.collector.entity.filter(Boolean); // Remove any undefined or null
    }
  }

  return JSON.stringify(values);
};
var useCreateFormData = function useCreateFormData() {
  var formQuery = useMutation(function (payload) {
    return apiClient.createFormData(payload);
  });
  var GENERIC_ERROR_MESSAGE = 'GENERIC_ERROR_MESSAGE';
  var createFormData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var payload, response, responseStatus, _e$response, _values$formLogic3, _values$formLogic3$pa, _e$response2, errorObj, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            actions.setSubmitting(true);
            payload = getPayload(values);
            _context.next = 5;
            return formQuery.mutateAsync(payload);
          case 5:
            response = _context.sent;
            responseStatus = handleStatus(response, actions);
            actions.setSubmitting(false);
            actions.setFieldValue('submissionresponse', response === null || response === void 0 ? void 0 : response.data, false);
            return _context.abrupt("return", {
              response: response,
              responseStatus: responseStatus
            });
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            if (_context.t0 !== null && _context.t0 !== void 0 && _context.t0.response) {
              handleStatus(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response, actions);
            }
            if (_context.t0.code === 'ECONNABORTED') {
              actions.setStatus(FORMS_TIMEOUT_ERROR);
            }

            // Set the error information in the 'submissionresponse' field
            actions.setFieldValue('submissionresponse', (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.data) || GENERIC_ERROR_MESSAGE, false);
            actions.setSubmitting(false);
            trackEvent(FORM_ERROR, {
              formCategory: values.collector.formID,
              formAction: 'Submit',
              formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$pa = _values$formLogic3.parentDocumentInfo) === null || _values$formLogic3$pa === void 0 ? void 0 : _values$formLogic3$pa.documentLocationHref) || document.location.href,
              formValue: 1
            });
            errorObj = R.path(['response', 'data', 'errors'], _context.t0);
            error = new Error((errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) || GENERIC_ERROR_MESSAGE);
            error.data = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response2 = _context.t0.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.data;
            throw error;
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function createFormData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    createFormData: createFormData
  };
};

var useCreateSubscriberPowerText = function useCreateSubscriberPowerText(_ref) {
  var key = _ref.key;
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var addSubscriberQuery = useMutation(function (emailAddress) {
    return apiClient.postAddSubscriberPowerText(key, emailAddress);
  });
  var postAddSubscriber = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var mobileNo, payload, addSubscriberResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            mobileNo = _ref2.mobileNo;
            _context.prev = 1;
            payload = {
              queryParams: {
                mobileNo: mobileNo
              }
            };
            _context.next = 5;
            return addSubscriberQuery.mutateAsync(payload);
          case 5:
            addSubscriberResponse = _context.sent;
            return _context.abrupt("return", addSubscriberResponse.data);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            logging({
              functionName: 'useCreateSubscriberPowerText.postAddSubscriber',
              error: _context.t0
            });
            return _context.abrupt("return", _context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function postAddSubscriber(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    postAddSubscriber: postAddSubscriber
  };
};

var useCreateToken = function useCreateToken() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var GENERIC_ERROR_MESSAGE = t('errors:default');
  var tokenQuery = useMutation(function (action) {
    return apiClient.createToken(action);
  });
  var createToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var action,
        tokenResponse,
        errorTypeEq,
        isInvalidRequest,
        errorMessage,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            action = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'create';
            _context.prev = 1;
            _context.next = 4;
            return tokenQuery.mutateAsync(action);
          case 4:
            tokenResponse = _context.sent;
            return _context.abrupt("return", tokenResponse.data.key);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            errorTypeEq = R.pathEq(['response', 'data', 'error', 'type']);
            isInvalidRequest = errorTypeEq('INVALID_REQUEST_ERROR', _context.t0);
            if (isInvalidRequest) {
              errorMessage = R.path(['response', 'data', 'error', 'message'], _context.t0);
            } else {
              errorMessage = _context.t0.message;
            }
            throw new Error(errorMessage || GENERIC_ERROR_MESSAGE);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function createToken() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    createToken: createToken
  };
};

var useCreateUpgradeDonation = function useCreateUpgradeDonation() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var GENERIC_ERROR_MESSAGE = t('errors:default');
  var formQuery = useMutation(function (payload) {
    return apiClient.createFormData(payload);
  });
  var createUpgradeDonation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      var errorTypeEq, isInvalidRequest, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return formQuery.mutateAsync(payload);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            errorTypeEq = R.pathEq(['response', 'data', 'error', 'type']);
            isInvalidRequest = errorTypeEq('INVALID_REQUEST_ERROR', _context.t0);
            if (isInvalidRequest) {
              errorMessage = R.path(['response', 'data', 'error', 'message'], _context.t0);
            } else {
              errorMessage = _context.t0.message;
            }
            throw new Error(errorMessage || GENERIC_ERROR_MESSAGE);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function createUpgradeDonation(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    createUpgradeDonation: createUpgradeDonation
  };
};

var useCreateUserFile = function useCreateUserFile(_ref) {
  var key = _ref.key,
    _ref$templateName = _ref.templateName,
    templateName = _ref$templateName === void 0 ? 'userFile' : _ref$templateName;
  var fileUploadQuery = useMutation(function (payload) {
    return apiClient.uploadUserFile(key, payload);
  });
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var uploadFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(files, sessionId) {
      var site,
        payload,
        fileUploadResponse,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            site = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'billygraham.org';
            _context.prev = 1;
            payload = {
              site: site,
              files: files,
              formId: templateName,
              sessionId: sessionId
            };
            payload.files = Object.assign.apply(Object, [{}].concat(_toConsumableArray(payload.files)));
            _context.next = 6;
            return fileUploadQuery.mutateAsync(payload);
          case 6:
            fileUploadResponse = _context.sent;
            return _context.abrupt("return", fileUploadResponse.data);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            logging({
              functionName: 'useCreateUserFile.uploadFile',
              error: _context.t0
            });
            throw new Error(_context.t0.message);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function uploadFile(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    uploadFile: uploadFile
  };
};

var _excluded$z = ["name", "required", "validate"];
var MIN_CURRENCY_VALUE = 5;
var useCurrency = function useCurrency(_ref) {
  var name = _ref.name,
    required = _ref.required,
    validate = _ref.validate,
    props = _objectWithoutProperties(_ref, _excluded$z);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values,
    setFieldTouched = _useFormikContext.setFieldTouched,
    handleChange = _useFormikContext.handleChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var minCurrencyValue = (props === null || props === void 0 ? void 0 : props.minCurrencyValue) || MIN_CURRENCY_VALUE;
  var validateMemo = useMemo(function () {
    return validate || validateCurrency(required, minCurrencyValue);
  }, [validate, required, minCurrencyValue]);
  var handleOnFocus = function handleOnFocus() {
    return setIsEditing(true);
  };
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
      e.preventDefault();
    }
  };
  var thisValueNow = deepFind(values, name);
  var shouldFormatCurrency = deepFind(values, 'formLogic.shouldFormatCurrency');
  // Sets the currency to the return value of formatCurrency and increments the count state
  var onBlurFormatValue = function onBlurFormatValue(event) {
    var currentValue = event.target.value || '';
    if (currentValue) {
      setFieldValue(name, +formatCurrency(currentValue, minCurrencyValue));
      setFieldTouched(name, true);
    }
  };
  var formattedValue = shouldFormatCurrency && thisValueNow && (thisValueNow === null || thisValueNow === void 0 ? void 0 : thisValueNow.toFixed(2)) || thisValueNow;
  var currencyValue = shouldFormatCurrency && isEditing ? thisValueNow : formattedValue;
  var isReadOnly = !isEditing;
  return {
    currencyValue: currencyValue,
    isReadOnly: isReadOnly,
    handleChange: handleChange,
    handleOnFocus: handleOnFocus,
    handleOnKeyDown: handleOnKeyDown,
    onBlurFormatValue: onBlurFormatValue,
    setIsEditing: setIsEditing,
    validateMemo: validateMemo
  };
};

var useDateCalendar = function useDateCalendar(_ref) {
  var dateStart = _ref.dateStart,
    name = _ref.name,
    required = _ref.required;
  var _useState = useState(dateStart),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    errorState = _useState6[0],
    setErrorState = _useState6[1];
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    isSubmitting = _useFormikContext.isSubmitting;

  // eslint-disable-next-line consistent-return
  var validate = function validate(value) {
    if (required && !value) {
      return "Required";
    }
  };
  var handleOnBlur = function handleOnBlur() {
    var error = validate(startDate);
    if (error) {
      setErrorState(true);
      setErrorMessage(error);
    } else {
      setErrorState(false);
      setErrorMessage('');
    }
  };
  var handleOnChange = function handleOnChange(date) {
    setStartDate(date);
    setFieldValue(name, date);
  };
  useEffect(function () {
    if (isSubmitting) {
      handleOnBlur();
    }
  }, [isSubmitting]);
  return {
    errorState: errorState,
    errorMessage: errorMessage,
    handleOnBlur: handleOnBlur,
    handleOnChange: handleOnChange,
    startDate: startDate,
    validate: validate
  };
};

var useDonationCart = function useDonationCart(_ref) {
  var _values$collector, _values$formLogic, _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$formLogic2, _values$formLogic2$br, _values$formLogic2$br2, _values$formLogic2$br3, _values$formLogic3, _values$formLogic4, _values$formLogic5, _values$formLogic6, _values$collector3, _values$collector3$ca, _values$collector3$ca2, _values$collector4, _values$collector4$ca, _values$collector4$ca2, _values$formLogic7;
  var projectId = _ref.projectId,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? {
      amount: 5,
      projectId: projectId,
      initialChargeProcessed: true
    } : _ref$defaultValue,
    _ref$defaultRecurring = _ref.defaultRecurringValue,
    defaultRecurringValue = _ref$defaultRecurring === void 0 ? {
      amount: 5,
      projectId: projectId,
      initialChargeProcessed: true,
      recurringDate: ''
    } : _ref$defaultRecurring;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    validateForm = _useFormikContext.validateForm;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    nextDonationCount = _useState2[0],
    setNextDonationCount = _useState2[1];
  var cart = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.cart;
  var isPledge = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.pledge;
  var subTotal = values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : (_values$collector2$ca2 = _values$collector2$ca.cartTotals) === null || _values$collector2$ca2 === void 0 ? void 0 : _values$collector2$ca2.subTotal;
  var itemName = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$br = _values$formLogic2.brbInfo) === null || _values$formLogic2$br === void 0 ? void 0 : (_values$formLogic2$br2 = _values$formLogic2$br.campaign) === null || _values$formLogic2$br2 === void 0 ? void 0 : (_values$formLogic2$br3 = _values$formLogic2$br2.item) === null || _values$formLogic2$br3 === void 0 ? void 0 : _values$formLogic2$br3.itemName;
  var itemizedDonations = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.itemizedDonations;
  var recurringDonations = values.formLogic.recurringDonations;
  var recurringDate = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.recurringDate;
  var showKeyPad = values.formLogic.activeMethod === 'CC';
  var showChecking = values.formLogic.activeMethod === 'EFT';
  var recurringGiftDate = recurringDate ? ordinalSuffix(parseInt(recurringDate === null || recurringDate === void 0 ? void 0 : recurringDate.split('-')[2], 10)) : 0;
  var recurringTotal = getRecurringTotal(cart);
  defaultValue.orgGift = values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.orgGift;
  defaultRecurringValue.orgGift = values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.orgGift;
  defaultRecurringValue.recurringDate = recurringDate;
  // use values to set projects options
  var projectOptions = getProjectOptions(projectId, values);
  if (values !== null && values !== void 0 && (_values$collector3 = values.collector) !== null && _values$collector3 !== void 0 && (_values$collector3$ca = _values$collector3.cart) !== null && _values$collector3$ca !== void 0 && (_values$collector3$ca2 = _values$collector3$ca.donation) !== null && _values$collector3$ca2 !== void 0 && _values$collector3$ca2.projects[0]) {
    var _values$collector$car;
    defaultValue.projectId = (_values$collector$car = values.collector.cart.donation.projects[0]) === null || _values$collector$car === void 0 ? void 0 : _values$collector$car.projectId;
  }
  var availableDateOptions = getAvailableDateOptions(values);
  if (!recurringDonations) {
    setFieldValue("formLogic.recurringDonations", []);
  }
  var getGiftName = function getGiftName(index) {
    if (recurringDonations && recurringDonations[index]) {
      return jsxs("span", {
        children: ["Gift Amount | ", jsx("p", {
          className: "tag",
          children: "Recurring"
        })]
      });
    }
    if (itemizedDonations && itemizedDonations[index] === 1) {
      return jsx("p", {
        className: "tag",
        children: "Meals"
      });
    }
    return jsxs("span", {
      children: ["Gift Amount | ", jsx("p", {
        className: "tag",
        children: "One-Time"
      })]
    });
  };
  var handleOneTimeGift = function handleOneTimeGift() {
    return setFieldValue("formLogic.itemizedDonations[".concat(nextDonationCount || 0, "]"), 0);
  };
  var handleRecurringPayment = function handleRecurringPayment() {
    return setFieldValue("formLogic.recurringDonations[".concat(nextDonationCount || 0, "]"), 1);
  };
  var handleDelete = function handleDelete(index) {
    handleDeleteItem(index, nextDonationCount, values, setNextDonationCount);
  };
  useEffect(function () {
    if (recurringDonations) {
      setNextDonationCount(recurringDonations.length);
    }
  }, [recurringDonations]);
  useEffect(function () {
    if (itemizedDonations) {
      setNextDonationCount(values.formLogic.itemizedDonations.length);
    }
  }, [itemizedDonations]);
  useEffect(function () {
    handleOrgGift(values, setFieldValue);
  }, [values.formLogic.orgGift]);
  useEffect(function () {
    handleSubTotal(cart, setFieldValue);
  }, [cart, values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$ca = _values$collector4.cart) === null || _values$collector4$ca === void 0 ? void 0 : (_values$collector4$ca2 = _values$collector4$ca.cartTotals) === null || _values$collector4$ca2 === void 0 ? void 0 : _values$collector4$ca2.subTotal]);
  useEffect(function () {
    if (!isPledge && cart) {
      delete values.collector.cart.pledge;
      setFieldValue("collector.cart.donation.projects", []);
    }
  }, [isPledge]);
  useEffect(function () {
    handleRecurringDateLogic(values, setFieldValue);
  }, [recurringDate]);
  useEffect(function () {
    setFieldValue('formLogic.recurringDate', '');
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.activeMethod]);
  useEffect(function () {
    validateForm();
  }, [values.formLogic.itemCalculator]);
  return {
    availableDateOptions: availableDateOptions,
    defaultRecurringValue: defaultRecurringValue,
    defaultValue: defaultValue,
    itemizedDonations: itemizedDonations,
    itemName: itemName,
    values: values,
    getGiftName: getGiftName,
    projectOptions: projectOptions,
    recurringDate: recurringDate,
    recurringDonations: recurringDonations,
    recurringGiftDate: recurringGiftDate,
    recurringTotal: recurringTotal,
    showChecking: showChecking,
    showKeyPad: showKeyPad,
    subTotal: subTotal,
    handleDelete: handleDelete,
    handleOneTimeGift: handleOneTimeGift,
    handleRecurringPayment: handleRecurringPayment
  };
};

var _excluded$y = ["entity", "index", "name", "nbLatency", "required"];
var useEmail = function useEmail(_ref) {
  var entity = _ref.entity,
    index = _ref.index,
    name = _ref.name,
    _ref$nbLatency = _ref.nbLatency,
    nbLatency = _ref$nbLatency === void 0 ? 1700 : _ref$nbLatency,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded$y);
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched,
    values = _useFormikContext.values,
    setFieldTouched = _useFormikContext.setFieldTouched,
    setFieldValue = _useFormikContext.setFieldValue;
  var emailErrors = errors;
  var touchedObj = touched;
  var hasEmailErrors = deepFind(emailErrors, name);
  var hasEmailTouched = deepFind(touchedObj, name);
  var valueObj = values;
  var paypal = deepFind(valueObj, 'payment.paypal');
  var translations = deepFind(valueObj, 'translations');
  var emailAddress = deepFind(valueObj, name);
  var emailValue = useDebounce(emailAddress, nbLatency);
  var token = deepFind(valueObj, 'formLogic.token') || '';
  var emailVerifyHandler = usePostEmailVerify({
    key: token
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    isValidEmailAddress = _useState4[0],
    setIsValidEmailAddress = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var translationEmailLabel = translations === null || translations === void 0 ? void 0 : translations.emailLabel;
  var emailLabel = translationEmailLabel || t(['Email Address'], {
    ns: 'labels'
  });
  var validEmailLabel = translations === null || translations === void 0 ? void 0 : translations.validEmailAddress;
  var invalidEmailLabel = translations === null || translations === void 0 ? void 0 : translations.invalidEmail;
  var handleEmailAddress = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(email) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setIsValidEmailAddress(null);
            setIsLoading(true);
            _context.next = 5;
            return emailVerifyHandler.postEmailVerify(email);
          case 5:
            response = _context.sent;
            setIsLoading(false);
            if ((response === null || response === void 0 ? void 0 : response.emailValid) === false) {
              setIsValidEmailAddress(false);
              setFieldValue('formLogic.isValidEmailAddress', false, false);
              setErrorMessage(invalidEmailLabel);
            } else if ((response === null || response === void 0 ? void 0 : response.emailValid) === true) {
              setIsValidEmailAddress(true);
              setFieldValue('formLogic.isValidEmailAddress', true, false);
              setErrorMessage('');
              setTimeout(function () {
                setIsValidEmailAddress(null);
              }, 3000);
            } else {
              setErrorMessage('');
              setFieldValue('formLogic.isValidEmailAddress', true, false);
              setTimeout(function () {
                setIsValidEmailAddress(null);
              }, 3000);
            }
            setFieldTouched(name, true);
            _context.next = 16;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            /* track error? */
            setIsLoading(false);
            setIsValidEmailAddress(null);
            setErrorMessage('');
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function handleEmailAddress(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var validate = function validate(value) {
    return validateEmail(isValidEmailAddress, paypal, required, translations, value);
  };
  useEffect(function () {
    if (emailValue) {
      handleEmailAddress(emailValue);
    }
  }, [emailValue]);
  useEffect(function () {
    setFieldValue("collector.entity[".concat(entity, "].email[").concat(index, "].emailType"), (props === null || props === void 0 ? void 0 : props.emailType) || EmailType.Home);
  }, []);
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
      e.preventDefault();
    }
  };
  var inputClass = 'input';
  if (isValidEmailAddress) {
    inputClass += ' is-success';
  } else if (isValidEmailAddress === false || hasEmailTouched && hasEmailErrors) {
    inputClass += ' is-danger';
  }
  return {
    emailLabel: emailLabel,
    errorMessage: errorMessage,
    hasEmailErrors: hasEmailErrors,
    handleOnKeyDown: handleOnKeyDown,
    inputClass: inputClass,
    isLoading: isLoading,
    isValidEmailAddress: isValidEmailAddress,
    validEmailLabel: validEmailLabel,
    values: values,
    validate: validate
  };
};

var useEmailList = function useEmailList() {
  return useQuery(['emailList'], function () {
    return apiClient.getEmailList();
  }, {
    select: R.prop('data')
  });
};

var _excluded$x = ["entity", "entityType", "isPrimary", "phoneRequired"];
var useEntity = function useEntity(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    entityType = _ref.entityType,
    isPrimary = _ref.isPrimary;
    _ref.phoneRequired;
    var props = _objectWithoutProperties(_ref, _excluded$x);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var valueObj = values;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var organizationNameLabel = t('Organization Name', {
    ns: 'labels'
  });
  var roleLabel = t('What is your role?', {
    ns: 'labels'
  });
  var translations = deepFind(valueObj, 'translations');
  var phoneLabel = (translations === null || translations === void 0 ? void 0 : translations.phoneLabel) || t(['Phone Number'], {
    ns: 'labels'
  });
  var mobilePhoneLabel = (translations === null || translations === void 0 ? void 0 : translations.mobilePhoneLabel) || t('Mobile Phone Number', {
    ns: 'labels'
  });
  useEffect(function () {
    var _props$relationshipPa, _props$relationshipTy;
    setFieldValue("collector.entity[".concat(entity, "].entityType"), entityType);
    setFieldValue("collector.entity[".concat(entity, "].isPrimary"), isPrimary);
    if ((props === null || props === void 0 ? void 0 : (_props$relationshipPa = props.relationshipPath) === null || _props$relationshipPa === void 0 ? void 0 : _props$relationshipPa.length) > 0 && (props === null || props === void 0 ? void 0 : (_props$relationshipTy = props.relationshipType) === null || _props$relationshipTy === void 0 ? void 0 : _props$relationshipTy.length) > 0) {
      setFieldValue("collector.entity[".concat(entity, "].entityRelationship"), [{
        path: props === null || props === void 0 ? void 0 : props.relationshipPath,
        relationshipType: props === null || props === void 0 ? void 0 : props.relationshipType
      }]);
    }
  }, []);
  return {
    mobilePhoneLabel: mobilePhoneLabel,
    organizationNameLabel: organizationNameLabel,
    phoneLabel: phoneLabel,
    roleLabel: roleLabel,
    values: values
  };
};

var EthiopiaSubCity = [{
  id: '',
  value: 'አንድ ምረጥ'
}, {
  id: 'Addis Ketema',
  value: 'አዲስ ከተማ'
}, {
  id: 'Akaki Kality',
  value: 'አቃቂ ቃሊቲ'
}, {
  id: 'Arada',
  value: 'አራዳ'
}, {
  id: 'Bole',
  value: 'ቦሌ'
}, {
  id: 'Gulele',
  value: 'ጉለሌ'
}, {
  id: 'Kirkos',
  value: 'ቂርቆስ'
}, {
  id: 'Kolfe',
  value: 'ኮልፌ'
}, {
  id: 'Lemi Kura',
  value: 'ለሚ ኩራ'
}, {
  id: 'Lideta',
  value: 'ልደታ'
}, {
  id: 'Nifasilk Lafto',
  value: 'ንፋስ ስልክ'
}, {
  id: 'Yeka',
  value: 'የካ'
}, {
  id: 'Burrayyuu',
  value: 'ቡራዩ'
}, {
  id: 'Furii',
  value: 'ፉሪ'
}, {
  id: 'Gafarsaa Gujee',
  value: 'ገፈርሳ ጉጂ'
}, {
  id: 'Galaan',
  value: 'ገላን'
}, {
  id: 'Galaan Guddaa',
  value: 'ገላን ጉዳ'
}, {
  id: 'Koyyee Faccee',
  value: 'ኮዬ ፈጬ'
}, {
  id: 'Kura Jiddaa',
  value: 'ኩራ ጂዳ'
}, {
  id: 'Laga Xafoo',
  value: 'ለገ ጣፎ'
}, {
  id: 'Malka Noonnoo',
  value: 'መልካ ኖኖ'
}, {
  id: 'Mana Abbichuu',
  value: 'መና አቢቹ'
}, {
  id: 'Sabbataa',
  value: 'ሰበታ'
}, {
  id: 'Sulultaa',
  value: 'ሱሉልታ'
}];

var EthiopiaSubCityEnglish = [{
  id: '',
  value: 'Select One'
}, {
  id: 'Addis Ketema',
  value: 'Addis Ketema'
}, {
  id: 'Akaki Kality',
  value: 'Akaki Kality'
}, {
  id: 'Arada',
  value: 'Arada'
}, {
  id: 'Bole',
  value: 'Bole'
}, {
  id: 'Gulele',
  value: 'Gulele'
}, {
  id: 'Kirkos',
  value: 'Kirkos'
}, {
  id: 'Kolfe',
  value: 'Kolfe'
}, {
  id: 'Lemi Kura',
  value: 'Lemi Kura'
}, {
  id: 'Lideta',
  value: 'Lideta'
}, {
  id: 'Nifasilk Lafto',
  value: 'Nifasilk Lafto'
}, {
  id: 'Yeka',
  value: 'Yeka'
}, {
  id: 'Burrayyuu',
  value: 'Burrayyuu'
}, {
  id: 'Furii',
  value: 'Furii'
}, {
  id: 'Gafarsaa Gujee',
  value: 'Gafarsaa Gujee'
}, {
  id: 'Galaan',
  value: 'Galaan'
}, {
  id: 'Galaan Guddaa',
  value: 'Galaan Guddaa'
}, {
  id: 'Koyyee Faccee',
  value: 'Koyyee Faccee'
}, {
  id: 'Kura Jiddaa',
  value: 'Kura Jiddaa'
}, {
  id: 'Laga Xafoo',
  value: 'Laga Xafoo'
}, {
  id: 'Malka Noonnoo',
  value: 'Malka Noonnoo'
}, {
  id: 'Mana Abbichuu',
  value: 'Mana Abbichuu'
}, {
  id: 'Sabbataa',
  value: 'Sabbataa'
}, {
  id: 'Sulultaa',
  value: 'Sulultaa'
}];

var useEthiopiaAddress = function useEthiopiaAddress() {
  var _values$formLogic;
  var _useState = useState(EthiopiaSubCity),
    _useState2 = _slicedToArray(_useState, 2),
    cities = _useState2[0],
    setCities = _useState2[1];
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var language = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.language;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var districtLabel = translations === null || translations === void 0 ? void 0 : translations.districtLabel;
  var subCityLabel = translations === null || translations === void 0 ? void 0 : translations.subCityLabel;
  useEffect(function () {
    if (language !== Language.AMH) {
      setCities(EthiopiaSubCityEnglish);
    }
  }, [language]);
  return {
    cities: cities,
    districtLabel: districtLabel,
    subCityLabel: subCityLabel
  };
};

var INVALID_SESSION = 'Invalid or Expired Session Token';

var useDeleteUserFile = function useDeleteUserFile(_ref) {
  var key = _ref.key,
    _ref$templateName = _ref.templateName,
    templateName = _ref$templateName === void 0 ? 'userFile' : _ref$templateName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var GENERIC_ERROR_MESSAGE = t('errors:default');
  var fileDeleteQuery = useMutation(function (payload) {
    return apiClient.deleteUserFile(key, payload);
  });
  var deleteFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
      var site,
        payload,
        fileUploadResponse,
        errorTypeEq,
        isInvalidRequest,
        errorMessage,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            site = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'billygraham.org';
            _context.prev = 1;
            payload = {
              site: site,
              file: file,
              formId: templateName
            };
            _context.next = 5;
            return fileDeleteQuery.mutateAsync(payload);
          case 5:
            fileUploadResponse = _context.sent;
            return _context.abrupt("return", fileUploadResponse.data);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            errorTypeEq = R.pathEq(['response', 'data', 'error', 'type']);
            isInvalidRequest = errorTypeEq('INVALID_REQUEST_ERROR', _context.t0);
            if (isInvalidRequest) {
              errorMessage = R.path(['response', 'data', 'error', 'message'], _context.t0);
            } else {
              errorMessage = _context.t0.message;
            }
            throw new Error(errorMessage || GENERIC_ERROR_MESSAGE);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function deleteFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    deleteFile: deleteFile
  };
};

var useGetSession = function useGetSession() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    token = _useState2[0],
    setToken = _useState2[1];
  var tokenHandler = useCreateToken();
  var getToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var action,
        session,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            action = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'create';
            _context.prev = 1;
            _context.next = 4;
            return tokenHandler.createToken(action);
          case 4:
            session = _context.sent;
            setToken(session);
            return _context.abrupt("return", session);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function getToken() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (token) {
      setFieldValue('formLogic.token', token, false);
    }
  }, [token]);
  useEffect(function () {
    if (!token) {
      getToken();
    }
  }, []);
  return {
    values: values,
    getToken: getToken
  };
};

var MAXIMUM_FILE_SIZE_IN_MB = 250;
var VALID_IMAGE_FILES = ['gif', 'jpg', 'jpeg', 'png'];
var VALID_IMAGE_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
var useFileUpload = function useFileUpload(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic$fil, _values$formLogic3;
  var acceptFileTypes = _ref.acceptFileTypes,
    label = _ref.label,
    name = _ref.name;
  var _useGetSession = useGetSession(),
    getToken = _useGetSession.getToken;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var templateName = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.templateName;
  var token = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.token) || '';
  var validFileTypes = acceptFileTypes.replaceAll(' ', '').split(',');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFileUploading = _useState2[0],
    setIsFileUploading = _useState2[1];
  var _useState3 = useState(token),
    _useState4 = _slicedToArray(_useState3, 2),
    session = _useState4[0],
    setSession = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDelete = _useState6[0],
    setIsDelete = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    files = _useState10[0],
    setFiles = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    filesToUpload = _useState12[0],
    setFilesToUpload = _useState12[1];
  var fileUploadMap = (_values$formLogic$fil = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.fileUploadMap) !== null && _values$formLogic$fil !== void 0 ? _values$formLogic$fil : {};
  var fileUploadHandler = useCreateUserFile({
    key: session,
    templateName: templateName
  });
  var fileDeleteHandler = useDeleteUserFile({
    key: session,
    templateName: templateName
  });
  var isValidFileSize = function isValidFileSize(file) {
    return file.size / 1024 / 1024 < MAXIMUM_FILE_SIZE_IN_MB;
  };
  var isValidFileType = function isValidFileType(fileType) {
    return [].concat(_toConsumableArray(validFileTypes), VALID_IMAGE_FILE_TYPES).some(function (element) {
      return element.includes(fileType);
    });
  };
  var hasValidFileTypes = function hasValidFileTypes(selectedFiles) {
    return selectedFiles.some(function (file) {
      return isValidFileType(file.type);
    });
  };
  var isValidFileImage = function isValidFileImage(filename) {
    var extIndex = filename.lastIndexOf('.');
    var fileExtension = filename.substring(extIndex + 1);
    return VALID_IMAGE_FILES.includes(fileExtension);
  };
  var validateFiles = function validateFiles(selectedFiles) {
    if (selectedFiles.length > 0) {
      selectedFiles.forEach(function (file) {
        if (!isValidFileSize(file) || !hasValidFileTypes(selectedFiles)) {
          throw new Error("The file must be PNG, JPEG or PDF, and no more than ".concat(MAXIMUM_FILE_SIZE_IN_MB, "mb."));
        }
      });
    }
  };
  var handleUpload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(selectedFiles, sessionId) {
      var uploadFiles, uploadedFiles, fileList;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            uploadFiles = selectedFiles || filesToUpload;
            _context.next = 4;
            return fileUploadHandler.uploadFile(uploadFiles, sessionId);
          case 4:
            uploadedFiles = _context.sent;
            fileList = uploadedFiles.files.map(function (item, index) {
              return {
                fileName: item,
                url: uploadedFiles.urls[index]
              };
            });
            setIsFileUploading(false);
            setFiles(function (prevState) {
              return [].concat(_toConsumableArray(prevState), _toConsumableArray(fileList));
            });
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            setError(_context.t0.message);
            setIsFileUploading(false);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function handleUpload(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleFileUpload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(selectedFiles) {
      var sessionId;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsFileUploading(true);
            setError(null);
            setIsDelete(false);
            sessionId = '';
            _context2.prev = 4;
            if (session) {
              _context2.next = 10;
              break;
            }
            _context2.next = 8;
            return getToken();
          case 8:
            sessionId = _context2.sent;
            setSession(sessionId);
          case 10:
            handleUpload(selectedFiles, sessionId);
            _context2.next = 25;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](4);
            if (!(_context2.t0.message === INVALID_SESSION)) {
              _context2.next = 23;
              break;
            }
            _context2.next = 18;
            return getToken();
          case 18:
            sessionId = _context2.sent;
            setSession(sessionId);
            handleUpload(selectedFiles, sessionId);
            _context2.next = 25;
            break;
          case 23:
            setError(_context2.t0.message);
            setIsFileUploading(false);
          case 25:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 13]]);
    }));
    return function handleFileUpload(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleDeleteFile = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(fileName) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fileDeleteHandler.deleteFile(fileName);
          case 3:
            _context3.next = 9;
            break;
          case 5:
            _context3.prev = 5;
            _context3.t0 = _context3["catch"](0);
            setError(_context3.t0.message);
            setIsFileUploading(false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 5]]);
    }));
    return function handleDeleteFile(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleChange = function handleChange(event) {
    var fileList = _toConsumableArray(event.target.files);
    try {
      validateFiles(fileList);
      var promiseArr = fileList.map(function (file) {
        return convertToBase64(file).then(function (fBase64) {
          var base64Arr = fBase64.split('base64,');
          var fileBase64 = base64Arr[1];
          var selectedFile = file;
          return _defineProperty({}, selectedFile.name, "".concat(selectedFile.type, ",").concat(fileBase64));
        });
      });
      Promise.all(promiseArr).then(function (selectedFiles) {
        setFilesToUpload(selectedFiles);
        handleFileUpload(selectedFiles);
      });
    } catch (err) {
      /* track error? */
      setError(err.message);
    }
  };
  var handleRemoveFile = function handleRemoveFile(fileName) {
    return function () {
      handleDeleteFile(fileName);
      setFiles(files.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.fileName) !== fileName;
      }));
      setIsDelete(true);
    };
  };
  useEffect(function () {
    setFieldValue(name, {
      attachment: files,
      label: label
    });
  }, [files]);
  useEffect(function () {
    var _Object$keys;
    if (((_Object$keys = Object.keys(fileUploadMap)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
      var attachments = Object.values(fileUploadMap);
      setFieldValue("collector.attachments", attachments, false);
    }
  }, [fileUploadMap]);
  return {
    error: error,
    files: files,
    isDelete: isDelete,
    handleChange: handleChange,
    handleRemoveFile: handleRemoveFile,
    isFileUploading: isFileUploading,
    isValidFileImage: isValidFileImage,
    values: values
  };
};

var addressObj = {
  addressType: AddressType.Mail,
  country: 'US',
  stateProvince: '',
  cityTownRegion: '',
  zipPostalCode: '',
  streetTwo: '',
  street: ''
};
var address = [addressObj];
var InitValues = {
  collector: {
    dataVersion: '1.1',
    entity: [{
      entityType: EntityType.I,
      isPrimary: true,
      firstName: '',
      lastName: '',
      address: address,
      email: [{
        emailAddress: ''
      }],
      phone: [{
        phoneNumber: ''
      }],
      over18: true
    }],
    cart: {
      donation: {
        projects: []
      },
      cartTotals: {
        taxAmount: 0,
        subTotal: 0,
        shippingTotal: 0
      }
    },
    SESourceCode: '',
    destination: 2,
    formID: ''
  },
  formLogic: {}
};

var InitValues$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InitValues: InitValues
});

var captchaV3ErrorMsg = ['Unable to validate recaptcha V3', 'Missing recaptcha data in payload'];

var _excluded$w = ["isSubmitting", "ref", "useRecaptcha", "setSubmitting"];
var useForm = function useForm(_ref) {
  var _Object$keys, _values$formLogic, _values$formLogic3;
  var isSubmitting = _ref.isSubmitting,
    ref = _ref.ref,
    _ref$useRecaptcha = _ref.useRecaptcha,
    useRecaptcha = _ref$useRecaptcha === void 0 ? true : _ref$useRecaptcha,
    setSubmitting = _ref.setSubmitting,
    props = _objectWithoutProperties(_ref, _excluded$w);
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    status = _useFormikContext.status,
    values = _useFormikContext.values;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    noOfVerifications = _useState2[0],
    setNoOfVerifications = _useState2[1];
  var formHandler = useCreateFormData();
  var _useGoogleReCaptcha = useGoogleReCaptcha$1(),
    executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;
  var _useGoogleRecaptcha = useGoogleReCaptcha(),
    logPayload = _useGoogleRecaptcha.logPayload,
    logging = _useGoogleRecaptcha.logging,
    setRecaptchaError = _useGoogleRecaptcha.setRecaptchaError;
  var hasErrors = ((_Object$keys = Object.keys(errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var isRecaptchaEnable = !isDisableRecaptcha({
    values: values
  });
  var formSubmittingOpacity = (props === null || props === void 0 ? void 0 : props.formSubmittingOpacity) || 0.5;
  var key = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.token) || '';
  var createSubscriber = useCreateSubscriberPowerText({
    key: key
  });
  var _usePowerByText = usePowerByText(),
    handleResponse = _usePowerByText.handleResponse;
  var addSubscriber = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", createSubscriber.postAddSubscriber(payload));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addSubscriber(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var errorStatus = {
    BluefinIframeFailure: true,
    BluefinIframeInvalid: true,
    FloodControlled: true,
    SchemaUnprocessable: true,
    VogonUnprocessable: true,
    LogicUnprocessable: true,
    OnlineTrainingUnprocessable: true,
    PaymentUnprocessable: true,
    Unprocessable: true
  };
  var handleReCaptchaVerify = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!(navigator.userAgent === 'bot')) {
              _context2.next = 5;
              break;
            }
            _context2.t0 = 'invalid-token-for-testing';
            _context2.next = 8;
            break;
          case 5:
            _context2.next = 7;
            return executeRecaptcha('submit');
          case 7:
            _context2.t0 = _context2.sent;
          case 8:
            return _context2.abrupt("return", _context2.t0);
          case 11:
            _context2.prev = 11;
            _context2.t1 = _context2["catch"](0);
            logging({
              functionName: 'useForm.handleReCaptchaVerify',
              error: _context2.t1,
              description: 'Error executing reCAPTCHA',
              logPayload: logPayload
            });
            setRecaptchaError();
            return _context2.abrupt("return", false);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 11]]);
    }));
    return function handleReCaptchaVerify() {
      return _ref3.apply(this, arguments);
    };
  }();
  var logError = function logError(error, info) {
    logging({
      functionName: 'useForm.logError',
      error: error,
      description: "React Errors componentStack: ".concat(info === null || info === void 0 ? void 0 : info.componentStack)
    });
  };
  var submitFormData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(actions, valueObj, setSubmittingForm) {
      var token;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return handleReCaptchaVerify();
          case 2:
            token = _context3.sent;
            if (!token) {
              _context3.next = 9;
              break;
            }
            valueObj.recaptcha = {
              id: token,
              type: 'v3'
            };
            setNoOfVerifications(function (noOfVerify) {
              return noOfVerify + 1;
            });
            _context3.next = 8;
            return formHandler.createFormData(valueObj, actions);
          case 8:
            setSubmittingForm(false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function submitFormData(_x2, _x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
  var onSubmitForm = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(valueObj, actions, setSubmittingForm) {
      var _valueObj$formLogic, _valueObj$echo, _valueObj$echo2, phoneNumber, response, _error$data, _error$data$errors$, _error$data$errors$$m, _error$data2, _error$data2$errors$, errMessage;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            if (!(valueObj !== null && valueObj !== void 0 && (_valueObj$formLogic = valueObj.formLogic) !== null && _valueObj$formLogic !== void 0 && _valueObj$formLogic.usePowerTextApi && valueObj !== null && valueObj !== void 0 && (_valueObj$echo = valueObj.echo) !== null && _valueObj$echo !== void 0 && _valueObj$echo.phone)) {
              _context4.next = 12;
              break;
            }
            phoneNumber = valueObj === null || valueObj === void 0 ? void 0 : (_valueObj$echo2 = valueObj.echo) === null || _valueObj$echo2 === void 0 ? void 0 : _valueObj$echo2.phone;
            _context4.next = 5;
            return addSubscriber({
              mobileNo: phoneNumber
            });
          case 5:
            response = _context4.sent;
            _context4.next = 8;
            return handleResponse(actions, response, phoneNumber);
          case 8:
            actions.setSubmitting(false);
            setSubmittingForm(false);
            _context4.next = 26;
            break;
          case 12:
            if (!(isRecaptchaEnable && useRecaptcha && executeRecaptcha)) {
              _context4.next = 17;
              break;
            }
            _context4.next = 15;
            return submitFormData(actions, valueObj, setSubmittingForm);
          case 15:
            _context4.next = 26;
            break;
          case 17:
            if (isRecaptchaEnable) {
              _context4.next = 23;
              break;
            }
            _context4.next = 20;
            return formHandler.createFormData(valueObj, actions);
          case 20:
            setSubmittingForm(false);
            _context4.next = 26;
            break;
          case 23:
            setSubmittingForm(false);
            actions.setStatus({
              hasErrorInfo: true,
              message: captchaV3ErrorMsg[0]
            });
            actions.setSubmitting(false);
          case 26:
            _context4.next = 38;
            break;
          case 28:
            _context4.prev = 28;
            _context4.t0 = _context4["catch"](0);
            actions.setSubmitting(false);
            setSubmittingForm(false);
            if (!(_context4.t0 !== null && _context4.t0 !== void 0 && (_error$data = _context4.t0.data) !== null && _error$data !== void 0 && (_error$data$errors$ = _error$data.errors[0]) !== null && _error$data$errors$ !== void 0 && (_error$data$errors$$m = _error$data$errors$.message) !== null && _error$data$errors$$m !== void 0 && _error$data$errors$$m.includes('recaptcha') && noOfVerifications === 0 && isRecaptchaEnable && useRecaptcha && executeRecaptcha)) {
              _context4.next = 38;
              break;
            }
            setNoOfVerifications(function (noOfVerify) {
              return noOfVerify + 1;
            });
            _context4.next = 36;
            return submitFormData(actions, valueObj, setSubmittingForm);
          case 36:
            errMessage = (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_error$data2 = _context4.t0.data) === null || _error$data2 === void 0 ? void 0 : (_error$data2$errors$ = _error$data2.errors[0]) === null || _error$data2$errors$ === void 0 ? void 0 : _error$data2$errors$.message) || '';
            logging({
              functionName: 'useForm.onSubmitForm',
              error: _context4.t0,
              description: "Recaptcha errored got new token, message: ".concat(errMessage)
            });
          case 38:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 28]]);
    }));
    return function onSubmitForm(_x5, _x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();

  // Pass the ref to the useImperativeHandle hook
  useImperativeHandle(ref, function () {
    return {
      submit: function submit(valueObj, actions, setSubmittingForm) {
        var _valueObj$formLogic2, _valueObj$payment, _valueObj$payment$pay, _valueObj$formLogic3, _valueObj$payment2;
        if (!hasErrors || valueObj !== null && valueObj !== void 0 && (_valueObj$formLogic2 = valueObj.formLogic) !== null && _valueObj$formLogic2 !== void 0 && _valueObj$formLogic2.isPaypalPayment && valueObj !== null && valueObj !== void 0 && (_valueObj$payment = valueObj.payment) !== null && _valueObj$payment !== void 0 && (_valueObj$payment$pay = _valueObj$payment.paypal) !== null && _valueObj$payment$pay !== void 0 && _valueObj$payment$pay.transactionId || valueObj !== null && valueObj !== void 0 && (_valueObj$formLogic3 = valueObj.formLogic) !== null && _valueObj$formLogic3 !== void 0 && _valueObj$formLogic3.isAPayPayment && valueObj !== null && valueObj !== void 0 && (_valueObj$payment2 = valueObj.payment) !== null && _valueObj$payment2 !== void 0 && _valueObj$payment2.bluefinAPay) {
          actions.setStatus('Loaded'); // Reset status to Loaded if no client side errors to allow user to resubmit.
          onSubmitForm(valueObj, actions, setSubmittingForm);
        }
      }
    };
  });
  useEffect(function () {
    var _values$formLogic2;
    if ((_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.isBluefinEncrypting && !isSubmitting) {
      setSubmitting(true);
    }
  }, [(_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.isBluefinEncrypting]);
  useEffect(function () {
    if (errorStatus[status]) {
      setSubmitting(false);
    }
  }, [status]);
  var initValues = InitValues;
  return {
    initValues: initValues,
    formSubmittingOpacity: formSubmittingOpacity,
    logError: logError,
    onSubmitForm: onSubmitForm
  };
};

/*
Spanish
Italian
German
Lao
Vietnamese
Khmer
Japanese
Bahasa Indonesia
Simplified Chinese
*/

var FormErrors = {
  de: {
    'Unfortunately we are not able to verify the information you provided.': 'Leider können wir die von Ihnen bereitgestellten Informationen nicht verifizieren.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Wenn Sie Unterstützung benötigen, rufen Sie uns bitte unter + 1 877-247-2426 an oder schreiben Sie uns eine E-Mail an',
    'We apologize for any inconvenience.': 'Wir entschuldigen uns für eventuelle Unannehmlichkeiten.',
    'Please try again or call 877-247-2426 or email us at': 'Bitte versuchen Sie es erneut oder rufen Sie uns unter +1 877-247-2426 an bzw. schreiben Sie uns eine E-Mail an ',
    'for assistance.': ', wenn Sie Unterstützung benötigen.',
    'Please share the below information with us.': '. Bitte teilen Sie uns die untenstehenden Informationen mit.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Bitte warten Sie und versuchen Sie es später erneut oder rufen Sie uns unter +1 877-247-2426 an bzw. schreiben Sie uns eine E-Mail an '
  },
  en: {
    'Unfortunately we are not able to verify the information you provided.': 'Unfortunately we are not able to verify the information you provided.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'If you would like assistance, please call us at 877-247-2426 or email us at',
    'We apologize for any inconvenience.': 'We apologize for any inconvenience.',
    'Please try again or call 877-247-2426 or email us at': 'Please try again or call 877-247-2426 or email us at',
    'for assistance.': 'for assistance.',
    'Please share the below information with us.': 'Please share the below information with us.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Please wait and try again later or call 877-247-2426 or email us at'
  },
  it: {
    'Unfortunately we are not able to verify the information you provided.': 'Purtroppo non siamo in grado di verificare le informazioni da Lei fornite.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Se desidera assistenza, La invitiamo a chiamarci al numero +1 877-247-2426 oppure a scriverci all’indirizzo email ',
    'We apologize for any inconvenience.': 'Ci scusiamo per l’eventuale disagio',
    'Please try again or call 877-247-2426 or email us at': 'La preghiamo di riprovare oppure di chiamare il numero + 1 877-247-2426 o scriverci all’indirizzo email',
    'for assistance.': 'per ricevere assistenza.',
    'Please share the below information with us.': 'La invitiamo a condividere con noi le informazioni riportate qui sotto.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'La preghiamo di attendere e riprovare più tardi oppure di chiamare il numero + 1 877-247-2426 o scriverci all’indirizzo email'
  },
  vi: {
    'Unfortunately we are not able to verify the information you provided.': 'Đáng tiếc, chúng tôi không thể xác nhận thông tin bạn cung cấp.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Nếu bạn cần sự trợ giúp, hãy gọi số 877-247-2426 hoặc email cho chúng tôi đến',
    'We apologize for any inconvenience.': 'Xin lỗi vì sự bất tiện.',
    'Please try again or call 877-247-2426 or email us at': 'Vui lòng thử lại hay gọi số 877-247-2426 hoặc email cho chúng tôi đến',
    'for assistance.': 'để được trợ giúp.',
    'Please share the below information with us.': 'Xin chia sẻ thông tin dưới đây với chúng tôi.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Xin chờ và thử lại sau hay gọi số 877-247-2426 hoặc email cho chúng tôi đến'
  },
  ja: {
    'Unfortunately we are not able to verify the information you provided.': '申し訳ありませんが、提供された情報を確認できません。',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'サポートが必要な場合は、877-247-2426までお電話いただくか、以下のメールアドレスまでご連絡ください。',
    'We apologize for any inconvenience.': 'ご不便をおかけして申し訳ありません。',
    'Please try again or call 877-247-2426 or email us at': 'もう一度お試しいただくか、877-247-2426までお電話いただくか、以下のメールアドレスまでご連絡ください。',
    'for assistance.': 'サポートが必要な場合は。',
    'Please share the below information with us.': '以下の情報を私たちと共有してください。',
    'Please wait and try again later or call 877-247-2426 or email us at': 'しばらくお待ちいただき、後でもう一度お試しいただくか、877-247-2426までお電話いただくか、以下のメールアドレスまでご連絡ください。'
  },
  zh: {
    'Unfortunately we are not able to verify the information you provided.': '很遗憾，我们无法验证您提供的信息。',
    'If you would like assistance, please call us at 877-247-2426 or email us at': '如果您需要帮助，请致电877-247-2426或发送电子邮件至',
    'We apologize for any inconvenience.': '对于给您带来的任何不便，我们深表歉意。',
    'Please try again or call 877-247-2426 or email us at': '请重试或致电877-247-2426或发送电子邮件至',
    'for assistance.': '寻求帮助。',
    'Please share the below information with us.': '请与我们分享以下信息。',
    'Please wait and try again later or call 877-247-2426 or email us at': '请稍等，稍后再试，或致电877-247-2426或发送电子邮件至'
  },
  lo: {
    'Unfortunately we are not able to verify the information you provided.': 'ຫນ້າເສຍດາຍ ທີ່່ພວກເຮົາບໍ່ສາມາດຢືນຢັນຂໍ້ມູນທີ່ ທ່ານໄດ້ໃຫ້ໄວ້.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'ຖ້າຫາກທ່ານຕ້ອງການຄວາມຊ່ວຍ ເຫລືອ, ສາມາດໂທຫາພວກເຮົາໄດ້ທີ່່ເບີ 877-247-2426 ຫລື ທາງອີເມວ',
    'We apologize for any inconvenience.': 'ພວກເຮົາຂໍໂທດສໍາລັບຄວາມບໍ່ສະດວກທີ່ອາດເກີດຂຶ້ນ.',
    'ກາລຸນາລອງອີກຄັ້ງ ຫຼື ໂທຫາພວກເຮົາໄດ້ທີ່່ເບີ 877-247-2426 ຫລື ທາງອີເມວ': 'ກະ​ລຸ​ນາ​ลอง​อีก​ครั้ง​หรือ​โทร 877-247-2426 ຫรือ ສົ່ງ E-mail ມາ',
    'for assistance.': 'ເພື່ອການຊ່ວຍເຫຼືອ.',
    'Please share the below information with us.': 'ກາລຸນາໃຫ້ຂໍ້ມູນລຸ່ມນີ້ກັບພວກເຮົາ.​',
    'Please wait and try again later or call 877-247-2426 or email us at': 'ກາລຸນາລອງອີກຄັ້ງ ຫຼື ໂທຫາພວກເຮົາໄດ້ທີ່່ເບີ 877-247-2426 ຫລື ທາງອີເມວ.'
  },
  id: {
    'Unfortunately we are not able to verify the information you provided.': 'Sayangnya, kami tidak dapat memverifikasikan informasi yang Anda sediakan.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Jika Anda butuh bantuan, silakan hubungi kami di 877-247-2426 atau kirim email ke',
    'We apologize for any inconvenience.': 'Mohon maaf atas ketidaknyamanan ini.',
    'Please try again or call 877-247-2426 or email us at': 'Silakan coba kembali atau hubungi 877-247-2426, atau kirim email ke',
    'for assistance.': 'untuk bantuan.',
    'Please share the below information with us.': 'Mohon bagikan informasi berikut kepada kami.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Mohon menunggu dan coba lagi nanti, atau hubungi 877-247-2426 atau kirim email ke'
  },
  km: {
    'Unfortunately we are not able to verify the information you provided.': 'សូមអធ្យាស្រ័យ យើងមិនអាចផ្ទៀងផ្ទាត់ព័ត៌មានដែលអ្នកបានផ្តល់នោះទេ។',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'ប្រសិនបើអ្នកចង់បានជំនួយ សូមទូរស័ព្ទមកយើងតាមរយៈលេខ 877-247-2426 ឬផ្ញើអ៊ីមែលមកយើងតាមរយៈ',
    'We apologize for any inconvenience.': 'យើងសូមអភ័យទោសចំពោះការរអាក់រអួលណាមួយ។',
    'Please try again or call 877-247-2426 or email us at': 'សូមព្យាយាមម្តងទៀត ឬទូរស័ព្ទទៅលេខ 877-247-2426 ឬផ្ញើអ៊ីមែលមកយើងតាមរយៈ',
    'for assistance.': 'សម្រាប់ជំនួយ។',
    'Please share the below information with us.': 'សូមចែករំលែកព័ត៌មានខាងក្រោមជាមួយយើងខ្ញុំ។',
    'Please wait and try again later or call 877-247-2426 or email us at': 'សូមរង់ចាំ ហើយព្យាយាមម្តងទៀតនៅពេលក្រោយ ឬទូរស័ព្ទទៅលេខ 877-247-2426 ឬផ្ញើអ៊ីមែលមកយើងតាមរយៈ'
  },
  zh_TW: {
    'Unfortunately we are not able to verify the information you provided.': '很遺憾，我們無法驗證您提供的信息。',
    'If you would like assistance, please call us at 877-247-2426 or email us at': '如果您需要幇助，請致電877-247-2426或發送電子郵件至',
    'We apologize for any inconvenience.': '對於給您带來的任何不便，我們深表歉意。',
    'Please try again or call 877-247-2426 or email us at': '請重試或致電877-247-2426或發送電子郵件至',
    'for assistance.': '尋求幇助。',
    'Please share the below information with us.': '請與我們分享以下信息。',
    'Please wait and try again later or call 877-247-2426 or email us at': '請稍等，稍後再試，或致電877-247-2426或發送電子郵件至'
  },
  et: {
    'Unfortunately we are not able to verify the information you provided.': 'Kahjuks, me ei saa kinnitada Teie poolt antud andmeid.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Kui soovite abi, siis palun helistage numbrile 877-247-2426 või kirjutage aadressile',
    'We apologize for any inconvenience.': 'Vabandame ebamugavuste pärast.',
    'Please try again or call 877-247-2426 or email us at': 'Palun proovige uuesti või helistage numbrile 877-247-2426 või kirjutage  aadressile',
    'for assistance.': 'abi jaoks.',
    'Please share the below information with us.': 'Palun jagage allolevaid andmeid meiega.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Palun oodake ja proovige hiljem uuesti või helistage numbrile 877-247-2426 või kirjutage aadressile'
  },
  ru: {
    'Unfortunately we are not able to verify the information you provided.': 'К сожалению, нам не удается подтвердить предоставленную информацию.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Если вам нужна помощь, пожалуйста, позвоните нам по номеру 877-247-2426 или напишите по адресу',
    'We apologize for any inconvenience.': 'Приносим извинения за предоставленные неудобства.',
    'Please try again or call 877-247-2426 or email us at': 'Пожалуйста, попробуйте снова, позвоните по номеру 877-247-2426 или напишите по адресу',
    'for assistance.': 'чтобы получить помощь.',
    'Please share the below information with us.': 'Пожалуйста, поделитесь с нами информацией ниже.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Пожалуйста, подождите и затем попробуйте снова или позвоните по номеру 877-247-2426 или напишите по адресу'
  },
  es: {
    'Unfortunately we are not able to verify the information you provided.': 'Lamentablemente, no podemos verificar la información facilitada.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Si desea asistencia, llame al 877-247-2426 o envíenos un correo a',
    'We apologize for any inconvenience.': 'Disculpe las molestias.',
    'Please try again or call 877-247-2426 or email us at': 'Por favor, inténtelo de nuevo, o llame al 877-247-2426 o envíenos un correo a',
    'for assistance.': 'para obtener ayuda.',
    'Please share the below information with us.': 'Por favor, comparta la  siguiente información con nosotros.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Espere por favor o inténtelo de nuevo más tarde. Para obtener ayuda, llame al 877-247-2426 o envíenos un correo a'
  },
  nl: {
    'Unfortunately we are not able to verify the information you provided.': 'Helaas kunnen we de door u verstrekte informatie niet verifiëren.',
    'If you would like assistance, please call us at 877-247-2426 or email us at': 'Indien u hulp nodig heeft, kan u ons bellen op 877-247-2426 of een  email sturen naar',
    'We apologize for any inconvenience.': 'Onze excuses voor het ongemak.',
    'Please try again or call 877-247-2426 or email us at': 'Gelieve het opnieuw te proberen of te bellen naar 877-247-2426 of een email te sturen naar',
    'for assistance.': 'voor hulp.',
    'Please share the below information with us.': 'Gelieve de onderstaande informatie met ons te delen.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Gelieve te wachten en het later opnieuw te proberen of bel naar 877-247-2426 of stuur een email naar'
  },
  fr: {
    'Unfortunately we are not able to verify the information you provided.': "Nous sommes dans l'incapacité de vérifier l'information que vous avez fournie.",
    'If you would like assistance, please call us at 877-247-2426 or email us at': "Si vous avez besoin d'aide, veuillez nous contacter au 877-247-2426 ou par email à",
    'We apologize for any inconvenience.': 'Veuillez nous excuser pour ce désagrément.',
    'Please try again or call 877-247-2426 or email us at': 'Veuillez réessayer ou nous contacter au 877-247-2426 ou via émail à',
    'for assistance.': 'pour toute assistance.',
    'Please share the below information with us.': 'Merci de compléter les informations suivantes.',
    'Please wait and try again later or call 877-247-2426 or email us at': 'Veuillez attendre et réessayer plus tard ou nous contacter au 877-247-2426 ou via émail à'
  }
};

var useFormErrorScreen = function useFormErrorScreen(_ref) {
  var _FormErrors$lng;
  var lng = _ref.lng;
  var formErrors = (_FormErrors$lng = FormErrors[lng]) !== null && _FormErrors$lng !== void 0 ? _FormErrors$lng : FormErrors.en;
  return {
    formErrors: formErrors
  };
};

var _excluded$v = ["entity", "index", "label", "name"];
var getLabelFields = function getLabelFields(_ref) {
  var valueObj = _ref.valueObj;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var translations = deepFind(valueObj, 'translations');
  var townCityLabel = t(['Town/City'], {
    ns: 'labels'
  });
  var countyLabel = t(['County'], {
    ns: 'labels'
  });
  var cityLabel = (translations === null || translations === void 0 ? void 0 : translations.cityLabel) || t(['City'], {
    ns: 'labels'
  });
  var postalCodeLabel = (translations === null || translations === void 0 ? void 0 : translations.postalCodeLabel) || t('Postal Code', {
    ns: 'labels'
  });
  var streetAddressLabel = (translations === null || translations === void 0 ? void 0 : translations.streetAddressLabel) || t('Street Address', {
    ns: 'labels'
  });
  var suburbLabel = (translations === null || translations === void 0 ? void 0 : translations.suburbLabel) || t('Suburb', {
    ns: 'labels'
  });
  var stateLabel = (translations === null || translations === void 0 ? void 0 : translations.stateLabel) || t('State', {
    ns: 'labels'
  });
  var postCodeLabel = (translations === null || translations === void 0 ? void 0 : translations.postCodeLabel) || t('Postcode', {
    ns: 'labels'
  });
  var denominationLabel = "".concat(t('Denomination', {
    ns: 'labels'
  }));
  var messageProcessingText = t('Your submission is currently being processed. This may take a few moments. Please don’t close this window, hit the back button, or refresh your browser.', {
    ns: 'labels'
  });
  var errMsgText = t("We are experiencing technical difficulties, and your submission may not have been processed.  If you need assistance, please call us toll-free at 877-247-2426.  Thank you for your patience and understanding.", {
    ns: 'labels'
  });
  return {
    cityLabel: cityLabel,
    countyLabel: countyLabel,
    denominationLabel: denominationLabel,
    errMsgText: errMsgText,
    messageProcessingText: messageProcessingText,
    postalCodeLabel: postalCodeLabel,
    postCodeLabel: postCodeLabel,
    stateLabel: stateLabel,
    streetAddressLabel: streetAddressLabel,
    suburbLabel: suburbLabel,
    townCityLabel: townCityLabel
  };
};
var useFormatAddress = function useFormatAddress(_ref2) {
  var _ref2$entity = _ref2.entity,
    entity = _ref2$entity === void 0 ? 0 : _ref2$entity,
    _ref2$index = _ref2.index,
    index = _ref2$index === void 0 ? 0 : _ref2$index,
    label = _ref2.label,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref2$name,
    props = _objectWithoutProperties(_ref2, _excluded$v);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var _useState = useState((props === null || props === void 0 ? void 0 : props.autoComplete) || false),
    _useState2 = _slicedToArray(_useState, 2),
    hideManualAddress = _useState2[0],
    setHideManualAddress = _useState2[1];
  var valueObj = values;
  var translations = deepFind(valueObj, 'translations');
  var _useTranslation2 = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation2.t;
  var addressLabel = t(label, {
    ns: 'labels'
  });
  var address1Label = (translations === null || translations === void 0 ? void 0 : translations.address1Label) || t(['Address 1'], {
    ns: 'labels'
  });
  var address2Label = (translations === null || translations === void 0 ? void 0 : translations.address2Label) || "".concat(t(['Address 2'], {
    ns: 'labels'
  }));
  var address3Label = (translations === null || translations === void 0 ? void 0 : translations.address3Label) || "".concat(t(['Address 3'], {
    ns: 'labels'
  }));
  var autoCompleteLabel = (translations === null || translations === void 0 ? void 0 : translations.autoCompleteLabel) || t('Find your address', {
    ns: 'labels'
  });
  var validateInput$1 = function validateInput$1(value) {
    return validateInput(translations, value, props === null || props === void 0 ? void 0 : props.required);
  };
  var _getLabelFields = getLabelFields(_objectSpread2({
      valueObj: valueObj
    }, props)),
    cityLabel = _getLabelFields.cityLabel,
    countyLabel = _getLabelFields.countyLabel,
    denominationLabel = _getLabelFields.denominationLabel,
    errMsgText = _getLabelFields.errMsgText,
    messageProcessingText = _getLabelFields.messageProcessingText,
    postalCodeLabel = _getLabelFields.postalCodeLabel,
    postCodeLabel = _getLabelFields.postCodeLabel,
    stateLabel = _getLabelFields.stateLabel,
    streetAddressLabel = _getLabelFields.streetAddressLabel,
    suburbLabel = _getLabelFields.suburbLabel,
    townCityLabel = _getLabelFields.townCityLabel;
  var address = deepFind(valueObj, name);
  var handleManualAddress = function handleManualAddress() {
    setHideManualAddress(false);
  };
  return {
    address: address,
    addressLabel: addressLabel,
    address1Label: address1Label,
    address2Label: address2Label,
    address3Label: address3Label,
    autoCompleteLabel: autoCompleteLabel,
    cityLabel: cityLabel,
    countyLabel: countyLabel,
    denominationLabel: denominationLabel,
    errMsgText: errMsgText,
    hideManualAddress: hideManualAddress,
    messageProcessingText: messageProcessingText,
    postalCodeLabel: postalCodeLabel,
    postCodeLabel: postCodeLabel,
    stateLabel: stateLabel,
    streetAddressLabel: streetAddressLabel,
    suburbLabel: suburbLabel,
    townCityLabel: townCityLabel,
    validateInput: validateInput$1,
    values: values,
    handleManualAddress: handleManualAddress
  };
};

var useFormProvider = function useFormProvider(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setSubmitting = _useState2[1];
  var refFormProvider = useRef(null);
  var isRecaptchaEnable = !isDisableRecaptcha({
    isDisableRecaptcha: props === null || props === void 0 ? void 0 : props.isDisableRecaptcha
  });
  var onSubmitForm = function onSubmitForm(values, actions) {
    var _refFormProvider$curr;
    setSubmitting(true);
    (_refFormProvider$curr = refFormProvider.current) === null || _refFormProvider$curr === void 0 ? void 0 : _refFormProvider$curr.submit(values, actions, setSubmitting);
  };
  var initValues = InitValues;
  return {
    initValues: initValues,
    isRecaptchaEnable: isRecaptchaEnable,
    isSubmitting: isSubmitting,
    refFormProvider: refFormProvider,
    onSubmitForm: onSubmitForm,
    setSubmitting: setSubmitting
  };
};

var useFreeGiftOffer = function useFreeGiftOffer(_ref) {
  var _giftOffer$warehouse;
  var giftOffer = _ref.giftOffer;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var hasFreeGift = deepFind(values, "formLogic.freeGiftOffer");
  var recurringDate = deepFind(values, 'formLogic.recurringDate');
  var isRecurring = deepFind(values, "formLogic.cart.donation.projects[0].isRecurring");
  var deliveryStatement = '*While supplies last; please allow 4 to 6 weeks for delivery; U.S. residents only';
  if (values.formLogic.deliveryStatement) {
    deliveryStatement = deepFind(values, 'formLogic.deliveryStatement');
  } else if (giftOffer !== null && giftOffer !== void 0 && giftOffer.label) {
    deliveryStatement = '';
  }
  var products = giftOffer !== null && giftOffer !== void 0 && giftOffer.productCode ? [_objectSpread2({
    amount: 0,
    productId: giftOffer.productCode,
    quantity: 1
  }, (giftOffer === null || giftOffer === void 0 ? void 0 : (_giftOffer$warehouse = giftOffer.warehouse) === null || _giftOffer$warehouse === void 0 ? void 0 : _giftOffer$warehouse.length) > 0 && {
    warehouse: giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.warehouse
  })] : [];
  var specialCode = [{
    key: 'SPECIAL',
    value: 'B582'
  }];
  useEffect(function () {
    if (hasFreeGift === 'yes') {
      setFieldValue("collector.cart.products", products, false);
      if ((recurringDate || isRecurring) && !(giftOffer !== null && giftOffer !== void 0 && giftOffer.shouldRemoveSpecialCode)) {
        setFieldValue("collector.entity[0].code", specialCode, false);
      }
    } else {
      setFieldValue("collector.cart.products", [], false);
      if (!(giftOffer !== null && giftOffer !== void 0 && giftOffer.shouldRemoveSpecialCode)) {
        setFieldValue("collector.entity[0].code", [], false);
      }
    }
  }, [hasFreeGift]);
  useEffect(function () {
    setFieldValue('formLogic.freeGiftOffer', 'yes');
  }, []);
  var _freeGiftHeper = freeGiftHeper(giftOffer),
    labelText = _freeGiftHeper.labelText,
    options = _freeGiftHeper.options;
  return {
    deliveryStatement: deliveryStatement,
    labelText: labelText,
    options: options
  };
};

var useGetBRBInfo = function useGetBRBInfo() {
  return useQuery(['brb'], function () {
    return apiClient.getBRBInfo();
  }, {
    select: R.prop('data')
  });
};

var useGetCoursesDiscountPrice = function useGetCoursesDiscountPrice(_ref, options) {
  var productCode = _ref.productCode,
    promoCode = _ref.promoCode;
  return useQuery(['discountPrice', productCode, promoCode], function () {
    return apiClient.getCoursesDiscountPrice(productCode, promoCode);
  }, _objectSpread2({
    select: R.path(['data', 'payload'])
  }, options));
};

var useGetDmagProducts = function useGetDmagProducts(_ref, options) {
  var subLocation = _ref.subLocation,
    subType = _ref.subType,
    promoCode = _ref.promoCode;
  return useQuery(['dmagProducts', subLocation, subType, promoCode], function () {
    return apiClient.getDmagProducts(subLocation, subType, promoCode);
  }, _objectSpread2({
    select: R.path(['data', 'payload'])
  }, options));
};

var useGetDmagNonDiscountSubscriptions = function useGetDmagNonDiscountSubscriptions() {
  return useQuery('dmagNonDiscountSubscriptions', function () {
    return apiClient.getDmagNonDiscountSubscriptions();
  }, {
    select: R.path(['data', 'payload'])
  });
};

var useGetDmagSubscriptions = function useGetDmagSubscriptions() {
  return useQuery('dmagSubscriptions', function () {
    return apiClient.getDmagSubscriptions();
  }, {
    select: R.path(['data', 'payload'])
  });
};

var useGetPing = function useGetPing() {
  return useQuery('ping', function () {
    return apiClient.getPing();
  }, {
    select: R.path(['data', 'results'])
  });
};

var useGetCoursesProducts = function useGetCoursesProducts(_ref, options) {
  var productCode = _ref.productCode;
  return useQuery(['courseProducts', productCode], function () {
    return apiClient.getCoursesProducts(productCode);
  }, _objectSpread2({
    select: R.path(['data', 'payload'])
  }, options));
};

var useGoogleReCaptcha = function useGoogleReCaptcha() {
  var _values$formLogic, _values$formLogic$par;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var site = getSiteUrl(values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref);
  var getLogPayload = function getLogPayload() {
    var _values$collector, _values$collector$car, _values$collector$car2, _values$collector2, _values$collector3, _values$collector4, _values$collector5, _values$collector5$en, _values$collector6, _values$collector6$en, _values$collector7, _values$collector7$en, _values$collector7$en2, _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector9, _values$collector10, _values$collector10$e, _values$collector11, _values$collector11$e, _values$collector12, _values$collector13, _values$collector13$e, _values$collector14, _values$collector14$e;
    return _objectSpread2(_objectSpread2(_objectSpread2({
      projects: values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.projects,
      sourceCode: (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : _values$collector2.SESourceCode) || ''
    }, (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : _values$collector3.entity) && (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : _values$collector4.entity[0]) && (values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : _values$collector5$en.email) && (values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[0]) === null || _values$collector6$en === void 0 ? void 0 : _values$collector6$en.email[0]) && (values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? void 0 : (_values$collector7$en2 = _values$collector7$en.email[0]) === null || _values$collector7$en2 === void 0 ? void 0 : _values$collector7$en2.emailAddress) && {
      emailAddress: values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.email[0]) === null || _values$collector8$en2 === void 0 ? void 0 : _values$collector8$en2.emailAddress
    }), (values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : _values$collector9.entity) && (values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$e = _values$collector10.entity[0]) === null || _values$collector10$e === void 0 ? void 0 : _values$collector10$e.firstName) && {
      firstName: values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : _values$collector11$e.firstName
    }), (values === null || values === void 0 ? void 0 : (_values$collector12 = values.collector) === null || _values$collector12 === void 0 ? void 0 : _values$collector12.entity) && (values === null || values === void 0 ? void 0 : (_values$collector13 = values.collector) === null || _values$collector13 === void 0 ? void 0 : (_values$collector13$e = _values$collector13.entity[0]) === null || _values$collector13$e === void 0 ? void 0 : _values$collector13$e.lastName) && {
      lastName: values === null || values === void 0 ? void 0 : (_values$collector14 = values.collector) === null || _values$collector14 === void 0 ? void 0 : (_values$collector14$e = _values$collector14.entity[0]) === null || _values$collector14$e === void 0 ? void 0 : _values$collector14$e.lastName
    });
  };
  var setRecaptchaError = function setRecaptchaError() {
    return setFieldValue('formLogic.hasRecaptchaError', true);
  };
  return {
    logPayload: getLogPayload(),
    site: site,
    values: values,
    logging: logging,
    setRecaptchaError: setRecaptchaError
  };
};

var useInputBlur = function useInputBlur(_ref) {
  var name = _ref.name,
    required = _ref.required;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldTouched = _useFormikContext.setFieldTouched;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var _useTranslation = useTranslation(['validation']),
    t = _useTranslation.t;
  var requiredLabel = (translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || t('Required', {
    ns: 'validation'
  });
  var handleOnBlur = function handleOnBlur() {
    var _values$formLogic;
    if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.isDonation && PAYMENT_INPUTS_DONATION_FUNNEL.includes(name) && validateFields({
      values: values
    })) {
      trackDonationFunnel({
        addressDetailComplete: 'Y',
        values: values
      });
    }
    setFieldTouched(name, true);
    return name;
  };
  var handleOnBlurUnControlled = function handleOnBlurUnControlled(e) {
    var _e$target;
    var value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    if (required && !value) {
      setErrorMessage(requiredLabel);
    } else if (value) {
      setErrorMessage('');
    }
  };
  return {
    errorMessage: errorMessage,
    handleOnBlur: handleOnBlur,
    handleOnBlurUnControlled: handleOnBlurUnControlled
  };
};

var useInputTextEvents = function useInputTextEvents(_ref) {
  var name = _ref.name;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var handleOnChangeUnControlled = function handleOnChangeUnControlled(e) {
    var _e$target;
    var value = (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '';
    setFieldValue(name, value, false);
  };
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
      e.preventDefault();
    }
  };
  return {
    handleOnChangeUnControlled: handleOnChangeUnControlled,
    handleOnKeyDown: handleOnKeyDown
  };
};

var _excluded$u = ["disableValidation", "entity", "index", "label", "minPhoneLength", "name", "phoneOptional", "phoneType", "required"];
var useInputPhone = function useInputPhone(_ref) {
  var disableValidation = _ref.disableValidation,
    entity = _ref.entity,
    index = _ref.index,
    label = _ref.label,
    minPhoneLength = _ref.minPhoneLength,
    name = _ref.name,
    phoneOptional = _ref.phoneOptional,
    phoneType = _ref.phoneType,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded$u);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldError = _useFormikContext.setFieldError,
    setFieldTouched = _useFormikContext.setFieldTouched,
    setFieldValue = _useFormikContext.setFieldValue;
  var valueObj = values;
  var translations = deepFind(valueObj, 'translations');
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    phone = _useState2[0],
    setPhone = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var phoneLabel = label || (translations === null || translations === void 0 ? void 0 : translations.phoneLabel);
  var requiredLabel = (translations === null || translations === void 0 ? void 0 : translations.requiredLabel) || t('Required', {
    ns: 'validation'
  });
  var invalidLabel = (translations === null || translations === void 0 ? void 0 : translations.invalid) || t('Invalid', {
    ns: 'validation'
  });
  var validatePhoneInput = function validatePhoneInput(value) {
    return !disableValidation ? validatePhone(value, minPhoneLength, phoneOptional, required, requiredLabel, invalidLabel) : undefined;
  };
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
      e.preventDefault();
    }
  };
  var handleOnBlurUnControlled = function handleOnBlurUnControlled() {
    var errorMsg = props === null || props === void 0 ? void 0 : props.validate(phone);
    if (typeof errorMsg === 'string') {
      setErrorMessage(errorMsg);
      if ((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.length) > 0) {
        setFieldError(name, 'Invalid');
      } else {
        setFieldTouched(name, false);
      }
    }
  };
  useEffect(function () {
    if ((phone === null || phone === void 0 ? void 0 : phone.length) > 0) {
      setFieldValue(name, phone);
    }
  }, [phone]);
  useEffect(function () {
    if (phoneType) {
      setFieldValue("collector.entity[".concat(entity, "].phone[").concat(index, "].phoneType"), phoneType, false);
    }
    if (props !== null && props !== void 0 && props.useCountryCode) {
      setFieldError(name, 'Invalid');
    }
  }, []);
  return {
    errorMessage: errorMessage,
    handleOnBlurUnControlled: handleOnBlurUnControlled,
    handleOnKeyDown: handleOnKeyDown,
    phoneLabel: phoneLabel,
    phone: phone,
    setPhone: setPhone,
    validatePhoneInput: validatePhoneInput
  };
};

var useInputValidation = function useInputValidation(_ref) {
  var maxLen = _ref.maxLen,
    required = _ref.required;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var valueObj = values;
  var translations = deepFind(valueObj, 'translations');
  var validate = function validate(value) {
    return validateString(translations, value, required, maxLen);
  };
  var validateInput$1 = function validateInput$1(value) {
    return validateInput(translations, value, required);
  };
  return {
    validate: validate,
    validateInput: validateInput$1
  };
};

var useItemCalculator = function useItemCalculator(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$formLogic, _values$collector2, _values$collector2$ca, _values$formLogic2, _values$formLogic2$br, _values$formLogic2$br2, _values$formLogic2$br3;
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$pledge = _ref.pledge,
    pledge = _ref$pledge === void 0 ? false : _ref$pledge;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    handleChange = _useFormikContext.handleChange;
  var projects = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.projects;
  var isPledge = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.pledge;
  var pledges = values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : _values$collector2$ca.pledge;
  var itemPrice = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$br = _values$formLogic2.brbInfo) === null || _values$formLogic2$br === void 0 ? void 0 : (_values$formLogic2$br2 = _values$formLogic2$br.campaign) === null || _values$formLogic2$br2 === void 0 ? void 0 : (_values$formLogic2$br3 = _values$formLogic2$br2.item) === null || _values$formLogic2$br3 === void 0 ? void 0 : _values$formLogic2$br3.itemCost) || 1;
  useEffect(function () {
    var _values$formLogic3, _values$formLogic4, _values$formLogic5, _values$formLogic5$it, _projects$index, _values$formLogic6, _values$formLogic6$it, _projects$index2;
    if (values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.itemCalculator && values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.itemCalculator[index] && values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && (_values$formLogic5$it = _values$formLogic5.itemCalculator[index]) !== null && _values$formLogic5$it !== void 0 && _values$formLogic5$it.amount && !pledge && (projects === null || projects === void 0 ? void 0 : projects.length) > 0 && projects[index] && ((_projects$index = projects[index]) === null || _projects$index === void 0 ? void 0 : _projects$index.amount) !== 0 && ((values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : (_values$formLogic6$it = _values$formLogic6.itemCalculator[index]) === null || _values$formLogic6$it === void 0 ? void 0 : _values$formLogic6$it.amount) / 1).toFixed(2) !== (((_projects$index2 = projects[index]) === null || _projects$index2 === void 0 ? void 0 : _projects$index2.amount) / itemPrice).toFixed(2)) {
      var _projects$index3;
      setFieldValue("formLogic.itemCalculator[".concat(index, "].amount"), (((_projects$index3 = projects[index]) === null || _projects$index3 === void 0 ? void 0 : _projects$index3.amount) / itemPrice).toFixed(2));
    }
  }, [projects]);
  useEffect(function () {
    if (isPledge === true) delete values.formLogic.itemizedDonations;
  }, [isPledge]);
  useEffect(function () {
    var _values$formLogic7, _values$formLogic8, _values$formLogic9, _values$formLogic9$it, _values$formLogic10, _values$formLogic10$i;
    // update the number of items in ItemCalculator (pledge) based on the amount of money given
    if (values !== null && values !== void 0 && (_values$formLogic7 = values.formLogic) !== null && _values$formLogic7 !== void 0 && _values$formLogic7.itemCalculator && values !== null && values !== void 0 && (_values$formLogic8 = values.formLogic) !== null && _values$formLogic8 !== void 0 && _values$formLogic8.itemCalculator[index] && values !== null && values !== void 0 && (_values$formLogic9 = values.formLogic) !== null && _values$formLogic9 !== void 0 && (_values$formLogic9$it = _values$formLogic9.itemCalculator[index]) !== null && _values$formLogic9$it !== void 0 && _values$formLogic9$it.amount && pledge && pledges && (pledges === null || pledges === void 0 ? void 0 : pledges.amount) !== 0 && ((values === null || values === void 0 ? void 0 : (_values$formLogic10 = values.formLogic) === null || _values$formLogic10 === void 0 ? void 0 : (_values$formLogic10$i = _values$formLogic10.itemCalculator[index]) === null || _values$formLogic10$i === void 0 ? void 0 : _values$formLogic10$i.amount) / 1).toFixed(2) !== ((pledges === null || pledges === void 0 ? void 0 : pledges.amount) / itemPrice).toFixed(2)) {
      setFieldValue("formLogic.itemCalculator[".concat(index, "].amount"), ((pledges === null || pledges === void 0 ? void 0 : pledges.amount) / itemPrice).toFixed(2));
    }
  }, [pledges]);

  // If the component is a pledge then this function updates the price of the pledge amount with the set price for the item calculator else than it updates the price of the object in the donation schema
  var handleItemChange = function handleItemChange(e) {
    handleChange(e);
    if (pledge) {
      setFieldValue('collector.cart.pledge.amount', parseFloat((e.target.value * itemPrice).toFixed(2)));
    } else {
      setFieldValue("collector.cart.donation.projects[".concat(index, "].amount"), parseFloat((e.target.value * itemPrice).toFixed(2)));
    }
  };
  return {
    handleItemChange: handleItemChange
  };
};

/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */

var useKeyPadPayment = function useKeyPadPayment() {
  var _values$formLogic, _values$formLogic2, _Object$keys, _values$formLogic3, _values$formLogic4;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var showGiftOffer = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.showFreeGiftOffer) && (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.giftOffer) && ((_Object$keys = Object.keys(values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.giftOffer)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var giftOffer = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.giftOffer;
  return {
    giftOffer: giftOffer,
    showGiftOffer: showGiftOffer
  };
};

var LaosProvinceList = [{
  id: 'ນະຄອນຫຼວງວຽງຈັນ',
  value: 'ນະຄອນຫຼວງວຽງຈັນ'
}, {
  id: 'ຜົ້ງສາລີ',
  value: 'ຜົ້ງສາລີ'
}, {
  id: 'ຫຼວງນໍ້າທາ',
  value: 'ຫຼວງນໍ້າທາ'
}, {
  id: 'ອຸດົມໄຊ',
  value: 'ອຸດົມໄຊ'
}, {
  id: 'ບໍ່ເເກ້ວ',
  value: 'ບໍ່ເເກ້ວ'
}, {
  id: 'ຫຼວງພຣະບາງ',
  value: 'ຫຼວງພຣະບາງ'
}, {
  id: 'ຫົວພັນ',
  value: 'ຫົວພັນ'
}, {
  id: 'ໄຊຍະບູລີ',
  value: 'ໄຊຍະບູລີ'
}, {
  id: 'ຊຽງຂວາງ',
  value: 'ຊຽງຂວາງ'
}, {
  id: 'ບໍລິຄໍາໄຊ',
  value: 'ບໍລິຄໍາໄຊ'
}, {
  id: 'ຄໍາມ່ວນ',
  value: 'ຄໍາມ່ວນ'
}, {
  id: 'ອັດຕະປື',
  value: 'ອັດຕະປື'
}, {
  id: 'ຈຳປາສັກ',
  value: 'ຈຳປາສັກ'
}, {
  id: 'ເຊກອງ',
  value: 'ເຊກອງ'
}, {
  id: 'ສາລະວັນ',
  value: 'ສາລະວັນ'
}, {
  id: 'ວຽງຈັນ',
  value: 'ວຽງຈັນ'
}, {
  id: 'ສະຫວັນນະເຂດ',
  value: 'ສະຫວັນນະເຂດ'
}, {
  id: 'ໄຊສົມບູນ',
  value: 'ໄຊສົມບູນ'
}];

var LaosDistrictList = [{
  id: 'ຈັນທະບຸລີ',
  value: 'ຈັນທະບຸລີ'
}, {
  id: 'ສີໂຄດຕະບອງ',
  value: 'ສີໂຄດຕະບອງ'
}, {
  id: 'ໄຊເສດຖາ',
  value: 'ໄຊເສດຖາ'
}, {
  id: 'ສີສັດຕະນາກ',
  value: 'ສີສັດຕະນາກ'
}, {
  id: 'ນາຊາຍທອງ',
  value: 'ນາຊາຍທອງ'
}, {
  id: 'ໄຊທານີ',
  value: 'ໄຊທານີ'
}, {
  id: 'ຫາດຊາຍຟອງ',
  value: 'ຫາດຊາຍຟອງ'
}, {
  id: 'ສັງທອງ',
  value: 'ສັງທອງ'
}, {
  id: 'ປາກງື່ມ',
  value: 'ປາກງື່ມ'
}, {
  id: 'ຜົ້ງສາລີ',
  value: 'ຜົ້ງສາລີ'
}, {
  id: 'ໃໝ່',
  value: 'ໃໝ່'
}, {
  id: 'ຂວາ',
  value: 'ຂວາ'
}, {
  id: 'ສຳພັນ',
  value: 'ສຳພັນ'
}, {
  id: 'ບຸນເໜືອ',
  value: 'ບຸນເໜືອ'
}, {
  id: 'ຍອດອູ',
  value: 'ຍອດອູ'
}, {
  id: 'ບຸນໃຕ້',
  value: 'ບຸນໃຕ້'
}, {
  id: 'ຫຼວງນໍ້າທາ',
  value: 'ຫຼວງນໍ້າທາ'
}, {
  id: 'ສີງ',
  value: 'ສີງ'
}, {
  id: 'ລອງ',
  value: 'ລອງ'
}, {
  id: 'ວຽງພູຄາ',
  value: 'ວຽງພູຄາ'
}, {
  id: 'ນາແລ',
  value: 'ນາແລ'
}, {
  id: 'ໄຊ',
  value: 'ໄຊ'
}, {
  id: 'ຫຼາ',
  value: 'ຫຼາ'
}, {
  id: 'ນາໝໍ້',
  value: 'ນາໝໍ້'
}, {
  id: 'ງາ',
  value: 'ງາ'
}, {
  id: 'ແບ່ງ',
  value: 'ແບ່ງ'
}, {
  id: 'ຮຸນ',
  value: 'ຮຸນ'
}, {
  id: 'ປາກແບ່ງ',
  value: 'ປາກແບ່ງ'
}, {
  id: 'ຫ້ວຍຊາຍ',
  value: 'ຫ້ວຍຊາຍ'
}, {
  id: 'ຕົ້ນເຜິ້ງ',
  value: 'ຕົ້ນເຜິ້ງ'
}, {
  id: 'ເມິງ',
  value: 'ເມິງ'
}, {
  id: 'ຜາອຸດົມ',
  value: 'ຜາອຸດົມ'
}, {
  id: 'ປາກທາ',
  value: 'ປາກທາ'
}, {
  id: 'ຫຼວງພະບາງ',
  value: 'ຫຼວງພະບາງ'
}, {
  id: 'ຊຽງເງິນ',
  value: 'ຊຽງເງິນ'
}, {
  id: 'ນານ',
  value: 'ນານ'
}, {
  id: 'ປາກອູ',
  value: 'ປາກອູ'
}, {
  id: 'ນ້ຳບາກ',
  value: 'ນ້ຳບາກ'
}, {
  id: 'ງອຍ',
  value: 'ງອຍ'
}, {
  id: 'ປາກແຊງ',
  value: 'ປາກແຊງ'
}, {
  id: 'ໂພນໄຊ',
  value: 'ໂພນໄຊ'
}, {
  id: 'ຈອມເພັດ',
  value: 'ຈອມເພັດ'
}, {
  id: 'ວຽງຄຳ',
  value: 'ວຽງຄຳ'
}, {
  id: 'ພູຄູນ',
  value: 'ພູຄູນ'
}, {
  id: 'ໂພນທອງ',
  value: 'ໂພນທອງ'
}, {
  id: 'ຊຳເໜືອ',
  value: 'ຊຳເໜືອ'
}, {
  id: 'ຊຽງຄໍ້',
  value: 'ຊຽງຄໍ້'
}, {
  id: 'ຮ້ຽມ',
  value: 'ຮ້ຽມ'
}, {
  id: 'ວຽງໄຊ',
  value: 'ວຽງໄຊ'
}, {
  id: 'ຫົວເມືອງ',
  value: 'ຫົວເມືອງ'
}, {
  id: 'ຊຳໃຕ້',
  value: 'ຊຳໃຕ້'
}, {
  id: 'ສົບເບົາ',
  value: 'ສົບເບົາ'
}, {
  id: 'ແອດ',
  value: 'ແອດ'
}, {
  id: 'ກ້ອນ',
  value: 'ກ້ອນ'
}, {
  id: 'ຊ່ອນ',
  value: 'ຊ່ອນ'
}, {
  id: 'ໄຊຍະບູລີ',
  value: 'ໄຊຍະບູລີ'
}, {
  id: 'ຄອບ',
  value: 'ຄອບ'
}, {
  id: 'ຫົງສາ',
  value: 'ຫົງສາ'
}, {
  id: 'ເງິນ',
  value: 'ເງິນ'
}, {
  id: 'ຊຽງຮ່ອນ',
  value: 'ຊຽງຮ່ອນ'
}, {
  id: 'ພຽງ',
  value: 'ພຽງ'
}, {
  id: 'ປາກລາຍ',
  value: 'ປາກລາຍ'
}, {
  id: 'ແກ່ນທ້າວ',
  value: 'ແກ່ນທ້າວ'
}, {
  id: 'ບໍ່ແຕນ',
  value: 'ບໍ່ແຕນ'
}, {
  id: 'ທົ່ງມີໄຊ',
  value: 'ທົ່ງມີໄຊ'
}, {
  id: 'ໄຊສະຖານ',
  value: 'ໄຊສະຖານ'
}, {
  id: 'ແປກ',
  value: 'ແປກ'
}, {
  id: 'ຄຳ',
  value: 'ຄຳ'
}, {
  id: 'ໜອງແຮດ',
  value: 'ໜອງແຮດ'
}, {
  id: 'ຄູນ',
  value: 'ຄູນ'
}, {
  id: 'ໝອກໃໝ່',
  value: 'ໝອກໃໝ່'
}, {
  id: 'ພູກູດ',
  value: 'ພູກູດ'
}, {
  id: 'ຜາໄຊ',
  value: 'ຜາໄຊ'
}, {
  id: 'ປາກຊັນ',
  value: 'ປາກຊັນ'
}, {
  id: 'ທ່າພະບາດ',
  value: 'ທ່າພະບາດ'
}, {
  id: 'ປາກກະດິງ',
  value: 'ປາກກະດິງ'
}, {
  id: 'ບໍລິຄັນ',
  value: 'ບໍລິຄັນ'
}, {
  id: 'ຄຳເກີດ',
  value: 'ຄຳເກີດ'
}, {
  id: 'ວຽງທອງ',
  value: 'ວຽງທອງ'
}, {
  id: 'ໄຊຈຳພອນ',
  value: 'ໄຊຈຳພອນ'
}, {
  id: 'ທ່າແຂກ',
  value: 'ທ່າແຂກ'
}, {
  id: 'ມະຫາໄຊ',
  value: 'ມະຫາໄຊ'
}, {
  id: 'ໜອງບົກ',
  value: 'ໜອງບົກ'
}, {
  id: 'ຫີນບູນ',
  value: 'ຫີນບູນ'
}, {
  id: 'ຍົມມະລາດ',
  value: 'ຍົມມະລາດ'
}, {
  id: 'ບົວລະພາ',
  value: 'ບົວລະພາ'
}, {
  id: 'ນາກາຍ',
  value: 'ນາກາຍ'
}, {
  id: 'ເຊບັ້ງໄຟ',
  value: 'ເຊບັ້ງໄຟ'
}, {
  id: 'ໄຊບົວທອງ',
  value: 'ໄຊບົວທອງ'
}, {
  id: 'ຄູນຄຳ',
  value: 'ຄູນຄຳ'
}, {
  id: 'ສາມັກຄີໄຊ',
  value: 'ສາມັກຄີໄຊ'
}, {
  id: 'ໄຊເຊດຖາ',
  value: 'ໄຊເຊດຖາ'
}, {
  id: 'ສະໜາມໄຊ',
  value: 'ສະໜາມໄຊ'
}, {
  id: 'ສານໄຊ',
  value: 'ສານໄຊ'
}, {
  id: 'ພູວົງ',
  value: 'ພູວົງ'
}, {
  id: 'ປາກເຊ',
  value: 'ປາກເຊ'
}, {
  id: 'ຊະນະສົມບູນ',
  value: 'ຊະນະສົມບູນ'
}, {
  id: 'ບາຈຽງຈະເລີນສຸກ',
  value: 'ບາຈຽງຈະເລີນສຸກ'
}, {
  id: 'ປາກຊ່ອງ',
  value: 'ປາກຊ່ອງ'
}, {
  id: 'ປະທຸມພອນ',
  value: 'ປະທຸມພອນ'
}, {
  id: 'ໂພນທອງ',
  value: 'ໂພນທອງ'
}, {
  id: 'ຈຳປາສັກ',
  value: 'ຈຳປາສັກ'
}, {
  id: 'ສູຂຸມາ',
  value: 'ສູຂຸມາ'
}, {
  id: 'ມູນລະປະໂມກ',
  value: 'ມູນລະປະໂມກ'
}, {
  id: 'ໂຂງ',
  value: 'ໂຂງ'
}, {
  id: 'ລະມາມ',
  value: 'ລະມາມ'
}, {
  id: 'ກະເລິມ',
  value: 'ກະເລິມ'
}, {
  id: 'ດັກເຈິງ',
  value: 'ດັກເຈິງ'
}, {
  id: 'ທ່າແຕງ',
  value: 'ທ່າແຕງ'
}, {
  id: 'ສາລາວັນ',
  value: 'ສາລາວັນ'
}, {
  id: 'ຕາໂອ້ຍ',
  value: 'ຕາໂອ້ຍ'
}, {
  id: 'ຕຸ້ມລານ',
  value: 'ຕຸ້ມລານ'
}, {
  id: 'ລະຄອນເພັງ',
  value: 'ລະຄອນເພັງ'
}, {
  id: 'ວາປີ',
  value: 'ວາປີ'
}, {
  id: 'ຄົງເຊໂດນ',
  value: 'ຄົງເຊໂດນ'
}, {
  id: 'ເລົ່າງາມ',
  value: 'ເລົ່າງາມ'
}, {
  id: 'ສະມ້ວຍ',
  value: 'ສະມ້ວຍ'
}, {
  id: 'ໂພນໂຮງ',
  value: 'ໂພນໂຮງ'
}, {
  id: 'ທຸລະຄົມ',
  value: 'ທຸລະຄົມ'
}, {
  id: 'ແກ້ວອຸດົມ',
  value: 'ແກ້ວອຸດົມ'
}, {
  id: 'ກາສີ',
  value: 'ກາສີ'
}, {
  id: 'ວັງວຽງ',
  value: 'ວັງວຽງ'
}, {
  id: 'ເຟືອງ',
  value: 'ເຟືອງ'
}, {
  id: 'ຊະນະຄາມ',
  value: 'ຊະນະຄາມ'
}, {
  id: 'ແມດ',
  value: 'ແມດ'
}, {
  id: 'ວຽງຄໍາ',
  value: 'ວຽງຄໍາ'
}, {
  id: 'ຫີນເຫີບ',
  value: 'ຫີນເຫີບ'
}, {
  id: 'ໝື່ນ',
  value: 'ໝື່ນ'
}, {
  id: 'ກສອນ ພົມວິຫານ',
  value: 'ກສອນ ພົມວິຫານ'
}, {
  id: 'ອຸທຸມພອນ',
  value: 'ອຸທຸມພອນ'
}, {
  id: 'ອາດສະພັງທອງ',
  value: 'ອາດສະພັງທອງ'
}, {
  id: 'ພີນ',
  value: 'ພີນ'
}, {
  id: 'ເຊໂປນ',
  value: 'ເຊໂປນ'
}, {
  id: 'ນອງ',
  value: 'ນອງ'
}, {
  id: 'ທ່າປາງທອງ',
  value: 'ທ່າປາງທອງ'
}, {
  id: 'ສອງຄອນ',
  value: 'ສອງຄອນ'
}, {
  id: 'ຈຳພອນ',
  value: 'ຈຳພອນ'
}, {
  id: 'ຊົນນະບູລີ',
  value: 'ຊົນນະບູລີ'
}, {
  id: 'ໄຊບູລີ',
  value: 'ໄຊບູລີ'
}, {
  id: 'ວີລະບຸລີ',
  value: 'ວີລະບຸລີ'
}, {
  id: 'ອາດສະພອນ',
  value: 'ອາດສະພອນ'
}, {
  id: 'ໄຊພູທອງ',
  value: 'ໄຊພູທອງ'
}, {
  id: 'ພະລານໄຊ',
  value: 'ພະລານໄຊ'
}, {
  id: 'ອະນຸວົງ',
  value: 'ອະນຸວົງ'
}, {
  id: 'ລ້ອງແຈ້ງ',
  value: 'ລ້ອງແຈ້ງ'
}, {
  id: 'ລ້ອງຊານ',
  value: 'ລ້ອງຊານ'
}, {
  id: 'ຮົ່ມ',
  value: 'ຮົ່ມ'
}, {
  id: 'ທ່າໂທມ',
  value: 'ທ່າໂທມ'
}];

var LaosVillageList = [{
  id: 'ບ. ວັດຈັນ',
  value: 'ບ. ວັດຈັນ'
}, {
  id: 'ບ. ມີໄຊ',
  value: 'ບ. ມີໄຊ'
}, {
  id: 'ບ. ຊຽງຍືນ',
  value: 'ບ. ຊຽງຍືນ'
}, {
  id: 'ບ. ສີສະເກດ',
  value: 'ບ. ສີສະເກດ'
}, {
  id: 'ບ. ຫັດສະດີເໜືອ',
  value: 'ບ. ຫັດສະດີເໜືອ'
}, {
  id: 'ບ. ຫັດສະດີໃຕ້',
  value: 'ບ. ຫັດສະດີໃຕ້'
}, {
  id: 'ບ. ສີສະຫວາດ',
  value: 'ບ. ສີສະຫວາດ'
}, {
  id: 'ບ. ສາຍລົມ',
  value: 'ບ. ສາຍລົມ'
}, {
  id: 'ບ. ທົ່ງຂັນຄໍາ',
  value: 'ບ. ທົ່ງຂັນຄໍາ'
}, {
  id: 'ບ. ສາຍໂສກ',
  value: 'ບ. ສາຍໂສກ'
}, {
  id: 'ບ. ອານຸ',
  value: 'ບ. ອານຸ'
}, {
  id: 'ບ. ສີຫອມ',
  value: 'ບ. ສີຫອມ'
}, {
  id: 'ບ. ຂົວຫຼວງ',
  value: 'ບ. ຂົວຫຼວງ'
}, {
  id: 'ບ. ຮ່ອງຄ້າ',
  value: 'ບ. ຮ່ອງຄ້າ'
}, {
  id: 'ບ. ທົ່ງຕູມ',
  value: 'ບ. ທົ່ງຕູມ'
}, {
  id: 'ບ. ດົງໝ້ຽງ',
  value: 'ບ. ດົງໝ້ຽງ'
}, {
  id: 'ບ. ສີດໍາດວນ',
  value: 'ບ. ສີດໍາດວນ'
}, {
  id: 'ບ. ສີບຸນເຮືອງ',
  value: 'ບ. ສີບຸນເຮືອງ'
}, {
  id: 'ບ. ທົ່ງສ້າງນາງ',
  value: 'ບ. ທົ່ງສ້າງນາງ'
}, {
  id: 'ບ. ສະຫວ່າງ',
  value: 'ບ. ສະຫວ່າງ'
}, {
  id: 'ບ. ດົງປ່າແຫຼບ',
  value: 'ບ. ດົງປ່າແຫຼບ'
}, {
  id: 'ບ. ໂພນຕ້ອງຈອມມະນີ',
  value: 'ບ. ໂພນຕ້ອງຈອມມະນີ'
}, {
  id: 'ບ. ໂພນຕ້ອງສະຫວາດ',
  value: 'ບ. ໂພນຕ້ອງສະຫວາດ'
}, {
  id: 'ບ. ຮ່ອງແຊງ',
  value: 'ບ. ຮ່ອງແຊງ'
}, {
  id: 'ບ. ຮ່ອງໄກ່ແກ້ວ',
  value: 'ບ. ຮ່ອງໄກ່ແກ້ວ'
}, {
  id: 'ບ. ໂພນສະຫວ່າງ',
  value: 'ບ. ໂພນສະຫວ່າງ'
}, {
  id: 'ບ. ໜອງທາໃຕ້',
  value: 'ບ. ໜອງທາໃຕ້'
}, {
  id: 'ບ. ໜອງທາເໜືອ',
  value: 'ບ. ໜອງທາເໜືອ'
}, {
  id: 'ບ. ໜອງປີງ',
  value: 'ບ. ໜອງປີງ'
}, {
  id: 'ບ. ບໍ່ນາງົວ',
  value: 'ບ. ບໍ່ນາງົວ'
}, {
  id: 'ບ. ຫ້ວຍຫົງ',
  value: 'ບ. ຫ້ວຍຫົງ'
}, {
  id: 'ບ. ດອນແດງ',
  value: 'ບ. ດອນແດງ'
}, {
  id: 'ບ. ສີຖານເໜືອ',
  value: 'ບ. ສີຖານເໜືອ'
}, {
  id: 'ບ. ໜອງດ້ວງເໜືອ',
  value: 'ບ. ໜອງດ້ວງເໜືອ'
}, {
  id: 'ບ. ໜອງດ້ວງໃຕ້',
  value: 'ບ. ໜອງດ້ວງໃຕ້'
}, {
  id: 'ບ. ໜອງດ້ວງທົ່ງ',
  value: 'ບ. ໜອງດ້ວງທົ່ງ'
}, {
  id: 'ບ. ໂພນສະຫວາດໃຕ້',
  value: 'ບ. ໂພນສະຫວາດໃຕ້'
}, {
  id: 'ບ. ໜອງບົວທອງໃຕ້',
  value: 'ບ. ໜອງບົວທອງໃຕ້'
}, {
  id: 'ບ. ໜອງບົວທອງເໜືອ',
  value: 'ບ. ໜອງບົວທອງເໜືອ'
}, {
  id: 'ບ. ໂພນຄໍາ',
  value: 'ບ. ໂພນຄໍາ'
}, {
  id: 'ບ. ດົງນາໂຊກເໜືອ',
  value: 'ບ. ດົງນາໂຊກເໜືອ'
}, {
  id: 'ບ. ດົງນາໂຊກໃຕ້',
  value: 'ບ. ດົງນາໂຊກໃຕ້'
}, {
  id: 'ບ. ນາຄໍາ',
  value: 'ບ. ນາຄໍາ'
}, {
  id: 'ບ. ຂຸນຕາທົ່ງ',
  value: 'ບ. ຂຸນຕາທົ່ງ'
}, {
  id: 'ບ. ຂຸນຕາທ່າ',
  value: 'ບ. ຂຸນຕາທ່າ'
}, {
  id: 'ບ. ອຸບມຸງ',
  value: 'ບ. ອຸບມຸງ'
}, {
  id: 'ບ. ໜອງປາໄນ',
  value: 'ບ. ໜອງປາໄນ'
}, {
  id: 'ບ. ວັດໄຕນ້ອຍທົ່ງ',
  value: 'ບ. ວັດໄຕນ້ອຍທົ່ງ'
}, {
  id: 'ບ. ວັດໄຕໃຫຍ່ທົ່ງ',
  value: 'ບ. ວັດໄຕໃຫຍ່ທົ່ງ'
}, {
  id: 'ບ. ວັດໄຕນ້ອຍທ່າ',
  value: 'ບ. ວັດໄຕນ້ອຍທ່າ'
}, {
  id: 'ບ. ວັດໄຕໃຫຍ່ທ່າ',
  value: 'ບ. ວັດໄຕໃຫຍ່ທ່າ'
}, {
  id: 'ບ. ໜອງສະໂນຄໍາ',
  value: 'ບ. ໜອງສະໂນຄໍາ'
}, {
  id: 'ບ. ປາກທ້າງ',
  value: 'ບ. ປາກທ້າງ'
}, {
  id: 'ບ. ອາກາດ',
  value: 'ບ. ອາກາດ'
}, {
  id: 'ບ. ເມືອງວາທ່າ',
  value: 'ບ. ເມືອງວາທ່າ'
}, {
  id: 'ບ. ເມືອງວາທົ່ງ',
  value: 'ບ. ເມືອງວາທົ່ງ'
}, {
  id: 'ບ. ສີໄຄທ່າ',
  value: 'ບ. ສີໄຄທ່າ'
}, {
  id: 'ບ. ສີໄຄທົ່ງ',
  value: 'ບ. ສີໄຄທົ່ງ'
}, {
  id: 'ບ. ຍາພະ',
  value: 'ບ. ຍາພະ'
}, {
  id: 'ບ. ສີບຸນເຮືອງທົ່ງ',
  value: 'ບ. ສີບຸນເຮືອງທົ່ງ'
}, {
  id: 'ບ. ສີບຸນເຮືອງທ່າ',
  value: 'ບ. ສີບຸນເຮືອງທ່າ'
}, {
  id: 'ບ. ນາແຮ່',
  value: 'ບ. ນາແຮ່'
}, {
  id: 'ບ. ວຽງສະຫວັນ',
  value: 'ບ. ວຽງສະຫວັນ'
}, {
  id: 'ບ. ໂພສີ',
  value: 'ບ. ໂພສີ'
}, {
  id: 'ບ. ໂນນສະຫວ່າງ',
  value: 'ບ. ໂນນສະຫວ່າງ'
}, {
  id: 'ບ. ທົ່ງປົ່ງ',
  value: 'ບ. ທົ່ງປົ່ງ'
}, {
  id: 'ບ. ນາເລົ່າ',
  value: 'ບ. ນາເລົ່າ'
}, {
  id: 'ບ. ດົງນາທອງ',
  value: 'ບ. ດົງນາທອງ'
}, {
  id: 'ບ. ໜອງໜ້ຽວ',
  value: 'ບ. ໜອງໜ້ຽວ'
}, {
  id: 'ບ. ຫຼັກຫີນ',
  value: 'ບ. ຫຼັກຫີນ'
}, {
  id: 'ບ. ໜອງບຶກໃຕ້',
  value: 'ບ. ໜອງບຶກໃຕ້'
}, {
  id: 'ບ. ໜອງບຶກເໜືອ',
  value: 'ບ. ໜອງບຶກເໜືອ'
}, {
  id: 'ບ. ດົງກະເລົາ',
  value: 'ບ. ດົງກະເລົາ'
}, {
  id: 'ບ. ຊໍາເກດ',
  value: 'ບ. ຊໍາເກດ'
}, {
  id: 'ບ. ໜອງແຕ່ງໃຕ້',
  value: 'ບ. ໜອງແຕ່ງໃຕ້'
}, {
  id: 'ບ. ໜອງແຕ່ງເໜືອ',
  value: 'ບ. ໜອງແຕ່ງເໜືອ'
}, {
  id: 'ບ. ຈັນສະຫວ່າງ',
  value: 'ບ. ຈັນສະຫວ່າງ'
}, {
  id: 'ບ. ໂພນສົມບູນ',
  value: 'ບ. ໂພນສົມບູນ'
}, {
  id: 'ບ. ໂພນສະຫວາດເໜືອ',
  value: 'ບ. ໂພນສະຫວາດເໜືອ'
}, {
  id: 'ບ. ໂນນຂີ້ເຫຼັກ',
  value: 'ບ. ໂນນຂີ້ເຫຼັກ'
}, {
  id: 'ບ. ໂນນແກ້ວ',
  value: 'ບ. ໂນນແກ້ວ'
}, {
  id: 'ບ. ສີຊົມຊື່ນ',
  value: 'ບ. ສີຊົມຊື່ນ'
}, {
  id: 'ບ. ດອນຊິງຊູ້',
  value: 'ບ. ດອນຊິງຊູ້'
}, {
  id: 'ບ. ເກົ້າລ້ຽວ',
  value: 'ບ. ເກົ້າລ້ຽວ'
}, {
  id: 'ບ. ດອນຄໍາ',
  value: 'ບ. ດອນຄໍາ'
}, {
  id: 'ບ. ຕາດທອງ',
  value: 'ບ. ຕາດທອງ'
}, {
  id: 'ບ. ໜອງດາ',
  value: 'ບ. ໜອງດາ'
}, {
  id: 'ບ. ວຽງຄໍາ',
  value: 'ບ. ວຽງຄໍາ'
}, {
  id: 'ບ. ໃໝ່',
  value: 'ບ. ໃໝ່'
}, {
  id: 'ບ. ຈໍາປາ',
  value: 'ບ. ຈໍາປາ'
}, {
  id: 'ບ. ຫ້ວຍຫ້ອມ',
  value: 'ບ. ຫ້ວຍຫ້ອມ'
}, {
  id: 'ບ. ອ່າງໃຫຍ່',
  value: 'ບ. ອ່າງໃຫຍ່'
}, {
  id: 'ບ. ໂພນໄຊ',
  value: 'ບ. ໂພນໄຊ'
}, {
  id: 'ບ. ຝາຍ',
  value: 'ບ. ຝາຍ'
}, {
  id: 'ບ. ນາໄຊ',
  value: 'ບ. ນາໄຊ'
}, {
  id: 'ບ. ໜອງບອນ',
  value: 'ບ. ໜອງບອນ'
}, {
  id: 'ບ. ໂພນສະອາດ',
  value: 'ບ. ໂພນສະອາດ'
}, {
  id: 'ບ. ໜອງສ້າງທໍ່',
  value: 'ບ. ໜອງສ້າງທໍ່'
}, {
  id: 'ບ. ໂພນເຄັງ',
  value: 'ບ. ໂພນເຄັງ'
}, {
  id: 'ບ. ທາດຫຼວງເໜືອ',
  value: 'ບ. ທາດຫຼວງເໜືອ'
}, {
  id: 'ບ. ທາດຫຼວງກາງ',
  value: 'ບ. ທາດຫຼວງກາງ'
}, {
  id: 'ບ. ທາດຫຼວງໃຕ້',
  value: 'ບ. ທາດຫຼວງໃຕ້'
}, {
  id: 'ບ. ສີສັງວອນ',
  value: 'ບ. ສີສັງວອນ'
}, {
  id: 'ບ. ຮ່ອງແກ່',
  value: 'ບ. ຮ່ອງແກ່'
}, {
  id: 'ບ. ສະພັ້ງໝໍ້',
  value: 'ບ. ສະພັ້ງໝໍ້'
}, {
  id: 'ບ. ໂພນທັນໃຕ້',
  value: 'ບ. ໂພນທັນໃຕ້'
}, {
  id: 'ບ. ໂພນທັນເໜືອ',
  value: 'ບ. ໂພນທັນເໜືອ'
}, {
  id: 'ບ. ວຽງຈະເລີນ',
  value: 'ບ. ວຽງຈະເລີນ'
}, {
  id: 'ບ. ໂພນພະເນົາ',
  value: 'ບ. ໂພນພະເນົາ'
}, {
  id: 'ບ. ຈອມມະນີເໜືອ',
  value: 'ບ. ຈອມມະນີເໜືອ'
}, {
  id: 'ບ. ຈອມມະນີກາງ',
  value: 'ບ. ຈອມມະນີກາງ'
}, {
  id: 'ບ. ຈອມມະນີໃຕ້',
  value: 'ບ. ຈອມມະນີໃຕ້'
}, {
  id: 'ບ. ໜອງໜ່ຽງ',
  value: 'ບ. ໜອງໜ່ຽງ'
}, {
  id: 'ບ. ຮ່ອງສຸພາບ',
  value: 'ບ. ຮ່ອງສຸພາບ'
}, {
  id: 'ບ. ໂນນສະຫວັນ',
  value: 'ບ. ໂນນສະຫວັນ'
}, {
  id: 'ບ. ໂນນສະຫງ່າ',
  value: 'ບ. ໂນນສະຫງ່າ'
}, {
  id: 'ບ. ໂນນສະຫວ່າງ',
  value: 'ບ. ໂນນສະຫວ່າງ'
}, {
  id: 'ບ. ວັງຊາຍ',
  value: 'ບ. ວັງຊາຍ'
}, {
  id: 'ບ. ຫົວຂົວ',
  value: 'ບ. ຫົວຂົວ'
}, {
  id: 'ບ. ໂນນຄໍ້ເໜືອ',
  value: 'ບ. ໂນນຄໍ້ເໜືອ'
}, {
  id: 'ບ. ໂນນຄໍ້ໃຕ້',
  value: 'ບ. ໂນນຄໍ້ໃຕ້'
}, {
  id: 'ບ. ໂນນຫວາຍ',
  value: 'ບ. ໂນນຫວາຍ'
}, {
  id: 'ບ. ຄໍາສະຫວາດ',
  value: 'ບ. ຄໍາສະຫວາດ'
}, {
  id: 'ບ. ໂຊກຄໍາ',
  value: 'ບ. ໂຊກຄໍາ'
}, {
  id: 'ບ. ແສງສະຫວ່າງ',
  value: 'ບ. ແສງສະຫວ່າງ'
}, {
  id: 'ບ. ອາມອນ',
  value: 'ບ. ອາມອນ'
}, {
  id: 'ບ. ຊໍາເຄ້',
  value: 'ບ. ຊໍາເຄ້'
}, {
  id: 'ບ. ໂຊກໃຫຍ່',
  value: 'ບ. ໂຊກໃຫຍ່'
}, {
  id: 'ບ. ໂຊກນ້ອຍ',
  value: 'ບ. ໂຊກນ້ອຍ'
}, {
  id: 'ບ. ໂພນທອງ',
  value: 'ບ. ໂພນທອງ'
}, {
  id: 'ບ. ນາບຽນ',
  value: 'ບ. ນາບຽນ'
}, {
  id: 'ບ. ຂາມງອຍ',
  value: 'ບ. ຂາມງອຍ'
}, {
  id: 'ບ. ດຸງ',
  value: 'ບ. ດຸງ'
}, {
  id: 'ບ. ນາສ້າງໄຜ່',
  value: 'ບ. ນາສ້າງໄຜ່'
}, {
  id: 'ບ. ໄຮ່ຄໍາ',
  value: 'ບ. ໄຮ່ຄໍາ'
}, {
  id: 'ບ. ສົມສະຫງ່າ',
  value: 'ບ. ສົມສະຫງ່າ'
}, {
  id: 'ບ. ເມືອງນ້ອຍ',
  value: 'ບ. ເມືອງນ້ອຍ'
}, {
  id: 'ບ. ຊຽງດາ',
  value: 'ບ. ຊຽງດາ'
}, {
  id: 'ບ. ນາຄວາຍໃຕ້',
  value: 'ບ. ນາຄວາຍໃຕ້'
}, {
  id: 'ບ. ຈອມລີ',
  value: 'ບ. ຈອມລີ'
}, {
  id: 'ບ. ນາໂນ',
  value: 'ບ. ນາໂນ'
}, {
  id: 'ບ. ເພຍວັດ',
  value: 'ບ. ເພຍວັດ'
}, {
  id: 'ບ. ສີເມືອງ',
  value: 'ບ. ສີເມືອງ'
}, {
  id: 'ບ. ທາດຂາວ',
  value: 'ບ. ທາດຂາວ'
}, {
  id: 'ບ. ເກົ້າຍອດ',
  value: 'ບ. ເກົ້າຍອດ'
}, {
  id: 'ບ. ພະໂພ',
  value: 'ບ. ພະໂພ'
}, {
  id: 'ບ. ພະໄຊ',
  value: 'ບ. ພະໄຊ'
}, {
  id: 'ບ. ໜອງຈັນ',
  value: 'ບ. ໜອງຈັນ'
}, {
  id: 'ບ. ດົງປ່າລານທົ່ງ',
  value: 'ບ. ດົງປ່າລານທົ່ງ'
}, {
  id: 'ບ. ດົງປ່າລານທາ',
  value: 'ບ. ດົງປ່າລານທາ'
}, {
  id: 'ບ. ໂພນສະຫວັນເໜືອ',
  value: 'ບ. ໂພນສະຫວັນເໜືອ'
}, {
  id: 'ບ. ໂພນສີນວນ',
  value: 'ບ. ໂພນສີນວນ'
}, {
  id: 'ບ. ໂພນສະຫວັນໃຕ້',
  value: 'ບ. ໂພນສະຫວັນໃຕ້'
}, {
  id: 'ບ. ທົ່ງພານທອງ',
  value: 'ບ. ທົ່ງພານທອງ'
}, {
  id: 'ບ. ສະພານທອງເໜືອ',
  value: 'ບ. ສະພານທອງເໜືອ'
}, {
  id: 'ບ. ສະພານທອງໃຕ້',
  value: 'ບ. ສະພານທອງໃຕ້'
}, {
  id: 'ບ. ໂພນປ່າເປົ້າ',
  value: 'ບ. ໂພນປ່າເປົ້າ'
}, {
  id: 'ບ. ດອນກອຍ',
  value: 'ບ. ດອນກອຍ'
}, {
  id: 'ບ. ດອນນົກຂຸ້ມ',
  value: 'ບ. ດອນນົກຂຸ້ມ'
}, {
  id: 'ບ. ໂສກປ່າຫຼວງ',
  value: 'ບ. ໂສກປ່າຫຼວງ'
}, {
  id: 'ບ. ບຶງຂະຫຍອງ',
  value: 'ບ. ບຶງຂະຫຍອງ'
}, {
  id: 'ບ. ວັດນາກ',
  value: 'ບ. ວັດນາກ'
}, {
  id: 'ບ. ທົ່ງກາງ',
  value: 'ບ. ທົ່ງກາງ'
}, {
  id: 'ບ. ທ່າພະລານໄຊ',
  value: 'ບ. ທ່າພະລານໄຊ'
}, {
  id: 'ບ. ດອນປ່າໄໝ່',
  value: 'ບ. ດອນປ່າໄໝ່'
}, {
  id: 'ບ. ພັນໝັ້ນ',
  value: 'ບ. ພັນໝັ້ນ'
}, {
  id: 'ບ. ວັດສົບ',
  value: 'ບ. ວັດສົບ'
}, {
  id: 'ບ. ໂພໄຊ',
  value: 'ບ. ໂພໄຊ'
}, {
  id: 'ບ. ສວນມອນ',
  value: 'ບ. ສວນມອນ'
}, {
  id: 'ບ. ສ້າງເຫວີຍ',
  value: 'ບ. ສ້າງເຫວີຍ'
}, {
  id: 'ບ. ຫາຍໂສກ',
  value: 'ບ. ຫາຍໂສກ'
}, {
  id: 'ບ. ຈອມແຈ້ງ',
  value: 'ບ. ຈອມແຈ້ງ'
}, {
  id: 'ບ. ໂຄກນິນ',
  value: 'ບ. ໂຄກນິນ'
}, {
  id: 'ບ. ໂພນສະຫວ່າງ',
  value: 'ບ. ໂພນສະຫວ່າງ'
}, {
  id: 'ບ. ໄຊສະຖານ',
  value: 'ບ. ໄຊສະຖານ'
}, {
  id: 'ບ. ຈອມເພັດເໜືອ',
  value: 'ບ. ຈອມເພັດເໜືອ'
}, {
  id: 'ບ. ຈອມເພັດໃຕ້',
  value: 'ບ. ຈອມເພັດໃຕ້'
}, {
  id: 'ບ. ດົງສະຫວາດ',
  value: 'ບ. ດົງສະຫວາດ'
}, {
  id: 'ບ. ໄຊມຸງຄຸນ',
  value: 'ບ. ໄຊມຸງຄຸນ'
}, {
  id: 'ບ. ສີເກີດ',
  value: 'ບ. ສີເກີດ'
}, {
  id: 'ບ. ຜາງແຫ້ງ',
  value: 'ບ. ຜາງແຫ້ງ'
}, {
  id: 'ບ. ນາລຽນ',
  value: 'ບ. ນາລຽນ'
}, {
  id: 'ບ. ດົງຫຼວງ',
  value: 'ບ. ດົງຫຼວງ'
}, {
  id: 'ບ. ໂພນສະຫວັນ',
  value: 'ບ. ໂພນສະຫວັນ'
}, {
  id: 'ບ. ໂພນແກ້ວ',
  value: 'ບ. ໂພນແກ້ວ'
}, {
  id: 'ບ. ນາສ້ຽວ',
  value: 'ບ. ນາສ້ຽວ'
}, {
  id: 'ບ. ດົງຊຽງດີ',
  value: 'ບ. ດົງຊຽງດີ'
}, {
  id: 'ບ. ໜອງຍາວ',
  value: 'ບ. ໜອງຍາວ'
}, {
  id: 'ບ. ດົງບອງ',
  value: 'ບ. ດົງບອງ'
}, {
  id: 'ບ. ນາຄູນໃຕ້',
  value: 'ບ. ນາຄູນໃຕ້'
}, {
  id: 'ບ. ນາຄູນເໜືອ',
  value: 'ບ. ນາຄູນເໜືອ'
}, {
  id: 'ບ. ນາຊາຍທອງໃຕ້',
  value: 'ບ. ນາຊາຍທອງໃຕ້'
}, {
  id: 'ບ. ນາຊາຍທອງກາງ',
  value: 'ບ. ນາຊາຍທອງກາງ'
}, {
  id: 'ບ. ນາຊາຍທອງເໜືອ',
  value: 'ບ. ນາຊາຍທອງເໜືອ'
}, {
  id: 'ບ. ຫົວຊ້າງ',
  value: 'ບ. ຫົວຊ້າງ'
}, {
  id: 'ບ. ນາຊອນ',
  value: 'ບ. ນາຊອນ'
}, {
  id: 'ບ. ຫົວຂົວ',
  value: 'ບ. ຫົວຂົວ'
}, {
  id: 'ບ. ໜອງຄັນຄູ',
  value: 'ບ. ໜອງຄັນຄູ'
}, {
  id: 'ບ. ນໍ້າກ້ຽງໃຕ້',
  value: 'ບ. ນໍ້າກ້ຽງໃຕ້'
}, {
  id: 'ບ.ນໍ້າກ້ຽງເໜືອ',
  value: 'ບ.ນໍ້າກ້ຽງເໜືອ'
}, {
  id: 'ບ. ນາຊັບ',
  value: 'ບ. ນາຊັບ'
}, {
  id: 'ບ. ເປີກ',
  value: 'ບ. ເປີກ'
}, {
  id: 'ບ. ອີ່ໄລໃຕ້',
  value: 'ບ. ອີ່ໄລໃຕ້'
}, {
  id: 'ບ.ອີ່ໄລເໜືອ',
  value: 'ບ.ອີ່ໄລເໜືອ'
}, {
  id: 'ບ. ສອງຂົວກາງແສນ',
  value: 'ບ. ສອງຂົວກາງແສນ'
}, {
  id: 'ບ. ແຈ້ງສະຫວ່າງ',
  value: 'ບ. ແຈ້ງສະຫວ່າງ'
}, {
  id: 'ບ. ສີສະຫວາດ',
  value: 'ບ. ສີສະຫວາດ'
}, {
  id: 'ບ. ຫ້ວຍນໍ້າເຢັນ',
  value: 'ບ. ຫ້ວຍນໍ້າເຢັນ'
}, {
  id: 'ບ. ນໍ້າຫຸມ',
  value: 'ບ. ນໍ້າຫຸມ'
}, {
  id: 'ບ. ສົງເປືອຍໃຕ້',
  value: 'ບ. ສົງເປືອຍໃຕ້'
}, {
  id: 'ບ. ສົງເປືອຍເໜືອ',
  value: 'ບ. ສົງເປືອຍເໜືອ'
}, {
  id: 'ບ. ໂພນຄໍາ',
  value: 'ບ. ໂພນຄໍາ'
}, {
  id: 'ບ. ຫົວນາ',
  value: 'ບ. ຫົວນາ'
}, {
  id: 'ບ. ນາໜາດ',
  value: 'ບ. ນາໜາດ'
}, {
  id: 'ບ. ຫຸ່ມແບ່ງ',
  value: 'ບ. ຫຸ່ມແບ່ງ'
}, {
  id: 'ບ. ແສນດິນ',
  value: 'ບ. ແສນດິນ'
}, {
  id: 'ບ. ຮ່ອງງົວ',
  value: 'ບ. ຮ່ອງງົວ'
}, {
  id: 'ບ. ນາຂ່າ',
  value: 'ບ. ນາຂ່າ'
}, {
  id: 'ບ. ໂພນມ່ວງ',
  value: 'ບ. ໂພນມ່ວງ'
}, {
  id: 'ບ. ນາງ່າ',
  value: 'ບ. ນາງ່າ'
}, {
  id: 'ບ. ບົວ',
  value: 'ບ. ບົວ'
}, {
  id: 'ບ. ພັດທະນາ',
  value: 'ບ. ພັດທະນາ'
}, {
  id: 'ບ. ໜອງສະ',
  value: 'ບ. ໜອງສະ'
}, {
  id: 'ບ. ນາດີ',
  value: 'ບ. ນາດີ'
}, {
  id: 'ບ. ໂພນທອງ',
  value: 'ບ. ໂພນທອງ'
}, {
  id: 'ບ. ໂພໄຊ',
  value: 'ບ. ໂພໄຊ'
}, {
  id: 'ບ. ໂພສີ',
  value: 'ບ. ໂພສີ'
}, {
  id: 'ບ. ສີວິໄລ',
  value: 'ບ. ສີວິໄລ'
}, {
  id: 'ບ. ຖໍ້າ',
  value: 'ບ. ຖໍ້າ'
}, {
  id: 'ບ. ນາທ່ອນ',
  value: 'ບ. ນາທ່ອນ'
}, {
  id: 'ບ. ອ່າງນໍ້າຫຸມ',
  value: 'ບ. ອ່າງນໍ້າຫຸມ'
}, {
  id: 'ບ. ນາຍາງ',
  value: 'ບ. ນາຍາງ'
}, {
  id: 'ບ. ດ່ານຊີ',
  value: 'ບ. ດ່ານຊີ'
}, {
  id: 'ບ. ປາກແຮດ',
  value: 'ບ. ປາກແຮດ'
}, {
  id: 'ບ. ສາຍນໍ້າເງິນ',
  value: 'ບ. ສາຍນໍ້າເງິນ'
}, {
  id: 'ບ. ສີວິໄລ',
  value: 'ບ. ສີວິໄລ'
}, {
  id: 'ບ. ຄໍາຮຸ່ງ',
  value: 'ບ. ຄໍາຮຸ່ງ'
}, {
  id: 'ບ. ພະຂາວ',
  value: 'ບ. ພະຂາວ'
}, {
  id: 'ບ. ຊ້າງຄູ',
  value: 'ບ. ຊ້າງຄູ'
}, {
  id: 'ບ. ສະພັງເມິກ',
  value: 'ບ. ສະພັງເມິກ'
}, {
  id: 'ບ. ດົງໂດກ',
  value: 'ບ. ດົງໂດກ'
}, {
  id: 'ບ. ຕານມີໄຊ',
  value: 'ບ. ຕານມີໄຊ'
}, {
  id: 'ບ. ໜອງພະຍາ',
  value: 'ບ. ໜອງພະຍາ'
}, {
  id: 'ບ. ນາທົ່ມ',
  value: 'ບ. ນາທົ່ມ'
}, {
  id: 'ບ. ໜອງວຽງຄໍາ',
  value: 'ບ. ໜອງວຽງຄໍາ'
}, {
  id: 'ບ. ດອນໜູນ',
  value: 'ບ. ດອນໜູນ'
}, {
  id: 'ບ. ໄຊ',
  value: 'ບ. ໄຊ'
}, {
  id: 'ບ. ໄຊສະຫວ່າງ',
  value: 'ບ. ໄຊສະຫວ່າງ'
}, {
  id: 'ບ. ຫ້ວຍແດນເມືອງ',
  value: 'ບ. ຫ້ວຍແດນເມືອງ'
}, {
  id: 'ບ. ວຽງແກ້ວ',
  value: 'ບ. ວຽງແກ້ວ'
}, {
  id: 'ບ. ໂນນແສງຈັນ',
  value: 'ບ. ໂນນແສງຈັນ'
}, {
  id: 'ບ. ຫ້ວຍເຕີຍ',
  value: 'ບ. ຫ້ວຍເຕີຍ'
}, {
  id: 'ບ. ດອນຕິ້ວ',
  value: 'ບ. ດອນຕິ້ວ'
}, {
  id: 'ບ. ດ່ານຊ້າງ',
  value: 'ບ. ດ່ານຊ້າງ'
}, {
  id: 'ບ. ໂນນສະອາດ',
  value: 'ບ. ໂນນສະອາດ'
}, {
  id: 'ບ. ໂນນບໍ່ແກ້ວ',
  value: 'ບ. ໂນນບໍ່ແກ້ວ'
}, {
  id: 'ບ. ນາ',
  value: 'ບ. ນາ'
}, {
  id: 'ບ. ທ່າງ່ອນ',
  value: 'ບ. ທ່າງ່ອນ'
}, {
  id: 'ບ. ທ່າສະຫວ່າງ',
  value: 'ບ. ທ່າສະຫວ່າງ'
}, {
  id: 'ບ. ວຽງພູຄໍາ',
  value: 'ບ. ວຽງພູຄໍາ'
}, {
  id: 'ບ. ແກ້ງໄຄ້',
  value: 'ບ. ແກ້ງໄຄ້'
}, {
  id: 'ບ. ໄຮ່',
  value: 'ບ. ໄຮ່'
}, {
  id: 'ບ. ເວີນຄໍາ',
  value: 'ບ. ເວີນຄໍາ'
}, {
  id: 'ບ. ສາມສະອາດ',
  value: 'ບ. ສາມສະອາດ'
}, {
  id: 'ບ. ໂພນງາມ',
  value: 'ບ. ໂພນງາມ'
}, {
  id: 'ບ. ໂພນໄຊ',
  value: 'ບ. ໂພນໄຊ'
}, {
  id: 'ບ. ຈະເລີນໄຊ',
  value: 'ບ. ຈະເລີນໄຊ'
}, {
  id: 'ບ. ໜອງໂນ',
  value: 'ບ. ໜອງໂນ'
}, {
  id: 'ບ. ໜອງເຂັງ',
  value: 'ບ. ໜອງເຂັງ'
}, {
  id: 'ບ. ໂພນໄຮ່ຄໍາ',
  value: 'ບ. ໂພນໄຮ່ຄໍາ'
}, {
  id: 'ບ. ໂພນໂຮງ',
  value: 'ບ. ໂພນໂຮງ'
}, {
  id: 'ບ. ຫາດກ້ຽງ',
  value: 'ບ. ຫາດກ້ຽງ'
}, {
  id: 'ບ. ທ່າສົ້ມມໍ',
  value: 'ບ. ທ່າສົ້ມມໍ'
}, {
  id: 'ບ. ໂພນຄໍ້',
  value: 'ບ. ໂພນຄໍ້'
}, {
  id: 'ບ. ນາກຸງ',
  value: 'ບ. ນາກຸງ'
}, {
  id: 'ບ. ທົ່ງມັ່ງ',
  value: 'ບ. ທົ່ງມັ່ງ'
}, {
  id: 'ບ. ຂຸດສາມບາດ',
  value: 'ບ. ຂຸດສາມບາດ'
}, {
  id: 'ບ. ຫົວຂົວ',
  value: 'ບ. ຫົວຂົວ'
}, {
  id: 'ບ. ຫົວນາ',
  value: 'ບ. ຫົວນາ'
}, {
  id: 'ບ. ນາຄັນທຸງ',
  value: 'ບ. ນາຄັນທຸງ'
}, {
  id: 'ບ. ຊໍາບອນ',
  value: 'ບ. ຊໍາບອນ'
}, {
  id: 'ບ. ໂພນແພງ',
  value: 'ບ. ໂພນແພງ'
}, {
  id: 'ບ. ນາຄາຍ',
  value: 'ບ. ນາຄາຍ'
}, {
  id: 'ບ. ນາໂງນໃໝ່',
  value: 'ບ. ນາໂງນໃໝ່'
}, {
  id: 'ບ. ນາໂງນເກົ່າ',
  value: 'ບ. ນາໂງນເກົ່າ'
}, {
  id: 'ບ. ນາຕານ',
  value: 'ບ. ນາຕານ'
}, {
  id: 'ບ. ທ່າຈໍາປາ',
  value: 'ບ. ທ່າຈໍາປາ'
}, {
  id: 'ບ. ເວີນແທນ',
  value: 'ບ. ເວີນແທນ'
}, {
  id: 'ບ. ທ່າດິນແດງໃຕ້',
  value: 'ບ. ທ່າດິນແດງໃຕ້'
}, {
  id: 'ບ. ທ່າດິນແດງເໜືອ',
  value: 'ບ. ທ່າດິນແດງເໜືອ'
}, {
  id: 'ບ. ນາແຖ',
  value: 'ບ. ນາແຖ'
}, {
  id: 'ບ. ດວງບຸດດີ',
  value: 'ບ. ດວງບຸດດີ'
}, {
  id: 'ບ. ຫາດພະອິນ',
  value: 'ບ. ຫາດພະອິນ'
}, {
  id: 'ບ. ທ່າດອກຄໍາ',
  value: 'ບ. ທ່າດອກຄໍາ'
}, {
  id: 'ບ. ໂພນຕ້ອງ',
  value: 'ບ. ໂພນຕ້ອງ'
}, {
  id: 'ບ. ໂພນງາມ 1',
  value: 'ບ. ໂພນງາມ 1'
}, {
  id: 'ບ. ໂພນງາມ 2',
  value: 'ບ. ໂພນງາມ 2'
}, {
  id: 'ບ. ໜອງສອງຫ້ອງ',
  value: 'ບ. ໜອງສອງຫ້ອງ'
}, {
  id: 'ບ. ປາກຊາບເກົ່າ',
  value: 'ບ. ປາກຊາບເກົ່າ'
}, {
  id: 'ບ. ປາກຊາບໃໝ່',
  value: 'ບ. ປາກຊາບໃໝ່'
}, {
  id: 'ບ. ສົມສະໄໝ',
  value: 'ບ. ສົມສະໄໝ'
}, {
  id: 'ບ. ປ່າໄລ່',
  value: 'ບ. ປ່າໄລ່'
}, {
  id: 'ບ. ຫາດວຽງຄໍາ',
  value: 'ບ. ຫາດວຽງຄໍາ'
}, {
  id: 'ບ. ດູນອຽນ',
  value: 'ບ. ດູນອຽນ'
}, {
  id: 'ບ. ນາຂາວ',
  value: 'ບ. ນາຂາວ'
}, {
  id: 'ບ. ແສນອຸດົມ',
  value: 'ບ. ແສນອຸດົມ'
}, {
  id: 'ບ. ນາພອກ',
  value: 'ບ. ນາພອກ'
}, {
  id: 'ບ. ນາມົນ',
  value: 'ບ. ນາມົນ'
}, {
  id: 'ບ. ທ່ານາກ',
  value: 'ບ. ທ່ານາກ'
}, {
  id: 'ບ. ໜອງບົວ',
  value: 'ບ. ໜອງບົວ'
}, {
  id: 'ບ. ດົງບັງ',
  value: 'ບ. ດົງບັງ'
}, {
  id: 'ບ. ນາສາລາ',
  value: 'ບ. ນາສາລາ'
}, {
  id: 'ບ. ໂນນແຕ້',
  value: 'ບ. ໂນນແຕ້'
}, {
  id: 'ບ. ລາດຄວາຍ',
  value: 'ບ. ລາດຄວາຍ'
}, {
  id: 'ບ. ອຸດົມຜົນ',
  value: 'ບ. ອຸດົມຜົນ'
}, {
  id: 'ບ. ດົງໝາກຄາຍ',
  value: 'ບ. ດົງໝາກຄາຍ'
}, {
  id: 'ບ. ໂພນຄໍາ',
  value: 'ບ. ໂພນຄໍາ'
}, {
  id: 'ບ. ດົງສ້າງຫີນ',
  value: 'ບ. ດົງສ້າງຫີນ'
}, {
  id: 'ບ. ນາແຄ',
  value: 'ບ. ນາແຄ'
}, {
  id: 'ບ. ໂຄກໃຫຍ່',
  value: 'ບ. ໂຄກໃຫຍ່'
}, {
  id: 'ບ. ໂຄກນ້ອຍ',
  value: 'ບ. ໂຄກນ້ອຍ'
}, {
  id: 'ບ. ໂພຄໍາ',
  value: 'ບ. ໂພຄໍາ'
}, {
  id: 'ບ. ນາລ້ອມ',
  value: 'ບ. ນາລ້ອມ'
}, {
  id: 'ບ. ສະພັງຄະນົງ',
  value: 'ບ. ສະພັງຄະນົງ'
}, {
  id: 'ບ. ໂຄກສະອາດ',
  value: 'ບ. ໂຄກສະອາດ'
}, {
  id: 'ບ. ໂຄກສີວິໄລ',
  value: 'ບ. ໂຄກສີວິໄລ'
}, {
  id: 'ບ. ໄຊສົມບູນ',
  value: 'ບ. ໄຊສົມບູນ'
}, {
  id: 'ບ. ໂນນທອງ',
  value: 'ບ. ໂນນທອງ'
}, {
  id: 'ບ. ໄຜ່ລ້ອມ',
  value: 'ບ. ໄຜ່ລ້ອມ'
}, {
  id: 'ບ. ສົມສະຫວັນ',
  value: 'ບ. ສົມສະຫວັນ'
}, {
  id: 'ບ. ສ້າງຄອມ',
  value: 'ບ. ສ້າງຄອມ'
}, {
  id: 'ບ. ຫົວຊຽງ',
  value: 'ບ. ຫົວຊຽງ'
}, {
  id: 'ບ. ສ້າງຫົວບໍ່',
  value: 'ບ. ສ້າງຫົວບໍ່'
}, {
  id: 'ບ. ດົງຄວາຍ',
  value: 'ບ. ດົງຄວາຍ'
}, {
  id: 'ບ. ດອນລຸ່ມ',
  value: 'ບ. ດອນລຸ່ມ'
}, {
  id: 'ບ. ໂຄກສະຫວ່າງ',
  value: 'ບ. ໂຄກສະຫວ່າງ'
}, {
  id: 'ບ. ໂພນສະຫວັນ',
  value: 'ບ. ໂພນສະຫວັນ'
}, {
  id: 'ບ. ນາຜາສຸກ',
  value: 'ບ. ນາຜາສຸກ'
}, {
  id: 'ບ. ບໍ່ເຫຼັກ',
  value: 'ບ. ບໍ່ເຫຼັກ'
}, {
  id: 'ບ. ຫາດຊາຍຂາວ',
  value: 'ບ. ຫາດຊາຍຂາວ'
}, {
  id: 'ບ. ສົມຫວັງເໜືອ',
  value: 'ບ. ສົມຫວັງເໜືອ'
}, {
  id: 'ບ. ສົມຫວັງໃຕ້',
  value: 'ບ. ສົມຫວັງໃຕ້'
}, {
  id: 'ບ. ໜອງໄຮ',
  value: 'ບ. ໜອງໄຮ'
}, {
  id: 'ບ. ດົງຄໍາຊ້າງ',
  value: 'ບ. ດົງຄໍາຊ້າງ'
}, {
  id: 'ບ. ສົມສະໜຸກ',
  value: 'ບ. ສົມສະໜຸກ'
}, {
  id: 'ບ. ດອນດູ່',
  value: 'ບ. ດອນດູ່'
}, {
  id: 'ບ. ທ່ານາ',
  value: 'ບ. ທ່ານາ'
}, {
  id: 'ບ. ບໍ່ໂອ',
  value: 'ບ. ບໍ່ໂອ'
}, {
  id: 'ບ. ພ້າວ',
  value: 'ບ. ພ້າວ'
}, {
  id: 'ບ. ດອນຂາຊ້າຍ',
  value: 'ບ. ດອນຂາຊ້າຍ'
}, {
  id: 'ບ. ກາງ',
  value: 'ບ. ກາງ'
}, {
  id: 'ບ. ແກ້ງຍາງ',
  value: 'ບ. ແກ້ງຍາງ'
}, {
  id: 'ບ. ສົມໂຮງ',
  value: 'ບ. ສົມໂຮງ'
}, {
  id: 'ບ. ແກ້ງປາຢ້າງ',
  value: 'ບ. ແກ້ງປາຢ້າງ'
}, {
  id: 'ບ. ນາທາມ',
  value: 'ບ. ນາທາມ'
}, {
  id: 'ບ. ຫາດດອນແກ້ວ',
  value: 'ບ. ຫາດດອນແກ້ວ'
}, {
  id: 'ບ. ຫາດກັນຊາ',
  value: 'ບ. ຫາດກັນຊາ'
}, {
  id: 'ບ. ຫົວຫ້າ',
  value: 'ບ. ຫົວຫ້າ'
}, {
  id: 'ບ. ດອນເກີດ',
  value: 'ບ. ດອນເກີດ'
}, {
  id: 'ບ. ໂພເງິນ',
  value: 'ບ. ໂພເງິນ'
}, {
  id: 'ບ. ໂພສີ',
  value: 'ບ. ໂພສີ'
}, {
  id: 'ບ. ສະຫວ່າງ',
  value: 'ບ. ສະຫວ່າງ'
}, {
  id: 'ບ. ປ່າຝາງ',
  value: 'ບ. ປ່າຝາງ'
}, {
  id: 'ບ. ຈອມທອງ',
  value: 'ບ. ຈອມທອງ'
}, {
  id: 'ບ. ຈຽມປາງ',
  value: 'ບ. ຈຽມປາງ'
}, {
  id: 'ບ. ຫ້ອມໃຕ້',
  value: 'ບ. ຫ້ອມໃຕ້'
}, {
  id: 'ບ. ຖິ່ນເພຍ',
  value: 'ບ. ຖິ່ນເພຍ'
}, {
  id: 'ບ. ທ່າແຂກ',
  value: 'ບ. ທ່າແຂກ'
}, {
  id: 'ບ. ຊາຍຟອງເໜືອ',
  value: 'ບ. ຊາຍຟອງເໜືອ'
}, {
  id: 'ບ. ຊາຍຟອງໃຕ້',
  value: 'ບ. ຊາຍຟອງໃຕ້'
}, {
  id: 'ບ. ໂຄກຊາຍ',
  value: 'ບ. ໂຄກຊາຍ'
}, {
  id: 'ບ. ສີຖານໃຕ້',
  value: 'ບ. ສີຖານໃຕ້'
}, {
  id: 'ບ. ດອນຝ້າຍ',
  value: 'ບ. ດອນຝ້າຍ'
}, {
  id: 'ບ. ສາລະຄໍາໃຕ້',
  value: 'ບ. ສາລະຄໍາໃຕ້'
}, {
  id: 'ບ. ສາລາຄໍາເໜືອ',
  value: 'ບ. ສາລາຄໍາເໜືອ'
}, {
  id: 'ບ. ດົງໂພນເລົາ',
  value: 'ບ. ດົງໂພນເລົາ'
}, {
  id: 'ບ. ໜອງແວງ',
  value: 'ບ. ໜອງແວງ'
}, {
  id: 'ບ. ນາໄຫ',
  value: 'ບ. ນາໄຫ'
}, {
  id: 'ບ. ນາໄຮ່',
  value: 'ບ. ນາໄຮ່'
}, {
  id: 'ບ. ໜອງແຮ້ວ',
  value: 'ບ. ໜອງແຮ້ວ'
}, {
  id: 'ບ. ດົງໂພສີ',
  value: 'ບ. ດົງໂພສີ'
}, {
  id: 'ບ. ດົງໂພແຮ່',
  value: 'ບ. ດົງໂພແຮ່'
}, {
  id: 'ບ. ທ່ານາແລ້ງ',
  value: 'ບ. ທ່ານາແລ້ງ'
}, {
  id: 'ບ. ທ່າມ່ວງ',
  value: 'ບ. ທ່າມ່ວງ'
}, {
  id: 'ບ. ປ່າຫວ້າ',
  value: 'ບ. ປ່າຫວ້າ'
}, {
  id: 'ບ. ທ່າເດືອ',
  value: 'ບ. ທ່າເດືອ'
}, {
  id: 'ບ. ຖິ່ນຕົມ',
  value: 'ບ. ຖິ່ນຕົມ'
}, {
  id: 'ບ. ຄໍາຈະເລີນ',
  value: 'ບ. ຄໍາຈະເລີນ'
}, {
  id: 'ບ. ໜອງແປນເໜືອ',
  value: 'ບ. ໜອງແປນເໜືອ'
}, {
  id: 'ບ. ໜອງແປນໃຕ້',
  value: 'ບ. ໜອງແປນໃຕ້'
}, {
  id: 'ບ. ຊຽງຄວນ',
  value: 'ບ. ຊຽງຄວນ'
}, {
  id: 'ບ. ທ່າພະ',
  value: 'ບ. ທ່າພະ'
}, {
  id: 'ບ. ໜອງພົງ',
  value: 'ບ. ໜອງພົງ'
}, {
  id: 'ບ. ປາກເປັ່ງ',
  value: 'ບ. ປາກເປັ່ງ'
}, {
  id: 'ບ. ຖິ່ນແທ່ນ',
  value: 'ບ. ຖິ່ນແທ່ນ'
}, {
  id: 'ບ. ຄວາຍແດງ',
  value: 'ບ. ຄວາຍແດງ'
}, {
  id: 'ບ. ສິມມະໂນເໜືອ',
  value: 'ບ. ສິມມະໂນເໜືອ'
}, {
  id: 'ບ. ສິມມະໂນໃຕ້',
  value: 'ບ. ສິມມະໂນໃຕ້'
}, {
  id: 'ບ. ນາລ້ອງ',
  value: 'ບ. ນາລ້ອງ'
}, {
  id: 'ບ. ສໍາພັນນາ',
  value: 'ບ. ສໍາພັນນາ'
}, {
  id: 'ບ. ແກ້ງໝໍ້',
  value: 'ບ. ແກ້ງໝໍ້'
}, {
  id: 'ບ. ທ່ານາສ້າງຫີນ',
  value: 'ບ. ທ່ານາສ້າງຫີນ'
}, {
  id: 'ບ. ດອນກາງຂອງ',
  value: 'ບ. ດອນກາງຂອງ'
}, {
  id: 'ບ. ປາກຕອນ',
  value: 'ບ. ປາກຕອນ'
}, {
  id: 'ບ. ຫີນລັບ',
  value: 'ບ. ຫີນລັບ'
}, {
  id: 'ບ. ໂຄກເພີງ',
  value: 'ບ. ໂຄກເພີງ'
}, {
  id: 'ບ. ຫ້ວຍລໍາ',
  value: 'ບ. ຫ້ວຍລໍາ'
}, {
  id: 'ບ. ນາຫອຍ',
  value: 'ບ. ນາຫອຍ'
}, {
  id: 'ບ. ສະໄກ',
  value: 'ບ. ສະໄກ'
}, {
  id: 'ບ. ທ່ານາຂາມ',
  value: 'ບ. ທ່ານາຂາມ'
}, {
  id: 'ບ. ອ່າງນ້ອຍ',
  value: 'ບ. ອ່າງນ້ອຍ'
}, {
  id: 'ບ. ໂຄກແຫ້',
  value: 'ບ. ໂຄກແຫ້'
}, {
  id: 'ບ. ເພຍລາດ',
  value: 'ບ. ເພຍລາດ'
}, {
  id: 'ບ. ສະນອດ',
  value: 'ບ. ສະນອດ'
}, {
  id: 'ບ. ທ່ານາສາ',
  value: 'ບ. ທ່ານາສາ'
}, {
  id: 'ບ. ໃໝ່',
  value: 'ບ. ໃໝ່'
}, {
  id: 'ບ. ຫ້ວຍຕົມ',
  value: 'ບ. ຫ້ວຍຕົມ'
}, {
  id: 'ບ. ນາປໍ',
  value: 'ບ. ນາປໍ'
}, {
  id: 'ບ. ຫີນສິ່ວ',
  value: 'ບ. ຫີນສິ່ວ'
}, {
  id: 'ບ. ໄຮ່ໃຕ້',
  value: 'ບ. ໄຮ່ໃຕ້'
}, {
  id: 'ບ. ນາສາວນາງ',
  value: 'ບ. ນາສາວນາງ'
}, {
  id: 'ບ. ປາກແຖບ',
  value: 'ບ. ປາກແຖບ'
}, {
  id: 'ບ. ນາຕານ',
  value: 'ບ. ນາຕານ'
}, {
  id: 'ບ. ນາຫອຍປັງ',
  value: 'ບ. ນາຫອຍປັງ'
}, {
  id: 'ບ. ນາທຽມ',
  value: 'ບ. ນາທຽມ'
}, {
  id: 'ບ. ນາລາດ',
  value: 'ບ. ນາລາດ'
}, {
  id: 'ບ. ໄຮ່ເໜືອ',
  value: 'ບ. ໄຮ່ເໜືອ'
}, {
  id: 'ບ. ເຕົາໄຫ',
  value: 'ບ. ເຕົາໄຫ'
}, {
  id: 'ບ. ກົ້ວ',
  value: 'ບ. ກົ້ວ'
}, {
  id: 'ບ. ນາໝ້ຽງ',
  value: 'ບ. ນາໝ້ຽງ'
}, {
  id: 'ບ. ໜອງບົວ',
  value: 'ບ. ໜອງບົວ'
}, {
  id: 'ບ. ກ້ວຍ',
  value: 'ບ. ກ້ວຍ'
}, {
  id: 'ບ. ຊໍ້',
  value: 'ບ. ຊໍ້'
}, {
  id: 'ບ. ວັງມ້າ',
  value: 'ບ. ວັງມ້າ'
}, {
  id: 'ບ. ຫ້ວຍຫ້າ',
  value: 'ບ. ຫ້ວຍຫ້າ'
}, {
  id: 'ບ. ຫ້ວຍຫາງ',
  value: 'ບ. ຫ້ວຍຫາງ'
}, {
  id: 'ບ. ໜອງບົວທອງ',
  value: 'ບ. ໜອງບົວທອງ'
}, {
  id: 'ບ. ໂຄກສາ',
  value: 'ບ. ໂຄກສາ'
}, {
  id: 'ບ. ທາງໂຄ້ງ',
  value: 'ບ. ທາງໂຄ້ງ'
}, {
  id: 'ບ. ນາຝາຍ',
  value: 'ບ. ນາຝາຍ'
}, {
  id: 'ບ. ສ້າງໄສ',
  value: 'ບ. ສ້າງໄສ'
}, {
  id: 'ບ. ໝາກຣາວ',
  value: 'ບ. ໝາກຣາວ'
}, {
  id: 'ບ. ໝາກນາວເໜືອ',
  value: 'ບ. ໝາກນາວເໜືອ'
}, {
  id: 'ບ. ໝາກນາວໃຕ້',
  value: 'ບ. ໝາກນາວໃຕ້'
}, {
  id: 'ບ. ໝາກນາວດົງ',
  value: 'ບ. ໝາກນາວດົງ'
}, {
  id: 'ບ. ນາຊາ',
  value: 'ບ. ນາຊາ'
}, {
  id: 'ບ. ດອນໄຮ່',
  value: 'ບ. ດອນໄຮ່'
}, {
  id: 'ບ. ໂນນສູງ',
  value: 'ບ. ໂນນສູງ'
}, {
  id: 'ບ. ນາເລີດ',
  value: 'ບ. ນາເລີດ'
}, {
  id: 'ບ. ດອນວັງໂພ',
  value: 'ບ. ດອນວັງໂພ'
}, {
  id: 'ບ. ຖິ່ນທຽງ',
  value: 'ບ. ຖິ່ນທຽງ'
}, {
  id: 'ບ. ທ່າເດືອສິງຫອມ',
  value: 'ບ. ທ່າເດືອສິງຫອມ'
}, {
  id: 'ບ. ດົງສານ',
  value: 'ບ. ດົງສານ'
}, {
  id: 'ບ. ດົງກະລຶມ',
  value: 'ບ. ດົງກະລຶມ'
}, {
  id: 'ບ. ໂດນເໜືອ',
  value: 'ບ. ໂດນເໜືອ'
}, {
  id: 'ບ. ໂດນໃຕ້',
  value: 'ບ. ໂດນໃຕ້'
}, {
  id: 'ບ. ໜອງວັງເຜິ້ງ',
  value: 'ບ. ໜອງວັງເຜິ້ງ'
}, {
  id: 'ບ. ນາກຸງ',
  value: 'ບ. ນາກຸງ'
}, {
  id: 'ບ. ທ່າກອກ',
  value: 'ບ. ທ່າກອກ'
}, {
  id: 'ບ. ທຸ່ນລົວ',
  value: 'ບ. ທຸ່ນລົວ'
}, {
  id: 'ບ. ໜອງພູວຽງ',
  value: 'ບ. ໜອງພູວຽງ'
}, {
  id: 'ບ. ນາຊອນ',
  value: 'ບ. ນາຊອນ'
}, {
  id: 'ບ. ນາທາມ',
  value: 'ບ. ນາທາມ'
}, {
  id: 'ບ. ໜອງແຄນ',
  value: 'ບ. ໜອງແຄນ'
}, {
  id: 'ບ. ດອນສ້າງໄຜ່',
  value: 'ບ. ດອນສ້າງໄຜ່'
}, {
  id: 'ບ. ໂນນສົມບູນ',
  value: 'ບ. ໂນນສົມບູນ'
}, {
  id: 'ບ. ຫົວນາທົ່ງ',
  value: 'ບ. ຫົວນາທົ່ງ'
}, {
  id: 'ບ. ໂພນຂາມ',
  value: 'ບ. ໂພນຂາມ'
}, {
  id: 'ບ. ນາບົງ',
  value: 'ບ. ນາບົງ'
}, {
  id: 'ບ. ໂນນ',
  value: 'ບ. ໂນນ'
}, {
  id: 'ບ. ທ່າກົກໄຮ່',
  value: 'ບ. ທ່າກົກໄຮ່'
}, {
  id: 'ບ. ຊຽງແລທ່າ',
  value: 'ບ. ຊຽງແລທ່າ'
}, {
  id: 'ບ. ຊຽງແລນາ',
  value: 'ບ. ຊຽງແລນາ'
}, {
  id: 'ບ. ເວີນກະເບົາ',
  value: 'ບ. ເວີນກະເບົາ'
}, {
  id: 'ບ. ທ່າຊ້າງ',
  value: 'ບ. ທ່າຊ້າງ'
}, {
  id: 'ບ. ໜອງດົງ',
  value: 'ບ. ໜອງດົງ'
}, {
  id: 'ບ. ຫ້ວຍນໍ້າຍຸນ',
  value: 'ບ. ຫ້ວຍນໍ້າຍຸນ'
}, {
  id: 'ບ. ຝັ່ງແດງ',
  value: 'ບ. ຝັ່ງແດງ'
}, {
  id: 'ບ. ພ້າວ',
  value: 'ບ. ພ້າວ'
}, {
  id: 'ບ. ດອນແຍງ',
  value: 'ບ. ດອນແຍງ'
}, {
  id: 'ບ. ດອນແດງ',
  value: 'ບ. ດອນແດງ'
}, {
  id: 'ບ. ດອນສັງຄີ',
  value: 'ບ. ດອນສັງຄີ'
}, {
  id: 'ບ. ໂນນຊາຍ',
  value: 'ບ. ໂນນຊາຍ'
}, {
  id: 'ບ. ປາກງື່ມ',
  value: 'ບ. ປາກງື່ມ'
}, {
  id: 'ບ. ໄຮ່',
  value: 'ບ. ໄຮ່'
}, {
  id: 'ບ. ສົມປະເສີດ',
  value: 'ບ. ສົມປະເສີດ'
}, {
  id: 'ບ. ເວີນແຄນ',
  value: 'ບ. ເວີນແຄນ'
}, {
  id: 'ບ. ສົມສະຫວາດ',
  value: 'ບ. ສົມສະຫວາດ'
}, {
  id: 'ບ. ໜອງຂຽດ',
  value: 'ບ. ໜອງຂຽດ'
}];

var useLaosAddress = function useLaosAddress() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    setFieldValue('collector.entity[1].address[0].streetTwo', '');
  }, []);
  return {
    cityList: [{
      id: '',
      value: 'ເລືອກຈາກໂຕເລືອກທາງລຸ່ມນີ້'
    }].concat(_toConsumableArray(LaosProvinceList), [{
      id: '-1',
      value: 'ບໍ່ໄດ້ຢູ່ໃນໂຕເລືອກນີ້'
    }]),
    districtList: [{
      id: '',
      value: 'ເລືອກຈາກໂຕເລືອກທາງລຸ່ມນີ້'
    }].concat(_toConsumableArray(LaosDistrictList), [{
      id: '-1',
      value: 'ບໍ່ໄດ້ຢູ່ໃນໂຕເລືອກນີ້'
    }]),
    villageList: [{
      id: '',
      value: 'ເລືອກຈາກໂຕເລືອກທາງລຸ່ມນີ້'
    }].concat(_toConsumableArray(LaosVillageList), [{
      id: '-1',
      value: 'ບໍ່ໄດ້ຢູ່ໃນໂຕເລືອກນີ້'
    }]),
    values: values
  };
};

var MAX_INPUT_LENGTH = 32;
var COUNTRIES_WHITE_LIST = ['LA', 'VN', 'JP', 'EE', 'ET', 'KH']; // countries with special chars allowed
var validateNameFields = function validateNameFields(_ref) {
  var country = _ref.country,
    invalidTxt = _ref.invalidTxt,
    maxCharsTxt = _ref.maxCharsTxt,
    required = _ref.required,
    requiredTxt = _ref.requiredTxt,
    translations = _ref.translations,
    value = _ref.value;
  return !COUNTRIES_WHITE_LIST.includes(country) ? validateName(value, required, MAX_INPUT_LENGTH, invalidTxt, maxCharsTxt, requiredTxt) : validateInput(translations, value, required);
};
var useName = function useName(_ref2) {
  var _valueObj$formLogic, _valueObj$formLogic2, _valueObj$collector, _valueObj$collector$e, _valueObj$collector2, _valueObj$collector2$, _valueObj$collector2$2;
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? '' : _ref2$label,
    nameTitles = _ref2.nameTitles,
    required = _ref2.required;
  var _useFormikContext = useFormikContext(),
    valueObj = _useFormikContext.values;
  var translations = deepFind(valueObj, 'translations');
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var isPrefixRequired = valueObj === null || valueObj === void 0 ? void 0 : (_valueObj$formLogic = valueObj.formLogic) === null || _valueObj$formLogic === void 0 ? void 0 : _valueObj$formLogic.isPrefixRequired;
  var isMiddleNameRequired = (valueObj === null || valueObj === void 0 ? void 0 : (_valueObj$formLogic2 = valueObj.formLogic) === null || _valueObj$formLogic2 === void 0 ? void 0 : _valueObj$formLogic2.isMiddleNameRequired) || false;
  var country = (valueObj === null || valueObj === void 0 ? void 0 : (_valueObj$collector = valueObj.collector) === null || _valueObj$collector === void 0 ? void 0 : (_valueObj$collector$e = _valueObj$collector.entity[0]) === null || _valueObj$collector$e === void 0 ? void 0 : _valueObj$collector$e.address) && (valueObj === null || valueObj === void 0 ? void 0 : (_valueObj$collector2 = valueObj.collector) === null || _valueObj$collector2 === void 0 ? void 0 : (_valueObj$collector2$ = _valueObj$collector2.entity[0]) === null || _valueObj$collector2$ === void 0 ? void 0 : (_valueObj$collector2$2 = _valueObj$collector2$.address[0]) === null || _valueObj$collector2$2 === void 0 ? void 0 : _valueObj$collector2$2.country) || 'US';
  var isCountryJapan = country === Countries.JP;
  var nameLabel = (translations === null || translations === void 0 ? void 0 : translations.nameLabel) || "".concat(t([label, 'Name'], {
    ns: 'labels'
  })).concat(required ? '*' : '');
  var requiredTxt = t('Required', {
    ns: 'validation'
  });
  var maxCharsTxt = (translations === null || translations === void 0 ? void 0 : translations.maxCharsTxt) || t('maxChars', {
    ns: 'validation',
    max: MAX_INPUT_LENGTH
  });
  var invalidTxt = t('Invalid', {
    ns: 'validation'
  });
  var titles = nameTitles || (translations === null || translations === void 0 ? void 0 : translations.nameTitles);
  var nameTitleOptions = titles !== null && titles !== void 0 ? titles : {
    '': t('Select One', {
      ns: 'labels'
    }),
    'Dr.': t('Dr.', {
      ns: 'labels'
    }),
    'Mr.': t('Mr.', {
      ns: 'labels'
    }),
    'Mrs.': t('Mrs.', {
      ns: 'labels'
    }),
    'Ms.': t('Ms.', {
      ns: 'labels'
    }),
    'Pastor': t('Pastor', {
      ns: 'labels'
    }),
    'Rev': t('Reverend', {
      ns: 'labels'
    })
  };
  var fNameLabel = (translations === null || translations === void 0 ? void 0 : translations.fNameLabel) || t('First Name', {
    ns: 'labels'
  });
  var lNameLabel = (translations === null || translations === void 0 ? void 0 : translations.lNameLabel) || t('Last Name', {
    ns: 'labels'
  });
  var validateInputFields = function validateInputFields(value) {
    return validateInput(value, required);
  };
  var validateInputName = function validateInputName(value) {
    return validateNameFields({
      country: country,
      invalidTxt: invalidTxt,
      maxCharsTxt: maxCharsTxt,
      required: required,
      requiredTxt: requiredTxt,
      translations: translations,
      value: value
    });
  };
  var preferNameLabel = t('Preferred Name', {
    ns: 'labels'
  });
  var middleNameLabel = (translations === null || translations === void 0 ? void 0 : translations.middleNameLabel) || t('Middle Name', {
    ns: 'labels'
  });
  var titleOptions = convertOptionsToList(nameTitleOptions);
  var translationPrefixLabel = (translations === null || translations === void 0 ? void 0 : translations.prefixLabel) || '';
  var prefixLabel = "".concat(translationPrefixLabel || t('Prefix', {
    ns: 'labels'
  })).concat(isPrefixRequired ? '*' : '');
  return {
    isCountryJapan: isCountryJapan,
    isMiddleNameRequired: isMiddleNameRequired,
    isPrefixRequired: isPrefixRequired,
    fNameLabel: fNameLabel,
    lNameLabel: lNameLabel,
    middleNameLabel: middleNameLabel,
    nameLabel: nameLabel,
    preferNameLabel: preferNameLabel,
    prefixLabel: prefixLabel,
    titleOptions: titleOptions,
    validateInputFields: validateInputFields,
    validateInputName: validateInputName
  };
};

var usePaymentMethod = function usePaymentMethod(_ref) {
  var _activeMethodMap, _values$payment, _values$payment2, _values$formLogic, _values$collector, _values$collector$car, _values$collector$car2, _values$collector$car3;
  var availablePaymentMethods = _ref.availablePaymentMethods,
    envVariables = _ref.envVariables,
    submitLabel = _ref.submitLabel;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeMethod = _useState2[0],
    setActiveMethod = _useState2[1];
  var _useState3 = useState({
      type: '',
      envVariables: envVariables,
      submitLabel: submitLabel,
      method: '',
      authPath: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    paymentObj = _useState4[0],
    setPaymentObj = _useState4[1];
  /* Since new prop will allow to determine what payment methods are available this map is to ensure we use valid payment codes */
  var activeMethodMap = (_activeMethodMap = {}, _defineProperty(_activeMethodMap, PaymentOptions.CCP, 'CCP'), _defineProperty(_activeMethodMap, PaymentOptions.EFT, 'EFT'), _activeMethodMap);
  var hasPaypalPayment = values === null || values === void 0 ? void 0 : (_values$payment = values.payment) === null || _values$payment === void 0 ? void 0 : _values$payment.paypal;
  var hasAPayPayment = values === null || values === void 0 ? void 0 : (_values$payment2 = values.payment) === null || _values$payment2 === void 0 ? void 0 : _values$payment2.bluefinAPay;
  var headingTxt = (translations === null || translations === void 0 ? void 0 : translations.howWouldYouLikeToGive) || t('How would you like to give today?', {
    ns: 'labels'
  });
  var ccLabel = (translations === null || translations === void 0 ? void 0 : translations.debitCreditText) || t('Debit/Credit Card', {
    ns: 'labels'
  });
  var checkLabel = (translations === null || translations === void 0 ? void 0 : translations.electronicCheckText) || t('Electronic Check', {
    ns: 'labels'
  });
  var billingHeadingTxt = (translations === null || translations === void 0 ? void 0 : translations.billingInformationText) || t('Billing Information', {
    ns: 'labels'
  });
  var checkImgUrl = 'https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2021/01/check.jpeg.webp';
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'];
  var enableApayPayment = (availablePaymentMethods === null || availablePaymentMethods === void 0 ? void 0 : availablePaymentMethods.includes(PaymentOptions.APAY)) && (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.enableApayPayment);
  var handleOnClick = function handleOnClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setActiveMethod(e.target.value);
    trackDonationFunnel({
      paymentOptionClick: 'Y',
      values: values
    });
  };
  var hasRecurringItem = function hasRecurringItem(item, idx) {
    var _values$formLogic2, _values$formLogic2$ca, _values$formLogic2$ca2;
    var formLogicItem = (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$ca = _values$formLogic2.cart) === null || _values$formLogic2$ca === void 0 ? void 0 : (_values$formLogic2$ca2 = _values$formLogic2$ca.donation) === null || _values$formLogic2$ca2 === void 0 ? void 0 : _values$formLogic2$ca2.projects[idx];
    return (formLogicItem === null || formLogicItem === void 0 ? void 0 : formLogicItem.isRecurring) === true || (item === null || item === void 0 ? void 0 : item.recurringDate);
  };
  useEffect(function () {
    if (activeMethod === PaymentOptions.CCP) {
      setPaymentObj(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          authPath: 'ccInfo.etoken',
          method: PaymentOptions.CCP,
          type: 'CC'
        });
      });
    } else if (activeMethod === PaymentOptions.EFT) {
      setPaymentObj(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          authPath: 'eftInfo.etoken',
          method: PaymentOptions.EFT,
          type: 'EFT'
        });
      });
    }
  }, [activeMethod]);
  useEffect(function () {
    if ((availablePaymentMethods === null || availablePaymentMethods === void 0 ? void 0 : availablePaymentMethods.length) === 1) {
      var _availablePaymentMeth = _slicedToArray(availablePaymentMethods, 1),
        payMethod = _availablePaymentMeth[0];
      setActiveMethod(activeMethodMap[payMethod]);
    }
  }, [availablePaymentMethods]);
  return {
    activeMethod: activeMethod,
    billingHeadingTxt: billingHeadingTxt,
    ccLabel: ccLabel,
    checkImgUrl: checkImgUrl,
    checkLabel: checkLabel,
    defaultAddressList: defaultAddressList,
    enableApayPayment: enableApayPayment,
    hasAPayPayment: hasAPayPayment,
    hasPaypalPayment: hasPaypalPayment,
    hasRecurring: values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.projects) === null || _values$collector$car3 === void 0 ? void 0 : _values$collector$car3.some(hasRecurringItem),
    headingTxt: headingTxt,
    paymentObj: paymentObj,
    handleOnClick: handleOnClick
  };
};

var usePaypalPayment = function usePaypalPayment(_ref) {
  var _values$collector;
  var _ref$envVariables = _ref.envVariables,
    envVariables = _ref$envVariables === void 0 ? {} : _ref$envVariables,
    _ref$onApproved = _ref.onApproved,
    onApproved = _ref$onApproved === void 0 ? function (value) {
      return value;
    } : _ref$onApproved,
    _ref$orderType = _ref.orderType,
    orderType = _ref$orderType === void 0 ? 'donate' : _ref$orderType;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    submitForm = _useFormikContext.submitForm,
    setErrors = _useFormikContext.setErrors,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var paypalLogPayload = getPaypalLogPayload(values);
  var intent = 'capture';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldDisableButton = _useState2[0],
    setShouldDisableButton = _useState2[1];
  /* 
    These hooks configure the showButton variable. This variable determines if the paypal button shows in a form
    The paypal button is intended to only show if recurring is false and if there is an amount in cart object that is greater than 0
    */
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showButton = _useState4[0],
    setShowButton = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasPaypalData = _useState6[0],
    setHasPaypalData = _useState6[1];

  /* 
      An object that configures the options for the paypal component.
      client-id either uses enviornment variabes or gets them as a prop called envVariables
    */
  var initialOptions = {
    clientId: process.env.PAYPAL_CLIENT_ID || process.env.GATSBY_PAYPAL_CLIENT_ID || envVariables.payPalClientID,
    currency: 'USD',
    intent: intent
  };
  var onShippingAddressChange = function onShippingAddressChange(data, actions) {
    var _data$shippingAddress, _data$shippingAddress2, _data$shippingAddress3, _data$shippingAddress4;
    if (!((_data$shippingAddress = data.shippingAddress.city) !== null && _data$shippingAddress !== void 0 && _data$shippingAddress.trim())) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return actions.reject(data.errors.ADDRESS_ERROR);
    }
    if (!((_data$shippingAddress2 = data.shippingAddress.state) !== null && _data$shippingAddress2 !== void 0 && _data$shippingAddress2.trim())) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return actions.reject(data.errors.STATE_ERROR);
    }
    if (!((_data$shippingAddress3 = data.shippingAddress.postalCode) !== null && _data$shippingAddress3 !== void 0 && _data$shippingAddress3.trim())) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return actions.reject(data.errors.ZIP_ERROR);
    }
    if (!((_data$shippingAddress4 = data.shippingAddress.countryCode) !== null && _data$shippingAddress4 !== void 0 && _data$shippingAddress4.trim())) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return actions.reject(data.errors.COUNTRY_ERROR);
    }
    return undefined;
  };
  var cart = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.cart;
  function handleApproved(data, actions) {
    /*
      This function uses the information that paypal gets form the user and inserts it into the formik fields
      then it submits the form.
      */

    return handleApprovedCaptureHelper(data, actions, setFieldValue, envVariables, logging, onApproved, paypalLogPayload, setHasPaypalData, values);
  }
  useEffect(function () {
    if (hasPaypalData) {
      setErrors({});
      values.formLogic.isPaypalPayment = true;
      setFieldValue("formLogic.isPaypalPayment", true, false);
      submitForm();
    }
  }, [hasPaypalData]);
  useEffect(function () {
    // In case there is no InitialValues this prevents a crash
    !values.collector && setFieldValue("collector", {
      cart: {
        donation: {},
        cartTotals: {}
      }
    });
  }, [values.collector, setFieldValue]);
  useEffect(function () {
    var _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$collector3, _values$collector3$ca, _values$collector3$ca2, _values$collector4, _values$collector4$ca, _values$collector4$ca2, _values$collector5, _values$collector5$ca, _values$collector5$ca2, _values$collector5$ca3;
    setShowButton(((_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : (_values$collector2$ca2 = _values$collector2$ca.cartTotals) === null || _values$collector2$ca2 === void 0 ? void 0 : _values$collector2$ca2.subTotal) > 0);
    if (((_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$ca = _values$collector3.cart) === null || _values$collector3$ca === void 0 ? void 0 : (_values$collector3$ca2 = _values$collector3$ca.products) === null || _values$collector3$ca2 === void 0 ? void 0 : _values$collector3$ca2.length) > 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && (_values$collector4$ca = _values$collector4.cart) !== null && _values$collector4$ca !== void 0 && (_values$collector4$ca2 = _values$collector4$ca.products[0]) !== null && _values$collector4$ca2 !== void 0 && _values$collector4$ca2.honorMemory && ((_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$ca = _values$collector5.cart) === null || _values$collector5$ca === void 0 ? void 0 : (_values$collector5$ca2 = _values$collector5$ca.products[0]) === null || _values$collector5$ca2 === void 0 ? void 0 : (_values$collector5$ca3 = _values$collector5$ca2.honorMemory) === null || _values$collector5$ca3 === void 0 ? void 0 : _values$collector5$ca3.sendBlank) !== 'Y') {
      var _values$collector6, _values$collector6$ca, _values$collector6$ca2;
      setShouldDisableButton(!isValidHonorMemorial((_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$ca = _values$collector6.cart) === null || _values$collector6$ca === void 0 ? void 0 : (_values$collector6$ca2 = _values$collector6$ca.products[0]) === null || _values$collector6$ca2 === void 0 ? void 0 : _values$collector6$ca2.honorMemory));
    }
  }, [cart]);
  function createOrder(data, actions) {
    if (orderType === 'donate') {
      var _values$collector7, _values$collector7$ca, _values$collector7$ca2, _values$collector8, _values$collector8$ca, _values$collector8$ca2, _values$collector9, _values$collector9$ca, _values$collector9$ca2;
      var obj = {
        purchase_units: [{
          amount: {
            value: values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$ca = _values$collector7.cart) === null || _values$collector7$ca === void 0 ? void 0 : (_values$collector7$ca2 = _values$collector7$ca.cartTotals) === null || _values$collector7$ca2 === void 0 ? void 0 : _values$collector7$ca2.subTotal,
            breakdown: {
              item_total: {
                currency_code: 'USD',
                value: values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$ca = _values$collector8.cart) === null || _values$collector8$ca === void 0 ? void 0 : (_values$collector8$ca2 = _values$collector8$ca.cartTotals) === null || _values$collector8$ca2 === void 0 ? void 0 : _values$collector8$ca2.subTotal
              }
            }
          },
          items: [{
            name: 'BGEA-Donation',
            quantity: '1',
            unit_amount: {
              currency_code: 'USD',
              value: values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : (_values$collector9$ca = _values$collector9.cart) === null || _values$collector9$ca === void 0 ? void 0 : (_values$collector9$ca2 = _values$collector9$ca.cartTotals) === null || _values$collector9$ca2 === void 0 ? void 0 : _values$collector9$ca2.subTotal
            },
            category: 'DONATION'
          }]
        }]
      };
      return actions.order.create(obj);
    }
    if (orderType === 'checkout') {
      var _values$collector10, _values$collector10$c, _values$collector10$c2;
      var _obj = {
        purchase_units: [{
          amount: {
            value: values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$c = _values$collector10.cart) === null || _values$collector10$c === void 0 ? void 0 : (_values$collector10$c2 = _values$collector10$c.cartTotals) === null || _values$collector10$c2 === void 0 ? void 0 : _values$collector10$c2.subTotal
          }
        }]
      };
      return actions.order.create(_obj);
    }
    return null;
  }
  return {
    cart: cart,
    initialOptions: initialOptions,
    showButton: showButton,
    shouldDisableButton: shouldDisableButton,
    values: values,
    createOrder: createOrder,
    handleApproved: handleApproved,
    onShippingAddressChange: onShippingAddressChange
  };
};

var usePledgeAmounts = function usePledgeAmounts() {
  var _values$formLogic, _values$formLogic$brb, _values$formLogic$brb2, _values$formLogic$brb3, _values$formLogic2, _values$formLogic2$br, _values$formLogic2$br2, _values$formLogic3, _values$formLogic3$br, _values$formLogic3$br2, _values$formLogic3$br3, _values$formLogic8;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var itemName = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$brb = _values$formLogic.brbInfo) === null || _values$formLogic$brb === void 0 ? void 0 : (_values$formLogic$brb2 = _values$formLogic$brb.campaign) === null || _values$formLogic$brb2 === void 0 ? void 0 : (_values$formLogic$brb3 = _values$formLogic$brb2.item) === null || _values$formLogic$brb3 === void 0 ? void 0 : _values$formLogic$brb3.itemName;
  // set frequency options based on thirdParty variable on fetch
  var frequencyOptions = values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && (_values$formLogic2$br = _values$formLogic2.brbInfo) !== null && _values$formLogic2$br !== void 0 && (_values$formLogic2$br2 = _values$formLogic2$br.campaign) !== null && _values$formLogic2$br2 !== void 0 && _values$formLogic2$br2.thirdParty ? [{
    id: 'one-time',
    value: 'One Time'
  }] : [{
    id: 'monthly',
    value: 'Monthly'
  }, {
    id: 'one-time',
    value: 'One Time'
  }];

  // Options to populate the pledge projects dropdown
  // Default is set at WMN
  var pledgeProjectOptions = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$br = _values$formLogic3.brbInfo) === null || _values$formLogic3$br === void 0 ? void 0 : (_values$formLogic3$br2 = _values$formLogic3$br.campaign) === null || _values$formLogic3$br2 === void 0 ? void 0 : (_values$formLogic3$br3 = _values$formLogic3$br2.projects) === null || _values$formLogic3$br3 === void 0 ? void 0 : _values$formLogic3$br3.map(function (project) {
    return {
      id: project === null || project === void 0 ? void 0 : project.pledgeCode,
      value: project === null || project === void 0 ? void 0 : project.description
    };
  })) || [{
    id: 'RS22CQHUX',
    value: 'Where Most Needed'
  }];
  useEffect(function () {
    var _values$formLogic4;
    if (values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.pledge) {
      var _values$formLogic5, _values$formLogic6;
      delete values.collector.cart.donation;
      if (values !== null && values !== void 0 && values.payment) {
        delete values.payment;
      }
      if (values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.recurringDate) {
        delete values.formLogic.recurringDate;
      }
      if (values !== null && values !== void 0 && (_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && _values$formLogic6.recurringDonations) {
        delete values.formLogic.recurringDonations;
      }
    }
  }, [values.formLogic]);
  useEffect(function () {
    var _values$collector, _values$collector$car;
    if (values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$car = _values$collector.cart) !== null && _values$collector$car !== void 0 && _values$collector$car.pledge) {
      var _values$formLogic7;
      setFieldValue("collector.cart.pledge.orgGift", values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.orgGift);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : _values$formLogic8.orgGift]);
  return {
    frequencyOptions: frequencyOptions,
    itemName: itemName,
    pledgeProjectOptions: pledgeProjectOptions,
    values: values
  };
};

var usePostAPaySession = function usePostAPaySession(_ref) {
  var key = _ref.key;
  var aPaySessionQuery = useMutation(function (payload) {
    return apiClient.postAPaySession(key, payload);
  });
  var postAPaySession = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      var aPaySessionResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return aPaySessionQuery.mutateAsync(payload);
          case 3:
            aPaySessionResponse = _context.sent;
            return _context.abrupt("return", aPaySessionResponse === null || aPaySessionResponse === void 0 ? void 0 : aPaySessionResponse.data);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function postAPaySession(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    postAPaySession: postAPaySession
  };
};

var usePostEmailVerify = function usePostEmailVerify(_ref) {
  var key = _ref.key;
  var emailVerifyQuery = useMutation(function (emailAddress) {
    return apiClient.postEmailVerify(key, emailAddress);
  });
  var postEmailVerify = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(emailAddress) {
      var payload, emailVerifyResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            payload = {
              emailAddress: emailAddress
            };
            _context.next = 4;
            return emailVerifyQuery.mutateAsync(payload);
          case 4:
            emailVerifyResponse = _context.sent;
            return _context.abrupt("return", emailVerifyResponse.data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function postEmailVerify(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    postEmailVerify: postEmailVerify
  };
};

var usePowerByText = function usePowerByText() {
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var handleResponse = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(actions, response, phoneNumber) {
      var _response$response, _response$response2, _response$response3, status, responseStatus;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            status = (response === null || response === void 0 ? void 0 : (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.status) || (response === null || response === void 0 ? void 0 : response.statusCode);
            _context.t0 = status;
            _context.next = _context.t0 === 200 ? 5 : _context.t0 === 201 ? 5 : _context.t0 === 400 ? 7 : 9;
            break;
          case 5:
            responseStatus = SUBMITTED;
            return _context.abrupt("break", 10);
          case 7:
            responseStatus = POWER_BY_TEXT_ERROR;
            return _context.abrupt("break", 10);
          case 9:
            responseStatus = UNPROCESSABLE;
          case 10:
            setFieldValue("formLogic.powerByTextResponse", response === null || response === void 0 ? void 0 : (_response$response2 = response.response) === null || _response$response2 === void 0 ? void 0 : _response$response2.data);
            actions.setStatus(responseStatus);
            actions.setFieldValue('submissionresponse', response === null || response === void 0 ? void 0 : (_response$response3 = response.response) === null || _response$response3 === void 0 ? void 0 : _response$response3.data, false);
            if (status === 429) {
              powerByTextError({
                phoneNumber: phoneNumber
              });
            }
            return _context.abrupt("return", responseStatus);
          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](0);
            return _context.abrupt("return", _context.t1);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 17]]);
    }));
    return function handleResponse(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    handleResponse: handleResponse
  };
};

var useRecaptcahMessage = function useRecaptcahMessage() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var recaptchaMessage = translations === null || translations === void 0 ? void 0 : translations.recaptchaMessage;
  var rePrivacyPolicyLabel = translations === null || translations === void 0 ? void 0 : translations.rePrivacyPolicyLabel;
  var termsOfService = translations === null || translations === void 0 ? void 0 : translations.termsOfService;
  var apply = translations === null || translations === void 0 ? void 0 : translations.apply;
  var and = translations === null || translations === void 0 ? void 0 : translations.and;
  return {
    recaptchaMessage: recaptchaMessage,
    rePrivacyPolicyLabel: rePrivacyPolicyLabel,
    termsOfService: termsOfService,
    apply: apply,
    and: and
  };
};

var useRecurringChoice = function useRecurringChoice(_ref) {
  var day = _ref.day;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var recurringText = "".concat(ordinalSuffix(day), " ").concat(t('of Next Month', {
    ns: 'common'
  }));
  return {
    recurringText: recurringText,
    values: values
  };
};

var _excluded$t = ["entity", "index", "label", "required"];
var getRegionOptions = function getRegionOptions(_ref) {
  var _countryInfo$regions;
  var country = _ref.country,
    props = _ref.props;
  var countryUpperCase = country.toUpperCase();
  var countryInfo = CountryRegion.find(function (Region) {
    return Region.countryShortCode === countryUpperCase;
  });
  return props !== null && props !== void 0 && props.customRegionList ? props === null || props === void 0 ? void 0 : props.customRegionList : countryInfo === null || countryInfo === void 0 ? void 0 : (_countryInfo$regions = countryInfo.regions) === null || _countryInfo$regions === void 0 ? void 0 : _countryInfo$regions.map(function (region) {
    return {
      value: region === null || region === void 0 ? void 0 : region.name,
      id: props !== null && props !== void 0 && props.useMobilizationAddress ? region === null || region === void 0 ? void 0 : region.name : region === null || region === void 0 ? void 0 : region.shortCode
    };
  });
};
var useRegion = function useRegion(_ref2) {
  var _values$formLogic;
  var entity = _ref2.entity,
    index = _ref2.index,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? '' : _ref2$label,
    required = _ref2.required,
    props = _objectWithoutProperties(_ref2, _excluded$t);
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var language = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.language;
  var translations = deepFind(values, 'translations');
  var isStellofyForm = deepFind(values, "formLogic.isStellofyForm") || false;
  var country = !isStellofyForm ? deepFind(values, "collector.entity[".concat(entity, "].address[").concat(index, "].country")) : deepFind(values, "volunteerApp.StellofyApplicationForm.country");
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var selectText = (translations === null || translations === void 0 ? void 0 : translations.selectOneLabel) || t('Select One', {
    ns: 'labels'
  });
  var alternateLabel = (translations === null || translations === void 0 ? void 0 : translations.stateLabel) || "".concat(t('State', {
    ns: 'labels'
  })).concat(required ? '*' : '');
  var textLabel = label || (translations === null || translations === void 0 ? void 0 : translations.stateProvinceLabel) || t([label, 'State/Province'], {
    ns: 'labels'
  });
  var validate = function validate(value) {
    return validateInput(translations, value, required);
  };
  useEffect(function () {
    if (country) {
      var regionOptions = getRegionOptions({
        country: country,
        props: props
      });
      setOptions(regionOptions);
    } else {
      setOptions([]);
      if (isStellofyForm) {
        setFieldValue("volunteerApp.StellofyApplicationForm.stateProvince", '');
      } else {
        setFieldValue("collector.entity[".concat(entity, "].address[").concat(index, "].stateProvince"), '');
      }
    }
  }, [country, language]);
  return {
    options: options,
    selectText: selectText,
    textLabel: country === Countries.AU ? alternateLabel : textLabel,
    validate: validate
  };
};

var useRecurring = function useRecurring(_ref) {
  var _values$collector$car;
  var index = _ref.index,
    donationDateButtons = _ref.donationDateButtons,
    isRecurring = _ref.isRecurring,
    givingBtnStyle = _ref.givingBtnStyle,
    _ref$recurringTextCop = _ref.recurringTextCopy,
    recurringTextCopy = _ref$recurringTextCop === void 0 ? '' : _ref$recurringTextCop;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var _values$formLogic = values === null || values === void 0 ? void 0 : values.formLogic,
    defaultDebitDay = _values$formLogic.defaultDebitDay;
  var availabilityChargeDates = getAvailabilityChargeDates();
  var translations = values === null || values === void 0 ? void 0 : values.translations;
  var selectText = translations === null || translations === void 0 ? void 0 : translations.selectText;
  var options = [{
    value: selectText,
    id: ''
  }].concat(_toConsumableArray(convertOptionsToList(availabilityChargeDates)));
  var recurringText = !donationDateButtons && isRecurring && (_values$collector$car = values.collector.cart.donation.projects[index]) !== null && _values$collector$car !== void 0 && _values$collector$car.recurringDate ? "".concat(recurringTextCopy, " ").concat(getFormattedStartDate(values.collector.cart.donation.projects[index].recurringDate, values)) : translations === null || translations === void 0 ? void 0 : translations.belowSelectedText;

  // Helper function to get button styles
  var getButtonStyles = function getButtonStyles(isActive) {
    return {
      margin: '0.5rem 1rem 0.5rem 0',
      padding: '0.5rem 1rem',
      color: isActive ? "".concat(givingBtnStyle.bgColor) : "".concat(givingBtnStyle.textColor),
      backgroundColor: isActive ? "".concat(givingBtnStyle.textColor) : "".concat(givingBtnStyle.bgColor),
      borderRadius: '4px',
      border: isActive ? '#dbdbdb 1px solid' : 'none'
    };
  };
  return {
    defaultDebitDay: defaultDebitDay,
    recurringText: recurringText,
    getButtonStyles: getButtonStyles,
    options: options,
    values: values
  };
};

var useSingleGift = function useSingleGift(_ref) {
  var _values$formLogic, _projects$index, _values$collector$car, _projects$index2, _values$formLogic3, _values$collector, _values$collector$car2, _values$collector$car3, _values$collector$car4;
  var index = _ref.index,
    projectId = _ref.projectId,
    buttonAmounts = _ref.buttonAmounts,
    recurringButtonAmounts = _ref.recurringButtonAmounts,
    donationDateButtons = _ref.donationDateButtons,
    _ref$onAmountChange = _ref.onAmountChange,
    onAmountChange = _ref$onAmountChange === void 0 ? function (value) {
      return value;
    } : _ref$onAmountChange;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldTouched = _useFormikContext.setFieldTouched,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeButton = _useState2[0],
    setActiveButton = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    buttons = _useState4[0],
    setButtons = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    projectIdUpdated = _useState6[0],
    setProjectIdUpdated = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    donationDay = _useState8[0],
    setDonationDay = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    errorMessage = _useState10[0],
    setErrorMessage = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    dateSelected = _useState12[0],
    setDateSelected = _useState12[1];
  var isResetDonation = (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isResetDonation;

  // Derived values
  var recurringDateNum = deepFind(values, "formLogic.recurringDateNum");
  var projects = deepFind(values, "collector.cart.donation.projects");
  var defaultDebitDay = deepFind(values, 'formLogic.defaultDebitDay');
  var isRecurring = deepFind(values, "formLogic.cart.donation.projects[0].isRecurring");

  // Date related computations
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var nextMonth = currentDate.getMonth() + 2;
  var availabilityChargeDates = getAvailabilityChargeDates();
  var hasProjectAmount = projects && projects[index] && ((_projects$index = projects[index]) === null || _projects$index === void 0 ? void 0 : _projects$index.amount);
  var disableButton = !hasProjectAmount || isRecurring && !((_values$collector$car = values.collector.cart.donation.projects[index]) !== null && _values$collector$car !== void 0 && _values$collector$car.recurringDate) || projects[index] && !((_projects$index2 = projects[index]) !== null && _projects$index2 !== void 0 && _projects$index2.projectId);

  // Handle change in donation amount
  var handleAmountChange = function handleAmountChange(e) {
    e.preventDefault();
    var valueNum = parseFloat(formatCurrency(e.target.value));
    onAmountChange(valueNum);
    setActiveButton(buttons.includes(valueNum) ? valueNum : 0);
    setFieldValue("collector.cart.donation.projects[".concat(index, "].amount"), valueNum, true);
    trackGivingButtons();
    setProjectIdUpdated(function (prev) {
      return prev + 1;
    });
  };

  // Validate the donation amount
  var validate = function validate(value) {
    var _projects$;
    if (value && !isRecurring) {
      setErrorMessage('');
    } else if (!((_projects$ = projects[0]) !== null && _projects$ !== void 0 && _projects$.recurringDate) && isRecurring) {
      setErrorMessage('Required');
    }
  };

  // Handle give button click
  var handleGiveButton = function handleGiveButton() {
    var _projects$index3;
    if (!((_projects$index3 = projects[index]) !== null && _projects$index3 !== void 0 && _projects$index3.amount)) {
      setFieldTouched("collector.cart.donation.projects[".concat(index, "].amount"), true);
    }
    beginCheckoutEvent({
      values: values
    });
  };

  // Handle donation date click
  var handleClick = function handleClick(e) {
    e.preventDefault();
    setDateSelected(true);
    setErrorMessage('');
    setDonationDay(Number(e.target.value));
  };

  // Set the default recurring date
  useEffect(function () {
    if (defaultDebitDay && isRecurring) {
      var recurringDate = Object.keys(availabilityChargeDates).find(function (key) {
        return availabilityChargeDates[key] === defaultDebitDay;
      });
      if (recurringDate) {
        setFieldValue("collector.cart.donation.projects[0].recurringDate", calculateStartDate(recurringDate), false);
      }
      setFieldValue('formLogic.recurringDateNum', "".concat(parseInt(defaultDebitDay, 10)), false);
    } else if (!isRecurring) {
      setFieldValue('formLogic.recurringDateNum', '', false);
      setFieldValue('formLogic.recurringDate', '', false);
    }
  }, [isRecurring, defaultDebitDay]);

  // Update button values based on recurring status
  useEffect(function () {
    setButtons(isRecurring ? recurringButtonAmounts : buttonAmounts);
  }, [isRecurring]);

  // Handle project ID updates
  useEffect(function () {
    setFieldValue("collector.cart.donation.projects[".concat(index, "].projectId"), projectId, false);
    setProjectIdUpdated(function (prev) {
      return prev + 1;
    });
  }, [index, projectId]);
  useEffect(function () {
    if (isResetDonation) {
      setActiveButton(0);
      setFieldValue('formLogic.recurringDate', '', false);
      setFieldValue('formLogic.recurringDateNum', '', false);
      setFieldValue("formLogic.cart.donation.projects.[".concat(index, "].isRecurring"), false, false);
    }
  }, [isResetDonation]);

  // Update the recurring date and subtotal
  useEffect(function () {
    var recurringDate = nextMonth === 13 ? "".concat(year + 1, "-01-").concat(donationDay || '01') : "".concat(year, "-").concat(nextMonth, "-").concat(donationDay || '01');
    projects === null || projects === void 0 ? void 0 : projects.forEach(function (project, i) {
      if (isRecurring && (!project.recurringDate || donationDay) && dateSelected) {
        setFieldValue("collector.cart.donation.projects[".concat(i, "].recurringDate"), recurringDate, false);
      }
      setFieldValue("collector.cart.donation.projects[".concat(index, "].initialChargeProcessed"), true, false);
      var subTotal = projects.reduce(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      function (acc, cur) {
        return acc + (cur.amount || 0);
      }, 0);
      if (!isRecurring) {
        delete project.recurringDate;
      }
      setFieldValue('collector.cart.cartTotals', {
        taxAmount: 0,
        subTotal: subTotal,
        shippingTotal: 0
      }, false);
    });
  }, [isRecurring, projectIdUpdated, donationDay, dateSelected]);

  // Update recurring date from form logic
  useEffect(function () {
    var _values$formLogic2;
    if (!donationDateButtons && isRecurring && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.recurringDate) {
      setFieldValue("collector.cart.donation.projects[".concat(index, "].recurringDate"), values.formLogic.recurringDate, false);
    }
  }, [(_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.recurringDate]);
  useEffect(function () {
    if (recurringDateNum) {
      var recurrDate = parseInt(recurringDateNum, 10);
      var startDate = calculateStartDate("".concat(recurrDate));
      setFieldValue('formLogic.recurringDate', startDate);
    }
  }, [recurringDateNum]);
  useEffect(function () {
    var _values$formLogic4;
    if (values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.projectTitle) {
      updateCartEvent({
        values: values
      });
    }
  }, [isRecurring, recurringDateNum, values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car2 = _values$collector.cart) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.donation) === null || _values$collector$car3 === void 0 ? void 0 : (_values$collector$car4 = _values$collector$car3.projects[0]) === null || _values$collector$car4 === void 0 ? void 0 : _values$collector$car4.amount]);
  return {
    buttons: buttons,
    handleAmountChange: handleAmountChange,
    activeButton: activeButton,
    projects: projects,
    formatCurrency: formatCurrency,
    setActiveButton: setActiveButton,
    isRecurring: isRecurring,
    donationDay: donationDay,
    handleClick: handleClick,
    validate: validate,
    errorMessage: errorMessage,
    disableButton: disableButton,
    setProjectIdUpdated: setProjectIdUpdated,
    handleGiveButton: handleGiveButton
  };
};

var minValLength = 184;
var maxValLength = 185;
var useSREDKeyPad = function useSREDKeyPad() {
  var _values$formLogic, _values$payment5, _values$payment5$blue;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    handleBlur = _useFormikContext.handleBlur,
    setFieldValue = _useFormikContext.setFieldValue,
    validateField = _useFormikContext.validateField;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    SREDKeyFormattedValue = _useState4[0],
    setSREDKeyFormattedValue = _useState4[1];
  var keyInput = useRef(null);
  var fauxKeyInput = useRef(null);
  var ccValue = useDebounce(values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.dummyTextField, 200);
  var bluefinAcc = process.env.REACT_APP_BLUEFIN_ACCOUNT;
  var gatsbyBluefinAcc = process.env.GATSBY_BLUEFIN_ACCOUNT;
  var bluefinAccount = bluefinAcc || gatsbyBluefinAcc;
  var showClearButton = values.payment && values.payment.bluefinECC && values.payment.bluefinECC.data;
  var handleOnCloseModal = function handleOnCloseModal() {
    if (modalIsOpen) {
      var _values$payment, _values$payment$bluef, _values$payment$bluef2, _values$payment2, _values$payment2$blue, _values$payment2$blue2, _values$formLogic2, _values$formLogic2$du, _values$formLogic3, _values$formLogic3$du;
      if ((values === null || values === void 0 ? void 0 : (_values$payment = values.payment) === null || _values$payment === void 0 ? void 0 : (_values$payment$bluef = _values$payment.bluefinECC) === null || _values$payment$bluef === void 0 ? void 0 : (_values$payment$bluef2 = _values$payment$bluef.data) === null || _values$payment$bluef2 === void 0 ? void 0 : _values$payment$bluef2.length) !== minValLength && (values === null || values === void 0 ? void 0 : (_values$payment2 = values.payment) === null || _values$payment2 === void 0 ? void 0 : (_values$payment2$blue = _values$payment2.bluefinECC) === null || _values$payment2$blue === void 0 ? void 0 : (_values$payment2$blue2 = _values$payment2$blue.data) === null || _values$payment2$blue2 === void 0 ? void 0 : _values$payment2$blue2.length) !== maxValLength) {
        values.payment.bluefinECC.data = '';
        keyInput.current.value = '';
      }
      if (((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$du = _values$formLogic2.dummyTextField) === null || _values$formLogic2$du === void 0 ? void 0 : _values$formLogic2$du.length) !== minValLength || ((_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$du = _values$formLogic3.dummyTextField) === null || _values$formLogic3$du === void 0 ? void 0 : _values$formLogic3$du.length) !== maxValLength) {
        setFieldValue("formLogic.dummyTextField", '');
      }
      setModalIsOpen(false);
    }
  };
  var handleOnModalClick = function handleOnModalClick(e) {
    e.preventDefault();
    setFieldValue('payment.account', bluefinAccount || '');
    setModalIsOpen(true);
    keyInput.current.focus();
  };
  var escFunction = useCallback(function (event) {
    if (event.keyCode === 27 || event.keyCode === 13) {
      validateField("formLogic.dummyTextField");
      keyInput.current.value = '';
      setSREDKeyFormattedValue('');
      setFieldValue("formLogic.dummyTextField", '');
      handleOnCloseModal();
    }
    if (event.keyCode === 13) {
      delete values.formLogic.dummyTextField;
      setFieldValue("payment.bluefinECC.data", '');
      delete values.payment;
      keyInput.current.value = '';
      setSREDKeyFormattedValue('');
      setFieldValue("formLogic.dummyTextField", '');
      handleOnCloseModal();
    }
  }, []);
  var clearInput = function clearInput() {
    delete values.formLogic.dummyTextField;
    setFieldValue("payment.bluefinECC.data", '');
    delete values.payment;
    keyInput.current.value = '';
    setSREDKeyFormattedValue('');
  };
  var formatEncryptedCC = function formatEncryptedCC(input) {
    var formattedString = '';
    var regex = /^.*;([^=]+)=([^?]+)\?\*([^=]+)=.*$/gm;
    var subst = "$1";
    switch (input.length) {
      case minValLength:
        formattedString = input.replace(regex, subst);
        break;
      case maxValLength:
        formattedString = input.replace(regex, subst);
        break;
      default:
        formattedString = '';
        break;
    }
    return formattedString;
  };
  useEffect(function () {
    var _values$payment3, _values$payment3$blue, _values$payment3$blue2;
    if ((values === null || values === void 0 ? void 0 : (_values$payment3 = values.payment) === null || _values$payment3 === void 0 ? void 0 : (_values$payment3$blue = _values$payment3.bluefinECC) === null || _values$payment3$blue === void 0 ? void 0 : (_values$payment3$blue2 = _values$payment3$blue.data) === null || _values$payment3$blue2 === void 0 ? void 0 : _values$payment3$blue2.length) === minValLength) {
      setModalIsOpen(false);
      keyInput.current.blur();
    }
    document.addEventListener('keydown', escFunction, false);
    return function () {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [values.payment, values.formLogic]);
  useEffect(function () {
    if (ccValue) {
      var regex = /^.*;([^=]+)=([^?]+)\?\*([^=]+)=.*$/gm;
      if (ccValue !== null && ccValue !== void 0 && ccValue.match(regex)) {
        setFieldValue('payment.bluefinECC.data', ccValue);
        setSREDKeyFormattedValue(formatEncryptedCC(ccValue));
      }
    }
  }, [ccValue]);
  useEffect(function () {
    var _values$payment4, _values$payment4$blue;
    if (values !== null && values !== void 0 && (_values$payment4 = values.payment) !== null && _values$payment4 !== void 0 && (_values$payment4$blue = _values$payment4.bluefinECC) !== null && _values$payment4$blue !== void 0 && _values$payment4$blue.data) {
      setTimeout(function () {
        setModalIsOpen(false);
      }, 500);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$payment5 = values.payment) === null || _values$payment5 === void 0 ? void 0 : (_values$payment5$blue = _values$payment5.bluefinECC) === null || _values$payment5$blue === void 0 ? void 0 : _values$payment5$blue.data]);
  useEffect(function () {
    setFieldValue("formLogic.dummyTextField", '');
    setFieldValue("payment.bluefinECC.data", '');
  }, []);
  return {
    keyInput: keyInput,
    fauxKeyInput: fauxKeyInput,
    modalIsOpen: modalIsOpen,
    showClearButton: showClearButton,
    values: values,
    SREDKeyFormattedValue: SREDKeyFormattedValue,
    clearInput: clearInput,
    handleBlur: handleBlur,
    handleOnCloseModal: handleOnCloseModal,
    handleOnModalClick: handleOnModalClick
  };
};

var useSREDKeyPadModal = function useSREDKeyPadModal(_ref) {
  var keyInput = _ref.keyInput;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  useEffect(function () {
    keyInput.current.focus();
  }, []);
  return {
    values: values
  };
};

var useGetStellofyPeople = function useGetStellofyPeople(_ref, options) {
  var peopleId = _ref.peopleId;
  return useQuery('stellofyTokenInfo', function () {
    return apiClient.getStellofyPeople(peopleId);
  }, _objectSpread2({
    select: R.path(['data', 'payload'])
  }, options));
};

var useGetStellofyRole = function useGetStellofyRole(_ref, options) {
  var roleId = _ref.roleId;
  return useQuery('stellofyTokenInfo', function () {
    return apiClient.getStellofyRole(roleId);
  }, _objectSpread2({
    select: R.path(['data', 'payload'])
  }, options));
};

var useGetStellofyToken = function useGetStellofyToken(_ref, options) {
  var key = _ref.key,
    stellofyToken = _ref.stellofyToken;
  return useQuery('stellofyTokenInfo', function () {
    return apiClient.getStellofyToken(key, stellofyToken);
  }, _objectSpread2({
    select: R.path(['data'])
  }, options));
};

var getFieldErrorNames = function getFieldErrorNames(formikErrors) {
  var transformObjectToDotNotation = function transformObjectToDotNotation(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      if (!value) return;
      var nextKey = key;
      if (prefix) {
        if (Number.isInteger(Number(key))) {
          nextKey = "".concat(prefix, "[").concat(key, "]");
        } else {
          nextKey = "".concat(prefix, ".").concat(key);
        }
      }
      if (_typeof(value) === 'object' && !(Array.isArray(value) && value[0] === 'Required')) {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });
    return result;
  };
  return transformObjectToDotNotation(formikErrors);
};
var validateBasicFields = function validateBasicFields(_ref) {
  var _values$collector$ent, _values$collector$ent2;
  var values = _ref.values;
  return ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.firstName) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length) > 0;
};
var handleFieldErrors = function handleFieldErrors(_ref2) {
  var errors = _ref2.errors,
    useScrollToFieldError = _ref2.useScrollToFieldError,
    setShowErrorMessage = _ref2.setShowErrorMessage;
  var fieldErrorNames = getFieldErrorNames(errors);
  if (fieldErrorNames.length <= 0) {
    setShowErrorMessage(false);
    return;
  }
  var element = document.querySelector("input[name='".concat(fieldErrorNames[0], "']")) || document.querySelector("select[name='".concat(fieldErrorNames[0], "']"));
  if (!element) {
    setShowErrorMessage(false);
    return;
  }
  setShowErrorMessage(true);

  // Scroll to first known error into view
  if (useScrollToFieldError) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
var useSubmitButton = function useSubmitButton(_ref3) {
  var _Object$keys, _values$collector, _values$collector$ent3, _values$collector2, _values$collector$ent4, _values$formLogic2;
  var text = _ref3.text,
    useScrollToFieldError = _ref3.useScrollToFieldError;
  var _useFormikContext = useFormikContext(),
    handleSubmit = _useFormikContext.handleSubmit,
    isSubmitting = _useFormikContext.isSubmitting,
    isValid = _useFormikContext.isValid,
    submitCount = _useFormikContext.submitCount,
    values = _useFormikContext.values,
    errors = _useFormikContext.errors;
  var _useLogging = useLogging(),
    logging = _useLogging.logging;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showErrorMessage = _useState4[0],
    setShowErrorMessage = _useState4[1];
  var translations = deepFind(values, 'translations');
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var hasErrors = ((_Object$keys = Object.keys(errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var submitLabel = (translations === null || translations === void 0 ? void 0 : translations.submitLabel) || t('Submit', {
    ns: 'labels'
  });
  var firstName = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && _values$collector.entity ? (_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.firstName : '';
  var lastName = values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && _values$collector2.entity ? (_values$collector$ent4 = values.collector.entity[0]) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.lastName : '';
  var submitText = text || submitLabel;
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    if (hasErrors) {
      logging({
        functionName: 'useSubmitButton.onSubmit',
        error: errors
      });
    }
    handleSubmit(e);
  };
  useEffect(function () {
    var _values$collector3;
    if (values !== null && values !== void 0 && (_values$collector3 = values.collector) !== null && _values$collector3 !== void 0 && _values$collector3.entity && validateBasicFields({
      values: values
    })) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [firstName, lastName]);
  useEffect(function () {
    var _values$formLogic;
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isValidEmailAddress) === false) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.isValidEmailAddress]);
  useEffect(function () {
    if (submitCount) {
      if (isValid) return;
      handleFieldErrors({
        errors: errors,
        useScrollToFieldError: useScrollToFieldError,
        setShowErrorMessage: setShowErrorMessage
      });
    }
  }, [submitCount]);
  return {
    isFormValid: isFormValid,
    isSubmitting: isSubmitting,
    showErrorMessage: showErrorMessage,
    submitText: submitText,
    values: values,
    onSubmit: onSubmit
  };
};

var VietnamDistrictList = [{
  id: 'An Giang',
  isDistrict: true,
  name: 'An Giang',
  list: [{
    id: 'Long Xuyên',
    name: 'Long Xuyên'
  }, {
    id: 'Châu Đốc',
    name: 'Châu Đốc'
  }, {
    id: 'Tân Châu',
    name: 'Tân Châu'
  }, {
    id: 'Tịnh Biên',
    name: 'Tịnh Biên'
  }, {
    id: 'An Phú',
    name: 'An Phú'
  }, {
    id: 'Châu Phú',
    name: 'Châu Phú'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Mới',
    name: 'Chợ Mới'
  }, {
    id: 'Phú Tân',
    name: 'Phú Tân'
  }, {
    id: 'Thoại Sơn',
    name: 'Thoại Sơn'
  }, {
    id: 'Tri Tôn',
    name: 'Tri Tôn'
  }]
}, {
  id: 'Bà Rịa–Vũng Tàu',
  name: 'Bà Rịa–Vũng Tàu',
  list: []
}, {
  id: 'Bắc Giang',
  name: 'Bắc Giang',
  list: []
}, {
  id: 'Bắc Kạn',
  name: 'Bắc Kạn',
  list: []
}, {
  id: 'Bạc Liêu',
  isDistrict: true,
  name: 'Bạc Liêu',
  list: [{
    id: 'Bạc Liêu',
    name: 'Bạc Liêu'
  }, {
    id: 'Giá Rai',
    name: 'Giá Rai'
  }, {
    id: 'Đông Hải',
    name: 'Đông Hải'
  }, {
    id: 'Hòa Bình',
    name: 'Hòa Bình'
  }, {
    id: 'Hồng Dân',
    name: 'Hồng Dân'
  }, {
    id: 'Phước Long',
    name: 'Phước Long'
  }, {
    id: 'Vĩnh Lợi',
    name: 'Vĩnh Lợi'
  }]
}, {
  id: 'Bắc Ninh',
  name: 'Bắc Ninh',
  list: []
}, {
  id: 'Bến Tre',
  isDistrict: true,
  name: 'Bến Tre',
  list: [{
    id: 'Bến Tre',
    name: 'Bến Tre'
  }, {
    id: 'Ba Tri',
    name: 'Ba Tri'
  }, {
    id: 'Bình Đại',
    name: 'Bình Đại'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Lách',
    name: 'Chợ Lách'
  }, {
    id: 'Giồng Trôm',
    name: 'Giồng Trôm'
  }, {
    id: 'Mỏ Cày Bắc',
    name: 'Mỏ Cày Bắc'
  }, {
    id: 'Mỏ Cày Nam',
    name: 'Mỏ Cày Nam'
  }, {
    id: 'Thạnh Phú',
    name: 'Thạnh Phú'
  }]
}, {
  id: 'Bình Định',
  name: 'Bình Định',
  list: []
}, {
  id: 'Bình Dương',
  name: 'Bình Dương',
  list: []
}, {
  id: 'Bình Phước',
  name: 'Bình Phước',
  list: []
}, {
  id: 'Bình Thuận',
  name: 'Bình Thuận',
  list: []
}, {
  id: 'Cà Mau',
  isDistrict: true,
  name: 'Cà Mau',
  list: [{
    id: 'Cà Mau',
    name: 'Cà Mau'
  }, {
    id: 'Cái Nước',
    name: 'Cái Nước'
  }, {
    id: 'Đầm Dơi',
    name: 'Đầm Dơi'
  }, {
    id: 'Năm Căn',
    name: 'Năm Căn'
  }, {
    id: 'Ngọc Hiển',
    name: 'Ngọc Hiển'
  }, {
    id: 'Phú Tân',
    name: 'Phú Tân'
  }, {
    id: 'Thới Bình',
    name: 'Thới Bình'
  }, {
    id: 'Trần Văn Thời',
    name: 'Trần Văn Thời'
  }, {
    id: 'U Minh',
    name: 'U Minh'
  }]
}, {
  id: 'Cần Thơ',
  name: 'Cần Thơ',
  isDistrict: true,
  list: [{
    id: 'Bình Thủy',
    name: 'Bình Thủy'
  }, {
    id: 'Cái Răng',
    name: 'Cái Răng'
  }, {
    id: 'Ninh Kiều',
    name: 'Ninh Kiều'
  }, {
    id: 'Ô Môn',
    name: 'Ô Môn'
  }, {
    id: 'Thốt Nốt',
    name: 'Thốt Nốt'
  }, {
    id: 'Cờ Đỏ',
    name: 'Cờ Đỏ'
  }, {
    id: 'Phong Điền',
    name: 'Phong Điền'
  }, {
    id: 'Thới Lai',
    name: 'Thới Lai'
  }, {
    id: 'Vĩnh Thạnh',
    name: 'Vĩnh Thạnh'
  }]
}, {
  id: 'Cao Bằng',
  name: 'Cao Bằng',
  list: []
}, {
  id: 'Đà Nẵng',
  name: 'Đà Nẵng',
  list: []
}, {
  id: 'Đắk Lắk',
  name: 'Đắk Lắk',
  list: []
}, {
  id: 'Đắk Nông',
  name: 'Đắk Nông',
  list: []
}, {
  id: 'Điện Biên',
  name: 'Điện Biên',
  list: []
}, {
  id: 'Đồng Nai',
  name: 'Đồng Nai',
  list: []
}, {
  id: 'Đồng Tháp',
  isDistrict: true,
  name: 'Đồng Tháp',
  list: [{
    id: 'Cao Lãnh',
    name: 'Cao Lãnh'
  }, {
    id: 'Hồng Ngự',
    name: 'Hồng Ngự'
  }, {
    id: 'Sa Đéc',
    name: 'Sa Đéc'
  }, {
    id: 'Cao Lãnh',
    name: 'Cao Lãnh'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Hồng Ngự',
    name: 'Hồng Ngự'
  }, {
    id: 'Lai Vung',
    name: 'Lai Vung'
  }, {
    id: 'Lấp Vò',
    name: 'Lấp Vò'
  }, {
    id: 'Tam Nông',
    name: 'Tam Nông'
  }, {
    id: 'Tân Hồng',
    name: 'Tân Hồng'
  }, {
    id: 'Thanh Bình',
    name: 'Thanh Bình'
  }, {
    id: 'Tháp Mười',
    name: 'Tháp Mười'
  }]
}, {
  id: 'Gia Lai',
  name: 'Gia Lai',
  list: []
}, {
  id: 'Hà Giang',
  name: 'Hà Giang',
  list: []
}, {
  id: 'Hà Nam',
  name: 'Hà Nam',
  list: []
}, {
  id: 'Hà Tĩnh',
  name: 'Hà Tĩnh',
  list: []
}, {
  id: 'Hải Dương',
  name: 'Hải Dương',
  list: []
}, {
  id: 'Haiphong',
  name: 'Haiphong',
  list: []
}, {
  id: 'Hanoi',
  name: 'Hanoi',
  list: []
}, {
  id: 'Hậu Giang',
  isDistrict: true,
  name: 'Hậu Giang',
  list: [{
    id: 'Vị Thanh',
    name: 'Vị Thanh'
  }, {
    id: 'Ngã Bảy',
    name: 'Ngã Bảy'
  }, {
    id: 'Long Mỹ',
    name: 'Long Mỹ'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Châu Thành A',
    name: 'Châu Thành A'
  }, {
    id: 'Long Mỹ',
    name: 'Long Mỹ'
  }, {
    id: 'Phụng Hiệp',
    name: 'Phụng Hiệp'
  }, {
    id: 'Vị Thủy',
    name: 'Vị Thủy'
  }]
}, {
  id: 'Hòa Bình',
  name: 'Hòa Bình',
  list: []
}, {
  id: 'Hưng Yên',
  name: 'Hưng Yên',
  list: []
}, {
  id: 'Huyện',
  isDistrict: true,
  name: 'Huyện',
  list: [{
    id: 'Phong Điền',
    name: 'Phong Điền'
  }, {
    id: 'Thới Lai',
    name: 'Thới Lai'
  }, {
    id: 'Vĩnh Thạnh',
    name: 'Vĩnh Thạnh'
  }, {
    id: 'Bến Lức',
    name: 'Bến Lức'
  }, {
    id: 'Thủ Thừa',
    name: 'Thủ Thừa'
  }, {
    id: 'Cần Giuộc',
    name: 'Cần Giuộc'
  }, {
    id: 'Cần Đước',
    name: 'Cần Đước'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Tân Trụ',
    name: 'Tân Trụ'
  }, {
    id: 'Đức Hòa',
    name: 'Đức Hòa'
  }, {
    id: 'Đức Huệ',
    name: 'Đức Huệ'
  }, {
    id: 'Thạnh Hóa',
    name: 'Thạnh Hóa'
  }, {
    id: 'Tân Thạnh',
    name: 'Tân Thạnh'
  }, {
    id: 'Mộc Hóa',
    name: 'Mộc Hóa'
  }, {
    id: 'Vĩnh Hưng',
    name: 'Vĩnh Hưng'
  }, {
    id: 'Tân Hưng',
    name: 'Tân Hưng'
  }, {
    id: 'Cai Lậy',
    name: 'Cai Lậy'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Gạo',
    name: 'Chợ Gạo'
  }, {
    id: 'Cái Bè',
    name: 'Cái Bè'
  }, {
    id: 'Gò Công Tây',
    name: 'Gò Công Tây'
  }, {
    id: 'Gò Công Đông',
    name: 'Gò Công Đông'
  }, {
    id: 'Tân Phú Đông',
    name: 'Tân Phú Đông'
  }, {
    id: 'Tân Phước',
    name: 'Tân Phước'
  }, {
    id: 'Ba Tri',
    name: 'Ba Tri'
  }, {
    id: 'Bình Đại',
    name: 'Bình Đại'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Lách',
    name: 'Chợ Lách'
  }, {
    id: 'Giồng Trôm',
    name: 'Giồng Trôm'
  }, {
    id: 'Mỏ Cày Bắc',
    name: 'Mỏ Cày Bắc'
  }, {
    id: 'Mỏ Cày Nam',
    name: 'Mỏ Cày Nam'
  }, {
    id: 'Thạnh Phú',
    name: 'Thạnh Phú'
  }, {
    id: 'Bình Tân',
    name: 'Bình Tân'
  }, {
    id: 'Long Hồ',
    name: 'Long Hồ'
  }, {
    id: 'Mang Thít',
    name: 'Mang Thít'
  }, {
    id: 'Tam Bình',
    name: 'Tam Bình'
  }, {
    id: 'Trà Ôn',
    name: 'Trà Ôn'
  }, {
    id: 'Vũng Liêm',
    name: 'Vũng Liêm'
  }, {
    id: 'Càng Long',
    name: 'Càng Long'
  }, {
    id: 'Cầu Kè',
    name: 'Cầu Kè'
  }, {
    id: 'Cầu Ngang',
    name: 'Cầu Ngang'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Duyên Hải',
    name: 'Duyên Hải'
  }, {
    id: 'Tiểu Cần',
    name: 'Tiểu Cần'
  }, {
    id: 'Trà Cú',
    name: 'Trà Cú'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Châu Thành A',
    name: 'Châu Thành A'
  }, {
    id: 'Long Mỹ',
    name: 'Long Mỹ'
  }, {
    id: 'Phụng Hiệp',
    name: 'Phụng Hiệp'
  }, {
    id: 'Vị Thủy',
    name: 'Vị Thủy'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Cù Lao Dung',
    name: 'Cù Lao Dung'
  }, {
    id: 'Kế Sách',
    name: 'Kế Sách'
  }, {
    id: 'Long Phú',
    name: 'Long Phú'
  }, {
    id: 'Mỹ Tú',
    name: 'Mỹ Tú'
  }, {
    id: 'Mỹ Xuyên',
    name: 'Mỹ Xuyên'
  }, {
    id: 'Thạnh Trị',
    name: 'Thạnh Trị'
  }, {
    id: 'Trần Đề',
    name: 'Trần Đề'
  }, {
    id: 'Cao Lãnh',
    name: 'Cao Lãnh'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Hồng Ngự',
    name: 'Hồng Ngự'
  }, {
    id: 'Lai Vung',
    name: 'Lai Vung'
  }, {
    id: 'Lấp Vò',
    name: 'Lấp Vò'
  }, {
    id: 'Tam Nông',
    name: 'Tam Nông'
  }, {
    id: 'Tân Hồng',
    name: 'Tân Hồng'
  }, {
    id: 'Thanh Bình',
    name: 'Thanh Bình'
  }, {
    id: 'Tháp Mười',
    name: 'Tháp Mười'
  }, {
    id: 'An Phú',
    name: 'An Phú'
  }, {
    id: 'Châu Phú',
    name: 'Châu Phú'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Mới',
    name: 'Chợ Mới'
  }, {
    id: 'Phú Tân',
    name: 'Phú Tân'
  }, {
    id: 'Thoại Sơn',
    name: 'Thoại Sơn'
  }, {
    id: 'Tri Tôn',
    name: 'Tri Tôn'
  }, {
    id: 'An Biên',
    name: 'An Biên'
  }, {
    id: 'An Minh',
    name: 'An Minh'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Giang Thành',
    name: 'Giang Thành'
  }, {
    id: 'Giồng Riềng',
    name: 'Giồng Riềng'
  }, {
    id: 'Gò Quao',
    name: 'Gò Quao'
  }, {
    id: 'Hòn Đất',
    name: 'Hòn Đất'
  }, {
    id: 'Kiên Hải',
    name: 'Kiên Hải'
  }, {
    id: 'Kiên Lương',
    name: 'Kiên Lương'
  }, {
    id: 'Tân Hiệp',
    name: 'Tân Hiệp'
  }, {
    id: 'U Minh Thượng',
    name: 'U Minh Thượng'
  }, {
    id: 'Vĩnh Thuận',
    name: 'Vĩnh Thuận'
  }, {
    id: 'Đông Hải',
    name: 'Đông Hải'
  }, {
    id: 'Hòa Bình',
    name: 'Hòa Bình'
  }, {
    id: 'Hồng Dân',
    name: 'Hồng Dân'
  }, {
    id: 'Phước Long',
    name: 'Phước Long'
  }, {
    id: 'Vĩnh Lợi',
    name: 'Vĩnh Lợi'
  }, {
    id: 'Cái Nước',
    name: 'Cái Nước'
  }, {
    id: 'Đầm Dơi',
    name: 'Đầm Dơi'
  }, {
    id: 'Năm Căn',
    name: 'Năm Căn'
  }, {
    id: 'Ngọc Hiển',
    name: 'Ngọc Hiển'
  }, {
    id: 'Phú Tân',
    name: 'Phú Tân'
  }, {
    id: 'Thới Bình',
    name: 'Thới Bình'
  }, {
    id: 'Trần Văn Thời',
    name: 'Trần Văn Thời'
  }, {
    id: 'U Minh',
    name: 'U Minh'
  }]
}, {
  id: 'Khánh Hòa',
  name: 'Khánh Hòa',
  list: []
}, {
  id: 'Kiên Giang',
  isDistrict: true,
  name: 'Kiên Giang',
  list: [{
    id: 'Rạch Giá',
    name: 'Rạch Giá'
  }, {
    id: 'Hà Tiên',
    name: 'Hà Tiên'
  }, {
    id: 'Phú Quốc',
    name: 'Phú Quốc'
  }, {
    id: 'An Biên',
    name: 'An Biên'
  }, {
    id: 'An Minh',
    name: 'An Minh'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Giang Thành',
    name: 'Giang Thành'
  }, {
    id: 'Giồng Riềng',
    name: 'Giồng Riềng'
  }, {
    id: 'Gò Quao',
    name: 'Gò Quao'
  }, {
    id: 'Hòn Đất',
    name: 'Hòn Đất'
  }, {
    id: 'Kiên Hải',
    name: 'Kiên Hải'
  }, {
    id: 'Kiên Lương',
    name: 'Kiên Lương'
  }, {
    id: 'Tân Hiệp',
    name: 'Tân Hiệp'
  }, {
    id: 'U Minh Thượng',
    name: 'U Minh Thượng'
  }, {
    id: 'Vĩnh Thuận',
    name: 'Vĩnh Thuận'
  }]
}, {
  id: 'Kon Tum',
  name: 'Kon Tum',
  list: []
}, {
  id: 'Lai Châu',
  name: 'Lai Châu',
  list: []
}, {
  id: 'Lâm Đồng',
  name: 'Lâm Đồng',
  list: []
}, {
  id: 'Lạng Sơn',
  name: 'Lạng Sơn',
  list: []
}, {
  id: 'Lào Cai',
  name: 'Lào Cai',
  list: []
}, {
  id: 'Long An',
  name: 'Long An',
  isDistrict: true,
  list: [{
    id: 'Tân An',
    name: 'Tân An'
  }, {
    id: 'Kiến Tường',
    name: 'Kiến Tường'
  }, {
    id: 'Bến Lức',
    name: 'Bến Lức'
  }, {
    id: 'Thủ Thừa',
    name: 'Thủ Thừa'
  }, {
    id: 'Cần Giuộc',
    name: 'Cần Giuộc'
  }, {
    id: 'Cần Đước',
    name: 'Cần Đước'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Tân Trụ',
    name: 'Tân Trụ'
  }, {
    id: 'Đức Hòa',
    name: 'Đức Hòa'
  }, {
    id: 'Đức Huệ',
    name: 'Đức Huệ'
  }, {
    id: 'Thạnh Hóa',
    name: 'Thạnh Hóa'
  }, {
    id: 'Tân Thạnh',
    name: 'Tân Thạnh'
  }, {
    id: 'Mộc Hóa',
    name: 'Mộc Hóa'
  }, {
    id: 'Vĩnh Hưng',
    name: 'Vĩnh Hưng'
  }, {
    id: 'Tân Hưng',
    name: 'Tân Hưng'
  }]
}, {
  id: 'Nam Định',
  name: 'Nam Định',
  list: []
}, {
  id: 'Nghệ An',
  name: 'Nghệ An',
  list: []
}, {
  id: 'Ninh Bình',
  name: 'Ninh Bình',
  list: []
}, {
  id: 'Ninh Thuận',
  name: 'Ninh Thuận',
  list: []
}, {
  id: 'Phú Thọ',
  name: 'Phú Thọ',
  list: []
}, {
  id: 'Phú Yên',
  name: 'Phú Yên',
  list: []
}, {
  id: 'Quận',
  isDistrict: true,
  name: 'Quận',
  list: [{
    id: 'Bình Thủy',
    name: 'Bình Thủy'
  }, {
    id: 'Cái Răng',
    name: 'Cái Răng'
  }, {
    id: 'Ninh Kiều',
    name: 'Ninh Kiều'
  }, {
    id: 'Ô Môn',
    name: 'Ô Môn'
  }, {
    id: 'Thốt Nốt',
    name: 'Thốt Nốt'
  }]
}, {
  id: 'Quảng Bình',
  name: 'Quảng Bình',
  list: []
}, {
  id: 'Quảng Nam',
  name: 'Quảng Nam',
  list: []
}, {
  id: 'Quảng Ngãi',
  name: 'Quảng Ngãi',
  list: []
}, {
  id: 'Quảng Ninh',
  name: 'Quảng Ninh',
  list: []
}, {
  id: 'Quảng Trị',
  name: 'Quảng Trị',
  list: []
}, {
  id: 'Sóc Trăng',
  isDistrict: true,
  name: 'Sóc Trăng',
  list: [{
    id: 'Sóc Trăng',
    name: 'Sóc Trăng'
  }, {
    id: 'Ngã Năm',
    name: 'Ngã Năm'
  }, {
    id: 'Vĩnh Châu',
    name: 'Vĩnh Châu'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Cù Lao Dung',
    name: 'Cù Lao Dung'
  }, {
    id: 'Kế Sách',
    name: 'Kế Sách'
  }, {
    id: 'Long Phú',
    name: 'Long Phú'
  }, {
    id: 'Mỹ Tú',
    name: 'Mỹ Tú'
  }, {
    id: 'Mỹ Xuyên',
    name: 'Mỹ Xuyên'
  }, {
    id: 'Thạnh Trị',
    name: 'Thạnh Trị'
  }, {
    id: 'Trần Đề',
    name: 'Trần Đề'
  }]
}, {
  id: 'Sơn La',
  name: 'Sơn La',
  list: []
}, {
  id: 'Tây Ninh',
  name: 'Tây Ninh',
  list: []
}, {
  id: 'Thái Bình',
  name: 'Thái Bình',
  list: []
}, {
  id: 'Thái Nguyên',
  name: 'Thái Nguyên',
  list: []
}, {
  id: 'Thanh Hóa',
  name: 'Thanh Hóa',
  list: []
}, {
  id: 'Thành phố Hồ Chí Minh',
  isDistrict: true,
  name: 'Thành phố Hồ Chí Minh',
  list: [{
    id: 'Tân An',
    name: 'Tân An'
  }, {
    id: 'Mỹ Tho',
    name: 'Mỹ Tho'
  }, {
    id: 'Bến Tre',
    name: 'Bến Tre'
  }, {
    id: 'Vĩnh Long',
    name: 'Vĩnh Long'
  }, {
    id: 'Trà Vinh',
    name: 'Trà Vinh'
  }, {
    id: 'Vị Thanh',
    name: 'Vị Thanh'
  }, {
    id: 'Ngã Bảy',
    name: 'Ngã Bảy'
  }, {
    id: 'Sóc Trăng',
    name: 'Sóc Trăng'
  }, {
    id: 'Cao Lãnh',
    name: 'Cao Lãnh'
  }, {
    id: 'Hồng Ngự',
    name: 'Hồng Ngự'
  }, {
    id: 'Sa Đéc',
    name: 'Sa Đéc'
  }, {
    id: 'Long Xuyên',
    name: 'Long Xuyên'
  }, {
    id: 'Châu Đốc',
    name: 'Châu Đốc'
  }, {
    id: 'Rạch Giá',
    name: 'Rạch Giá'
  }, {
    id: 'Hà Tiên',
    name: 'Hà Tiên'
  }, {
    id: 'Phú Quốc',
    name: 'Phú Quốc'
  }, {
    id: 'Bạc Liêu',
    name: 'Bạc Liêu'
  }, {
    id: 'Cà Mau',
    name: 'Cà Mau'
  }]
}, {
  id: 'Thị xã',
  isDistrict: true,
  name: 'Thị xã',
  list: [{
    id: 'Kiến Tường',
    name: 'Kiến Tường'
  }, {
    id: 'Cai Lậy',
    name: 'Cai Lậy'
  }, {
    id: 'Gò Công',
    name: 'Gò Công'
  }, {
    id: 'Bình Minh',
    name: 'Bình Minh'
  }, {
    id: 'Duyên Hải',
    name: 'Duyên Hải'
  }, {
    id: 'Long Mỹ',
    name: 'Long Mỹ'
  }, {
    id: 'Ngã Năm',
    name: 'Ngã Năm'
  }, {
    id: 'Vĩnh Châu',
    name: 'Vĩnh Châu'
  }, {
    id: 'Tân Châu',
    name: 'Tân Châu'
  }, {
    id: 'Tịnh Biên',
    name: 'Tịnh Biên'
  }, {
    id: 'Giá Rai',
    name: 'Giá Rai'
  }]
}, {
  id: 'Thừa Thiên–Huế',
  name: 'Thừa Thiên–Huế',
  list: []
}, {
  id: 'Tiền Giang',
  isDistrict: true,
  name: 'Tiền Giang',
  list: [{
    id: 'Mỹ Tho',
    name: 'Mỹ Tho'
  }, {
    id: 'Cai Lậy',
    name: 'Cai Lậy'
  }, {
    id: 'Gò Công',
    name: 'Gò Công'
  }, {
    id: 'Cai Lậy',
    name: 'Cai Lậy'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Chợ Gạo',
    name: 'Chợ Gạo'
  }, {
    id: 'Cái Bè',
    name: 'Cái Bè'
  }, {
    id: 'Gò Công Tây',
    name: 'Gò Công Tây'
  }, {
    id: 'Gò Công Đông',
    name: 'Gò Công Đông'
  }, {
    id: 'Tân Phú Đông',
    name: 'Tân Phú Đông'
  }, {
    id: 'Tân Phước',
    name: 'Tân Phước'
  }]
}, {
  id: 'Trà Vinh',
  isDistrict: true,
  name: 'Trà Vinh',
  list: [{
    id: 'Trà Vinh',
    name: 'Trà Vinh'
  }, {
    id: 'Duyên Hải',
    name: 'Duyên Hải'
  }, {
    id: 'Càng Long',
    name: 'Càng Long'
  }, {
    id: 'Cầu Kè',
    name: 'Cầu Kè'
  }, {
    id: 'Cầu Ngang',
    name: 'Cầu Ngang'
  }, {
    id: 'Châu Thành',
    name: 'Châu Thành'
  }, {
    id: 'Duyên Hải',
    name: 'Duyên Hải'
  }, {
    id: 'Tiểu Cần',
    name: 'Tiểu Cần'
  }, {
    id: 'Trà Cú',
    name: 'Trà Cú'
  }]
}, {
  id: 'Tuyên Quang',
  name: 'Tuyên Quang',
  list: []
}, {
  id: 'Vĩnh Long',
  isDistrict: true,
  name: 'Vĩnh Long',
  list: [{
    id: 'Vĩnh Long',
    name: 'Vĩnh Long'
  }, {
    id: 'Bình Minh',
    name: 'Bình Minh'
  }, {
    id: 'Bình Tân',
    name: 'Bình Tân'
  }, {
    id: 'Long Hồ',
    name: 'Long Hồ'
  }, {
    id: 'Mang Thít',
    name: 'Mang Thít'
  }, {
    id: 'Tam Bình',
    name: 'Tam Bình'
  }, {
    id: 'Trà Ôn',
    name: 'Trà Ôn'
  }, {
    id: 'Vũng Liêm',
    name: 'Vũng Liêm'
  }]
}, {
  id: 'Vĩnh Phúc',
  name: 'Vĩnh Phúc',
  list: []
}, {
  id: 'Yên Bái',
  name: 'Yên Bái',
  list: []
}];

var getUniqueList = function getUniqueList(data, key) {
  return _toConsumableArray(new Map(data.map(function (x) {
    return [key(x), x];
  })).values());
};
var convertList = function convertList(villages) {
  return villages.map(function (village) {
    return {
      value: village.name,
      id: village.name
    };
  });
};
var useVietnamAddress = function useVietnamAddress(_ref) {
  var _values$collector$ent;
  var visibleList = _ref.visibleList;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(convertList(VietnamDistrictList[0].list)),
    _useState2 = _slicedToArray(_useState, 2),
    villageList = _useState2[0],
    setVillageList = _useState2[1];
  var streetTwo = (_values$collector$ent = values.collector.entity[1]) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.address[0].streetTwo;
  var cityList = [{
    id: '',
    value: 'Chọn'
  }].concat(_toConsumableArray(VietnamDistrictList.map(function (district) {
    return {
      value: district.name,
      id: district.name
    };
  })));
  var districtTownList = [{
    id: '',
    value: 'Chọn'
  }].concat(_toConsumableArray(VietnamDistrictList.filter(function (district) {
    return district.isDistrict;
  }).map(function (district) {
    return {
      value: district.name,
      id: district.name
    };
  })));
  useEffect(function () {
    if (streetTwo) {
      var _VietnamDistrictList$;
      var villages = (_VietnamDistrictList$ = VietnamDistrictList.find(function (district) {
        return district.id === streetTwo;
      })) === null || _VietnamDistrictList$ === void 0 ? void 0 : _VietnamDistrictList$.list;
      if ((villages === null || villages === void 0 ? void 0 : villages.length) > 0) {
        setVillageList(convertList(villages));
      }
    }
  }, [streetTwo]);
  useEffect(function () {
    if (visibleList.includes('streetThree')) {
      setFieldValue('collector.entity[1].address[0].streetThree', '');
    }
  }, []);
  return {
    cityList: cityList,
    districtTownList: districtTownList,
    villageList: [{
      id: '',
      value: 'Chọn'
    }].concat(_toConsumableArray(getUniqueList(villageList, function (village) {
      return village.id;
    }))),
    values: values
  };
};

var useUser = function useUser() {
  return useQuery(['user'], function () {
    return apiClient.getUserInfo();
  }, {
    select: R.prop('data')
  });
};

var useUserEsubList = function useUserEsubList() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var GENERIC_ERROR_MESSAGE = t('errors:default');
  var esubListQuery = useMutation(function (payload) {
    return apiClient.getUserEsubList(payload);
  });
  var getUserEsubList = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var dsan, email, esubListResponse, errorTypeEq, isInvalidRequest, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dsan = _ref.dsan, email = _ref.email;
            _context.prev = 1;
            _context.next = 4;
            return esubListQuery.mutateAsync(JSON.stringify({
              dsan: dsan,
              email: email
            }));
          case 4:
            esubListResponse = _context.sent;
            return _context.abrupt("return", esubListResponse.data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            errorTypeEq = R.pathEq(['response', 'data', 'error', 'type']);
            isInvalidRequest = errorTypeEq('INVALID_REQUEST_ERROR', _context.t0);
            if (isInvalidRequest) {
              errorMessage = R.path(['response', 'data', 'error', 'message'], _context.t0);
            } else {
              errorMessage = _context.t0.message;
            }
            throw new Error(errorMessage || GENERIC_ERROR_MESSAGE);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function getUserEsubList(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    getUserEsubList: getUserEsubList
  };
};

var _excluded$s = ["entity", "index", "name", "showLabel"];
var Address = function Address(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref$name,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    props = _objectWithoutProperties(_ref, _excluded$s);
  var _useAddress = useAddress(_objectSpread2({
      name: name
    }, props)),
    address = _useAddress.address,
    Format = _useAddress.Format;
  if (!address) {
    return null;
  }
  return jsx(Block, {
    className: "address-container",
    mb: 4,
    children: jsx(Format, _objectSpread2(_objectSpread2({}, props), {}, {
      entity: entity,
      index: index,
      name: name,
      showLabel: showLabel
    }))
  });
};

var Age = function Age(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Are you over 18?' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].over18") : _ref$name;
  return jsx(Form$1.Field, {
    children: jsx(Columns, {
      children: jsx(Columns.Column, {
        size: "one-quarter",
        children: jsx(Checkbox, {
          name: name,
          label: label
        })
      })
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ApplePayBtn = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e1cpxmh90"
} : {
  target: "e1cpxmh90",
  label: "ApplePayBtn"
})(process.env.NODE_ENV === "production" ? {
  name: "6e7brg",
  styles: "-webkit-appearance:-apple-pay-button"
} : {
  name: "6e7brg",
  styles: "-webkit-appearance:-apple-pay-button",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcGxlUGF5QnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLa0MiLCJmaWxlIjoiQXBwbGVQYXlCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdWknO1xuXG5pbXBvcnQgeyB1c2VBcHBsZVBheUJ1dHRvbiB9IGZyb20gJy4uLy4uL2hvb2tzL3VzZUFwcGxlUGF5QnV0dG9uJztcblxuY29uc3QgQXBwbGVQYXlCdG4gPSBzdHlsZWQoQnV0dG9uKWBcbiAgLyogc3R5bGVsaW50LWRpc2FibGUgcHJvcGVydHktbm8tdmVuZG9yLXByZWZpeCAqL1xuICAtd2Via2l0LWFwcGVhcmFuY2U6IC1hcHBsZS1wYXktYnV0dG9uO1xuYDtcblxuZXhwb3J0IGNvbnN0IEFwcGxlUGF5QnV0dG9uID0gKHtcbiAgYXBwbGVQYXlWZXJzaW9uLFxuICBvblBheW1lbnRTdWNjZXNzLFxuICBvblBheW1lbnRFcnJvcixcbn06IHtcbiAgYXBwbGVQYXlWZXJzaW9uOiBudW1iZXI7XG4gIG9uUGF5bWVudFN1Y2Nlc3M/OiAocGF5bWVudDogYW55KSA9PiB2b2lkO1xuICBvblBheW1lbnRFcnJvcj86IChlcnJvcjogRXJyb3IpID0+IHZvaWQ7XG59KSA9PiB7XG4gIGNvbnN0IHsgaGFuZGxlUGF5bWVudCB9ID0gdXNlQXBwbGVQYXlCdXR0b24oe1xuICAgIGFwcGxlUGF5VmVyc2lvbixcbiAgICBvblBheW1lbnRTdWNjZXNzLFxuICAgIG9uUGF5bWVudEVycm9yLFxuICB9KTtcblxuICByZXR1cm4gPEFwcGxlUGF5QnRuIGNsYXNzTmFtZT1cImFwcGxlLXBheS1idXR0b25cIiBvbkNsaWNrPXtoYW5kbGVQYXltZW50fSAvPjtcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
var ApplePayButton = function ApplePayButton(_ref) {
  var applePayVersion = _ref.applePayVersion,
    onPaymentSuccess = _ref.onPaymentSuccess,
    onPaymentError = _ref.onPaymentError;
  var _useApplePayButton = useApplePayButton({
      applePayVersion: applePayVersion,
      onPaymentSuccess: onPaymentSuccess,
      onPaymentError: onPaymentError
    }),
    handlePayment = _useApplePayButton.handlePayment;
  return jsx(ApplePayBtn, {
    className: "apple-pay-button",
    onClick: handlePayment
  });
};

var ApplePayment = function ApplePayment() {
  var _useApplePayment = useApplePayment(),
    applePayVersion = _useApplePayment.applePayVersion,
    isApplePayAvailable = _useApplePayment.isApplePayAvailable,
    handlePaymentSuccess = _useApplePayment.handlePaymentSuccess,
    handlePaymentError = _useApplePayment.handlePaymentError;
  return jsx("div", {
    children: isApplePayAvailable ? jsx(ApplePayButton, {
      applePayVersion: applePayVersion,
      onPaymentSuccess: handlePaymentSuccess,
      onPaymentError: handlePaymentError
    }) : null
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var PhoneContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1p9076p0"
} : {
  target: "e1p9076p0",
  label: "PhoneContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "nziu9y",
  styles: ".react-international-phone-country-selector{position:relative;}.react-international-phone-country-selector-button{display:flex;height:var(--react-international-phone-height, 36px);box-sizing:border-box;align-items:center;justify-content:center;padding:0;border:1px solid var(\n        --react-international-phone-country-selector-border-color,\n        var(--react-international-phone-border-color, gainsboro)\n      );margin:0;appearance:button;background-color:var(\n      --react-international-phone-country-selector-background-color,\n      var(--react-international-phone-background-color, white)\n    );cursor:pointer;text-transform:none;user-select:none;}.react-international-phone-country-selector-button:hover{background-color:var(\n      --react-international-phone-country-selector-background-color-hover,\n      whitesmoke\n    );}.react-international-phone-country-selector-button--hide-dropdown{cursor:auto;}.react-international-phone-country-selector-button--hide-dropdown:hover{background-color:transparent;}.react-international-phone-country-selector-button__button-content{display:flex;align-items:center;justify-content:center;}.react-international-phone-country-selector-button__flag-emoji{margin:0 4px;}.react-international-phone-country-selector-button__flag-emoji--disabled{opacity:0.75;}.react-international-phone-country-selector-button__dropdown-arrow{border-top:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid var(--react-international-phone-country-selector-arrow-color, #777);border-right:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid transparent;border-left:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid transparent;margin-right:4px;transition:all 0.1s ease-out;}.react-international-phone-country-selector-button__dropdown-arrow--active{transform:rotateX(180deg);}.react-international-phone-country-selector-button__dropdown-arrow--disabled{border-top-color:var(\n      --react-international-phone-disabled-country-selector-arrow-color,\n      #999\n    );}.react-international-phone-country-selector-button--disabled{background-color:var(\n      --react-international-phone-disabled-country-selector-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );cursor:auto;}.react-international-phone-country-selector-button--disabled:hover{background-color:var(\n      --react-international-phone-disabled-country-selector-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );}.react-international-phone-flag-emoji{width:var(--react-international-phone-flag-width, 24px);height:var(--react-international-phone-flag-height, 24px);box-sizing:border-box;}.react-international-phone-country-selector-dropdown{position:absolute;z-index:1;top:var(--react-international-phone-dropdown-top, 44px);left:var(--react-international-phone-dropdown-left, 0);display:flex;width:300px;max-height:200px;flex-direction:column;padding:4px 0;margin:0;background-color:var(\n      --react-international-phone-dropdown-item-background-color,\n      var(--react-international-phone-background-color, white)\n    );box-shadow:var(\n      --react-international-phone-dropdown-shadow,\n      2px 2px 16px rgba(0, 0, 0, 0.25)\n    );color:var(\n      --react-international-phone-dropdown-item-text-color,\n      var(--react-international-phone-text-color, #222)\n    );list-style:none;overflow-y:scroll;}.react-international-phone-country-selector-dropdown__preferred-list-divider{height:1px;border:none;margin:var(\n      --react-international-phone-dropdown-preferred-list-divider-margin,\n      0\n    );background:var(\n      --react-international-phone-dropdown-preferred-list-divider-color,\n      var(--react-international-phone-border-color, gainsboro)\n    );}.react-international-phone-country-selector-dropdown__list-item{display:flex;min-height:var(--react-international-phone-dropdown-item-height, 28px);box-sizing:border-box;align-items:center;padding:2px 8px;}.react-international-phone-country-selector-dropdown__list-item-flag-emoji{margin-right:8px;}.react-international-phone-country-selector-dropdown__list-item-country-name{overflow:hidden;margin-right:8px;font-size:var(--react-international-phone-dropdown-item-font-size, 14px);text-overflow:ellipsis;white-space:nowrap;}.react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(--react-international-phone-dropdown-item-dial-code-color, gray);font-size:var(--react-international-phone-dropdown-item-font-size, 14px);}.react-international-phone-country-selector-dropdown__list-item:hover{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      var(\n        --react-international-phone-selected-dropdown-item-background-color,\n        whitesmoke\n      )\n    );cursor:pointer;}.react-international-phone-country-selector-dropdown__list-item--selected,.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      whitesmoke\n    );color:var(\n      --react-international-phone-selected-dropdown-item-text-color,\n      var(--react-international-phone-text-color, #222)\n    );}.react-international-phone-country-selector-dropdown__list-item--selected .react-international-phone-country-selector-dropdown__list-item-dial-code,.react-international-phone-country-selector-dropdown__list-item--focused .react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(\n      --react-international-phone-selected-dropdown-item-dial-code-color,\n      var(--react-international-phone-dropdown-item-dial-code-color, gray)\n    );}.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      var(\n        --react-international-phone-selected-dropdown-item-background-color,\n        whitesmoke\n      )\n    );}.react-international-phone-dial-code-preview{display:flex;align-items:center;justify-content:center;padding:0 8px;border:1px solid var(\n        --react-international-phone-dial-code-preview-border-color,\n        var(--react-international-phone-border-color, gainsboro)\n      );margin-right:-1px;background-color:var(\n      --react-international-phone-dial-code-preview-background-color,\n      var(--react-international-phone-background-color, white)\n    );color:var(\n      --react-international-phone-dial-code-preview-text-color,\n      var(--react-international-phone-text-color, #222)\n    );font-size:var(\n      --react-international-phone-dial-code-preview-font-size,\n      var(--react-international-phone-font-size, 13px)\n    );}.react-international-phone-dial-code-preview--disabled{background-color:var(\n      --react-international-phone-dial-code-preview-disabled-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );color:var(\n      --react-international-phone-dial-code-preview-disabled-text-color,\n      var(--react-international-phone-disabled-text-color, #666)\n    );}.react-international-phone-input-container{display:flex;}.react-international-phone-input-container .react-international-phone-country-selector-button{border-radius:var(--react-international-phone-border-radius, 4px);margin-right:-1px;border-bottom-right-radius:0;border-top-right-radius:0;}.react-international-phone-input-container .react-international-phone-input{overflow:visible;height:var(--react-international-phone-height, 36px);box-sizing:border-box;padding:0 8px;border:1px solid var(--react-international-phone-border-color, gainsboro);border-radius:var(--react-international-phone-border-radius, 4px);margin:0;background-color:var(--react-international-phone-background-color, white);border-bottom-left-radius:0;border-top-left-radius:0;color:var(--react-international-phone-text-color, #222);font-family:inherit;font-size:var(--react-international-phone-font-size, 13px);}.react-international-phone-input-container .react-international-phone-input:focus{outline:none;}.react-international-phone-input-container .react-international-phone-input--disabled{background-color:var(\n      --react-international-phone-disabled-background-color,\n      whitesmoke\n    );color:var(--react-international-phone-disabled-text-color, #666);}"
} : {
  name: "nziu9y",
  styles: ".react-international-phone-country-selector{position:relative;}.react-international-phone-country-selector-button{display:flex;height:var(--react-international-phone-height, 36px);box-sizing:border-box;align-items:center;justify-content:center;padding:0;border:1px solid var(\n        --react-international-phone-country-selector-border-color,\n        var(--react-international-phone-border-color, gainsboro)\n      );margin:0;appearance:button;background-color:var(\n      --react-international-phone-country-selector-background-color,\n      var(--react-international-phone-background-color, white)\n    );cursor:pointer;text-transform:none;user-select:none;}.react-international-phone-country-selector-button:hover{background-color:var(\n      --react-international-phone-country-selector-background-color-hover,\n      whitesmoke\n    );}.react-international-phone-country-selector-button--hide-dropdown{cursor:auto;}.react-international-phone-country-selector-button--hide-dropdown:hover{background-color:transparent;}.react-international-phone-country-selector-button__button-content{display:flex;align-items:center;justify-content:center;}.react-international-phone-country-selector-button__flag-emoji{margin:0 4px;}.react-international-phone-country-selector-button__flag-emoji--disabled{opacity:0.75;}.react-international-phone-country-selector-button__dropdown-arrow{border-top:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid var(--react-international-phone-country-selector-arrow-color, #777);border-right:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid transparent;border-left:var(\n        --react-international-phone-country-selector-arrow-size,\n        4px\n      ) solid transparent;margin-right:4px;transition:all 0.1s ease-out;}.react-international-phone-country-selector-button__dropdown-arrow--active{transform:rotateX(180deg);}.react-international-phone-country-selector-button__dropdown-arrow--disabled{border-top-color:var(\n      --react-international-phone-disabled-country-selector-arrow-color,\n      #999\n    );}.react-international-phone-country-selector-button--disabled{background-color:var(\n      --react-international-phone-disabled-country-selector-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );cursor:auto;}.react-international-phone-country-selector-button--disabled:hover{background-color:var(\n      --react-international-phone-disabled-country-selector-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );}.react-international-phone-flag-emoji{width:var(--react-international-phone-flag-width, 24px);height:var(--react-international-phone-flag-height, 24px);box-sizing:border-box;}.react-international-phone-country-selector-dropdown{position:absolute;z-index:1;top:var(--react-international-phone-dropdown-top, 44px);left:var(--react-international-phone-dropdown-left, 0);display:flex;width:300px;max-height:200px;flex-direction:column;padding:4px 0;margin:0;background-color:var(\n      --react-international-phone-dropdown-item-background-color,\n      var(--react-international-phone-background-color, white)\n    );box-shadow:var(\n      --react-international-phone-dropdown-shadow,\n      2px 2px 16px rgba(0, 0, 0, 0.25)\n    );color:var(\n      --react-international-phone-dropdown-item-text-color,\n      var(--react-international-phone-text-color, #222)\n    );list-style:none;overflow-y:scroll;}.react-international-phone-country-selector-dropdown__preferred-list-divider{height:1px;border:none;margin:var(\n      --react-international-phone-dropdown-preferred-list-divider-margin,\n      0\n    );background:var(\n      --react-international-phone-dropdown-preferred-list-divider-color,\n      var(--react-international-phone-border-color, gainsboro)\n    );}.react-international-phone-country-selector-dropdown__list-item{display:flex;min-height:var(--react-international-phone-dropdown-item-height, 28px);box-sizing:border-box;align-items:center;padding:2px 8px;}.react-international-phone-country-selector-dropdown__list-item-flag-emoji{margin-right:8px;}.react-international-phone-country-selector-dropdown__list-item-country-name{overflow:hidden;margin-right:8px;font-size:var(--react-international-phone-dropdown-item-font-size, 14px);text-overflow:ellipsis;white-space:nowrap;}.react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(--react-international-phone-dropdown-item-dial-code-color, gray);font-size:var(--react-international-phone-dropdown-item-font-size, 14px);}.react-international-phone-country-selector-dropdown__list-item:hover{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      var(\n        --react-international-phone-selected-dropdown-item-background-color,\n        whitesmoke\n      )\n    );cursor:pointer;}.react-international-phone-country-selector-dropdown__list-item--selected,.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      whitesmoke\n    );color:var(\n      --react-international-phone-selected-dropdown-item-text-color,\n      var(--react-international-phone-text-color, #222)\n    );}.react-international-phone-country-selector-dropdown__list-item--selected .react-international-phone-country-selector-dropdown__list-item-dial-code,.react-international-phone-country-selector-dropdown__list-item--focused .react-international-phone-country-selector-dropdown__list-item-dial-code{color:var(\n      --react-international-phone-selected-dropdown-item-dial-code-color,\n      var(--react-international-phone-dropdown-item-dial-code-color, gray)\n    );}.react-international-phone-country-selector-dropdown__list-item--focused{background-color:var(\n      --react-international-phone-selected-dropdown-item-background-color,\n      var(\n        --react-international-phone-selected-dropdown-item-background-color,\n        whitesmoke\n      )\n    );}.react-international-phone-dial-code-preview{display:flex;align-items:center;justify-content:center;padding:0 8px;border:1px solid var(\n        --react-international-phone-dial-code-preview-border-color,\n        var(--react-international-phone-border-color, gainsboro)\n      );margin-right:-1px;background-color:var(\n      --react-international-phone-dial-code-preview-background-color,\n      var(--react-international-phone-background-color, white)\n    );color:var(\n      --react-international-phone-dial-code-preview-text-color,\n      var(--react-international-phone-text-color, #222)\n    );font-size:var(\n      --react-international-phone-dial-code-preview-font-size,\n      var(--react-international-phone-font-size, 13px)\n    );}.react-international-phone-dial-code-preview--disabled{background-color:var(\n      --react-international-phone-dial-code-preview-disabled-background-color,\n      var(--react-international-phone-disabled-background-color, whitesmoke)\n    );color:var(\n      --react-international-phone-dial-code-preview-disabled-text-color,\n      var(--react-international-phone-disabled-text-color, #666)\n    );}.react-international-phone-input-container{display:flex;}.react-international-phone-input-container .react-international-phone-country-selector-button{border-radius:var(--react-international-phone-border-radius, 4px);margin-right:-1px;border-bottom-right-radius:0;border-top-right-radius:0;}.react-international-phone-input-container .react-international-phone-input{overflow:visible;height:var(--react-international-phone-height, 36px);box-sizing:border-box;padding:0 8px;border:1px solid var(--react-international-phone-border-color, gainsboro);border-radius:var(--react-international-phone-border-radius, 4px);margin:0;background-color:var(--react-international-phone-background-color, white);border-bottom-left-radius:0;border-top-left-radius:0;color:var(--react-international-phone-text-color, #222);font-family:inherit;font-size:var(--react-international-phone-font-size, 13px);}.react-international-phone-input-container .react-international-phone-input:focus{outline:none;}.react-international-phone-input-container .react-international-phone-input--disabled{background-color:var(\n      --react-international-phone-disabled-background-color,\n      whitesmoke\n    );color:var(--react-international-phone-disabled-text-color, #666);}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});

var _excluded$r = ["defaultCountry", "disableCountryGuess", "disableValidation", "entity", "forceDialCode", "hideDropdown", "index", "label", "name", "phoneDisclaimer", "phoneOptional", "phoneType", "required"];
var InputPhone = function InputPhone(_ref) {
  var _ref$defaultCountry = _ref.defaultCountry,
    defaultCountry = _ref$defaultCountry === void 0 ? 'us' : _ref$defaultCountry,
    _ref$disableCountryGu = _ref.disableCountryGuess,
    disableCountryGuess = _ref$disableCountryGu === void 0 ? true : _ref$disableCountryGu,
    _ref$disableValidatio = _ref.disableValidation,
    disableValidation = _ref$disableValidatio === void 0 ? false : _ref$disableValidatio,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$forceDialCode = _ref.forceDialCode,
    forceDialCode = _ref$forceDialCode === void 0 ? true : _ref$forceDialCode,
    _ref$hideDropdown = _ref.hideDropdown,
    hideDropdown = _ref$hideDropdown === void 0 ? true : _ref$hideDropdown,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].phone[").concat(index, "].phoneNumber") : _ref$name,
    _ref$phoneDisclaimer = _ref.phoneDisclaimer,
    phoneDisclaimer = _ref$phoneDisclaimer === void 0 ? '' : _ref$phoneDisclaimer,
    _ref$phoneOptional = _ref.phoneOptional,
    phoneOptional = _ref$phoneOptional === void 0 ? false : _ref$phoneOptional,
    _ref$phoneType = _ref.phoneType,
    phoneType = _ref$phoneType === void 0 ? 'CELL' : _ref$phoneType,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$r);
  var _useInputPhone = useInputPhone(_objectSpread2({
      disableValidation: disableValidation,
      entity: entity,
      index: index,
      label: label,
      minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
      name: name,
      phoneOptional: phoneOptional,
      phoneType: phoneType,
      required: required
    }, props)),
    errorMessage = _useInputPhone.errorMessage,
    phoneLabel = _useInputPhone.phoneLabel,
    phone = _useInputPhone.phone,
    setPhone = _useInputPhone.setPhone,
    validatePhoneInput = _useInputPhone.validatePhoneInput,
    handleOnBlurUnControlled = _useInputPhone.handleOnBlurUnControlled,
    handleOnKeyDown = _useInputPhone.handleOnKeyDown;
  var _useInputBlur = useInputBlur({
      name: name
    }),
    handleOnBlur = _useInputBlur.handleOnBlur;
  return jsxs(Fragment, {
    children: [jsxs(Form$1.Label, {
      className: "form-label-input-phone",
      htmlFor: name,
      children: [jsx("span", {
        dangerouslySetInnerHTML: {
          __html: phoneLabel
        }
      }), required ? jsx("span", {
        "aria-hidden": "true",
        children: "*"
      }) : '']
    }), jsxs(Form$1.Field, {
      className: "form-field-input-phone",
      children: [jsxs(Form$1.Control, {
        children: [props !== null && props !== void 0 && props.useCountryCode ? jsxs(PhoneContainer, {
          children: [jsx(PhoneInput, {
            defaultCountry: defaultCountry,
            disableCountryGuess: disableCountryGuess,
            forceDialCode: forceDialCode,
            hideDropdown: hideDropdown,
            value: phone,
            onBlur: handleOnBlurUnControlled,
            onChange: function onChange(value) {
              return setPhone(value);
            }
          }), errorMessage && jsx("p", {
            className: "help is-danger",
            role: "alert",
            children: errorMessage
          })]
        }) : jsx(Field$2, _objectSpread2({
          phone_mask: true,
          type: "tel",
          className: fieldClassList('input', name),
          id: name,
          name: name,
          onBlur: handleOnBlur,
          onKeyDown: handleOnKeyDown,
          required: required,
          "aria-required": required,
          validate: (props === null || props === void 0 ? void 0 : props.validate) || validatePhoneInput
        }, props)), phoneDisclaimer && jsx("div", {
          children: phoneDisclaimer
        })]
      }), name !== '' && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: jsx(ErrorMessage$1, {
          name: name
        })
      })]
    })]
  });
};

var _excluded$q = ["display", "id", "isDisabled", "label", "name", "value", "required"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RadioField = /*#__PURE__*/_styled(Field$2, process.env.NODE_ENV === "production" ? {
  target: "evh2jbl0"
} : {
  target: "evh2jbl0",
  label: "RadioField"
})(process.env.NODE_ENV === "production" ? {
  name: "10hcc6x",
  styles: "margin-right:0.313rem"
} : {
  name: "10hcc6x",
  styles: "margin-right:0.313rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJhZGlvLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNZ0MiLCJmaWxlIjoiUmFkaW8udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRmllbGQgfSBmcm9tICdmb3JtaWsnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgRm9ybSB9IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcblxuaW1wb3J0IHsgdXNlSW5wdXRWYWxpZGF0aW9uIH0gZnJvbSAnLi4vLi4vaG9va3MnO1xuXG5jb25zdCBSYWRpb0ZpZWxkID0gc3R5bGVkKEZpZWxkKWBcbiAgbWFyZ2luLXJpZ2h0OiAwLjMxM3JlbTtcbmA7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUmFkaW9Qcm9wcyB7XG4gIGRpc3BsYXk/OiBzdHJpbmc7XG4gIGlkPzogc3RyaW5nO1xuICBpc0Rpc2FibGVkPzogYm9vbGVhbjtcbiAgbGFiZWw6IHN0cmluZztcbiAgbmFtZTogc3RyaW5nO1xuICByZXF1aXJlZD86IGJvb2xlYW47XG4gIHZhbHVlOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjb25zdCBSYWRpbyA9ICh7XG4gIGRpc3BsYXkgPSAnaXMtaW5saW5lLWJsb2NrJyxcbiAgaWQsXG4gIGlzRGlzYWJsZWQgPSBmYWxzZSxcbiAgbGFiZWwsXG4gIG5hbWUgPSAnUmFkaW8nLFxuICB2YWx1ZSxcbiAgcmVxdWlyZWQsXG4gIC4uLnByb3BzXG59OiBSYWRpb1Byb3BzKSA9PiB7XG4gIGNvbnN0IHsgdmFsaWRhdGVJbnB1dCB9ID0gdXNlSW5wdXRWYWxpZGF0aW9uKHsgcmVxdWlyZWQgfSk7XG4gIHJldHVybiAoXG4gICAgPEZvcm0uTGFiZWwgY2xhc3NOYW1lPXtkaXNwbGF5fSBwcj17Mn0+XG4gICAgICA8UmFkaW9GaWVsZFxuICAgICAgICB0eXBlPVwicmFkaW9cIlxuICAgICAgICBkaXNhYmxlZD17aXNEaXNhYmxlZH1cbiAgICAgICAgaWQ9e2lkfVxuICAgICAgICBuYW1lPXtuYW1lfVxuICAgICAgICB2YWxpZGF0ZT17dmFsaWRhdGVJbnB1dH1cbiAgICAgICAgdmFsdWU9e3ZhbHVlfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAvPlxuICAgICAge2xhYmVsfVxuICAgIDwvRm9ybS5MYWJlbD5cbiAgKTtcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});
var Radio = function Radio(_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'is-inline-block' : _ref$display,
    id = _ref.id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'Radio' : _ref$name,
    value = _ref.value,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded$q);
  var _useInputValidation = useInputValidation({
      required: required
    }),
    validateInput = _useInputValidation.validateInput;
  return jsxs(Form$1.Label, {
    className: display,
    pr: 2,
    children: [jsx(RadioField, _objectSpread2({
      type: "radio",
      disabled: isDisabled,
      id: id,
      name: name,
      validate: validateInput,
      value: value
    }, props)), label]
  });
};

/* eslint-disable react/no-danger */

var RadioGroup = function RadioGroup(_ref) {
  var display = _ref.display,
    label = _ref.label,
    name = _ref.name,
    options = _ref.options,
    required = _ref.required;
  return jsxs(Fragment, {
    children: [jsx(Form$1.Label, {
      className: "form-label-radio-group",
      children: jsx("span", {
        dangerouslySetInnerHTML: {
          __html: label
        }
      })
    }), jsxs(Form$1.Field, {
      className: "form-field-radio-group",
      children: [jsx(Form$1.Control, {
        children: options.map(function (option) {
          return jsx(Radio, {
            display: display,
            id: option.id,
            isDisabled: option === null || option === void 0 ? void 0 : option.isDisabled,
            name: name,
            label: option.label,
            required: required,
            value: option.value
          }, option.id);
        })
      }), name !== '' && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: jsx(ErrorMessage$1, {
          name: name
        })
      })]
    })]
  });
};

var _excluded$p = ["country", "display", "entity", "hideChurchDenomination", "isEmbedSite", "orgType", "relationshipPath", "relationshipType", "setOrg", "addressVisibleList"];
var ColumnsStyled = /*#__PURE__*/_styled(Columns, process.env.NODE_ENV === "production" ? {
  target: "ecsjyi30"
} : {
  target: "ecsjyi30",
  label: "ColumnsStyled"
})("margin-bottom:", function (props) {
  return !props.isEmbedSite ? '0 !important' : 'auto';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Church = function Church(_ref) {
  var _props$requiredList, _props$requiredList2, _props$denominationOp, _props$requiredList3, _props$requiredList4, _props$languageOption;
  var country = _ref.country,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'] : _ref$display,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 1 : _ref$entity,
    hideChurchDenomination = _ref.hideChurchDenomination,
    _ref$isEmbedSite = _ref.isEmbedSite,
    isEmbedSite = _ref$isEmbedSite === void 0 ? false : _ref$isEmbedSite,
    _ref$orgType = _ref.orgType,
    orgType = _ref$orgType === void 0 ? 'church' : _ref$orgType,
    _ref$relationshipPath = _ref.relationshipPath,
    relationshipPath = _ref$relationshipPath === void 0 ? 'collector.entity[0]' : _ref$relationshipPath,
    _ref$relationshipType = _ref.relationshipType,
    relationshipType = _ref$relationshipType === void 0 ? 'Church' : _ref$relationshipType,
    _ref$setOrg = _ref.setOrg,
    setOrg = _ref$setOrg === void 0 ? true : _ref$setOrg,
    addressVisibleList = _ref.addressVisibleList,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var _useChurch = useChurch(_objectSpread2({
      entity: entity,
      orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
      orgType: orgType,
      relationshipPath: relationshipPath,
      relationshipType: relationshipType,
      setOrg: setOrg
    }, props)),
    attendanceLabel = _useChurch.attendanceLabel,
    capacityLabel = _useChurch.capacityLabel,
    churchAddressLabel = _useChurch.churchAddressLabel,
    churchLabel = _useChurch.churchLabel,
    churchLangQuestionLabel = _useChurch.churchLangQuestionLabel,
    denominationLabel = _useChurch.denominationLabel,
    mobilePhoneLabel = _useChurch.mobilePhoneLabel,
    orgFieldName = _useChurch.orgFieldName,
    orgRoleName = _useChurch.orgRoleName,
    orgRolesList = _useChurch.orgRolesList,
    phoneName = _useChurch.phoneName,
    phoneLabel = _useChurch.phoneLabel,
    roleLabel = _useChurch.roleLabel;
  return jsxs(Container, {
    children: [jsxs(ColumnsStyled, {
      isEmbedSite: isEmbedSite,
      children: [display.includes('OrganizationName') && jsx(Columns.Column, {
        size: "half",
        children: jsx(InputText, {
          label: churchLabel,
          name: orgFieldName,
          required: props === null || props === void 0 ? void 0 : (_props$requiredList = props.requiredList) === null || _props$requiredList === void 0 ? void 0 : _props$requiredList.includes('OrganizationName')
        })
      }), display.includes('OrganizationRole') && jsx(Columns.Column, {
        size: "half",
        children: jsx(Dropdown, {
          label: roleLabel,
          name: orgRoleName,
          options: orgRolesList,
          required: props === null || props === void 0 ? void 0 : (_props$requiredList2 = props.requiredList) === null || _props$requiredList2 === void 0 ? void 0 : _props$requiredList2.includes('OrganizationRole')
        })
      }), !hideChurchDenomination && (props === null || props === void 0 ? void 0 : (_props$denominationOp = props.denominationOptions) === null || _props$denominationOp === void 0 ? void 0 : _props$denominationOp.length) > 0 && jsx(Columns.Column, {
        size: "half",
        children: jsx(Dropdown, {
          name: "formLogic.denomination",
          label: denominationLabel,
          required: true,
          options: props === null || props === void 0 ? void 0 : props.denominationOptions
        })
      }), display.includes('Phone') && jsx(Columns.Column, {
        size: "half",
        children: jsx(InputPhone, {
          label: (props === null || props === void 0 ? void 0 : props.phoneLabel) || phoneLabel,
          entity: entity,
          name: phoneName,
          phoneType: props === null || props === void 0 ? void 0 : props.phoneType,
          required: props === null || props === void 0 ? void 0 : (_props$requiredList3 = props.requiredList) === null || _props$requiredList3 === void 0 ? void 0 : _props$requiredList3.includes('Phone'),
          minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer
        })
      }), display.includes('MobilePhone') && jsx(Columns.Column, {
        children: jsx(InputPhone, {
          entity: entity,
          index: (props === null || props === void 0 ? void 0 : props.mobilePhoneIndex) || 1,
          required: (props === null || props === void 0 ? void 0 : props.mobilePhoneRequired) || false,
          label: (props === null || props === void 0 ? void 0 : props.mobilePhoneLabel) || mobilePhoneLabel,
          minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
          name: props === null || props === void 0 ? void 0 : props.phoneFieldName,
          phoneType: (props === null || props === void 0 ? void 0 : props.mobilePhoneType) || 'CELL',
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer
        })
      }), display.includes('Website') && jsx(Columns.Column, {
        size: "half",
        children: jsx(InputText, {
          name: "formLogic.churchWebsite",
          label: "Church website"
        })
      })]
    }), display.includes('Address') && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
      address1Label: props === null || props === void 0 ? void 0 : props.address1Label,
      country: country,
      customRegionList: props === null || props === void 0 ? void 0 : props.customRegionList,
      entity: entity,
      index: 0,
      isEmbedSite: isEmbedSite,
      label: churchAddressLabel,
      name: props === null || props === void 0 ? void 0 : props.churchFieldName,
      postalCodeList: props === null || props === void 0 ? void 0 : props.postalCodeList,
      type: props.addressType || 'MAIL',
      showLabel: props === null || props === void 0 ? void 0 : props.showAddressLabel,
      required: props === null || props === void 0 ? void 0 : (_props$requiredList4 = props.requiredList) === null || _props$requiredList4 === void 0 ? void 0 : _props$requiredList4.includes('Address'),
      visibleList: addressVisibleList
    })), (props === null || props === void 0 ? void 0 : props.showLangQuestion) && (props === null || props === void 0 ? void 0 : (_props$languageOption = props.languageOptions) === null || _props$languageOption === void 0 ? void 0 : _props$languageOption.length) > 0 && jsx(RadioGroup, {
      label: churchLangQuestionLabel,
      name: "formLogic.churchLangQuestion",
      options: props === null || props === void 0 ? void 0 : props.languageOptions
    }), (props === null || props === void 0 ? void 0 : props.showAttendanceField) && jsx(InputText, {
      label: attendanceLabel,
      name: "formLogic.churchAttendance.orgs[".concat(entity, "].avgWeekendAttendance"),
      required: props === null || props === void 0 ? void 0 : props.attendanceFieldRequired
    }), (props === null || props === void 0 ? void 0 : props.showChurchCapacity) && jsx(InputText, {
      label: capacityLabel,
      name: "formLogic.sanctuarySize.orgs[".concat(entity, "].sanctuarySize"),
      required: true
    })]
  });
};

var _excluded$o = ["country", "entity", "index", "name", "required", "showCountry", "validate", "validateZipPostalCode"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Column$2 = /*#__PURE__*/_styled(Columns.Column, process.env.NODE_ENV === "production" ? {
  target: "e142amtx0"
} : {
  target: "e142amtx0",
  label: "Column"
})(process.env.NODE_ENV === "production" ? {
  name: "pit38s",
  styles: "height:auto"
} : {
  name: "pit38s",
  styles: "height:auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var CountryPostal = function CountryPostal(_ref) {
  var limitCountry = _ref.country,
    _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].address[").concat(index, "]") : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    _ref$showCountry = _ref.showCountry,
    showCountry = _ref$showCountry === void 0 ? false : _ref$showCountry,
    validate = _ref.validate,
    validateZipPostalCode = _ref.validateZipPostalCode,
    props = _objectWithoutProperties(_ref, _excluded$o);
  var _useCountryPostal = useCountryPostal({
      required: required
    }),
    postalCodeLabel = _useCountryPostal.postalCodeLabel;
  var _useInputValidation = useInputValidation({
      required: required
    }),
    validateInput = _useInputValidation.validateInput;
  var size = showCountry ? 'half' : 'one-third';
  return jsx(Form$1.Field, {
    className: "country-postal",
    children: jsx(Form$1.Control, {
      "aria-label": "currency",
      children: jsxs(Columns, {
        children: [jsx(Column$2, {
          size: size,
          className: "postal-code-field",
          children: jsx(InputText, {
            label: (props === null || props === void 0 ? void 0 : props.postalCodeLabel) || postalCodeLabel,
            name: "".concat(name, ".zipPostalCode"),
            required: true,
            validate: validateZipPostalCode || validate || validateInput
          })
        }), showCountry && jsx(Column$2, {
          size: "half",
          className: "country-field",
          children: jsx(Country, {
            name: "".concat(name, ".country"),
            entity: entity,
            index: index,
            country: limitCountry,
            required: required,
            validate: validate
          })
        })]
      })
    })
  });
};

var _excluded$n = ["index", "inputSize", "name", "placeholderText", "onChange", "required", "disableOnBlur", "validate"];
var Currency = function Currency(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$inputSize = _ref.inputSize,
    inputSize = _ref$inputSize === void 0 ? '' : _ref$inputSize,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.cart.donation.projects.".concat(index, ".amount") : _ref$name,
    _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? '' : _ref$placeholderText,
    _onChange = _ref.onChange,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    _ref$disableOnBlur = _ref.disableOnBlur,
    disableOnBlur = _ref$disableOnBlur === void 0 ? false : _ref$disableOnBlur,
    validate = _ref.validate,
    props = _objectWithoutProperties(_ref, _excluded$n);
  var _useCurrency = useCurrency(_objectSpread2({
      name: name,
      required: required,
      validate: validate
    }, props)),
    currencyValue = _useCurrency.currencyValue,
    handleChange = _useCurrency.handleChange,
    handleOnFocus = _useCurrency.handleOnFocus,
    handleOnKeyDown = _useCurrency.handleOnKeyDown,
    onBlurFormatValue = _useCurrency.onBlurFormatValue,
    setIsEditing = _useCurrency.setIsEditing,
    validateMemo = _useCurrency.validateMemo;
  return jsx(Form$1.Field, {
    children: jsxs(Form$1.Control, {
      "aria-label": "currency",
      children: [jsx(Field$2, {
        "aria-label": "currency",
        className: "input is-".concat(inputSize),
        id: name,
        inputMode: "decimal",
        name: name,
        onBlur: disableOnBlur ? function () {} : onBlurFormatValue // Use this bool to decide if onBlur should be used
        ,
        onChange: function onChange(e) {
          e.persist = function () {};
          setIsEditing(true);
          handleChange(e);
          _onChange && _onChange(e);
        },
        onFocus: handleOnFocus,
        onKeyDown: handleOnKeyDown,
        onWheel: function onWheel(event) {
          return event.currentTarget.blur();
        },
        pattern: "^[0-9]*\\.[0-9]{2}$",
        placeholder: placeholderText,
        step: "1.00",
        type: "number",
        validate: validateMemo,
        value: currencyValue || ''
      }), jsx(Icon, {
        align: "left",
        size: "small",
        children: jsx(DollarSignIcon, {
          height: "1em",
          viewBox: "0 0 320 512"
        })
      }), name !== '' && jsx("p", {
        className: "help is-danger",
        children: jsx(ErrorMessage$1, {
          name: name
        })
      })]
    })
  });
};

var CustomMarkupSection = function CustomMarkupSection(_ref) {
  var styles = _ref.styles,
    customMarkup = _ref.customMarkup;
  return jsx(Fragment, {
    children: customMarkup && Object.keys(customMarkup).length > 0 && jsx(Form$1.Field, {
      children: jsx("div", {
        style: styles === null || styles === void 0 ? void 0 : styles.main
        // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: customMarkup.markup
        }
      })
    })
  });
};

var _excluded$m = ["label", "dateFormat", "dateStart", "name", "required", "placeholderText"];
var DateCalendar = function DateCalendar(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Date' : _ref$label,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'MM/dd/yyyy' : _ref$dateFormat,
    _ref$dateStart = _ref.dateStart,
    dateStart = _ref$dateStart === void 0 ? null : _ref$dateStart,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'Date' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? 'mm/dd/yyyy' : _ref$placeholderText,
    props = _objectWithoutProperties(_ref, _excluded$m);
  var _useDateCalendar = useDateCalendar({
      label: label,
      dateFormat: dateFormat,
      dateStart: dateStart,
      name: name,
      required: required
    }),
    errorState = _useDateCalendar.errorState,
    errorMessage = _useDateCalendar.errorMessage,
    handleOnBlur = _useDateCalendar.handleOnBlur,
    handleOnChange = _useDateCalendar.handleOnChange,
    startDate = _useDateCalendar.startDate,
    validate = _useDateCalendar.validate;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    i18n = _useTranslation.i18n;
  switch (i18n.language) {
    case 'ar':
      registerLocale(i18n.language, ar);
      break;
    case 'es':
      registerLocale(i18n.language, es);
      break;
    case 'pt':
      registerLocale(i18n.language, pt);
      break;
    case 'ru':
      registerLocale(i18n.language, ru);
      break;
    case 'zh':
      registerLocale(i18n.language, zhCN);
      break;
    case 'zh-tw':
      registerLocale(i18n.language, zhTW);
      break;
    default:
      registerLocale(i18n.language, enUS);
  }
  return jsxs(Fragment, {
    children: [jsx(Form$1.Label, {
      children: label
    }), jsxs(Form$1.Field, {
      children: [jsx(Form$1.Control, {
        children: jsx(Field$2, {
          name: name,
          type: "text",
          validate: validate,
          required: required,
          children: function children(_ref2) {
            var field = _ref2.field;
            return jsx(DatePicker, _objectSpread2(_objectSpread2(_objectSpread2({}, field), props), {}, {
              selected: startDate,
              name: field.name,
              onChange: handleOnChange,
              locale: i18n.language,
              className: errorState ? 'react-datePicker__error input' : 'input',
              dateFormat: dateFormat,
              onBlur: handleOnBlur,
              placeholderText: placeholderText,
              showMonthDropdown: true,
              showYearDropdown: true,
              style: {
                width: '100%'
              }
            }));
          }
        })
      }), required && errorMessage && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: errorMessage
      })]
    })]
  });
};

var ItemCalculator = function ItemCalculator(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Number of items' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "formLogic.itemCalculator[".concat(index, "].amount") : _ref$name,
    pledge = _ref.pledge;
  var _useItemCalculator = useItemCalculator({
      index: index,
      pledge: pledge
    }),
    handleItemChange = _useItemCalculator.handleItemChange;
  return jsx(Columns, {
    children: jsx(Columns.Column, {
      size: "half",
      children: jsxs(Form$1.Control, {
        children: [jsx("label", {
          className: "label",
          htmlFor: name,
          children: label
        }), jsx(Field$2, {
          id: name,
          onWheel: function onWheel(event) {
            return event.currentTarget.blur();
          },
          name: name,
          type: "number",
          onChange: handleItemChange,
          label: "",
          className: "input"
        })]
      })
    })
  });
};

var SREDKeyPadModal = function SREDKeyPadModal(_ref) {
  var keyInput = _ref.keyInput,
    modalIsOpen = _ref.modalIsOpen,
    handleOnCloseModal = _ref.handleOnCloseModal;
  useSREDKeyPadModal({
    keyInput: keyInput
  });
  return jsx(Modal, {
    closeOnBlur: true,
    closeOnEsc: true,
    show: modalIsOpen,
    showClose: false,
    onClose: function onClose() {
      return handleOnCloseModal();
    },
    children: jsx(Modal.Card, {
      children: jsx(Modal.Card.Body, {
        children: jsx(Content, {
          children: jsx(Container, {
            mb: 4,
            children: jsx(Notification, {
              color: "secondary",
              children: "Type in the caller's credit card information."
            })
          })
        })
      })
    })
  });
};

var SREDKeyPad = function SREDKeyPad(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Credit Card Information' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "payment.bluefinECC.data" : _ref$name;
  var _useSREDKeyPad = useSREDKeyPad(),
    keyInput = _useSREDKeyPad.keyInput,
    fauxKeyInput = _useSREDKeyPad.fauxKeyInput,
    modalIsOpen = _useSREDKeyPad.modalIsOpen,
    showClearButton = _useSREDKeyPad.showClearButton,
    SREDKeyFormattedValue = _useSREDKeyPad.SREDKeyFormattedValue,
    clearInput = _useSREDKeyPad.clearInput,
    handleBlur = _useSREDKeyPad.handleBlur,
    handleOnCloseModal = _useSREDKeyPad.handleOnCloseModal,
    handleOnModalClick = _useSREDKeyPad.handleOnModalClick;
  return jsxs(Form$1.Field, {
    pt: 4,
    children: [jsx(Form$1.Label, {
      htmlFor: "formLogic.SREDKey",
      children: label
    }), jsxs(Form$1.Control, {
      children: [jsx(Field$2, {
        type: "text",
        className: "input",
        name: "formLogic.dummyTextField",
        innerRef: keyInput,
        "aria-hidden": true,
        onBlur: function onBlur(e) {
          handleOnCloseModal();
          handleBlur(e);
        },
        style: {
          opacity: '0',
          height: '0',
          width: '0',
          padding: '0',
          position: 'absolute'
        }
      }), jsx(Field$2, {
        type: "text",
        className: "input",
        name: name,
        label: label,
        onBlur: function onBlur(e) {
          handleOnCloseModal();
          handleBlur(e);
        },
        "aria-label": "value-input",
        style: {
          opacity: '0',
          height: '0',
          width: '0',
          padding: '0',
          position: 'absolute'
        }
      }), jsxs(Form$1.Field, {
        kind: "addons",
        children: [jsx(Form$1.Control, {
          children: showClearButton ? jsx(Button, {
            type: "button",
            className: "button is-info",
            id: "SREDclear",
            onClick: clearInput,
            children: "Clear"
          }) : jsx(Button, {
            type: "button",
            className: "button is-info",
            id: "SREDbutton",
            onClick: handleOnModalClick,
            style: {
              zIndex: '0'
            },
            children: "Input Credit Card"
          })
        }), jsx(Form$1.Control, {
          children: jsx(Field$2, {
            type: "text",
            name: "formLogic.SREDKey",
            id: "formLogic.SREDKey",
            label: "",
            value: SREDKeyFormattedValue,
            onClick: handleOnModalClick,
            innerRef: fauxKeyInput,
            className: "input is-info",
            style: {
              zIndex: 0
            }
          })
        })]
      })]
    }), jsx(SREDKeyPadModal, {
      keyInput: keyInput,
      modalIsOpen: modalIsOpen,
      handleOnCloseModal: handleOnCloseModal
    })]
  });
};

/* eslint-disable react/no-danger */

var FreeGiftOffer = function FreeGiftOffer(_ref) {
  var giftOffer = _ref.giftOffer;
  var _useFreeGiftOffer = useFreeGiftOffer({
      giftOffer: giftOffer
    }),
    deliveryStatement = _useFreeGiftOffer.deliveryStatement,
    labelText = _useFreeGiftOffer.labelText,
    options = _useFreeGiftOffer.options;
  return jsx(Fragment, {
    children: ((giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.title) || (giftOffer === null || giftOffer === void 0 ? void 0 : giftOffer.description)) && jsx("div", {
      className: "free-gift-offer-container container",
      children: jsxs("div", {
        className: "notification",
        children: [jsx("div", {
          className: "button-group has-addons",
          children: jsx(RadioGroup, {
            display: "is-block",
            label: labelText,
            name: "formLogic.freeGiftOffer",
            options: options,
            required: true
          })
        }), jsx("p", {
          children: jsx("small", {
            children: jsx("span", {
              dangerouslySetInnerHTML: {
                __html: deliveryStatement
              }
            })
          })
        })]
      })
    })
  });
};

var KeyPadPayment = function KeyPadPayment() {
  var _useKeyPadPayment = useKeyPadPayment(),
    giftOffer = _useKeyPadPayment.giftOffer,
    showGiftOffer = _useKeyPadPayment.showGiftOffer;
  return jsxs(Fragment, {
    children: [jsx(SREDKeyPad, {}), showGiftOffer && jsx(FreeGiftOffer, {
      giftOffer: giftOffer
    })]
  });
};

var _excluded$l = ["isPaypalPayment", "formErrors"],
  _excluded2 = ["isPaypalPayment", "formErrors"],
  _excluded3 = ["formErrors"],
  _excluded4 = ["formErrors"],
  _excluded5 = ["showFloodControlledError", "showTimeoutErrorScreen"];
var RecaptchaError = function RecaptchaError(_ref) {
  var isPaypalPayment = _ref.isPaypalPayment,
    formErrors = _ref.formErrors,
    props = _objectWithoutProperties(_ref, _excluded$l);
  var domAttributes = pickDomAttributes(props);
  var recaptchaStr1 = props !== null && props !== void 0 && props.lng ? formErrors['Unfortunately we are not able to verify the information you provided.'] : 'Unfortunately we are not able to verify the information you provided.';
  var recaptchaStr2 = props !== null && props !== void 0 && props.lng ? formErrors['If you would like assistance, please call us at 877-247-2426 or email us at'] : 'If you would like assistance, please call us at 877-247-2426 or email us at webmaster@billygraham.org';
  var recaptchaStr3 = props !== null && props !== void 0 && props.lng ? formErrors['We apologize for any inconvenience.'] : 'We apologize for any inconvenience.';
  return jsx(Container, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
    my: 3,
    children: jsxs(Notification, {
      color: "danger",
      children: [isPaypalPayment && jsx("p", {
        children: ErrorMessages.PaypalFailureMessage
      }), jsxs("p", {
        children: [recaptchaStr1, jsx("br", {}), " ", recaptchaStr2, ' ', jsx("a", {
          href: "mailto:webmaster@billygraham.org",
          children: "webmaster@billygraham.org"
        }), ". ", recaptchaStr3]
      })]
    })
  }));
};
var ErrorMessage = function ErrorMessage(_ref2) {
  var isPaypalPayment = _ref2.isPaypalPayment,
    formErrors = _ref2.formErrors,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var errorMessageStr1 = props !== null && props !== void 0 && props.lng ? formErrors['Please try again or call 877-247-2426 or email us at'] : 'Please try again or call 877-247-2426 or email us at';
  var errorMessageStr2 = props !== null && props !== void 0 && props.lng ? formErrors['for assistance.'] : 'for assistance.';
  var errorMessageStr3 = props !== null && props !== void 0 && props.lng ? formErrors['Please share the below information with us.'] : 'Please share the below information with us.';
  return jsx(Message, {
    color: "danger",
    children: jsxs(Message.Body, {
      children: [isPaypalPayment && jsx("p", {
        children: ErrorMessages.PaypalFailureMessage
      }), jsxs("p", {
        children: [errorMessageStr1, ' ', jsx("a", {
          href: "mailto:webmaster@billygraham.org",
          children: "webmaster@billygraham.org"
        }), ' ', errorMessageStr2]
      }), jsx("p", {
        children: errorMessageStr3
      }), jsx("span", {
        dangerouslySetInnerHTML: {
          __html: (props === null || props === void 0 ? void 0 : props.customErrorMessage) || (props === null || props === void 0 ? void 0 : props.errorMessage)
        }
      })]
    })
  });
};
var ErrorTimeoutMessage = function ErrorTimeoutMessage() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var errDonationMsg = "We are experiencing technical difficulties, and your donation may not have been processed. If it was successful, you will receive an email confirmation in the next 2 business days. If you need assistance, please call us toll-free at 877-247-2426.  Thank you for your patience and understanding.";
  var errMsg = "We are experiencing technical difficulties, and your submission may not have been processed.  If you need assistance, please call us toll-free at 877-247-2426.  Thank you for your patience and understanding.";
  return jsx(Message, {
    color: "danger",
    children: jsx(Message.Body, {
      children: values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.isDonation ? errDonationMsg : errMsg
    })
  });
};
var ErrorScreen = function ErrorScreen(_ref3) {
  var _errors$, _errors$$data, _errors$2, _values$formLogic2, _error$toLowerCase;
  var formErrors = _ref3.formErrors,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var domAttributes = pickDomAttributes(props);
  var _useFormikContext2 = useFormikContext(),
    values = _useFormikContext2.values;
  var submissionresponse = values === null || values === void 0 ? void 0 : values.submissionresponse;
  var errors = submissionresponse === null || submissionresponse === void 0 ? void 0 : submissionresponse.errors;
  var error = (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? ((_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : (_errors$$data = _errors$.data) === null || _errors$$data === void 0 ? void 0 : _errors$$data.message) || ((_errors$2 = errors[0]) === null || _errors$2 === void 0 ? void 0 : _errors$2.message) : '';
  var isPaypalPayment = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.isPaypalPayment;
  var errorStr1 = props !== null && props !== void 0 && props.lng ? formErrors['Please try again or call 877-247-2426 or email us at'] : 'Please try again or call 877-247-2426 or email us at';
  var errorStr2 = props !== null && props !== void 0 && props.lng ? formErrors['for assistance.'] : 'for assistance.';
  var errorStr3 = props !== null && props !== void 0 && props.lng ? formErrors['Please share the below information with us.'] : 'Please share the below information with us.';
  var CustomErrorComponent = props === null || props === void 0 ? void 0 : props.customErrorComponent;
  if (error !== null && error !== void 0 && (_error$toLowerCase = error.toLowerCase()) !== null && _error$toLowerCase !== void 0 && _error$toLowerCase.includes('recaptcha')) {
    return jsx(RecaptchaError, _objectSpread2(_objectSpread2({}, props), {}, {
      isPaypalPayment: isPaypalPayment,
      formErrors: formErrors
    }));
  }
  if (props !== null && props !== void 0 && props.useErrorMessage && (props !== null && props !== void 0 && props.errorMessage || props !== null && props !== void 0 && props.customErrorMessage)) {
    return jsx(ErrorMessage, _objectSpread2(_objectSpread2({}, props), {}, {
      isPaypalPayment: isPaypalPayment,
      formErrors: formErrors
    }));
  }
  return (
    // Only render if there's an error
    error || props !== null && props !== void 0 && props.errorMessage || props !== null && props !== void 0 && props.customErrorComponent ? jsx(Container, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
      my: 3,
      children: jsxs(Notification, {
        color: "danger",
        children: [isPaypalPayment && jsx("p", {
          children: ErrorMessages.PaypalFailureMessage
        }), !(props !== null && props !== void 0 && props.customErrorComponent) ? jsxs(Fragment, {
          children: [jsxs("p", {
            children: [errorStr1, ' ', jsx("a", {
              href: "mailto:webmaster@billygraham.org",
              children: "webmaster@billygraham.org"
            }), ' ', errorStr2]
          }), (error || (props === null || props === void 0 ? void 0 : props.errorMessage)) && jsxs(Fragment, {
            children: [jsx("p", {
              children: errorStr3
            }), jsx("pre", {
              children: error || (props === null || props === void 0 ? void 0 : props.errorMessage)
            })]
          })]
        }) : jsx(CustomErrorComponent, {})]
      })
    })) : null
  );
};
var FloodControlledErrorScreen = function FloodControlledErrorScreen(_ref4) {
  var formErrors = _ref4.formErrors,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var domAttributes = pickDomAttributes(props);
  var floodStr1 = props !== null && props !== void 0 && props.lng ? formErrors['Please wait and try again later or call 877-247-2426 or email us at'] : 'Please wait and try again later or call 877-247-2426 or email us at';
  var floodStr2 = props !== null && props !== void 0 && props.lng ? formErrors['for assistance.'] : 'for assistance.';
  return jsx(Container, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
    my: 3,
    children: jsxs(Notification, {
      color: "warning",
      children: [jsx("p", {
        children: props === null || props === void 0 ? void 0 : props.errorMessage
      }), jsxs("p", {
        children: [floodStr1, ' ', jsx("a", {
          href: "mailto:webmaster@billygraham.org",
          children: "webmaster@billygraham.org"
        }), ' ', floodStr2]
      })]
    })
  }));
};
var FormErrorScreens = function FormErrorScreens(_ref5) {
  var showFloodControlledError = _ref5.showFloodControlledError,
    showTimeoutErrorScreen = _ref5.showTimeoutErrorScreen,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var _useFormErrorScreen = useFormErrorScreen({
      lng: props === null || props === void 0 ? void 0 : props.lng
    }),
    formErrors = _useFormErrorScreen.formErrors;
  if (showTimeoutErrorScreen) {
    return jsx(ErrorTimeoutMessage, {});
  }
  return showFloodControlledError ? jsx(FloodControlledErrorScreen, _objectSpread2(_objectSpread2({}, props), {}, {
    formErrors: formErrors
  })) : jsx(ErrorScreen, _objectSpread2(_objectSpread2({}, props), {}, {
    formErrors: formErrors
  }));
};

var _excluded$k = ["masked", "method", "iframeSelector", "callbacks", "submitLabel"];
var BluefinPaymentIframe = function BluefinPaymentIframe(_ref) {
  var _ref$masked = _ref.masked,
    masked = _ref$masked === void 0 ? undefined : _ref$masked,
    method = _ref.method,
    _ref$iframeSelector = _ref.iframeSelector,
    iframeSelector = _ref$iframeSelector === void 0 ? 'payment_iframe' : _ref$iframeSelector,
    _ref$callbacks = _ref.callbacks,
    callbacks = _ref$callbacks === void 0 ? {} : _ref$callbacks,
    _ref$submitLabel = _ref.submitLabel,
    submitLabel = _ref$submitLabel === void 0 ? 'Process Payment' : _ref$submitLabel,
    props = _objectWithoutProperties(_ref, _excluded$k);
  var _useBluefinPaymentIfr = useBluefinPaymentIframe(_objectSpread2({
      callbacks: callbacks,
      masked: masked,
      method: method
    }, props)),
    ackText = _useBluefinPaymentIfr.ackText,
    errorMessage = _useBluefinPaymentIfr.errorMessage,
    giftOffer = _useBluefinPaymentIfr.giftOffer,
    iframeLoaded = _useBluefinPaymentIfr.iframeLoaded,
    isDisabled = _useBluefinPaymentIfr.isDisabled,
    isEmbedSite = _useBluefinPaymentIfr.isEmbedSite,
    isSubmitting = _useBluefinPaymentIfr.isSubmitting,
    privacyText = _useBluefinPaymentIfr.privacyText,
    processBtn = _useBluefinPaymentIfr.processBtn,
    ref = _useBluefinPaymentIfr.ref,
    showFormErrorScreen = _useBluefinPaymentIfr.showFormErrorScreen,
    showGiftOffer = _useBluefinPaymentIfr.showGiftOffer,
    state = _useBluefinPaymentIfr.state,
    status = _useBluefinPaymentIfr.status,
    totalAmount = _useBluefinPaymentIfr.totalAmount;
  return jsxs(Container, {
    className: "payment-bluefin-container",
    pt: 4,
    children: [jsxs(Panel, {
      className: state === null || state === void 0 ? void 0 : state.panelClass,
      children: [jsxs(Panel.Header, {
        children: [jsx(LockIcon, {
          viewBox: "0 0 448 512"
        }), jsx("span", {
          children: " ".concat(state.iframeHeading)
        })]
      }), jsx(Panel.Block, {
        children: jsx("iframe", {
          title: "bluefin-payment",
          ref: ref,
          id: iframeSelector,
          className: state.iframeClass,
          width: props.config.settings.width,
          height: props.config.settings.height
          // style={props.config.settings.style}
          ,
          src: state.iframeSrc,
          onLoad: iframeLoaded
        })
      })]
    }), jsxs(Block, {
      children: [showGiftOffer && jsx(FreeGiftOffer, {
        giftOffer: giftOffer
      }), jsxs(Content, {
        textSize: 6,
        className: "payment-privacy-content",
        children: [ackText, jsx("strong", {
          children: jsx("a", {
            href: (props === null || props === void 0 ? void 0 : props.privacyLink) || 'https://billygraham.org/privacy-policy/',
            target: "_blank",
            rel: "noopener noreferrer",
            children: privacyText
          })
        })]
      })]
    }), showFormErrorScreen && isEmbedSite && jsx(FormErrorScreens, _objectSpread2(_objectSpread2({}, props), {}, {
      errorMessage: errorMessage,
      useErrorMessage: true
    })), jsxs(Block, {
      display: "flex",
      justifyContent: "flex-end",
      className: "payment-submit-button",
      children: [parseInt(totalAmount, 10) > 0 && jsxs("div", {
        style: {
          padding: '0.5rem 0.5rem'
        },
        children: [jsx("strong", {
          children: "Total:"
        }), " ", "$".concat(totalAmount)]
      }), isSubmitting || status === 'BluefinEncrypting' ? jsx("button", {
        className: "button is-primary is-loading",
        type: "button",
        disabled: true,
        children: "Submitting"
      }) : jsx("button", {
        className: "button is-primary",
        type: "button",
        disabled: isDisabled,
        onClick: function onClick() {
          return processBtn();
        },
        children: submitLabel
      })]
    })]
  });
};

var _excluded$j = ["envVariables", "method", "type", "submitLabel"];
var BluefinPayment = function BluefinPayment(_ref) {
  var _ref$envVariables = _ref.envVariables,
    envVariables = _ref$envVariables === void 0 ? {} : _ref$envVariables,
    method = _ref.method,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CC' : _ref$type,
    _ref$submitLabel = _ref.submitLabel,
    submitLabel = _ref$submitLabel === void 0 ? 'Process Payment' : _ref$submitLabel,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var _useBluefinPayment = useBluefinPayment(),
    BFConfig = _useBluefinPayment.BFConfig;
  var configVariables = [envVariables.bluefinAcc || process.env.BLUEFIN_ACCOUNT, envVariables.bluefinDevServer || process.env.BLUEFIN_DEVSERVER, envVariables.gatsbyBluefinAcc || process.env.BLUEFIN_ACCOUNT, envVariables.gatsbyBluefinDevServer || process.env.BLUEFIN_DEVSERVER];
  return jsx("div", {
    className: "field",
    children: jsx(BluefinPaymentIframe, _objectSpread2({
      type: type,
      config: BFConfig.apply(void 0, [type].concat(configVariables)),
      method: method,
      submitLabel: submitLabel
    }, props), type)
  });
};

var DonationCart = function DonationCart(_ref) {
  var projectId = _ref.projectId;
  var _useDonationCart = useDonationCart({
      projectId: projectId
    }),
    availableDateOptions = _useDonationCart.availableDateOptions,
    defaultRecurringValue = _useDonationCart.defaultRecurringValue,
    defaultValue = _useDonationCart.defaultValue,
    getGiftName = _useDonationCart.getGiftName,
    itemizedDonations = _useDonationCart.itemizedDonations,
    itemName = _useDonationCart.itemName,
    projectOptions = _useDonationCart.projectOptions,
    recurringDate = _useDonationCart.recurringDate,
    recurringDonations = _useDonationCart.recurringDonations,
    recurringGiftDate = _useDonationCart.recurringGiftDate,
    recurringTotal = _useDonationCart.recurringTotal,
    showChecking = _useDonationCart.showChecking,
    showKeyPad = _useDonationCart.showKeyPad,
    subTotal = _useDonationCart.subTotal,
    values = _useDonationCart.values,
    handleDelete = _useDonationCart.handleDelete,
    handleOneTimeGift = _useDonationCart.handleOneTimeGift,
    handleRecurringPayment = _useDonationCart.handleRecurringPayment;
  return jsxs(Fragment, {
    children: [jsx(FieldArray, {
      name: "collector.cart.donation.projects",
      render: function render(arrayHelpers) {
        var _arrayHelpers$form, _arrayHelpers$form$va, _arrayHelpers$form$va2, _arrayHelpers$form$va3, _arrayHelpers$form$va4, _arrayHelpers$form$va5, _values$formLogic, _values$formLogic$brb, _values$formLogic$brb2;
        return jsxs("div", {
          children: [arrayHelpers === null || arrayHelpers === void 0 ? void 0 : (_arrayHelpers$form = arrayHelpers.form) === null || _arrayHelpers$form === void 0 ? void 0 : (_arrayHelpers$form$va = _arrayHelpers$form.values) === null || _arrayHelpers$form$va === void 0 ? void 0 : (_arrayHelpers$form$va2 = _arrayHelpers$form$va.collector) === null || _arrayHelpers$form$va2 === void 0 ? void 0 : (_arrayHelpers$form$va3 = _arrayHelpers$form$va2.cart) === null || _arrayHelpers$form$va3 === void 0 ? void 0 : (_arrayHelpers$form$va4 = _arrayHelpers$form$va3.donation) === null || _arrayHelpers$form$va4 === void 0 ? void 0 : (_arrayHelpers$form$va5 = _arrayHelpers$form$va4.projects) === null || _arrayHelpers$form$va5 === void 0 ? void 0 : _arrayHelpers$form$va5.map(function (project, index) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              jsxs("div", {
                children: [jsxs(Columns, {
                  children: [jsx(Columns.Column, {
                    children: jsxs(Form$1.Field, {
                      children: [jsx(Form$1.Label, {
                        className: "label",
                        children: getGiftName(index)
                      }), (itemizedDonations === null || itemizedDonations === void 0 ? void 0 : itemizedDonations.length) > 0 && itemizedDonations[index] === 1 ? jsx(ItemCalculator, {
                        index: index
                      }) : jsxs("div", {
                        children: [jsx(Currency, {
                          name: "collector.cart.donation.projects[".concat(index, "].amount"),
                          inputSize: "normal",
                          disableOnBlur: true // disable onBlur because of ItemCalculator
                        }), itemName && jsx(ItemCalculator, {
                          index: index,
                          pledge: false,
                          label: "Number of ".concat(itemName, "s")
                        })]
                      })]
                    })
                  }), jsx(Columns.Column, {
                    children: jsx(Dropdown, {
                      name: "collector.cart.donation.projects[".concat(index, "].projectId"),
                      label: "Select Charity",
                      options: projectOptions,
                      validate: function validate() {
                        return undefined;
                      }
                    })
                  }), jsx(Columns.Column, {
                    children: jsx(Form$1.Field, {
                      children: jsx(Form$1.Control, {
                        children: jsx(Button, {
                          color: "danger",
                          onClick: function onClick(e) {
                            e === null || e === void 0 ? void 0 : e.preventDefault();
                            handleDelete(index);
                            arrayHelpers.remove(index);
                          },
                          children: "Delete"
                        })
                      })
                    })
                  })]
                }), jsx("hr", {
                  className: "has-background-grey"
                })]
              }, "".concat(project === null || project === void 0 ? void 0 : project.projectId, "-").concat(index))
            );
          }), jsxs(Form$1.Control, {
            children: [jsx(Button, {
              color: "info",
              mr: 2,
              onClick: function onClick(e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                handleOneTimeGift();
                arrayHelpers.push(defaultValue);
              },
              children: "Add a One-Time Gift"
            }), !(values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && (_values$formLogic$brb = _values$formLogic.brbInfo) !== null && _values$formLogic$brb !== void 0 && (_values$formLogic$brb2 = _values$formLogic$brb.campaign) !== null && _values$formLogic$brb2 !== void 0 && _values$formLogic$brb2.thirdParty) && jsx(Button, {
              color: "info",
              onClick: function onClick(e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                handleRecurringPayment();
                arrayHelpers.push(defaultRecurringValue);
              },
              children: "Add a Recurring Payment"
            })]
          }), (recurringDonations === null || recurringDonations === void 0 ? void 0 : recurringDonations.length) > 0 && (recurringDonations === null || recurringDonations === void 0 ? void 0 : recurringDonations.some(function (e) {
            return e === 1;
          })) && jsx(Block, {
            children: jsx(Dropdown, {
              name: "formLogic.recurringDate",
              label: "Select the recurring charge date",
              required: true,
              options: availableDateOptions
            })
          }), jsxs("div", {
            className: "is-size-5",
            children: ["Today's Total: ", jsxs("strong", {
              children: ["$", subTotal ? parseFloat("".concat(subTotal)).toFixed(2) : '0.00']
            })]
          }), jsx("div", {
            className: "is-size-5",
            children: recurringTotal > 0 && recurringDate && jsxs("p", {
              children: ["Your Recurring Gift:", ' ', jsxs("strong", {
                children: ["$", parseFloat("".concat(recurringTotal)).toFixed(2)]
              }), ' ', "on the ", jsx("strong", {
                children: recurringGiftDate
              }), " of every month, starting next month"]
            })
          })]
        });
      }
    }), jsxs(Block, {
      children: [jsx("hr", {}), showKeyPad && jsx(KeyPadPayment, {}), showChecking && jsx(BluefinPayment, {
        type: "EFT",
        method: "EFT",
        authPath: "eftInfo.etoken"
      })]
    })]
  });
};

var _excluded$i = ["entity", "index", "label", "name", "nbLatency", "required"];
var InputEmail = function InputEmail(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "collector.entity[".concat(entity, "].email[").concat(index, "].emailAddress") : _ref$name,
    nbLatency = _ref.nbLatency,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$i);
  var _useEmail = useEmail(_objectSpread2({
      entity: entity,
      index: index,
      name: name,
      nbLatency: nbLatency,
      required: required
    }, props)),
    emailLabel = _useEmail.emailLabel,
    errorMessage = _useEmail.errorMessage,
    hasEmailErrors = _useEmail.hasEmailErrors,
    handleOnKeyDown = _useEmail.handleOnKeyDown,
    inputClass = _useEmail.inputClass,
    isLoading = _useEmail.isLoading,
    isValidEmailAddress = _useEmail.isValidEmailAddress,
    validate = _useEmail.validate,
    validEmailLabel = _useEmail.validEmailLabel;
  var _useInputBlur = useInputBlur({
      name: name
    }),
    handleOnBlur = _useInputBlur.handleOnBlur;
  return jsxs(Form$1.Field, {
    className: "input-email-field",
    children: [jsxs(Form$1.Label, {
      htmlFor: name,
      children: [label || emailLabel, required ? jsx("span", {
        "aria-hidden": "true",
        children: "*"
      }) : '']
    }), jsxs(Form$1.Control, {
      children: [jsx(Field$2, {
        id: name,
        name: name,
        onKeyDown: handleOnKeyDown,
        type: "email",
        label: label || emailLabel,
        className: inputClass,
        onBlur: handleOnBlur,
        validate: validate,
        required: required,
        "aria-required": required
      }), isLoading ? jsx(Icon, {
        size: "small",
        align: "left",
        children: jsx(SpinnerIcon, {
          viewBox: "0 0 512 512"
        })
      }) : jsx(Icon, {
        size: "small",
        align: "left",
        children: jsx(EnvelopeIcon, {
          viewBox: "0 0 512 512"
        })
      }), isValidEmailAddress && !errorMessage && jsx("p", {
        className: "help is-success",
        children: validEmailLabel
      }), !isValidEmailAddress && errorMessage && jsx("p", {
        className: "help is-danger",
        children: errorMessage
      }), hasEmailErrors && !errorMessage && jsx("p", {
        className: "help is-danger",
        children: jsx(ErrorMessage$1, {
          name: name
        })
      })]
    })]
  });
};

var _excluded$h = ["entity", "fNameLabel", "isEmbedSite", "lNameLabel", "nameLabel", "required", "validateInputName"];
var Column$1 = /*#__PURE__*/_styled(Columns.Column, process.env.NODE_ENV === "production" ? {
  target: "egi4kwa1"
} : {
  target: "egi4kwa1",
  label: "Column"
})("padding-top:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";padding-bottom:0;margin-top:0;margin-bottom:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Field$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "egi4kwa0"
} : {
  target: "egi4kwa0",
  label: "Field"
})("margin-bottom:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var NameJp = function NameJp(_ref) {
  var entity = _ref.entity,
    fNameLabel = _ref.fNameLabel,
    isEmbedSite = _ref.isEmbedSite,
    lNameLabel = _ref.lNameLabel;
    _ref.nameLabel;
    var required = _ref.required,
    validateInputName = _ref.validateInputName,
    props = _objectWithoutProperties(_ref, _excluded$h);
  return jsx(Field$1, {
    isEmbedSite: isEmbedSite,
    children: jsx(Form$1.Control, {
      className: "form-name-component",
      children: jsxs(Columns, {
        children: [jsx(Column$1, {
          isEmbedSite: isEmbedSite,
          size: "half",
          children: jsx(InputText, {
            id: "text",
            name: (props === null || props === void 0 ? void 0 : props.lastNameFieldName) || "collector.entity[".concat(entity, "].lastName"),
            label: lNameLabel,
            required: required,
            validate: validateInputName
          })
        }), jsx(Column$1, {
          isEmbedSite: isEmbedSite,
          size: "half",
          children: jsx(InputText, {
            id: "text",
            name: (props === null || props === void 0 ? void 0 : props.firstNameFieldName) || "collector.entity[".concat(entity, "].firstName"),
            label: (props === null || props === void 0 ? void 0 : props.firstNameLabel) || fNameLabel,
            required: required,
            validate: validateInputName
          })
        })]
      })
    })
  });
};

var _excluded$g = ["entity", "isEmbedSite", "label", "nameTitles", "required", "showNameLabel", "visibleList"];
var Column = /*#__PURE__*/_styled(Columns.Column, process.env.NODE_ENV === "production" ? {
  target: "e1sjhs2m1"
} : {
  target: "e1sjhs2m1",
  label: "Column"
})("padding-top:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";padding-bottom:0;margin-top:0;margin-bottom:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Field = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1sjhs2m0"
} : {
  target: "e1sjhs2m0",
  label: "Field"
})("margin-bottom:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5hbWUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNDcUMiLCJmaWxlIjoiTmFtZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZGlzYWJsZSBuby1uZXN0ZWQtdGVybmFyeSAqL1xuaW1wb3J0IHR5cGUgeyBOYW1lUHJvcHMgfSBmcm9tICcuLi8uLi9ob29rcy91c2VOYW1lJztcblxuaW1wb3J0IHsgQ29sdW1ucywgRm9ybSB9IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgSW5wdXRUZXh0IH0gZnJvbSAnLi4vSW5wdXRUZXh0JztcbmltcG9ydCB7IHVzZU5hbWUgfSBmcm9tICcuLi8uLi9ob29rcyc7XG5pbXBvcnQgeyBEcm9wZG93biB9IGZyb20gJy4uL0Ryb3Bkb3duJztcblxuaW1wb3J0IHsgTmFtZUpwIH0gZnJvbSAnLi9OYW1lSnAnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByb3BzIGV4dGVuZHMgTmFtZVByb3BzIHtcbiAgZW50aXR5PzogbnVtYmVyO1xuICBmaXJzdE5hbWVGaWVsZE5hbWU/OiBzdHJpbmc7XG4gIGZpcnN0TmFtZUxhYmVsPzogc3RyaW5nO1xuICBpc0VtYmVkU2l0ZT86IGJvb2xlYW47XG4gIGxhc3ROYW1lTGFiZWw/OiBzdHJpbmc7XG4gIGxhc3ROYW1lRmllbGROYW1lPzogc3RyaW5nO1xuICBtaWRkbGVOYW1lRmllbGROYW1lPzogc3RyaW5nO1xuICBuYW1lTGFiZWw/OiBzdHJpbmc7XG4gIHByZWZpeEZpZWxkTmFtZT86IHN0cmluZztcbiAgcHJlZml4TGFiZWw/OiBzdHJpbmc7XG4gIHJlcXVpcmVkPzogYm9vbGVhbjtcbiAgc2hvd05hbWVMYWJlbD86IGJvb2xlYW47XG59XG5cbmludGVyZmFjZSBDb2x1bW5Qcm9wcyB7XG4gIGlzRW1iZWRTaXRlPzogYm9vbGVhbjtcbn1cblxuY29uc3QgQ29sdW1uID0gc3R5bGVkKENvbHVtbnMuQ29sdW1uKTxDb2x1bW5Qcm9wcz5gXG4gIHBhZGRpbmctdG9wOiAkeyhwcm9wcykgPT4gKHByb3BzLmlzRW1iZWRTaXRlID8gJzAnIDogJzAuNzVyZW0nKX07XG4gIHBhZGRpbmctYm90dG9tOiAwO1xuICBtYXJnaW4tdG9wOiAwO1xuICBtYXJnaW4tYm90dG9tOiAwO1xuYDtcblxuY29uc3QgRmllbGQgPSBzdHlsZWQuZGl2PENvbHVtblByb3BzPmBcbiAgbWFyZ2luLWJvdHRvbTogJHsocHJvcHMpID0+IChwcm9wcy5pc0VtYmVkU2l0ZSA/ICcwJyA6ICcwLjc1cmVtJyl9O1xuYDtcblxuZXhwb3J0IGNvbnN0IE5hbWUgPSAoe1xuICBlbnRpdHkgPSAwLFxuICBpc0VtYmVkU2l0ZSA9IGZhbHNlLFxuICBsYWJlbCxcbiAgbmFtZVRpdGxlcyxcbiAgcmVxdWlyZWQgPSB0cnVlLFxuICBzaG93TmFtZUxhYmVsID0gZmFsc2UsXG4gIHZpc2libGVMaXN0ID0gWydmaXJzdE5hbWUnLCAnbGFzdE5hbWUnXSxcbiAgLi4ucHJvcHNcbn06IFByb3BzKSA9PiB7XG4gIGNvbnN0IHtcbiAgICBpc0NvdW50cnlKYXBhbixcbiAgICBpc01pZGRsZU5hbWVSZXF1aXJlZCxcbiAgICBpc1ByZWZpeFJlcXVpcmVkLFxuICAgIGZOYW1lTGFiZWwsXG4gICAgbE5hbWVMYWJlbCxcbiAgICBtaWRkbGVOYW1lTGFiZWwsXG4gICAgbmFtZUxhYmVsLFxuICAgIHByZWZlck5hbWVMYWJlbCxcbiAgICBwcmVmaXhMYWJlbCxcbiAgICB0aXRsZU9wdGlvbnMsXG4gICAgdmFsaWRhdGVJbnB1dEZpZWxkcyxcbiAgICB2YWxpZGF0ZUlucHV0TmFtZSxcbiAgfSA9IHVzZU5hbWUoe1xuICAgIGxhYmVsLFxuICAgIG5hbWVUaXRsZXMsXG4gICAgcmVxdWlyZWQsXG4gIH0pO1xuXG4gIGNvbnN0IHNpemVDb2wgPVxuICAgIHZpc2libGVMaXN0Lmxlbmd0aCA9PT0gMVxuICAgICAgPyAxMlxuICAgICAgOiB2aXNpYmxlTGlzdC5sZW5ndGggPT09IDNcbiAgICAgID8gJ3R3by1maWZ0aHMnXG4gICAgICA6ICdoYWxmJztcblxuICBpZiAoaXNDb3VudHJ5SmFwYW4pIHtcbiAgICByZXR1cm4gKFxuICAgICAgPE5hbWVKcFxuICAgICAgICBlbnRpdHk9e2VudGl0eX1cbiAgICAgICAgaXNFbWJlZFNpdGU9e2lzRW1iZWRTaXRlfVxuICAgICAgICBmTmFtZUxhYmVsPXtmTmFtZUxhYmVsfVxuICAgICAgICBsTmFtZUxhYmVsPXtsTmFtZUxhYmVsfVxuICAgICAgICBuYW1lTGFiZWw9e25hbWVMYWJlbH1cbiAgICAgICAgcmVxdWlyZWQ9e3JlcXVpcmVkfVxuICAgICAgICB2YWxpZGF0ZUlucHV0TmFtZT17dmFsaWRhdGVJbnB1dE5hbWV9XG4gICAgICAvPlxuICAgICk7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxGaWVsZCBpc0VtYmVkU2l0ZT17aXNFbWJlZFNpdGV9PlxuICAgICAge3Nob3dOYW1lTGFiZWwgJiYgKFxuICAgICAgICA8Rm9ybS5MYWJlbD57cHJvcHM/Lm5hbWVMYWJlbCB8fCBuYW1lTGFiZWx9PC9Gb3JtLkxhYmVsPlxuICAgICAgKX1cbiAgICAgIDxGb3JtLkNvbnRyb2wgY2xhc3NOYW1lPVwiZm9ybS1uYW1lLWNvbXBvbmVudFwiPlxuICAgICAgICA8Q29sdW1ucz5cbiAgICAgICAgICB7dmlzaWJsZUxpc3QuaW5jbHVkZXMoJ3ByZWZpeCcpICYmIChcbiAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbiBzaXplPVwib25lLWZpZnRoXCI+XG4gICAgICAgICAgICAgIDxEcm9wZG93blxuICAgICAgICAgICAgICAgIGxhYmVsPXtwcm9wcz8ucHJlZml4TGFiZWwgfHwgcHJlZml4TGFiZWx9XG4gICAgICAgICAgICAgICAgbmFtZT17XG4gICAgICAgICAgICAgICAgICBwcm9wcz8ucHJlZml4RmllbGROYW1lIHx8IGBjb2xsZWN0b3IuZW50aXR5WyR7ZW50aXR5fV0ucHJlZml4YFxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBvcHRpb25zPXt0aXRsZU9wdGlvbnN9XG4gICAgICAgICAgICAgICAgcmVxdWlyZWQ9e2lzUHJlZml4UmVxdWlyZWR9XG4gICAgICAgICAgICAgICAgdmFsaWRhdGU9e2lzUHJlZml4UmVxdWlyZWQgJiYgdmFsaWRhdGVJbnB1dEZpZWxkc31cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgKX1cbiAgICAgICAgICB7dmlzaWJsZUxpc3QuaW5jbHVkZXMoJ2ZpcnN0TmFtZScpICYmIChcbiAgICAgICAgICAgIDxDb2x1bW4gaXNFbWJlZFNpdGU9e2lzRW1iZWRTaXRlfSBzaXplPXtzaXplQ29sfT5cbiAgICAgICAgICAgICAgPElucHV0VGV4dFxuICAgICAgICAgICAgICAgIGlkPVwidGV4dFwiXG4gICAgICAgICAgICAgICAgbmFtZT17XG4gICAgICAgICAgICAgICAgICBwcm9wcz8uZmlyc3ROYW1lRmllbGROYW1lIHx8XG4gICAgICAgICAgICAgICAgICBgY29sbGVjdG9yLmVudGl0eVske2VudGl0eX1dLmZpcnN0TmFtZWBcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgbGFiZWw9e3Byb3BzPy5maXJzdE5hbWVMYWJlbCB8fCBmTmFtZUxhYmVsfVxuICAgICAgICAgICAgICAgIHJlcXVpcmVkPXtyZXF1aXJlZH1cbiAgICAgICAgICAgICAgICB2YWxpZGF0ZT17dmFsaWRhdGVJbnB1dE5hbWV9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L0NvbHVtbj5cbiAgICAgICAgICApfVxuICAgICAgICAgIHt2aXNpYmxlTGlzdC5pbmNsdWRlcygnbWlkZGxlTmFtZScpICYmIChcbiAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbiBzaXplPXtzaXplQ29sfT5cbiAgICAgICAgICAgICAgPElucHV0VGV4dFxuICAgICAgICAgICAgICAgIGlkPVwidGV4dFwiXG4gICAgICAgICAgICAgICAgbmFtZT17XG4gICAgICAgICAgICAgICAgICBwcm9wcz8ubWlkZGxlTmFtZUZpZWxkTmFtZSB8fFxuICAgICAgICAgICAgICAgICAgYGNvbGxlY3Rvci5lbnRpdHlbJHtlbnRpdHl9XS5taWRkbGVOYW1lYFxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBsYWJlbD17bWlkZGxlTmFtZUxhYmVsfVxuICAgICAgICAgICAgICAgIHJlcXVpcmVkPXtpc01pZGRsZU5hbWVSZXF1aXJlZH1cbiAgICAgICAgICAgICAgICB2YWxpZGF0ZT17aXNNaWRkbGVOYW1lUmVxdWlyZWQgJiYgdmFsaWRhdGVJbnB1dEZpZWxkc31cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgKX1cbiAgICAgICAgICB7dmlzaWJsZUxpc3QuaW5jbHVkZXMoJ2xhc3ROYW1lJykgJiYgKFxuICAgICAgICAgICAgPENvbHVtbiBpc0VtYmVkU2l0ZT17aXNFbWJlZFNpdGV9IHNpemU9e3NpemVDb2x9PlxuICAgICAgICAgICAgICA8SW5wdXRUZXh0XG4gICAgICAgICAgICAgICAgaWQ9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgICBuYW1lPXtcbiAgICAgICAgICAgICAgICAgIHByb3BzPy5sYXN0TmFtZUZpZWxkTmFtZSB8fFxuICAgICAgICAgICAgICAgICAgYGNvbGxlY3Rvci5lbnRpdHlbJHtlbnRpdHl9XS5sYXN0TmFtZWBcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgbGFiZWw9e3Byb3BzPy5sYXN0TmFtZUxhYmVsIHx8IGxOYW1lTGFiZWx9XG4gICAgICAgICAgICAgICAgcmVxdWlyZWQ9e3JlcXVpcmVkfVxuICAgICAgICAgICAgICAgIHZhbGlkYXRlPXt2YWxpZGF0ZUlucHV0TmFtZX1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQ29sdW1uPlxuICAgICAgICAgICl9XG4gICAgICAgICAge3Zpc2libGVMaXN0LmluY2x1ZGVzKCdwcmVmZXJyZWROYW1lJykgJiYgKFxuICAgICAgICAgICAgPENvbHVtbnMuQ29sdW1uIHNpemU9e3NpemVDb2x9PlxuICAgICAgICAgICAgICA8SW5wdXRUZXh0XG4gICAgICAgICAgICAgICAgaWQ9XCJ0ZXh0XCJcbiAgICAgICAgICAgICAgICBuYW1lPXtgY29sbGVjdG9yLmVudGl0eVske2VudGl0eX1dLnByZWZlcnJlZE5hbWVgfVxuICAgICAgICAgICAgICAgIGxhYmVsPXtwcmVmZXJOYW1lTGFiZWx9XG4gICAgICAgICAgICAgICAgdmFsaWRhdGU9e3ZhbGlkYXRlSW5wdXROYW1lfVxuICAgICAgICAgICAgICAgIHJlcXVpcmVkPXtyZXF1aXJlZH1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgKX1cbiAgICAgICAgPC9Db2x1bW5zPlxuICAgICAgPC9Gb3JtLkNvbnRyb2w+XG4gICAgPC9GaWVsZD5cbiAgKTtcbn07XG4iXX0= */"));
var Name = function Name(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$isEmbedSite = _ref.isEmbedSite,
    isEmbedSite = _ref$isEmbedSite === void 0 ? false : _ref$isEmbedSite,
    label = _ref.label,
    nameTitles = _ref.nameTitles,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    _ref$showNameLabel = _ref.showNameLabel,
    showNameLabel = _ref$showNameLabel === void 0 ? false : _ref$showNameLabel,
    _ref$visibleList = _ref.visibleList,
    visibleList = _ref$visibleList === void 0 ? ['firstName', 'lastName'] : _ref$visibleList,
    props = _objectWithoutProperties(_ref, _excluded$g);
  var _useName = useName({
      label: label,
      nameTitles: nameTitles,
      required: required
    }),
    isCountryJapan = _useName.isCountryJapan,
    isMiddleNameRequired = _useName.isMiddleNameRequired,
    isPrefixRequired = _useName.isPrefixRequired,
    fNameLabel = _useName.fNameLabel,
    lNameLabel = _useName.lNameLabel,
    middleNameLabel = _useName.middleNameLabel,
    nameLabel = _useName.nameLabel,
    preferNameLabel = _useName.preferNameLabel,
    prefixLabel = _useName.prefixLabel,
    titleOptions = _useName.titleOptions,
    validateInputFields = _useName.validateInputFields,
    validateInputName = _useName.validateInputName;
  var sizeCol = visibleList.length === 1 ? 12 : visibleList.length === 3 ? 'two-fifths' : 'half';
  if (isCountryJapan) {
    return jsx(NameJp, {
      entity: entity,
      isEmbedSite: isEmbedSite,
      fNameLabel: fNameLabel,
      lNameLabel: lNameLabel,
      nameLabel: nameLabel,
      required: required,
      validateInputName: validateInputName
    });
  }
  return jsxs(Field, {
    isEmbedSite: isEmbedSite,
    children: [showNameLabel && jsx(Form$1.Label, {
      children: (props === null || props === void 0 ? void 0 : props.nameLabel) || nameLabel
    }), jsx(Form$1.Control, {
      className: "form-name-component",
      children: jsxs(Columns, {
        children: [visibleList.includes('prefix') && jsx(Columns.Column, {
          size: "one-fifth",
          children: jsx(Dropdown, {
            label: (props === null || props === void 0 ? void 0 : props.prefixLabel) || prefixLabel,
            name: (props === null || props === void 0 ? void 0 : props.prefixFieldName) || "collector.entity[".concat(entity, "].prefix"),
            options: titleOptions,
            required: isPrefixRequired,
            validate: isPrefixRequired && validateInputFields
          })
        }), visibleList.includes('firstName') && jsx(Column, {
          isEmbedSite: isEmbedSite,
          size: sizeCol,
          children: jsx(InputText, {
            id: "text",
            name: (props === null || props === void 0 ? void 0 : props.firstNameFieldName) || "collector.entity[".concat(entity, "].firstName"),
            label: (props === null || props === void 0 ? void 0 : props.firstNameLabel) || fNameLabel,
            required: required,
            validate: validateInputName
          })
        }), visibleList.includes('middleName') && jsx(Columns.Column, {
          size: sizeCol,
          children: jsx(InputText, {
            id: "text",
            name: (props === null || props === void 0 ? void 0 : props.middleNameFieldName) || "collector.entity[".concat(entity, "].middleName"),
            label: middleNameLabel,
            required: isMiddleNameRequired,
            validate: isMiddleNameRequired && validateInputFields
          })
        }), visibleList.includes('lastName') && jsx(Column, {
          isEmbedSite: isEmbedSite,
          size: sizeCol,
          children: jsx(InputText, {
            id: "text",
            name: (props === null || props === void 0 ? void 0 : props.lastNameFieldName) || "collector.entity[".concat(entity, "].lastName"),
            label: (props === null || props === void 0 ? void 0 : props.lastNameLabel) || lNameLabel,
            required: required,
            validate: validateInputName
          })
        }), visibleList.includes('preferredName') && jsx(Columns.Column, {
          size: sizeCol,
          children: jsx(InputText, {
            id: "text",
            name: "collector.entity[".concat(entity, "].preferredName"),
            label: preferNameLabel,
            validate: validateInputName,
            required: required
          })
        })]
      })
    })]
  });
};

var _excluded$f = ["entity", "entityType", "isPrimary", "phoneRequired", "visibleList", "required", "showAddressLabel"];
var InputContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e5cp1o50"
} : {
  target: "e5cp1o50",
  label: "InputContainer"
})("padding-bottom:", function (props) {
  return props.isEmbedSite ? '0' : '0.75rem';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var EntityFields = function EntityFields(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity,
    _ref$entityType = _ref.entityType,
    entityType = _ref$entityType === void 0 ? 'I' : _ref$entityType,
    _ref$isPrimary = _ref.isPrimary,
    isPrimary = _ref$isPrimary === void 0 ? true : _ref$isPrimary,
    _ref$phoneRequired = _ref.phoneRequired,
    phoneRequired = _ref$phoneRequired === void 0 ? true : _ref$phoneRequired,
    _ref$visibleList = _ref.visibleList,
    visibleList = _ref$visibleList === void 0 ? ['Name', 'Email', 'Phone', 'Age', 'Address'] : _ref$visibleList,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$showAddressLabel = _ref.showAddressLabel,
    showAddressLabel = _ref$showAddressLabel === void 0 ? true : _ref$showAddressLabel,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var _useEntity = useEntity(_objectSpread2({
      entity: entity,
      entityType: entityType,
      isPrimary: isPrimary,
      phoneRequired: phoneRequired
    }, props)),
    mobilePhoneLabel = _useEntity.mobilePhoneLabel,
    phoneLabel = _useEntity.phoneLabel,
    organizationNameLabel = _useEntity.organizationNameLabel,
    roleLabel = _useEntity.roleLabel;
  var _useOrgRoles = useOrgRoles({
      orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles
    }),
    optionsList = _useOrgRoles.optionsList;
  return jsx("div", {
    children: visibleList === null || visibleList === void 0 ? void 0 : visibleList.map(function (component) {
      var _props$socialPhones, _props$socialMediaInp;
      return jsxs("div", {
        children: [component === 'Name' && jsx(Name, _objectSpread2(_objectSpread2({}, props), {}, {
          entity: entity,
          firstNameFieldName: props === null || props === void 0 ? void 0 : props.firstNameFieldName,
          lastNameFieldName: props === null || props === void 0 ? void 0 : props.lastNameFieldName,
          required: required,
          label: props === null || props === void 0 ? void 0 : props.nameLabel,
          nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
          visibleList: props === null || props === void 0 ? void 0 : props.visibleName
        })), component === 'Email' && jsx(InputContainer, {
          className: "entity-input-container",
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          children: jsx(InputEmail, {
            entity: entity,
            name: props === null || props === void 0 ? void 0 : props.emailFieldName,
            required: props === null || props === void 0 ? void 0 : props.emailRequired,
            nbLatency: props === null || props === void 0 ? void 0 : props.nbLatency
          })
        }), component === 'Phone' && jsx(InputContainer, {
          className: "entity-input-container",
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          children: jsx(InputPhone, {
            entity: entity,
            required: phoneRequired,
            label: (props === null || props === void 0 ? void 0 : props.phoneLabel) || phoneLabel,
            minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
            name: props === null || props === void 0 ? void 0 : props.phoneFieldName,
            phoneType: props === null || props === void 0 ? void 0 : props.phoneType,
            phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer
          })
        }), component === 'SocialPhones' && (props === null || props === void 0 ? void 0 : (_props$socialPhones = props.socialPhones) === null || _props$socialPhones === void 0 ? void 0 : _props$socialPhones.map(function (phone, idx) {
          return jsx(InputContainer, {
            className: "entity-input-container",
            isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
            children: jsx(InputPhone, {
              entity: entity,
              index: visibleList.includes('Phone') ? idx + 1 : idx,
              required: phone === null || phone === void 0 ? void 0 : phone.isRequired,
              label: phone.label,
              minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
              name: visibleList.includes('Phone') ? "collector.entity[".concat(entity, "].phone[").concat(idx + 1, "].phoneNumber") : "collector.entity[".concat(entity, "].phone[").concat(idx, "].phoneNumber"),
              phoneType: phone.type,
              disableValidation: phone === null || phone === void 0 ? void 0 : phone.disableValidation
            })
          }, phone.type);
        })), component === 'SocialMediaInputs' && (props === null || props === void 0 ? void 0 : (_props$socialMediaInp = props.socialMediaInputs) === null || _props$socialMediaInp === void 0 ? void 0 : _props$socialMediaInp.map(function (social, idx) {
          return jsx(InputText, {
            label: social.label,
            name: "collector.entity[".concat(entity, "].social[").concat(idx, "].handle")
          }, social.socialMediaType);
        })), component === 'MobilePhone' && jsx(InputContainer, {
          className: "entity-input-container",
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          children: jsx(InputPhone, {
            entity: entity,
            index: 1,
            required: props === null || props === void 0 ? void 0 : props.mobilePhoneRequired,
            label: (props === null || props === void 0 ? void 0 : props.mobilePhoneLabel) || mobilePhoneLabel,
            minPhoneLength: props === null || props === void 0 ? void 0 : props.minPhoneLength,
            name: props === null || props === void 0 ? void 0 : props.phoneFieldName,
            phoneType: (props === null || props === void 0 ? void 0 : props.mobilePhoneType) || 'CELL',
            phoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer
          })
        }), component === 'OptInTextCheckbox' && (props === null || props === void 0 ? void 0 : props.optInAttrValue) && jsx(Checkbox, {
          id: "formLogic.textOptIn",
          name: "formLogic.textOptIn",
          labelHtml: props === null || props === void 0 ? void 0 : props.optinLabel,
          valueObj: {
            value: props === null || props === void 0 ? void 0 : props.optInAttrValue
          }
        }), component === 'DisclaimerOptInText' && (props === null || props === void 0 ? void 0 : props.disclaimerOptInText) && jsx(Content, {
          className: "disclaimer-optin-text",
          textWeight: "bold",
          children: props === null || props === void 0 ? void 0 : props.disclaimerOptInText
        }), component === 'Address' && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: props === null || props === void 0 ? void 0 : props.autoComplete,
          country: props === null || props === void 0 ? void 0 : props.country,
          customRegionList: props === null || props === void 0 ? void 0 : props.customRegionList,
          entity: entity,
          index: 0,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          label: props === null || props === void 0 ? void 0 : props.addressLabel,
          required: required,
          showLabel: showAddressLabel,
          type: "MAIL",
          useRegionComponent: props === null || props === void 0 ? void 0 : props.useRegionComponent,
          visibleList: props === null || props === void 0 ? void 0 : props.addressVisibleList
        })), component === 'Age' && jsx(Age, {
          entity: entity
        }), component === 'OrganizationName' && jsx(InputText, {
          label: organizationNameLabel,
          name: "collector.entity[".concat(entity, "].organizationName"),
          required: required
        }), component === 'OrganizationRole' && jsx(Dropdown, {
          label: roleLabel,
          name: "collector.entity[".concat(entity, "].orgs.role"),
          options: optionsList,
          required: required
        })]
      }, component);
    })
  });
};

var _excluded$e = ["errorMessage", "id", "label", "max", "min", "name", "pattern", "required", "showErrorMessage", "validate"];
var InputNumber = function InputNumber(_ref) {
  var errorMessage = _ref.errorMessage,
    id = _ref.id,
    label = _ref.label,
    max = _ref.max,
    min = _ref.min,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'number' : _ref$name,
    pattern = _ref.pattern,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    showErrorMessage = _ref.showErrorMessage,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (value) {
      return validateNumber(value, required, min, max, errorMessage);
    } : _ref$validate,
    props = _objectWithoutProperties(_ref, _excluded$e);
  if (props !== null && props !== void 0 && props.useControlledInput) {
    return jsxs(Form$1.Field, {
      className: "form-input-number",
      children: [label && jsxs(Form$1.Label, {
        htmlFor: name,
        children: [label, required ? jsx("span", {
          "aria-hidden": "true",
          children: "*"
        }) : '']
      }), jsx("input", {
        ref: props === null || props === void 0 ? void 0 : props.innerRef,
        name: name,
        className: "input ".concat(showErrorMessage ? 'is-danger' : ''),
        onBlur: props === null || props === void 0 ? void 0 : props.onBlur,
        id: name,
        type: "number"
      }), showErrorMessage && jsx("p", {
        className: "help is-danger",
        role: "alert",
        children: errorMessage
      })]
    });
  }
  return jsxs(Form$1.Field, {
    children: [jsx(Form$1.Label, {
      children: label
    }), jsx(Field$2, _objectSpread2({
      type: "number",
      className: fieldClassList('input', name),
      id: id,
      name: name,
      pattern: pattern || null,
      validate: validate
    }, props)), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

var _excluded$d = ["id", "label", "name", "required"];
var InputTime = function InputTime(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'input' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded$d);
  var _useInputValidation = useInputValidation({
      required: required
    }),
    validate = _useInputValidation.validate;
  return jsxs(Form$1.Field, {
    children: [label && jsx(Form$1.Label, {
      children: label
    }), jsx(Field$2, _objectSpread2({
      type: "time",
      className: fieldClassList('input', name),
      id: id,
      name: name,
      validate: (props === null || props === void 0 ? void 0 : props.validate) || validate
    }, props)), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var UploadThumbnailsSummary = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efpmpqg3"
} : {
  target: "efpmpqg3",
  label: "UploadThumbnailsSummary"
})(process.env.NODE_ENV === "production" ? {
  name: "zyr7to",
  styles: "display:flex;flex-direction:column;width:170px;height:105px;margin-right:20px;margin-bottom:40px;position:relative;word-wrap:break-word"
} : {
  name: "zyr7to",
  styles: "display:flex;flex-direction:column;width:170px;height:105px;margin-right:20px;margin-bottom:40px;position:relative;word-wrap:break-word",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var AmzImage = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "efpmpqg2"
} : {
  target: "efpmpqg2",
  label: "AmzImage"
})(process.env.NODE_ENV === "production" ? {
  name: "84on97",
  styles: "width:170px;height:105px;object-fit:scale-down"
} : {
  name: "84on97",
  styles: "width:170px;height:105px;object-fit:scale-down",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var StyledButtonIcon = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "efpmpqg1"
} : {
  target: "efpmpqg1",
  label: "StyledButtonIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "15e3mw0",
  styles: "border:0;position:absolute;right:0"
} : {
  name: "15e3mw0",
  styles: "border:0;position:absolute;right:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var FileName = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "efpmpqg0"
} : {
  target: "efpmpqg0",
  label: "FileName"
})(process.env.NODE_ENV === "production" ? {
  name: "35sw9d",
  styles: "font-size:0.625em"
} : {
  name: "35sw9d",
  styles: "font-size:0.625em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVVcGxvYWRUaHVtYm5haWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJCNEIiLCJmaWxlIjoiRmlsZVVwbG9hZFRodW1ibmFpbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCdXR0b24sIFRhZyB9IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcbmltcG9ydCB7IENsb3NlSWNvbiB9IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LWljb25zJztcblxuY29uc3QgVXBsb2FkVGh1bWJuYWlsc1N1bW1hcnkgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICB3aWR0aDogMTcwcHg7XG4gIGhlaWdodDogMTA1cHg7XG4gIG1hcmdpbi1yaWdodDogMjBweDtcbiAgbWFyZ2luLWJvdHRvbTogNDBweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB3b3JkLXdyYXA6IGJyZWFrLXdvcmQ7XG5gO1xuXG5jb25zdCBBbXpJbWFnZSA9IHN0eWxlZC5pbWdgXG4gIHdpZHRoOiAxNzBweDtcbiAgaGVpZ2h0OiAxMDVweDtcbiAgb2JqZWN0LWZpdDogc2NhbGUtZG93bjtcbmA7XG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkljb24gPSBzdHlsZWQoQnV0dG9uKWBcbiAgYm9yZGVyOiAwO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHJpZ2h0OiAwO1xuYDtcblxuY29uc3QgRmlsZU5hbWUgPSBzdHlsZWQuc3BhbmBcbiAgZm9udC1zaXplOiAwLjYyNWVtO1xuYDtcblxuaW50ZXJmYWNlIEZpbGVVcGxvYWRUaHVtYm5haWxQcm9wcyB7XG4gIGZpbGVOYW1lPzogc3RyaW5nO1xuICBmaWxlVXJsPzogc3RyaW5nO1xuICBzaG93SW1hZ2U/OiBib29sZWFuO1xuICBoYW5kbGVSZW1vdmVGaWxlPzogKGZpbGUpID0+IHZvaWQ7XG59XG5cbmV4cG9ydCBjb25zdCBGaWxlVXBsb2FkVGh1bWJuYWlsID0gKHtcbiAgZmlsZU5hbWUsXG4gIGZpbGVVcmwsXG4gIHNob3dJbWFnZSxcbiAgaGFuZGxlUmVtb3ZlRmlsZSxcbn06IEZpbGVVcGxvYWRUaHVtYm5haWxQcm9wcykgPT4ge1xuICByZXR1cm4gKFxuICAgIDxVcGxvYWRUaHVtYm5haWxzU3VtbWFyeSBrZXk9e2ZpbGVOYW1lfT5cbiAgICAgIDxTdHlsZWRCdXR0b25JY29uIG9uQ2xpY2s9e2hhbmRsZVJlbW92ZUZpbGUoZmlsZU5hbWUpfSBzaXplPVwic21hbGxcIj5cbiAgICAgICAgPENsb3NlSWNvbiB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgLz5cbiAgICAgIDwvU3R5bGVkQnV0dG9uSWNvbj5cbiAgICAgIHtzaG93SW1hZ2UgPyAoXG4gICAgICAgIDw+XG4gICAgICAgICAgPEFtekltYWdlIHNyYz17ZmlsZVVybH0gYWx0PVwiaXRlbVwiIC8+XG4gICAgICAgICAgPFRhZyBjb2xvcj1cImluZm9cIj57ZmlsZU5hbWV9PC9UYWc+XG4gICAgICAgIDwvPlxuICAgICAgKSA6IChcbiAgICAgICAgPEZpbGVOYW1lPntmaWxlTmFtZX08L0ZpbGVOYW1lPlxuICAgICAgKX1cbiAgICA8L1VwbG9hZFRodW1ibmFpbHNTdW1tYXJ5PlxuICApO1xufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var FileUploadThumbnail = function FileUploadThumbnail(_ref) {
  var fileName = _ref.fileName,
    fileUrl = _ref.fileUrl,
    showImage = _ref.showImage,
    handleRemoveFile = _ref.handleRemoveFile;
  return jsxs(UploadThumbnailsSummary, {
    children: [jsx(StyledButtonIcon, {
      onClick: handleRemoveFile(fileName),
      size: "small",
      children: jsx(CloseIcon, {
        viewBox: "0 0 24 24"
      })
    }), showImage ? jsxs(Fragment, {
      children: [jsx(AmzImage, {
        src: fileUrl,
        alt: "item"
      }), jsx(Tag, {
        color: "info",
        children: fileName
      })]
    }) : jsx(FileName, {
      children: fileName
    })]
  }, fileName);
};

var FileUpload = function FileUpload(_ref) {
  var _ref$acceptFileTypes = _ref.acceptFileTypes,
    acceptFileTypes = _ref$acceptFileTypes === void 0 ? "audio/*, image/*, application/pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document " : _ref$acceptFileTypes,
    id = _ref.id,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "formLogic.fileUploadMap[".concat(id, "]") : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  var _useFileUpload = useFileUpload({
      acceptFileTypes: acceptFileTypes,
      label: label,
      name: name
    }),
    error = _useFileUpload.error,
    files = _useFileUpload.files,
    isDelete = _useFileUpload.isDelete,
    isFileUploading = _useFileUpload.isFileUploading,
    isValidFileImage = _useFileUpload.isValidFileImage,
    handleChange = _useFileUpload.handleChange,
    handleRemoveFile = _useFileUpload.handleRemoveFile;
  return jsxs(Form$1.Field, {
    children: [jsxs(Form$1.Label, {
      children: [label, " (Max: 250MB)"]
    }), jsx(Form$1.Control, {
      children: isFileUploading ? jsx(Loader, {}) : jsx(Field$2, {
        name: name,
        type: "text",
        required: required,
        children: function children(_ref2) {
          var field = _ref2.field;
          return jsx("input", {
            name: field.name,
            type: "file",
            onChange: handleChange,
            multiple: true
          });
        }
      })
    }), error && !isDelete && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: error || ' An error occurred. Please try again.'
    }), files.map(function (file) {
      return jsx(FileUploadThumbnail, {
        fileName: file.fileName,
        fileUrl: file.url,
        showImage: isValidFileImage(file.url),
        handleRemoveFile: handleRemoveFile
      }, file.url);
    }), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

var _excluded$c = ["status"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SpinnerContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8aktao1"
} : {
  target: "e8aktao1",
  label: "SpinnerContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1gipcv8",
  styles: "left:50%;margin-left:-20px;top:50%;margin-top:-20px;position:relative;z-index:19!important"
} : {
  name: "1gipcv8",
  styles: "left:50%;margin-left:-20px;top:50%;margin-top:-20px;position:relative;z-index:19!important",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
var Spinner = /*#__PURE__*/_styled(Loader, process.env.NODE_ENV === "production" ? {
  target: "e8aktao0"
} : {
  target: "e8aktao0",
  label: "Spinner"
})("width:40px;height:40px;border:4px solid ", colors.prussianBlue, ";border-top-color:transparent;border-right-color:transparent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var FormLoading = function FormLoading(_ref) {
  var status = _ref.status,
    props = _objectWithoutProperties(_ref, _excluded$c);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Fragment, {
    children: [status === 'loading' && jsxs(Container, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
      children: [jsxs(Notification, {
        children: [jsx("p", {
          className: "is-size-5 pb-6 mb-6",
          children: "Form is Loading..."
        }), jsx(SpinnerContainer$1, {
          children: jsx(Spinner, {})
        })]
      }), jsx("div", {
        className: "formLoading notification is-secondary has-text-centered py-6"
      })]
    })), status === 'ServerOffline' && jsx(Container, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
      children: jsxs(Notification, {
        color: "danger",
        children: [jsx("p", {
          className: "is-size-5 ",
          children: "This form is not available at this time."
        }), jsx("p", {
          children: "Please wait and try again later or call 877-247-2426 for assistance."
        })]
      })
    }))]
  });
};

var GoogleReCaptchaProvider = function GoogleReCaptchaProvider(_ref) {
  var children = _ref.children;
  var sitekeyV3 = getRecaptchaKeyV3();
  return jsx(GoogleReCaptchaProvider$1, {
    reCaptchaKey: sitekeyV3,
    children: children
  });
};

var _excluded$b = ["status"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SubmittingScreenContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1hlrkui1"
} : {
  target: "e1hlrkui1",
  label: "SubmittingScreenContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "2uope9",
  styles: "position:absolute;z-index:999;padding:0;margin:0;top:0;left:0;bottom:0;right:0;width:100%;height:100%;align-items:center;justify-content:center;pointer-events:none"
} : {
  name: "2uope9",
  styles: "position:absolute;z-index:999;padding:0;margin:0;top:0;left:0;bottom:0;right:0;width:100%;height:100%;align-items:center;justify-content:center;pointer-events:none",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var SpinnerContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1hlrkui0"
} : {
  target: "e1hlrkui0",
  label: "SpinnerContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "qwmb0v",
  styles: "left:3%;margin-left:-20px;bottom:2%;margin-top:-20px;position:absolute;z-index:19!important;padding:2rem"
} : {
  name: "qwmb0v",
  styles: "left:3%;margin-left:-20px;bottom:2%;margin-top:-20px;position:absolute;z-index:19!important;padding:2rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var FormSubmittingScreen = function FormSubmittingScreen(_ref) {
  var _values$formLogic;
  _ref.status;
    var props = _objectWithoutProperties(_ref, _excluded$b);
  var _useFormatAddress = useFormatAddress(_objectSpread2({}, props)),
    messageProcessingText = _useFormatAddress.messageProcessingText;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var donationMsg = "Your donation is currently being processed. This may take a few moments. Please don\u2019t close this window, hit the back button, or refresh your browser.";
  var message = messageProcessingText;
  var domAttributes = pickDomAttributes(props);
  return jsx(SubmittingScreenContainer, _objectSpread2(_objectSpread2({}, domAttributes), {}, {
    children: jsx(SpinnerContainer, {
      children: jsx(Message, {
        color: "info",
        size: "medium",
        children: jsx(Message.Body, {
          children: values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.isDonation ? donationMsg : message
        })
      })
    })
  }));
};

var ErrorBoundaryContext = /*#__PURE__*/createContext(null);
var initialState = {
  didCatch: false,
  error: null
};
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.resetErrorBoundary = _this.resetErrorBoundary.bind(_assertThisInitialized(_this));
    _this.state = initialState;
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "resetErrorBoundary",
    value: function resetErrorBoundary() {
      var error = this.state.error;
      if (error !== null) {
        var _this$props$onReset, _this$props;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
          args: args,
          reason: "imperative-api"
        });
        this.setState(initialState);
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;
      (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var didCatch = this.state.didCatch;
      var resetKeys = this.props.resetKeys;

      // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
      // we'd end up resetting the error boundary immediately.
      // This would likely trigger a second error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

      if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
        var _this$props$onReset2, _this$props3;
        (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
          next: resetKeys,
          prev: prevProps.resetKeys,
          reason: "keys"
        });
        this.setState(initialState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        fallbackRender = _this$props4.fallbackRender,
        FallbackComponent = _this$props4.FallbackComponent,
        fallback = _this$props4.fallback;
      var _this$state = this.state,
        didCatch = _this$state.didCatch,
        error = _this$state.error;
      var childToRender = children;
      if (didCatch) {
        var props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };
        if (typeof fallbackRender === "function") {
          childToRender = fallbackRender(props);
        } else if (FallbackComponent) {
          childToRender = /*#__PURE__*/createElement(FallbackComponent, props);
        } else if (fallback === null || /*#__PURE__*/isValidElement(fallback)) {
          childToRender = fallback;
        } else {
          throw error;
        }
      }
      return /*#__PURE__*/createElement(ErrorBoundaryContext.Provider, {
        value: {
          didCatch: didCatch,
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        }
      }, childToRender);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        didCatch: true,
        error: error
      };
    }
  }]);
  return ErrorBoundary;
}(Component);
function hasArrayChanged() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some(function (item, index) {
    return !Object.is(item, b[index]);
  });
}

var FallbackRender = function FallbackRender(_ref) {
  var error = _ref.error;
  return jsx(FormErrorScreens, {
    errorMessage: error === null || error === void 0 ? void 0 : error.message
  });
};

var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useForm = useForm(_objectSpread2({
      isSubmitting: props === null || props === void 0 ? void 0 : props.isSubmitting,
      ref: ref,
      setSubmitting: props === null || props === void 0 ? void 0 : props.setSubmitting
    }, props)),
    formSubmittingOpacity = _useForm.formSubmittingOpacity,
    logError = _useForm.logError;
  return jsx(ErrorBoundary, {
    fallbackRender: FallbackRender,
    onError: logError,
    children: jsx("div", {
      className: "form-opacity-container",
      style: {
        opacity: props !== null && props !== void 0 && props.isSubmitting ? formSubmittingOpacity : 1
      },
      children: props.children
    })
  });
});
Form.displayName = 'Form';

var _excluded$a = ["children", "isBasicTemplate"];
var FormProvider = function FormProvider(_ref) {
  var children = _ref.children,
    isBasicTemplate = _ref.isBasicTemplate,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var _useFormProvider = useFormProvider(_objectSpread2({}, props)),
    initValues = _useFormProvider.initValues,
    isRecaptchaEnable = _useFormProvider.isRecaptchaEnable,
    isSubmitting = _useFormProvider.isSubmitting,
    refFormProvider = _useFormProvider.refFormProvider,
    onSubmitForm = _useFormProvider.onSubmitForm,
    setSubmitting = _useFormProvider.setSubmitting;
  return jsx(Formik, {
    enableReinitialize: true,
    initialValues: initValues,
    onSubmit: onSubmitForm,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: true,
    children: jsxs(Fragment, {
      children: [!isRecaptchaEnable && jsx(Form$2, {
        children: jsx(Form, _objectSpread2(_objectSpread2({}, props), {}, {
          isSubmitting: isSubmitting,
          ref: refFormProvider,
          setSubmitting: setSubmitting,
          children: children
        }))
      }), !isBasicTemplate && isRecaptchaEnable && jsx(Form$2, {
        children: jsx(GoogleReCaptchaProvider, {
          children: jsx(Form, _objectSpread2(_objectSpread2({}, props), {}, {
            isSubmitting: isSubmitting,
            ref: refFormProvider,
            setSubmitting: setSubmitting,
            children: children
          }))
        })
      }), isBasicTemplate && isRecaptchaEnable && jsx(GoogleReCaptchaProvider, {
        children: jsx(Form, _objectSpread2(_objectSpread2({}, props), {}, {
          isSubmitting: isSubmitting,
          ref: refFormProvider,
          setSubmitting: setSubmitting,
          children: children
        }))
      }), isSubmitting && jsx(FormSubmittingScreen, {})]
    })
  });
};

var _excluded$9 = ["label", "max", "name", "options", "required", "validate"];
var MultiSelect = function MultiSelect(_ref) {
  var label = _ref.label,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? Infinity : _ref$max,
    name = _ref.name,
    options = _ref.options,
    required = _ref.required,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function (value) {
      return validateMultiSelect(value, required, max);
    } : _ref$validate,
    props = _objectWithoutProperties(_ref, _excluded$9);
  var _useField = useField({
      name: name,
      validate: validate
    }),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var handleChange = function handleChange(event) {
    var valueArray = Array.from(event.target.selectedOptions, function (option) {
      return option.value;
    });
    helpers.setValue(valueArray);
  };
  return jsxs(Form$1.Field, {
    children: [label && jsx(Form$1.Label, {
      children: label
    }), jsx(Form$1.Control, {
      children: jsx(Form$1.Select, _objectSpread2(_objectSpread2(_objectSpread2({}, field), props), {}, {
        multiple: true,
        onChange: handleChange,
        children: options.map(function (option) {
          return jsx("option", {
            value: option.value,
            children: option.value
          }, option.id);
        })
      }))
    }), meta.touched && meta.error && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

/**
 * Enum for the SDK script resolve status,
 *
 * @enum {string}
 */
var SCRIPT_LOADING_STATE;
(function (SCRIPT_LOADING_STATE) {
  SCRIPT_LOADING_STATE["INITIAL"] = "initial";
  SCRIPT_LOADING_STATE["PENDING"] = "pending";
  SCRIPT_LOADING_STATE["REJECTED"] = "rejected";
  SCRIPT_LOADING_STATE["RESOLVED"] = "resolved";
})(SCRIPT_LOADING_STATE || (SCRIPT_LOADING_STATE = {}));
/**
 * Enum for the PayPalScriptProvider context dispatch actions
 *
 * @enum {string}
 */
var DISPATCH_ACTION;
(function (DISPATCH_ACTION) {
  DISPATCH_ACTION["LOADING_STATUS"] = "setLoadingStatus";
  DISPATCH_ACTION["RESET_OPTIONS"] = "resetOptions";
  DISPATCH_ACTION["SET_BRAINTREE_INSTANCE"] = "braintreeInstance";
})(DISPATCH_ACTION || (DISPATCH_ACTION = {}));
/**
 * Enum for all the available hosted fields
 *
 * @enum {string}
 */
var PAYPAL_HOSTED_FIELDS_TYPES;
(function (PAYPAL_HOSTED_FIELDS_TYPES) {
  PAYPAL_HOSTED_FIELDS_TYPES["NUMBER"] = "number";
  PAYPAL_HOSTED_FIELDS_TYPES["CVV"] = "cvv";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_DATE"] = "expirationDate";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_MONTH"] = "expirationMonth";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_YEAR"] = "expirationYear";
  PAYPAL_HOSTED_FIELDS_TYPES["POSTAL_CODE"] = "postalCode";
})(PAYPAL_HOSTED_FIELDS_TYPES || (PAYPAL_HOSTED_FIELDS_TYPES = {}));
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*********************************************
 * Common reference to the script identifier *
 *********************************************/
// keep this script id value in kebab-case format
var SCRIPT_ID = "data-react-paypal-script-id";
var SDK_SETTINGS = {
  DATA_CLIENT_TOKEN: "dataClientToken",
  DATA_JS_SDK_LIBRARY: "dataJsSdkLibrary",
  DATA_LIBRARY_VALUE: "react-paypal-js",
  DATA_NAMESPACE: "dataNamespace",
  DATA_SDK_INTEGRATION_SOURCE: "dataSdkIntegrationSource",
  DATA_USER_ID_TOKEN: "dataUserIdToken"
};
var LOAD_SCRIPT_ERROR = "Failed to load the PayPal JS SDK script.";
/*********************
 * PayPal namespaces *
 *********************/
var DEFAULT_PAYPAL_NAMESPACE = "paypal";
/*******************
 * Script Provider *
 *******************/
var SCRIPT_PROVIDER_REDUCER_ERROR = "usePayPalScriptReducer must be used within a PayPalScriptProvider";

/**
 * Get the namespace from the window in the browser
 * this is useful to get the paypal object from window
 * after load PayPal SDK script
 *
 * @param namespace the name space to return
 * @returns the namespace if exists or undefined otherwise
 */
function getPayPalWindowNamespace$1(namespace) {
  if (namespace === void 0) {
    namespace = DEFAULT_PAYPAL_NAMESPACE;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return window[namespace];
}
/**
 * Creates a string hash code based on the string argument
 *
 * @param str the source input string to hash
 * @returns string hash code
 */
function hashStr(str) {
  var hash = "";
  for (var i = 0; i < str.length; i++) {
    var total = str[i].charCodeAt(0) * i;
    if (str[i + 1]) {
      total += str[i + 1].charCodeAt(0) * (i - 1);
    }
    hash += String.fromCharCode(97 + Math.abs(total) % 26);
  }
  return hash;
}
function generateErrorMessage(_a) {
  var reactComponentName = _a.reactComponentName,
    sdkComponentKey = _a.sdkComponentKey,
    _b = _a.sdkRequestedComponents,
    sdkRequestedComponents = _b === void 0 ? "" : _b,
    _c = _a.sdkDataNamespace,
    sdkDataNamespace = _c === void 0 ? DEFAULT_PAYPAL_NAMESPACE : _c;
  var requiredOptionCapitalized = sdkComponentKey.charAt(0).toUpperCase().concat(sdkComponentKey.substring(1));
  var errorMessage = "Unable to render <".concat(reactComponentName, " /> because window.").concat(sdkDataNamespace, ".").concat(requiredOptionCapitalized, " is undefined.");
  // The JS SDK only loads the buttons component by default.
  // All other components like messages and marks must be requested using the "components" query parameter
  var requestedComponents = typeof sdkRequestedComponents === "string" ? sdkRequestedComponents : sdkRequestedComponents.join(",");
  if (!requestedComponents.includes(sdkComponentKey)) {
    var expectedComponents = [requestedComponents, sdkComponentKey].filter(Boolean).join();
    errorMessage += "\nTo fix the issue, add '".concat(sdkComponentKey, "' to the list of components passed to the parent PayPalScriptProvider:") + "\n`<PayPalScriptProvider options={{ components: '".concat(expectedComponents, "'}}>`.");
  }
  return errorMessage;
}

/**
 * Generate a new random identifier for react-paypal-js
 *
 * @returns the {@code string} containing the random library name
 */
function getScriptID(options) {
  // exclude the data-react-paypal-script-id value from the options hash
  var _a = options,
    _b = SCRIPT_ID;
  _a[_b];
  var paypalScriptOptions = __rest$1(_a, [_b + ""]);
  return "react-paypal-js-".concat(hashStr(JSON.stringify(paypalScriptOptions)));
}
/**
 * Destroy the PayPal SDK from the document page
 *
 * @param reactPayPalScriptID the script identifier
 */
function destroySDKScript(reactPayPalScriptID) {
  var scriptNode = self.document.querySelector("script[".concat(SCRIPT_ID, "=\"").concat(reactPayPalScriptID, "\"]"));
  if (scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.parentNode) {
    scriptNode.parentNode.removeChild(scriptNode);
  }
}
/**
 * Reducer function to handle complex state changes on the context
 *
 * @param state  the current state on the context object
 * @param action the action to be executed on the previous state
 * @returns a the same state if the action wasn't found, or a new state otherwise
 */
function scriptReducer(state, action) {
  var _a, _b;
  switch (action.type) {
    case DISPATCH_ACTION.LOADING_STATUS:
      if (_typeof(action.value) === "object") {
        return _assign(_assign({}, state), {
          loadingStatus: action.value.state,
          loadingStatusErrorMessage: action.value.message
        });
      }
      return _assign(_assign({}, state), {
        loadingStatus: action.value
      });
    case DISPATCH_ACTION.RESET_OPTIONS:
      // destroy existing script to make sure only one script loads at a time
      destroySDKScript(state.options[SCRIPT_ID]);
      return _assign(_assign({}, state), {
        loadingStatus: SCRIPT_LOADING_STATE.PENDING,
        options: _assign(_assign((_a = {}, _a[SDK_SETTINGS.DATA_SDK_INTEGRATION_SOURCE] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _a), action.value), (_b = {}, _b[SCRIPT_ID] = "".concat(getScriptID(action.value)), _b))
      });
    case DISPATCH_ACTION.SET_BRAINTREE_INSTANCE:
      return _assign(_assign({}, state), {
        braintreePayPalCheckoutInstance: action.value
      });
    default:
      {
        return state;
      }
  }
}
// Create the React context to use in the script provider component
var ScriptContext = /*#__PURE__*/createContext(null);

/**
 * Check if the context is valid and ready to dispatch actions.
 *
 * @param scriptContext the result of connecting to the context provider
 * @returns strict context avoiding null values in the type
 */
function validateReducer(scriptContext) {
  if (typeof (scriptContext === null || scriptContext === void 0 ? void 0 : scriptContext.dispatch) === "function" && scriptContext.dispatch.length !== 0) {
    return scriptContext;
  }
  throw new Error(SCRIPT_PROVIDER_REDUCER_ERROR);
}

/**
 * Custom hook to get access to the Script context and
 * dispatch actions to modify the state on the {@link ScriptProvider} component
 *
 * @returns a tuple containing the state of the context and
 * a dispatch function to modify the state
 */
function usePayPalScriptReducer() {
  var scriptContext = validateReducer(useContext(ScriptContext));
  var derivedStatusContext = _assign(_assign({}, scriptContext), {
    isInitial: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.INITIAL,
    isPending: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.PENDING,
    isResolved: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.RESOLVED,
    isRejected: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.REJECTED
  });
  return [derivedStatusContext, scriptContext.dispatch];
}
function useProxyProps(props) {
  var proxyRef = useRef(new Proxy({}, {
    get: function get(target, prop, receiver) {
      /**
       *
       * If target[prop] is a function, return a function that accesses
       * this function off the target object. We can mutate the target with
       * new copies of this function without having to re-render the
       * SDK components to pass new callbacks.
       *
       * */
      if (typeof target[prop] === "function") {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          // eslint-disable-next-line @typescript-eslint/ban-types
          return target[prop].apply(target, args);
        };
      }
      return Reflect.get(target, prop, receiver);
    }
  }));
  proxyRef.current = Object.assign(proxyRef.current, props);
  return proxyRef.current;
}

/**
This `<PayPalButtons />` component supports rendering [buttons](https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-reference/#buttons) for PayPal, Venmo, and alternative payment methods.
It relies on the `<PayPalScriptProvider />` parent component for managing state related to loading the JS SDK script.
*/
var PayPalButtons = function PayPalButtons(_a) {
  var _b;
  var _c = _a.className,
    className = _c === void 0 ? "" : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    children = _a.children,
    _e = _a.forceReRender,
    forceReRender = _e === void 0 ? [] : _e,
    buttonProps = __rest$1(_a, ["className", "disabled", "children", "forceReRender"]);
  var isDisabledStyle = disabled ? {
    opacity: 0.38
  } : {};
  var classNames = "".concat(className, " ").concat(disabled ? "paypal-buttons-disabled" : "").trim();
  var buttonsContainerRef = useRef(null);
  var buttons = useRef(null);
  var proxyProps = useProxyProps(buttonProps);
  var _f = usePayPalScriptReducer()[0],
    isResolved = _f.isResolved,
    options = _f.options;
  var _g = useState(null),
    initActions = _g[0],
    setInitActions = _g[1];
  var _h = useState(true),
    isEligible = _h[0],
    setIsEligible = _h[1];
  var _j = useState(null),
    setErrorState = _j[1];
  function closeButtonsComponent() {
    if (buttons.current !== null) {
      buttons.current.close()["catch"](function () {
        // ignore errors when closing the component
      });
    }
  }
  if ((_b = buttons.current) === null || _b === void 0 ? void 0 : _b.updateProps) {
    buttons.current.updateProps({
      message: buttonProps.message
    });
  }
  // useEffect hook for rendering the buttons
  useEffect(function () {
    // verify the sdk script has successfully loaded
    if (isResolved === false) {
      return closeButtonsComponent;
    }
    var paypalWindowNamespace = getPayPalWindowNamespace$1(options.dataNamespace);
    // verify dependency on window object
    if (paypalWindowNamespace === undefined || paypalWindowNamespace.Buttons === undefined) {
      setErrorState(function () {
        throw new Error(generateErrorMessage({
          reactComponentName: PayPalButtons.displayName,
          sdkComponentKey: "buttons",
          sdkRequestedComponents: options.components,
          sdkDataNamespace: options[SDK_SETTINGS.DATA_NAMESPACE]
        }));
      });
      return closeButtonsComponent;
    }
    var decoratedOnInit = function decoratedOnInit(data, actions) {
      setInitActions(actions);
      if (typeof buttonProps.onInit === "function") {
        buttonProps.onInit(data, actions);
      }
    };
    try {
      buttons.current = paypalWindowNamespace.Buttons(_assign(_assign({}, proxyProps), {
        onInit: decoratedOnInit
      }));
    } catch (err) {
      return setErrorState(function () {
        throw new Error("Failed to render <PayPalButtons /> component. Failed to initialize:  ".concat(err));
      });
    }
    // only render the button when eligible
    if (buttons.current.isEligible() === false) {
      setIsEligible(false);
      return closeButtonsComponent;
    }
    if (!buttonsContainerRef.current) {
      return closeButtonsComponent;
    }
    buttons.current.render(buttonsContainerRef.current)["catch"](function (err) {
      // component failed to render, possibly because it was closed or destroyed.
      if (buttonsContainerRef.current === null || buttonsContainerRef.current.children.length === 0) {
        // paypal buttons container is no longer in the DOM, we can safely ignore the error
        return;
      }
      // paypal buttons container is still in the DOM
      setErrorState(function () {
        throw new Error("Failed to render <PayPalButtons /> component. ".concat(err));
      });
    });
    return closeButtonsComponent;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, __spreadArray(__spreadArray([isResolved], forceReRender, true), [buttonProps.fundingSource], false));
  // useEffect hook for managing disabled state
  useEffect(function () {
    if (initActions === null) {
      return;
    }
    if (disabled === true) {
      initActions.disable()["catch"](function () {
        // ignore errors when disabling the component
      });
    } else {
      initActions.enable()["catch"](function () {
        // ignore errors when enabling the component
      });
    }
  }, [disabled, initActions]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isEligible ? /*#__PURE__*/React.createElement("div", {
    ref: buttonsContainerRef,
    style: isDisabledStyle,
    className: classNames
  }) : children);
};
PayPalButtons.displayName = "PayPalButtons";
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function findScript(url, attributes) {
  var currentScript = document.querySelector("script[src=\"".concat(url, "\"]"));
  if (currentScript === null) return null;
  var nextScript = createScriptElement(url, attributes);
  var currentScriptClone = currentScript.cloneNode();
  delete currentScriptClone.dataset.uidAuto;
  if (Object.keys(currentScriptClone.dataset).length !== Object.keys(nextScript.dataset).length) {
    return null;
  }
  var isExactMatch = true;
  Object.keys(currentScriptClone.dataset).forEach(function (key) {
    if (currentScriptClone.dataset[key] !== nextScript.dataset[key]) {
      isExactMatch = false;
    }
  });
  return isExactMatch ? currentScript : null;
}
function insertScriptElement(_a) {
  var url = _a.url,
    attributes = _a.attributes,
    onSuccess = _a.onSuccess,
    onError = _a.onError;
  var newScript = createScriptElement(url, attributes);
  newScript.onerror = onError;
  newScript.onload = onSuccess;
  document.head.insertBefore(newScript, document.head.firstElementChild);
}
function processOptions(_a) {
  var customSdkBaseUrl = _a.sdkBaseUrl,
    environment = _a.environment,
    options = __rest(_a, ["sdkBaseUrl", "environment"]);
  var sdkBaseUrl = customSdkBaseUrl || processSdkBaseUrl(environment);
  var optionsWithStringIndex = options;
  var _b = Object.keys(optionsWithStringIndex).filter(function (key) {
      return typeof optionsWithStringIndex[key] !== "undefined" && optionsWithStringIndex[key] !== null && optionsWithStringIndex[key] !== "";
    }).reduce(function (accumulator, key) {
      var value = optionsWithStringIndex[key].toString();
      key = camelCaseToKebabCase(key);
      if (key.substring(0, 4) === "data" || key === "crossorigin") {
        accumulator.attributes[key] = value;
      } else {
        accumulator.queryParams[key] = value;
      }
      return accumulator;
    }, {
      queryParams: {},
      attributes: {}
    }),
    queryParams = _b.queryParams,
    attributes = _b.attributes;
  if (queryParams["merchant-id"] && queryParams["merchant-id"].indexOf(",") !== -1) {
    attributes["data-merchant-id"] = queryParams["merchant-id"];
    queryParams["merchant-id"] = "*";
  }
  return {
    url: "".concat(sdkBaseUrl, "?").concat(objectToQueryString(queryParams)),
    attributes: attributes
  };
}
function camelCaseToKebabCase(str) {
  var replacer = function replacer(match, indexOfMatch) {
    return (indexOfMatch ? "-" : "") + match.toLowerCase();
  };
  return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, replacer);
}
function objectToQueryString(params) {
  var queryString = "";
  Object.keys(params).forEach(function (key) {
    if (queryString.length !== 0) queryString += "&";
    queryString += key + "=" + params[key];
  });
  return queryString;
}
function processSdkBaseUrl(environment) {
  return environment === "sandbox" ? "https://www.sandbox.paypal.com/sdk/js" : "https://www.paypal.com/sdk/js";
}
function createScriptElement(url, attributes) {
  if (attributes === void 0) {
    attributes = {};
  }
  var newScript = document.createElement("script");
  newScript.src = url;
  Object.keys(attributes).forEach(function (key) {
    newScript.setAttribute(key, attributes[key]);
    if (key === "data-csp-nonce") {
      newScript.setAttribute("nonce", attributes["data-csp-nonce"]);
    }
  });
  return newScript;
}
function loadScript(options, PromisePonyfill) {
  if (PromisePonyfill === void 0) {
    PromisePonyfill = Promise;
  }
  validateArguments(options, PromisePonyfill);
  if (typeof document === "undefined") return PromisePonyfill.resolve(null);
  var _a = processOptions(options),
    url = _a.url,
    attributes = _a.attributes;
  var namespace = attributes["data-namespace"] || "paypal";
  var existingWindowNamespace = getPayPalWindowNamespace(namespace);
  if (!attributes["data-js-sdk-library"]) {
    attributes["data-js-sdk-library"] = "paypal-js";
  }
  if (findScript(url, attributes) && existingWindowNamespace) {
    return PromisePonyfill.resolve(existingWindowNamespace);
  }
  return loadCustomScript({
    url: url,
    attributes: attributes
  }, PromisePonyfill).then(function () {
    var newWindowNamespace = getPayPalWindowNamespace(namespace);
    if (newWindowNamespace) {
      return newWindowNamespace;
    }
    throw new Error("The window.".concat(namespace, " global variable is not available."));
  });
}
function loadCustomScript(options, PromisePonyfill) {
  if (PromisePonyfill === void 0) {
    PromisePonyfill = Promise;
  }
  validateArguments(options, PromisePonyfill);
  var url = options.url,
    attributes = options.attributes;
  if (typeof url !== "string" || url.length === 0) {
    throw new Error("Invalid url.");
  }
  if (typeof attributes !== "undefined" && _typeof(attributes) !== "object") {
    throw new Error("Expected attributes to be an object.");
  }
  return new PromisePonyfill(function (resolve, reject) {
    if (typeof document === "undefined") return resolve();
    insertScriptElement({
      url: url,
      attributes: attributes,
      onSuccess: function onSuccess() {
        return resolve();
      },
      onError: function onError() {
        var defaultError = new Error("The script \"".concat(url, "\" failed to load. Check the HTTP status code and response body in DevTools to learn more."));
        return reject(defaultError);
      }
    });
  });
}
function getPayPalWindowNamespace(namespace) {
  return window[namespace];
}
function validateArguments(options, PromisePonyfill) {
  if (_typeof(options) !== "object" || options === null) {
    throw new Error("Expected an options object.");
  }
  var environment = options.environment;
  if (environment && environment !== "production" && environment !== "sandbox") {
    throw new Error('The `environment` option must be either "production" or "sandbox".');
  }
  if (typeof PromisePonyfill !== "undefined" && typeof PromisePonyfill !== "function") {
    throw new Error("Expected PromisePonyfill to be a function.");
  }
}

/**
This `<PayPalScriptProvider />` component takes care of loading the JS SDK `<script>`.
It manages state for script loading so children components like `<PayPalButtons />` know when it's safe to use the `window.paypal` global namespace.

Note: You always should use this component as a wrapper for  `PayPalButtons`, `PayPalMarks`, `PayPalMessages` and `BraintreePayPalButtons` components.
 */
var PayPalScriptProvider = function PayPalScriptProvider(_a) {
  var _b;
  var _c = _a.options,
    options = _c === void 0 ? {
      clientId: "test"
    } : _c,
    children = _a.children,
    _d = _a.deferLoading,
    deferLoading = _d === void 0 ? false : _d;
  var _e = useReducer(scriptReducer, {
      options: _assign(_assign({}, options), (_b = {}, _b[SDK_SETTINGS.DATA_JS_SDK_LIBRARY] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _b[SDK_SETTINGS.DATA_SDK_INTEGRATION_SOURCE] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _b[SCRIPT_ID] = "".concat(getScriptID(options)), _b)),
      loadingStatus: deferLoading ? SCRIPT_LOADING_STATE.INITIAL : SCRIPT_LOADING_STATE.PENDING
    }),
    state = _e[0],
    dispatch = _e[1];
  useEffect(function () {
    if (deferLoading === false && state.loadingStatus === SCRIPT_LOADING_STATE.INITIAL) {
      return dispatch({
        type: DISPATCH_ACTION.LOADING_STATUS,
        value: SCRIPT_LOADING_STATE.PENDING
      });
    }
    if (state.loadingStatus !== SCRIPT_LOADING_STATE.PENDING) {
      return;
    }
    var isSubscribed = true;
    loadScript(state.options).then(function () {
      if (isSubscribed) {
        dispatch({
          type: DISPATCH_ACTION.LOADING_STATUS,
          value: SCRIPT_LOADING_STATE.RESOLVED
        });
      }
    })["catch"](function (err) {
      console.error("".concat(LOAD_SCRIPT_ERROR, " ").concat(err));
      if (isSubscribed) {
        dispatch({
          type: DISPATCH_ACTION.LOADING_STATUS,
          value: {
            state: SCRIPT_LOADING_STATE.REJECTED,
            message: String(err)
          }
        });
      }
    });
    return function () {
      isSubscribed = false;
    };
  }, [state.options, deferLoading, state.loadingStatus]);
  return /*#__PURE__*/React.createElement(ScriptContext.Provider, {
    value: _assign(_assign({}, state), {
      dispatch: dispatch
    })
  }, children);
};

var _excluded$8 = ["entity", "envVariables", "method", "name", "onApproved", "orderType"];
// Form Component for Paypal Integration
var PaypalPayment = function PaypalPayment(_ref) {
  _ref.entity;
    var _ref$envVariables = _ref.envVariables,
    envVariables = _ref$envVariables === void 0 ? {} : _ref$envVariables,
    method = _ref.method;
    _ref.name;
    var _ref$onApproved = _ref.onApproved,
    onApproved = _ref$onApproved === void 0 ? function (value) {
      return value;
    } : _ref$onApproved,
    _ref$orderType = _ref.orderType,
    orderType = _ref$orderType === void 0 ? 'donate' : _ref$orderType,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var _usePaypalPayment = usePaypalPayment({
      envVariables: envVariables,
      onApproved: onApproved,
      orderType: orderType
    }),
    cart = _usePaypalPayment.cart,
    initialOptions = _usePaypalPayment.initialOptions,
    showButton = _usePaypalPayment.showButton,
    shouldDisableButton = _usePaypalPayment.shouldDisableButton,
    createOrder = _usePaypalPayment.createOrder,
    handleApproved = _usePaypalPayment.handleApproved;
  if (cart === undefined) {
    return null;
  }
  return jsxs(Fragment, {
    children: [jsx(PayPalScriptProvider, {
      options: initialOptions,
      children: showButton && jsx(PayPalButtons, {
        createOrder: createOrder,
        style: {
          layout: 'vertical',
          height: 40
        },
        disabled: shouldDisableButton,
        fundingSource: "paypal",
        onApprove: handleApproved,
        forceReRender: [cart]
      })
    }), jsx(Field$2, {
      name: "collector.cart.payment.method",
      value: method,
      type: "hidden"
    }), jsx(Field$2, {
      name: "collector.cart.payment.".concat(props.authPath),
      type: "hidden"
    })]
  });
};

var _excluded$7 = ["addressVisibleList", "availablePaymentMethods", "country", "disableCreditCardPayment", "disableEftPayment", "disablePayPalPayment", "displayList", "emailRequired", "hideHeadingText", "useSREDKeyPad"];
var PaymentMethod = function PaymentMethod(_ref) {
  var addressVisibleList = _ref.addressVisibleList,
    _ref$availablePayment = _ref.availablePaymentMethods,
    availablePaymentMethods = _ref$availablePayment === void 0 ? ['CC', 'EFT', 'PPM', 'APAY'] : _ref$availablePayment,
    _ref$country = _ref.country,
    country = _ref$country === void 0 ? ['US'] : _ref$country,
    _ref$disableCreditCar = _ref.disableCreditCardPayment,
    disableCreditCardPayment = _ref$disableCreditCar === void 0 ? false : _ref$disableCreditCar,
    _ref$disableEftPaymen = _ref.disableEftPayment,
    disableEftPayment = _ref$disableEftPaymen === void 0 ? false : _ref$disableEftPaymen,
    _ref$disablePayPalPay = _ref.disablePayPalPayment,
    disablePayPalPayment = _ref$disablePayPalPay === void 0 ? false : _ref$disablePayPalPay,
    _ref$displayList = _ref.displayList,
    displayList = _ref$displayList === void 0 ? ['Name', 'Email', 'Address'] : _ref$displayList,
    _ref$emailRequired = _ref.emailRequired,
    emailRequired = _ref$emailRequired === void 0 ? true : _ref$emailRequired,
    _ref$hideHeadingText = _ref.hideHeadingText,
    hideHeadingText = _ref$hideHeadingText === void 0 ? false : _ref$hideHeadingText,
    _ref$useSREDKeyPad = _ref.useSREDKeyPad,
    useSREDKeyPad = _ref$useSREDKeyPad === void 0 ? false : _ref$useSREDKeyPad,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var _usePaymentMethod = usePaymentMethod({
      availablePaymentMethods: availablePaymentMethods,
      envVariables: props === null || props === void 0 ? void 0 : props.envVariables,
      submitLabel: props === null || props === void 0 ? void 0 : props.submitLabel
    }),
    activeMethod = _usePaymentMethod.activeMethod,
    billingHeadingTxt = _usePaymentMethod.billingHeadingTxt,
    ccLabel = _usePaymentMethod.ccLabel,
    checkImgUrl = _usePaymentMethod.checkImgUrl,
    checkLabel = _usePaymentMethod.checkLabel,
    defaultAddressList = _usePaymentMethod.defaultAddressList,
    enableApayPayment = _usePaymentMethod.enableApayPayment,
    hasAPayPayment = _usePaymentMethod.hasAPayPayment,
    hasPaypalPayment = _usePaymentMethod.hasPaypalPayment,
    hasRecurring = _usePaymentMethod.hasRecurring,
    headingTxt = _usePaymentMethod.headingTxt,
    paymentObj = _usePaymentMethod.paymentObj,
    handleOnClick = _usePaymentMethod.handleOnClick;
  return jsx("div", {
    className: "payment-method-container",
    children: jsxs(Container, {
      children: [(availablePaymentMethods === null || availablePaymentMethods === void 0 ? void 0 : availablePaymentMethods.length) > 1 && !hideHeadingText && jsx(Heading, {
        renderAs: "h3",
        textAlign: "center",
        subtitle: true,
        size: 4,
        children: headingTxt
      }), jsxs(Button.Group, {
        align: "center",
        children: [!disableCreditCardPayment && jsx(Button, {
          className: activeMethod === 'CCP' ? 'is-active' : 'is-primary',
          value: "CCP",
          onClick: handleOnClick,
          children: ccLabel
        }), !disableEftPayment && jsx(Button, {
          className: activeMethod === 'EFT' ? 'is-active' : 'is-primary',
          value: "EFT",
          onClick: handleOnClick,
          children: checkLabel
        }), !disablePayPalPayment && !hasRecurring && jsx(PaypalPayment, {
          authPath: "paypalInfo.nonce",
          envVariables: props.envVariables,
          method: "PPM"
        }), enableApayPayment && jsx(ApplePayment, {})]
      }), (activeMethod === PaymentOptions.EFT || activeMethod === PaymentOptions.CCP) && !hasPaypalPayment && !hasAPayPayment && jsxs(Fragment, {
        children: [jsx(Heading, {
          renderAs: "h3",
          subtitle: true,
          size: 4,
          children: billingHeadingTxt
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: addressVisibleList || defaultAddressList,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          autoComplete: props === null || props === void 0 ? void 0 : props.autoComplete,
          country: country,
          visibleList: displayList,
          emailRequired: emailRequired,
          minPhoneLength: 10,
          required: true
        })), activeMethod === PaymentOptions.EFT && jsx(Block, {
          pt: "3",
          children: jsx(Image, {
            src: checkImgUrl
          })
        }), jsx(Field$2, {
          type: "hidden",
          name: "cart.payment.paymentMethod",
          value: activeMethod
        }), paymentObj.method && !useSREDKeyPad && jsx(BluefinPayment, _objectSpread2(_objectSpread2({}, props), {}, {
          type: paymentObj.type,
          envVariables: paymentObj.envVariables,
          submitLabel: paymentObj.submitLabel,
          method: paymentObj.method,
          authPath: paymentObj.authPath
        })), paymentObj.method && useSREDKeyPad && jsx(KeyPadPayment, {})]
      })]
    })
  });
};

var PledgeAmounts = function PledgeAmounts() {
  var _usePledgeAmounts = usePledgeAmounts(),
    frequencyOptions = _usePledgeAmounts.frequencyOptions,
    itemName = _usePledgeAmounts.itemName,
    pledgeProjectOptions = _usePledgeAmounts.pledgeProjectOptions;
  return jsxs(Columns, {
    children: [jsxs(Columns.Column, {
      children: [jsx(Form$1.Label, {
        children: "Pledge Amount"
      }), jsx(Form$1.Control, {
        children: jsx(Currency, {
          name: "collector.cart.pledge.amount",
          inputSize: "normal"
        })
      })]
    }), itemName && jsx(Columns.Column, {
      size: "one-quarter",
      children: jsx(ItemCalculator, {
        pledge: true,
        label: "Number of ".concat(itemName, "s")
      })
    }), jsx(Columns.Column, {
      children: jsx(Form$1.Control, {
        children: jsx(Dropdown, {
          label: "What type of Pledge",
          name: "collector.cart.pledge.frequency",
          options: frequencyOptions
        })
      })
    }), jsx(Columns.Column, {
      children: jsx(Form$1.Control, {
        children: jsx(Dropdown, {
          label: "Select Charity",
          name: "collector.cart.pledge.pledgeCode",
          options: pledgeProjectOptions
        })
      })
    })]
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var P = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1t6jk710"
} : {
  target: "e1t6jk710",
  label: "P"
})(process.env.NODE_ENV === "production" ? {
  name: "17mtvgw",
  styles: "font-size:0.875em;color:#b3b3b3"
} : {
  name: "17mtvgw",
  styles: "font-size:0.875em;color:#b3b3b3",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var RecaptchaMessage = function RecaptchaMessage(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useRecaptcahMessage = useRecaptcahMessage(),
    recaptchaMessage = _useRecaptcahMessage.recaptchaMessage,
    termsOfService = _useRecaptcahMessage.termsOfService,
    rePrivacyPolicyLabel = _useRecaptcahMessage.rePrivacyPolicyLabel,
    apply = _useRecaptcahMessage.apply,
    and = _useRecaptcahMessage.and;
  return jsx(Container, {
    children: jsx(P, {
      className: "form-recaptcha-message",
      children: props !== null && props !== void 0 && props.customRecaptchaMsg ? jsx("span", {
        dangerouslySetInnerHTML: {
          __html: props === null || props === void 0 ? void 0 : props.customRecaptchaMsg
        }
      }) : jsxs(Fragment, {
        children: [recaptchaMessage, ' ', jsx("a", {
          href: "https://policies.google.com/privacy",
          target: "_blank",
          rel: "noreferrer",
          children: rePrivacyPolicyLabel
        }), ' ', and, ' ', jsx("a", {
          href: "https://policies.google.com/terms",
          target: "_blank",
          rel: "noreferrer",
          children: termsOfService
        }), ' ', apply, "."]
      })
    })
  });
};

var RecurringChoice = function RecurringChoice(_ref) {
  var day = _ref.day,
    donationDay = _ref.donationDay,
    handleClick = _ref.handleClick,
    getButtonStyles = _ref.getButtonStyles,
    _ref$fieldName = _ref.fieldName,
    fieldName = _ref$fieldName === void 0 ? 'collector.cart.donation.projects[0].recurringDate' : _ref$fieldName;
  var _useRecurringChoice = useRecurringChoice({
      day: day
    }),
    recurringText = _useRecurringChoice.recurringText;
  return jsx("label", {
    style: getButtonStyles(donationDay === day),
    htmlFor: "dayChoice-".concat(day),
    children: jsx(Field$2, {
      name: fieldName,
      type: "text",
      children: function children() {
        return jsxs(Fragment, {
          children: [jsx("input", {
            style: {
              appearance: 'none'
            },
            id: "dayChoice-".concat(day),
            name: "input_8",
            type: "radio",
            value: day,
            checked: donationDay === day,
            onClick: handleClick
          }), jsx("span", {
            children: recurringText
          })]
        });
      }
    })
  });
};

/* eslint-disable react/no-danger */

var RecurringInfo = function RecurringInfo(_ref) {
  var _ref$recurringCopy = _ref.recurringCopy,
    recurringCopy = _ref$recurringCopy === void 0 ? 'Your donation will be processed today and your monthly draft will begin on' : _ref$recurringCopy,
    recurringText = _ref.recurringText,
    index = _ref.index;
  return jsx("div", {
    children: jsxs("label", {
      id: "draft-text",
      className: "has-tooltip-multiline has-tooltip-bottom",
      htmlFor: "collector.cart.donation.projects[".concat(index, "].recurringDate"),
      "data-tooltip": "Your donation will be processed today and your monthly draft will begin on the date selected below:",
      children: [jsx("span", {
        dangerouslySetInnerHTML: {
          __html: recurringCopy
        }
      }), ' ', " ".concat(recurringText)]
    })
  });
};

var _excluded$6 = ["index", "label", "addClass", "name", "givingBtnStyle"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
// Styled components
var FieldWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e17wxjcx2"
} : {
  target: "e17wxjcx2",
  label: "FieldWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Label = /*#__PURE__*/_styled("label", process.env.NODE_ENV === "production" ? {
  target: "e17wxjcx1"
} : {
  target: "e17wxjcx1",
  label: "Label"
})(process.env.NODE_ENV === "production" ? {
  name: "zjla7v",
  styles: "align-items:center;display:grid;grid-template-columns:70px 1px auto;height:auto;margin-left:10px;position:relative;.switch-label{grid-column:3/4;}input{grid-column:2/3;height:0;opacity:0;width:0;}.slider{background-color:rgb(204, 204, 204);border-radius:5px;cursor:pointer;display:block;grid-column:1/2;height:34px;position:absolute;transition:0.4s;width:60px;&::before{position:absolute;content:'';height:26px;width:26px;left:4px;bottom:4px;background-color:white;transition:0.4s;border-radius:15%;}}"
} : {
  name: "zjla7v",
  styles: "align-items:center;display:grid;grid-template-columns:70px 1px auto;height:auto;margin-left:10px;position:relative;.switch-label{grid-column:3/4;}input{grid-column:2/3;height:0;opacity:0;width:0;}.slider{background-color:rgb(204, 204, 204);border-radius:5px;cursor:pointer;display:block;grid-column:1/2;height:34px;position:absolute;transition:0.4s;width:60px;&::before{position:absolute;content:'';height:26px;width:26px;left:4px;bottom:4px;background-color:white;transition:0.4s;border-radius:15%;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Input = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "e17wxjcx0"
} : {
  target: "e17wxjcx0",
  label: "Input"
})(process.env.NODE_ENV === "production" ? {
  name: "1mdqh9c",
  styles: "&:checked+.slider{background-color:#003658;}&:focus+.slider,&:hover+.slider{box-shadow:0 0 1px red;}&:checked+.slider::before{transform:translateX(26px);}"
} : {
  name: "1mdqh9c",
  styles: "&:checked+.slider{background-color:#003658;}&:focus+.slider,&:hover+.slider{box-shadow:0 0 1px red;}&:checked+.slider::before{transform:translateX(26px);}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

// Main Component
var RecurringToggle = function RecurringToggle(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'I would like to make this gift monthly.' : _ref$label,
    _ref$addClass = _ref.addClass,
    addClass = _ref$addClass === void 0 ? '' : _ref$addClass,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "formLogic.cart.donation.projects.[".concat(index, "].isRecurring") : _ref$name,
    givingBtnStyle = _ref.givingBtnStyle,
    props = _objectWithoutProperties(_ref, _excluded$6);
  return jsx(FieldWrapper, {
    className: "field is-horizontal debbie ".concat(addClass),
    children: jsx(Field$2, {
      name: name,
      children: function children(_ref2) {
        var field = _ref2.field;
        return jsx(Fragment, {
          children: jsxs(Label, {
            htmlFor: name,
            children: [jsx("span", {
              className: "switch-label",
              children: label
            }), jsx(Input, _objectSpread2(_objectSpread2(_objectSpread2({}, field), props), {}, {
              id: name,
              type: "checkbox",
              checked: field.value,
              bgColor: givingBtnStyle.bgColor,
              role: "switch"
            })), jsx("span", {
              className: "slider"
            })]
          })
        });
      }
    })
  });
};

var _excluded$5 = ["addToggleClass", "isRecurring", "index", "donationDateButtons", "recurringChoiceDay", "donationDay", "handleClick", "errorMessage", "givingBtnStyle"];
var RecurringSection = function RecurringSection(_ref) {
  var addToggleClass = _ref.addToggleClass,
    isRecurring = _ref.isRecurring,
    index = _ref.index,
    donationDateButtons = _ref.donationDateButtons,
    recurringChoiceDay = _ref.recurringChoiceDay,
    donationDay = _ref.donationDay,
    handleClick = _ref.handleClick;
    _ref.errorMessage;
    var givingBtnStyle = _ref.givingBtnStyle,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var _useRecurring = useRecurring({
      index: index,
      donationDateButtons: donationDateButtons,
      isRecurring: isRecurring,
      givingBtnStyle: givingBtnStyle
    }),
    defaultDebitDay = _useRecurring.defaultDebitDay,
    recurringText = _useRecurring.recurringText,
    options = _useRecurring.options,
    getButtonStyles = _useRecurring.getButtonStyles;
  return jsxs(Columns, {
    flexDirection: "column",
    className: "recurring-section",
    children: [jsx(Columns.Column, {
      children: !(props !== null && props !== void 0 && props.isEmbedSite) ? jsx(RecurringToggle, {
        addClass: addToggleClass,
        index: index,
        givingBtnStyle: givingBtnStyle,
        label: props === null || props === void 0 ? void 0 : props.recurringToggleLabel
      }) : jsx(Checkbox, {
        name: "formLogic.cart.donation.projects.[".concat(index, "].isRecurring"),
        label: (props === null || props === void 0 ? void 0 : props.recurringToggleLabel) || 'I would like to make this gift monthly.'
      })
    }), isRecurring && jsx(Columns.Column, {
      children: jsxs("div", {
        className: "field is-horizontal",
        style: {
          display: 'unset'
        },
        children: [jsx(RecurringInfo, {
          recurringText: (props === null || props === void 0 ? void 0 : props.recurringText) || recurringText,
          index: index,
          recurringCopy: props === null || props === void 0 ? void 0 : props.recurringCopy
        }), donationDateButtons ? jsx(Fragment, {
          children: jsx(Container, {
            className: "is-flex",
            children: recurringChoiceDay.map(function (day) {
              return jsx(RecurringChoice, {
                day: day,
                donationDay: donationDay,
                handleClick: handleClick,
                getButtonStyles: getButtonStyles
              }, day);
            })
          })
        }) : jsx(Container, {
          children: jsx(Dropdown, {
            name: "formLogic.recurringDateNum",
            label: "",
            defaultValue: defaultDebitDay || '',
            options: options
          })
        })]
      })
    })]
  });
};

var _excluded$4 = ["addToggleClass", "buttonSize", "buttons", "donationDateButtons", "donationDay", "errorMessage", "activeButton", "isRecurring", "handleAmountChange", "handleClick", "projects", "index", "setActiveButton", "GivingButton", "givingBtnStyle", "recurringToggle", "recurringChoiceDay"];
var DonationRecurring = function DonationRecurring(_ref) {
  var addToggleClass = _ref.addToggleClass,
    buttonSize = _ref.buttonSize,
    buttons = _ref.buttons,
    donationDateButtons = _ref.donationDateButtons,
    donationDay = _ref.donationDay;
    _ref.errorMessage;
    var activeButton = _ref.activeButton,
    isRecurring = _ref.isRecurring,
    handleAmountChange = _ref.handleAmountChange,
    handleClick = _ref.handleClick,
    projects = _ref.projects,
    index = _ref.index,
    setActiveButton = _ref.setActiveButton,
    GivingButton = _ref.GivingButton,
    givingBtnStyle = _ref.givingBtnStyle,
    recurringToggle = _ref.recurringToggle,
    recurringChoiceDay = _ref.recurringChoiceDay,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var _useRecurring = useRecurring({
      index: index,
      donationDateButtons: donationDateButtons,
      isRecurring: isRecurring,
      givingBtnStyle: givingBtnStyle,
      recurringTextCopy: props === null || props === void 0 ? void 0 : props.recurringTextCopy
    }),
    defaultDebitDay = _useRecurring.defaultDebitDay,
    recurringText = _useRecurring.recurringText,
    options = _useRecurring.options,
    getButtonStyles = _useRecurring.getButtonStyles;
  return jsxs("div", {
    className: "donation-recurring-section",
    children: [jsx("div", {
      className: "donation-buttons",
      children: jsx(Button.Group, {
        size: buttonSize,
        children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (btn) {
          return jsxs(GivingButton, {
            onClick: handleAmountChange,
            value: btn,
            type: "button",
            className: activeButton === btn ? 'is-Active' : '',
            isActive: activeButton === btn,
            bgColor: givingBtnStyle.bgColor,
            textColor: givingBtnStyle.textColor,
            children: ["$", btn]
          }, "gift-button-".concat(btn));
        })
      })
    }), jsxs(Columns, {
      className: "donation-currency-recurring-section",
      children: [jsx(Columns.Column, {
        className: "donation-currency",
        children: projects && projects[index] && jsx(Currency, _objectSpread2(_objectSpread2({}, props), {}, {
          inputSize: buttonSize,
          name: "collector.cart.donation.projects[".concat(index, "].amount"),
          placeholderText: props === null || props === void 0 ? void 0 : props.placeholderText,
          onChange: function onChange(event) {
            var newValue = parseFloat(formatCurrency(event.target.value));
            if (buttons.includes(newValue)) {
              setActiveButton(newValue);
            } else {
              setActiveButton(0);
            }
          }
        }))
      }), projects && projects[index] && recurringToggle === true && jsx(Columns.Column, {
        className: "donation-recurring",
        children: jsx(Columns, {
          flexDirection: "column",
          className: "recurring-section",
          children: jsx(Columns.Column, {
            children: !(props !== null && props !== void 0 && props.isEmbedSite) ? jsx(RecurringToggle, {
              addClass: addToggleClass,
              index: index,
              givingBtnStyle: givingBtnStyle,
              label: props === null || props === void 0 ? void 0 : props.recurringToggleLabel
            }) : jsx(Checkbox, {
              name: "formLogic.cart.donation.projects.[".concat(index, "].isRecurring"),
              label: (props === null || props === void 0 ? void 0 : props.recurringToggleLabel) || 'I would like to make this gift monthly.',
              isChecked: props === null || props === void 0 ? void 0 : props.isMonthly
            })
          })
        })
      })]
    }), projects && projects[index] && recurringToggle === true && isRecurring && jsxs("div", {
      className: "donation-recurring-info",
      children: [jsx(RecurringInfo, {
        recurringText: (props === null || props === void 0 ? void 0 : props.recurringText) || recurringText,
        index: index,
        recurringCopy: props === null || props === void 0 ? void 0 : props.recurringCopy
      }), donationDateButtons ? jsx(Fragment, {
        children: jsx(Container, {
          className: "is-flex",
          children: recurringChoiceDay.map(function (day) {
            return jsx(RecurringChoice, {
              day: day,
              donationDay: donationDay,
              handleClick: handleClick,
              getButtonStyles: getButtonStyles
            }, day);
          })
        })
      }) : jsx(Container, {
        children: jsx(Dropdown, {
          name: "formLogic.recurringDateNum",
          label: "",
          defaultValue: defaultDebitDay || '',
          options: options
        })
      })]
    })]
  });
};

var _excluded$3 = ["addToggleClass", "buttonAmounts", "buttonSize", "donationDateButtons", "give", "giveBtnText", "giveButton", "givingBtnStyle", "givingRecurringBtnStyle", "index", "projectId", "recurringButtonAmounts", "recurringChoiceDay", "recurringToggle", "uniqueClassName"];
var GivingButton = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "enfbr7u0"
} : {
  target: "enfbr7u0",
  label: "GivingButton"
})("&&{background-color:", function (props) {
  return props.isActive ? props.textColor : props.bgColor;
}, ";color:", function (props) {
  return props.isActive ? props.bgColor : props.textColor;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var SingleGift = function SingleGift(_ref) {
  var _ref$addToggleClass = _ref.addToggleClass,
    addToggleClass = _ref$addToggleClass === void 0 ? '' : _ref$addToggleClass,
    _ref$buttonAmounts = _ref.buttonAmounts,
    buttonAmounts = _ref$buttonAmounts === void 0 ? [250, 100, 50, 25] : _ref$buttonAmounts,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? 'medium' : _ref$buttonSize,
    donationDateButtons = _ref.donationDateButtons,
    give = _ref.give,
    _ref$giveBtnText = _ref.giveBtnText,
    giveBtnText = _ref$giveBtnText === void 0 ? 'Give Now' : _ref$giveBtnText,
    giveButton = _ref.giveButton,
    _ref$givingBtnStyle = _ref.givingBtnStyle,
    givingBtnStyle = _ref$givingBtnStyle === void 0 ? {
      bgColor: '#003658',
      textColor: '#ffffff'
    } : _ref$givingBtnStyle,
    _ref$givingRecurringB = _ref.givingRecurringBtnStyle,
    givingRecurringBtnStyle = _ref$givingRecurringB === void 0 ? {
      bgColor: '#00c4a7',
      textColor: '#ffffff'
    } : _ref$givingRecurringB,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$projectId = _ref.projectId,
    projectId = _ref$projectId === void 0 ? 0 : _ref$projectId,
    _ref$recurringButtonA = _ref.recurringButtonAmounts,
    recurringButtonAmounts = _ref$recurringButtonA === void 0 ? [100, 50, 25, 10] : _ref$recurringButtonA,
    _ref$recurringChoiceD = _ref.recurringChoiceDay,
    recurringChoiceDay = _ref$recurringChoiceD === void 0 ? [10, 25] : _ref$recurringChoiceD,
    recurringToggle = _ref.recurringToggle,
    _ref$uniqueClassName = _ref.uniqueClassName,
    uniqueClassName = _ref$uniqueClassName === void 0 ? '' : _ref$uniqueClassName,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var _useSingleGift = useSingleGift({
      index: index,
      projectId: projectId,
      buttonAmounts: buttonAmounts,
      recurringButtonAmounts: recurringButtonAmounts,
      donationDateButtons: donationDateButtons
    }),
    activeButton = _useSingleGift.activeButton,
    buttons = _useSingleGift.buttons,
    disableButton = _useSingleGift.disableButton,
    donationDay = _useSingleGift.donationDay,
    errorMessage = _useSingleGift.errorMessage,
    handleAmountChange = _useSingleGift.handleAmountChange,
    handleGiveButton = _useSingleGift.handleGiveButton,
    handleClick = _useSingleGift.handleClick,
    isRecurring = _useSingleGift.isRecurring,
    projects = _useSingleGift.projects,
    setActiveButton = _useSingleGift.setActiveButton,
    setProjectIdUpdated = _useSingleGift.setProjectIdUpdated;
  return jsxs(Container, {
    children: [!(props !== null && props !== void 0 && props.isEmbedSite) ? jsxs(Fragment, {
      children: [jsx(DonationButtons, _objectSpread2({
        activeButton: activeButton,
        GivingButton: GivingButton,
        buttonSize: buttonSize,
        buttons: buttons,
        givingBtnStyle: givingBtnStyle,
        handleAmountChange: handleAmountChange,
        index: index,
        projects: projects,
        setActiveButton: setActiveButton,
        uniqueClassName: uniqueClassName
      }, props)), projects && projects[index] && recurringToggle === true && jsx(RecurringSection, _objectSpread2({
        addToggleClass: addToggleClass,
        donationDateButtons: donationDateButtons,
        donationDay: donationDay,
        errorMessage: errorMessage,
        handleClick: handleClick,
        givingBtnStyle: givingRecurringBtnStyle,
        index: index,
        isRecurring: isRecurring,
        recurringChoiceDay: recurringChoiceDay
      }, props))]
    }) : jsx(DonationRecurring, _objectSpread2({
      addToggleClass: addToggleClass,
      activeButton: activeButton,
      donationDateButtons: donationDateButtons,
      donationDay: donationDay,
      GivingButton: GivingButton,
      buttonSize: buttonSize,
      buttons: buttons,
      errorMessage: errorMessage,
      givingBtnStyle: givingBtnStyle,
      handleAmountChange: handleAmountChange,
      index: index,
      isRecurring: isRecurring,
      recurringChoiceDay: recurringChoiceDay,
      projects: projects,
      setActiveButton: setActiveButton,
      recurringToggle: recurringToggle,
      handleClick: handleClick
    }, props)), give && jsx(Columns, {
      className: "give-now-section",
      children: jsx(Columns.Column, {
        className: "give-now-column-section",
        children: jsx(GivingButton, {
          className: "giveNowBtn",
          bgColor: givingBtnStyle.bgColor,
          disabled: disableButton,
          onClick: function onClick() {
            setProjectIdUpdated(function (prev) {
              return prev + 1;
            });
            handleGiveButton();
            giveButton === null || giveButton === void 0 ? void 0 : giveButton();
          },
          textColor: givingBtnStyle.textColor,
          type: "button",
          children: giveBtnText
        })
      })
    })]
  });
};

var _excluded$2 = ["buttonSize", "buttons", "activeButton", "handleAmountChange", "projects", "index", "setActiveButton", "GivingButton", "givingBtnStyle", "uniqueClassName"];
var DonationButtons = function DonationButtons(_ref) {
  var buttonSize = _ref.buttonSize,
    buttons = _ref.buttons,
    activeButton = _ref.activeButton,
    handleAmountChange = _ref.handleAmountChange,
    projects = _ref.projects,
    index = _ref.index,
    setActiveButton = _ref.setActiveButton,
    GivingButton = _ref.GivingButton,
    givingBtnStyle = _ref.givingBtnStyle,
    uniqueClassName = _ref.uniqueClassName,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsxs(Columns, {
    className: "buttonSection",
    children: [jsx(Columns.Column, {
      children: jsx(Button.Group, {
        size: buttonSize,
        children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (btn) {
          return jsxs(GivingButton, {
            onClick: handleAmountChange,
            value: btn,
            type: "button",
            className: "".concat(uniqueClassName, " donation-gift-button ").concat(activeButton === btn ? 'is-Active' : ''),
            isActive: activeButton === btn,
            bgColor: givingBtnStyle.bgColor,
            textColor: givingBtnStyle.textColor,
            id: "donation-gift-button-".concat(btn),
            children: ["$", btn]
          }, "gift-button-".concat(btn));
        })
      })
    }), jsx(Columns.Column, {
      size: "one-third",
      children: projects && projects[index] && jsx(Currency, _objectSpread2(_objectSpread2({}, props), {}, {
        inputSize: buttonSize,
        name: "collector.cart.donation.projects[".concat(index, "].amount"),
        placeholderText: props === null || props === void 0 ? void 0 : props.placeholderText,
        onChange: function onChange(event) {
          var newValue = parseFloat(formatCurrency(event.target.value));
          if (buttons.includes(newValue)) {
            setActiveButton(newValue);
          } else {
            setActiveButton(0);
          }
        }
      }))
    })]
  });
};

var _excluded$1 = ["isDisabled", "isEmbedSite", "isNewSubmitButton", "text", "useScrollToFieldError", "showErrorMsg"];
var ButtonStyled = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e1mzs82w0"
} : {
  target: "e1mzs82w0",
  label: "ButtonStyled"
})("font-size:15px;line-height:21px;font-weight:700;letter-spacing:1.5px;font-family:Proxima Nova,sans-serif;border-color:#1a1a1a;border-radius:", function (props) {
  return props.isNewSubmitButton ? '0' : '4px';
}, ";text-transform:", function (props) {
  return props.isNewSubmitButton ? 'uppercase' : 'none';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var SubmitButton = function SubmitButton(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$isEmbedSite = _ref.isEmbedSite,
    isEmbedSite = _ref$isEmbedSite === void 0 ? false : _ref$isEmbedSite,
    _ref$isNewSubmitButto = _ref.isNewSubmitButton,
    isNewSubmitButton = _ref$isNewSubmitButto === void 0 ? false : _ref$isNewSubmitButto,
    text = _ref.text,
    _ref$useScrollToField = _ref.useScrollToFieldError,
    useScrollToFieldError = _ref$useScrollToField === void 0 ? false : _ref$useScrollToField,
    _ref$showErrorMsg = _ref.showErrorMsg,
    showErrorMsg = _ref$showErrorMsg === void 0 ? false : _ref$showErrorMsg,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var domAttributes = pickDomAttributes(props);
  var _useSubmitButton = useSubmitButton({
      text: text,
      useScrollToFieldError: useScrollToFieldError
    }),
    isFormValid = _useSubmitButton.isFormValid,
    isSubmitting = _useSubmitButton.isSubmitting,
    showErrorMessage = _useSubmitButton.showErrorMessage,
    submitText = _useSubmitButton.submitText,
    onSubmit = _useSubmitButton.onSubmit;
  return jsxs(Fragment, {
    children: [showErrorMessage && showErrorMsg && jsx(Message, {
      color: "danger",
      children: jsx(Message.Body, {
        children: jsx("div", {
          children: (props === null || props === void 0 ? void 0 : props.submitErrorMsg) || 'There was a problem with your submission. Please review the fields above.'
        })
      })
    }), jsx("div", {
      className: "submit-button",
      children: !isEmbedSite ? jsx(ButtonStyled, _objectSpread2(_objectSpread2({
        color: (props === null || props === void 0 ? void 0 : props.color) || 'info',
        disabled: isSubmitting || isDisabled || !isFormValid,
        submit: true,
        type: "submit",
        onClick: onSubmit,
        isNewSubmitButton: isNewSubmitButton
      }, domAttributes), {}, {
        children: submitText
      })) : jsx(Button, _objectSpread2(_objectSpread2({
        disabled: isSubmitting || isDisabled || !isFormValid,
        submit: true,
        type: "submit",
        onClick: onSubmit
      }, domAttributes), {}, {
        children: submitText
      }))
    }), !(props !== null && props !== void 0 && props.hideRecaptchaMessage) && jsx(RecaptchaMessage, _objectSpread2({}, props))]
  });
};

var _excluded = ["id", "label", "name", "required", "maxLen"];
var TextArea = function TextArea(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'input' : _ref$name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$maxLen = _ref.maxLen,
    maxLen = _ref$maxLen === void 0 ? 65535 : _ref$maxLen,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useInputValidation = useInputValidation({
      required: required,
      maxLen: maxLen
    }),
    validate = _useInputValidation.validate;
  return jsxs(Form$1.Field, {
    className: "textarea-field",
    children: [jsx(Form$1.Label, {
      children: label
    }), jsx(Field$2, _objectSpread2(_objectSpread2({}, props), {}, {
      as: "textarea",
      className: fieldClassList('textarea', name),
      id: id,
      name: name,
      validate: (props === null || props === void 0 ? void 0 : props.validate) || validate,
      maxLength: maxLen
    })), name !== '' && jsx("p", {
      className: "help is-danger",
      role: "alert",
      children: jsx(ErrorMessage$1, {
        name: name
      })
    })]
  });
};

export { Acknowledgement, Address, AddressType, Age, Analytics, ApplePayment, Checkbox, Church, CommunicationType, Countries, Country, CountryPostal, CountryRegion, Currency, CustomMarkupSection, DDCLANG, DEFAULT_ERROR, DateCalendar, DeliverToOtherDepartment, DonationButtons, DonationCart, Dropdown, EmailType, EntityFields, EntityType, FileUpload, FluentLanguageValue, FormErrorScreens, FormLoading, FormProvider, FormSubmittingScreen, FreeGiftOffer, Frequency, GiftType, InputEmail, InputNumber, InputPhone, InputText, InputTime, Language, MultiSelect, NBSettings, Name, PaymentMethod, PaymentOptions, PaypalPayment, PhoneNumberFieldFormat, PhoneType, PledgeAmounts, Radio, RadioGroup, RecaptchaMessage, RecurringChoice, RecurringInfo, RecurringSection, RecurringToggle, Region, RelationshipType, ResponseStatus, SendBlank, SingleGift, SubmitButton, SubscriptionCategory, Templates, TextArea, VogonStatus, addCartEvent, addEvents, addItemToCart, addToCartEvent, alternateButtonAmounts, applyHelper, beginCheckoutEvent, buildSrcStr, calculateDiscount, calculateStartDate, calculateStartDateMonthDropDown, calculateTotalPrice, captchaCheckboxScrollPosition, chargeDates, chargeMonths, confirmationChoiceEvent, convertOptionsToList, convertToBase64, createDate, deepFind, donationGiftLogic, fieldClassList, formatCurrency, formatDate, formatUSCurrency, freeGiftHeper, getAcousticURI, getApiURI, getAppleMerchantId, getAvailabilityChargeDates, getAvailabilityChargeDays, getAvailabilityChargeMonths, getAvailableDateOptions, getAvailableOptions, getBRBInfo, getBluefinAccount, getBluefinApiURI, getBluefinServer, getChargeDays, getChurchCodes, getChurchFieldNames, getCraftyClicksAccessToken, getDataEntryURI, getDaysInMonth, getEmbedFormURL, getEnvironmentVariable, getErrorMessage, getFileUploadURI, getFormURI, getFormattedStartDate, getFormattedStartDateDropDown, getGoogleMapVariable, getLoggingURI, getPaymentErrors, getPaypalLogPayload, getPowerByTextApiURI, getProject, getProjectDescription, getProjectOptions, getQueryStringDict, getRecaptchaKeyV2, getRecaptchaKeyV3, getRecurringTotal, getReferenceURI, getSiteUrl, getStellofyURI, getValidDate, handleApprovedCaptureHelper, handleCheckoutComponentDidMount, handleDeleteItem, handleFormValues$1 as handleFormValues, handleOrgGift, handleRecurringDateLogic, handleSubTotal, hasPayment, hasRecurringPaymentType, InitValues$1 as initialValues, inputEmailClass, isDevEnvironment, isDisableRecaptcha, isJSON, isProdEnvironment, isQaEnvironment, isStagingEnvironment, isValidDate, isValidHonorMemorial, listenerHelper, loadRecaptchaV2Script, lpad, ordinalSuffix, powerByTextError, qualifyingGiftEvent, questionsHelper, removeCartEvent, removeEvents, removeFromCartEvent, responseHandlerHelper, selectedForAskEvent, setDefaultValues, shouldEnableButton, trackDonationFunnel, trackEvent, trackGivingButtons, updateCartEvent, updateCartInfo, updateCheckoutEvent, updateRecurringPayment, updateSelectedProject, useAddress, useApplePayButton, useApplePayment, useAutoCompleteAddress, useBluefinPayment, useBluefinPaymentIframe, useChurch, useCountry, useCountryPostal, useCraftyClicks, useCreateFormData, useCreateLogging, useCreateSubscriberPowerText, useCreateToken, useCreateUpgradeDonation, useCreateUserFile, useCurrency, useDateCalendar, useDonationCart, useEmail, useEmailList, useEntity, useEthiopiaAddress, useFileUpload, useForm, useFormErrorScreen, useFormProvider, useFormatAddress, useFreeGiftOffer, useGetBRBInfo, useGetCoursesDiscountPrice, useGetCoursesProducts, useGetDmagNonDiscountSubscriptions, useGetDmagProducts, useGetDmagSubscriptions, useGetPing, useGetSession, useGetStellofyPeople, useGetStellofyRole, useGetStellofyToken, useGoogleReCaptcha, useInputBlur, useInputPhone, useInputTextEvents, useInputValidation, useItemCalculator, useKeyPadPayment, useLaosAddress, useLogging, useName, useOrgRoles, usePaymentMethod, usePaypalPayment, usePledgeAmounts, usePostAPaySession, usePostEmailVerify, usePowerByText, useRecaptcahMessage, useRecurring, useRecurringChoice, useRegion, useSREDKeyPad, useSREDKeyPadModal, useSingleGift, useSubmitButton, useUser, useUserEsubList, useVietnamAddress, userChoiceEvent, uuid, validateAcknowledgement, validateCaptcha, validateCountry, validateCurrency, validateEchoPhoneNumber, validateEmail, validateFields, validateInput, validateMultiSelect, validateName, validateNumber, validateObject, validatePhone, validateString, validateZipPostalCode, viewCartEvent };
